/**
 * @author z.geddes
 * created on 16.12.2015
 */

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages', [
      'littlepayPortalMerchantApp.pages.account',
      'littlepayPortalMerchantApp.pages.admin',
      'littlepayPortalMerchantApp.pages.parent',
      'littlepayPortalMerchantApp.pages.library',
    ])
    .config(routeConfig).run(function($rootScope, $transitions, sidebarService, WebAnalytics, $translate, Auth, tmhDynamicLocale, CUSTOM_MERCHANT_CONFIG) {

    $rootScope.htmlPageTitle = CUSTOM_MERCHANT_CONFIG.htmlTitle;
    $rootScope.faviconPath = CUSTOM_MERCHANT_CONFIG.faviconPath;
    $rootScope.$baSidebarService = sidebarService;

    $rootScope.$on('$locationChangeSuccess', function(e, newUrl, oldUrl) {
      WebAnalytics.trackLocationChange(newUrl, oldUrl);
      if(Auth.getSelectedLocale() !== undefined){
        $translate.use(Auth.getSelectedLocale()).then(function(){
          $translate.refresh();
          if(localStorage.getItem('locale')) {
            tmhDynamicLocale.set(localStorage.getItem('locale'));
          }
        });
      }
    });
  })
  .factory('translateCustomHandlerFactory', function($log) {
    return function (translationID) {
      $log.warn('Translation for ' + translationID + ' is missing' + ' in ' + localStorage.getItem('locale'));
      return 'Translation text missing';
    };
  });

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider,
                       lockProvider, jwtOptionsProvider, AUTH0, LITTLEPAY_API,
                       LITTLEPAY_ANALYTICS_API, $translateProvider, tmhDynamicLocaleProvider, CUSTOM_MERCHANT_CONFIG) {

    $httpProvider.defaults.withCredentials = false;
    var lockOptions = angular.copy(AUTH0);

    if (CUSTOM_MERCHANT_CONFIG.customAuth0LogoPath) {
      lockOptions.options.theme.logo = CUSTOM_MERCHANT_CONFIG.customAuth0LogoPath;
    }

    lockProvider.init(lockOptions);

    // Configuration for angular-jwt
    jwtOptionsProvider.config({
      tokenGetter: function() {
        return localStorage.getItem('id_token');
      },
      whiteListedDomains: [LITTLEPAY_API.host, LITTLEPAY_ANALYTICS_API.host],
      unauthenticatedRedirector: ['toastr', '$translate', 'Auth', function(toastr, $translate, Auth) {
        toastr.error($translate.instant('UNAUTHENTICATED-LOGIN-REQUIRED'));
        Auth.logout(); // logout function redirects to /login
      }],
    });

    $urlRouterProvider.otherwise('/login');
    // The following hardcoded location.href is needed for Auth0 authentication.
    // Otherwise, we will be having authentication issue with the angular lock framework
    // when logging in with address localhost:9000
    $urlRouterProvider.otherwise(function() {
      if (!window.__karma__) {
        location.href = '/login';
      }
    });

    $locationProvider.html5Mode(true);
    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push([
      '$q', '$rootScope', function($q, $rootScope) {
        return {
          'responseError': function(response) {
            if (response.status === 403) {
              $rootScope.$broadcast('unauthenticated', response);
            }
            return $q.reject(response);
          },
        };
      }
    ]);

    $translateProvider
      .useStaticFilesLoader({
        files: [
          {
            prefix: '../assets/locales/locale-',
            suffix: '.json'
          }
        ]
      })
      .useSanitizeValueStrategy('escapeParameters')
      .preferredLanguage(AUTH0.options.language)
      .fallbackLanguage('en');

    $translateProvider.useMissingTranslationHandler('translateCustomHandlerFactory');

    $translateProvider.forceAsyncReload(true);

    tmhDynamicLocaleProvider.localeLocationPattern('assets/locales/i18n/angular-locale_{{locale}}.js');
    tmhDynamicLocaleProvider.defaultLocale('en-gb');
  }

})();

/**
 * @author z.geddes
 * created on 15.12.2015
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme', [
    // 'toastr',
    // 'chart.js',
    // 'angular-chartist',
    // 'angular.morris-chart',
    'littlepayPortalMerchantApp.theme.constants',
    'littlepayPortalMerchantApp.theme.services',
    // 'littlepayPortalOperationApp.theme.authentication'
  ]);

})();
'use strict';

angular.module('littlepayPortalMerchantApp.pages.library', []);
/**
 * @author z.geddes
 * created on 24.01.2018
 */
/*jshint immed: false */

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin', [
      'littlepayPortalMerchantApp.pages.admin.dashboard',
      'littlepayPortalMerchantApp.pages.admin.transactions',
      'littlepayPortalMerchantApp.pages.admin.customers',
      'littlepayPortalMerchantApp.pages.admin.products',
      'littlepayPortalMerchantApp.pages.admin.devices',
      'littlepayPortalMerchantApp.pages.admin.corrections',
      'littlepayPortalMerchantApp.pages.admin.settings',
      'littlepayPortalMerchantApp.pages.admin.unauthorized',
      'littlepayPortalMerchantApp.pages.admin.notifications',
      'littlepayPortalMerchantApp.pages.admin.analysis',
      'littlepayPortalMerchantApp.pages.admin.support',
      'littlepayPortalMerchantApp.pages.admin.developer',
      'littlepayPortalMerchantApp.pages.admin.search',
    ])
    .config(routeConfig).run(function($transitions, Auth, authManager) {

      Auth.registerAuthenticationListener();
      authManager.checkAuthOnRefresh();
      authManager.redirectWhenUnauthenticated();

      // Redirect to login if route requires auth and you're not logged in
      $transitions.onStart({
        to: function(state) {
          return state.name !== 'login';
        },
      }, function(transaction) {
        Auth.redirectUserToCorrectPath(transaction.to());
      });

      $transitions.onBefore({
        'to': (function(state) {
          return state.name !== 'login';
        }),
      }, function(trans) {
        var $location = trans.injector().get('$location');
        var form = trans.injector().get('Form');

        form.queries = {};
        form.invalid = {};
        form.loading = {
          'hasLoaded': false,
          'error': false,
        };

        angular.forEach($location.search(), function(e, key) {
          form.queries[key] = e;
        });
        return form;
      });

      $transitions.onSuccess({
        to: '**',
      }, function(trans) {
        var $location = trans.injector().get('$location');
        var form = trans.injector().get('Form');
        if (Object.keys($location.search()).length === 0) {
          form.queries = {};
        }
      });

    })
    .config(['tooltipsConfProvider', function configConf(tooltipsConfProvider) {
      tooltipsConfProvider.configure({
        'smart': true,
        'speed': 'medium',
        'size': 'small',
      });
    }]);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin', {
        url: '/admin',
        templateUrl: 'app/pages/admin/admin.html',
        controller: 'AdminCtrl',
        abstract: true,
        resolve: {
          translateReady: ['$translate', function($translate) {
            return $translate.onReady();
          }]
        },
      });
    $urlRouterProvider.when('/admin', '/admin/transactions');

  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.parent', [
      'littlepayPortalMerchantApp.pages.parent.settings',
      'littlepayPortalMerchantApp.pages.parent.users',
      'littlepayPortalMerchantApp.pages.parent.account',
      'littlepayPortalMerchantApp.pages.parent.notifications',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('parent', {
        url: '/parent',
        templateUrl: 'app/pages/parent/parent.html',
        controller: 'AdminCtrl',
        abstract: true,
      });
  }
})();

/**
 * @author z.geddes
 * created on 18.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme.constants', []);

})();
/**
 * @author z.geddes
 * created on 18.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme.services', []);

})();
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.account', [
      'littlepayPortalMerchantApp.pages.account.login',
      'littlepayPortalMerchantApp.pages.account.changePassword',
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('account', {
        url: '/account',
        abstract: true,
        templateUrl: 'app/pages/account/account.html',
        controller: 'AccountCtrl',
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis',
    [
      'littlepayPortalMerchantApp.pages.admin.analysis.transctions',
      'littlepayPortalMerchantApp.pages.admin.analysis.customers',
      'littlepayPortalMerchantApp.pages.admin.analysis.corrections',
      'littlepayPortalMerchantApp.pages.admin.analysis.declines',
      'littlepayPortalMerchantApp.pages.admin.analysis.debtRecovery',
      'littlepayPortalMerchantApp.pages.admin.analysis.customreports'
    ])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.analysis', {
        url: '/analysis',
        abstract: true,
        template: '<ui-view></ui-view>',
        title: 'PAGE-TITLES.ANALYSIS',
        permission: 'AccessAnalytics',
        admin: true,
        sidebarMeta: {
          order: 300,
          icon: 'ion-speedometer',
        }
      })
      .state('parent.analysis', {
        url: '/analysis',
        abstract: true,
        template: '<ui-view></ui-view>',
        title: 'PAGE-TITLES.ANALYSIS',
        admin: true,
        sidebarMeta: {
          order: 300,
          icon: 'ion-speedometer'
        }
      });
  }

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
    .controller('AdminAnalysis', AdminAnalysis);

  AdminAnalysis.$inject = ['$scope', '$location', 'Auth', '$filter'];

  function AdminAnalysis($scope, $location, Auth, $filter) {
    this.options = {currencyCodes: []};
    this.analyticsModel = undefined;
    this.chartOptions = {};
    this.pageState = 'loading';
    this.csvFilename = '';
    this.paginationData = {
      currentPage: 1,
      entryNumber: 100,
      pagination: {
        limit: 100,
        total: 0
      }
    };
    this.datePickerOptions = {
      weekMode: false,
      firstDayOfWeek: 'sunday'
    };
    this.tableData = [];

    this.pageLoaded = function() {
      if(this.pageState!=='loading') {
        return;
      }

      if ($scope.analyticsConfig.currencyCodes) {
        this.pageState = 'ready';
      } else {
        if(Auth.isParent() && !Auth.isAdmin() && !Auth.isOperationsAdmin()) {
          this.pageState = 'error_permissions';
        } else if(!Auth.isParent() && !Auth.isAdmin() && !Auth.hasPermission('AccessAnalytics') && !Auth.isOperationsAdmin()) {
          this.pageState = 'error_permissions';
        } else {
          this.pageState = 'no_data';
        }
      }
      $scope.pageLoaded();
    };

    this.isFirstForDate = function(date, index) {
      if (index > 0) {
        return this.analyticsModel.detailData[index - 1].date !== date;
      }

      return true;
    };

    this.isAtParentLevel = function() {
      return Auth.isParent();
    };

    this.hasNoData = function() {
      return this.analyticsModel.detailData.length === 0;
    };

    this.isFirstForDateOrParticipant = function(item, index) {
      if (index > 0) {
        return this.analyticsModel.detailData[index - 1].date !== item.date ||
          this.analyticsModel.detailData[index - 1].participant_id !== item.participant_id;
      }

      return true;
    };

    this.calcPreviousPeriodDates = function() {
      var daysBetween = $scope.getAnalyticsEndDate().diff($scope.getAnalyticsStartDate(), 'days');
      this.previousEndDate = $scope.getAnalyticsStartDate().clone();
      this.previousEndDate.subtract(1, 'days');
      this.previousStartDate = this.previousEndDate.clone();
      this.previousStartDate.subtract(daysBetween, 'days');
      this.previousEndDate = this.previousEndDate.format('DD/MM/YYYY');
      this.previousStartDate = this.previousStartDate.format('DD/MM/YYYY');
    };

    this.getDefaultFromDate = function() {
      if(!this.datePickerOptions.weekMode) {
        return moment().subtract(7, 'days');
      } else {
        var date = moment();
        date.subtract(7, 'days');
        if(this.datePickerOptions.firstDayOfWeek==='sunday') {
          date.day(0);
        } else {
          date.day(1);
        }
        return date;
      }
    };

    this.getDefaultToDate = function() {
      if(!this.datePickerOptions.weekMode) {
        return moment().subtract(1, 'days');
      } else {
        var date = this.getDefaultFromDate();
        date.add(6, 'days');
        return date;
      }
    };

    this.initData = function(analyticsConfig, datePickerOptions) {
      if($scope.analyticsConfig.weekMode!==undefined && $scope.analyticsConfig.weekMode!==datePickerOptions.weekMode) {
        this.clearSearchValues();
        this.clearSelectedDateRange();
      }

      var fromDate = $scope.getAnalyticsStartDate();
      if (!fromDate) {
        fromDate = $location.search()['start-date'] ?
          moment($location.search()['start-date'], 'YYYY-MM-DD', true) :
          this.getDefaultFromDate();
      }
      var toDate = $scope.getAnalyticsEndDate();
      if (!toDate) {
        toDate = $location.search()['end-date'] ?
          moment($location.search()['end-date'], 'YYYY-MM-DD', true) :
          this.getDefaultToDate();
      }
      var currencyCode = $scope.getAnalyticsCurrencyCode();
      if (!currencyCode) {
        currencyCode = $location.search()['currency-code'] ?
          parseInt($location.search()['currency-code'], 10) :
          undefined;
      }
      if ((!currencyCode && analyticsConfig.currencyCodes.length) ||
        (currencyCode && !analyticsConfig.currencyCodes.includes(currencyCode))) {
        currencyCode = analyticsConfig.currencyCodes[0];
      }

      $scope.analyticsConfig.selectedDateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };
      var minStartDate = moment().subtract(91, 'day');
      if(analyticsConfig.firstDate) {
        minStartDate = moment(analyticsConfig.firstDate);
        minStartDate.subtract(1, 'day');
      }
      $scope.analyticsConfig.selectedCurrencyCode = currencyCode;
      $scope.analyticsConfig.minStartDate = minStartDate;
      $scope.analyticsConfig.maxEndDate = moment().subtract(1, 'days');
      $scope.analyticsConfig.currencyCodes = analyticsConfig.currencyCodes;
      $scope.analyticsConfig.weekMode = datePickerOptions.weekMode;

      this.formatCsvFilename();
    };

    this.setSearchValues = function() {
      $location.search('currency-code', $scope.getAnalyticsCurrencyCode());
      $location.search('start-date', $scope.getAnalyticsStartDateFormatted());
      $location.search('end-date', $scope.getAnalyticsEndDateFormatted());
    };

    this.clearSearchValues = function() {
      $location.search('currency-code', null);
      $location.search('start-date', null);
      $location.search('end-date', null);
    };

    this.clearSelectedDateRange = function() {
      $scope.analyticsConfig.selectedDateRange = {};
    };

    this.formatCsvFilename = function() {
      var filename = this.csvFilenamePrefix + '_';
      var startDate = $scope.getAnalyticsStartDateFormatted();
      var endDate = $scope.getAnalyticsEndDateFormatted();
      if (startDate === endDate) {
        filename += startDate;
      } else {
        filename += startDate + '-' + endDate;
      }
      filename += '_' + $filter('toISOCurrency')($scope.getAnalyticsCurrencyCode()) + '.csv';
      this.csvFilename = filename;
    };

    this.toUpperOr = function(val, defaultVal) {
      defaultVal = defaultVal || '';
      return val ? val.toUpperCase() : defaultVal;
    };

    this.getColWidth = function(index) {
      return this.isAtParentLevel() ? this.colWidths[index] + '%' : (this.colWidths[index] + (this.colWidths[1] / this.colWidths.length-1)) + '%';
    };
  }
})();

(function() {

  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.corrections', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.corrections', {
        url: '/corrections',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'PAGE-TITLES.CORRECTIONS',
        sidebarMeta: {
          icon: 'ion-android-refresh',
          order: 130,
        },
      })
      .state('admin.corrections.list', {
        url: '/list',
        templateUrl: 'app/pages/admin/corrections/corrections/corrections.html',
        controller: 'AdminCorrectionsCtrl',
        title: 'PAGE-TITLES.CORRECTIONS-LIST',
        sidebarMeta: {
          order: 100,
        },
      })
      .state('admin.corrections.correctionRequests', {
        url: '/correction-requests',
        templateUrl: 'app/pages/admin/corrections/correctionRequests/correctionRequests.html',
        controller: 'AdminCorrectionRequestsCtrl',
        title: 'PAGE-TITLES.CORRECTION-REQUESTS',
        sidebarMeta: {
          order: 110,
        },
      })
      .state('admin.corrections.makeCorrection', {
        url: '/make-correction',
        templateUrl: 'app/pages/admin/corrections/makeCorrection/makeCorrection.html',
        controller: 'AdminMakeCorrectionCtrl',
        title: 'PAGE-TITLES.MAKE-CORRECTIONS',
        sidebarMeta: {
          order: 120,
        },
        resolve: {
          timeQueries: [
            'Form', function(Form) {
              angular.forEach(Form.queries, function(e, key) {
                if (key === 'fromTime' || key === 'toTime') {
                  Form.queries[key] = moment(decodeURIComponent(e), 'DD/MM/YYYY')
                    .format('YYYY-MM-DD');
                }
                return Form;
              });
            }],
        },
      });

    $urlRouterProvider.when('/admin/corrections', 'admin/corrections/list');

  }
})();

(function() {

  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.customers', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.customers', {
        url: '/customers',
        templateUrl: 'app/pages/admin/customers/customers/customers.html',
        controller: 'AdminCustomersCtrl as vm',
        childrenState: [
          'admin.customerSummary.transactions',
          'admin.customerSummary.cards',
          'admin.customerSummary.refunds',
          'admin.customerSummary.receipt'],
        title: 'PAGE-TITLES.CUSTOMERS',
        sidebarMeta: {
          icon: 'ion-ios-people',
          order: 110,
        },
      })
      .state('admin.customersByVaultId', {
        url: '/customersByVaultId/:vaultId',
        controller: 'AdminCustomersByVaultIdCtrl',
      })
      .state('admin.trialInvitations', {
        url: '/customers/trial-invitations',
        templateUrl: 'app/pages/admin/customers/trialInvitations/trialInvitations.html',
        controller: 'AdminTrialInvitationsCtrl',
        permission: 'GetAccessLinks',
        title: 'PAGE-TITLES.TRIAL-INVITATIONS',
        sidebarMeta: {
          icon: 'ion-ios-people',
          order: 150,
        },
      })
      .state('admin.customersById', {
        url: '/customersById/:customerId',
        controller: 'AdminCustomersByIdCtrl',
      });

    $urlRouterProvider.when('/admin/customers/:customerId',
      '/admin/customers/:customerId/transactions');
  }

})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.dashboard', [])/*.config(routeConfig)*/;

  /**
   * Hide the Dashboard from the system.
   */
  // function routeConfig($stateProvider) {
  //   $stateProvider
  //     .state('admin.dashboard', {
  //       url: '/dashboard',
  //       templateUrl: 'app/pages/admin/dashboard/dashboard.html',
  //       controller: 'AdminDashboardCtrl as vm',
  //       title: 'Dashboard',
  //       permission: 'AccessDashboard',
  //       sidebarMeta: {
  //         order: 100,
  //         icon: 'ion-speedometer',
  //       },
  //       resolve: {
  //         initOptions: function() {
  //           return {
  //             'fields': {
  //               'sales': [{
  //                 'label': 'Sales',
  //                 'id': 'total_sales',
  //                 'type': 'number'
  //               }, {
  //                 'label': 'Refunds',
  //                 'id': 'total_refunds',
  //                 'type': 'number'
  //               }],
  //               'declines': [{
  //                 'label': 'Gross Declines %',
  //                 'id': 'number_of_declines',
  //                 'type': 'number'
  //               }],
  //               'customers': [{
  //                 'label': 'Existing Customers #',
  //                 'id': 'existing_customer',
  //                 'type': 'number'
  //               }, {
  //                 'label': 'New Customers #',
  //                 'id': 'new_customer',
  //                 'type': 'number'
  //               }]
  //             },
  //             'charts': {
  //               'title': {
  //                 'text': ''
  //               },
  //               'chart': {
  //                 'type': 'column'
  //               },
  //               'xAxis': {
  //                 'pointStart': Date.UTC(2010, 0, 1),
  //                 'type': 'datetime',
  //                 'tickWidth': 0,
  //                 'gridLineWidth': 0,
  //                 'lineColor': 'transparent'
  //               },
  //               'yAxis': [{
  //                 'title': {
  //                   'text': ''
  //                 }
  //               }, {
  //                 'title': {
  //                   'text': ''
  //                 },
  //                 'opposite': true,
  //               }],
  //               'tooltip': {
  //                 'shared': true,
  //                 'crosshairs': true
  //               },
  //               'credits': {
  //                 'enabled': false
  //               },
  //               'colors': ['#DBE8F9', '#F7A54B', '#466289', '#A0AEC1'],
  //               'plotOptions': {
  //                 'series': {
  //                   'cursor': 'pointer',
  //                   'stacking': 'normal',
  //                   'marker': {
  //                     'lineWidth': 1
  //                   }
  //                 }
  //               }
  //             }
  //           };
  //         }
  //       }
  //     });
  // }
})();


(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.developer', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/admin/developer', 'admin/orders/orders');
    $stateProvider
      .state('admin.developer', {
        hide: __env.isProduction,
        url: '/developer',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'PAGE-TITLES.DEVELOPER',
        childrenState: [
          'admin.developer.logs',
        ],
        sidebarMeta: {
          icon: 'code icon',
          order: 170,
        },
        onEnter: ['Auth', '$state', function (Auth, $state) {
          if (__env.isProduction) {
            localStorage.clear();
            Auth.logout();
            return $state.target('login', {});
          }
        }]
      })
      .state('admin.developer.logs', {
        hide: __env.isProduction,
        url: '/logs',
        templateUrl: 'app/pages/admin/developer/logs/logs.html',
        controller: 'AdminDeveloperLogsCtrl as vm',
        title: 'PAGE-TITLES.LOGS',
        sidebarMeta: {
          order: 100,
        },
        resolve: {
          fetchDevices: function(Device) {
            Device.model.entryNumber = 1000;
            return Device.fetchDevices(1);
          }
        },
      })
      .state('admin.developer.transaction-simulator', {
        hide: __env.isProduction,
        url: '/transaction-simulator',
        templateUrl: 'app/pages/admin/developer/transaction/transaction.html',
        controller: 'AdminDeveloperTransactionCtrl as vm',
        title: 'PAGE-TITLES.TRANSACTION-SIMULATOR',
        sidebarMeta: {
          order: 101,
        }
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.devices', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.devices', {
        url: '/devices',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'PAGE-TITLES.DEVICES',
        childrenState: ['admin.devices.deviceSummary'],
        sidebarMeta: {
          icon: 'ion-laptop',
          order: 150,
        },
      })
      .state('admin.devices.list', {
        url: '/list',
        templateUrl: 'app/pages/admin/devices/devices/devices.html',
        controller: 'AdminDevicesCtrl',
        title: 'PAGE-TITLES.DEVICE-LIST',
        sidebarMeta: {
          order: 100,
        },
      })
      .state('admin.devices.devicesAssignments', {
        url: '/assignments',
        templateUrl: 'app/pages/admin/devices/assignments/assignments.html',
        controller: 'AdminDevicesAssignmentsCtrl',
        title: 'PAGE-TITLES.DEVICE-ASSIGNMENTS',
        sidebarMeta: {
          order: 200,
        },
      });
    $urlRouterProvider.when('/admin/devices', 'admin/devices/list');

  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/library/notifications/notifications/notifications.html',
        controller: 'AdminNotificationsCtrl',
        title: 'PAGE-TITLES.NOTIFICATIONS',
      })
      .state('admin.notificationSummary', {
        url: '/notifications/:notificationId',
        templateUrl: 'app/pages/library/notifications/notificationSummary/notificationSummary.html',
        controller: 'AdminNotificationSummaryCtrl',
        title: 'PAGE-TITLES.NOTIFICATION-SUMMARY',
      });
  }
})();

(function() {

  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.products', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.products', {
        url: '/products',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'PAGE-TITLES.PRODUCTS',
        childrenState: [
          'admin.products.cappingSummary',
          'admin.products.cappingSummary.default',
          'admin.products.cappingSummary.rules',
          'admin.products.cappingSummary.zones',
          'admin.products.newProduct',
          'admin.products.discountSummary',
          'admin.products.newDiscountProduct'],
        sidebarMeta: {
          icon: 'ion-cube',
          order: 120,
        },
      })
      .state('admin.products.discount', {
        url: '/discount',
        templateUrl: 'app/pages/admin/products/discount/list/list.html',
        controller: 'AdminProductsDiscountListCtrl as vm',
        title: 'PAGE-TITLES.DISCOUNT',
        sidebarMeta: {
          order: 130,
        },
      })
      .state('admin.products.pricingPeriod', {
        url: '/pricing-periods',
        templateUrl: 'app/pages/admin/products/pricingPeriods/pricingPeriods.html',
        controller: 'AdminProductsPricingPeriodsCtrl as vm',
        title: 'PAGE-TITLES.PRICING-PERIOD',
        sidebarMeta: {
          order: 140,
        },
        resolve: {
          callPricingPeriods: [
            'PricingPeriod', function(PricingPeriod) {
              PricingPeriod.model.list = [];
              return PricingPeriod.fetch(1);
          }],
          initPricingPeriod: [
            'WEEK_NAMES', 'WEEK_NAMES_INDEX', function(WEEK_NAMES, WEEK_NAMES_INDEX) {
              var initValues = {
                'weeknames': WEEK_NAMES,
                'weeknamesIndex': WEEK_NAMES_INDEX,
                'selectedRule': 0,
                'options': [],
                'defaultOptions': {
                  start: ['08:00'],
                  hour: 3600,
                  value: [],
                  connect: [],
                  range: {
                    min: 0,
                    max: 86400,
                  },
                },
              };
              return initValues;
            }],
        },
      })
      .state('admin.products.exceptionPeriod', {
        url: '/exception-periods',
        templateUrl: 'app/pages/admin/products/exceptionPeriods/exceptionPeriods.html',
        controller: 'AdminProductsExceptionPeriodsCtrl as vm',
        title: 'PAGE-TITLES.EXCEPTION-PERIOD',
        sidebarMeta: {
          order: 150,
        },
      })
      .state('admin.products.zones', {
        url: '/zones',
        templateUrl: 'app/pages/admin/products/zones/zones.html',
        controller: 'AdminProductsZonesCtrl as vm',
        title: 'PAGE-TITLES.ZONES',
        callParticipants: false,
        sidebarMeta: {
          order: 160,
        },
      });

    $urlRouterProvider.when('/admin/products', 'admin/products/capping');

  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.search', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.search', {
        url: '/search',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'PAGE-TITLES.SEARCH',
        callParticipants: false,
        childrenState: [
          'admin.search.charges',
          'admin.search.charges.cardNumber',
          'admin.search.charges.amount',
          'admin.search.charges.period',
          'admin.search.charges.status',
          'admin.search.trips',
          'admin.search.orders'],
        sidebarMeta: {
          icon: 'star icon',
          order: 111,
        },
      })
      .state('admin.search.charges', {
        url: '/charges',
        templateUrl: 'app/pages/admin/search/charges/searchCharges.html',
        controller: 'AdminSearchChargesCtrl as vm',
        title: 'PAGE-TITLES.CHARGES',
        callParticipants: false,
        sidebarMeta: {
          order: 100,
        },
      })
      .state('admin.search.trips', {
        url: '/trips',
        templateUrl: 'app/pages/admin/search/trips/searchTrips.html',
        controller: 'AdminSearchTripsCtrl as vm',
        title: 'PAGE-TITLES.TRIPS',
        callParticipants: false,
        sidebarMeta: {
          order: 102,
        },
      })
      .state('admin.search.orders', {
        url: '/orders',
        templateUrl: 'app/pages/admin/search/orders/orders.html',
        controller: 'AdminOrdersCtrl as vm',
        title: 'ORDER.ORDERS',
        childrenState: ['admin.search.orders.orderDetails'],
        sidebarMeta: {
          order: 103,
        },
      });

      $urlRouterProvider.when('/admin/search', '/admin/search/charges/cardNumber');
      $urlRouterProvider.when('/admin/search/charges', '/admin/search/charges/cardNumber');
      $urlRouterProvider.when('/admin/search/trips', '/admin/search/trips/cardNumber');

  }
})();

(function() {

  'use strict';
  angular.module('littlepayPortalMerchantApp.pages.admin.settings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.settings', {
        url: '/settings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'PAGE-TITLES.SETTINGS',
        childrenState: ['admin.settings.accountSummary'],
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 160,
        },
      })
      .state('admin.settings.profile', {
        url: '/profile',
        templateUrl: 'app/pages/admin/settings/settingsGeneral/settingsGeneral.html',
        controller: 'AdminSettingsGeneralCtrl',
        title: 'PAGE-TITLES.PROFILE',
        sidebarMeta: {
          order: 100,
        },
      })
      .state('admin.settings.account', {
        url: '/account',
        templateUrl: 'app/pages/admin/settings/settingsAccount/settingsAccount.html',
        controller: 'AdminSettingsAccountCtrl',
        title: 'PAGE-TITLES.ACCOUNT',
        sidebarMeta: {
          order: 110,
        }
      })
      .state('admin.settings.accountSummary', {
        url: '/account/:userId',
        templateUrl: 'app/pages/admin/settings/settingsAccountSummary/settingsAccountSummary.html',
        controller: 'AdminSettingsAccountSummaryCtrl',
        parentState: 'admin.settings.account',
        title: 'PAGE-TITLES.ACCOUNT-SUMMARY',
      });
    $urlRouterProvider.when('/admin/settings', 'admin/settings/profile');

  }
})();

(function() {

  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.support', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, CUSTOM_MERCHANT_CONFIG) {
    $stateProvider
      .state('admin.support', {
        hideFn: shouldHideSupportTab,
        url: '/support',
        templateUrl: 'app/pages/admin/support/supportInfo.html',
        title: 'PAGE-TITLES.SUPPORT',
        sidebarMeta: {
          icon: 'ion-ios-contact',
          order: 400,
        },
        controller: function($scope, $translate) {
          $scope.customMerchantSubdomainName = CUSTOM_MERCHANT_CONFIG.subdomain;

          $scope.merchantSupportCenter = function() {
            var supportCenterKey= 'SUPPORT.SUPPORT-CENTER';
            var postfix = '.SUPPORT-CENTER';
            return getTranslationKey($scope,$translate,supportCenterKey, postfix);
          };

          $scope.merchantSupportFromHere = function() {
            var supportFromHereKey= 'SUPPORT.FROMHERE';
            var postfix = '.FROMHERE';
            return getTranslationKey($scope,$translate,supportFromHereKey, postfix);
          };

          $scope.merchantSupportCenterValue= function() {
            var supportCenterKey= 'SUPPORT.SUPPORT-CENTER-VALUE';
            var postfix = '.SUPPORT-CENTER-VALUE';
            return getTranslationKey($scope,$translate,supportCenterKey, postfix);
          };

          $scope.merchantSupportEmergencyContact = function() {
            var supportEmergencyContactKey= 'SUPPORT.EMERGENCY-CONTACT-NUMBER-VALUE';
            var postfix = '.EMERGENCY-CONTACT-NUMBER-VALUE';
            return getTranslationKey($scope,$translate,supportEmergencyContactKey, postfix);
          };

        }
      });
  }

  shouldHideSupportTab.$inject = ['CUSTOM_MERCHANT_CONFIG'];

  function shouldHideSupportTab(CUSTOM_MERCHANT_CONFIG) {
    return !CUSTOM_MERCHANT_CONFIG.shouldShowSupportTab;
  }

  function getTranslationKey($scope, $translate, defualtKey, postfix) {
    if($scope.customMerchantSubdomainName !== undefined) {
      var customKey = 'SUPPORT.' + $scope.customMerchantSubdomainName.toUpperCase() + postfix;
      var translation = $translate.instant(customKey);

      if (translation !== 'Translation text missing' && translation !== undefined) {
        return customKey;
      }
    }
    return defualtKey;
  }

})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.transactions', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.transactions', {
        url: '/transactions',
        templateUrl: 'app/pages/admin/transactions/transactions.html',
        controller: 'AdminTransactionsCtrl',
        title: 'PAGE-TITLES.TRANSACTIONS',
        sidebarMeta: {
          icon: 'ion-loop',
          order: 109,
        },
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.unauthorized', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.unauthorized', {
        url: '/unauthorized',
        templateUrl: 'app/pages/admin/unauthorized/unauthorized.html',
        controller: 'AdminUnauthorizedCtrl',
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.parent.account', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('parent.account', {
        url: '/account',
        templateUrl: 'app/pages/parent/account/account.html',
        title: 'PAGE-TITLES.ACCOUNT',
        sidebarMeta: {
          icon: 'ion-person',
          order: 120,
        },
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.parent.notifications', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('parent.notifications', {
        url: '/notifications',
        templateUrl: 'app/pages/library/notifications/notifications/notifications.html',
        controller: 'AdminNotificationsCtrl',
        title: 'PAGE-TITLES.NOTIFICATIONS',
      })
      .state('parent.notificationSummary', {
        url: '/notifications/:notificationId',
        templateUrl: 'app/pages/library/notifications/notificationSummary/notificationSummary.html',
        controller: 'AdminNotificationSummaryCtrl',
        title: 'Notification Summary',
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.parent.settings', [])
    .config(function($stateProvider) {
      $stateProvider
        .state('parent.settings', {
          url: '/settings',
          templateUrl: 'app/pages/admin/settings/settingsGeneral/settingsGeneral.html',
          controller: 'AdminSettingsGeneralCtrl',
          title: 'PAGE-TITLES.SETTINGS',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
        });
    });
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.parent.users', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('parent.users', {
        url: '/users',
        templateUrl: 'app/pages/parent/users/users/users.html',
        controller: 'ParentUsersCtrl',
        title: 'PAGE-TITLES.USERS',
        childrenState: ['parent.newUser', 'parent.userSummary'],
        sidebarMeta: {
          icon: 'ion-ios-people',
          order: 110,
        },
      })
      .state('parent.newUser', {
        url: '/users/new-user',
        templateUrl: 'app/pages/parent/users/newUser/newUser.html',
        controller: 'ParentUsersNewUserCtrl',
        title: 'New User',
        parentState: 'parent.users',
      })
      .state('parent.userSummary', {
        url: '/users/:userId',
        templateUrl: 'app/pages/parent/users/userSummary/userSummary.html',
        controller: 'ParentUserSummaryCtrl',
        title: 'User Summary',
        parentState: 'parent.users',
      });
  }
})();

/**
 * @author z.geddes
 * created on 20.03.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.account.changePassword', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('account.changePassword', {
        url: '/changePassword',
        templateUrl: 'app/pages/account/changePassword/changePassword.html',
        controller: 'AccountChangePasswordCtrl',
      });
  }
})();

/**
 * @author z.geddes
 * created on 20.03.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.account.login', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/pages/account/login/login.html',
        controller: 'AccountLoginCtrl',
        title: 'Login',
      });
  }

})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis.corrections', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    var getConfig = function(permission, adminOnly) {
      return {
        url: '/corrections',
        templateUrl: 'app/pages/admin/analysis/movedtocontrolportal.html',
        controller: function () {},
        title: 'PAGE-TITLES.CORRECTIONS',
        permission: permission,
        admin: adminOnly,
        sidebarMeta: {
          order: 300,
        },
        resolve: {
          initOptions: function() {
            return {
              'initiators': [
                {
                  'label': 'ALL-INITIATORS',
                  'id': undefined,
                },
                {
                  'label': 'CUSTOMER',
                  'id': 'CUSTOMER',
                },
                {
                  'label': 'MERCHANT',
                  'id': 'MERCHANT',
                }],
              'correctionTypes': [
                {
                  'label': 'APPROVED',
                  'id': 'approved_amount',
                }, {
                  'label': 'NOT-APPROVED',
                  'id': 'awaiting_amount',
                }, {
                  'label': 'REFUSED',
                  'id': 'refused_amount',
                }, {
                  'label': 'CORRECTIONS-AS-OF-TOTAL',
                  'id': 'corrections_as_percentage_total',
                }],
            };
          },
          analyticsConfig: [
            'AnalysisConfig', function(AnalysisConfig) {
              return AnalysisConfig.getConfig();
            }],
        },
      };
    };

    $stateProvider
      .state('admin.analysis.corrections', getConfig('AccessAnalytics', true))
      .state('parent.analysis.corrections', getConfig(undefined, true));
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis.customers', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    var initOptions = function () {
      var new_vs_returning = {
        'label': 'EXISTING-VS-NEW-CUSTOMERS',
        'id': 'new_vs_returning',
        'showInPreviousDateFilter': false,
        'showFareTypeFilters': true,
        'showProductFilters': false,
        'csvPrefix': 'CustomersAnalysis_NewVsReturning'
      };
      var capped_vs_uncapped = {
        'label': 'CAPPED-VS-UNCAPPED-CUSTOMERS',
        'id': 'capped_vs_uncapped',
        'showInPreviousDateFilter': false,
        'showFareTypeFilters': false,
        'showProductFilters': false,
        'csvPrefix': 'CustomersAnalysis_CappedVsUncapped'
      }
      var cohort_retention = {
        'label': 'COHORT-RETENSION',
        'id': 'cohort_retention',
        'showStartingWeekFilters': true,
        'disabled': true
      };
      var average_revenue = {
        'label': 'AVG-REVENUE-PER-CUSTOMER',
        'id': 'average_revenue',
        'showInPreviousDateFilter': false,
        'disabled': true
      };
      var reactivated_customers = {
        'label': 'REACTIVATED-CUSTOMERS',
        'id': 'reactivated_customers',
        'showFareTypeFilters': true,
        'disabled': true
      };
      var life_time_value = {
        'label': 'LIFETIME-VALUE',
        'id': 'lifetime_value',
        'disabled': true
      };
      var rfm_segmentation = {
        'label': 'RFM-SEGMENTATION',
        'id': 'rfm_segmentation',
        'disabled': true
      };
      return {
        'selects': [
          new_vs_returning,
          capped_vs_uncapped,
          cohort_retention,
          rfm_segmentation
        ],
        'fare_type': [{
          'label': 'FLAT-FARE',
          'id': 'flat_fare',
        }, {
          'label': 'RETAIL-FARE',
          'id': 'retail_fare',
        }, {
          'label': 'VARIABLE-FARE',
          'id': 'variable_fare'
        }],
        'product': [{
          'label': 'SINGLE-NO-CAP',
          'id': 'single',
          'type': 'number'
        }, {
          'label': 'SINGLE-DAILY-CAP',
          'id': 'daily_cap',
          'type': 'number'
        }, {
          'label': 'SINGLE-WEEKLY-CAP',
          'id': 'weekly_cap',
          'type': 'number'
        }],
        'starting_week': [],
        'capping_frequencies': [],
        'chart_types': [
          {
            id: 'customer_count',
            label: 'BY-CUSTOMER-COUNT'
          },
          {
            id: 'total_nominal_amount',
            label: 'BY-NOMINAL-AMOUNT'
          },
          {
            id: 'total_charge_amount',
            label: 'BY-CHARGE-AMOUNT'
          }
        ]
      };
    };

    var getConfig = function(permission, adminOnly) {
      return {
        disabled: true,
        url: '/customers',
        templateUrl: 'app/pages/admin/analysis/movedtocontrolportal.html',
        controller: function () {},
        title: 'PAGE-TITLES.CUSTOMERS',
        permission: permission,
        admin: adminOnly,
        requiresAnalyticsPurchase: 'customers',
        sidebarMeta: {
          order: 200,
        },
        resolve: {
          initOptions: initOptions,
          analyticsConfig: [
            'AnalysisConfig', function(AnalysisConfig) {
              return AnalysisConfig.getConfig();
            }
          ]
        }
      };
    };

    $stateProvider
      .state('admin.analysis.customers', getConfig('AccessAnalytics', true))
      .state('parent.analysis.customers', getConfig(undefined, true));
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis.customreports', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {

    var getConfig = function(permission, adminOnly, $rootScope) {
      return {
        url: '/customreports',
        templateUrl: 'app/pages/admin/analysis/movedtocontrolportal.html',
        controller: function () {},
        title: 'PAGE-TITLES.CUSTOM-REPORTS',
        permission: permission,
        admin: adminOnly,
        quicksight:true,
        description: 'Beta version only - not for everyone',
        sidebarMeta: {
          order: 700
        },
        resolve: {
          initOptions: function() {
          },
          analyticsConfig: [
            'AnalysisConfig', function(AnalysisConfig) {
              return AnalysisConfig.getConfig();
            }
          ]
        }
      };
    };

    $stateProvider
      .state('admin.analysis.custom-reports', getConfig('AccessAnalytics', true))
      .state('parent.analysis.custom-reports', getConfig(undefined, true));
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis.debtRecovery', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {

    var getConfig = function(permission, adminOnly) {
      return {
        disabled: false,
        url: '/debt-recovery',
        templateUrl: 'app/pages/admin/analysis/movedtocontrolportal.html',
        controller: function () {},
        title: 'PAGE-TITLES.DEBT-RECOVERY',
        permission: permission,
        admin: adminOnly,
        sidebarMeta: {
          order: 500,
        },
        resolve: {
          initOptions: function() {
            return {
              'debts': [
                {
                  'label': 'DEBT-RECOVERED',
                  'id': 'recovered_debt_percent',
                  'mappedTo': 'recovered_debt',
                }, {
                  'label': 'DEBT-OUTSTANDING',
                  'id': 'outstanding_debt_percent',
                  'mappedTo': 'outstanding_debt',
                }],
            };
          },
          analyticsConfig: [
            'AnalysisConfig', function(AnalysisConfig) {
              return AnalysisConfig.getConfig();
            }],
        },
      };
    };

    $stateProvider
      .state('admin.analysis.debtRecovery', getConfig('AccessAnalytics', true))
      .state('parent.analysis.debtRecovery', getConfig(undefined, true));
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis.declines', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    var getConfig = function(permission, adminOnly) {
      return {
        url: '/declines',
        templateUrl: 'app/pages/admin/analysis/movedtocontrolportal.html',
        controller: function () {},
        title: 'PAGE-TITLES.DECLINES',
        permission: permission,
        admin: adminOnly,
        sidebarMeta: {
          order: 400,
        },
        resolve: {
          initOptions: function() {
            return {
              'declineBy': [
                {
                  'name': 'FILTERS-TRANSACTION-COUNT',
                  'value': [
                    {
                      'label': 'FILTERS-ALL-ISSUER-LIABILITY',
                      'id': 'all_percent',
                    }, {
                      'label': 'FILTERS-COVERED-UNDER-ISSUER-LIABILITY',
                      'id': 'covered_percent',
                    }, {
                      'label': 'FILTERS-NOT-COVERED-UNDER-ISSUER-LIABILITY',
                      'id': 'not_covered_percent',
                    }],
                },
                {
                  'name': 'FILTERS-TRANSACTION-AMOUNT',
                  'value': [
                    {
                      'label': 'FILTERS-ALL-ISSUER-LIABILITY',
                      'id': 'all_amount_percent',
                    }, {
                      'label': 'FILTERS-COVERED-UNDER-ISSUER-LIABILITY',
                      'id': 'covered_amount_percent',
                    }, {
                      'label': 'FILTERS-NOT-COVERED-UNDER-ISSUER-LIABILITY',
                      'id': 'not_covered_amount_percent',
                    }],
                }],
              'liability': [],
            };
          },
          analyticsConfig: [
            'AnalysisConfig', function(AnalysisConfig) {
              return AnalysisConfig.getConfig();
            }],
        },
      };
    };

    $stateProvider
      .state('admin.analysis.declines', getConfig('AccessAnalytics', true))
      .state('parent.analysis.declines', getConfig(undefined, true));
  }
})();

(function() {

  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.customers')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.customerSummary', {
        url: '/customers/:customerId',
        templateUrl: 'app/pages/admin/customers/customerSummary/customerSummary.html',
        controller: 'AdminCustomerSummaryCtrl as vm',
        parentState: 'admin.customers',
        title: 'PAGE-TITLES.CUSTOMER-SUMMARY',
      })
      .state('admin.customerSummary.transactions', {
        url: '/transactions',
        templateUrl: 'app/pages/admin/customers/customerSummary/transactions/transactions.html',
        controller: 'AdminCustomerSummaryTransactionsCtrl as trs',
        customerTabs: true,
        parentState: 'admin.customers',
        title: 'PAGE-TITLES.CUSTOMER-SUMMARY',
        resolve: {
          timeQueries: [
            'Form', function(Form) {
              angular.forEach(Form.queries, function(e, key) {
                if (key === 'fromTime' || key === 'toTime') {
                  Form.queries[key] = moment(decodeURIComponent(e), 'DD/MM/YYYY')
                    .format('YYYY-MM-DD');
                }
                return Form;
              });
            }],
        },
      })
      .state('admin.customerSummary.cards', {
        url: '/cards',
        templateUrl: 'app/pages/admin/customers/customerSummary/cards/customerCards.html',
        controller: 'AdminCustomerSummaryCardsCtrl as crd',
        customerTabs: true,
        parentState: 'admin.customers',
        title: 'PAGE-TITLES.CUSTOMER-SUMMARY',
      })
      .state('admin.customerSummary.refunds', {
        url: '/refunds',
        templateUrl: 'app/pages/admin/customers/customerSummary/refunds/customerRefunds.html',
        controller: 'AdminCustomerSummaryRefundsCtrl as rfd',
        customerTabs: true,
        parentState: 'admin.customers',
        title: 'PAGE-TITLES.CUSTOMER-SUMMARY',
      })
      .state('admin.customerSummary.receipt', {
        url: '/receipt',
        templateUrl: 'app/pages/admin/customers/customerSummary/customerInvoice/customerReceipt.html',
        controller: 'AdminCustomerSummaryInvoiceCtrl as rp',
        parentState: 'admin.customers',
        receipt: true,
        title: 'PAGE-TITLES.CUSTOMER-SUMMARY',
        resolve: {
          loadFeatures: function(Participant, $location) {

            var features = Participant.model.invoiceConfigs;
            if (angular.equals(features, {})) {
              var previousPath = $location.path().replace('receipt','transactions');
              $location.path(previousPath);
            }

            return features;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.products')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.products.newProduct', {
        url: '/new-product',
        templateUrl: 'app/pages/admin/products/capping/new/new.html',
        controller: 'AdminCappingNewCtrl as vm',
        title: 'PAGE-TITLES.NEW-CAPPING',
        permission: 'WriteProducts',
        parentState: 'admin.products.capping',
        parentBreadCrumb: 'PAGE-TITLES.CAPPING',
        parentBreadCrumbUrl: 'admin/products/capping',
      })
      .state('admin.products.capping', {
        url: '/capping',
        templateUrl: 'app/pages/admin/products/capping/list/list.html',
        controller: 'AdminProductsCappingListCtrl as vm',
        title: 'PAGE-TITLES.CAPPING',
        sidebarMeta: {
          order: 100,
        },
      })
      .state('admin.products.cappingSummary', {
        url: '/capping/:cappingId',
        templateUrl: 'app/pages/admin/products/capping/summary/summary.html',
        controller: 'AdminProductsCappingSummaryCtrl as vm',
        parentState: 'admin.products.capping',
        permission: 'WriteProducts',
        title: 'PAGE-TITLES.CAPPING-SUMMARY',
        resolve: {
          productsForm: function(PRODUCTS_FILTER, Auth) {
            var productsForm = {
              'forms': {
                'defaultForm': false,
                'ruleForm': false,
                'zoneOptionsForm': false,
                'zoneRulesForm': false,
              },
              'filters': PRODUCTS_FILTER,
              'participant': Auth.getParticipantName(),
              'switchSelected': 'peak',
              'peak_zones': {},
              'offpeak_zones': {},
            };
            return productsForm;
          },
        },
      })
      .state('admin.products.cappingSummary.default', {
        url: '/default?copy',
        templateUrl: 'app/pages/admin/products/capping/summary/widgets/default.html',
        title: 'PAGE-TITLES.PRODUCT-SUMMARY',
        parentState: 'admin.products.capping',
        permission: 'WriteProducts',
        parentBreadCrumb: 'PAGE-TITLES.CAPPING',
        parentBreadCrumbUrl: 'admin/products/capping',

      })
      .state('admin.products.cappingSummary.rules', {
        url: '/rules?copy',
        templateUrl: 'app/pages/admin/products/capping/summary/widgets/rules.html',
        title: 'PAGE-TITLES.PRODUCT-SUMMARY',
        parentState: 'admin.products.capping',
        permission: 'WriteProducts',
        parentBreadCrumb: 'PAGE-TITLES.CAPPING',
        parentBreadCrumbUrl: 'admin/products/capping',
      })
      .state('admin.products.cappingSummary.zones', {
        url: '/zones?copy',
        templateUrl: 'app/pages/admin/products/capping/summary/widgets/zones.html',
        title: 'PAGE-TITLES.PRODUCT-SUMMARY',
        parentState: 'admin.products.capping',
        permission: 'WriteProducts',
        parentBreadCrumb: 'PAGE-TITLES.CAPPING',
        parentBreadCrumbUrl: 'admin/products/capping',
      })
      .state('admin.products.cappingSummary.incentives', {
              url: '/incentives?copy',
              templateUrl: 'app/pages/admin/products/capping/summary/widgets/incentives.html',
              title: 'PAGE-TITLES.PRODUCT-SUMMARY',
              parentState: 'admin.products.capping',
              permission: 'WriteProducts',
              parentBreadCrumb: 'PAGE-TITLES.CAPPING',
              parentBreadCrumbUrl: 'admin/products/capping',
      });

    $urlRouterProvider.when('admin/capping/:cappingId', 'admin/capping/:cappingId/default');

  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.products')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('admin.products.newDiscountProduct', {
        url: '/new-discount-product',
        templateUrl: 'app/pages/admin/products/discount/new/new.html',
        controller: 'AdminDiscountNewCtrl as vm',
        title: 'PAGE-TITLES.NEW-DISCOUNT',
        permission: 'WriteProducts',
        parentState: 'admin.products.discount',
        parentBreadCrumb: 'PAGE-TITLES.DISCOUNT',
        parentBreadCrumbUrl: 'admin/products/discount',
      })
      .state('admin.products.discountSummary', {
        url: '/discount/:discountId',
        templateUrl: 'app/pages/admin/products/discount/summary/summary.html',
        controller: 'AdminProductsDiscountSummaryCtrl as vm',
        parentState: 'admin.products.discount',
        permission: 'WriteProducts',
        title: 'PAGE-TITLES.DISCOUNT-SUMMARY',
        resolve: {
          productsForm: function(PRODUCTS_FILTER, Auth) {
            var productsForm = {
              'forms': {
                'defaultForm': false,
              },
              'filters': PRODUCTS_FILTER,
              'participant': Auth.getParticipantName(),
            };
            return productsForm;
          },
        },
      })

    $urlRouterProvider.when('admin/discount/:discountId', 'admin/discount/:discountId/default');

  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.search')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.search.charges.cardNumber', {
        url: '/cardNumber',
        templateUrl: 'app/pages/admin/search/widgets/cardNumber.html',
        title: 'PAGE-TITLES.CHARGES-SEARCH',
        parentState: 'admin.search.charges',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.CHARGES-SEARCH-TOOLTIP-TEXT'
      })
      .state('admin.search.charges.amount', {
        url: '/amount',
        templateUrl: 'app/pages/admin/search/widgets/amount.html',
        title: 'PAGE-TITLES.CHARGES-SEARCH',
        parentState: 'admin.search.charges',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.CHARGES-SEARCH-TOOLTIP-TEXT'
      })
      .state('admin.search.charges.period', {
        url: '/period',
        templateUrl: 'app/pages/admin/search/widgets/period.html',
        title: 'PAGE-TITLES.CHARGES-SEARCH',
        parentState: 'admin.search.charges',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.CHARGES-SEARCH-TOOLTIP-TEXT'
      })
      .state('admin.search.charges.status', {
        url: '/status',
        templateUrl: 'app/pages/admin/search/widgets/status.html',
        title: 'PAGE-TITLES.CHARGES-SEARCH',
        parentState: 'admin.search.charges',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.CHARGES-SEARCH-TOOLTIP-TEXT'
      });
  }
})();


(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.search')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('admin.search.orderDetails', {
        url: '/orders/:orderId',
        templateUrl: 'app/pages/admin/search/orders/orderDetails/orderDetails.html',
        controller: 'AdminOrderDetailsCtrl as vm',
        title: 'ORDER.ORDER-DETAILS'
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.search')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider

      .state('admin.search.trips.cardNumber', {
        url: '/cardNumber',
        templateUrl: 'app/pages/admin/search/widgets/cardNumber.html',
        title: 'PAGE-TITLES.TRIPS-SEARCH',
        parentState: 'admin.search.trips',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.TRIPS-SEARCH-TOOLTIP-TEXT'
      })
      .state('admin.search.trips.amount', {
        url: '/amount',
        templateUrl: 'app/pages/admin/search/widgets/amount.html',
        title: 'PAGE-TITLES.TRIPS-SEARCH',
        parentState: 'admin.search.trips',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.TRIPS-SEARCH-TOOLTIP-TEXT'
      })
      .state('admin.search.trips.period', {
        url: '/period',
        templateUrl: 'app/pages/admin/search/widgets/period.html',
        title: 'PAGE-TITLES.TRIPS-SEARCH',
        parentState: 'admin.search.trips',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.TRIPS-SEARCH-TOOLTIP-TEXT'
      })
      .state('admin.search.trips.trip', {
        url: '/trip',
        templateUrl: 'app/pages/admin/search/widgets/trip.html',
        title: 'PAGE-TITLES.TRIPS-SEARCH',
        parentState: 'admin.search.trips',
        callParticipants: false,
        tooltipText: 'TRANSACTIONS.SEARCH.TRIPS-SEARCH-TOOLTIP-TEXT'
      });
  }
})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.pages.admin.analysis.transctions', [])
    .config(routeConfig);

  function routeConfig($stateProvider) {
    var transactionParameters = {
      'currencyCodes': [],
      'fareType': [{
        'name': 'ALL-FARE-TYPES',
        'value': ''
      }, {
        'name': 'FLAT-FARE',
        'value': 'flat_fare'
      }, {
        'name': 'RETAIL-FARE',
        'value': 'retail_fare'
      }, {
        'name': 'VARIABLE-FARE',
        'value': 'variable_fare'
      }],
      'product': [],
      'schemes': [],
      'price': [
        {
          'name': 'ALL',
          'value': undefined
        }, {
          'name': 'NOMINAL',
          'value': 'nominal_amount'
        }, {
          'name': 'ADJUSTED',
          'value': 'adjusted_amount'
        }
      ],
      'completions': [
        {
          'name': 'All',
          'value': ''
        },
        {
          'name': 'Complete',
          'value': 'complete'
        },
        {
          'name': 'Incomplete',
          'value': 'incomplete'
        }
      ]
    };

    var getConfig = function(permission, adminOnly) {
      return {
        url: '/transactions',
        templateUrl: 'app/pages/admin/analysis/movedtocontrolportal.html',
        controller: function () {},
        title: 'PAGE-TITLES.TRANSACTIONS',
        permission: permission,
        admin: adminOnly,
        sidebarMeta: {
          order: 100
        },
        resolve: {
          initOptions: function() {
            return transactionParameters;
          },
          analyticsConfig: [
            'AnalysisConfig', function(AnalysisConfig) {
              return AnalysisConfig.getConfig();
            }
          ]
        }
      };
    };

    $stateProvider
      .state('admin.analysis.transactions', getConfig('AccessAnalytics', true))
      .state('parent.analysis.transactions', getConfig(undefined, true));
  }
})();

'use strict';

if (window.Sentry) {
  var appVersionNumber = document.getElementsByTagName('title')[0].dataset.versionNumber;
  window.Sentry.init({
    environment: window.__env.environment,
    release: appVersionNumber,
    dsn: 'https://2465e8715b8244189172d4b98ee49a57@o480661.ingest.sentry.io/6080607',
    integrations: [
      new window.Sentry.Integrations.Angular(),
      new window.Sentry.Integrations.BrowserTracing({
        tracingOrigins: [window.__env.host, window.__env.analytics_host],
      }),
    ],
    beforeSend: function (event) {
      if (event.user) {
        // Don't send user's email address
        delete event.user.email;
      }
      return event;
    },
    tracesSampleRate: 1.0,
  });
}

var dependencies = [
  'auth0.lock',
  'angular-jwt',
  'ngCookies',
  'ngResource',
  'ngSanitize',
  'ngCsv',
  'ui.router',
  'isoCurrency',
  'iso-3166-country-codes',
  '720kb.tooltips',
  'ngclipboard',
  '19degrees.ngSweetAlert2',
  'yaru22.angular-timeago',
  'angular.backtop',
  'toastr',
  'xeditable',
  'ui.select',
  'ui.slimscroll',
  'moment-picker',
  'ngPako',
  'pascalprecht.translate',
  'tmh.dynamicLocale',
  'littlepayPortalMerchantApp.theme',
  'littlepayPortalMerchantApp.pages',
];

if (window.Sentry) {
  dependencies.push('ngSentry');
}
angular.module('littlepayPortalMerchantApp', dependencies);



(function() {
  'use strict';
  window.__env = window.__env || {};

  var hostnameSplit = window.location.hostname.split('.');
  if (hostnameSplit[1] === 'merchant') {
    var merchantName = hostnameSplit[0].toLowerCase();
    window.__env.merchantFromSubdomain = merchantName;

    var cssClass = merchantName.replace(/-/g, '');
    document.body.classList.add(cssClass);
  }
}());

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AdminCtrl', [
    '$scope',
    'Auth',
    '$rootScope',
    '$timeout',
    'Customer',
    '$location',
    'sweetAlert',
    'NOTIFICATIONS',
    'RightBar',
    'sidebarService',
    '$translate',
    'Participant',
    'FeatureFlags',
    'PRODUCTS_FILTER',
    '$state',
    '$interval',
    function($scope, Auth, $rootScope, $timeout, Customer, $location, sweetAlert,
             NOTIFICATIONS, RightBar, sidebarService, $translate, Participant, FeatureFlags, PRODUCTS_FILTER, $state) {
      $scope.profile = Auth.currentUser.profile;
      $scope.availableParticipants = RightBar.model.participants;
      $scope.participantName = Auth.getParticipantName();
      $scope.tabPage = false;
      $scope.pageError = false;
      $scope.errorMsg = 'Something went wrong. Please try again later.';
      $scope.url = 'admin/';
      $scope.languages = Auth.availableLanguages;
      $scope.isMultipleLanguage = Auth.isMultipleLanguage;
      $scope.profile.language = Auth.getSelectedLanguage();
      $scope.feature_flags = FeatureFlags.feature_flags;
      $rootScope.isReceipt = $state.current.receipt;

      // the link changes depending on subdomain and environment
      this.hasSubdomain = window.__env.merchantFromSubdomain;
      this.environment = window.__env.environment;
      this.subdomain = '';
      if (this.hasSubdomain) {
        if (this.hasSubdomain === 'vixtech') {
          this.subdomain = this.hasSubdomain + '.';
        }
      }
      this.environmentUrl = this.environment === 'dev' ? 'dev.' : this.environment === 'qa' ? 'qa.' : '';
      $scope.ctrlUrl = `https://${this.subdomain}control.${this.environmentUrl}littlepay.com`;
      $scope.ctrlDate = new Date('2024-07-31T23:59:59');
      $scope.showCtrlWarning = Auth.getParticipantName() === 'vasttrafik' ? false : true;

      $scope.analyticsConfig = {
        firstDayOfWeek: 'sunday',
        selectedDateRange: {},
        customDatepickerOptions: [
          {
            label: 'YESTERDAY',
            fromDate: moment().subtract(1, 'days'),
            toDate: moment().subtract(1, 'days'),
          },
          {
            label: 'LAST-7-DAYS',
            fromDate: moment().subtract(7, 'days'),
            toDate: moment().subtract(1, 'days'),
          },
          {
            label: 'LAST-30-DAYS',
            fromDate: moment().subtract(30, 'days'),
            toDate: moment().subtract(1, 'days'),
          },
          {
            label: 'LAST-90-DAYS',
            fromDate: moment().subtract(90, 'days'),
            toDate: moment().subtract(1, 'days'),
          },
        ],
      };

      $scope.getAnalyticsStartDate = function() {
        return $scope.analyticsConfig.selectedDateRange.fromDate;
      };

      $scope.getAnalyticsStartDateFormatted = function() {
        return $scope.getAnalyticsStartDate().format('YYYY-MM-DD');
      };

      $scope.getAnalyticsEndDate = function() {
        return $scope.analyticsConfig.selectedDateRange.toDate;
      };

      $scope.getAnalyticsEndDateFormatted = function() {
        return $scope.getAnalyticsEndDate().format('YYYY-MM-DD');
      };

      $scope.getAnalyticsCurrencyCode = function() {
        return $scope.analyticsConfig.selectedCurrencyCode;
      };

      $scope.deleteAlert = function(fn, msg) {
        sweetAlert.swal({
          title: $scope.translate('ADMIN.ARE-YOU-SURE'),
          html: msg || $scope.translate('WARNING-NOT-REVERTABLE'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: $scope.translate('ADMIN.YES-DELETE'),
          cancelButtonText: $scope.translate('ADMIN.NO-CANCEL'),
          confirmButtonClass: 'btn btn-success btn-sm',
          cancelButtonClass: 'btn btn-danger btn-sm',
        }).then(function(result) {
          if (result.value && fn) {
            fn();
          }
        });
      };

      $scope.successMsg = function(title, msg) {
        sweetAlert.swal(title, msg, 'success');
      };

      $scope.errorMsg = function(title, msg) {
        sweetAlert.swal(title, msg, 'error');
      };

      $scope.translate = function(key, var_key, translatePrefixOverride) {
        if(key) {
          var prefix = translatePrefixOverride || this.translatePrefix || '';
          return $translate.instant(prefix + key, var_key);
        }
      };

      $scope.rightBarCollapse = function() {
        $scope.isRightbarOpened = !$scope.isRightbarOpened;
        if ($scope.isRightbarOpened) {
          document.querySelector('#participant-filter').focus();
          if (!sidebarService.isMenuCollapsed()) {
            sidebarService.setMenuCollapsed(true);
          }
        } else {
          if (!sidebarService.shouldMenuBeCollapsed()) {
            sidebarService.setMenuCollapsed(false);
          }

        }
      };

      $scope.customerTabPage = function() {
        $scope.tabPage = true;
      };

      $scope.openNotifications = function() {
        $scope.notificationsOpened = !$scope.notificationsOpened;
      };

      /* Page loading functions */
      $scope.pageLoaded = function() {
        $timeout(function() {
          $scope.pageLoading = false;
        }, 300);
      };

      $scope.callErrorPage = function(msg, url) {
        $scope.pageError = true;
        $scope.errorMsg = msg;
        $scope.url += url;
      };

      $scope.pageLoadAgain = function() {
        $scope.pageLoading = true;
      };

      $scope.isEmpty = function (obj) {
        return angular.equals(obj, {});
      };

      $scope.newNotification = !$scope.profile.user_metadata ||
        !$scope.profile.user_metadata.notifications || NOTIFICATIONS.list.slice(-1)[0].key !==
          $scope.profile.user_metadata.notifications.version;

      $scope.notificationSeen = function() {
        $scope.newNotification = false;
      };

      $rootScope.$on('$stateChangeStart', function(ev, to, toParams, from) {
        if (to.customerTabs === undefined && from.customerTabs === undefined) {
          $scope.tabPage = false;
        }
        $scope.customerPage = true;
        if ((from.name === 'admin.transactions' || from.name === 'admin.issueRefund' ||
          from.name === 'admin.correctionRequests' || from.name === 'admin.corrections') &&
          to.name === 'admin.customersById') {
          Customer.model.searchForm.customerId = toParams.customerId;
          Customer.search(1).then(function(data) {
            var path = '/admin/customers/' + data.list[0].id + '/transaction';
            $location.path(path);
          });
        }
        if (from.name === 'admin.customerSummary' && to.name === 'admin.customersById') {
          $location.path('/admin/transactions');
        }

        $scope.pageLoadAgain();
      });

      $scope.getAvailableParticipantCount = function() {
        var count = $scope.availableParticipants.length;
        for (var i = 0; i < $scope.availableParticipants.length; i++) {
          count += $scope.availableParticipants[i].children.length;
        }
        return count;
      };

      $scope.loadCurrentParticipant = function(callback) {
        Participant.fetchCurrentParticipant().then(function() {
          $rootScope.currentParticipant = Participant.model.currentParticipant;
          if(callback) {
            callback();
          }
        }).catch(function() {
          $rootScope.currentParticipant = null;
        });
      };

      $scope.getCappingTypes = function() {
        return $scope.feature_flags.TimeBasedCapping ?
            PRODUCTS_FILTER.cappingTypes :
            PRODUCTS_FILTER.cappingTypes.filter(function(ct) { return ct !== 'TIME_BASED_CAP'; });
      };

      $scope.loadCurrentParticipant(function() {
        sidebarService.loadMenuItems(FeatureFlags);

        if ($scope.availableParticipants.length < 1) {
          RightBar.loadAvailableParticipants(Auth.currentUser.profile.user_id).then(function() {
            $scope.availableParticipants = RightBar.model.participants;
          });
        }
      });
    }
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('AnalysisConfig', AnalysisConfig);
AnalysisConfig.$inject = ['$resource', 'Auth', 'Config', '$q'];

/** @ngInject */
function AnalysisConfig($resource, Auth, Config, $q) {
  var cache = {};

  var url = Config.getAnalyticsAPIServerURL() + ':participantId/analysis/config';

  var AnalysisConfig = $resource(url, {
    participantId: '@participantId',
  }, {
    get: {
      method: 'get',
    },
  });

  AnalysisConfig.getConfig = function() {
    return {};
  };

  return AnalysisConfig;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('CorrectionAnalysis', CorrectionAnalysis);
CorrectionAnalysis.$inject = ['$resource', 'Auth', 'Config', 'Utils', '$filter'];

/** @ngInject */
function CorrectionAnalysis($resource, Auth, Config, Utils, $filter) {
  var url = Config.getAnalyticsAPIServerURL() + ':participantId';

  var CorrectionAnalysis = $resource(url + '/analysis/corrections', {
    participantId: '@participantId',
  }, {
    getCorrections: {
      method: 'get',
    },
  });

  CorrectionAnalysis.model = {
    currencySymbol: undefined,
    summaryData: {},
    detailData: [],
  };

  CorrectionAnalysis.getCorrectionsData = function(startDate, endDate, currencyCode) {
    var query = {
      'participantId': Auth.getParticipantName(),
      'start_date': startDate,
      'end_date': endDate,
      'currency_code': currencyCode,
    };
    return CorrectionAnalysis.getCorrections(query, function(data) {
      if (!Auth.isParent()) {
        data.detailData = data.detailData.filter(function(row) {
          return row.initiator !== null ||
            (row.initiator === null && row.participant_name === null);
        });
      }
      data.currencySymbol = $filter('toISOCurrencySymbol')(currencyCode);
      CorrectionAnalysis.model.currencySymbol = data.currencySymbol;
      CorrectionAnalysis.model.summaryData = data.summaryData;
      CorrectionAnalysis.model.detailData = data.detailData;
    }, function() {
      CorrectionAnalysis.model.currencySymbol = undefined;
      CorrectionAnalysis.model.summaryData = {};
      CorrectionAnalysis.model.detailData = [];
    }).$promise;
  };

  return CorrectionAnalysis;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('CustomerAnalysis', CustomerAnalysis);
CustomerAnalysis.$inject = ['$resource', 'Auth', 'Config'];

/** @ngInject */
function CustomerAnalysis($resource, Auth, Config) {
  var url = Config.getAnalyticsAPIServerURL() + ':participantId';

  var CustomerAnalysis = $resource(url + '/analysis/customers-status', {
    participantId: '@participantId',
  }, {
    getCustomersStatus: {
      method: 'get',
    },
    getCustomerSummary: {
      method: 'get',
      url: url + '/analysis/customers-status-summary',
      isArray: false,
    },
    getCustomersCappedVsUncappedData: {
      method: 'get',
      url: url + '/analysis/customers-capped-vs-uncapped'
    },
    getCustomersCappedVsUncappedSummary: {
      method: 'get',
      url: url + '/analysis/customers-capped-vs-uncapped-summary',
      isArray: false,
    }
  });

  CustomerAnalysis.model = {
    currencySymbol: undefined,
    new_vs_returning: {summaryData: {}, csvData: [], csvDataSummary: {}},
    cohort_retention: {filter_labels: []},
    reactivated_customers: {},
    reactivated_customers_history: {},
    lifetime_value: {},
    rfm_segmentation: {},
    capped_vs_uncapped: {summaryData: {}, csvData: []}
  };

  function summariseCsvData() {
    var csvData = CustomerAnalysis.model.new_vs_returning.csvData;
    var csvDataSummary = {};
    csvDataSummary.new = 0;
    csvDataSummary.new_nominal = 0;
    csvDataSummary.new_adjusted = 0;
    csvData.forEach(function(entry) {
          csvDataSummary.new = csvDataSummary.new + entry.new;
          csvDataSummary.new_nominal = csvDataSummary.new_nominal + entry.new_nominal;
          csvDataSummary.new_adjusted = csvDataSummary.new_adjusted + entry.new_adjusted;
    });
    CustomerAnalysis.model.new_vs_returning.csvDataSummary = csvDataSummary;
  }

  CustomerAnalysis.getCustomersData = function(startDate, endDate, currencyCode) {
    var query = getQueryParameters(startDate, endDate, currencyCode);

    return CustomerAnalysis.getCustomersStatus(query,
      function(data) {
        CustomerAnalysis.model.new_vs_returning.csvData = data.customers_status_result;
        CustomerAnalysis.model.cohort_retention = data.cohort_retention;
        CustomerAnalysis.model.average_revenue = data.average_revenue;
        CustomerAnalysis.model.reactivated_customers = data.reactivated_customers;
        CustomerAnalysis.model.reactivated_customers_history = data.reactivated_customers_history;
        CustomerAnalysis.model.lifetime_value = data.lifetime_value;
        CustomerAnalysis.model.rfm_segmentation = data.rfm_segmentation;

        summariseCsvData();
      },
      function() {
        CustomerAnalysis.model.currencySymbol = undefined;
        CustomerAnalysis.model.new_vs_returning.csvData = [];
        CustomerAnalysis.model.new_vs_returning = [];
        CustomerAnalysis.model.cohort_retention = [];
        CustomerAnalysis.model.rfm_segmentation = [];
      }).$promise;
  };

  CustomerAnalysis.getCustomersSummary = function(startDate, endDate, currencyCode) {
    var query = getQueryParameters(startDate, endDate, currencyCode);

    return CustomerAnalysis.getCustomerSummary(query,
      function(data) {
        CustomerAnalysis.model.new_vs_returning.summaryData = data.customers_status_summary_result;
      },
      function() {
        CustomerAnalysis.model.new_vs_returning.summaryData = {};
      }).$promise;
  };

  CustomerAnalysis.getCappedVsUncappedData = function(startDate, endDate, currencyCode) {
    var parameters = getQueryParameters(startDate, endDate, currencyCode);

    return CustomerAnalysis.getCustomersCappedVsUncappedData(parameters,
      function(data) {
        CustomerAnalysis.model.capped_vs_uncapped.csvData = data.data;
      },
      function() {
        CustomerAnalysis.model.capped_vs_uncapped.csvData = [];
      }).$promise;
  };

  CustomerAnalysis.getCappedVsUncappedSummary = function(startDate, endDate, currencyCode) {
    var parameters = getQueryParameters(startDate, endDate, currencyCode);

    return CustomerAnalysis.getCustomersCappedVsUncappedSummary(parameters,
      function(data) {
        CustomerAnalysis.model.capped_vs_uncapped.summaryData = data.summaryData;
      },
      function() {
        CustomerAnalysis.model.capped_vs_uncapped.summaryData = {};
      }).$promise;
  };

  function getQueryParameters(startDate, endDate, currencyCode) {
    return {
      'participantId': Auth.getParticipantName(),
      'start_date': startDate,
      'end_date': endDate,
      'currency_code': currencyCode,
    };
  }

  return CustomerAnalysis;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('DashboardAnalysis', DashboardAnalysis);
DashboardAnalysis.$inject = ['$resource', 'Auth', 'Config', 'Utils', 'AnalysisData'];

/** @ngInject */
function DashboardAnalysis($resource, Auth, Config, Utils, AnalysisData) {
  var url = Config.getAPIServerURL() + ':participantId';

  var DashboardAnalysis = $resource(url + '/transactions', {
    participantId: '@participantId',
  }, {
    getSales: {
      method: 'get',
    },
  });

  DashboardAnalysis.model = {
    csvData: [],
    graph: [],
  };

  DashboardAnalysis.getData = function() {
    var query = {
      'participantId': Auth.getParticipantName(),
      'limit': 10,
    };
    return DashboardAnalysis.getSales(query, function() {
      DashboardAnalysis.model.csvData = AnalysisData.json;
    }).$promise;
  };

  return DashboardAnalysis;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('DebtAnalysis', DebtAnalysis);
DebtAnalysis.$inject = ['$resource', '$filter', 'Auth', 'Config'];

/** @ngInject */
function DebtAnalysis($resource, $filter, Auth, Config) {
  var url = Config.getAnalyticsAPIServerURL() + ':participantId/analysis/debt-recovery';

  var DebtAnalysis = $resource(url, {
    participantId: '@participantId',
  }, {
    getDebts: {
      method: 'get',
    },
  });

  return {
    getDebtRecoveryData: function(startDate, endDate, currencyCode) {
      var query = {
        'participantId': Auth.getParticipantName(),
        'start_date': startDate,
        'end_date': endDate,
        'currency_code': currencyCode,
      };

      return DebtAnalysis.getDebts(query).$promise;
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('DeclineAnalysis', DeclineAnalysis);
DeclineAnalysis.$inject = ['$resource', '$filter', 'Auth', 'Config'];

/** @ngInject */
function DeclineAnalysis($resource, $filter, Auth, Config) {
  var url = Config.getAnalyticsAPIServerURL() +
    ':participantId/analysis/declines';

  var api = $resource(url,
    {participantId: '@participantId'}, {
      getDeclines: {
        method: 'get',
      },
    });

  return {
    getDeclines: function(startDate, endDate, currencyCode) {
      var query = {
        'participantId': Auth.getParticipantName(),
        'start_date': startDate,
        'end_date': endDate,
        'currency_code': currencyCode,
        'zip': 1,
      };

      return api.getDeclines(query).$promise;
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('TransactionAnalysis', TransactionAnalysis);
TransactionAnalysis.$inject = ['$resource', 'Auth', 'Config', 'Utils', '$filter', 'pako'];

/** @ngInject */
function TransactionAnalysis($resource, Auth, Config, Utils, $filter, pako) {
  var url = Config.getAnalyticsAPIServerURL() + ':participantId';

  var TransactionAnalysis = $resource(url + '/analysis/transactions', {
    participantId: '@participantId'
  }, {
    getTransactions: {
      method: 'get'
    },
    downloadTransactions: {
      url: url + '/analysis/transactions/download/details',
      method: 'get',
      transformResponse: function(data, headers) {
        return {
          data: data,
          headers: headers()
        };
      }
    }
  });

  TransactionAnalysis.model = {
    currencySymbol: undefined,
    summaryData: {},
    detailData: [],
    hasAdjustments: false
  };

  TransactionAnalysis.getTransactionData = function(startDate, endDate, currencyCode, locations) {
    var query = {
      'participantId': Auth.getParticipantName(),
      'start_date': startDate,
      'end_date': endDate,
      'currency_code': currencyCode
    };
    if(locations.length>0) {
      query.locations = locations.join(',');
    }

    return TransactionAnalysis.getTransactions(query,
      function(data) {
        if(data.data) {
          data = unzipData(data);
        }

        if (!Auth.isParent()) {
          data.detailData = data.detailData.filter(function(row) {
            return !(row.scheme === null && row.participant_name !== null);
          });
        }
        data.currencySymbol = $filter('toISOCurrencySymbol')(currencyCode);
        TransactionAnalysis.model.currencySymbol = data.currencySymbol;
        TransactionAnalysis.model.summaryData = data.summaryData;
        TransactionAnalysis.model.detailData = data.detailData;
        TransactionAnalysis.model.hasAdjustments = data.detailData.some(function(item) {
          return item.nominal_amount !== item.adjusted_amount;
        });
        if(data.locations) {
          TransactionAnalysis.model.locations = data.locations
            .map(
              function(location) {
                return location.location_name;
              })
            .sort(function(a, b) {
              return a === 'UNKNOWN' ?
                -1 :
                (b === 'UNKNOWN' ? 1 : a.localeCompare(b));
            });
        }
      },
      function() {
        TransactionAnalysis.model.currencySymbol = undefined;
        TransactionAnalysis.model.summaryData = {};
        TransactionAnalysis.model.detailData = [];
        TransactionAnalysis.model.hasAdjustments = false;
        TransactionAnalysis.model.locations = [];
      }).$promise;
  };

  function unzipData(data) {
    return JSON.parse(
      pako.inflate(
        atob(data.data),
        {to: 'string'}
      )
    );
  }

  return TransactionAnalysis;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.constants')

  .constant('AUTH0', (function() {
    var __env = window.__env || {};
    return {
      options: {
        avatar:null,
        closable: true,
        theme: {
          logo: 'https://static.littlepay.com/static/images/svg/logos/littlepay-logo-positive.svg',
          primaryColor: '#00A35F',
        },
        languageDictionary: {
          title: 'Littlepay Merchant Portal',
        },
        auth: {
          sso: false,
          params: {
            scope: 'openid name app_metadata identities user_id last_password_reset',
          },
        },
        language: localStorage.getItem('language') || 'en',
      },
      clientID: __env.AUTH0_clientID,
      domain: __env.domain,
    };
  })())
  .constant('WEEK_NAMES', {
    'SUNDAY': 'Sunday',
    'MONDAY': 'Monday',
    'TUESDAY': 'Tuesday',
    'WEDNESDAY': 'Wednesday',
    'THURSDAY': 'Thursday',
    'FRIDAY': 'Friday',
    'SATURDAY': 'Saturday',
  })
  .constant('WEEK_NAMES_INDEX', [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
  ])
  .constant('layoutSizes', {
    resWidthCollapseSidebar: 1200,
    resWidthHideSidebar: 500,
  })
  .constant('LITTLEPAY_API', (function() {
    var __env = window.__env || {};
    return {
      protocol: 'https',
      host: __env.host,
      port: 443,
      rootEndpoint: '/api/v1/participant/',
    };
  })())
  .constant('LITTLEPAY_ANALYTICS_API', (function() {
    var __env = window.__env || {};
    return {
      protocol: 'https',
      host: __env.analytics_host,
      port: 443,
      rootEndpoint: '/api/v1/',
    };
  })())
  .constant('NOTIFICATIONS', (function() {
    var __env = window.__env || {};
    return {
      list: __env.list,
    };
  })())
  .constant('TRANSACTION_SIMULATOR_OPTIONS', {
    currencies: [
      'AUD',
      'CRC',
      'EUR',
      'GBP',
      'NZD',
      'USD'
    ],
    transactionOutcomes: [
      {value: 'ALLOW', label: 'ALLOW'},
      {value: 'DENY', label: 'DENY'}
    ],
    validBins: [
      '411111',
      '123456',
      '424242',
      '401288',
      '426398',
      '444433',
      '557700',
      '555544',
      '510006',
      '555555',
      '453244',
      '471634',
      '453939',
      '471624',
      '437399',
      '402400',
      '448508',
      '402400',
      '453284',
      '453229',
      '520769',
      '553179',
      '523843',
      '546793',
      '531219',
      '546573',
      '533726',
      '553074',
      '511847',
      '528500',
      '476173',
      '541333',
      `462294`
    ]
  });

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .constant('CUSTOM_MERCHANT_CONFIG', (function () {
    var CUSTOM_SUBDOMAINS = {
      KUBAPAY: 'kubapay',
      VIXTECH: 'vixtech',
    };
    var subdomain = window.__env && window.__env.merchantFromSubdomain;
    var htmlTitle = 'Littlepay Merchant Portal';
    var faviconPath = '';
    var shouldShowPrivacyPolicy = subdomain !== CUSTOM_SUBDOMAINS.KUBAPAY;
    var shouldShowSupportTab = subdomain !== CUSTOM_SUBDOMAINS.KUBAPAY;
    var customAuth0LogoPath = null;

    if (subdomain === CUSTOM_SUBDOMAINS.KUBAPAY) {
      customAuth0LogoPath = 'assets/images/logo-kubapay.png';
    } else if (subdomain === CUSTOM_SUBDOMAINS.VIXTECH) {
      customAuth0LogoPath = 'assets/images/logo-vix.svg';
      htmlTitle = 'Merchant Portal';
      faviconPath = '/assets/images/favicons/vixtech';
    }

    return {
      shouldShowPrivacyPolicy: shouldShowPrivacyPolicy,
      shouldShowSupportTab: shouldShowSupportTab,
      customAuth0LogoPath: customAuth0LogoPath,
      subdomain : subdomain,
      htmlTitle: htmlTitle,
      faviconPath: faviconPath,
      CUSTOM_SUBDOMAINS: CUSTOM_SUBDOMAINS,
    };
  })());


'use strict';

angular.module('littlepayPortalMerchantApp.theme.constants')
  .constant('TRANSACTION_FILTERS', {
    'paymentGuaranteeStatus': [
      'CREATED',
      'AUTHORISED',
      'VERIFIED',
      'UNAVAILABLE',
      'INVALID',
      'DECLINED',
      'FAILED',
      'UNKNOWN',
      'LOST',
      'STOLEN',
      'LATE',
      'UNRECOVERABLE'],
    'settlementResult': ['SETTLED', 'REJECTED'],
    'tripStatus': {
      'PENDING': 'pending_variable_fare',
      'INCOMPLETE': 'incomplete_variable_fare',
    },
    'cardType': ['DEBIT', 'CREDIT'],
    'formFactor': {
       'CARD': 'CARD',
       'NON_CARD':'NON CARD'
    },
    'CARD': ['card', 'mini-card'],
    'NON_CARD': ['non-card', 'key-fob', 'mobile-tag','mobile-phone', 'mobile','wrist-worn', 'watch', 'other', 'unknown']
  });

'use strict';

angular.module('littlepayPortalMerchantApp.theme.constants')
  .constant('PRODUCTS_FILTER', {
    'cappingActivation': {
      'CUSTOMER_DEFAULT': 'All Customers',
      'REGISTERED_CUSTOMER_DEFAULT': 'Registered Customers',
    },
    'productType': {
      'CAPPING': 'Capping'
    },
    'cappingTypes': [
      'DAILY_CAP',
      'WEEKLY_CAP',
      'MULTI_DAY_CAP',
      'TIME_BASED_CAP'
    ],
    'cappingStatus': {
      'INACTIVE': 'Inactive',
      'ACTIVE': 'Active',
    },
    'discountType': ['FIXED', 'PERCENTAGE'],
    'transactionTypes': ['variable', 'flat'],
    'zonePricingType': ['INEXPENSIVE', 'EXPENSIVE', 'PEAK', 'OFFPEAK'],
    'cappingAppliedLevel': ['CUSTOMER', 'CARD'],
    'maxOverlapHours': 5,
    'zoneMode': ['CONCENTRIC', 'NONCONCENTRIC'],
    'incentiveType': {
      'DAILY_CAP': 'Daily Cap Discount',
      'CUMULATIVE_CAP': 'Cumulative Cap'
    },
    'incentiveDiscountType': {
      'FLAT': 'Flat',
      'PERCENTAGE': 'Percentage'
    },
    'incentiveDiscountQualifier': {
      'SINGLE_TRIP': 'Single Trip',
      'CAP_REACHED': 'Cap Reached'
    },
    'cumulativeCapConfiguration': {
      'DAILY_TABLE': 'Daily Table',
      'ZONE_TRIANGLE': 'Zone Triangle',
    }
  });

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('aggregationStatus', aggregationStatus);

/** @ngInject */
function aggregationStatus() {
  return {
    restrict: 'E',
    template: '<span class="label label-warning" ng-if="adjusted">{{ "GUARANTEESTATUS.ADJUSTED" | translate }}</span><span class="label label-incomplete" ng-if="incomplete">{{ "GUARANTEESTATUS.INCOMPLETE" | translate }}</span><span class="label label-warning" ng-if="pending">{{ "GUARANTEESTATUS.TAP-PENDING" | translate }}</span><span class="label label-danger" ng-if="initiallyDeclined">{{ "GUARANTEESTATUS.INITIALLY-DECLINED" | translate }}</span>',
    transclude: true,
    scope: {
      'ngModel': '=',
    },
    link: function(scope) {

      scope.adjusted = false;
      scope.incomplete = false;
      scope.pending = false;
      scope.initiallyDeclined = false;

      if (scope.ngModel.aggregation_status_history) {
        var hasDeclined = scope.ngModel.aggregation_status_history.filter(function(a) {
          return a.state === 'DECLINED';
        });

        var hasAuthorised = scope.ngModel.aggregation_status_history.filter(function(a) {
          return a.state === 'AUTHORISED';
        });

        var orderedStatusList = scope.ngModel.aggregation_status_history.sort(function(a, b) {
          return moment(a.updated_time, 'YYYY-MM-DDTHH:mm:ssZ') > moment(b.updated_time, 'YYYY-MM-DDTHH:mm:ssZ') ? -1 : 1;
        });

        scope.initiallyDeclined = hasDeclined.length > 0 && hasAuthorised.length > 0 &&
          orderedStatusList[0].state !== 'DECLINED';
      }

      angular.forEach(scope.ngModel.micropayments, function(micropayment) {
        if (micropayment.charge_type === 'incomplete_variable_fare') {
          scope.incomplete = true;
        }
        if (micropayment.charge_type === 'pending_variable_fare') {
          scope.pending = true;
        }
        angular.forEach(micropayment.adjustments, function(adjustment) {
          if (adjustment.applied) {
            scope.adjusted = true;
          }
        });
      });

    },
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('calcPeakPeriod', calcPeakPeriod);

/** @ngInject */
function calcPeakPeriod($filter, Utils) {
  return {
    require: 'ngModel',
    scope: {
      'ngModel': '=',
      'calcPeakPeriod': '=',
      'offPeak': '=',
    },

    link: function(scope, element, attrs, modelCtrl) {

      modelCtrl.$render = function() {
        element.val($filter('secondsToHms')(modelCtrl.$viewValue));
      };

      function peakCalc() {
        var total = 0;
        for (var i = 0; i < scope.calcPeakPeriod.length; i += 2) {
          total += Utils.convertToSec(scope.calcPeakPeriod[i + 1]) -
            Utils.convertToSec(scope.calcPeakPeriod[i]);
        }
        if (scope.offPeak) {
          return 86400 - total;
        } else {
          return total;
        }
      }

      scope.$watch('calcPeakPeriod', function() {
        if (angular.isArray(scope.calcPeakPeriod) && scope.calcPeakPeriod.length > 1) {
          scope.$evalAsync(function() {
            scope.ngModel = peakCalc();
          });
        } else {
          scope.ngModel = '';
        }
      });
    },
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('calcPeakSegment', calcPeakSegment);

/** @ngInject */
function calcPeakSegment() {
  return {
    require: 'ngModel',
    scope: {
      'ngModel': '=',
      'calcPeakSegment': '=',
      'offPeak': '=',
    },

    link: function(scope) {

      function peakSegmentCalc() {
        if (scope.offPeak) {
          return (scope.calcPeakSegment.length / 2) + 1;
        } else {
          return scope.calcPeakSegment.length / 2;
        }
      }

      scope.$watch('calcPeakSegment', function() {
        if (scope.calcPeakSegment.length > 1) {
          scope.$evalAsync(function() {
            scope.ngModel = peakSegmentCalc();
          });
        } else {
          scope.ngModel = '';
        }
      });
    },
  };
}

'use strict';

checkValidity.$inject = ['$browser'];
angular.module('littlepayPortalMerchantApp.theme').directive('checkValidity', checkValidity);

function checkValidity($browser) {
  return {
    require: 'ngModel',
    scope: {
      'ngModel': '=',
      'isValid': '=',
      'withIndex': '=',
      'minValue': '=',
      'withParent': '=',
      'disable': '=',
      'cannotBeNull': '='
    },
    link: function ($scope, $element, $attrs, ngModelCtrl) {
      var parent = $element.parent();

      function checkIsValid() {
        return $scope.isValid($scope.ngModel, $scope.withIndex)
      }

      var listener = function () {
        if ($scope.isValid) {
          ngModelCtrl.$setValidity('myField', checkIsValid());
        }
      };

      function checkHasError(condition) {
        if(condition) {
          removeError();
        }else {
          $scope.disable = true;
          parent.addClass('has-error');
        }
      }

      function hasError() {
        var hasError = checkIsValid() || ngModelCtrl.$viewValue === '';
        checkHasError(hasError);
      }

      if ($scope.withParent) {
        ngModelCtrl.$parsers.push(function () {
          if (ngModelCtrl.$viewValue) {
            hasError();
          } else {
            removeError();
          }
          return ngModelCtrl.$viewValue;
        });

        $scope.$watch('ngModel', function () {
          if ($scope.ngModel ) {
            hasError();
          }else if($scope.cannotBeNull && $scope.ngModel === ''){
            $scope.disable = true;
            parent.addClass('has-error');
          }
        });
      }

      function removeError() {
        $scope.disable = false;
        parent.removeClass('has-error');
      }

      $element.bind('change', listener);
      $element.bind('keydown', function (event) {
        var key = event.keyCode;
        // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
        // This lets us support copy and paste too
        if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) {
          return;
        }
        $browser.defer(listener); // Have to do this or changes don't get picked up properly
      });

      $element.bind('paste cut', function () {
        $browser.defer(listener);
      });
    }
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('dropdown', dropdown);

/** @ngInject */
function dropdown($timeout) {
  return {
    require: 'ngModel',
    scope: {
      'ngModel': '=',
      'dropdownChange': '=',
      'multiple': '=',
      'clearable': '=',
      'clearedFunction': '=',
      'defaultText': '@',
      'synUiWithModel': '@',
      'clear': '=?',
      'cleared': '=',
      'hasError': '=',
    },

    link: function(scope, element) {
      var oldValue;

      var dropdown = $(element)
        .dropdown('set selected', scope.ngModel)
        .dropdown({
          clearable: scope.clearable || false,
          placeholder: scope.defaultText,
          onChange: function(value) {
            if(value) {
              scope.$apply(function() {
                scope.ngModel = value;
              });
              if (scope.dropdownChange) {
                $timeout(scope.dropdownChange(value), 1);
              }
            }else if (scope.ngModel && scope.cleared) {
              // scope.ngModel = '';
              scope.cleared(scope.ngModel);
            }
          },
          fullTextSearch: true
        });

      function isMultipleSelect() {
        return $(element).attr('multiple')!==undefined && !$(element).hasClass('multiple');
      }

      scope.clear = function() {
        setTimeout(function () {
          dropdown.dropdown('clear');
        },0);
      };

      scope.$watch('ngModel', function(value) {

        $timeout(function() {

          if(scope.hasError) {
            dropdown.addClass('error');
          }else {
            dropdown.removeClass('error');
          }

          if (value===undefined || value==='' || (angular.isArray(value) && value.length<1)) {
            dropdown.dropdown('hide').dropdown('clear');
            if (scope.defaultText) {
              dropdown.dropdown('set text', scope.defaultText);
            } else if (dropdown.dropdown('get item', value)) {
              dropdown.dropdown('set text',
                dropdown.dropdown('get item', value).html());
            } else {
              dropdown.dropdown('set text', '');
            }

            oldValue = value;
          } else {
            if (scope.synUiWithModel) {
              //a bit hacky, but couldnt find another way to make it work
              //when the value changes, compare with old value and remove
              //any labels that are no longer selected
              if(isMultipleSelect() && oldValue) {
                oldValue.forEach(function(v) {
                  if(value.indexOf(v)===-1) {
                    dropdown.dropdown('remove label', v);
                  }
                });
              } else {
                dropdown.dropdown('set selected', value);

                var option = dropdown.dropdown('get item', value);
                if (!!option) {
                  dropdown.dropdown('set text', option.html());
                }
              }
            }
          }

          oldValue = value;
        });
      });
    },
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('hcChart', hcChart);

/** @ngInject */
function hcChart($window) {
  return {
    restrict: 'C',
    template: '<div></div>',
    scope: {
      options: '=',
      language: '=',
      onLanguageChange: '='
    },
    link: function(scope, element) {
      var Highcharts = $window.Highcharts;

      Highcharts.setOptions({
        lang: {
          thousandsSep: ',',
        },
      });

      scope.$watch('language', function(newLanguage) {
        var currentLanguage = localStorage.getItem('locale');
        if(newLanguage && newLanguage!==currentLanguage && scope.onLanguageChange) {
          scope.onLanguageChange();
        }
      });


      scope.$watch('options', function(newVal) {
        if (newVal) {
          Highcharts.chart(element[0], scope.options);
        }
      }, true);
    },
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('hourInput', hourInput);
hourInput.$inject = ['$filter', '$browser'];

/** @ngInject */
function hourInput($filter, $browser) {
  return {
    require: 'ngModel',
    link: function($scope, $element, $attrs, ngModelCtrl) {
      var listener = function() {
        var value = $element.val();

        var timeInputRegEx = /(\d{0,2})(:)*(\d{0,2})(:)*(\d{0,2})/;
        var matches = value.match(timeInputRegEx);
        var results = '';
        var hour = matches[1];
        var colon1 = matches[2];
        var minute = matches[3];
        var colon2 = matches[4];
        var second = matches[5];

        if (hour && hour < 24) {
          results = hour;
        }
        if (colon1 && hour.length === 2) {
          results = results + colon1;
        }
        if (minute && (minute < 61)) {
          if (colon1) {
            results = results + minute;
          } else {
            results = results + ':' + minute;
          }
        }
        if (colon2 && (hour.length === 2 && colon1 && minute.length === 2)) {
          results = results + colon2;
        }
        if (second && (second < 61)) {
          if (colon2) {
            results = results + second;
          } else {
            results = results + ':' + second;
          }
        }
        $element.val(results);
      };

      // This runs when we update the text field
      ngModelCtrl.$parsers.push(function(viewValue) {
        if (viewValue) {
          var transformedInput = viewValue.replace(/[^0-9]\s*:/g, '');
          if (transformedInput !== viewValue) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      });

      // This runs when the model gets updated on the scope directly and keeps our view in sync
      ngModelCtrl.$render = function() {
        $element.val($filter('date')(ngModelCtrl.$viewValue, 'HH:mm:ss'));
      };

      $element.bind('change', listener);
      $element.bind('keydown', function(event) {
        var key = event.keyCode;
        // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
        // This lets us support copy and paste too
        if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
          return;
        }
        $browser.defer(listener); // Have to do this or changes don't get picked up properly
      });

      $element.bind('paste cut', function() {
        $browser.defer(listener);
      });
    },
  };
}

/**
 * @author z.geddes
 * created on 02.02.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      },
      link: function(scope, ele, attrs) {
        scope.$watch(attrs.selected, function() {
          scope.selected = scope.$eval(attrs.selected);
          scope.selectedVar = attrs.selectedVar;
          scope.selectedName = attrs.selectedName;
        });
      },
    };
  }

})();

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('isAdjusted', isAdjusted);

/** @ngInject */
function isAdjusted() {
  return {
    restrict: 'E',
    template: '<span class="label label-warning" ng-if="adjusted">{{ "GUARANTEESTATUS.ADJUSTED" | translate }}</span>',
    transclude: true,
    scope: {
      'ngModel': '=',
    },
    link: function(scope) {

      scope.adjusted = isAdjusted();

      function isAdjusted() {
        var adjusted = false;
        angular.forEach(scope.ngModel.micropayment.adjustments, function(adjustment) {
          if (adjustment.applied) {
            adjusted = true;
          }
        });
        return adjusted;
      }

    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')

  .directive('ngDatepicker', ngDatepicker);
ngDatepicker.$inject = ['$timeout', '$locale'];

/** @ngInject */
function ngDatepicker($timeout, $locale) {

  var setScopeValues = function(scope, attrs) {
    scope.locale = attrs.locale || 'en';
    scope.firstWeekDaySunday = scope.$eval(attrs.firstWeekDaySunday) || false;
    scope.calendarOpened = scope.$eval(attrs.calendarOpened) || false;
    scope.inset = attrs.inset || 'absolute';
    scope.hasError = false;
  };

  return {
    restrict: 'EA',
    require: '?ngModel',
    scope: {
      notBefore: '=',
      notAfter: '=',
      fromNowOn: '=',
      remove: '=',
      hasError: '=?'
    },
    link: function(scope, element, attrs, ngModel) {
      setScopeValues(scope, attrs);

      scope.format = 'YYYY-MM-DD';
      scope.days = [];
      scope.dayNames = [];
      scope.calendarDateValue = null;

      moment.locale(scope.locale);
      var calendarDate = moment();

      var generateCalendar = function(start, end) {
        var lastDayOfMonth = calendarDate.endOf('month').date(),
          month = calendarDate.month(),
          year = calendarDate.year(),
          n = 1;
        var startDate = start || scope.notBefore;
        var endDate = end || scope.notAfter;
        var firstWeekDay = scope.firstWeekDaySunday === true ?
          calendarDate.set('date', 2).day() :
          calendarDate.set('date', 1).day();
        if (firstWeekDay !== 1) {
          n -= firstWeekDay - 1;
        }

        //Code to fix date issue
        if (n === 2) {
          n = -5;
        }

        scope.calendarDateValue = calendarDate;
        scope.days = [];
        var selectedDate = moment(ngModel.$viewValue, scope.format);
        for (var i = n; i <= lastDayOfMonth; i += 1) {
          if (i > 0) {
            var currentDate = moment(year+'-'+ (month + 1)+'-'+i, 'YYYY-MM-DD');
            scope.days.push({
              day: i,
              month: month + 1,
              year: year,
              enabled: !isDisabledDate(currentDate, startDate, endDate),
              today: moment().isSame(currentDate, 'day'),
              selected: selectedDate.isSame(currentDate, 'day'),
            });
          } else {
            scope.days.push({
              day: null,
              month: null,
              year: null,
              enabled: false,
            });
          }
        }

        function isDisabledDate(currentDate, startDate, endDate) {
            return futureDateIsInvalid(currentDate) || pastDateIsInvalid(currentDate) || (startDate !== undefined && moment(startDate).isAfter(currentDate, 'day')) || (endDate !== undefined && moment(endDate).isBefore(currentDate, 'day'));
        }

      };

      if(scope.calendarOpened) {
        generateCalendar();
      }

      var generateDayNames = function() {
        var date = scope.firstWeekDaySunday === true ? moment('2015-06-07') : moment('2015-06-01');
        for (var i = 0; i < 7; i += 1) {
          scope.dayNames.push(date.format('ddd'));
          date.add('1', 'd');
        }
      };

      generateDayNames();

      scope.showCalendar = function() {
        scope.calendarOpened = true;
        generateCalendar();

        var left = getInput().offset().left;
        var top = getInput().offset().top + getInput().outerHeight(true);

        getDatepicker()
          .appendTo('body')
          .css({
            'left': left + 'px',
            'top': top + 'px',
            'position': 'absolute'
          });
      };

      function futureDateIsInvalid(date) {
        return scope.fromNowOn === false && moment().isBefore(date, 'day');
      }

      function pastDateIsInvalid(date) {
        return scope.fromNowOn === true && moment().isAfter(date, 'day')
      }

      function getInput() {
        return $('#datepickerInput-' + scope.$id);
      }

      function getDatepicker() {
        return $('#datepickerBox-' + scope.$id);
      }

      function getWrapper() {
        return $('#datepickerWrapper-' + scope.$id);
      }

      function removeError() {
        getWrapper().removeClass('error');
        scope.hasError = false;
      }

      function addError() {
        getWrapper().addClass('error');
        scope.hasError = true;
      }

      scope.closeCalendar = function() {
        scope.calendarOpened = false;
      };

      scope.prevYear = function() {
        calendarDate.subtract(1, 'Y');
        generateCalendar();
      };

      scope.prevMonth = function() {
        calendarDate.subtract(1, 'M');
        generateCalendar();
      };

      scope.nextMonth = function() {
        calendarDate.add(1, 'M');
        generateCalendar();
      };

      scope.nextYear = function() {
        calendarDate.add(1, 'Y');
        generateCalendar();
      };

      scope.selectDate = function(event, date) {
        event.preventDefault();
        var selectedDate = moment(date.day + '.' + date.month + '.' + date.year, 'DD.MM.YYYY');
        scope.closeCalendar();
        ngModel.$setViewValue(selectedDate.format(scope.format));
        ngModel.$render();
      };

      scope.blurEventHandler = function() {
        var pickerBox = getDatepicker(),
          input = getInput();
        $timeout(function() {
          if (!$(document.activeElement).is(pickerBox) && !$(document.activeElement).is(input)) {
            scope.closeCalendar();
          }
        });
      };

      scope.$on('blurEvent', scope.blurEventHandler);

      scope.blurHandler = function() {
        scope.$emit('blurEvent');
      };

      scope.clearInput = function() {
        scope.remove(ngModel.$viewValue);
        scope.dateHolder = null;
      };

      scope.changeHandler = function() {
        if (!scope.dateHolder) {
          ngModel.$setViewValue(null);
          removeError();
        } else {
          var date = moment(scope.dateHolder, scope.getAndUpdateMomentDateFormat(), true);

          var isValid = date.isValid() && !futureDateIsInvalid(date) && !pastDateIsInvalid(date);

          if (isValid) {
            removeError();
            ngModel.$setViewValue(date.format(scope.format));
            ngModel.$render();
            generateCalendar(); // live update calendar while editing
          }else {
            addError();
          }
        }
      };

      scope.getAndUpdateMomentDateFormat = function() {
        // Moment locales do not match our Angular behaviour, e.g. M vs MM is cannot be defined at the locale level,
        // so convert our Angular locale date formats (e.g. d.M.y) to moment format (e.g. D.M.YYYY).
        var momentFormat = $locale.DATETIME_FORMATS.shortDate.toUpperCase();
        if (/\bY$/.test(momentFormat)) {
          // convert Y to YYYY, but leave YY as is
          momentFormat += 'YYY';
        }

        // re-render dateHolder if needed
        if (momentFormat !== scope.lastMomentFormat) {
          scope.lastMomentFormat = momentFormat;
          ngModel.$render();
        }

        return momentFormat;
      };

      scope.$watchGroup(['notBefore', 'notAfter'], function(newValues) {
        generateCalendar(newValues[0], newValues[1]);
      });

      ngModel.$render = function() {
        var newValue = ngModel.$viewValue;
        if (newValue) {
          var date = moment(newValue);
          scope.dateHolder = date.format(scope.getAndUpdateMomentDateFormat());
          calendarDate = date;
          removeError();
        }else {
          scope.dateHolder = null;
        }
      };
    },
    template: '<div id="datepickerWrapper-{{$id}}" class="ui fluid icon input">' +
      '	<input id="datepickerInput-{{$id}}" type="text" tabindex="1" ng-focus="showCalendar()" ng-blur="blurHandler()" class="ng-datepicker-input form-control" placeholder="{{ getAndUpdateMomentDateFormat() }}" ng-model="dateHolder" ng-change="changeHandler()" autocomplete="off">' +
      '<i class="times link icon" ng-if="remove && dateHolder" ng-click="clearInput()"></i>'+
      '</div>' +
      '<div id="datepickerBox-{{$id}}" class="ng-datepicker {{inset}}" tabindex="1" ng-show="calendarOpened" ng-blur="blurHandler()">' +
      '  <div class="controls">' +
      '    <div class="left">' +
      '      <i class="fa fa-backward prev-year-btn" ng-click="prevYear()"></i>' +
      '      <i class="fa fa-angle-left prev-month-btn" ng-click="prevMonth()"></i>' +
      '    </div>' +
      '    <span class="date">{{ calendarDateValue.toDate() | date:"MMMM y" }}</span>' +
      '    <div class="right">' +
      '      <i class="fa fa-angle-right next-month-btn" ng-click="nextMonth()"></i>' +
      '      <i class="fa fa-forward next-year-btn" ng-click="nextYear()"></i>' +
      '    </div>' +
      '  </div>' +
      '  <div class="day-names">' +
      '    <span ng-repeat="dn in dayNames">' +
      '      <span>{{ dn }}</span>' +
      '    </span>' +
      '  </div>' +
      '  <div class="calendar">' +
      '    <span ng-repeat="d in days">' +
      '      <span class="day" ng-click="selectDate($event, d)" ng-class="{disabled: !d.enabled, today: d.today, selected: d.selected }">{{ d.day }}</span>' +
      '    </span>' +
      '  </div>' +
      '</div>',
  };

}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('nouislider', nouislider);

nouislider.$inject = ['$window', '$timeout', 'Utils'];

/** @ngInject */
function nouislider($window, $timeout, Utils) {
  var noUiSlider = $window.noUiSlider;
  return {
    restrict: 'A',
    scope: {
      'options': '=',
    },
    link: function($scope, $element) {
      var slider = $element[0];

      $scope.ngModel = angular.copy($scope.options.start);

      for (var i = 0; i <= 24; i += 2) {
        $scope.options.value.push(i * $scope.options.hour);
      }
      initSlider();

      function initSlider() {
        slider = noUiSlider.create($element[0], {
          start: $scope.options.start,
          step: $scope.options.hour / 4,
          behaviour: 'drag',
          margin: $scope.options.hour / 2,
          connect: $scope.options.connect.length > 0 ? $scope.options.connect : false,
          range: $scope.options.range,
          pips: {
            mode: 'values',
            values: $scope.options.value,
            density: 2,
          },
          format: {
            to: function(value) {
              return Utils.convertToHour(Math.round(value));
            },
            from: function(value) {
              return Utils.convertToSec(value);
            },
          },
        });

        if ($scope.options.start.length < 2) {
          $element.find('.noUi-origin').first().hide();
        }

        $element.find('.noUi-value-large').each(function() {
          var val = $(this).html();
          $(this).html(Utils.convertToHour(val));
        });

        slider.on('update', function() {
          $timeout(function() {
            $scope.options.start = returnCurrentArray(slider.get());
          }, 1);

        });

        var base = $element.find('.noUi-connects');

        base.bind('dblclick', function() {
          var currentPeriods = getPeakPeriods(slider.get());
          var midPoint = (event.offsetX / base.width()) * 86400;
          var prevDiff = midPoint - (Math.floor(midPoint / (30 * 60)) * (30 * 60));
          var nextDiff = (Math.ceil(midPoint / (30 * 60)) * (30 * 60)) - midPoint;
          if (prevDiff < nextDiff) {
            midPoint = midPoint - prevDiff;
          } else {
            midPoint = midPoint + nextDiff;
          }
          currentPeriods = addPeakPeriod(midPoint, currentPeriods);
          currentPeriods = sortAndConvertPeakPeriods(currentPeriods);
          $scope.options.start = currentPeriods;
          addRange();
        });
      }

      function returnCurrentArray(val) {
        return angular.isArray(val) ? val : [val];
      }

      function addRange() {
        $scope.options.connect = Utils.adjustConnect($scope.options.start);
        slider.destroy();
        $timeout(initSlider(), 1);
      }

      function getPeakPeriods(val) {
        var periods = [];
        if (angular.isArray(val)) {
          for (var i = 0; i < val.length; i += 2) {
            var from = Utils.convertHourToSec(val[i]);
            var to = Utils.convertHourToSec(val[i + 1]);
            periods.push({
              'from': from,
              'to': to,
            });
          }
        }
        return periods;
      }

      function addPeakPeriod(midPoint, currentPeriods) {
        var margin = 30 * 60;

        //make sure double click isnt inside existing peak period
        for (var i = 0; i < currentPeriods.length; i++) {
          if (midPoint > currentPeriods[i].from - margin && midPoint < currentPeriods[i].to +
            margin) {
            return currentPeriods;
          }
        }

        var from = Math.max(0, midPoint - $scope.options.hour);

        //validate from time
        for (i = 0; i < currentPeriods.length; i++) {
          if (from > currentPeriods[i].from - margin && from < currentPeriods[i].to + margin) {
            from = currentPeriods[i].to + margin;
            break;
          }
        }

        var to = Math.min(86400, from + 2 * $scope.options.hour);

        //validate to time
        for (i = 0; i < currentPeriods.length; i++) {
          if (to > currentPeriods[i].from - margin && to < currentPeriods[i].to + margin) {
            to = currentPeriods[i].from - margin;
            break;
          }
        }

        //not enough room
        if (to - from < 30 * 60) {
          return currentPeriods;
        }

        currentPeriods.push({
          'from': from,
          'to': to,
        });
        return currentPeriods;
      }

      function sortAndConvertPeakPeriods(currentPeriods) {
        currentPeriods.sort(function(a, b) {
          if (a.to <= b.from) {
            return -1;
          }
          if (b.to <= a.from) {
            return 1;
          }
          return 0;
        });
        var convertedPeriods = [];
        for (var i = 0; i < currentPeriods.length; i++) {
          convertedPeriods.push(Utils.convertToHour(currentPeriods[i].from));
          convertedPeriods.push(Utils.convertToHour(currentPeriods[i].to));
        }
        return convertedPeriods;
      }

      $scope.$watch('options.removed', function(newValue) {
        if (newValue !== undefined) {
          $scope.options.start.splice(newValue.index * 2, 2);
          if ($scope.options.start.length === 0) {
            $scope.options.start = ['08:00'];
          }
          addRange();
        }
      }, true);
    },
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('numbersOnly', numbersOnly);

/** @ngInject */
function numbersOnly() {
  return {
    require: 'ngModel',

    link: function(scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9]/g, '');

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('paymentGuaranteeStatusLabel', paymentGuaranteeStatusLabel);

/** @ngInject */
function paymentGuaranteeStatusLabel() {
  return {
    restrict: 'E',
    template:
      '<span class="label label-{{ngModel.payment_guarantee_status | lowercase}}" ng-if="ngModel.payment_guarantee_status">' +
      '  {{ getTranslationKey() | translate }}' +
      '</span>',
    transclude: true,
    scope: {
      'ngModel': '=',
    },
    link: function(scope) {
      scope.getTranslationKey = function() {
        var status = scope.ngModel.payment_guarantee_status;
        var translationKey = 'GUARANTEESTATUS.' + status;

        if (status === 'LOST' || status === 'STOLEN') {
          translationKey = 'TRANSACTIONS.' + status + '-CARD';
        } else if (status === 'LATE') {
          translationKey = 'TRANSACTIONS.LATE-TAP';
        }
        return translationKey;
      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('shortMediumDateTime', shortMediumDateTime);

/** @ngInject */
function shortMediumDateTime() {
  return {
    restrict: 'E',
    template: '{{ ngModel | date:"shortDate"}} {{ ngModel | date:"mediumTime"}}',
    transclude: true,
    scope: {
      'ngModel': '=',
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('tapLocation', tapLocation);

/** @ngInject */
function tapLocation() {
  return {
    restrict: 'E',
    template:
      '<p>' +
      '  {{ ngModel.location }}' +
      '  <span ng-if="ngModel.zone_names && ngModel.zone_names.length">' +
      '    {{ getTranslationKey("IN-ZONE") | translate:{ zone: (ngModel.zone_names | join:{ limit: 3, useAnd: true }) } }}' +
      '  </span>' +
      '  <span ng-if="ngModel.route_id">' +
      '    {{ getTranslationKey("ON-ROUTE") | translate:{ route: ngModel.route_id } }}' +
      '  </span>' +
      '</p>',
    transclude: true,
    scope: {
      ngModel: '=',
    },
    link: function(scope) {
      scope.getTranslationKey = function(key) {
        return 'COMPONENTS.TAP-LOCATION.' + key;
      };
    }
  };
}

/*global angular,window*/
(function withAngular(angular, window) {
  'use strict';

  var directiveName = 'tooltips'
    , resizeObserver = (function resizeObserver() {

    var callbacks = []
      , lastTime = 0
      , runCallbacks = function runCallbacks(currentTime) {

      if (currentTime - lastTime >= 15) {

        callbacks.forEach(function iterator(callback) {

          callback();
        });
        lastTime = currentTime;
      } else {

        window.console.log('Skipped!');
      }
    }
      , resizeTimeout
      , resize = function resize() {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(function onResizeTimeout() {
        window.requestAnimationFrame(runCallbacks);
      }, 500);
    }
      , addCallback = function addCallback(callback) {

      if (callback) {

        callbacks.push(callback);
      }
    };

    return {
      'add': function add(callback) {

        if (!callbacks.length) {

          window.addEventListener('resize', resize);
        }
        addCallback(callback);
      },
      'remove': function remove() {
        if (!callbacks.length) {
          window.clearTimeout(resizeTimeout);
          window.removeEventListener('resize', resize);
        }
      },
    };
  }())
    , getAttributesToAdd = function getAttributesToAdd(element) {
    var attributesToAdd = {};

    element.removeAttr(directiveName);
    if (element.attr('tooltip-template') !== undefined) {

      attributesToAdd['tooltip-template'] = element.attr('tooltip-template');
      element.removeAttr('tooltip-template');
    }

    if (element.attr('tooltip-template-url') !== undefined) {

      attributesToAdd['tooltip-template-url'] = element.attr('tooltip-template-url');
      element.removeAttr('tooltip-template-url');
    }

    if (element.attr('tooltip-template-url-cache') !== undefined) {

      attributesToAdd['tooltip-template-url-cache'] = element.attr('tooltip-template-url-cache');
      element.removeAttr('tooltip-template-url-cache');
    }

    if (element.attr('tooltip-controller') !== undefined) {

      attributesToAdd['tooltip-controller'] = element.attr('tooltip-controller');
      element.removeAttr('tooltip-controller');
    }

    if (element.attr('tooltip-side') !== undefined) {

      attributesToAdd['tooltip-side'] = element.attr('tooltip-side');
      element.removeAttr('tooltip-side');
    }

    if (element.attr('tooltip-show-trigger') !== undefined) {

      attributesToAdd['tooltip-show-trigger'] = element.attr('tooltip-show-trigger');
      element.removeAttr('tooltip-show-trigger');
    }

    if (element.attr('tooltip-hide-trigger') !== undefined) {

      attributesToAdd['tooltip-hide-trigger'] = element.attr('tooltip-hide-trigger');
      element.removeAttr('tooltip-hide-trigger');
    }

    if (element.attr('tooltip-smart') !== undefined) {

      attributesToAdd['tooltip-smart'] = element.attr('tooltip-smart');
      element.removeAttr('tooltip-smart');
    }

    if (element.attr('tooltip-class') !== undefined) {

      attributesToAdd['tooltip-class'] = element.attr('tooltip-class');
      element.removeAttr('tooltip-class');
    }

    if (element.attr('tooltip-show') !== undefined) {

      attributesToAdd['tooltip-show'] = element.attr('tooltip-show');
      element.removeAttr('tooltip-show');
    }

    if (element.attr('tooltip-close-button') !== undefined) {

      attributesToAdd['tooltip-close-button'] = element.attr('tooltip-close-button');
      element.removeAttr('tooltip-close-button');
    }

    if (element.attr('tooltip-size') !== undefined) {

      attributesToAdd['tooltip-size'] = element.attr('tooltip-size');
      element.removeAttr('tooltip-size');
    }

    if (element.attr('tooltip-speed') !== undefined) {

      attributesToAdd['tooltip-speed'] = element.attr('tooltip-speed');
      element.removeAttr('tooltip-speed');
    }

    return attributesToAdd;
  }
    , getStyle = function getStyle(anElement) {

    if (window.getComputedStyle) {

      return window.getComputedStyle(anElement, '');
    } else if (anElement.currentStyle) {

      return anElement.currentStyle;
    }
  }
    , getAppendedTip = function getAppendedTip(theTooltipElement) {
    var tipsInBody = window.document.querySelectorAll('._exradicated-tooltip')
      , aTipInBody
      , tipsInBodyIndex = 0
      , tipsInBodyLength = tipsInBody.length
      , angularizedElement;

    for (; tipsInBodyIndex < tipsInBodyLength; tipsInBodyIndex += 1) {

      aTipInBody = tipsInBody.item(tipsInBodyIndex);
      if (aTipInBody) {

        angularizedElement = angular.element(aTipInBody);
        if (angularizedElement.data('_tooltip-parent') &&
          angularizedElement.data('_tooltip-parent') === theTooltipElement) {

          return angularizedElement;
        }
      }
    }
  }
    , removeAppendedTip = function removeAppendedTip(theTooltipElement) {
    var tipElement = getAppendedTip(theTooltipElement);

    if (tipElement) {

      tipElement.remove();
    }
  }
    , isOutOfPage = function isOutOfPage(theTipElement) {

    if (theTipElement) {
      var squarePosition = theTipElement[0].getBoundingClientRect();

      if (squarePosition.top < 0 ||
        squarePosition.top > window.document.body.offsetHeight ||
        squarePosition.left < 0 ||
        squarePosition.left > window.document.body.offsetWidth ||
        squarePosition.bottom < 0 ||
        squarePosition.bottom > window.document.body.offsetHeight ||
        squarePosition.right < 0 ||
        squarePosition.right > window.document.body.offsetWidth) {

        theTipElement.css({
          'top': '',
          'left': '',
          'bottom': '',
          'right': '',
        });
        return true;
      }

      return false;
    }

    throw new Error('You must provide a position');
  }
    , getSideClasses = function getSideClasses(sides) {

    return sides.split(' ').map(function mapSideClasses(side) {

      return '_' + side;
    }).join(' ');
  }
    , directions = [
    '_top',
    '_top _left',
    '_left',
    '_bottom _left',
    '_bottom',
    '_bottom _right',
    '_right',
    '_top _right']
    , smartPosition = function smartPosition(tipElement, tooltipElement, startSide) {

    var directionsIndex = directions.indexOf(getSideClasses(startSide))
      , directionsLength = directions.length
      , directionsCount = 0;

    for (; directionsCount < directionsLength && isOutOfPage(tipElement); directionsCount += 1) {

      directionsIndex += 1;
      if (directionsIndex >= directions.length) {

        directionsIndex = 0;
      }
      tooltipElement.removeClass('_top _left _bottom _right');
      tooltipElement.addClass(directions[directionsIndex]);
    }
  }
    , tooltipConfigurationProvider = function tooltipConfigurationProvider() {

    var tooltipConfiguration = {
      'side': 'top',
      'showTrigger': 'mouseenter',
      'hideTrigger': 'mouseleave',
      'class': '',
      'smart': false,
      'closeButton': false,
      'size': '',
      'speed': 'steady',
      'tooltipTemplateUrlCache': false,
      'show': null,
    };

    return {
      'configure': function configure(configuration) {
        var configurationKeys = Object.keys(tooltipConfiguration)
          , configurationIndex = 0
          , aConfigurationKey;

        if (configuration) {

          for (; configurationIndex < configurationKeys.length; configurationIndex += 1) {

            aConfigurationKey = configurationKeys[configurationIndex];
            if (aConfigurationKey &&
              configuration[aConfigurationKey]) {

              tooltipConfiguration[aConfigurationKey] = configuration[aConfigurationKey];
            }
          }
        }
      },
      '$get': /*@ngInject*/ function instantiateProvider() {

        return tooltipConfiguration;
      },
    };
  }
    , tooltipDirective = /*@ngInject*/ [
    '$log',
    '$http',
    '$compile',
    '$timeout',
    '$controller',
    '$injector',
    'tooltipsConf',
    '$templateCache',
    '$q',
    function tooltipDirective($log, $http, $compile, $timeout, $controller, $injector, tooltipsConf,
                              $templateCache, $q) {

      var linkingFunction = function linkingFunction($scope, $element, $attrs, $controllerDirective,
                                                     $transcludeFunc) {

        if ($attrs.tooltipTemplate &&
          $attrs.tooltipTemplateUrl) {

          throw new Error('You can not define tooltip-template and tooltip-template-url together');
        }

        if (!($attrs.tooltipTemplateUrl || $attrs.tooltipTemplate) &&
          $attrs.tooltipController) {

          throw new Error(
            'You can not have a controller without a template or templateUrl defined');
        }

        var oldTooltipSide = getSideClasses(tooltipsConf.side)
          , oldTooltipShowTrigger = tooltipsConf.showTrigger
          , oldTooltipHideTrigger = tooltipsConf.hideTrigger
          , oldTooltipClass
          , oldSize = tooltipsConf.size
          , oldSpeed = '_' + tooltipsConf.speed;

        $attrs.tooltipSide = $attrs.tooltipSide || tooltipsConf.side;
        $attrs.tooltipShowTrigger = $attrs.tooltipShowTrigger || tooltipsConf.showTrigger;
        $attrs.tooltipHideTrigger = $attrs.tooltipHideTrigger || tooltipsConf.hideTrigger;
        $attrs.tooltipShow = $attrs.tooltipShow || tooltipsConf.show;
        $attrs.tooltipClass = $attrs.tooltipClass || tooltipsConf.class;
        $attrs.tooltipSmart = $attrs.tooltipSmart === 'true' || tooltipsConf.smart;
        $attrs.tooltipCloseButton = $attrs.tooltipCloseButton ||
          tooltipsConf.closeButton.toString();
        $attrs.tooltipSize = $attrs.tooltipSize || tooltipsConf.size;
        $attrs.tooltipSpeed = $attrs.tooltipSpeed || tooltipsConf.speed;
        $attrs.tooltipAppendToBody = $attrs.tooltipAppendToBody === 'true';

        $transcludeFunc($scope, function onTransclusionDone(element, scope) {
          var attributes = getAttributesToAdd(element)
            , tooltipElement = angular.element(window.document.createElement('tooltip'))
            , tipContElement = angular.element(window.document.createElement('tip-cont'))
            , tipElement = angular.element(window.document.createElement('tip'))
            , tipTipElement = angular.element(window.document.createElement('tip-tip'))
            , closeButtonElement = angular.element(window.document.createElement('span'))
            , tipArrowElement = angular.element(window.document.createElement('tip-arrow'))
            , whenActivateMultilineCalculation = function whenActivateMultilineCalculation() {

              return tipContElement.html();
            }
            , calculateIfMultiLine = function calculateIfMultiLine(newValue) {

              if (newValue !== undefined &&
                tipContElement[0].getClientRects().length > 1) {

                tooltipElement.addClass('_multiline');
              } else {

                tooltipElement.removeClass('_multiline');
              }
            }
            , onTooltipShow = function onTooltipShow(event) {

              if (event && !tooltipElement.hasClass('active')) {

                event.stopImmediatePropagation();
              }

              tipElement.addClass('_hidden');
              if ($attrs.tooltipSmart) {

                switch ($attrs.tooltipSide) {
                  case 'top':
                  case 'left':
                  case 'bottom':
                  case 'right':
                  case 'top left':
                  case 'top right':
                  case 'bottom left':
                  case 'bottom right': {
                    smartPosition(tipElement, tooltipElement, $attrs.tooltipSide);
                    break;
                  }
                  case 'bottom left aligned': {
                    tooltipElement.removeClass('_top _left _bottom _right');
                    tooltipElement.addClass('_bottom').addClass('_left').addClass('_aligned');
                    break;
                  }

                  default: {

                    throw new Error('Position not supported');
                  }
                }
              }

              if ($attrs.tooltipAppendToBody) {

                var tipTipElementStyle = getStyle(tipTipElement[0])
                  , tipArrowElementStyle = getStyle(tipArrowElement[0])
                  , tipElementStyle = getStyle(tipElement[0])
                  , tipElementBoundingClientRect = tipElement[0].getBoundingClientRect()
                  , exradicatedTipElement = angular.copy(tipElement)
                  , tipTipStyleIndex = 0
                  , tipTipStyleLength = tipTipElementStyle.length
                  , tipArrowStyleIndex = 0
                  , tipArrowStyleLength = tipArrowElementStyle.length
                  , tipStyleIndex = 0
                  , tipStyleLength = tipElementStyle.length
                  , aStyleKey
                  , tipTipCssToSet = {}
                  , tipCssToSet = {}
                  , tipArrowCssToSet = {}
                  , paddingTopValue
                  , paddingBottomValue
                  , paddingLeftValue
                  , paddingRightValue;

                tipElement.removeClass('_hidden');
                exradicatedTipElement.removeClass('_hidden');
                exradicatedTipElement.data('_tooltip-parent', tooltipElement);
                removeAppendedTip(tooltipElement);

                for (; tipTipStyleIndex < tipTipStyleLength; tipTipStyleIndex += 1) {

                  aStyleKey = tipTipElementStyle[tipTipStyleIndex];
                  if (aStyleKey &&
                    tipTipElementStyle.getPropertyValue(aStyleKey)) {

                    tipTipCssToSet[aStyleKey] = tipTipElementStyle.getPropertyValue(aStyleKey);
                  }
                }

                for (; tipArrowStyleIndex < tipArrowStyleLength; tipArrowStyleIndex += 1) {

                  aStyleKey = tipArrowElementStyle[tipArrowStyleIndex];
                  if (aStyleKey &&
                    tipArrowElementStyle.getPropertyValue(aStyleKey)) {

                    tipArrowCssToSet[aStyleKey] = tipArrowElementStyle.getPropertyValue(aStyleKey);
                  }
                }

                for (; tipStyleIndex < tipStyleLength; tipStyleIndex += 1) {

                  aStyleKey = tipElementStyle[tipStyleIndex];
                  if (aStyleKey &&
                    aStyleKey !== 'position' &&
                    aStyleKey !== 'display' &&
                    aStyleKey !== 'opacity' &&
                    aStyleKey !== 'z-index' &&
                    aStyleKey !== 'bottom' &&
                    aStyleKey !== 'height' &&
                    aStyleKey !== 'left' &&
                    aStyleKey !== 'right' &&
                    aStyleKey !== 'top' &&
                    aStyleKey !== 'width' &&
                    tipElementStyle.getPropertyValue(aStyleKey)) {

                    tipCssToSet[aStyleKey] = tipElementStyle.getPropertyValue(aStyleKey);
                  }
                }
                paddingTopValue = window.parseInt(tipElementStyle.getPropertyValue('padding-top'),
                  10);
                paddingBottomValue = window.parseInt(
                  tipElementStyle.getPropertyValue('padding-bottom'), 10);
                paddingLeftValue = window.parseInt(tipElementStyle.getPropertyValue('padding-left'),
                  10);
                paddingRightValue = window.parseInt(tipElementStyle.getPropertyValue('padding-right'),
                  10);

                tipCssToSet.top = tipElementBoundingClientRect.top + window.pageYOffset + 'px';
                tipCssToSet.left = tipElementBoundingClientRect.left + window.pageXOffset + 'px';
                tipCssToSet.height = tipElementBoundingClientRect.height -
                  (paddingTopValue + paddingBottomValue) + 'px';
                tipCssToSet.width = tipElementBoundingClientRect.width -
                  (paddingLeftValue + paddingRightValue) + 'px';

                exradicatedTipElement.css(tipCssToSet);

                exradicatedTipElement.children().css(tipTipCssToSet);
                exradicatedTipElement.children().next().css(tipArrowCssToSet);
                if (event &&
                  $attrs.tooltipHidden !== 'true') {

                  exradicatedTipElement.addClass('_exradicated-tooltip');
                  angular.element(window.document.body).append(exradicatedTipElement);
                }
              } else {

                tipElement.removeClass('_hidden');
                if (event &&
                  $attrs.tooltipHidden !== 'true') {

                  tooltipElement.addClass('active');
                }
              }
            }
            , onTooltipHide = function onTooltipHide(event) {

              if (event && tooltipElement.hasClass('active')) {

                event.stopImmediatePropagation();
              }

              if ($attrs.tooltipAppendToBody) {

                removeAppendedTip(tooltipElement);
              } else {

                tooltipElement.removeClass('active');
              }
            }
            , registerOnScrollFrom = function registerOnScrollFrom(theElement) {
              var parentElement = theElement.parent()
                , timer;

              if (theElement[0] &&
                (theElement[0].scrollHeight > theElement[0].clientHeight ||
                  theElement[0].scrollWidth > theElement[0].clientWidth)) {

                theElement.on('scroll', function onScroll() {
                  var that = this;

                  if (timer) {

                    $timeout.cancel(timer);
                  }

                  timer = $timeout(function doLater() {

                    var theTipElement = getAppendedTip(tooltipElement)
                      , tooltipBoundingRect = tooltipElement[0].getBoundingClientRect()
                      , thatBoundingRect = that.getBoundingClientRect();

                    if (tooltipBoundingRect.top < thatBoundingRect.top ||
                      tooltipBoundingRect.bottom > thatBoundingRect.bottom ||
                      tooltipBoundingRect.left < thatBoundingRect.left ||
                      tooltipBoundingRect.right > thatBoundingRect.right) {

                      removeAppendedTip(tooltipElement);
                    } else if (theTipElement) {

                      onTooltipShow(true);
                    }
                  });
                });
              }

              if (parentElement &&
                parentElement.length) {

                registerOnScrollFrom(parentElement);
              }
            }
            , showTemplate = function showTemplate(template) {

              tooltipElement.removeClass('_force-hidden'); //see lines below, this forces to hide tooltip when is empty
              tipTipElement.empty();
              tipTipElement.append(closeButtonElement);
              tipTipElement.append(template);
              $timeout(function doLater() {

                onTooltipShow();
              });
            }
            , hideTemplate = function hideTemplate() {

              //hide tooltip because is empty
              tipTipElement.empty();
              tooltipElement.addClass('_force-hidden'); //force to be hidden if empty
            }
            , getTemplate = function getTemplate(tooltipTemplateUrl) {

              var template = $templateCache.get(tooltipTemplateUrl);

              if (typeof template !== 'undefined') {
                // Wrap template in a Promise so that getTemplate always returns a Promise
                return $q.resolve(template);
              }

              // How should failing to load the template be handled?
              return $http.get(tooltipTemplateUrl).then(function onGetTemplateSuccess(response) {
                $templateCache.put(tooltipTemplateUrl, response.data);

                return response.data;
              });
            }
            , onTooltipTemplateChange = function onTooltipTemplateChange(newValue) {

              if (newValue) {

                showTemplate(newValue);
              } else {

                hideTemplate();
              }
            }
            , onTooltipTemplateUrlChange = function onTooltipTemplateUrlChange(newValue) {

              if (newValue && !$attrs.tooltipTemplateUrlCache) {

                getTemplate(newValue).then(function onGetTemplateSuccess(template) {

                  showTemplate($compile(template)(scope));
                }).catch(function onGetTemplateFailure(reason) {

                  $log.error(reason);
                });
              } else {

                hideTemplate();
              }
            }
            , onTooltipTemplateUrlCacheChange = function onTooltipTemplateUrlCacheChange(newValue) {

              if (newValue && $attrs.tooltipTemplateUrl) {

                getTemplate($attrs.tooltipTemplateUrl).then(function onGetTemplateSuccess(template) {

                  showTemplate($compile(template)(scope));
                }).catch(function onGetTemplateFailure(reason) {

                  $log.error(reason);
                });
              } else {

                hideTemplate();
              }
            }
            , onTooltipSideChange = function onTooltipSideChange(newValue) {

              if (newValue) {

                if (oldTooltipSide) {

                  tooltipElement.removeClass(oldTooltipSide);
                }
                tooltipElement.addClass(getSideClasses(newValue));
                oldTooltipSide = newValue;
              }
            }
            , onTooltipShowTrigger = function onTooltipShowTrigger(newValue) {

              if (newValue) {

                if (oldTooltipShowTrigger) {

                  tooltipElement.off(oldTooltipShowTrigger);
                }
                tooltipElement.on(newValue, onTooltipShow);
                oldTooltipShowTrigger = newValue;
              }
            }
            , onTooltipHideTrigger = function onTooltipHideTrigger(newValue) {

              if (newValue) {

                if (oldTooltipHideTrigger) {

                  tooltipElement.off(oldTooltipHideTrigger);
                }
                tooltipElement.on(newValue, onTooltipHide);
                oldTooltipHideTrigger = newValue;
              }
            }
            , onTooltipShowTooltip = function onTooltipShowTooltip(newValue) {

              if (newValue === 'true') {

                tooltipElement.addClass('active');
              } else {
                tooltipElement.removeClass('active');
              }
            }
            , onTooltipClassChange = function onTooltipClassChange(newValue) {

              if (newValue) {

                if (oldTooltipClass) {

                  tipElement.removeClass(oldTooltipClass);
                }
                tipElement.addClass(newValue);
                oldTooltipClass = newValue;
              }
            }
            , onTooltipSmartChange = function onTooltipSmartChange() {

              if (typeof $attrs.tooltipSmart !== 'boolean') {

                $attrs.tooltipSmart = $attrs.tooltipSmart === 'true';
              }
            }
            , onTooltipCloseButtonChange = function onTooltipCloseButtonChange(newValue) {
              var enableButton = newValue === 'true';

              if (enableButton) {

                closeButtonElement.on('click', onTooltipHide);
                closeButtonElement.css('display', 'block');
              } else {

                closeButtonElement.off('click');
                closeButtonElement.css('display', 'none');
              }
            }
            ,
            onTooltipTemplateControllerChange = function onTooltipTemplateControllerChange(newValue) {

              if (newValue) {

                var tipController = $controller(newValue, {
                  '$scope': scope,
                })
                  , newScope = scope.$new(false, scope)
                  , indexOfAs = newValue.indexOf('as')
                  , controllerName;

                if (indexOfAs >= 0) {

                  controllerName = newValue.substr(indexOfAs + 3);
                  newScope[controllerName] = tipController;
                } else {

                  angular.extend(newScope, tipController);
                }

                tipTipElement.replaceWith($compile(tipTipElement)(newScope));
                /*eslint-disable no-use-before-define*/
                unregisterOnTooltipControllerChange();
                /*eslint-enable no-use-before-define*/
              }
            }
            , onTooltipSizeChange = function onTooltipSizeChange(newValue) {

              if (newValue) {

                if (oldSize) {

                  tipTipElement.removeClass('_' + oldSize);
                }
                tipTipElement.addClass('_' + newValue);
                oldSize = newValue;
              }
            }
            , onTooltipSpeedChange = function onTooltipSpeedChange(newValue) {

              if (newValue) {

                if (oldSpeed) {

                  tooltipElement.removeClass('_' + oldSpeed);
                }
                tooltipElement.addClass('_' + newValue);
                oldSpeed = newValue;
              }
            }
            , unregisterOnTooltipTemplateChange = $attrs.$observe('tooltipTemplate',
            onTooltipTemplateChange)
            , unregisterOnTooltipTemplateUrlChange = $attrs.$observe('tooltipTemplateUrl',
            onTooltipTemplateUrlChange)
            , unregisterOnTooltipTemplateUrlCacheChange = $attrs.$observe('tooltipTemplateUrlCache',
            onTooltipTemplateUrlCacheChange)
            , unregisterOnTooltipSideChangeObserver = $attrs.$observe('tooltipSide',
            onTooltipSideChange)
            , unregisterOnTooltipShowTrigger = $attrs.$observe('tooltipShowTrigger',
            onTooltipShowTrigger)
            , unregisterOnTooltipHideTrigger = $attrs.$observe('tooltipHideTrigger',
            onTooltipHideTrigger)
            , unregisterOnTooltipShowTooltip = $attrs.$observe('tooltipShow', onTooltipShowTooltip)
            , unregisterOnTooltipClassChange = $attrs.$observe('tooltipClass', onTooltipClassChange)
            , unregisterOnTooltipSmartChange = $attrs.$observe('tooltipSmart', onTooltipSmartChange)
            , unregisterOnTooltipCloseButtonChange = $attrs.$observe('tooltipCloseButton',
            onTooltipCloseButtonChange)
            , unregisterOnTooltipControllerChange = $attrs.$observe('tooltipController',
            onTooltipTemplateControllerChange)
            , unregisterOnTooltipSizeChange = $attrs.$observe('tooltipSize', onTooltipSizeChange)
            , unregisterOnTooltipSpeedChange = $attrs.$observe('tooltipSpeed', onTooltipSpeedChange)
            , unregisterTipContentChangeWatcher = scope.$watch(whenActivateMultilineCalculation,
            calculateIfMultiLine);

          closeButtonElement.addClass('close-button');
          closeButtonElement.html('&times;');

          tipElement.addClass('_hidden');

          tipTipElement.append(closeButtonElement);
          tipTipElement.append($attrs.tooltipTemplate);

          tipElement.append(tipTipElement);
          tipElement.append(tipArrowElement);

          tipContElement.append(element);

          tooltipElement.attr(attributes);
          tooltipElement.addClass('tooltips');

          tooltipElement.append(tipContElement);
          tooltipElement.append(tipElement);
          $element.after(tooltipElement);

          if ($attrs.tooltipAppendToBody) {

            resizeObserver.add(function onResize() {

              registerOnScrollFrom(tooltipElement);
            });
            registerOnScrollFrom(tooltipElement);
          }

          resizeObserver.add(function registerResize() {

            calculateIfMultiLine();
            onTooltipShow();
          });

          $timeout(function doLater() {

            onTooltipShow();
            tipElement.removeClass('_hidden');
            tooltipElement.addClass('_ready');
          });

          scope.$on('$destroy', function unregisterListeners() {

            unregisterOnTooltipTemplateChange();
            unregisterOnTooltipTemplateUrlChange();
            unregisterOnTooltipTemplateUrlCacheChange();
            unregisterOnTooltipSideChangeObserver();
            unregisterOnTooltipShowTrigger();
            unregisterOnTooltipHideTrigger();
            unregisterOnTooltipShowTooltip();
            unregisterOnTooltipClassChange();
            unregisterOnTooltipSmartChange();
            unregisterOnTooltipCloseButtonChange();
            unregisterOnTooltipSizeChange();
            unregisterOnTooltipSpeedChange();
            unregisterTipContentChangeWatcher();
            resizeObserver.remove();
            element.off($attrs.tooltipShowTrigger + ' ' + $attrs.tooltipHideTrigger);
          });
        });
      };

      return {
        'restrict': 'A',
        'transclude': 'element',
        'priority': 1,
        'terminal': true,
        'link': linkingFunction,
      };
    }];

  angular.module('720kb.tooltips', [])
    .provider(directiveName + 'Conf', tooltipConfigurationProvider)
    .directive(directiveName, tooltipDirective);
}(angular, window));

'use strict';

var characterRegExp = new RegExp(/[^\w\sŽžÀ-ÿ!"#$%&'\(\)*+,\-./:;=?@\[\]^`\{\|\}~\\]/g);
/** @ngInject */
function validInputFilterDirective($browser) {
  return {
    link: function($scope, $element) {
      var listener = function() {
        if(
          $element.prop('nodeName') === 'TEXTAREA' ||
          ($element.prop('nodeName') === 'INPUT' && $element.attr('type') === 'text')
        ) {
          var value = $element.val();
          $element.val(value.replace(characterRegExp, ''));
        }
      };

      $element.bind('change', listener);
      $element.bind('keydown', function(event) {
        var key = event.keyCode;
        // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
        // This lets us support copy and paste too
        if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
          return;
        }
        $browser.defer(listener); // Have to do this or changes don't get picked up properly
      });

      $element.bind('paste cut', function() {
        $browser.defer(listener);
      });
    },
  };
}

angular.module('littlepayPortalMerchantApp.theme')
  .directive('input', validInputFilterDirective)
  .directive('textarea', validInputFilterDirective);
validInputFilterDirective.$inject = ['$browser'];

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .filter('dateToString', dateToString)
  .filter('toISOCurrency', toISOCurrency)
  .filter('toISOCurrencySymbol', toISOCurrencySymbol)
  .filter('toYesNo', toYesNo)
  .filter('toEnabledNot', toEnabledNot)
  .filter('toRegisteredOrNot', toRegisteredOrNot)
  .filter('htmlToPlaintext', htmlToPlaintext)
  .filter('titleCase', titleCase)
  .filter('lowerCaseWithUpperCaseFirstLetter', lowerCaseWithUpperCaseFirstLetter)
  .filter('replaceUnderscore', replaceUnderscore)
  .filter('replaceUnderscoreWithDash', replaceUnderscoreWithDash)
  .filter('customerStatusClass', customerStatusClass)
  .filter('removeSpaces', removeSpaces)
  .filter('removeSpacesAndLowerCase', removeSpacesAndLowerCase)
  .filter('capitalize', capitalize)
  .filter('secondsToHms', secondsToHms)
  .filter('hoursToDayString', hoursToDayString)
  .filter('refundApprovalStatus', refundApprovalStatus)
  .filter('refundStatus', refundStatus)
  .filter('expiry', expiry)
  .filter('dateWithTimezone', dateWithTimezone)
  .filter('wholeNumberCurrencyToDecimal', wholeNumberCurrencyToDecimal)
  .filter('prettify', prettify)
  .filter('filtersCardNumber', filtersCardNumber)
  .filter('expDate', expDate)
  .filter('calculateVAT', calculateVAT)
  .filter('calculateExclVAT', calculateExclVAT)
  .filter('convertToUtc', convertToUtc)
  .filter('calculateTotalAmount', calculateTotalAmount);

/** @ngInject */
function dateToString() {
  var pad = function(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  };

  return function(date) {
    if (date.constructor.name === 'Moment') {
      return date.format('DD/MM/YYYY');
    } else {
      date = new Date(date);
      return pad(date.getDate(), 2) + '/' + pad(date.getMonth() + 1, 2) + '/' + date.getFullYear();
    }
  };
}

var currencyMap = {
  36: { code: 'AUD', symbol: '$' },
  188: { code: 'CRC', symbol: '₡' },
  554: { code: 'NZD', symbol: '$' },
  752: { code: 'SEK', symbol: 'kr' },
  826: { code: 'GBP', symbol: '£' },
  840: { code: 'USD', symbol: '$' },
  978: { code: 'EUR', symbol: '€' },
  604: { code: 'PEN', symbol: 'S/' },
  484: { code: 'MXN', symbol: '$' },
};

/** @ngInject */
function toISOCurrency() {
  return function(currency) {
    var currencyData = currencyMap[Number(currency)];
    return currencyData && currencyData.code;
  };
}

function toISOCurrencySymbol() {
  return function(currency) {
    var currencyData = currencyMap[Number(currency)];
    return currencyData && currencyData.symbol;
  };
}


/** @ngInject */
function toYesNo($translate) {
  return function(trueOrFalse) {
    return $translate.instant('FILTERS.'+ (trueOrFalse ? 'YES' : 'NO'));
  };
}

/** @ngInject */
function toEnabledNot() {
  return function(trueOrFalse) {
    return trueOrFalse ? 'Enabled' : 'Disabled';
  };
}

/** @ngInject */
function toRegisteredOrNot() {
  return function(trueOrFalse) {
    return trueOrFalse ? 'REGISTERED' : 'UNREGISTERED';
  };
}

/** @ngInject */
function htmlToPlaintext() {
  return function(text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  };
}

/** @ngInject */
function titleCase() {
  return function(input) {
    input = input || '';
    input = input.charAt(0).toUpperCase() + input.slice(1);
    return input.replace(/([A-Z])/g, function($1) {
      return ' ' + $1.charAt(0).toUpperCase() + $1.substr(1).toLowerCase();
    });
  };
}

/** @ngInject */
function lowerCaseWithUpperCaseFirstLetter() {
  return function(input) {
    if (!input || input.length === 0) return input;

    var capitalisedFirstLetter = input.charAt(0).toUpperCase();
    var lowerCaseRestOfString = input.slice(1).toLowerCase();
    return capitalisedFirstLetter + lowerCaseRestOfString;
  }
}

/** @ngInject */
function replaceUnderscore() {
  return function(input) {
    input = input || '';
    return input.replace(/_/g, ' ');
  };
}

/** @ngInject */
function replaceUnderscoreWithDash() {
  return function(input) {
    input = input || '';
    return input.replace(/_/g, '-').toUpperCase();
  };
}

/** @ngInject */
function customerStatusClass() {
  return function(customerStatusClass) {
    var className = '';
    if (customerStatusClass === 'ACTIVE') {
      className = 'text-success';
    }
    if (customerStatusClass === 'REMOVED') {
      className = 'text-danger';
    }
    if (customerStatusClass === 'CREATED') {
      className = 'text-primary';
    }
    return className;
  };
}

/** @ngInject */
function removeSpaces() {
  return function(string) {
    if (!angular.isString(string)) {
      return string;
    }
    return (string.replace(/[\s]/g, '-'));
  };
}

/** @ngInject */
function removeSpacesAndLowerCase() {
  return function(string) {
    if (!angular.isString(string)) {
      return string;
    }
    return (string.replace(/[\s]/g, '-')).toLowerCase();
  };
}

/** @ngInject */
function capitalize() {
  return function(input, allWords) {
    if (!!allWords) {
      return input.replace(/\b\w/g, function(l) {
        return l.toUpperCase();
      });
    }
    return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
}

/** @ngInject */
function secondsToHms() {
  return function(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h === 1 ? ' hour ' : ' hours ') : '';
    var mDisplay = m > 0 ? m + (m === 1 ? ' minute ' : ' minutes ') : '';
    var sDisplay = s > 0 ? s + (s === 1 ? ' second' : ' seconds') : '';
    return hDisplay + mDisplay + sDisplay;
  };
}

/** @ngInject */
function hoursToDayString() {
  return function(hours) {
    var days = Math.floor(hours / 24);
    var remainHours = hours % 24;
    var result = '';

    // day(s)
    if (days) {
      var dayString = 'day';
      if (days > 1) {
        dayString += 's';
      }
      result += days + ' ' + dayString + ' ';
    }

    // hour(s)
    if (remainHours) {
      var hourString = 'hour';
      if (remainHours > 1) {
        hourString += 's';
      }
      result += remainHours + ' ' + hourString;
    }
    return result.trim();
  };
}

/** @ngInject */
function expiry() {
  return function(input) {
    input = input || '';
    return input ? input.match(/.{1,2}/g).reverse().join('/') : null;
  };
}

/** @ngInject */
function refundApprovalStatus() {
  return function(refund) {
    var approval = refund.approval;
    if (approval == 'AWAITING') {
      return 'AWAITING APPROVAL';
    }
    return approval;
  };
}

/** @ngInject */
function refundStatus() {
  return function(refund) {
    var status = refund.status;
    var approval = refund.approval;
    if (status === 'SENT_FOR_SETTLEMENT' && approval === 'AWAITING') {
      return '';
    }
    return status;
  };
}

/** @ngInject */
function dateWithTimezone(dateFilter) {
  return function(date, format, timezone) {
    var formatedDate;
    if (!date){
      formatedDate = '-';
    }else if (date === 'Indefinite') {
      formatedDate = date;
    }else {
      if(format[1]) {
        formatedDate = dateFilter(moment.utc(date).format('YYYY-MM-DDTHH:mm:ss[Z]'), format[0], moment().tz(format[1]).format("ZZ"));
      }else {
        formatedDate = dateFilter(moment.utc(date).format('YYYY-MM-DDTHH:mm:ss[Z]'), format[0]);
      }
    }

    return formatedDate;
  };
}

/** @ngInject */
function wholeNumberCurrencyToDecimal() {
  return function (wholeNumberAmount) {
    return (wholeNumberAmount / 100).toFixed(2);
  };
}

/** @ngInject */
function prettify() {
  function syntaxHighlight(json) {
    json = json || {};
    json = json.replace(/&/g, '&amp;');
    json = json.replace(/</g, '&lt;');
    json = json.replace(/>/g, '&gt;');
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      function(match) {
        var cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      });
  }
  return syntaxHighlight;
}

/** @ngInject */
function filtersCardNumber() {
  return function(form) {
    form = form || '';
    if(!form.card_first && !form.card_last) {
      return;
    }
    return (form.card_first ? form.card_first : '******') + '-'+ (form.card_last ? form.card_last : '******');
  };
}

/** @ngInject */
function expDate(parseDate) {
  return function(number, currentMonth, currentYear) {
    if (!number) {
      return '';
    }
    number = String(number);
    var src = 'filt';
    var formattedNumber = number;
    var filterDate = parseDate.parseDate(formattedNumber, src);
    var monthsArray = parseDate.getMonths();

    if (filterDate.month.length === 2) {
      formattedNumber = filterDate.month;
      if (monthsArray.indexOf(filterDate.month) !== -1) {

      } else {
        console.log('Please select a month, 01-12');
        return '';
      }
    }

    if (filterDate.year) {
      formattedNumber += ('/' + filterDate.year);
      if (number.length === 4) {
        if (filterDate.yearInt < currentYear) {
          return '';
        }
        if ((filterDate.yearInt === currentYear) && (filterDate.month < currentMonth)) {
          return '';
        }
      }
    }
    return formattedNumber;
  };
}

/** @ngInject */

  function calculateVAT() {
    return function(input, vat) {
      input = input || '';
      return (input - noVat(input, vat)).toFixed(2);
    };
  }

  function calculateExclVAT() {
    return function(input, vat) {
      input = input || '';
      return (noVat(input, vat)).toFixed(2);
    };
  }

  var noVat = function(input, vat) {
    return input / (parseFloat(vat) + 1);
  };

  /** @ngInject */
function convertToUtc() {
  return function(time) {
    if (time && time !== 'undefined') {
      return moment(time, 'DD/MM/YYYY HH:mm').utc()
        .format('YYYY-MM-DDTHH:mm:ss') + 'Z';

    } else {
      return null;
    }
  };
}

/** @ngInject */
function calculateTotalAmount() {
  return function(transactions) {
    if (transactions) {
      return transactions.reduce(function(prev, cur) {
        return prev + cur.amount;
      }, 0);
    } else {
      return 0;
    }
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .filter('join', join);

/** @ngInject */
function join($translate) {
  /**
   * Join an array of strings.
   * @param values Array of strings to join.
   * @param opts Limit the count and/or use the word "and". Default is no limit without "and".
   */
  return function(values, opts) {
    var limit = opts && opts.limit;
    var useAnd = opts && opts.useAnd;

    if (!values || values.length === 0 || (limit != null && limit <= 0)) {
      return '';
    }
    if (values.length === 1 || limit === 1) {
      return values[0];
    }

    var truncated = values.slice(0, limit);
    var last = values.length === truncated.length ? values[values.length - 1] : $translate.instant('FILTERS.MORE');
    var allButLast = truncated.slice(0, -1);
    var lastJoiner = ', ';
    if (useAnd) {
      lastJoiner = ' ' + $translate.instant('FILTERS.AND') + ' ';
    }

    return allButLast.join(', ') + lastJoiner + last;
  };
}

"use strict";

angular.module("littlepayPortalMerchantApp.theme").filter("toLocaleString", [
  function () {
    function toLocaleString(date) {
      var locale = localStorage.getItem("locale");
      return new Date(date).toLocaleString(locale, {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });
    }
    toLocaleString.$stateful = true;

    return toLocaleString;
  },
]);

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Adjustments', Adjustments);

Adjustments.$inject = ['$resource', '$stateParams', 'Auth', 'Config'];

/** @ngInject */
function Adjustments($resource, $stateParams, Auth, Config) {

  var url = Config.getAPIServerURL();
  var Adjustments = $resource(
    url + 'participants/:participantId/customers/:customerId/adjustment-decision/:fareId', {
      participantId: '@participantId',
    }, {
      query: {
        isArray: false,
      },
    });

  Adjustments.model = {
    decision: {},
  };

  Adjustments.getCharges = function(participant, pageNo) {
    return Adjustments.getListByPageNo(pageNo, participant);
  };

  Adjustments.getFareDecision = function(key, fareId) {
    var customerId = $stateParams.customerId;

    return Adjustments.query({
      'customerId': customerId,
      'participantId': Auth.getParticipantName(),
      'fareId': fareId,
    }, function(resp) {
      if (resp.product_rule_check_map !== undefined) {
        Adjustments.model.decision[key] = resp.product_rule_check_map;
      }
    }, function() {
    }).$promise;
  };

  return Adjustments;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Aggregation', Aggregation);
Aggregation.$inject = ['$resource', '$stateParams', 'Auth', 'Config', '$q', '$location', '$filter'];

/** @ngInject */
function Aggregation($resource, $stateParams, Auth, Config, $q, $location, $filter) {
  var url = Config.getAPIServerURL();
  var Aggregation = $resource(
    url + ':participantName/customers/:customerId/aggregations/:aggregationId', {
      customerId: '@customerId',
      participantName: '@participantName',
      aggregationId: '@aggregationId',
    }, {
      query: {
        isArray: false,
      },
    });
  var deferred = $q.defer();

  Aggregation.model = {
    pagination: {},
    aggregations: [],
    receiptTransactions: [],
    selected_aggregation: {},
  };

  Aggregation.customerAggregations = function(attributes) {
    if ($location.search().aggregationId) {
      return Aggregation.getAggregation(attributes.participant);
    } else {
      return Aggregation.getListByPageNo(attributes.pageNo);
    }
  };

  Aggregation.getAllAggregations = function() {
    return Aggregation.query({
      'customerId': $stateParams.customerId,
      'participantName': Auth.getParticipantName(),
      'start': 0,
      'limit': 10000,
    }, function(resp) {
      Aggregation.model.receiptTransactions = resp.list;
    }).$promise;
  }

  Aggregation.getListByPageNo = function(pageNo) {

    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(Aggregation.model.entryNumber) || Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    Aggregation.model.currentPage = pageNo;

    return Aggregation.query({
      'customerId': $stateParams.customerId,
      'participantName': Auth.getParticipantName(),
      'start': start,
      'limit': defaultPageLimit,
      'truncated-pan': $location.search().card,
      'from-time': $filter('convertToUtc')(decodeURIComponent($location.search().fromTime)),
      'to-time': $filter('convertToUtc')(decodeURIComponent($location.search().toTime)),
      'payment-guarantee-status': $location.search().status,
      'settlement-result': $location.search().settlement,
      'charge-type': $location.search().trip,
    }, function(resp) {
      Aggregation.model.aggregations = resp.list;
      Aggregation.model.pagination = resp.pagination;
      Aggregation.model.selected_aggregation = resp.list[0];
    }).$promise;
  };

  Aggregation.getAggregation = function() {
    return Aggregation.query({
      'customerId': $stateParams.customerId,
      'participantName': Auth.getParticipantName(),
      'aggregationId': $location.search().aggregationId,
    }, function(data) {
      Aggregation.model.aggregations = [data];
      Aggregation.model.currentPage = 1;
      Aggregation.model.pagination.limit = 10;
      Aggregation.model.pagination.total = 1;
    }).$promise;
  };

  Aggregation.isAdjustedSingle = function(aggregation) {
    var adjusted = false;
    angular.forEach(aggregation.micropayments, function(micropayment) {
      angular.forEach(micropayment.adjustments, function(adjustment) {
        if (adjustment.applied) {
          adjusted = true;
        }
      });
    });
    return adjusted;
  };

  Aggregation.isIncomplete = function(aggregation) {
    var incomplete = false;
    angular.forEach(aggregation.micropayments, function(micropayment) {
      if (micropayment.charge_type === 'incomplete_variable_fare') {
        incomplete = true;
      }
    });
    return incomplete;
  };

  Aggregation.isPending = function(aggregation) {
    var pending = false;
    angular.forEach(aggregation.micropayments, function(micropayment) {
      if (micropayment.charge_type === 'pending_variable_fare') {
        pending = true;
      }
    });
    return pending;
  };

  return Aggregation;
}

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme.services')
    .factory('AmCharts', AmCharts);

  AmCharts.$inject = ['$window'];

  /** @ngInject */
  function AmCharts($window) {
    /*jshint validthis: true*/
    if (!$window.AmCharts) {
      //display error
    }

    return $window.AmCharts;

  }
})();

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Auth', Auth);
Auth.$inject = [
  '$location',
  '$rootScope',
  '$http',
  '$window',
  'lock',
  'authManager',
  'RightBar',
  'jwtHelper',
  'WebAnalytics',
  '$translate',
  'tmhDynamicLocale'];

/** @ngInject */
function Auth($location, $rootScope, $http, $window, lock, authManager, RightBar,
              jwtHelper, WebAnalytics, $translate, tmhDynamicLocale) {
  var currentUser = {
    profile: JSON.parse(localStorage.getItem('profile'))
  };

  var login = function() {
    lock.show({
      autoclose: false,
      language: localStorage.getItem('language'),
      languageDictionary: {
        title: $translate.instant('MERCHANT-PORTAL')
      }
    });
  };

  var removeLocalStorage = function() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('isAdmin');
  };

  // Logging out just requires removing the user's
  // id_token and profile
  var logout = function() {
    removeLocalStorage();
    authManager.unauthenticate();
    var userId = currentUser.profile.user_id;
    currentUser.profile = {};
    WebAnalytics.trackLogoutSuccessEvent(userId);
    lock.logout({
        returnTo: window.location.protocol + '//' + window.location.host + '/login'
      });
  };

  var changePassword = function() {
    lock.show({
      initialScreen: 'forgotPassword',
      allowLogin: false,
      allowSignUp: false,
      allowForgotPassword: true,
      language: localStorage.getItem('language'),
    });
  };

  var changeLanguage = function(selectedLanguage) {
    var language = selectedLanguage.split('-')[0];
    localStorage.setItem('language', language);
    localStorage.setItem('locale', selectedLanguage);

    tmhDynamicLocale.set(selectedLanguage);
    getLocalLanguage = language;
    $translate.use(language).then(function(){
      $translate.refresh();
    });
  };

  var localVar = localStorage.getItem('locale');
  var getLocalLanguage = 'en';

  var availableLanguages = window.__env.available_languages;
  var isMultipleLanguage = Object.keys(availableLanguages).length > 1;

  if(isMultipleLanguage) {
    getLocalLanguage = localStorage.getItem('language') || 'en';
  }

  var getSelectedLocale = function() {
    var localVar = localStorage.getItem('locale');

    var getLocalLanguage = isMultipleLanguage ? (localStorage.getItem('language') || window.__env.defaultLocale) : window.__env.defaultLocale;

    if(!localVar || !availableLanguages[localVar]) {
      localStorage.setItem('locale', 'en-gb');
      localStorage.setItem('language', 'en');
    }
    return getLocalLanguage;
  };

  var getSelectedLanguage = function() {
    var language = 'en-gb';
    if(isMultipleLanguage) {
      var locale = localStorage.getItem('locale');
      if (availableLanguages[locale]){
         language = locale;
      }
    }
    return language;
  };

  var getParticipantName = function() {
    if (currentUser.profile && currentUser.profile.app_metadata && currentUser.profile.account) {
      return currentUser.profile.account.name;
    }
  };

  var getParticipantId = function() {
    if (currentUser.profile && currentUser.profile.app_metadata && currentUser.profile.account) {
      return currentUser.profile.account.participant_id;
    }
  };

  var isLoggedIn = function() {
    var idToken = localStorage.getItem('id_token');
    return $rootScope.isAuthenticated && idToken && !jwtHelper.isTokenExpired(idToken);
  };

  var isAdmin = function() {
    var isAdmin = false;
    if (localStorage.getItem('isAdmin') === 'true') {
      isAdmin = true;
    }
    return isAdmin;
  };

  var isOperationsAdmin = function() {
    return currentUser &&
      currentUser.profile &&
      currentUser.profile.app_metadata &&
      currentUser.profile.app_metadata['operations-role'] &&
      currentUser.profile.app_metadata['operations-role'] === 'admin';
  };

  var isParent = function() {
    return currentUser.profile.account && currentUser.profile.account.parent;
  };

  var hasPermission = function(permission) {
    if (isAdmin() && permission !== 'AccessDashboard' && permission !== 'AccessAnalytics') {
      return true;
    } else {

      return currentUser.profile && currentUser.profile.account &&
        currentUser.profile.account.permissions &&
        currentUser.profile.account.permissions.indexOf(permission) > -1;
    }
  };

  var checkUserHasPermission = function(permissionName){
    if(isAdmin()){
      return true;
    }else{
      if(currentUser.profile && currentUser.profile.account && currentUser.profile.account.permissions &&
        currentUser.profile.account.permissions.includes(permissionName)){
          return true;
      }
    }
    return false;
  };

  var redirectUserToCorrectPath = function(toState) {
    if (isLoggedIn() && currentUser.profile) {
      if (currentUser.profile.last_password_reset) {
        if (currentUser.profile.account && !currentUser.profile.account.parent) {
          if (/\/admin\//.test($location.path())) {
            var permission = toState.permission;
            if (!isAdmin() && permission && angular.isString(permission) &&
              !hasPermission(permission)) {
              $location.path('/admin/unauthorized');
            }
          } else {
            //redirect to analytics if we are already in analytics
            if (/\/parent\/analysis\//.test($location.path())) {
              $window.location.href = window.location.href.replace('parent', 'admin');
            } else {
              $window.location.href = '/admin/transactions';
            }
          }
        } else if (!/\/parent\//.test($location.path())) {
          //redirect to analytics if already in analytics
          if (/\/admin\/analysis\//.test($location.path())) {
            $window.location.href = window.location.href.replace('admin', 'parent');
          } else {
            $window.location.href = '/parent/settings';
          }
        }
      } else {
        $location.path('/account/changePassword');
      }
    } else {
      if ($location.path() !== '/login') {
        location.href = '/login';
      }
    }
  };

  var setCurrentAccount = function(profile) {
    if (!profile.account) {
      if (RightBar.model.participants.length > 0) {
        //this needs to be done, as the "name" property here is actually the id
        var newAccount = angular.copy(RightBar.model.participants[0]);
        newAccount.displayName = angular.copy(newAccount.name);
        newAccount.name = newAccount.id;
        profile.account = newAccount;
      } else {
        //should never happen - will cause problems
      }
    }

    RightBar.resetFilteredParticipants();

    localStorage.setItem('profile', JSON.stringify(profile));
    localStorage.setItem('isAdmin', profile.account && profile.account.role === 'admin');

    currentUser.profile = profile;
  };

  var registerAuthenticationListener = function() {
    lock.on('authenticated', function(authResult) {
      localStorage.setItem('id_token', authResult.idToken);

      authManager.authenticate();
      lock.getUserInfo(authResult.accessToken, function(err, profile) {
        if (!err) {
          WebAnalytics.trackLoginSuccessEvent(profile.user_id);
        }
        RightBar.loadAvailableParticipants(profile.user_id).then(function() {
          setCurrentAccount(profile);
          redirectUserToCorrectPath();
        });
      });
    });
  };

  return {
    changePassword: changePassword,
    changeLanguage: changeLanguage,
    getSelectedLanguage: getSelectedLanguage,
    getSelectedLocale: getSelectedLocale,
    availableLanguages: availableLanguages,
    isMultipleLanguage: isMultipleLanguage,
    currentUser: currentUser,
    getParticipantName: getParticipantName,
    getParticipantId: getParticipantId,
    isLoggedIn: isLoggedIn,
    isAdmin: isAdmin,
    isOperationsAdmin: isOperationsAdmin,
    isParent: isParent,
    login: login,
    logout: logout,
    removeLocalStorage: removeLocalStorage,
    hasPermission: hasPermission,
    checkUserHasPermission : checkUserHasPermission,
    setCurrentAccount: setCurrentAccount,
    registerAuthenticationListener: registerAuthenticationListener,
    redirectUserToCorrectPath: redirectUserToCorrectPath
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Capping', Capping);
Capping.$inject = ['$resource', 'Auth', 'Config', '$stateParams'];

/** @ngInject */
function Capping($resource, Auth, Config, $stateParams) {

  var url = Config.getAPIServerURL();
  var Capping = $resource(url + ':participantName/products/capping/:cappingId', {
    participantName: '@participantName',
    cappingId: '@cappingId',
  }, {
    getAllCapping: {
      method: 'get',
      isArray: true,
    },
    getCappingById: {
      method: 'get',
    },
    updateCapping: {
      method: 'put',
    },
    deleteCapping: {
      method: 'delete',
    },
    createCapping: {
      method: 'post',
    },
    getByOriginalIds: {
      method: 'get',
      url: url + ':participantName/products/capping-by-original-ids',
    },
  });

  Capping.model = {
    allCapping: [],
    selectedCapping: {},
    newCapping: {},
  };

  Capping.create = function(data) {
    return Capping.createCapping({
      'participantName': Auth.getParticipantName(),
    }, data).$promise;
  };

  Capping.removeCapping = function(id) {
    return Capping.deleteCapping({
      'participantName': Auth.getParticipantName(),
      'cappingId': id,
    }).$promise;
  };

  Capping.fetchAllCappings = function(filters) {
    var data = {
      'participantName': Auth.getParticipantName(),
    };
    if(filters) {
      angular.extend(data, filters);
    }
    return Capping.getAllCapping(data).$promise;
  };

  Capping.fetchCappingById = function(zoneNames, timePeriodType) {
    var data = {
      'cappingId': $stateParams.cappingId,
      'participantName': Auth.getParticipantName(),
    };

    if (zoneNames && timePeriodType) {
      var x = zoneNames.map(function(a) {
        return (a);
      });
      angular.extend(data, {
        'zones': x.join('+'),
        'time-period': timePeriodType,
      });
    }

    return Capping.getCappingById(data).$promise;
  };

  Capping.getLatestVersionByOriginalIds = function(originalIds) {
    var data = {
      id: originalIds,
      participantName: Auth.getParticipantName(),
    };
    return Capping.getByOriginalIds(data).$promise;
  }

  return Capping;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('CappingHelper', CappingHelper);
CappingHelper.$inject = ['Capping'];

/** @ngInject */
function CappingHelper(Capping) {

  CappingHelper.model = {
    temporaryCapping: {},
    incentiveRules: {},
    allAvailableProducts: [],
    incentiveAppliedProductIds: [],
    selectedZoneDay:{
      'peak_incentive_triangle_schedule':1,
      'off_peak_incentive_triangle_schedule': 1,
    },
    peakOffPeak: {
      'peak_zones': 'peak_incentive_triangle_schedule',
      'offpeak_zones': 'off_peak_incentive_triangle_schedule',
    },
    disable: false,
  };

  CappingHelper.shouldBeDisabled = function (temporaryCapping) {
    var shouldBeDisabled = CappingHelper.model.disable;
    if(temporaryCapping.incentive_rules && CappingHelper.isIncentiveTypeDailyCap(temporaryCapping)) {
      shouldBeDisabled = shouldBeDisabled || CappingHelper.model.dropdownIsInvalid;
    }
    return shouldBeDisabled;
  }

  CappingHelper.toggleIncentiveEnable = function (temporaryCapping) {
    if(temporaryCapping.incentive_enabled) {
      temporaryCapping.incentive_rules = CappingHelper.model.incentiveRules;
    }else if(temporaryCapping.incentive_rules) {
      delete temporaryCapping.incentive_rules;
    }
  };

  CappingHelper.isWeeklyCap = function(temporaryCapping) {
    return temporaryCapping.capping_type === 'WEEKLY_CAP';
  };

  CappingHelper.isIncentiveTypeDailyCap = function(temporaryCapping) {
    return temporaryCapping.incentive_rules.incentive_type === 'DAILY_CAP';
  };

  CappingHelper.isIncentiveCumulativeCap = function(temporaryCapping) {
    return temporaryCapping.incentive_rules && temporaryCapping.incentive_rules.incentive_type === 'CUMULATIVE_CAP';
  };

  CappingHelper.isWeeklyOrMultiDayCap = function(temporaryCapping) {
    return temporaryCapping && (CappingHelper.isWeeklyCap(temporaryCapping) || temporaryCapping.capping_type === 'MULTI_DAY_CAP');
  };

  CappingHelper.isIncentiveConfigurationDailyTable = function (temporaryCapping) {
    return temporaryCapping.incentive_rules.configuration_type === 'DAILY_TABLE';
  };

  CappingHelper.isIncentiveTypeCapping = function(temporaryCapping) {
    return CappingHelper.isIncentiveTypeDailyCap(temporaryCapping) && temporaryCapping.incentive_rules.qualifier === 'CAP_REACHED';
  };

  CappingHelper.displayDailyIncentiveTable = function(temporaryCapping) {
    return CappingHelper.isIncentiveTypeDailyCap(temporaryCapping) || (!CappingHelper.isIncentiveTypeDailyCap(temporaryCapping) && CappingHelper.isIncentiveConfigurationDailyTable(temporaryCapping));
  };

  CappingHelper.getDiscountDays = function(temporaryCapping) {
    if(temporaryCapping) {
      var numberOfDays = CappingHelper.isWeeklyCap(temporaryCapping) ? 7 : temporaryCapping.rules.num_days_in_cap_window;
      return _.range(1, numberOfDays + 1);
    }
  };

  CappingHelper.setIncentiveRulesWithCumulativeCap = function(temporaryCapping) {
    CappingHelper.model.incentiveRules = {
      'incentive_type' : 'CUMULATIVE_CAP',
      'configuration_type': 'DAILY_TABLE',
      'qualifier': 'SINGLE_TRIP',
      'incentive_schedule':{}
    };

    CappingHelper.getDiscountDays(temporaryCapping).forEach(function (dayNumber) {
      var schedule = {
        'day': dayNumber,
        'cap_limit': 0,
        'description': null,
        'discount': 0
      };
      CappingHelper.model.incentiveRules.incentive_schedule[dayNumber] = schedule;
    });
  };

  CappingHelper.setIncentiveRulesWithDailyCapDiscount = function(temporaryCapping) {
    CappingHelper.model.incentiveRules = {
      'incentive_type' : 'DAILY_CAP',
      'type': 'FLAT',
      'configuration_type': 'DAILY_TABLE',
      'qualifier': 'SINGLE_TRIP',
      'incentive_schedule':{}
    };
    CappingHelper.getDiscountDays(temporaryCapping).forEach(function (dayNumber) {
      var schedule = {
        'day': dayNumber,
        'discount': 0,
        'description': null
      };
      CappingHelper.model.incentiveRules.incentive_schedule[dayNumber] = schedule;
    });

    if(temporaryCapping.incentive_rules && temporaryCapping.incentive_rules.applied_original_product_ids) {
      fetchSelectedDailyCapProducts(temporaryCapping.incentive_rules.applied_original_product_ids);
    }else {
      CappingHelper.incentiveAppliedProductIds = [];
    }
    if(_.isEmpty(CappingHelper.model.allAvailableProducts)) {
      fetchAllDailyCapProductsToSelect();
    }
  };

  CappingHelper.toggleIncentiveZoneTable = function(day, zoneKey) {
    CappingHelper.model.selectedZoneDay[zoneKey] = day;
  };

  CappingHelper.toggleStatus = function (y) {
    y.status = y.status === 'ENABLED' ? 'DISABLED' : 'ENABLED';
  };

  CappingHelper.isEmpty = function (item) {
    return angular.equals({}, item);
  };

  CappingHelper.incentiveConfigurationChanged = function (temporaryCapping) {
    if(CappingHelper.isIncentiveConfigurationDailyTable(temporaryCapping)) {
      angular.forEach(CappingHelper.model.peakOffPeak, function (zoneKey){
        if(CappingHelper.model.incentiveRules[zoneKey]) {
          delete CappingHelper.model.incentiveRules[zoneKey];
        }
      });
    } else {
      angular.forEach(CappingHelper.model.peakOffPeak, function (zoneKey, zoneName){
        CappingHelper.model.selectedZoneDay[zoneKey] = 1;
        if(temporaryCapping.rules[zoneName]) {
          temporaryCapping.incentive_rules[zoneKey] = {};
          CappingHelper.getDiscountDays(temporaryCapping).forEach(function (dayNumber) {
            temporaryCapping.incentive_rules[zoneKey][dayNumber] = angular.copy(temporaryCapping.rules[zoneName]);
          });
        }
      });
    }
    CappingHelper.model.disable = false;
  };

  CappingHelper.validateIncentiveField = function(cappingField) {
    return !_.isNull(cappingField) && !isNaN(cappingField);
  };

  CappingHelper.getAppliedOriginalProductIds = function () {
    if(CappingHelper.model.allAvailableProducts && CappingHelper.incentiveAppliedProductIds) {
      CappingHelper.appliedIncentiveProducts = CappingHelper.model.allAvailableProducts.filter(function (product) {
        return CappingHelper.incentiveAppliedProductIds.indexOf(product.id) >= 0;
      });
      return CappingHelper.appliedIncentiveProducts.map(function (product) {
        return product.original_version_id || product.id;
      });
    }
  };

  function fetchSelectedDailyCapProducts (originalIds) {
    return Capping.getLatestVersionByOriginalIds(originalIds).then(function (data) {
      CappingHelper.incentiveAppliedProductIds = extractProductsIds(data);
      CappingHelper.appliedIncentiveProducts = setProductsScheduleStatus(data);
    });
  }

  function extractProductsIds(response) {
    var productIds = Object.values(response).map(function (product) {
      return product.id;
    });
    // strip undefined IDs, caused by AngularJS sticking in $promise and $resolved fields
    return _.compact(productIds);
  }

  function fetchAllDailyCapProductsToSelect() {
    var data = {
      latestForCappingType: 'DAILY_CAP'
    };
    return Capping.fetchAllCappings(data).then(function (response) {
      // strip undefined IDs, caused by AngularJS sticking in $promise and $resolved fields
      // filter all daily capping products that is multi-operator
      CappingHelper.model.allAvailableProducts = _.compact(setProductsScheduleStatus(response) ).filter(function (product) {
        return !product.multi_participant;
      });
    });
  }

  function setProductsScheduleStatus(products) {
    angular.forEach(products, function (product) {
      var scheduleStatus = CappingScheduleHelper.getScheduleStatus(product);
      switch (scheduleStatus) {
        case 'isExpired':
          product.schedule_status = 'EXPIRED';
          break;
        case 'isFuture':
          product.schedule_status = product.status === 'ACTIVE' ? 'FUTURE' : 'DISABLED';
          break;
        case 'isCurrent':
          product.schedule_status = product.status === 'ACTIVE' ? '' : 'DISABLED';
          break;
        default:
      }
    });
    return products;
  }

  return CappingHelper;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('CappingScheduleHelper', CappingScheduleHelper);

/** @ngInject */
function CappingScheduleHelper() {

  CappingScheduleHelper.getScheduleStatus = function(product) {
    var status;

    if((!product.start_date || moment().utc().isAfter(product.start_date)) && (!product.end_date || moment().utc().isBefore(product.end_date))) {
      status = 'isCurrent';
    } else if(CappingScheduleHelper.isFutureScheduled(product)) {
      status = 'isFuture';
    }else if(moment().utc().isAfter(product.end_date)){
      status = 'isExpired';
    }
    return status;
  }

  CappingScheduleHelper.isFutureScheduled = function (product) {
    return moment().utc().isBefore(product.start_date) && (moment().utc().isBefore(product.end_date) || !product.end_date);
  }

  return CappingScheduleHelper;
}

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme.services')
    .factory('Chartist', Chartist);

  Chartist.$inject = ['$window'];

  /** @ngInject */
  function Chartist($window) {
    /*jshint validthis: true*/
    if (!$window.Chartist) {
      //display error
    }

    return $window.Chartist;

  }
})();

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Config', Config);
Config.$inject = ['LITTLEPAY_API', 'LITTLEPAY_ANALYTICS_API'];

/** @ngInject */
function Config(LITTLEPAY_API, LITTLEPAY_ANALYTICS_API) {
  var DEFAULT_PAGE_LIMIT = 10;
  var AGGREGATION_SUMMARY_LIST_LIMIT = 10;

  var getAPIServerConfig = function() {
    return LITTLEPAY_API;
  };

  var getAnalyticsAPIServerConfig = function() {
    return LITTLEPAY_ANALYTICS_API;
  };

  var getAPIServerURL = function() {
    var apiServerConfig = getAPIServerConfig();
    return apiServerConfig.protocol + '://' + apiServerConfig.host + ':' + apiServerConfig.port +
      apiServerConfig.rootEndpoint;
  };

  var getAnalyticsAPIServerURL = function() {
    var config = getAnalyticsAPIServerConfig();
    return config.protocol + '://' + config.host + ':' + config.port + config.rootEndpoint;
  };

  return {
    getAPIServerURL: getAPIServerURL,
    getAnalyticsAPIServerURL: getAnalyticsAPIServerURL,
    getDefaultPageLimit: function() {
      return DEFAULT_PAGE_LIMIT;
    },
    getAggregationSummaryListLimit: function() {
      return AGGREGATION_SUMMARY_LIST_LIMIT;
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Customer', Customer);
Customer.$inject = ['$resource', '$stateParams', 'Auth', 'Config', 'Form'];

/** @ngInject */
function Customer($resource, $stateParams, Auth, Config, Form) {
  var url = Config.getAPIServerURL();
  var Customer = $resource(url + ':participantName/customers/:customerId', {
    participantName: '@participantName',
  }, {
    query: {
      isArray: false,
    },
    debtRecoveryForCard: {
      method: 'post',
      url: url + ':participantName/debt/trigger/card',
    },
    getDebtsForCustomer: {
      method: 'get',
      url: url + ':participantName/customers/:customerId/debts',
    },
  });

  Customer.model = {
    pagination: {},
    customers: [],
    currentCustomer: {},
    searchPerformed: false,
    searchForm: Form.queries,
  };

  Customer.triggerDebtRecoveryForCard = function(customerId, vaultId) {
    var participantId = Auth.getParticipantName();

    var debtRequest = {
      participant_id: participantId,
      customer_id: customerId,
      funding_source_vault_id: vaultId,
    };

    return Customer.debtRecoveryForCard({
      'participantName': participantId,
    }, debtRequest).$promise;
  };

  /* Form Validation */
  Customer.validateExpiryMonth = function(val) {
    var valid;
    try {
      var month = parseInt(val, 10);
      valid = month >= 1 && month <= 12;
    } catch (e) {
      valid = false;
    }

    Form.invalid.expiryMonth = !valid;
    return valid;
  };

  Customer.cardBinFieldHandler = function(val) {
    if (!val) {
      Customer.searchForm.cardBin = '';
      return;
    }
    var binRegex = /(\d{0,6})/;
    var matches = val.match(binRegex);
    var results = '';

    var firstSixDigits = matches[0];
    if (firstSixDigits) {
      results = firstSixDigits;
    }

    Customer.searchForm.cardBin = results;
  };

  Customer.panLastFourDigitsFieldHandler = function(val) {
    if (!val) {
      Customer.searchForm.panLastFourDigits = '';
      return;
    }
    var binRegex = /(\d{0,4})/;
    var matches = val.match(binRegex);
    var results = '';

    var lastFourDigits = matches[0];
    if (lastFourDigits) {
      results = lastFourDigits;
    }

    Customer.searchForm.panLastFourDigits = results;
  };

  Customer.truncatedPanFieldHandler = function(val) {
    if (!val) {
      Customer.searchForm.truncatedPan = '';
      return;
    }
    var truncatedPanRegEx = /(\d{0,6})(-)*(\d{0,4})/;
    var matches = val.match(truncatedPanRegEx);
    var results = '';
    var firstSixDigits = matches[1];
    var hyphen = matches[2];
    var lastFourDigits = matches[3];

    if (firstSixDigits) {
      results = firstSixDigits;
    }
    if (hyphen && firstSixDigits.length === 6) {
      results = results + hyphen;
    }
    if (lastFourDigits) {
      if (hyphen) {
        results = results + lastFourDigits;
      } else {
        results = results + '-' + lastFourDigits;
      }
    }
    Customer.searchForm.truncatedPan = results;
  };

  Customer.search = function(pageNo, searchById) {
    pageNo = pageNo || 1;
    searchById = searchById || '';
    var defaultPageLimit = parseInt(Customer.model.entryNumber) || Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    Customer.model.currentPage = pageNo;
    var query = {
      start: start,
      limit: defaultPageLimit,
      participantName: Auth.getParticipantName(),
    };

    query = angular.extend(query, {
      'card-bin': Customer.model.searchForm.cardBin,
      'vault-id': $stateParams.vaultId,
      'pan-last-four-digits': Customer.model.searchForm.pan,
      'customer-ref': Customer.model.searchForm.customerRef,
      'customer-id': Customer.model.searchForm.customerId || Form.queries.customerId,
      'card-expiry': (Customer.model.searchForm.expiryYear &&
        Customer.model.searchForm.expiryMonth) ?
        Customer.model.searchForm.expiryYear + Customer.model.searchForm.expiryMonth :
        '',
    });
    return Customer.query(query, function(resp) {
      Customer.model.customers = resp.list;
      Customer.model.pagination = resp.pagination;
      Customer.model.searchPerformed = true;
    }).$promise;
  };

  Customer.fetchCurrentCustomer = function(customerId) {
    return Customer.get({
      participantName: Auth.getParticipantName(),
      customerId: $stateParams.customerId || customerId,
    }, function(data) {
      Customer.model.currentCustomer = data;
    }).$promise;
  };

  Customer.pasteJustNumbers = function($event) {
    var clipboardData;
    var position = 6;
    $event.stopPropagation();
    $event.preventDefault();
    clipboardData = $event.originalEvent.clipboardData.getData('text/plain').match(/[0-9]/g);
    if (clipboardData) {
      clipboardData = clipboardData.join('');
    }
    var pan = '';
    if (clipboardData !== null && clipboardData.length > 6) {
      pan = clipboardData.slice(-4);
      return [clipboardData.slice(0, position), pan];
    } else {
      return [clipboardData];
    }

  };

  return Customer;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('AnalysisData', AnalysisData);

/** @ngInject */
function AnalysisData() {
  var AnalysisData = {};

  AnalysisData.json = [
    {
      'submit_date': '2018-05-25T00:00:00',
      'total_sales': 42000,
      'total_refunds': 378,
      'refund_percent': 0.009,
      'number_of_transactions': 10000,
      'new_customer': 600,
      'existing_customer': 7400,
      'new_customer_value': 3150,
      'existing_customer_value': 38850,
      'average_transaction_value': 4.2,
      'number_of_declines': 180,
      'gross_decline_percent': 0.018,
      'recovered_percent': 0.018,
      'total_declines': 756,
      'total_nomial_sales': 43680,
      'total_adjusted_sales': 42000,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 746.8,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-05-26T00:00:00',
      'total_sales': 42420,
      'total_refunds': 255,
      'refund_percent': 0.006,
      'number_of_transactions': 10100,
      'new_customer': 606,
      'existing_customer': 7474,
      'new_customer_value': 4410,
      'existing_customer_value': 39690,
      'average_transaction_value': 4.2,
      'number_of_declines': 181.07,
      'gross_decline_percent': 0.018,
      'recovered_percent': 0.017,
      'total_declines': 761,
      'total_nomial_sales': 44541,
      'total_adjusted_sales': 42420,
      'adjusted_as_percent_of_nominal': 0.952,
      'customer_value_last_12_mths': 741.9,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-05-27T00:00:00',
      'total_sales': 43693,
      'total_refunds': 218,
      'refund_percent': 0.005,
      'number_of_transactions': 10403,
      'new_customer': 936,
      'existing_customer': 7386,
      'new_customer_value': 4013.1,
      'existing_customer_value': 41850.9,
      'average_transaction_value': 4.2,
      'number_of_declines': 185.57,
      'gross_decline_percent': 0.018,
      'recovered_percent': 0.017,
      'total_declines': 779,
      'total_nomial_sales': 47625,
      'total_adjusted_sales': 43693,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 747.9,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-05-28T00:00:00',
      'total_sales': 45440,
      'total_refunds': 409,
      'refund_percent': 0.009,
      'number_of_transactions': 10819,
      'new_customer': 866,
      'existing_customer': 7790,
      'new_customer_value': 5790.33,
      'existing_customer_value': 40532.31,
      'average_transaction_value': 4.2,
      'number_of_declines': 191.45,
      'gross_decline_percent': 0.018,
      'recovered_percent': 0.016,
      'total_declines': 804,
      'total_nomial_sales': 48167,
      'total_adjusted_sales': 45440,
      'adjusted_as_percent_of_nominal': 0.943,
      'customer_value_last_12_mths': 742.3,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-05-29T00:00:00',
      'total_sales': 45440,
      'total_refunds': 318,
      'refund_percent': 0.007,
      'number_of_transactions': 10819,
      'new_customer': 649,
      'existing_customer': 8006,
      'new_customer_value': 3613.17,
      'existing_customer_value': 44562.38,
      'average_transaction_value': 4.2,
      'number_of_declines': 190.88,
      'gross_decline_percent': 0.018,
      'recovered_percent': 0.016,
      'total_declines': 802,
      'total_nomial_sales': 49076,
      'total_adjusted_sales': 45440,
      'adjusted_as_percent_of_nominal': 0.926,
      'customer_value_last_12_mths': 746,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-05-30T00:00:00',
      'total_sales': 45440,
      'total_refunds': 364,
      'refund_percent': 0.008,
      'number_of_transactions': 10819,
      'new_customer': 757,
      'existing_customer': 7898,
      'new_customer_value': 3071.19,
      'existing_customer_value': 46067.87,
      'average_transaction_value': 4.2,
      'number_of_declines': 189.73,
      'gross_decline_percent': 0.018,
      'recovered_percent': 0.015,
      'total_declines': 797,
      'total_nomial_sales': 49530,
      'total_adjusted_sales': 45440,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 748.2,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-05-31T00:00:00',
      'total_sales': 46804,
      'total_refunds': 374,
      'refund_percent': 0.008,
      'number_of_transactions': 11144,
      'new_customer': 1114,
      'existing_customer': 7801,
      'new_customer_value': 5749.27,
      'existing_customer_value': 45355.35,
      'average_transaction_value': 4.2,
      'number_of_declines': 194.64,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.015,
      'total_declines': 817,
      'total_nomial_sales': 51484,
      'total_adjusted_sales': 46804,
      'adjusted_as_percent_of_nominal': 0.909,
      'customer_value_last_12_mths': 749.4,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-01T00:00:00',
      'total_sales': 47740,
      'total_refunds': 477,
      'refund_percent': 0.01,
      'number_of_transactions': 11367,
      'new_customer': 1023,
      'existing_customer': 8070,
      'new_customer_value': 5806.76,
      'existing_customer_value': 45808.9,
      'average_transaction_value': 4.2,
      'number_of_declines': 197.15,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.015,
      'total_declines': 828,
      'total_nomial_sales': 49172,
      'total_adjusted_sales': 47740,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 747.6,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-02T00:00:00',
      'total_sales': 48217,
      'total_refunds': 241,
      'refund_percent': 0.005,
      'number_of_transactions': 11480,
      'new_customer': 1148,
      'existing_customer': 8036,
      'new_customer_value': 3290.5,
      'existing_customer_value': 49357.48,
      'average_transaction_value': 4.2,
      'number_of_declines': 198.52,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.014,
      'total_declines': 834,
      'total_nomial_sales': 49181,
      'total_adjusted_sales': 48217,
      'adjusted_as_percent_of_nominal': 0.98,
      'customer_value_last_12_mths': 743.6,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-03T00:00:00',
      'total_sales': 50628,
      'total_refunds': 253,
      'refund_percent': 0.005,
      'number_of_transactions': 12054,
      'new_customer': 1085,
      'existing_customer': 8559,
      'new_customer_value': 6159.81,
      'existing_customer_value': 48594.08,
      'average_transaction_value': 4.2,
      'number_of_declines': 207.19,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.014,
      'total_declines': 870,
      'total_nomial_sales': 52147,
      'total_adjusted_sales': 50628,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 747.6,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-04T00:00:00',
      'total_sales': 52653,
      'total_refunds': 421,
      'refund_percent': 0.008,
      'number_of_transactions': 12536,
      'new_customer': 1003,
      'existing_customer': 9026,
      'new_customer_value': 6159.81,
      'existing_customer_value': 48594.08,
      'average_transaction_value': 4.2,
      'number_of_declines': 213.76,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.013,
      'total_declines': 898,
      'total_nomial_sales': 52653,
      'total_adjusted_sales': 52653,
      'adjusted_as_percent_of_nominal': 1,
      'customer_value_last_12_mths': 744.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-05T00:00:00',
      'total_sales': 53179,
      'total_refunds': 425,
      'refund_percent': 0.008,
      'number_of_transactions': 12662,
      'new_customer': 1013,
      'existing_customer': 9116,
      'new_customer_value': 3422.12,
      'existing_customer_value': 51331.78,
      'average_transaction_value': 4.2,
      'number_of_declines': 215.25,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.013,
      'total_declines': 904,
      'total_nomial_sales': 57966,
      'total_adjusted_sales': 53179,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 748.7,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-06T00:00:00',
      'total_sales': 53711,
      'total_refunds': 322,
      'refund_percent': 0.006,
      'number_of_transactions': 12788,
      'new_customer': 767,
      'existing_customer': 9463,
      'new_customer_value': 4229.74,
      'existing_customer_value': 52166.78,
      'average_transaction_value': 4.2,
      'number_of_declines': 216.75,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.012,
      'total_declines': 910,
      'total_nomial_sales': 56397,
      'total_adjusted_sales': 53711,
      'adjusted_as_percent_of_nominal': 0.952,
      'customer_value_last_12_mths': 743.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-07T00:00:00',
      'total_sales': 56397,
      'total_refunds': 508,
      'refund_percent': 0.009,
      'number_of_transactions': 13428,
      'new_customer': 1343,
      'existing_customer': 9399,
      'new_customer_value': 6598.39,
      'existing_customer_value': 52053.98,
      'average_transaction_value': 4.2,
      'number_of_declines': 227.13,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.012,
      'total_declines': 954,
      'total_nomial_sales': 58653,
      'total_adjusted_sales': 56397,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 748.7,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-08T00:00:00',
      'total_sales': 56397,
      'total_refunds': 395,
      'refund_percent': 0.007,
      'number_of_transactions': 13428,
      'new_customer': 671,
      'existing_customer': 10071,
      'new_customer_value': 6158.5,
      'existing_customer_value': 55426.49,
      'average_transaction_value': 4.2,
      'number_of_declines': 225.77,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.012,
      'total_declines': 948,
      'total_nomial_sales': 61473,
      'total_adjusted_sales': 56397,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 743.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-09T00:00:00',
      'total_sales': 56397,
      'total_refunds': 395,
      'refund_percent': 0.007,
      'number_of_transactions': 13428,
      'new_customer': 1074,
      'existing_customer': 9668,
      'new_customer_value': 6220.08,
      'existing_customer_value': 55980.76,
      'average_transaction_value': 4.2,
      'number_of_declines': 223.74,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.012,
      'total_declines': 940,
      'total_nomial_sales': 62037,
      'total_adjusted_sales': 56397,
      'adjusted_as_percent_of_nominal': 0.909,
      'customer_value_last_12_mths': 748.7,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-10T00:00:00',
      'total_sales': 59217,
      'total_refunds': 355,
      'refund_percent': 0.006,
      'number_of_transactions': 14099,
      'new_customer': 1269,
      'existing_customer': 10010,
      'new_customer_value': 8086.11,
      'existing_customer_value': 56602.77,
      'average_transaction_value': 4.2,
      'number_of_declines': 233.28,
      'gross_decline_percent': 0.017,
      'recovered_percent': 0.012,
      'total_declines': 980,
      'total_nomial_sales': 63954,
      'total_adjusted_sales': 59217,
      'adjusted_as_percent_of_nominal': 0.926,
      'customer_value_last_12_mths': 749.9,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-11T00:00:00',
      'total_sales': 60993,
      'total_refunds': 427,
      'refund_percent': 0.007,
      'number_of_transactions': 14522,
      'new_customer': 1452,
      'existing_customer': 10166,
      'new_customer_value': 5660.28,
      'existing_customer_value': 59028.6,
      'average_transaction_value': 4.2,
      'number_of_declines': 239.56,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1006,
      'total_nomial_sales': 66483,
      'total_adjusted_sales': 60993,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 746,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-12T00:00:00',
      'total_sales': 64043,
      'total_refunds': 576,
      'refund_percent': 0.009,
      'number_of_transactions': 15248,
      'new_customer': 1220,
      'existing_customer': 10979,
      'new_customer_value': 4245.21,
      'existing_customer_value': 63678.11,
      'average_transaction_value': 4.2,
      'number_of_declines': 250.02,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1050,
      'total_nomial_sales': 67245,
      'total_adjusted_sales': 64043,
      'adjusted_as_percent_of_nominal': 0.952,
      'customer_value_last_12_mths': 749.9,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-13T00:00:00',
      'total_sales': 64043,
      'total_refunds': 576,
      'refund_percent': 0.009,
      'number_of_transactions': 15248,
      'new_customer': 762,
      'existing_customer': 11436,
      'new_customer_value': 4287.66,
      'existing_customer_value': 64314.89,
      'average_transaction_value': 4.2,
      'number_of_declines': 248.52,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1044,
      'total_nomial_sales': 64043,
      'total_adjusted_sales': 64043,
      'adjusted_as_percent_of_nominal': 1,
      'customer_value_last_12_mths': 746,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-14T00:00:00',
      'total_sales': 64683,
      'total_refunds': 517,
      'refund_percent': 0.008,
      'number_of_transactions': 15401,
      'new_customer': 1232,
      'existing_customer': 11089,
      'new_customer_value': 6002.72,
      'existing_customer_value': 62599.83,
      'average_transaction_value': 4.2,
      'number_of_declines': 249.5,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1048,
      'total_nomial_sales': 67271,
      'total_adjusted_sales': 64683,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 747.1,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-15T00:00:00',
      'total_sales': 67917,
      'total_refunds': 408,
      'refund_percent': 0.006,
      'number_of_transactions': 16171,
      'new_customer': 1617,
      'existing_customer': 11320,
      'new_customer_value': 8575.32,
      'existing_customer_value': 60027.24,
      'average_transaction_value': 4.2,
      'number_of_declines': 260.15,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1093,
      'total_nomial_sales': 74030,
      'total_adjusted_sales': 67917,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 745.7,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-16T00:00:00',
      'total_sales': 69276,
      'total_refunds': 416,
      'refund_percent': 0.006,
      'number_of_transactions': 16494,
      'new_customer': 1155,
      'existing_customer': 12041,
      'new_customer_value': 5351,
      'existing_customer_value': 65995.66,
      'average_transaction_value': 4.2,
      'number_of_declines': 264.82,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1112,
      'total_nomial_sales': 71354,
      'total_adjusted_sales': 69276,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 743.7,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-17T00:00:00',
      'total_sales': 72047,
      'total_refunds': 504,
      'refund_percent': 0.007,
      'number_of_transactions': 17154,
      'new_customer': 858,
      'existing_customer': 12865,
      'new_customer_value': 7348.71,
      'existing_customer_value': 66138.35,
      'average_transaction_value': 4.2,
      'number_of_declines': 273.48,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1149,
      'total_nomial_sales': 73488,
      'total_adjusted_sales': 72047,
      'adjusted_as_percent_of_nominal': 0.98,
      'customer_value_last_12_mths': 746.6,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-18T00:00:00',
      'total_sales': 74929,
      'total_refunds': 599,
      'refund_percent': 0.008,
      'number_of_transactions': 17840,
      'new_customer': 1070,
      'existing_customer': 13202,
      'new_customer_value': 5566.64,
      'existing_customer_value': 68655.28,
      'average_transaction_value': 4.2,
      'number_of_declines': 282.43,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1186,
      'total_nomial_sales': 80174,
      'total_adjusted_sales': 74929,
      'adjusted_as_percent_of_nominal': 0.935,
      'customer_value_last_12_mths': 743.7,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-19T00:00:00',
      'total_sales': 76427,
      'total_refunds': 764,
      'refund_percent': 0.01,
      'number_of_transactions': 18197,
      'new_customer': 1638,
      'existing_customer': 12920,
      'new_customer_value': 6494.42,
      'existing_customer_value': 67727.51,
      'average_transaction_value': 4.2,
      'number_of_declines': 286.93,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1205,
      'total_nomial_sales': 78720,
      'total_adjusted_sales': 76427,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 746.8,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-20T00:00:00',
      'total_sales': 76427,
      'total_refunds': 611,
      'refund_percent': 0.008,
      'number_of_transactions': 18197,
      'new_customer': 1092,
      'existing_customer': 13466,
      'new_customer_value': 5789.31,
      'existing_customer_value': 71401.49,
      'average_transaction_value': 4.2,
      'number_of_declines': 284.63,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1195,
      'total_nomial_sales': 81777,
      'total_adjusted_sales': 76427,
      'adjusted_as_percent_of_nominal': 0.935,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-21T00:00:00',
      'total_sales': 78720,
      'total_refunds': 394,
      'refund_percent': 0.005,
      'number_of_transactions': 18743,
      'new_customer': 1874,
      'existing_customer': 13120,
      'new_customer_value': 5962.99,
      'existing_customer_value': 73543.54,
      'average_transaction_value': 4.2,
      'number_of_declines': 292.29,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1228,
      'total_nomial_sales': 78720,
      'total_adjusted_sales': 78720,
      'adjusted_as_percent_of_nominal': 1,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-22T00:00:00',
      'total_sales': 82656,
      'total_refunds': 413,
      'refund_percent': 0.005,
      'number_of_transactions': 19680,
      'new_customer': 1181,
      'existing_customer': 14563,
      'new_customer_value': 8030.16,
      'existing_customer_value': 72271.43,
      'average_transaction_value': 4.2,
      'number_of_declines': 306.29,
      'gross_decline_percent': 0.016,
      'recovered_percent': 0.012,
      'total_declines': 1286,
      'total_nomial_sales': 85962,
      'total_adjusted_sales': 82656,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-23T00:00:00',
      'total_sales': 83483,
      'total_refunds': 417,
      'refund_percent': 0.005,
      'number_of_transactions': 19877,
      'new_customer': 1590,
      'existing_customer': 14311,
      'new_customer_value': 9485.63,
      'existing_customer_value': 74831.05,
      'average_transaction_value': 4.2,
      'number_of_declines': 306.57,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1288,
      'total_nomial_sales': 84317,
      'total_adjusted_sales': 83483,
      'adjusted_as_percent_of_nominal': 0.99,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-24T00:00:00',
      'total_sales': 86822,
      'total_refunds': 608,
      'refund_percent': 0.007,
      'number_of_transactions': 20672,
      'new_customer': 1860,
      'existing_customer': 14677,
      'new_customer_value': 10750.38,
      'existing_customer_value': 75252.63,
      'average_transaction_value': 4.2,
      'number_of_declines': 318.2,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1336,
      'total_nomial_sales': 95504,
      'total_adjusted_sales': 86822,
      'adjusted_as_percent_of_nominal': 0.909,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-25T00:00:00',
      'total_sales': 87690,
      'total_refunds': 702,
      'refund_percent': 0.008,
      'number_of_transactions': 20879,
      'new_customer': 1670,
      'existing_customer': 15033,
      'new_customer_value': 10159.11,
      'existing_customer_value': 80144.05,
      'average_transaction_value': 4.2,
      'number_of_declines': 320.41,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1346,
      'total_nomial_sales': 94705,
      'total_adjusted_sales': 87690,
      'adjusted_as_percent_of_nominal': 0.926,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-26T00:00:00',
      'total_sales': 91198,
      'total_refunds': 638,
      'refund_percent': 0.007,
      'number_of_transactions': 21714,
      'new_customer': 1520,
      'existing_customer': 15851,
      'new_customer_value': 5643.95,
      'existing_customer_value': 84659.21,
      'average_transaction_value': 4.2,
      'number_of_declines': 330.23,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1387,
      'total_nomial_sales': 96670,
      'total_adjusted_sales': 91198,
      'adjusted_as_percent_of_nominal': 0.943,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-27T00:00:00',
      'total_sales': 93022,
      'total_refunds': 558,
      'refund_percent': 0.006,
      'number_of_transactions': 22148,
      'new_customer': 2215,
      'existing_customer': 15504,
      'new_customer_value': 9391.53,
      'existing_customer_value': 84523.75,
      'average_transaction_value': 4.2,
      'number_of_declines': 335.49,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1409,
      'total_nomial_sales': 94882,
      'total_adjusted_sales': 93022,
      'adjusted_as_percent_of_nominal': 0.98,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-28T00:00:00',
      'total_sales': 93952,
      'total_refunds': 940,
      'refund_percent': 0.01,
      'number_of_transactions': 22370,
      'new_customer': 1790,
      'existing_customer': 16106,
      'new_customer_value': 9767.19,
      'existing_customer_value': 87904.7,
      'average_transaction_value': 4.2,
      'number_of_declines': 337.83,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1419,
      'total_nomial_sales': 93952,
      'total_adjusted_sales': 93952,
      'adjusted_as_percent_of_nominal': 1,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-29T00:00:00',
      'total_sales': 94891,
      'total_refunds': 949,
      'refund_percent': 0.01,
      'number_of_transactions': 22593,
      'new_customer': 1582,
      'existing_customer': 16493,
      'new_customer_value': 11537.49,
      'existing_customer_value': 91018,
      'average_transaction_value': 4.2,
      'number_of_declines': 339.5,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1426,
      'total_nomial_sales': 95840,
      'total_adjusted_sales': 94891,
      'adjusted_as_percent_of_nominal': 0.99,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-06-30T00:00:00',
      'total_sales': 97738,
      'total_refunds': 977,
      'refund_percent': 0.01,
      'number_of_transactions': 23271,
      'new_customer': 1629,
      'existing_customer': 16988,
      'new_customer_value': 6602.01,
      'existing_customer_value': 99030.14,
      'average_transaction_value': 4.2,
      'number_of_declines': 348.28,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1463,
      'total_nomial_sales': 99693,
      'total_adjusted_sales': 97738,
      'adjusted_as_percent_of_nominal': 0.98,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-01T00:00:00',
      'total_sales': 99693,
      'total_refunds': 698,
      'refund_percent': 0.007,
      'number_of_transactions': 23736,
      'new_customer': 1187,
      'existing_customer': 17802,
      'new_customer_value': 7922.41,
      'existing_customer_value': 97709.74,
      'average_transaction_value': 4.2,
      'number_of_declines': 353.47,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1485,
      'total_nomial_sales': 109662,
      'total_adjusted_sales': 99693,
      'adjusted_as_percent_of_nominal': 0.909,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-02T00:00:00',
      'total_sales': 99693,
      'total_refunds': 598,
      'refund_percent': 0.006,
      'number_of_transactions': 23736,
      'new_customer': 1662,
      'existing_customer': 17328,
      'new_customer_value': 13864.22,
      'existing_customer_value': 97049.54,
      'average_transaction_value': 4.2,
      'number_of_declines': 352.77,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1482,
      'total_nomial_sales': 101687,
      'total_adjusted_sales': 99693,
      'adjusted_as_percent_of_nominal': 0.98,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-03T00:00:00',
      'total_sales': 102684,
      'total_refunds': 1027,
      'refund_percent': 0.01,
      'number_of_transactions': 24449,
      'new_customer': 1467,
      'existing_customer': 18092,
      'new_customer_value': 8401.72,
      'existing_customer_value': 103621.18,
      'average_transaction_value': 4.2,
      'number_of_declines': 360.08,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1512,
      'total_nomial_sales': 109872,
      'total_adjusted_sales': 102684,
      'adjusted_as_percent_of_nominal': 0.935,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-04T00:00:00',
      'total_sales': 105764,
      'total_refunds': 740,
      'refund_percent': 0.007,
      'number_of_transactions': 25182,
      'new_customer': 2266,
      'existing_customer': 17879,
      'new_customer_value': 7071.45,
      'existing_customer_value': 106071.68,
      'average_transaction_value': 4.2,
      'number_of_declines': 369.03,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1550,
      'total_nomial_sales': 106822,
      'total_adjusted_sales': 105764,
      'adjusted_as_percent_of_nominal': 0.99,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-05T00:00:00',
      'total_sales': 106822,
      'total_refunds': 855,
      'refund_percent': 0.008,
      'number_of_transactions': 25434,
      'new_customer': 1780,
      'existing_customer': 18567,
      'new_customer_value': 13365.03,
      'existing_customer_value': 105435.25,
      'average_transaction_value': 4.2,
      'number_of_declines': 369.74,
      'gross_decline_percent': 0.015,
      'recovered_percent': 0.012,
      'total_declines': 1553,
      'total_nomial_sales': 111095,
      'total_adjusted_sales': 106822,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-06T00:00:00',
      'total_sales': 107890,
      'total_refunds': 971,
      'refund_percent': 0.009,
      'number_of_transactions': 25688,
      'new_customer': 1284,
      'existing_customer': 19266,
      'new_customer_value': 10395.02,
      'existing_customer_value': 108405.26,
      'average_transaction_value': 4.2,
      'number_of_declines': 371.19,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1559,
      'total_nomial_sales': 111127,
      'total_adjusted_sales': 107890,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-07T00:00:00',
      'total_sales': 108969,
      'total_refunds': 545,
      'refund_percent': 0.005,
      'number_of_transactions': 25945,
      'new_customer': 2335,
      'existing_customer': 18421,
      'new_customer_value': 9177.32,
      'existing_customer_value': 113186.97,
      'average_transaction_value': 4.2,
      'number_of_declines': 371.91,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1562,
      'total_nomial_sales': 118776,
      'total_adjusted_sales': 108969,
      'adjusted_as_percent_of_nominal': 0.917,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-08T00:00:00',
      'total_sales': 114417,
      'total_refunds': 1144,
      'refund_percent': 0.01,
      'number_of_transactions': 27242,
      'new_customer': 2179,
      'existing_customer': 19614,
      'new_customer_value': 7953.68,
      'existing_customer_value': 119305.19,
      'average_transaction_value': 4.2,
      'number_of_declines': 388.16,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1630,
      'total_nomial_sales': 121283,
      'total_adjusted_sales': 114417,
      'adjusted_as_percent_of_nominal': 0.943,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-09T00:00:00',
      'total_sales': 116706,
      'total_refunds': 700,
      'refund_percent': 0.006,
      'number_of_transactions': 27787,
      'new_customer': 2501,
      'existing_customer': 19729,
      'new_customer_value': 12725.89,
      'existing_customer_value': 114532.98,
      'average_transaction_value': 4.2,
      'number_of_declines': 392.36,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1648,
      'total_nomial_sales': 120207,
      'total_adjusted_sales': 116706,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-10T00:00:00',
      'total_sales': 122541,
      'total_refunds': 1225,
      'refund_percent': 0.01,
      'number_of_transactions': 29176,
      'new_customer': 2918,
      'existing_customer': 20424,
      'new_customer_value': 14889.29,
      'existing_customer_value': 117459.93,
      'average_transaction_value': 4.2,
      'number_of_declines': 410.74,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1725,
      'total_nomial_sales': 123767,
      'total_adjusted_sales': 122541,
      'adjusted_as_percent_of_nominal': 0.99,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-11T00:00:00',
      'total_sales': 126217,
      'total_refunds': 884,
      'refund_percent': 0.007,
      'number_of_transactions': 30052,
      'new_customer': 2705,
      'existing_customer': 21337,
      'new_customer_value': 13367.27,
      'existing_customer_value': 120305.44,
      'average_transaction_value': 4.2,
      'number_of_declines': 419.25,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1761,
      'total_nomial_sales': 131266,
      'total_adjusted_sales': 126217,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-12T00:00:00',
      'total_sales': 126217,
      'total_refunds': 631,
      'refund_percent': 0.005,
      'number_of_transactions': 30052,
      'new_customer': 1803,
      'existing_customer': 22238,
      'new_customer_value': 8605.18,
      'existing_customer_value': 129077.71,
      'average_transaction_value': 4.2,
      'number_of_declines': 416.74,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1750,
      'total_nomial_sales': 128742,
      'total_adjusted_sales': 126217,
      'adjusted_as_percent_of_nominal': 0.98,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-13T00:00:00',
      'total_sales': 131266,
      'total_refunds': 1313,
      'refund_percent': 0.01,
      'number_of_transactions': 31254,
      'new_customer': 2500,
      'existing_customer': 22503,
      'new_customer_value': 10636,
      'existing_customer_value': 131177.38,
      'average_transaction_value': 4.2,
      'number_of_declines': 432.11,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1815,
      'total_nomial_sales': 141767,
      'total_adjusted_sales': 131266,
      'adjusted_as_percent_of_nominal': 0.926,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-14T00:00:00',
      'total_sales': 137829,
      'total_refunds': 689,
      'refund_percent': 0.005,
      'number_of_transactions': 32817,
      'new_customer': 3282,
      'existing_customer': 22972,
      'new_customer_value': 12656.84,
      'existing_customer_value': 131992.8,
      'average_transaction_value': 4.2,
      'number_of_declines': 450.08,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1890,
      'total_nomial_sales': 144721,
      'total_adjusted_sales': 137829,
      'adjusted_as_percent_of_nominal': 0.952,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-15T00:00:00',
      'total_sales': 137829,
      'total_refunds': 965,
      'refund_percent': 0.007,
      'number_of_transactions': 32817,
      'new_customer': 3282,
      'existing_customer': 22972,
      'new_customer_value': 18262.02,
      'existing_customer_value': 127834.13,
      'average_transaction_value': 4.2,
      'number_of_declines': 448.73,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1885,
      'total_nomial_sales': 147477,
      'total_adjusted_sales': 137829,
      'adjusted_as_percent_of_nominal': 0.935,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-16T00:00:00',
      'total_sales': 144721,
      'total_refunds': 1302,
      'refund_percent': 0.009,
      'number_of_transactions': 34457,
      'new_customer': 2412,
      'existing_customer': 25154,
      'new_customer_value': 13039.08,
      'existing_customer_value': 135978.99,
      'average_transaction_value': 4.2,
      'number_of_declines': 468.81,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1969,
      'total_nomial_sales': 154851,
      'total_adjusted_sales': 144721,
      'adjusted_as_percent_of_nominal': 0.935,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-17T00:00:00',
      'total_sales': 144721,
      'total_refunds': 1013,
      'refund_percent': 0.007,
      'number_of_transactions': 34457,
      'new_customer': 2412,
      'existing_customer': 25154,
      'new_customer_value': 18813.53,
      'existing_customer_value': 131694.72,
      'average_transaction_value': 4.2,
      'number_of_declines': 466,
      'gross_decline_percent': 0.014,
      'recovered_percent': 0.012,
      'total_declines': 1957,
      'total_nomial_sales': 150510,
      'total_adjusted_sales': 144721,
      'adjusted_as_percent_of_nominal': 0.962,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-18T00:00:00',
      'total_sales': 144721,
      'total_refunds': 1013,
      'refund_percent': 0.007,
      'number_of_transactions': 34457,
      'new_customer': 2757,
      'existing_customer': 24809,
      'new_customer_value': 9688.97,
      'existing_customer_value': 145334.53,
      'average_transaction_value': 4.2,
      'number_of_declines': 464.14,
      'gross_decline_percent': 0.013,
      'recovered_percent': 0.012,
      'total_declines': 1949,
      'total_nomial_sales': 159193,
      'total_adjusted_sales': 144721,
      'adjusted_as_percent_of_nominal': 0.909,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-19T00:00:00',
      'total_sales': 149062,
      'total_refunds': 745,
      'refund_percent': 0.005,
      'number_of_transactions': 35491,
      'new_customer': 3194,
      'existing_customer': 25199,
      'new_customer_value': 11975.56,
      'existing_customer_value': 147698.63,
      'average_transaction_value': 4.2,
      'number_of_declines': 474.24,
      'gross_decline_percent': 0.013,
      'recovered_percent': 0.012,
      'total_declines': 1992,
      'total_nomial_sales': 156516,
      'total_adjusted_sales': 149062,
      'adjusted_as_percent_of_nominal': 0.952,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-20T00:00:00',
      'total_sales': 152044,
      'total_refunds': 912,
      'refund_percent': 0.006,
      'number_of_transactions': 36201,
      'new_customer': 2896,
      'existing_customer': 26065,
      'new_customer_value': 16286.77,
      'existing_customer_value': 146580.92,
      'average_transaction_value': 4.2,
      'number_of_declines': 479.85,
      'gross_decline_percent': 0.013,
      'recovered_percent': 0.012,
      'total_declines': 2015,
      'total_nomial_sales': 161166,
      'total_adjusted_sales': 152044,
      'adjusted_as_percent_of_nominal': 0.943,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-21T00:00:00',
      'total_sales': 156605,
      'total_refunds': 1253,
      'refund_percent': 0.008,
      'number_of_transactions': 37287,
      'new_customer': 2237,
      'existing_customer': 27592,
      'new_customer_value': 17101.11,
      'existing_customer_value': 153909.96,
      'average_transaction_value': 4.2,
      'number_of_declines': 492.77,
      'gross_decline_percent': 0.013,
      'recovered_percent': 0.012,
      'total_declines': 2070,
      'total_nomial_sales': 167567,
      'total_adjusted_sales': 156605,
      'adjusted_as_percent_of_nominal': 0.935,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
    {
      'submit_date': '2018-07-22T00:00:00',
      'total_sales': 164435,
      'total_refunds': 987,
      'refund_percent': 0.006,
      'number_of_transactions': 39151,
      'new_customer': 3915,
      'existing_customer': 27406,
      'new_customer_value': 17443.13,
      'existing_customer_value': 156988.16,
      'average_transaction_value': 4.2,
      'number_of_declines': 513.78,
      'gross_decline_percent': 0.013,
      'recovered_percent': 0.012,
      'total_declines': 2158,
      'total_nomial_sales': 177590,
      'total_adjusted_sales': 164435,
      'adjusted_as_percent_of_nominal': 0.926,
      'customer_value_last_12_mths': 749.5,
      'liability': 'not_covered',
    },
    {
      'submit_date': '2018-07-23T00:00:00',
      'total_sales': 166080,
      'total_refunds': 1495,
      'refund_percent': 0.009,
      'number_of_transactions': 39543,
      'new_customer': 3163,
      'existing_customer': 28471,
      'new_customer_value': 11338.03,
      'existing_customer_value': 170070.51,
      'average_transaction_value': 4.2,
      'number_of_declines': 514.77,
      'gross_decline_percent': 0.013,
      'recovered_percent': 0.012,
      'total_declines': 2162,
      'total_nomial_sales': 171062,
      'total_adjusted_sales': 166080,
      'adjusted_as_percent_of_nominal': 0.971,
      'customer_value_last_12_mths': 749.5,
      'liability': 'covered',
    },
  ];

  AnalysisData.debt = [
    {
      'days_after_transaction_date': 0,
      'recovered_debt': 20,
      'outstanding_debt': 1980,
      'original_debt': 2000,
      'recovered_debt_percent': 1.00,
      'outstanding_debt_percent': 99.00,
    }, {
      'days_after_transaction_date': 5,
      'recovered_debt': 100,
      'outstanding_debt': 1900,
      'original_debt': 2000,
      'recovered_debt_percent': 5.00,
      'outstanding_debt_percent': 95.00,
    }, {
      'days_after_transaction_date': 10,
      'recovered_debt': 300,
      'outstanding_debt': 1700,
      'original_debt': 2000,
      'recovered_debt_percent': 15.00,
      'outstanding_debt_percent': 85.00,
    }, {
      'days_after_transaction_date': 15,
      'recovered_debt': 600,
      'outstanding_debt': 1400,
      'original_debt': 2000,
      'recovered_debt_percent': 30.00,
      'outstanding_debt_percent': 70.00,
    }, {
      'days_after_transaction_date': 20,
      'recovered_debt': 1000,
      'outstanding_debt': 1000,
      'original_debt': 2000,
      'recovered_debt_percent': 50.00,
      'outstanding_debt_percent': 50.00,
    }, {
      'days_after_transaction_date': 25,
      'recovered_debt': 1400,
      'outstanding_debt': 600,
      'original_debt': 2000,
      'recovered_debt_percent': 70.00,
      'outstanding_debt_percent': 30.00,
    }, {
      'days_after_transaction_date': 30,
      'recovered_debt': 1420,
      'outstanding_debt': 580,
      'original_debt': 2000,
      'recovered_debt_percent': 71.00,
      'outstanding_debt_percent': 29.00,
    }, {
      'days_after_transaction_date': '30+',
      'recovered_debt': 1440,
      'outstanding_debt': 560,
      'original_debt': 2000,
      'recovered_debt_percent': 72.00,
      'outstanding_debt_percent': 28.00,
    }];

  return AnalysisData;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Device', Device);
Device.$inject = ['$resource', 'Auth', 'Config', '$location'];

/** @ngInject */
function Device($resource, Auth, Config, $location) {

  var url = Config.getAPIServerURL() + ':participantId';
  var Device = $resource(url + '/devices/:deviceId', {
    participantId: '@participantId',
    deviceId: '@deviceId',
  }, {
    getAllDevices: {
      method: 'get',
    },
    getAssignments: {
      method: 'get',
      url: url + '/device-assignments',
    },
  });

  Device.searchForm = {
    'terminal_id': '',
  };

  Device.model = {
    allDevices: [],
    pagination: {},
  };
  Device.assignmentsModel = {
    assignments: [],
    pagination: {},
  };

  if ($location.search().terminal) {
    Device.searchForm.terminal_id = $location.search().terminal;
  }
  if ($location.search().group) {
    Device.searchForm.group_id = $location.search().group;
  }

  Device.fetchAllDevices = function(displayInTransactionSimulator) {
    var query = {
      start: 0,
      limit: 100000,
      participantId: Auth.getParticipantName(),
      "display-in-transaction-simulator": displayInTransactionSimulator
    };

    return Device.getAllDevices(query).$promise;
  };

  Device.fetchDevices = function(pageNo) {
    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(Device.model.entryNumber) || Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    Device.model.currentPage = pageNo;
    var order = $location.search().order;
    var reverse = $location.search().reverse;

    var query = {
      start: start,
      limit: defaultPageLimit,
      participantId: Auth.getParticipantName(),
    };

    if (Device.searchForm.newSearch) {
      query = angular.extend(query, {
        'terminal-id': Device.searchForm.terminal_id,
      });
    }
    if (order || reverse) {
      query = angular.extend(query, {
        'sort': order,
        'asc': reverse,
      });
    }

    return Device.getAllDevices(query, function(data) {
      Device.model.allDevices = data.devices;
      Device.model.pagination = data.pagination;
    }).$promise;
  };

  Device.clearSearchForm = function() {
    Device.searchForm.terminal_id = '';
    Device.searchForm.newSearch = false;
    $location.search('terminal', null);
  };

  Device.fetchAssignments = function(pageNo) {
    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(Device.assignmentsModel.entryNumber) ||
      Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    Device.assignmentsModel.currentPage = pageNo;

    var query = {
      start: start,
      limit: defaultPageLimit,
      participantId: Auth.getParticipantName(),
    };

    return Device.getAssignments(query, function(data) {
      Device.assignmentsModel.assignments = data.assignments;
      Device.assignmentsModel.pagination = data.pagination;
    }).$promise;
  };

  return Device;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('DeviceSimulator', DeviceSimulator);
DeviceSimulator.$inject = ['$resource', 'Auth', 'Config'];

/** @ngInject */
function DeviceSimulator($resource, Auth, Config) {

  var url = Config.getAPIServerURL() + ':participantName';
  var DeviceSimulator = $resource(url + '/devices/:deviceId/transaction', {
    participantName: '@participantName',
    deviceId: '@deviceId'
  }, {
    submit: {
      method: 'post'
    }
  });

  DeviceSimulator.submitTransaction = function(deviceId, body) {
    return DeviceSimulator.submit({
      'participantName': Auth.getParticipantName(),
      'deviceId': deviceId
    }, body).$promise;
  };

  return DeviceSimulator;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Discount', Discount);
Discount.$inject = ['$resource', 'Auth', 'Config', '$stateParams'];

/** @ngInject */
function Discount($resource, Auth, Config, $stateParams) {

  var url = Config.getAPIServerURL();
  var Discount = $resource(url + ':participantName/products/discount/:discountId', {
    participantName: '@participantName',
    discountId: '@discountId',
  }, {
    getAllDiscount: {
      method: 'get',
      isArray: true,
    },
    getDiscountById: {
      method: 'get',
    },
    updateDiscount: {
      method: 'put',
    },
    deleteDiscount: {
      method: 'delete',
    },
    createDiscount: {
      method: 'post',
    },
  });

  Discount.model = {
    allDiscount: [],
    selectedDiscount: {},
    newDiscount: {},
  };

  Discount.create = function(data) {
    return Discount.createDiscount({
      'participantName': Auth.getParticipantName(),
    }, data).$promise;
  };

  Discount.removeDiscount = function(id) {
    return Discount.deleteDiscount({
      'participantName': Auth.getParticipantName(),
      'discountId': id,
    }).$promise;
  };

  Discount.fetchAllDiscounts = function() {
    var data = {
      'participantName': Auth.getParticipantName(),
    };
    return Discount.getAllDiscount(data).$promise;
  };

  Discount.fetchDiscountById = function(zoneNames, timePeriodType) {
    var data = {
      'discountId': $stateParams.discountId,
      'participantName': Auth.getParticipantName(),
    };

    if (zoneNames && timePeriodType) {
      var x = zoneNames.map(function(a) {
        return (a);
      });
      angular.extend(data, {
        'zones': x.join('+'),
        'time-period': timePeriodType,
      });
    }

    return Discount.getDiscountById(data).$promise;
  };

  return Discount;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .factory('Order', Order);
Order.$inject = ['$resource', '$stateParams', 'Config', 'Auth'];

/** @ngInject */
function Order($resource, $stateParams, Config, Auth) {

  var url = Config.getAPIServerURL();

  var Order = $resource(url, { participantId: '@participantId', orderId: '@orderId',comment: "@comment",reason: "@reason", amount: "@amount"}, {
    getOne: {
      method: 'get',
      url: url + 'orders/:orderId'
    },
    submitRefund: {
      method: "post",
      url: url + ":participantId/orders/:orderId/refund",
      params: { comment: "@comment", reason: "@reason", amount: "@amount" },
      hasBody: false,
      },
  });

  Order.model = {
    pagination: {},
    orders: {}
  };

  Order.getOrderDetails = function(orderId) {
    return Order.getOne({ orderId: orderId || $stateParams.orderId}, function(data) {
      Order.model.currentOrderDetails = data;
    }).$promise;
  };

  Order.requestOrderRefund = function (orderId, refundRequest) {
    var query = {
      participantId: Auth.getParticipantId(),
      orderId: orderId,
      comment: refundRequest.comment,
      reason: refundRequest.reason,
      amount: refundRequest.amount,
    };

    return Order.submitRefund(query).$promise;
  };

  Order.validateReasonContents = function(customerComment, issuerComment) {
    var invalid = false;
    var cardRegex = /(\d\s?){15,}/;
    if (customerComment) {
      invalid = invalid || cardRegex.test(customerComment);
    }
    if (issuerComment) {
      invalid = invalid || cardRegex.test(issuerComment);
    }
    return !invalid;
  };

  return Order;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('OrderSearch', OrderSearch);
OrderSearch.$inject = ['Auth', '$resource', 'Config', '$location'];

/** @ngInject */
function OrderSearch(Auth, $resource, Config, $location) {

  var url = Config.getAPIServerURL() + ':participantId/orders/';

  var OrderSearch = $resource(url, { participantId: Auth.getParticipantId() }, {
    getOrders: {
      method: 'get',
    },
  });

  OrderSearch.searchForm = {
    from_date: moment(new Date()).format('YYYY-MM-DD'),
    to_date: moment(new Date()).format('YYYY-MM-DD'),
    from_time: '00:00',
    to_time: '23:59'
  };

  OrderSearch.model = {
    pagination: {},
    orders: {}
  };

  OrderSearch.fetchOrders = function(pageNo) {
    pageNo = pageNo || 1;
    var query = getQueryParameters(pageNo);
    return OrderSearch.getOrders(query, function(data) {
      OrderSearch.model.orders = data.orders;
      processPagination(data.pagination, pageNo);
    }).$promise;
  };

  function getQueryParameters(pageNo) {
    var queryParams = angular.copy(OrderSearch.searchForm) || null;
    var limit = parseInt(OrderSearch.model.entryNumber) || Config.getDefaultPageLimit();

    var query = {
      'size': limit,
      'page': pageNo,
      'participant_id': Auth.getParticipantId(),
      'from-date-time': buildDateTimeString(queryParams.from_date, queryParams.from_time, '00'),
      'to-date-time': buildDateTimeString(queryParams.to_date, queryParams.to_time, '59'),
    };
    if(queryParams.card_last) {
      query['last-four'] = queryParams.card_last;
    }
    if(queryParams.expiration) {
      query.expiry = queryParams.expiration;
    }
    if(queryParams.amount) {
      query.amount = buildAmountString(queryParams.amount);
    }
    return query;
  }

  function processPagination(paginationData, pageNo) {
    OrderSearch.model.pagination.current_page = pageNo;
    OrderSearch.model.pagination.limit = parseInt(OrderSearch.model.entryNumber) || Config.getDefaultPageLimit();
    if(OrderSearch.model.pagination.limit * OrderSearch.model.pagination.current_page > paginationData.total_items) {
      OrderSearch.model.pagination.next = 0;
    } else {
      OrderSearch.model.pagination.next = paginationData.total_items * OrderSearch.model.pagination.current_page;
    }
    OrderSearch.model.pagination.item_count = paginationData.size;
  }

  function buildAmountString(amount) {
    amount = amount || 0;
    return (amount * 100).toFixed(0);
  }

  function buildDateTimeString(date, time, seconds) {
    date = date || moment(new Date()).format('YYYY-MM-DD');
    time = time || '00:00';
    time += ':' + seconds;
    return convertToUtc(date + ' ' + time);
  }

  function convertToUtc(time) {
    if (time) {
      return moment(decodeURIComponent(time), 'YYYY-MM-DD HH:mm:ss').utc()
        .format('YYYY-MM-DDTHH:mm:ss') +
        'Z';
    } else {
      return null;
    }
  }

  OrderSearch.isValid = function(key, value, model) {
    var isFilterValid = false;
    if(model) {
      switch (key) {
        case 'card_last':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^\d{4}$/).test(value);
          break;
        case 'amount':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^-?\d+\.?\d*$/).test(value);
          break;
        case 'expiration':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^(0[1-9]|1[0-2])\/?(\d{2})$/).test(value);
          break;
        case 'from_date':
        case 'to_date':
          isFilterValid = new RegExp(/^(\d{4})\-(0[1-9]|1[0-2])\-(0[1-9]|[12]\d|3[01])$/).test(value);
          break;
        case 'from_time':
        case 'to_time':
          isFilterValid = new RegExp(/^([01]?\d|2[0-3]):[0-5]\d$/).test(value);
          break;
        default:
      }
      model.$valid = isFilterValid;
    }

    return isFilterValid;
  };

  OrderSearch.removeFilters = function(field, form) {
    if(!angular.isArray(field) && form[field]) {
      delete form[field];
      $location.search(field, null);
      if(field === 'from_date' || field === 'to_date') {
        form[field] = moment(new Date()).format('YYYY-MM-DD');
      } else if(field === 'from_time') {
        form[field] = '00:00';
      } else if(field === 'to_time') {
        form[field] = '23:59';
      }
    } else if (angular.isArray(field)) {
      angular.forEach(field, function(obj) {
        if(form[obj]) {
          delete form[obj];
          $location.search(obj, null);
        }
      });
    }
  };

  OrderSearch.resetClick = function(form) {
    angular.forEach(form, function(value, key) {
      OrderSearch.removeFilters(key, form);
    });
    $location.search('page', null);
  };

  function isUndefinedOrEmpty(value) {
    return (value === undefined) || (value === '');
  }

  return OrderSearch;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .factory('EcomPurchases', EcomPurchases);
EcomPurchases.$inject = ['$resource', '$stateParams', 'Config'];

/** @ngInject */
function EcomPurchases($resource, $stateParams, Config) {
  var urlBase = Config.getAPIServerURL();

  var EcomPurchases = $resource(urlBase + 'intent/:intentId/purchases', {}, {
    getByIntentId: {
      method: 'get',
      isArray: true
    },
    submitRefund: {
      method: 'post',
      url: urlBase + 'purchases/:purchaseId/refunds'
    }
  });

  EcomPurchases.model = {
    purchasesForCurrentOrder: []
  };

  EcomPurchases.requestPurchaseRefund = function(purchaseId, refundRequest) {
    return EcomPurchases.submitRefund({
      purchaseId: purchaseId,
    }, refundRequest).$promise;
  };

  EcomPurchases.getPurchasesForIntent = function(intentId) {
    EcomPurchases.model.purchasesForCurrentOrder = [];
    return EcomPurchases.getByIntentId({ intentId: intentId }, function(data) {
      EcomPurchases.model.purchasesForCurrentOrder = data;
    }).$promise;
  };

  return EcomPurchases;
}

'use strict';

/**
 * ErrorHandler module overrides the built in Angular $exceptionHandler service.
 * It implements `exceptionHandler` which leverages the Analytics service
 * to track JS error event in Matomo.
 */
angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('$exceptionHandler', ErrorHandler);

ErrorHandler.$inject = ['$log', '$injector', 'WebAnalytics'];

/** @ngInject */
function ErrorHandler($log, $injector, WebAnalytics) {
  return function exceptionHandler(exception, cause) {
    var $location = $injector.get('$location');
    WebAnalytics.trackJSError($location.url(), exception, cause);
    // forward exception to Angular log output, retaining default behaviour of $exceptionHandler
    $log.error(exception, cause);
  };
}

/**
 * @author z.geddes
 * created on 12.01.2021
 */
'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Event', Event);

Event.$inject = ['$resource', '$stateParams', 'Config', 'Auth', '$location'];

/** @ngInject */
function Event($resource, $stateParams, Config, Auth, $location) {
  var url_events = Config.getAPIServerURL() + ':participantId/events/device/:deviceIdIssuer/:deviceId';
  var url_event_details = Config.getAPIServerURL() + ':participantId/events/:eventId/correlation-id/:correlationId';
  var url_events_by_corid = Config.getAPIServerURL() + ':participantId/events/correlation/:correlationId';

  Event.model = {
    list: [],
    pagination: {},
    currentPage: 1,
    entryNumber: '10'
  };

  Event.resetModel = function () {
    Event.model = {
      list: {},
      pagination: {},
      currentPage: 1,
      entryNumber: '10'
    };
  };

  function getPageLimit() {
    return parseInt(Event.model.entryNumber) || Config.getDefaultPageLimit();
  }

  function getStart(pageNo) {
    return (pageNo - 1) * getPageLimit();
  }

  Event.getEvents = function(device, correlationId, pageNo, perPage) {
    Event.model.currentPage = pageNo || 1;
    Event.model.entryNumber = perPage || '10';

    var query = {
      'start': getStart(Event.model.currentPage),
      'limit': getPageLimit(),
      'correlation_id': correlationId,
      'participantId': Auth.getParticipantName(),
      'deviceIdIssuer': device.device_id_issuer,
      'deviceId': device.terminal_id,
    };

    return $resource(url_events, {
      participantId: '@participantId',
      deviceIdIssuer: '@deviceIdIssuer',
      deviceId: '@deviceId',
    }, {
      get: {
        method: 'get',
      }
    }).get(query).$promise;
  };

  Event.getEventsByCorrelationId = function(pageNo, perPage) {
    Event.model.currentPage = pageNo || 1;
    Event.model.entryNumber = perPage || '10';

    var query = {
      'start': getStart(Event.model.currentPage),
      'limit': getPageLimit(),
      'participantId': Auth.getParticipantName(),
      'correlationId': $location.search().correlation_id,
    };

    return $resource(url_events_by_corid, {
      participantId: '@participantId',
      correlationId: '@correlationId'
    }, {
      get: {
        method: 'get',
      }
    }).get(query).$promise;
  };

  Event.getEventDetails = function(event) {
    var query = {
      'participantId': Auth.getParticipantName(),
      'eventId': event.event_id,
      'correlationId': event.correlation_id_list[0],
    };
    return $resource(url_event_details, {
      participantId: '@participantId',
      eventId: '@eventId',
      correlationId: '@correlationId',
    }, {
      get: {
        method: 'get',
      }
    }).get(query).$promise;
  };

  return Event;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('ExceptionPeriod', ExceptionPeriod);
ExceptionPeriod.$inject = ['$resource', 'Auth', 'Config', '$filter'];

/** @ngInject */
function ExceptionPeriod($resource, Auth, Config, $filter) {

  var url = Config.getAPIServerURL();
  var ExceptionPeriod = $resource(url + ':participantId/exception-periods/:exceptionId', {
    exceptionId: '@exceptionId',
    participantId: '@participantId',
  }, {
    get: {
      method: 'get',
    },
    update: {
      method: 'put',
    },
    delete: {
      method: 'delete',
    },
    create: {
      method: 'post',
    },
  });

  ExceptionPeriod.model = {
    list: {},
    current: {},
    pagination: {},
  };

  ExceptionPeriod.fetch = function(pageNo) {
    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(ExceptionPeriod.model.entryNumber) ||
      Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    ExceptionPeriod.model.currentPage = pageNo;

    var query = {
      'start': start,
      'limit': defaultPageLimit,
      'participantId': Auth.getParticipantName(),
    };

    return ExceptionPeriod.get(query, function(data) {
      ExceptionPeriod.model.list = data.list;
      ExceptionPeriod.model.pagination = data.pagination;
    }).$promise;
  };

  function returnDate(data) {
    data.date = ($filter('date')(data.dateNew, 'yyyy-MM-dd')).toString();
    data.start_time = moment(data.date + 'T00:00:00', 'YYYY-MM-DDTHH:mm:ss').utc().format(
      'YYYY-MM-DDTHH:mm:ss[Z]');
    data.finish_time = moment(data.date + 'T23:59:59', 'YYYY-MM-DDTHH:mm:ss').utc().format(
      'YYYY-MM-DDTHH:mm:ss[Z]');
    return data;
  }

  ExceptionPeriod.save = function(data) {
    data.participantId = Auth.getParticipantName();
    data = returnDate(data);
    if (data.id) {
      return ExceptionPeriod.update({
        'exceptionId': data.id,
      }, data).$promise;
    } else {
      return ExceptionPeriod.create(data).$promise;
    }
  };

  return ExceptionPeriod;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('FeatureFlags', FeatureFlags);
FeatureFlags.$inject = ['$resource', 'Auth', 'Config'];

/** @ngInject */
function FeatureFlags($resource, Auth, Config) {

  var url = Config.getAPIServerURL();

  var FeatureFlags = $resource(url + ':participantName/feature', {
    participantName: '@participantName'
  });

  FeatureFlags.feature_flags = {
    RevenueInspection: false,
    TimeBasedCapping: false,
    ReceiptGeneration: false
  };

  FeatureFlags.values = {};

  FeatureFlags.assignFlags = function () {
    angular.forEach(FeatureFlags.feature_flags, function(data, key) {
      FeatureFlags.feature_flags[key] = FeatureFlags.isFlagEnabled(key);
    });
  }

  FeatureFlags.fetchFeatureFlags = function() {
    return FeatureFlags.get({
      participantName: Auth.getParticipantName()
    }, function(response) {
      FeatureFlags.values = response;
      FeatureFlags.assignFlags();
    }).$promise;
  };

  FeatureFlags.isFlagEnabled = function(flag) {
    if (!FeatureFlags.values[flag] || FeatureFlags.values[flag]==='DEFAULT') {
      return window.__env.feature_flag_defaults && window.__env.feature_flag_defaults[flag]==='ENABLED'
    } else {
      return FeatureFlags.values && FeatureFlags.values[flag]==='ENABLED';
    }
  }

  return FeatureFlags;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Form', Form);

/** @ngInject */
function Form() {
  var Form = {};

  Form.queries = {};

  Form.loading = {
    'hasLoaded': false,
    'error': false,
  };

  Form.invalid = {};

  Form.resetInvalid = function() {
    angular.forEach(Form.invalid, function(i, key) {
      Form.invalid[key] = false;
    });
  };

  Form.isInvalid = function() {
    var invalid = false;
    angular.forEach(Form.invalid, function(val) {
      if (!invalid && val === true) {
        invalid = true;
      }
    });
    return invalid;
  };

  return Form;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Identifier', Identifier);
Identifier.$inject = ['$resource', '$stateParams', 'Auth', 'Config', 'List'];

/** @ngInject */
function Identifier($resource, $stateParams, Auth, Config, List) {

  var url = Config.getAPIServerURL();
  var Identifier = $resource(url + ':participantName/customers/:customerId/identifiers', {
    participantName: '@participantName',
  }, {
    query: {
      method: 'get',
      isArray: true,
    },
  });

  Identifier.model = {
    identifiers: [],
    listHistory: [],
  };

  Identifier.fetchCustomerIdentifiers = function(callback, customerId) {

    return Identifier.query({
      customerId: customerId || $stateParams.customerId,
      participantName: Auth.getParticipantName(),
    }, function(response) {
      Identifier.model.identifiers = response;
      var identifierCount = response.length;
      angular.forEach(response, function(data, index) {
        List.fetchIdentifierLists(data.id).then(function(data) {
          Identifier.model.identifiers[index].lists = data;
          identifierCount--;
          if (identifierCount === 0 && callback) {
            callback();
          }
        });
      });
    }).$promise;
  };

  Identifier.fetchListHistory = function(identifier_id, key) {
    List.getListHistory({
      customerId: $stateParams.customerId,
      identifierId: identifier_id,
      participantName: Auth.getParticipantName(),
    }, function(data) {
      Identifier.model.listHistory[key] = data.filter(
        function(i, pos, arr) {
          return (pos === 0 || i.function !== arr[pos - 1].function || i.action !==
            arr[pos - 1].action);
        }
      );
    });
  };

  return Identifier;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Link', Link);

Link.$inject = ['$resource', 'Auth', 'Config'];

/** @ngInject */
function Link($resource, Auth, Config) {

  var url = Config.getAPIServerURL() + ':participantId';

  var Link = $resource(url + '/access-links/request-link', {
    participantId: '@participantId',
  }, {
    getLink: {
      method: 'post',
    },
  });

  Link.model = {
    allLinks: [],
  };

  Link.fetchLink = function(link_type, day) {
    var expiry = day || 3;
    var data = {
      'link_type': link_type,
      'expires_in': expiry * 86400,
    };
    return Link.getLink({
      participantId: Auth.getParticipantName(),
    }, data, function(data) {
      Link.model.allLinks = data;
    }).$promise;
  };

  return Link;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('List', List);
List.$inject = ['$resource', '$stateParams', 'Auth', 'Config'];

/** @ngInject */
function List($resource, $stateParams, Auth, Config) {

  var url = Config.getAPIServerURL() +
    ':participantName/customers/:customerId/identifiers/:identifierId';
  var List = $resource(url, {
    participantName: '@participantName',
  }, {
    getListEntries: {
      url: url + '/list-entries',
      method: 'get',
      isArray: true,
    },
    getListHistory: {
      url: url + '/list-history',
      method: 'get',
      isArray: true,
    },
    getListEntriesByVaultId: {
      url: Config.getAPIServerURL() + ':participantName/vault/:vaultId/list-entries?function=:function',
      method: 'get'
    },
    addCardToListByVaultId: {
      url: Config.getAPIServerURL() + ':participantName/vault/:vaultId/list-entries',
      method: 'post'
    },
    removeCardFromListByVaultId: {
      url: Config.getAPIServerURL() + ':participantName/vault/:vaultId/list-entries/deny-entries',
      method: 'delete'
    }
  });

  List.model = {
    lists: [],
    pagination: {},
  };

  List.fetchIdentifierLists = function(identifierId, customerId) {
    return List.getListEntries({
      customerId: customerId || $stateParams.customerId,
      participantName: Auth.getParticipantName(),
      identifierId: identifierId,
    }, function(data) {
      List.model.lists = data;
    }).$promise;
  };

  List.getCardListEntries = function(vaultId) {
    return List.getListEntriesByVaultId({
      participantName: Auth.getParticipantName(),
      vaultId: vaultId,
      function: 'DENY'
    }).$promise;
  };

  List.addCardToList = function(vaultId, request) {
    var params = {
      participantName: Auth.getParticipantName(),
      vaultId: vaultId,
    };

    return List.addCardToListByVaultId(params, request).$promise;
  };

  List.removeCardFromList = function(vaultId) {
    var params = {
      participantName: Auth.getParticipantName(),
      vaultId: vaultId
    };

    return List.removeCardFromListByVaultId(params).$promise;
  };

  return List;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('OrganiseData', OrganiseData);

OrganiseData.$inject = ['Utils', '$translate', '$filter'];

/** @ngInject */
function OrganiseData(Utils, $translate, $filter) {
  function arrayHasItem(id, arr) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].id === id) {
        return true;
      }
    }
    return false;
  }

  function getDeclineReason(code, acquirerCode, scheme, prefix) {
    if(code==='UNKNOWN') {
      return '';
    }

    prefix = prefix===undefined ? ' - ' : prefix;
    acquirerCode = acquirerCode || 'VA';

    var translateKey = acquirerCode + '.' + scheme + '.' + code;
    var translation = $translate.instant(translateKey);
    if(scheme && (translation !== translateKey && translation !== 'Translation text missing')) {
      return prefix + translation;
    }

    translateKey = acquirerCode + '.' + code;
    translation = $translate.instant(translateKey);
    return prefix + (translation!==translateKey ? translation : $translate.instant('UNKNOWN'));
  }

  return {
    backupData: function(data) {
      return JSON.parse(JSON.stringify(data));
    },
    fillEmptyDateKeys: function(arr, startDate, endDate, format) {
      var newformat = format || 'YYYY-MM-DD';
      var results = [];
      var date = moment(startDate);
      while (date.isSameOrBefore(endDate)) {
        var dateString = !format ? date.format(newformat) : $filter('date')(date.toDate(), 'shortDate');

        if (!arr[dateString]) {
          results[dateString] = [];
        } else {
          results[dateString] = arr[dateString];
        }
        date.add(1, 'days');
      }
      return results;
    },
    getDataTable: function(data, fn, selectedFilters, selectedPrice, fieldName, groupKey) {
      var temp = Utils.groupBy(data, function(c) {
        // TODO: remove the c.submit_date once all analytics data has been updated to use 'date' or a key
        return !!groupKey ? c[groupKey] : moment(c.submit_date).format('YYYY-MM-DD');
      });
      var groupByDateResults = angular.equals(temp, {}) ?
        {} :
        this.fillEmptyDateKeys(temp, selectedFilters.startDate, selectedFilters.endDate);
      return fn(groupByDateResults, selectedFilters, selectedPrice, fieldName);
    },
    sortData: function(groupByDateResults, selectedFilters) {
      return Object.keys(groupByDateResults).map(function(dateKey) {
        var eachDayData = [];
        eachDayData.push(new Date(dateKey));

        selectedFilters.filterOptions.map(function(field) {
          var total = groupByDateResults[dateKey].map(function(f) {
            return f[field.id];
          });
          if (total.length > 0) {
            total = total.reduce(Utils.getSum);
          } else {
            total = 0;
          }
          eachDayData.push(total);
        });

        return eachDayData;
      });
    },

    groupByProducts: function(groupByDateResults, selectedFilters, selectedPrice, fieldName) {
      return Object.keys(groupByDateResults).map(function(dateKey) {
        var eachDayData = [];
        eachDayData.push(new Date(dateKey));

        var groupByAttributesResult = Utils.groupBy(groupByDateResults[dateKey], function(c) {
          return c[fieldName];
        });

        selectedFilters.products.map(function(obj) {
          var total = 0;
          if (groupByAttributesResult[obj.id]) {
            total = groupByAttributesResult[obj.id].map(function(o) {
              return o[selectedPrice];
            }).reduce(Utils.getSum);
          }
          return eachDayData.push(total);
        });
        return eachDayData;
      });
    },

    filterData: function(data, key, e) {
      return data.filter(function(s) {
        if (angular.isArray(e)) {
          return e.indexOf(s[key]) !== -1;
        } else {
          return s[key] === e;
        }
      });
    },

    filterOutData: function(data, keys, value) {
      return data.filter(function(s) {
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (s[key] === value) {
            return false;
          }
        }
        return true;
      });
    },

    getDataTableToMap: function(dataTemporary, ignoreColumnIds) {
      // dataTemporary is a double dimensional array (table data), we need to transform
      // it to a map that contains key(the column label) with array of values (values of the column)
      var seriesData = {};
      var seriesLabels = [];
      dataTemporary.map(function(row) {
        Object.keys(row).forEach(function(property) {
          if (ignoreColumnIds.indexOf(property) === -1) {
            if (!seriesData[property]) {
              seriesData[property] = [];
              seriesLabels.push(property);
            }
            seriesData[property].push(row[property]);
          }
        });
      });

      return {'labels': seriesLabels, 'data': seriesData};
    },

    fillEmptyDateKeysWeekly: function(arr, startDate, endDate, format) {
      format = format || 'YYYY-MM-DD';
      var results = [];
      var date = moment(startDate);
      while (date.isSameOrBefore(endDate)) {
        var dateString = date.format(format);
        if (!arr[dateString]) {
          results[dateString] = [];
        } else {
          results[dateString] = arr[dateString];
        }
        date.add(7, 'days');
      }
      return results;
    },

    sortDataWeekly: function(groupByWeekResults, selectedFilters) {
      return Object.keys(groupByWeekResults).map(function(weekKey) {
        var eachDayData = [];
        eachDayData.push(weekKey);

        selectedFilters.filterOptions.map(function(field) {
          var total = groupByWeekResults[weekKey].map(function(f) {
            return f[field.id];
          });
          if (total.length > 0) {
            total = total.reduce(Utils.getSum);
          } else {
            total = 0;
          }
          eachDayData.push(total);
        });

        return eachDayData;
      });
    },

    getDataTableWeekly: function(data, fn, selectedFilters, selectedPrice, fieldName, groupKey) {
      var temp = Utils.groupBy(data, function(c) {
        // TODO: remove the c.submit_date once all analytics data has been updated to use 'date' or a key
        return !!groupKey ? moment(c[groupKey]).format('YYYY-MM-DD') : moment(c.submit_date).format('YYYY-MM-DD');
      });
      var groupByDateResults = angular.equals(temp, {}) ?
        {} :
        this.fillEmptyDateKeysWeekly(temp, selectedFilters.startDate, selectedFilters.endDate);
      return fn(groupByDateResults, selectedFilters, selectedPrice, fieldName);
    },

    getAvailableSchemeOptions: function(detailData) {
      var availableSchemes = [];
      detailData.forEach(function(data) {
        if (data.scheme && !arrayHasItem(data.scheme, availableSchemes)) {
          availableSchemes.push({
            label: (data.scheme === 'UNKNOWN' ? $translate.instant('ANALYSIS.TRANSACTIONS.UNKNOWN') : data.scheme),
            id: data.scheme,
          });
        }
      });
      availableSchemes.sort(function(a, b) {
        return a.label.localeCompare(b.label);
      });
      availableSchemes.unshift({
        label: $translate.instant('ANALYSIS.TRANSACTIONS.ALL-SCHEMES'),
        id: '',
      });
      return availableSchemes;
    },

    getAvailableDeclineReasons: function(detailData) {
      var availableDeclineReasons = [];
      detailData.forEach(function(data) {
        if(data.decline_code) {
          var id = data.decline_code;
          if(!arrayHasItem(id, availableDeclineReasons)) {
            var label = data.decline_code + getDeclineReason(data.decline_code, data.acquirer_code, data.scheme);
            availableDeclineReasons.push({
              id: id,
              label: label,
              scheme: data.decline_scheme
            });
          }
        }
      });
      availableDeclineReasons.sort(function(a, b) {
        return a.label.localeCompare(b.label);
      });
      return availableDeclineReasons;
    },

    getAvailableFareTypeOptions: function(detailData) {
      var availableFareTypes = [];
      detailData.forEach(function(data) {
        if (data.fare_type && !arrayHasItem(data.fare_type, availableFareTypes)) {
          availableFareTypes.push({
            label: (data.fare_type === 'UNKNOWN' ? $translate.instant('ANALYSIS.TRANSACTIONS.UNKNOWN') : data.fare_type),
            id: data.fare_type,
          });
        }
      });
      availableFareTypes.sort(function(a, b) {
        return a.label.localeCompare(b.label);
      });
      return availableFareTypes;
    },

    getAvailableRequestTypeOptions: function(detailData) {
      var availableRequestTypes = [];
      detailData.forEach(function(data) {
        if (data.request_type && !arrayHasItem(data.request_type, availableRequestTypes)) {
          availableRequestTypes.push({
            label: (data.request_type === 'UNKNOWN' ? $translate.instant('ANALYSIS.TRANSACTIONS.UNKNOWN') : data.request_type),
            id: data.request_type,
          });
        }
      });
      availableRequestTypes.sort(function(a, b) {
        return a.label.localeCompare(b.label);
      });
      return availableRequestTypes;
    },

    getDeclineReason: getDeclineReason
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .factory('parseDate', parseDate);

/** @ngInject */
function parseDate() {
  var parseDate = {};

  parseDate.parseDate = function (v, s) {
  // turns string into date object
    var date = {
      month: '',
      year: '',
      yearInt: '',
      numLength: ''
    };
    date.month = v.substring(0, 2);
    if (s === 'dir') {
      date.year = v.substring(3, 5);
    } else {
      date.year = v.substring(2, 4);
    }
    date.yearInt = parseInt(date.year, 10);

    return date;
  };


  parseDate.getMonths = function () {
    var monthArray = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    return monthArray;
  };

  return parseDate;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Participant', Participant);
Participant.$inject = ['$resource', 'Auth', 'Config', 'FeatureFlags', '$filter'];

/** @ngInject */
function Participant($resource, Auth, Config, FeatureFlags, $filter) {

  var url = Config.getAPIServerURL();

  var Participant = $resource(url + ':participantName', {
    participantName: '@participantName',
    userId: '@userId',
  }, {
    getParticipant: {
      method: 'get',
    },
    updateParticipant: {
      method: 'put',
    },
    getAvailable: {
      method: 'get',
      url: url + 'users/:userId/participants',
      isArray: true,
    },
  });

  Participant.model = {
    currentParticipant: {},
    invoiceConfigs: {},
    availableParticipants: [],
  };

  Participant.fetchCurrentParticipant = function() {
    return FeatureFlags.fetchFeatureFlags().catch(function(error) {
    }).then(function() {
      return Participant.getParticipant({
        participantName: Auth.getParticipantName(),
      }, function(data) {
        Participant.model.currentParticipant = data;
        Participant.model.invoiceConfigs = data.config.product_config.receipt_configs;
      }).$promise;
    });
  };

  Participant.updateCurrentParticipant = function(data) {
    return Participant.updateParticipant({
      participantName: Auth.getParticipantName(),
    }, data);
  };

  Participant.fetchAvailableParticipants = function() {
    return Participant.getAvailable({
      userId: Auth.currentUser.profile.user_id,
    }, function(data) {
      Participant.model.availableParticipants = data;
    }).$promise;
  };

  Participant.selectedDateFormatForReceipt = function(form) {
    angular.forEach(form, function(field, key) {
      if (field) {
        if (key === 'fromTime') {
          Participant.model.invoiceConfigs.fromTime = $filter('convertToUtc')(moment(field).startOf('day'));
        }
        if (key === 'toTime') {
          Participant.model.invoiceConfigs.toTime = $filter('convertToUtc')(moment(field).endOf('day'));
        }
      }
    });
  };

  Participant.isAnyDateSelected = function(form) {
    return form.fromTime || form.toTime;
  }

  Participant.calculateTotalAmount = function(transactions) {
    Participant.model.invoiceConfigs['total_amount'] = $filter('calculateTotalAmount')(transactions);
  }

  return Participant;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Permission', Permission);
Permission.$inject = ['$resource', '$stateParams', 'Auth', 'Config'];

/** @ngInject */
function Permission($resource, $stateParams, Auth, Config) {

  var url = Config.getAPIServerURL() + 'permissions/user-permissions';
  var Permission = $resource(url, null, {
    getPermissions: {
      method: 'get',
    },
  });

  Permission.model = {
    list: {},
  };

  Permission.fetchPermissions = function() {
    return Permission.getPermissions(function(data) {
      Permission.model.list = data;
    }).$promise;
  };

  return Permission;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('PricingPeriod', PricingPeriod);
PricingPeriod.$inject = ['$resource', '$stateParams', 'Auth', 'Config'];

/** @ngInject */
function PricingPeriod($resource, $stateParams, Auth, Config) {

  var url = Config.getAPIServerURL();
  var PricingPeriod = $resource(url + ':participantId/pricing-periods/:periodId', {
    periodId: '@periodId',
    participantId: '@participantId',
  }, {
    get: {
      method: 'get',
    },
    update: {
      method: 'put',
    },
    delete: {
      method: 'delete',
    },
    create: {
      method: 'post',
    },
  });

  PricingPeriod.model = {
    list: {},
    current: {},
    pagination: {},
  };

  PricingPeriod.fetch = function(pageNo) {
    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(PricingPeriod.model.entryNumber) ||
      Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    PricingPeriod.model.currentPage = pageNo;

    var query = {
      'start': start,
      'limit': defaultPageLimit,
      'participantId': Auth.getParticipantName(),
    };

    return PricingPeriod.get(query, function(data) {
      PricingPeriod.model.list = data.list;
      PricingPeriod.model.pagination = data.pagination;
    }).$promise;
  };

  PricingPeriod.save = function(data) {
    data.participantId = Auth.getParticipantName();
    if (data.id) {
      return PricingPeriod.update({
        'periodId': data.id,
      }, data).$promise;
    } else {
      return PricingPeriod.create(data).$promise;
    }
  };

  return PricingPeriod;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Refund', Refund);
Refund.$inject = ['$resource', '$stateParams', 'Auth', 'Config', '$location'];

/** @ngInject */
function Refund($resource, $stateParams, Auth, Config, $location) {
  var url = Config.getAPIServerURL() + ':participantName';
  var Refund = $resource(url, {
    participantName: '@participantName',
    customerId: '@customerId',
    refundId: '@refundId',
  }, {
    getCustomerRefund: {
      url: url + '/customers/:customerId/refunds',
      method: 'get',
      isArray: true,
    },
    updateCustomerRefund: {
      url: url + '/refunds/:refundId',
      method: 'put',
    },
    addCustomerRefund: {
      url: url + '/customers/:customerId/refunds',
      method: 'post',
    },
    getparticipantRefund: {
      url: url + '/refunds',
      method: 'get',
    },
  });

  Refund.model = {
    currentRefund: {},
    refundHistory: {},
    pagination: {},
    list: [],
  };
  Refund.invalid = {};
  Refund.refundNotificationMessage = {};

  Refund.getRefundHistory = function() {
    return Refund.getCustomerRefund({
      participantName: Auth.getParticipantName(),
      customerId: $stateParams.customerId,
    }, function(data) {
      Refund.model.refundHistory = data;
    }).$promise;
  };

  Refund.approveRequest = function() {
    var query = {
      participantName: Auth.getParticipantName(),
      refundId: Refund.model.currentRefund.id,
    };
    Refund.model.currentRefund = angular.extend({
          issuer: Auth.currentUser.profile.name,
        }, Refund.model.currentRefund);

    return Refund.updateCustomerRefund(query, Refund.model.currentRefund).$promise;
  };

  Refund.validateRefundAmountEmpty = function() {
    var valid = false;
    if (Refund.model.currentRefund.refund_amount) {
      valid = true;
    }
    Refund.invalid.refundAmount = !valid;
    return valid;
  };

  Refund.validateRefundAmount = function() {
    var regEx = /^\d+(\.\d{1,2})*$/;
    var refundAmount = Refund.model.currentRefund.refund_amount + '';
    var valid = regEx.test(refundAmount);
    if (valid) {
      var refundAmountNum = parseInt(refundAmount);
      valid = refundAmountNum <= Refund.model.currentRefund.amount;
    }
    Refund.invalid.refundAmount = !valid;
    return valid;
  };

  Refund.validateReason = function() {
    var valid = false;
    if (Refund.model.currentRefund.reason) {
      var reason = Refund.model.currentRefund.reason;
      valid = reason.trim().length > 0;
    }
    Refund.invalid.reason = !valid;
    return valid;
  };

  Refund.validateReasonContents = function() {
    var reasonInvalid = false;
    var issuerCommentInvalid = false;
    var cardRegex = /(\d\s?){15,}/;
    if (Refund.model.currentRefund.reason) {
      var reason = Refund.model.currentRefund.reason;
      reasonInvalid = cardRegex.test(reason);
    }
    if (Refund.model.currentRefund.issuer_comment) {
      var issuerComment = Refund.model.currentRefund.issuer_comment;
      issuerCommentInvalid = cardRegex.test(issuerComment);
    }
    Refund.invalid.reason = reasonInvalid;
    Refund.invalid.issuer_comment = issuerCommentInvalid;
    var valid = !(reasonInvalid || issuerCommentInvalid);
    return valid;
  };

  Refund.resetValidation = function() {
    Refund.invalid.reason = false;
    Refund.invalid.refund_amount = false;
    Refund.model.currentRefund.reason = '';
  };

  Refund.refundAmountHandler = function(val) {
    val = angular.isString(val) ? val : val + '';
    var regEx = /(\d+)(\.)*(\d{0,2})/;
    var matches = val.match(regEx);
    if (!matches) {
      Refund.model.currentRefund.refund_amount = '';
      return;
    }
    var firstDigit = matches[1];
    var dot = matches[2];
    var secondDigit = matches[3];

    var refundAmount = 0;
    if (matches.length >= 2) {
      refundAmount = firstDigit;
    }
    if (matches.length >= 3 && dot) {
      refundAmount += '.';
    }
    if (matches.length >= 4 && secondDigit) {
      refundAmount += secondDigit;
    }
    Refund.model.currentRefund.refund_amount = refundAmount;
  };

  // query Parameter
  // funding_source_id: string
  // transaction_amount: number
  // refund_amount: number
  // reason: string
  // issuer: string
  Refund.addRefund = function(data) {
    var form = angular.extend({
      issuer: Auth.currentUser.profile.name,
    }, data);

    return Refund.addCustomerRefund({
      customerId: $stateParams.customerId || data.customer_id,
      participantName: Auth.getParticipantName(),
    }, form).$promise;
  };

  Refund.fetchRefunds = function(pageNo, incompleteTrip) {
    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(Refund.model.entryNumber) || Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    Refund.model.currentPage = pageNo;

    var query = {
      start: start,
      limit: defaultPageLimit,
      participantName: Auth.getParticipantName(),
    };

    query = angular.extend(query, {
      'initiator': $location.search().initiator,
      'approval-status': $location.search().status,
    });

    if (incompleteTrip) {
      angular.extend(query, {
        'approval-status': 'AWAITING',
      });
    }

    return Refund.getparticipantRefund(query, function(data) {
      Refund.model.list = data.refunds;
      Refund.model.pagination = data.pagination;
    }).$promise;
  };

  return Refund;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('RevenueInspectionUser', RevenueInspectionUser);
RevenueInspectionUser.$inject = ['$resource', 'Auth', 'Config', '$location'];

/** @ngInject */
function RevenueInspectionUser($resource, Auth, Config, $location) {

  var url = Config.getAPIServerURL() + ':participantId/revenueinspection/users/:userId';

  var RevenueInspectionUser = $resource(url, {
    userId: '@userId',
    participantId: '@participantId',
  }, {
      getAllUsers: {
        method: 'get',
    },
      deleteTheUser: {
        method: 'delete',
     },
     createAuser: {
       method: 'post',
       data: '@data',
     },
    changeUserPassword: {
      method: 'patch',
    },
  });

  RevenueInspectionUser.model = {
    allUsers: [],
    newUser: {},
    user: {},
    pagination: {},
    selectedAccount: [],
    participantAccounts: {},
  };
  RevenueInspectionUser.invalid = {};

  RevenueInspectionUser.getUsers = function(pageNo) {
    pageNo = pageNo || 1;
    var defaultPageLimit = parseInt(RevenueInspectionUser.model.entryNumber) || Config.getDefaultPageLimit();
    var start = (pageNo - 1) * defaultPageLimit;
    RevenueInspectionUser.model.currentPage = pageNo;

    var query = {
      start: start,
      limit: defaultPageLimit,
      participantId: Auth.getParticipantId(),
      group: $location.search().participant,
    };

    return RevenueInspectionUser.getAllUsers(query, function(data) {
      data.list.sort(function(a, b) {
        return a.email.localeCompare(b.email);
      });
      RevenueInspectionUser.model.allUsers = data.list;
      RevenueInspectionUser.model.pagination = data.pagination;

    }).$promise;
  };

  RevenueInspectionUser.createUser = function() {

    var new_user_data = {
      'participantId': Auth.getParticipantName(),
      'email': RevenueInspectionUser.model.newUser.email,
      'password': RevenueInspectionUser.model.newUser.password,
      'email_verified': false,
      'app_meta_data': {
        participants: [Auth.getParticipantId()],
      },
    };

     return RevenueInspectionUser.createAuser(new_user_data).$promise;
  };

  RevenueInspectionUser.deleteUser = function(id) {
    return RevenueInspectionUser.deleteTheUser({
      userId: id,
      participantId: Auth.getParticipantName(),
    }).$promise;
  };

  RevenueInspectionUser.updateUser = function(data) {
    data = angular.extend(data, {
      participantId: Auth.getParticipantName(),
    });
    return RevenueInspectionUser.changeUserPassword(data, function(d) {
      return d;
    }).$promise;
  };


  return RevenueInspectionUser;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('RightBar', RightBar);
RightBar.$inject = ['$resource', 'Config', '$rootScope'];

/** @ngInject */
function RightBar($resource, Config, $rootScope) {
  var url = Config.getAPIServerURL();

  var RightBar = $resource(url + 'users/:userId/participants', {
    userId: '@userId',
  }, {
    getAvailable: {
      method: 'get',
      isArray: true,
    },
  });

  RightBar.model = {
    participants: [],
  };

  RightBar.parseAccounts = function(arr) {
    var children = [];
    for (var i = 0; i < arr.length; i++) {
      arr[i].children = [];
      if (!arr[i].parent) {
        children.push(arr[i]);
        arr.splice(i, 1);
        i--;
      }
    }

    var childCount = 0;

    for (i = 0; i < children.length; i++) {
      var child = children[i];
      if (typeof child.parent_name !== 'undefined') {
        for (var j = 0; j < arr.length; j++) {
          if (child.parent_name === arr[j].participant_id) {
            arr[j].children.push(child);
            children.splice(i, 1);
            i--;
            childCount++;
            break;
          }
        }
      }
    }

    arr = arr.concat(children);

    $rootScope.availableParticipantCount = arr.length + childCount;

    arr.sort(function(a, b) {
      return a.id.localeCompare(b.id);
    });
    for (i = 0; i < arr.length; i++) {
      arr[i].children.sort(function(a, b) {
        return a.id.localeCompare(b.id);
      });
    }

    return arr;
  };

  RightBar.resetFilteredParticipants = function() {
    angular.forEach(RightBar.model.participants, function(participant) {
      participant.hide = false;
      angular.forEach(participant.children, function(child) {
        child.hide = false;
      });
    });
  };

  RightBar.loadAvailableParticipants = function(userId) {
    return RightBar.getAvailable({
      userId: userId,
    }, function(data) {
      RightBar.model.participants = RightBar.parseAccounts(data);
    }).$promise;
  };

  return RightBar;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Statement', Statement);
Statement.$inject = ['$resource', 'Auth', 'Config', '$filter', '$translate'];

/** @ngInject */
function Statement($resource, Auth, Config, $filter, $translate) {

  var url = Config.getAPIServerURL();
  var endPoint = ':participantName/customers/:customerId/statement';
  var Statement = $resource(url + endPoint, {
    participantName: '@participantName',
  });

  Statement.flattenObject = function(data) {
    var customerTransaction = [];
    angular.forEach(data.aggregations, function(aggregation) {
      var tap = aggregation.micropayments[0].taps[0];
      var transaction = {};
      transaction[($translate.instant('TRANSACTIONS.LOCATION')).toUpperCase()] = tap.location;
      transaction[($translate.instant('TRANSACTIONS.TIME')).toUpperCase()] = $filter('date')(tap.tap_time, 'medium');
      transaction[($translate.instant('TRANSACTIONS.AMOUNT')).toUpperCase()] = $filter('isoCurrency')(aggregation.amount, aggregation.currency);
      if (!_.isEmpty(aggregation.refunds)) {
        var refunds = aggregation.refunds[0];
        transaction[($translate.instant('TRANSACTIONS.REFUNDAMOUNT')).toUpperCase()] = $filter('isoCurrency')(refunds.amount, refunds.currency);
        transaction[($translate.instant('TRANSACTIONS.REFUNDTIME')).toUpperCase()] = $filter('date')(refunds.updated_time, 'medium');
        transaction[($translate.instant('TRANSACTIONS.REFUNDSTATUS')).toUpperCase()] = $translate.instant('CUSTOMERS.CUSTOMER-SUMMARY.'+ refunds.settlement_result.status || $filter('removeSpacesAndLowerCase')('SENT FOR SETTLEMENT'));
        ;
      } else {
        transaction[($translate.instant('TRANSACTIONS.REFUNDAMOUNT')).toUpperCase()] = '-';
        transaction[($translate.instant('TRANSACTIONS.REFUNDTIME')).toUpperCase()] = '-';
        transaction[($translate.instant('TRANSACTIONS.REFUNDSTATUS')).toUpperCase()] = '-';
      }
      customerTransaction.push(transaction);
    });
    return customerTransaction;
  };

  Statement.getCustomerStatement = function(customerId) {
    return Statement.get({
      customerId: customerId,
      participantName: Auth.getParticipantName(),
    }, function(data) {
      return data;
    }).$promise;
  };

  return Statement;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Transaction', Transaction);
Transaction.$inject = ['$resource', 'Auth', 'Config', '$location', '$filter'];

/** @ngInject */
function Transaction($resource, Auth, Config, $location, $filter) {

  var url = Config.getAPIServerURL() + ':participantId';
  var Transaction = $resource(url + '/transactions', {
    participantId: '@participantId',
  }, {
    getTransactions: {
      method: 'get',
    },
  });

  Transaction.model = {
    allTransactions: [],
    limit: 10,
  };

  Transaction.searchForm = {};

  Transaction.fetchTransactions = function(refundable, queryParams) {
    queryParams = queryParams || $location.search();
    Transaction.model.limit = Transaction.model.limit || 10;
    var query = {
      'participantId': Auth.getParticipantName(),
      'limit': Transaction.model.limit,
    };

    query = angular.extend(query, {
      'transaction-amount': queryParams.amount,
      'start-time': $filter('convertToUtc')(decodeURIComponent(queryParams.fromTime)),
      'end-time': $filter('convertToUtc')(decodeURIComponent(queryParams.toTime)),
    });

    if (queryParams.cardBin && queryParams.pan) {
      query = angular.extend(query, {
        'truncated-pan': queryParams.cardBin + '-' + queryParams.pan,
      });
    }

    if (queryParams.expiryYear && queryParams.expiryMonth) {
      query = angular.extend(query, {
        'card-expiry': queryParams.expiryYear + queryParams.expiryMonth,
      });
    }

    if (refundable === 'refundable') {
      query = angular.extend(query, {
        'refundable': true,
      });
    }
    return Transaction.getTransactions(query, function(data) {
      Transaction.model.allTransactions = data.list;
      Transaction.model.limit = data.limit;
    }).$promise;
  };

  return Transaction;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('TransactionSearch', TransactionSearch);
TransactionSearch.$inject = ['Auth', '$resource', 'Config', '$location', 'TRANSACTION_FILTERS'];

/** @ngInject */
function TransactionSearch(Auth, $resource, Config, $location, TRANSACTION_FILTERS) {

  var url = Config.getAPIServerURL() + ':participantId/search/transaction/';
  var TransactionSearch = $resource(url + 'aggregations', {}, {
    getTransactions: {
      method: 'get',
    },
    getCharge: {
      method: 'get',
      url: url + 'aggregation/:aggregationId',
    },
    getStatusHistory: {
      url: url + 'aggregation/:aggregationId/statushistory',
      method: 'get',
    },
    getTrips: {
      url: url +'micropayments',
      method: 'get',
    }
  });

  TransactionSearch.searchForm = {};

  TransactionSearch.model = {
    chargeList: [],
    tripList: [],
    pagination: {},
    dataStatus: [],
    selectedTransaction: null,
  };

  function getCardExpiry(queryParams) {
    var expiry = null;
    if(queryParams.expiration) {
      expiry = (queryParams.expiration).substring(3, 5) + (queryParams.expiration).substring(0, 2);
    }
    return expiry;
  }

  TransactionSearch.getAggregationStatusHistory = function(aggregationId) {
    return TransactionSearch.getStatusHistory({
      aggregationId: aggregationId,
      participantId: Auth.getParticipantName()
    }, function(data) {
      TransactionSearch.model.dataStatus = isInitiallyDeclined(data);
    }).$promise;
  };

  TransactionSearch.fetchTrips = function(pageNo, queryParams) {
    pageNo = pageNo || 1;
    var query = getQueryParameters(pageNo, queryParams);
    return TransactionSearch.getTrips(query, function(data) {
      TransactionSearch.model.tripList = data.list;
      TransactionSearch.model.pagination = data.pagination;
    }).$promise;
  };

  TransactionSearch.fetchTransactions = function(pageNo, queryParams) {
    pageNo = pageNo || 1;
    var query = getQueryParameters(pageNo, queryParams);

    return TransactionSearch.getTransactions(query, function(data) {
      TransactionSearch.model.chargeList = data.list;
      TransactionSearch.model.pagination = data.pagination;
    }).$promise;
  };

  TransactionSearch.selectTrip = function (trip) {
    TransactionSearch.getCharge({
      aggregationId: trip.aggregation_id,
      participantId: Auth.getParticipantName()
    }, function(data) {
      TransactionSearch.selectCharge(data);
    });
  };

  TransactionSearch.selectCharge = function(charge) {
    TransactionSearch.model.selectedTransaction = charge;
    TransactionSearch.getAggregationStatusHistory(charge.id);
  };

  TransactionSearch.hasAmountError = function(form, searchForm, amount) {
    return !TransactionSearch.isValid('amount', form.minAmount, searchForm[amount]) || !isAmountValid(form, searchForm[amount]);
  };

  TransactionSearch.isValid = function(key, value, model) {
    var isFilterValid = false;
    if(model) {
      switch (key) {
        case 'card_first':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^[0-9]{6,6}$/).test(value);
          break;
        case 'card_last':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^[0-9]{4,4}$/).test(value);
          break;
        case 'expiration':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/).test(value);
          break;
        case 'amount':
          isFilterValid = isUndefinedOrEmpty(value) || new RegExp(/^-?\d+\.?\d*$/).test(value);
          break;
        default:
      }
      model.$valid = isFilterValid;
    }

    return isFilterValid;
  };

  TransactionSearch.removeFilters = function(field, form) {
    if(!angular.isArray(field) && form[field]){
      delete form[field];
      $location.search(field, null);
    }else if (angular.isArray(field)) {
      angular.forEach(field, function(obj) {
        if(form[obj]) {
          delete form[obj];
          $location.search(obj, null);
        }
      });
    }
  };

  TransactionSearch.setForms = function(form, query) {
    if(angular.equals(query, {})){
      TransactionSearch.searchForm = {};
      form = {};
    }else {
      angular.forEach($location.search(), function(field, key) {
        form[key] = field;
        TransactionSearch.searchForm[key] = field;
      });
    }
  };

  TransactionSearch.setFiltersOnUrl = function(form) {
    angular.forEach(form, function(field, key) {
      $location.search(key, (field || null));
    });
    $location.search('page', null);
  };

  function isUndefinedOrEmpty(value) {
    return (value === undefined) || (value === '');
  }

  function isAmountValid(form, model) {
    var min = form.minAmount;
    var max = form.maxAmount;
    var isValid = isUndefinedOrEmpty(min) || isUndefinedOrEmpty(max) || (min && max && (parseFloat(min) <= parseFloat(max)));
    if(model) {
      model.$valid = isValid;
    }

    for (var key in TransactionSearch.searchForm) {
      if(key === 'minAmount'  && !isValid) {
        delete TransactionSearch.searchForm.minAmount;
      }
      if(key === 'maxAmount'  && !isValid) {
        delete TransactionSearch.searchForm.maxAmount;
      }
    }
    return isValid;
  }

  function isInitiallyDeclined(data) {
    var hasDeclined = false;
    angular.forEach(data.aggregation_history, function(status){
      if(status.state === 'DECLINED') {
        hasDeclined = true;
      }
    });
    var initiallyDeclined = (hasDeclined && data.aggregation_history[0].state === 'AUTHORISED') ? true : false;
    return initiallyDeclined;
  }

  function getQueryParameters(pageNo, queryParams) {
    queryParams = queryParams || $location.search();
    return {
      'page-size': TransactionSearch.model.entryNumber,
      'page-number': pageNo,
      'card-first': queryParams.card_first,
      'card-last': queryParams.card_last,
      'card-expiry': getCardExpiry(queryParams),
      'card-type': queryParams.card_type,
      'form-factor': TRANSACTION_FILTERS[queryParams.form_factor],
      'amount': queryParams.amount,
      'from-date': getTime(queryParams.fromTime, ' 00:00'),
      'to-date': getTime(queryParams.toTime, ' 23:59'),
      'settlement-status': queryParams.settlement_status,
      'payment-status': queryParams.charge_status,
      'sort-column': $location.search().order,
      'min-amount': queryParams.minAmount,
      'max-amount': queryParams.maxAmount,
      'sort-order': getSortOrder(),
      'route-id': queryParams.route,
      'terminal-id': queryParams.terminal_id,
      'participantId': Auth.getParticipantName()
    };
  }

  function getSortOrder() {
    var order = null;
    if($location.search().reverse === 'false') {
      order = 'DESC';
    }else {
      order = $location.search().reverse ? 'ASC' : 'DESC';
    }
    return order;
  }

  function getTime(time, hour) {
    return time ? convertToUtc(moment(time, 'YYYY-MM-DD').format('DD/MM/YYYY') + hour) : null;
  }

  function convertToUtc(time) {
    if (time) {
      return moment(decodeURIComponent(time), 'DD/MM/YYYY HH:mm').utc()
        .format('YYYY-MM-DDTHH:mm:ss') +
        'Z';
    } else {
      return null;
    }
  }

  TransactionSearch.getEarliestFromDate = function() {
    // current earliest date is 6 months ago
    return moment().subtract(6, 'months').format('YYYY-MM-DD');
  };

  return TransactionSearch;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('User', User);
User.$inject = ['$resource', 'Auth', 'Config', '$location', 'CUSTOM_MERCHANT_CONFIG'];

/** @ngInject */
function User($resource, Auth, Config, $location, CUSTOM_MERCHANT_CONFIG) {

  var url = Config.getAPIServerURL() + ':participantId/users/:userId';

  var User = $resource(url, {
    userId: '@userId',
    participantId: '@participantId',
  }, {
    getAllUsers: {
      method: 'get',
    },
    getUser: {
      method: 'get',
    },
    deleteTheUser: {
      method: 'delete',
    },
    createAuser: {
      method: 'post',
      data: '@data',
    },
    changeUserPassword: {
      method: 'patch',
    },
  });

  User.model = {
    allUsers: [],
    newUser: {},
    user: {},
    pagination: {},
    selectedAccount: [],
    participantAccounts: {},
  };
  User.invalid = {};

  User.fetchUser = function (userId) {
    return User.getUser({
      participantId: Auth.getParticipantName(),
      userId: userId,
    }, function (data) {
      User.model.user = data;
    }).$promise;
  };

  User.updateUser = function (data) {
    data = angular.extend(data, {
      participantId: Auth.getParticipantName(),
    });
    if(isSubdomainValidCustomDomain(CUSTOM_MERCHANT_CONFIG.subdomain, CUSTOM_MERCHANT_CONFIG.CUSTOM_SUBDOMAINS) === true ){
      data.app_meta_data.brandedPortal = CUSTOM_MERCHANT_CONFIG.subdomain;
    }

    return User.changeUserPassword(data, function (d) {
      return d;
    }).$promise;
  };

  User.getUsers = function () {
    var query = {
      participantId: Auth.getParticipantName(),
      group: $location.search().participant,
    };

    return User.getAllUsers(query, function (data) {
      for (var i = 0; i < data.list.length; i++) {
        if (data.list[i].app_meta_data && data.list[i].app_meta_data.participants) {
          var participants = data.list[i].app_meta_data.participants;
          for (var metadata in participants) {
            if (participants[metadata].name === Auth.getParticipantName() && data.list[i]) {
              data.list[i].participants = {
                'role': participants[metadata].role,
                'name': Auth.getParticipantName(),
                'permissions': participants[metadata].permissions,
              };
            }
          }
        }

      }

      data.list.sort(function (a, b) {
        return a.email.localeCompare(b.email);
      });
      User.model.allUsers = data.list;
      User.model.pagination = data.pagination;

    }).$promise;
  };

  User.deleteUser = function (id) {
    return User.deleteTheUser({
      userId: id,
      participantId: Auth.getParticipantName(),
    }).$promise;
  };

  User.userPermissions = function (userPermissions) {
    var permissions = [];
    angular.forEach(userPermissions, function (data, index) {
      if (data) {
        permissions.push(index);
      }
    });
    return permissions;
  };

  User.userPermissionsReverse = function (permissions, userPermissions) {
    var readablePermissions = {};
    angular.forEach(permissions, function (p) {
      if (userPermissions && userPermissions.length > 0 && userPermissions.indexOf(p.name) > -1) {
        readablePermissions[p.name] = true;
      }
    });

    return readablePermissions;
  };

  User.createUser = function () {
    User.model.newUser.role = User.model.newUser.role || 'user';
    var new_user_data = {
      'participantId': Auth.getParticipantName(),
      'email': User.model.newUser.email,
      'password': User.model.newUser.password,
      'email_verified': false,
      'app_meta_data': {
        participants: [
          {
            'name': Auth.getParticipantName(),
            'role': User.model.newUser.role,
          }],
      },
    };
    if (User.model.newUser.role === 'user') {
      new_user_data.app_meta_data.participants[0] = angular.extend(
        new_user_data.app_meta_data.participants[0], {
          'permissions': User.userPermissions(User.model.newUser.permissions),
        });
    }
    if(isSubdomainValidCustomDomain(CUSTOM_MERCHANT_CONFIG.subdomain, CUSTOM_MERCHANT_CONFIG.CUSTOM_SUBDOMAINS) === true ){
      new_user_data.app_meta_data.brandedPortal = CUSTOM_MERCHANT_CONFIG.subdomain;
    }

    return User.createAuser(new_user_data).$promise;
  };

  //  ==== FORM VALIDATIONS ===== //

  var checkEmpty = function (field) {
    var valid = (User.model.newUser[field]);
    User.invalid[field] = !valid;
    return valid;
  };

  User.validateEmailEmpty = function () {
    return checkEmpty('email');
  };

  User.validateEmailFormat = function () {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var valid = re.test(User.model.newUser.email);
    User.invalid.email = !valid;
    return valid;
  };

  User.validatePasswordEmpty = function () {
    return checkEmpty('password');
  };

  User.validatePasswordFormat = function () {
    var reContains = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).*/;
    var reRepeated = /^(?=.{16,}$)(([\w!@#$%^&*])\2?(?!\2))+$/;
    var valid = reRepeated.test(User.model.newUser.password);
    if (valid === true) {
      valid = reContains.test(User.model.newUser.password);
    }
    User.invalid.password = !valid;
    return valid;
  };

  User.validateRepeatPassword = function () {
    var valid = User.model.newUser.password === (User.model.newUser.repeatPassword || null);
    User.invalid.repeatPassword = !valid;
    return valid;
  };

  User.resetValidation = function () {
    angular.forEach(User.invalid, function (value, key) {
      User.invalid[key] = false;
    });
  };

  User.clearCreateUserForm = function () {
    User.resetValidation();
    User.model.newUser.email = '';
    User.model.newUser.password = '';
    User.model.newUser.repeatPassword = '';
    User.model.newUser.role = 'user';
    angular.forEach(User.model.newUser.permissions, function (data, index) {
      User.model.newUser.permissions[index] = false;
    });
  };

  return User;
}

function isSubdomainValidCustomDomain(subdomain, CUSTOM_SUBDOMAINS){
  var isBrandedPortal = false;
  if(subdomain !== undefined && CUSTOM_SUBDOMAINS !== undefined) {
    _.forEach(CUSTOM_SUBDOMAINS, function(value,key){
      if(value === subdomain){
        isBrandedPortal = true;
      }
    });
  }
  return isBrandedPortal;
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Utils', Utils);

/** @ngInject */
function Utils() {
  return {
    MONTH_NAMES: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'],
    MONTH_NAMES_SHORT: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'],
    pad: function(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    convertToSec: function(val) {
      var time = val.split(':');
      var inSeconds = 0;
      if (time[0]) {
        inSeconds += parseInt(time[0]) * 3600;
      }
      if (time[1]) {
        inSeconds += parseInt(time[1]) * 60;
      }
      if (time[2]) {
        inSeconds += parseInt(time[2]);
      }
      return inSeconds;
    },
    convertToHour: function(sec) {
      var hour = (Math.floor(sec / 3600)).toString();
      hour = hour.length > 1 ? hour : '0' + hour;

      var minutes = (Math.floor(sec % 3600 / 60)).toString();
      minutes = minutes.length > 1 ? minutes : '0' + minutes;

      return hour + ':' + minutes;
    },
    isOdd: function(x) {
      return x % 2 === 1;
    },
    adjustConnect: function(start) {
      var connect = [];
      for (var i = 0; i < start.length + 1; i++) {
        connect.push(this.isOdd(i));
      }
      connect = start.length === 1 ? [] : connect;
      return connect;
    },
    convertHourToSec: function(hour) {
      var temp = hour.split(':');
      if (temp.length !== 2) {
        return 0;
      }

      var hours = parseInt(temp[0], 10);
      var minutes = parseInt(temp[1], 10);

      return (hours * 60 * 60) + (minutes * 60);
    },
    groupBy: function(xs, f) {
      return xs.reduce(function(r, v) {
        var k = f(v);
        return ((r[k] || (r[k] = [])).push(v), r);
      }, {});
    },
    getSum: function(total, num) {
      return total + num;
    },
    formatDate: function(timeAsMilli, locale) {
      var date = new Date(timeAsMilli);
      return date.toLocaleDateString(locale);
    },
    formatDateToWeek: function(timeAsMilli, locale) {
      var date = moment(new Date(timeAsMilli));
      return date.isoWeek();
    },
    isFunction: function(aFunction) {
      return !!aFunction && typeof aFunction === 'function';
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('WebAnalytics', WebAnalytics);

/** @ngInject */
function WebAnalytics() {
  var runWithPaq = function(fn) {
    if (window._paq) {
      fn(window._paq);
    }
  };

  WebAnalytics.hasConsent = function() {
    if (window.Matomo) {
      return window.Matomo.getTracker().hasRememberedConsent();
    }
    return false;
  };

  WebAnalytics.confirmCookieConsent = function() {
    runWithPaq(function(paq) {
      paq.push(['rememberConsentGiven', 87600]);
    });
  };

  WebAnalytics.trackSearchResponseEvent = function(urlPath, numResults) {
    runWithPaq(function(paq) {
      // false is passed for searchCategory param
      paq.push(['trackSiteSearch', urlPath, false, numResults]);
    });
  };

  WebAnalytics.trackLoginSuccessEvent = function(userId) {
    runWithPaq(function(paq) {
      paq.push(['setUserId', userId]);
      paq.push(['trackEvent', 'Login', 'LoginSuccess', userId]);
    });
  };

  WebAnalytics.trackLogoutSuccessEvent = function(userId) {
    runWithPaq(function(paq) {
      paq.push(['trackEvent', 'Logout', 'LogoutSuccess', userId]);
      paq.push(['resetUserId']);
    });
  };

  WebAnalytics.trackJSError = function(urlPath, exception, cause) {
    runWithPaq(function(paq) {
      var action = urlPath;
      if (exception.lineNumber) { // some browsers might define lineNumber, possibly FF?
        action += ':' + exception.lineNumber;
      }
      paq.push(['trackEvent', 'JavaScript Errors', action, exception.stack || cause]);
    });
  };

  WebAnalytics.trackDownload = function(filepath) {
    runWithPaq(function(paq) {
      paq.push(['trackLink', filepath, 'download']);
    });
  };

  WebAnalytics.trackCSVDownload = function(filepath) {
    runWithPaq(function(paq) {
      paq.push(['trackEvent', 'Analytics', 'DownloadCSV', filepath]);
    });
  };

  WebAnalytics.trackLocationChange = function(newUrl, oldUrl) {
    runWithPaq(function(paq) {
      if (oldUrl !== newUrl) {
        paq.push(['setReferrerUrl', oldUrl]);
        paq.push(['setCustomUrl', newUrl]);
        // remove all previously assigned custom variables
        _paq.push(['deleteCustomVariables', 'page']);
        // Matomo needs to re-scan the entire DOM for newly added links whenever the DOM changes.
        _paq.push(['enableLinkTracking']);
        // Tell Matomo to treat new location as new page view
        paq.push(['trackPageView']);
      }
    });
  };

  return WebAnalytics;
}

/**
 * @author z.geddes
 * created on 05.03.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .factory('Zone', Zone);

Zone.$inject = ['$resource', '$stateParams', 'Config', 'Auth'];

/** @ngInject */
function Zone($resource, $stateParams, Config, Auth) {
  var url = Config.getAPIServerURL() + ':participantId/zones/:zoneId';
  var Zone = $resource(url, {
    participantId: '@participantId',
    zoneId: '@zoneId',
  }, {
    get: {
      method: 'get',
    },
    update: {
      method: 'put',
    },
    delete: {
      method: 'delete',
    },
    create: {
      method: 'post',
    }
  });

  Zone.model = {
    list: [],
    idToNameMap: {},
    current: {},
  };

  function _updateIdToNameMap() {
    Zone.model.idToNameMap = Zone.model.list.reduce(function (map, zone) {
      map[zone.id] = zone.zone_name;
      return map;
    }, {});
  }

  Zone.remove = function(id) {
    var query = {
      'participantId': Auth.getParticipantName(),
      'zoneId': id,
    };

    return Zone.delete(query).$promise;
  };

  Zone.fetch = function() {
    var query = {
      'participantId': Auth.getParticipantName(),
    };

    return Zone.get(query, function(data) {
      Zone.model.list = data.list;
    }).$promise.then(function(data) {
      _updateIdToNameMap();
      return data;
    });
  };

  Zone.save = function(data) {
    if (data.id) {
      return Zone.update({
        'zoneId': data.id,
        'participantId': Auth.getParticipantName(),
      }, data).$promise;
    } else {
      return Zone.create({
        'participantId': Auth.getParticipantName(),
      }, data).$promise;
    }
  };

  return Zone;
}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AccountCtrl', [
    '$scope',
    function($scope) {
      $scope.loginPage = true;
    },
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.dashboard')
  .controller('AdminDashboardCtrl', AdminDashboardCtrl);

AdminDashboardCtrl.$inject = [
  '$scope',
  'DashboardAnalysis',
  '$timeout',
  'OrganiseData',
  'initOptions'];

/** @ngInject */
function AdminDashboardCtrl($scope, DashboardAnalysis, $timeout, OrganiseData, initOptions) {
  var vm = this;
  vm.analyticsModel = DashboardAnalysis.model;
  vm.options = initOptions;
  vm.formSubmit = formSubmit;
  vm.getData = getData;
  $scope.pageLoaded();

  angular.forEach(vm.options.fields, function(option, key) {
    vm['chartOptions_' + key] = angular.copy(vm.options.charts);
  });

  function getData() {
    vm.loading = true;

    DashboardAnalysis.getData().then(function() {
      formSubmit();
    }).finally(function() {
      vm.loading = false;
    });

  }

  function formSubmit() {

    vm.loading = true;
    vm.dataTemporary = OrganiseData.backupData(vm.analyticsModel.csvData);

    angular.forEach(vm.options.fields, function(option, key) {

      var data = OrganiseData.getDataTable(vm.dataTemporary, OrganiseData.sortData, option);

      data = data.slice(0, 7);
      vm['chartOptions_' + key].series = getSeries(data, option);

    });

    $timeout(function() {
      vm.loading = false;
    }, 1000);
  }

  function getSeries(data, selectedChart) {
    return selectedChart.map(function(c, index) {
      var type = index === 0 ? 'column' : 'spline';
      var axis = type === 'spline' ? 1 : 0;
      return {
        name: c.label,
        type: type,
        data: data.map(function(s) {
          return s[index + 1];
        }),
        lineWidth: 6,
        yAxis: axis,
        marker: {
          radius: 0,
        },
        pointStart: Date.UTC(2010, 0, 1),
        pointInterval: 24 * 3600 * 1000,
      };
    });
  }

}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AdminTransactionsCtrl', AdminTransactionsCtrl);
AdminTransactionsCtrl.$inject = ['$scope', 'Transaction', '$location'];

/** @ngInject */
function AdminTransactionsCtrl($scope, Transaction, $location) {
  $scope.transactionModel = Transaction.model;
  $scope.loading = false;
  $scope.pageLoaded();

  $scope.translatePrefix = 'TRANSACTIONS.';


  var getTransactions = function() {
    $scope.loading = true;
    var msg = $scope.translate('ERROR-MESSAGE');
    Transaction.fetchTransactions().catch(function() {
      $scope.callErrorPage(msg, 'customers');
    }).finally(function() {
      $scope.pageLoaded();
      $scope.loading = false;
    });
  };

  $scope.onEntryChange = function() {
    $scope.transactionModel.limit = $location.search().entry;
    getTransactions();
  };

  $scope.seeTransaction = function(e, transaction) {
    if (e.target.localName === 'td') {
      var url = '/admin/customersById/' + transaction.customer_id;
      $location.path(url).search({
        aggregationId: transaction.aggregation_id,
      });
    }
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.unauthorized')
  .controller('AdminUnauthorizedCtrl', AdminUnauthorizedCtrl);

/** @ngInject */
function AdminUnauthorizedCtrl($scope) {
  $scope.pageLoaded();
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('expirationDirective', expirationDirective);
expirationDirective.$inject = ['$filter', 'parseDate'];

/** @ngInject */
function expirationDirective($filter, parseDate) {
  return {
    require: 'ngModel',
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'remove': '=',
      'name': '@',
    },
    templateUrl: 'app/theme/components/cardExpiration/cardExpiration.html',
    link: function(scope, $element, $attrs, ngModelCtrl) {
      scope.removeContent = function() {
        scope.remove('expiration');
      };
      scope.errorExp = false;
      scope.errorExpMonth = false;
      scope.expDate = scope.expDateModel;
      var currentMonth = $filter('date')(new Date(), 'MM');
      var acceptedYear = '15';
      currentMonth = parseInt(currentMonth, 10);

      scope.$watch('ngModel', function(value, oldValue) {
        if(!value && oldValue) {
          scope.expDate = '';
        }
      });

      ngModelCtrl.$render = function() {
        if(new RegExp(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/).test(ngModelCtrl.$viewValue)) {
          scope.expDate = ngModelCtrl.$viewValue;
        }
      };

      scope.$watch('expDate', function(value, oldValue) {
        if (value) {
          scope.ngModel = value;

          value = String(value);
          var number = value.replace(/[^0-9]+/g, '');
          scope.expDateModel = number;
          scope.expDate = $filter('expDate')(number, currentMonth, acceptedYear);
          var src = 'dir';
          var date = parseDate.parseDate(value, src);
  	      var monthsArray = parseDate.getMonths();

          if (value.length > 5) {
            scope.expDate = oldValue;
          }

          if (date.month.length === 2) {
            if (monthsArray.indexOf(date.month) !== -1) {
              scope.errorExpMonth = false;
            } else {
              scope.errorExpMonth = true;
            }
          }

          if (date.year.length === 2) {
            if ((date.yearInt < acceptedYear) || ((date.yearInt === acceptedYear) && (date.month < currentMonth))) {
              console.log('Please select a date in the future!');
              scope.errorExp = true;
            } else {
              scope.errorExp = false;
            }
          }
        }
      });
    }
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('collapseMenuButton', collapseMenuButton);
collapseMenuButton.$inject = ['$rootScope', '$location'];

/** @ngInject */
function collapseMenuButton() {
  return {
    restrict: 'E',
    templateUrl: 'app/theme/components/collapseMenuButton/collapseMenuButton.html',
    link: function() {
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('currencyPicker', currencyPicker);
currencyPicker.$inject = [];

/** @ngInject */
function currencyPicker() {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'onChange': '=',
      'currencyCodes': '=',
    },
    templateUrl: 'app/theme/components/currencyPicker/currencyPicker.html',
    link: function(scope) {
      scope.selectedCode = scope.ngModel;

      scope.updateCurrencyPicker = function(value) {
        scope.onChange(parseInt(value, 10));
      };

      scope.$watch('currencyCodes', function(newCurrencyCode) {
        if (!newCurrencyCode) {
          return;
        }

        if (newCurrencyCode.indexOf(scope.selectedCode) === -1) {
          scope.selectedCode = newCurrencyCode[0];
        }
      });
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('dateRangePicker', dateRangePicker);
dateRangePicker.$inject = [];

/** @ngInject */
function dateRangePicker() {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'onChange': '=',
      'startDate': '=',
      'endDate': '=',
      'maxEndDate': '=',
      'minStartDate': '=',
    },
    templateUrl: 'app/theme/components/dateRangePicker/dateRangePicker.html',
    link: function(scope) {
      scope.updateStartDate = function() {
        if (scope.onChange) {
          scope.onChange();
        }
      };

      scope.updateEndDate = function() {
        if (scope.onChange) {
          scope.onChange();
        }
      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('dateRangePicker2', dateRangePicker2);
dateRangePicker2.$inject = ['$timeout', '$filter', '$translate'];

/** @ngInject **/
function dateRangePicker2($timeout, $filter, $translate) {
  return {
    restrict: 'E',
    require: '?ngModel',
    scope: {
      'ngModel': '=',
      'onDateChange': '=',
      'maxDate': '=',
      'maxDays': '@',
      'minDate': '=',
      'customOptions': '=',
      'align': '@',
      'firstDayOfWeek': '=',
      'weekMode': '='
    },
    link: function(scope, element) {
      var datepicker = element.find('.datepicker:first');
      var button = element.find('.datepicker-button:first');

      scope.ngModel = scope.ngModel || {};
      scope.align = scope.align || 'left';
      scope.firstDayOfWeek = scope.firstDayOfWeek || 'sunday';
      scope.calendarOpened = false;
      scope.days = [];
      scope.dayNames = [];
      scope.pickedFromDate = null;
      scope.dynamicMinDate = scope.minDate.clone();
      scope.dynamicMaxDate = scope.maxDate.clone();

      var currentDate = scope.ngModel.fromDate.clone();

      generateDayNames();
      if(scope.weekMode) {
        initWeekModeOptions();
      }

      scope.highlightRange = function(onDate) {
        var days = $('span.day').removeClass('hover');
        var dates = getFromToDates(onDate);

        if(scope.pickedFromDate) {
          days.removeClass('in-range').removeClass('from-to-date');
        }

        if(dates.from && dates.to) {
          $('span.' + dates.from.format('YYYY-MM-DD')).addClass('from-to-date');
          $('span.' + dates.to.format('YYYY-MM-DD')).addClass('from-to-date');

          while (dates.from.isBefore(dates.to, 'day')) {
            $('span.' + dates.from.format('YYYY-MM-DD')).addClass('hover');
            dates.from.add(1, 'day');
          }
        } else if (scope.weekMode && !isDateOutsideOverallMinMax(onDate)) {
          var startWeek = getFirstDayOfWeek(onDate);
          var endWeek = getLastDayOfWeek(onDate);
          while (startWeek.isSameOrBefore(endWeek, 'day')) {
            $('span.' + startWeek.format('YYYY-MM-DD')).addClass('hover');
            startWeek.add(1, 'day');
          }
        }
      };

      function getFromToDates(onDate) {
        var dates = {};
        if (scope.pickedFromDate) {
          if(scope.weekMode) {
            dates = getFromToDatesWeekMode(onDate);
          } else {
            dates = getFromToDatesDayMode(onDate);
          }

          if(dates.to.isBefore(dates.from, 'day')) {
            var temp = dates.from.clone();
            dates.from = dates.to;
            dates.to = temp;
          }
        }

        return dates;
      }

      function getFromToDatesWeekMode(onDate) {
        var fromDate = getFirstDayOfWeek(scope.pickedFromDate.clone());
        var toDate = getLastDayOfWeek(onDate);

        if(isDateOutsideMinMax(onDate)) {
          if(onDate.isBefore(fromDate, 'day')) {
            toDate = getLastDayOfWeek(fromDate);
            fromDate = scope.dynamicMinDate.clone();
          } else if(onDate.isAfter(fromDate, 'day')) {
            toDate = scope.dynamicMaxDate.clone();
          }
        } else {
          if (toDate.isBefore(fromDate, 'day')) {
            fromDate.add(6, 'days');
            toDate.subtract(6, 'days');
          }
        }

        return {
          from: fromDate,
          to: toDate
        };
      }

      function getFromToDatesDayMode(onDate) {
        var fromDate = scope.pickedFromDate.clone();
        var toDate = onDate.clone();
        if(isDateOutsideMinMax(toDate)) {
          if(onDate.isBefore(fromDate, 'day')) {
            toDate = scope.dynamicMinDate.clone();
          } else if(onDate.isAfter(fromDate, 'day')) {
            toDate = scope.dynamicMaxDate.clone();
          }
        }

        return {
          from: fromDate,
          to: toDate
        };
      }

      scope.toggleCalendar = function() {
        scope.calendarOpened = !scope.calendarOpened;
        if (scope.calendarOpened) {
          $('.back-top').hide();
          generateCalendar(scope.ngModel.fromDate.clone());

          var button = element.find('.datepicker-button:first');
          var buttonPos = button.position();
          var buttonSize = {width: button.outerWidth(true), height: button.outerHeight()};
          var datepicker = element.find('.datepicker:first');
          var calendar = datepicker.find('.calendar-wrapper:first');
          if (calendar.css('width').indexOf('%') > -1) {
            datepicker.css('width', buttonSize.width);
          } else {
            datepicker.css('width', '');
          }
          datepicker.css('left', '-9999px').removeClass('ng-hide');
          var dpWidth = datepicker.outerWidth();
          var left = scope.align === 'left' ?
            buttonPos.left :
            buttonPos.left + buttonSize.width - dpWidth;
          datepicker.css({
            left: left,
            top: button.position().top + buttonSize.height - 1,
          });

          $timeout(function() {
            datepicker.focus();
          }, 100);
        } else {
          $('.back-top').show();
        }
      };

      scope.prevMonth = function(event) {
        event.preventDefault();
        currentDate.subtract(1, 'M');
        generateCalendar(currentDate);
      };

      scope.nextMonth = function(event) {
        event.preventDefault();
        currentDate.add(1, 'M');
        generateCalendar(currentDate);
      };

      scope.canGoBack = function() {
        var startOfMonth = moment(currentDate).startOf('month');
        return (!scope.minDate || scope.minDate.isBefore(startOfMonth, 'day')) &&
          (!scope.dynamicMinDate || scope.dynamicMinDate.isBefore(startOfMonth, 'day')) &&
          (!scope.minDateWeekMode || scope.minDateWeekMode.isBefore(startOfMonth, 'day'));
      };

      scope.canGoForward = function() {
        var endOfMonth = moment(currentDate).endOf('month');
        return (!scope.maxDate || scope.maxDate.isAfter(endOfMonth, 'day')) &&
          (!scope.dynamicMaxDate || scope.dynamicMaxDate.isAfter(endOfMonth, 'day')) &&
          (!scope.maxDateWeekMode || scope.maxDateWeekMode.isAfter(endOfMonth, 'day'));
      };

      scope.clearSelection = function() {
        scope.pickedFromDate = null;
        scope.dynamicMinDate = null;
        scope.dynamicMaxDate = null;
        generateCalendar(scope.ngModel.fromDate.clone());
      };

      scope.isCustomOptionSelected = function(option) {
        return option.fromDate.isSame(scope.ngModel.fromDate, 'day') &&
          option.toDate.isSame(scope.ngModel.toDate, 'day');
      };

      scope.selectCustomOption = function(option) {
        scope.ngModel.fromDate = option.fromDate.clone();
        scope.ngModel.toDate = option.toDate.clone();
        closeCalendar();
        scope.pickedFromDate = null;
        scope.onDateChange();
      };

      scope.selectDate = function(event, day) {
        event.preventDefault();
        if (day.class.indexOf('disabled') > -1) {
          return;
        }

        if(scope.weekMode) {
          selectDateWeekMode(day.date);
        } else {
          selectDateDayMode(day.date);
        }
      };

      function isDateInRange(date) {
        return date.isBetween(scope.ngModel.fromDate, scope.ngModel.toDate);
      }

      function isDateFromOrTo(date) {
        return date.isSame(scope.ngModel.fromDate, 'day') ||
          date.isSame(scope.ngModel.toDate, 'day');
      }

      function isDateOutsideOverallMinMax(date) {
        return (scope.minDate && date.isBefore(scope.minDate, 'day')) ||
               (scope.maxDate && date.isAfter(scope.maxDate, 'day')) ||
               (scope.minDateWeekMode && date.isBefore(scope.minDateWeekMode, 'day')) ||
               (scope.maxDateWeekMode && date.isAfter(scope.maxDateWeekMode, 'day'));
      }

      function isDateOutsideDynamicMinMax(date) {
        return (scope.dynamicMinDate && date.isBefore(scope.dynamicMinDate, 'day')) ||
               (scope.dynamicMaxDate && date.isAfter(scope.dynamicMaxDate, 'day'));
      }

      function isDateOutsideMinMax(date) {
        return isDateOutsideOverallMinMax(date) ||
               isDateOutsideDynamicMinMax(date);
      }

      function getFirstDayOfWeek(date) {
        date = date.clone();
        if(scope.firstDayOfWeek==='sunday') {
          date.day(0);
        } else {
          if(date.day()===0) {
            date.subtract(6, 'days');
          } else {
            date.day(1);
          }
        }
        return date;
      }

      function getLastDayOfWeek(date) {
        date = getFirstDayOfWeek(date);
        date.add(6, 'days');
        return date;
      }

      function generateCalendar(date) {
        var year = date.format('YYYY');
        var month = $translate.instant('COMPONENTS.DATERANGE.' + date.format('MMMM'));
        scope.title = month + ' ' + year;
        currentDate = date.clone();

        var daysToShow = date.endOf('month').date();
        var daysOfPreviousMonthToShow = getDaysOfPreviousMonthToShow(date);
        var daysOfNextMonthToShow = getDaysOfNextMonthToShow(date);

        scope.days = [];

        var tempDate = date.startOf('month').subtract(daysOfPreviousMonthToShow, 'days');
        for(var i = 0; i < daysOfPreviousMonthToShow + daysToShow + daysOfNextMonthToShow; i++) {
          var className = tempDate.format('YYYY-MM-DD');
          if (isDateInRange(tempDate)) {
            className += ' in-range';
          }
          if (isDateFromOrTo(tempDate)) {
            className += ' from-to-date';
          }
          if (tempDate.month() !== currentDate.month()) {
            className += ' other-month';
          }
          if (isDateOutsideMinMax(tempDate)) {
            className += ' disabled';
          }

          scope.days.push({
            class: className,
            date: tempDate.clone()
          });
          tempDate.add(1, 'day');
        }
      }

      function getDaysOfPreviousMonthToShow(date) {
        var daysToShow = 0;
        var firstDayOfMonth = date.startOf('month').day();
        if(scope.firstDayOfWeek==='sunday') {
          daysToShow = firstDayOfMonth;
        } else {
          daysToShow = firstDayOfMonth - 1;
          if(firstDayOfMonth===0) {
            daysToShow = 6;
          }
        }
        return daysToShow;
      }

      function getDaysOfNextMonthToShow(date) {
        var daysToShow = 0;
        var lastDayOfMonth = date.endOf('month').day();
        if(scope.firstDayOfWeek==='sunday') {
          daysToShow = 6 - lastDayOfMonth;
        } else {
          daysToShow = 7 - lastDayOfMonth;
          if(lastDayOfMonth===0) {
            daysToShow = 0;
          }
        }
        return daysToShow;
      }

      function generateDayNames() {
        var date = scope.firstDayOfWeek === 'sunday' ? moment('2015-06-07').locale('fr') : moment('2015-06-01');
        for (var i = 0; i < 7; i += 1) {
          scope.dayNames.push(date.format('ddd'));
          date.add('1', 'd');
        }
      }

      function initWeekModeOptions() {
        if(scope.minDate) {
          var minDate = scope.minDate.clone();
          minDate = getFirstDayOfWeek(minDate);

          scope.minDateWeekMode = minDate;
          scope.minDate = undefined;
          scope.dynamicMinDate = undefined;
        }
        if(scope.maxDate) {
          var maxDate = scope.maxDate.clone();
          maxDate = getLastDayOfWeek(maxDate);

          scope.maxDateWeekMode = maxDate;
          scope.maxDate = undefined;
          scope.dynamicMaxDate = undefined;
        }
      }

      function generateDynamicMinMaxDates() {
        if(scope.maxDays) {
          if(scope.weekMode) {
            generateDynamicMinMaxDatesWeekMode();
          } else {
            generateDynamicMinMaxDatesDayMode();
          }
        } else {
          scope.dynamicMinDate = null;
          scope.dynamicMaxDate = null;
        }
      }

      function generateDynamicMinMaxDatesWeekMode() {
        var date = scope.pickedFromDate.clone();
        date.subtract(scope.maxDays - 1, 'day');
        date = getFirstDayOfWeek(date);
        if (date.isBefore(scope.minDateWeekMode, 'day')) {
          date = scope.minDateWeekMode.clone();
        }
        scope.dynamicMinDate = date;

        date = scope.pickedFromDate.clone();
        date.add(scope.maxDays - 1, 'day');
        date = getLastDayOfWeek(date);
        if (date.isAfter(scope.maxDateWeekMode, 'day')) {
          date = scope.maxDateWeekMode.clone();
        }
        scope.dynamicMaxDate = date;
      }

      function generateDynamicMinMaxDatesDayMode() {
        var date = scope.pickedFromDate.clone();
        date.subtract(scope.maxDays - 1, 'day');
        if(scope.minDate && date.isBefore(scope.minDate, 'day')) {
          date = scope.minDate.clone();
        }
        scope.dynamicMinDate = date;

        date = scope.pickedFromDate.clone();
        date.add(scope.maxDays - 1, 'day');
        if(scope.maxDate && date.isAfter(scope.maxDate, 'day')) {
          date = scope.maxDate.clone();
        }
        scope.dynamicMaxDate = date;
      }

      function closeCalendar() {
        scope.calendarOpened = false;
        scope.pickedFromDate = null;
        scope.dynamicMinDate = null;
        scope.dynamicMaxDate = null;
        $('.back-top').show();
      }

      function selectDateWeekMode(date) {
        var selectedDate = moment(date);
        if (!scope.pickedFromDate) {
          scope.pickedFromDate = getFirstDayOfWeek(selectedDate);
          scope.highlightRange(selectedDate);
          generateDynamicMinMaxDates();
        } else {
          var fromDate = scope.pickedFromDate;
          var toDate = getFirstDayOfWeek(selectedDate);
          toDate.add(6, 'days');

          if(toDate.isBefore(fromDate, 'day')) {
            fromDate.add(6, 'days');
            toDate.subtract(6, 'days');
          }

          scope.ngModel.fromDate = fromDate;
          scope.ngModel.toDate = toDate;

          closeCalendar();
          scope.pickedFromDate = null;

          if (scope.ngModel.toDate.isBefore(scope.ngModel.fromDate, 'day')) {
            var temp = scope.ngModel.toDate.clone();
            scope.ngModel.toDate = scope.ngModel.fromDate.clone();
            scope.ngModel.fromDate = temp;
          }
          scope.onDateChange();
        }
      }

      function selectDateDayMode(date) {
        var selectedDate = moment(date);
        if (!scope.pickedFromDate) {
          scope.pickedFromDate = selectedDate;
          scope.highlightRange(selectedDate);
          generateDynamicMinMaxDates();
        } else {
          scope.ngModel.fromDate = scope.pickedFromDate;
          scope.ngModel.toDate = selectedDate;

          closeCalendar();
          scope.pickedFromDate = null;

          if (scope.ngModel.toDate.isBefore(scope.ngModel.fromDate, 'day')) {
            var temp = scope.ngModel.toDate.clone();
            scope.ngModel.toDate = scope.ngModel.fromDate.clone();
            scope.ngModel.fromDate = temp;
          }
          scope.onDateChange();
        }
      }

      document.body.addEventListener('click', function(event) {
        var target = $(event.target);
        var clickedInsideButton = target.parents().is(button);
        var clickedInsideDatepicker = target.parents().is(datepicker);
        var isClearSelectionButton = target.is('.datepicker-clear-selection');
        if (!clickedInsideButton && !clickedInsideDatepicker && !isClearSelectionButton) {
          closeCalendar();
          scope.$apply();
        }
      });
      window.addEventListener('resize', function() {
        if(scope.calendarOpened) {
          closeCalendar();
          scope.$apply();
        }
      });
    },
    templateUrl: 'app/theme/components/dateRangePicker2/dateRangePicker2.html'
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('editButton', ['$q', editButton]);

/** @ngInject */
function editButton($q) {
  return {
    restrict: 'E',
    scope: {
      'variable': '=',
      'update': '=',
      'cancel': '=',
      'order': '=',
      'edit': '=',
      'disable': '=',
    },
    templateUrl: 'app/theme/components/editButton/editButton.html',
    link: function(scope) {
      scope.editClick = function () {
        if (scope.variable === undefined) {
          scope.variable = false;
        }

        if (scope.variable) {
          if (!scope.disable) {
            $q.when(scope.update(scope.order)).then(function () {
              scope.variable = false;
            }).catch(function () {
              // prevent unhandled rejection
            });
          }
        } else if (scope.edit) {
          scope.edit(scope.order);
          scope.variable = true;
        } else {
          scope.variable = true;
        }
      };

      scope.editCancel = function () {
        scope.variable = false;
        scope.cancel();
      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('entryChange', entryChange);
entryChange.$inject = ['$location'];

/** @ngInject */
function entryChange($location) {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'onEntryChange': '=',
      'onSearchFilter': '=',
      'searchFilterPlaceholder': '@',
      'filterModel': '=',
      'onClear': '=',
    },
    templateUrl: 'app/theme/components/entryChange/entryChange.html',
    link: function(scope) {
      scope.placeholder = scope.searchFilterPlaceholder || 'Search by Id';

      scope.ngModel.entryNumber = $location.search().entry ? $location.search().entry : '10';
      scope.ngModel.currentPage = $location.search().page ? parseInt($location.search().page) : 1;

      scope.updateListEntry = function() {
        var entry = scope.ngModel.entryNumber;
        $location.search('entry', entry);
        scope.ngModel.entryNumber = entry;

        $location.search('page', 1);
        scope.ngModel.currentPage = 1;
        scope.onEntryChange();
      };

      var delay = (function() {
        var timer = 0;
        return function(callback, ms) {
          clearTimeout(timer);
          timer = setTimeout(callback, ms);
        };
      })();

      var typeFunction = function() {
        $location.search('id', scope.filterModel.customerId);
        if (scope.filterModel.customerId === '') {
          scope.onClear();
        }
        scope.onSearchFilter(scope.ngModel.currentPage);
      };

      scope.onSearch = function(e) {
        var code = (e.keyCode || e.which);

        // do nothing if it's an arrow key
        if (code === 37 || code === 38 || code === 39 || code === 40) {
          return;
        }
        delay(function() {
          typeFunction();
        }, 1000);
      };
      scope.onEntryChange();
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .controller('FooterCtrl', FooterCtrl);
FooterCtrl.$inject = ['$scope', 'Auth', 'NOTIFICATIONS'];

/** @ngInject */
function FooterCtrl($scope, Auth, NOTIFICATIONS) {
  $scope.infoBox = {};
  $scope.newNotifications = NOTIFICATIONS.list;
  $scope.profile.user_metadata.notifications = $scope.profile.user_metadata.notifications || {};
  $scope.active = ($scope.profile.user_metadata.notifications &&
  $scope.profile.user_metadata.notifications.hideAnnoyingPopup) || false;
  $scope.isParent = Auth.isParent();


  // $scope.checked = function() {
  //   $scope.check = true;
  //   angular.forEach($scope.infoBox, function(i) {
  //     if (i) {
  //       $scope.check = !i;
  //     }
  //   });
  //   $scope.active = $scope.check;
  // };

  $scope.updatePopupNotifications = function() {
    if ($scope.profile.user_metadata.notifications) {
      $scope.profile.user_metadata.notifications.hideAnnoyingPopup = $scope.active;
    } else {
      $scope.profile.user_metadata.notifications = {
        'hideAnnoyingPopup': $scope.active,
      };
    }
    localStorage.setItem('profile', JSON.stringify($scope.profile));
  };

  $scope.$watch('active', function(a) {
    if (a) {
      $scope.updatePopupNotifications();
    }

  });

  $scope.logout = function() {
    localStorage.clear();
    Auth.logout();
  };

}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('inlineLoader', inlineLoader);

/** @ngInject */
function inlineLoader() {
  return {
    restrict: 'E',
    scope: {
      'show': '=',
    },
    transclude: true,
    templateUrl: 'app/theme/components/inlineLoader/inlineLoader.html',
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('languageSelection', ['Auth', languageSelection]);

/** @ngInject */
function languageSelection(Auth) {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'languages': '='
    },
    templateUrl: 'app/theme/components/languageSelection/languageSelection.html',
    link: function(scope) {

      scope.languageChanged = function(newVar) {
        Auth.changeLanguage(newVar);
      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('modal', modal);
modal.$inject = ['$timeout'];

/** @ngInject */
function modal($timeout) {
  return {
    restrict: 'E',
    scope: {
      'show': '=',
      'focusFirst': '=',
      'header': '@',
      'confirmation': '@',
      'modalName': '@',
      'onSubmitClick': '=',
      'onCloseClick': '=',
      'topPosition': '@',
      'cancel': '@',
      'loading': '=',
      'hideContentWhenLoading': '=',
      'modalClass': '@',
      'modalBodyClass': '@'
    },
    transclude: true,
    templateUrl: 'app/theme/components/modal/modal.html',
    link: function(scope, jElement) {
      scope.modalTitle = scope.header;

      var $el = angular.element(jElement);
      var $element = angular.element(document.querySelector('.' + scope.modalName));

      function closest(el, selector) {
        var matchesFn;
        // find vendor prefix
        [
          'matches',
          'webkitMatchesSelector',
          'mozMatchesSelector',
          'msMatchesSelector',
          'oMatchesSelector'].some(function(fn) {
          if (typeof document.body[fn] === 'function') {
            matchesFn = fn;
            return true;
          }
          return false;
        });

        var parent;
        while (el) {
          parent = el.parentElement;
          if (parent && parent[matchesFn](selector)) {
            return parent;
          }
          el = parent;
        }
        return null;
      }

      if ($element[0]) {
        var $modal = closest($element[0], 'modal');
        $modal.parentElement.removeChild($modal);
      }

      var updateModalPosition = function() {
        if (scope.show) {
          getModal().css({
            'marginTop': (scope.topPosition === 'top') ? '0' : -($element.get(0).clientHeight / 2) + 'px',
            'marginLeft': -($element.get(0).clientWidth / 2) + 'px',
            'top': (scope.topPosition === 'top') ? '10%' : '50%'
          });
          showModal();
        }
      };

      /* set focus to first input, button or select in the modal if focus-first="true" attribute is set */
      /* cannot focus an element that is not visible, so 100 timeout allows modal to be visible first */
      var focusFirstInput = function() {
        setTimeout(function() {
          var modalBody = document.querySelector('.' + scope.modalName + ' div.modal-body');
          var elements = modalBody.querySelectorAll('input,button,select');
          if (elements.length) {
            elements[0].focus();
          }
        }, 100);
      };

      var getModal = function() {
        if(!$element.length) {
          $element = angular.element(document.querySelector('.' + scope.modalName));
        }
        return $element;
      };

      var showModal = function() {
        getModal().css('visibility', 'visible');
      };

      var hideModal = function() {
        getModal().css('visibility', 'hidden');
      };

      /* Watchers */
      scope.$watch('show', function(show) {
        scope.backdropShowStyle = show ? 'display: block;' : 'display: none';
        if (show) {
          angular.element(document.querySelector('body')).append($el);
          $timeout(updateModalPosition);
          if (scope.focusFirst) {
            focusFirstInput();
          }
        }
      });

      scope.$watch('loading', function(loading) {
        if(scope.hideContentWhenLoading && scope.show && scope.wasLoading && loading===false) {
          updateModalPosition();
        }
        scope.wasLoading = loading;
      });

      /* Event Handlers */
      scope.submitClick = function() {
        scope.onSubmitClick();
      };

      scope.closeClick = function() {
        scope.show = false;
        hideModal();
        if (scope.onCloseClick !== undefined) {
          scope.onCloseClick();
        }
      };
    },
  };
}

/**
 * @author z.geddes
 * created on 16.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .directive('navbarBreadcrumb', navbarBreadcrumb);

  /** @ngInject */
  function navbarBreadcrumb($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/navbarBreadcrumb/navbarBreadcrumb.html',
      link: function($scope) {
        $scope.$watch(function() {
          $scope.parentPageTitle = '';
          $scope.parentPageurl = '';
          $scope.tooltipText = null;
          if($state.current.parentBreadCrumb){
            $scope.parentPageTitle = $scope.translate($state.current.parentBreadCrumb)
            $scope.parentPageurl = $state.current.parentBreadCrumbUrl;
          }
          $scope.activePageTitle = $scope.translate($state.current.title);

          if ($state.current.tooltipText){
            $scope.tooltipText = $scope.translate($state.current.tooltipText);
          }
        });
        $scope.callModalClick = function() {
          $scope.showPageTitleModal = true;
        };

        $scope.hidePageTitleModal = function() {
          $scope.showPageTitleModal = false;
        };
      },

    };


  }

})();

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('newModal', newModal);

/** @ngInject */
function newModal() {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      'header': '@',
      'show': '=',
      'callFunction':'=',
      'size': '@',
      'cancel': '=',
      'submit': '='
    },
    templateUrl: 'app/theme/components/newModal/newModal.html',
    link: function(scope, element) { // set error states
      var modalElement = element.children();

      scope.cancelText = scope.cancel || 'Cancel';
      scope.submitText = 'Submit';

      scope.show = function(transaction) {
        scope.callFunction(transaction);
        modalElement.modal('show');
      };

      scope.submitClick = function() {
        scope.submit();
      };

      scope.$on('$destroy', function() {
        modalElement.remove();
      });
    }
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('notificationMessage', notificationMessage);
notificationMessage.$inject = ['$sce'];

/** @ngInject */
function notificationMessage($sce) {
  return {
    restrict: 'E',
    templateUrl: 'app/theme/components/notificationMessage/notificationMessage.html',
    scope: {
      ngModel: '=',
    },
    link: function(scope) {
      scope.ngModel.show = false;

      ['success', 'info', 'warning', 'error'].forEach(function(status) {
        var headers = {
          'success': 'Success',
          'danger': 'Error',
          'warning': 'Warning',
        };
        scope.ngModel[status + 'Message'] = function(message) {
          scope.ngModel.status = status === 'error' ? 'danger' : status;
          scope.ngModel.header = headers[scope.ngModel.status] + ': ';
          scope.ngModel.message = message;
          scope.ngModel.show = true;
        };
      });

      /* Scope Methods */
      scope.ngModel.currentMessageHtml = function() {
        return $sce.trustAsHtml(scope.ngModel.message);
      };

      /* Root Scope Methods */
      scope.ngModel.hide = function() {
        scope.ngModel.show = false;
      };
    },
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('pageLoader', pageLoader);

/** @ngInject */
function pageLoader() {
  return {
    restrict: 'E',
    scope: {
      'show': '=',
    },
    transclude: true,
    templateUrl: 'app/theme/components/pageLoader/pageLoader.html',
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('pageResultsSummary', pageResultsSummary);

/** @ngInject */
function pageResultsSummary() {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'onPageClick': '=',
    },
    templateUrl: 'app/theme/components/pageResultsSummary/pageResultsSummary.html',
    link: function() {

    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('pagination', pagination);
pagination.$inject = ['Config', '$location', '$timeout', '$q'];

/** @ngInject */
function pagination(Config, $location, $timeout, $q) {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'onPageClick': '=',
      'onEntryChange': '=',
    },
    templateUrl: 'app/theme/components/pagination/pagination.html',
    link: function(scope) {
      var startPageNo = 1;
      var lastPageNo = startPageNo + 3;

      /* Private Methods */

      var assignpageNo = function() {
        scope.defaultPageLimit = parseInt(scope.ngModel.entryNumber) ||
          Config.getDefaultPageLimit();
      };

      assignpageNo();

      var updatePagination = function(newCurrentPage) {
        var resultsStartNo = ((scope.ngModel.currentPage - 1) * scope.defaultPageLimit) + 1;
        scope.ngModel.resultsStartNo = resultsStartNo;
        var resultsEndNo = resultsStartNo + scope.defaultPageLimit - 1;
        var total = scope.ngModel.pagination.total;
        if (resultsEndNo > total) {
          resultsEndNo = total;
        }
        scope.ngModel.resultsEndNo = resultsEndNo;

        startPageNo = newCurrentPage - (4 / 2);

        var noOfPages = scope.ngModel.noOfPages;

        if (startPageNo > noOfPages - 4) {
          startPageNo = noOfPages - 3;
        }
        if (startPageNo < 1) {
          startPageNo = 1;
        }
        lastPageNo = newCurrentPage + 1;

        if (lastPageNo > noOfPages) {
          lastPageNo = noOfPages;
        }
        if (lastPageNo < 4 && noOfPages > 4) {
          lastPageNo = 4;
        }
        if (lastPageNo < 4) {
          lastPageNo = noOfPages;
        }
        scope.pageNumbers = [];

        if(scope.ngModel.pagination.total) {
          for (var i = startPageNo; i <= lastPageNo; i++) {
            scope.pageNumbers.push(i);
          }
        }else {
          updatePaginationWithoutPage();
        }
      };

      var updatePaginationWithoutPage = function () {
        var currentPage = scope.ngModel.pagination.current_page;
        if(currentPage) {
          scope.pageNumbers = [currentPage];

          if (currentPage > 1) {
            scope.pageNumbers.unshift(currentPage - 1);
          }
          if (scope.ngModel.pagination.next > 0) {
            scope.pageNumbers.push(currentPage + 1);
          }
        }
      };

      /* Watchers */
      scope.$watch('ngModel.pagination.total', function(total) {
        scope.ngModel.noOfPages = Math.ceil(total / scope.ngModel.pagination.limit);
        scope.ngModel.currentPage = scope.ngModel.currentPage || 1;
        updatePagination(scope.ngModel.currentPage);
      });

      scope.$watch('ngModel.pagination.limit', function(limit) {
        scope.ngModel.noOfPages = Math.ceil(scope.ngModel.pagination.total / limit);
        scope.ngModel.currentPage = scope.ngModel.currentPage || 1;
        updatePagination(scope.ngModel.currentPage);
      });

      scope.$watchGroup(['ngModel.pagination.current_page', 'ngModel.pagination.item_count'], function (next) {
        scope.ngModel.currentPage = scope.ngModel.pagination.current_page || 1;
        updatePaginationWithoutPage();
      });

      var pageNoQuery = function(no) {
        $location.search('page', no);
      };

      var updatePageEntry = function() {
        assignpageNo();

        if (parseInt(scope.ngModel.entryNumber) !== scope.ngModel.pagination.limit &&
          scope.onEntryChange) {

          $q.all(updatePagination(1)).then(function() {
            scope.onEntryChange(scope.ngModel.currentPage);
          });
        }
      };

      scope.$watch('ngModel.currentPage', updatePagination);
      scope.$watch('ngModel.entryNumber', updatePageEntry);

      /* Event Handlers */
      scope.pageClick = function(event, pageNo) {
        pageNoQuery(pageNo);
        scope.ngModel.currentPage = pageNo;
        scope.onPageClick(pageNo);
      };

      scope.goToFirstPage = function() {
        pageNoQuery(null);
        scope.onPageClick(1);
      };

      scope.goToLastPage = function() {
        pageNoQuery(scope.ngModel.noOfPages);
        scope.onPageClick(scope.ngModel.noOfPages);
      };

      scope.prevTenPageClick = function() {
        var pageNo = scope.ngModel.currentPage - 4;
        if (pageNo < 1) {
          pageNo = 1;
        }
        pageNoQuery(pageNo);
        scope.onPageClick(pageNo);
      };

      scope.nextTenPageClick = function() {
        var currentPage = parseInt(scope.ngModel.currentPage, 10);
        var pageNo = currentPage + 4;

        var noOfPages = scope.ngModel.noOfPages;
        if (pageNo > noOfPages) {
          pageNo = noOfPages;
        }
        pageNoQuery(pageNo);
        scope.onPageClick(pageNo);
      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('peakRule', peakRule);

/** @ngInject */
function peakRule() {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'options': '=',
      'selectedRule': '=',
      'key': '=',
      'temp': '=',
      'hasChanged': '=',
      'remove': '=',
      'save': '=',
    },
    templateUrl: 'app/theme/components/peakRule/peakRule.html',
    link: function($scope) {

      $scope.$watch('options.start', function() {
        if ($scope.options.start.length > 1) {
          $scope.ngModel.time_periods = [];

          for (var i = 0; i < $scope.options.start.length; i += 2) {
            $scope.ngModel.time_periods.push({
              'start_time': $scope.options.start[i],
              'finish_time': $scope.options.start[i + 1],
              'timezone': 'UTC',
              'type': 'PEAK',
            });
          }
        }
      });

      $scope.isEmpty = function(obj) {
        return angular.equals({}, obj);
      };

      $scope.editClick = function(key) {
        $scope.selectedRule = key;
      };

      $scope.$watch('ngModel', function(data) {
        $scope.hasChanged = !angular.equals(data, $scope.temp);
      }, true);
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .controller('CookieCtrl', CookieCtrl)
  .directive('cookiepopup', cookiepopup);

CookieCtrl.$inject = ['$scope', '$cookies', 'WebAnalytics', '$timeout'];

/** @ngInject */
function CookieCtrl($scope, $cookies, WebAnalytics, $timeout) {
  $scope.displayPopup = false;
  $scope.consent = function() {
    $scope.displayPopup = false;
    WebAnalytics.confirmCookieConsent();
  };
  $timeout(function() {
    $scope.displayPopup = !WebAnalytics.hasConsent();
  }, 2000);
}

/** @ngInject */
function cookiepopup() {
  return {
    restrict: 'E',
    templateUrl: 'app/theme/components/popup/cookie-popup.html',
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('RightbarCtrl', RightbarCtrl);
RightbarCtrl.$inject = ['$scope', '$rootScope', 'Auth', '$state'];

/** @ngInject */
function RightbarCtrl($scope, $rootScope, Auth, $state) {
  $scope.isParent = false;
  $scope.filterText = '';

  $scope.changeAccount = function(account) {
    var newAccount = angular.copy(account);
    newAccount.name = newAccount.id;
    newAccount.displayName = account.name;
    Auth.currentUser.profile.account = newAccount;
    Auth.setCurrentAccount($scope.profile);

    $scope.pageLoadAgain();
    $scope.rightBarCollapse();
    $state.reload();
  };

  $scope.filterParticipants = function() {
    angular.forEach($scope.availableParticipants, function(account) {
      account.hide = account.id.toLowerCase().indexOf($scope.filterText.toLowerCase()) === -1;
      angular.forEach(account.children, function(child) {
        child.hide = child.id.toLowerCase().indexOf($scope.filterText.toLowerCase()) === -1;
      });
    });
  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('selectDropdown', selectDropdown);

/** @ngInject */
function selectDropdown() {
  return {
    restrict: 'E',
    templateUrl: 'app/theme/components/selectDropdown/selectDropdown.html',
    scope: {
      placeholder: '@',
      list: '=',
      selected: '=',
    },
    link: function(scope, $element) {
      scope.listVisible = false;
      scope.isPlaceholder = true;

      scope.select = function(value) {
        scope.isPlaceholder = false;
        scope.selected = value;
      };

      var listener = function() {
        scope.$apply(function() {
          scope.listVisible = !scope.listVisible;
        });
      };

      $element.bind('click', listener);

      scope.$watch('selected', function() {
        if (scope.selected) {
          angular.forEach(scope.list, function(value, key) {
            if (key === scope.selected) {
              scope.display = value;
            }
          });
          scope.isPlaceholder = false;
        }
      });
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('selectProducts',selectProducts);
selectProducts.$inject = ['$translate'];

/** @ngInject */
function selectProducts($translate) {
  return {
    require: 'ngModel',
    scope: {
      'ngModel': '=',
      'allProducts': '=',
      'isValid': '=',
      'disabled': '=',
    },
    templateUrl: 'app/theme/components/selectProducts/selectProducts.html',
    link: function(scope) {

      scope.checkValidity = function () {
        scope.isProductsFieldEmpty =  _.isEmpty(scope.ngModel);
        scope.disabled = scope.isProductsFieldEmpty;
      }

      scope.checkValidity();

      scope.getScheduleStatus = function (product){
        var status;
        if(product.schedule_status) {
          status = ' (' + $translate.instant('PRODUCTS.CAPPING.' + product.schedule_status)+')';
        }
        return status;
      }
    },
  };
}

/**
 * @author z.geddes
 * created on 13.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .service('lpUtil', lpUtil);

  /** @ngInject */
  function lpUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node !== null) {
        if (node === parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16);
      var g = parseInt(hex.slice(3, 5), 16);
      var b = parseInt(hex.slice(5, 7), 16);
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function(elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    };
  }
})();

/**
 * @author z.geddes
 * created on 16.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .controller('SidebarCtrl', SidebarCtrl);

  SidebarCtrl.$inject = ['$scope', 'sidebarService', 'Auth', '$transitions', 'FeatureFlags'];

  /** @ngInject */
  function SidebarCtrl($scope, sidebarService, Auth, $transitions, FeatureFlags) {
    function initSidebar() {
      sidebarService.loadMenuItems(FeatureFlags);
    }

    $scope.getMenuItems = function() {
      return sidebarService.menuItems;
    };

    $scope.hoverItem = function($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 55;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.logout = function() {
      Auth.logout();
    };

    $scope.ctrlWarnGap = Auth.getParticipantName() === 'vasttrafik' ? 0 : 85;

    $transitions.onSuccess({}, function() {
      if (sidebarService.canSidebarBeHidden()) {
        sidebarService.setMenuCollapsed(true);
      }
      initSidebar();
    });

    initSidebar();
  }
})();

/**
 * @author z.geddes
 * created on 16.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .directive('sidebar', sidebar);

  sidebar.$inject = ['$timeout', 'sidebarService', 'lpUtil'];

  /** @ngInject */
  function sidebar($timeout, sidebarService, lpUtil) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/sidebar/sidebar.html',
      controller: 'SidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!lpUtil.isDescendant(el[0], $evt.target) &&
            !$evt.originalEvent.$sidebarEventProcessed &&
            !sidebarService.isMenuCollapsed() &&
            sidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function() {
              sidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = sidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed !== sidebarService.isMenuCollapsed() || scope.menuHeight !==
            newMenuHeight) {
            scope.$apply(function() {
              scope.menuHeight = newMenuHeight;
              sidebarService.setMenuCollapsed(newMenuCollapsed);
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      },
    };
  }

})();

(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .provider('sidebarService', sidebarServiceProvider);

  function sidebarServiceProvider() {
    /*jshint validthis: true*/
    var sidebar = this;
    var staticMenuItems = [];
    var vm = this;
    vm.quicksightBeta = true;

    sidebar.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    sidebar.$get = function($state, layoutSizes, Auth, $rootScope, $injector) {

      return new SidebarFactory();

      function SidebarFactory() {
        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;
        this.menuItems = [];

        var isMenuCollapsed = shouldMenuBeCollapsed();
        var wasMenuCollapsed = false;

        this.loadMenuItems = function(FeatureFlags, cb) {
          var prefix = Auth.isParent() ? 'parent' : 'admin';
          var states = defineMenuItemStates(FeatureFlags, prefix);
          var items = states.filter(function(item) {
            return item.level === 0;
          });

          items.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level === 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          this.menuItems = items.concat(staticMenuItems);
          if(cb) {
            cb();
          }
        };

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
          wasMenuCollapsed = isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            if (currentItem.subMenu) {
              currentItem.subMenu.forEach(function(subItem) {
                if (subItem.stateRef) {
                  result.push(subItem.stateRef);
                  _iterateSubItems(subItem);
                }
              });
            }
          }
        };

        function menuItemStateIsEnabled(FeatureFlags, state) {
          var isHidden = state.hide || (state.hideFn && $injector.invoke(state.hideFn)) ;
          var isFeatureDisabled = state.featureFlag && !FeatureFlags.feature_flags[state.featureFlag];


          return (!isHidden && !isFeatureDisabled ) ;
        }

        function defineMenuItemStates(FeatureFlags, prefix) {
          return $state.get()
            .filter(function(s) {
              return s.sidebarMeta && menuItemStateIsEnabled(FeatureFlags, s) && (
                       !s.permission ||
                       (s.permission && (Auth.hasPermission(s.permission))) ||
                       (s.admin && Auth.isAdmin()) ||
                       Auth.isOperationsAdmin()
              );
            })
            .map(function(s) {
              var meta = s.sidebarMeta;

              var disableFlag = shouldMenuItemBeDisabled(s, FeatureFlags);

              var filteredData = {
                name: s.name,
                title: s.title,
                level: ((s.name.replace((prefix + '.'), '')).match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                children: s.childrenState,
                disabled: disableFlag,
              };

              return filteredData;
            })
            .sort(function(a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return wasMenuCollapsed === true ||
            (window.innerWidth <= layoutSizes.resWidthCollapseSidebar && !wasMenuCollapsed);
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }

        function shouldMenuItemBeDisabled(menuItem, FeatureFlags) {
          var disabled = menuItem.disabled;
          if (menuItem.requiresAnalyticsPurchase && $rootScope.currentParticipant) {
            disabled = !$rootScope.currentParticipant.config.product_config.analytics_modules[menuItem.requiresAnalyticsPurchase];
          }
          if(menuItem.quicksight !== undefined && menuItem.quicksight === true){
            var flg = FeatureFlags.isFlagEnabled('Quicksight_Beta');
            vm.quicksightBeta = flg;
          }
          if(vm.quicksightBeta === false){
            disabled = true;
            vm.quicksightBeta = true;
          }
          return disabled;
        }
      }
    };
  }
})();

/**
 * @author z.geddes
 * created on 03.01.2018
 */
(function() {
  'use strict';

  angular.module('littlepayPortalMerchantApp.theme')
    .directive('sidebarToggleMenu', sidebarToggleMenu)
    .directive('sidebarCollapseMenu', sidebarCollapseMenu)
    .directive('lpSidebarTogglingItem', lpSidebarTogglingItem)
    .controller('lpSidebarTogglingItemCtrl', lpSidebarTogglingItemCtrl)
    .directive('lpUiSrefTogglingSubmenu', lpUiSrefTogglingSubmenu)
    .directive('lpUiSrefToggler', lpUiSrefToggler);

  function sidebarToggleMenu(sidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            sidebarService.toggleMenuCollapsed();
          });
        });
      },
    };
  }

  /** @ngInject */
  function sidebarCollapseMenu(sidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!sidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              sidebarService.setMenuCollapsed(true);
            });
          }
        });
      },
    };
  }

  /** @ngInject */
  function lpSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'lpSidebarTogglingItemCtrl',
    };
  }

  /** @ngInject */
  function lpSidebarTogglingItemCtrl($scope, $element, $attrs, $state, sidebarService,
                                     $transitions) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.lpSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {

      vm.$$expandSubmenu = function() {
        console.warn('$$expandMenu should be overwritten by lpUiSrefTogglingSubmenu');
      };
      vm.$$collapseSubmenu = function() {
        console.warn('$$collapseSubmenu should be overwritten by lpUiSrefTogglingSubmenu');
      };
      var subItemsStateRefs = sidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('sidebar-item-expanded');
      };

      vm.$toggle = function() {
        if ($element.hasClass('sidebar-item-expanded')) {
          vm.$collapse();
        } else {
          vm.$expand();
        }
      };
      if (_isState($state.current)) {
        $element.addClass('sidebar-item-expanded');
      }

      $transitions.onStart({}, function(trans) {
        if (!_isState(trans.to()) && $element.hasClass('sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('sidebar-item-expanded');
        }
      });

      $transitions.onSuccess({}, function(trans) {
        if (_isState(trans.to()) && !$element.hasClass('sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('sidebar-item-expanded');
        }
      });

    }

    $transitions.onStart({}, function(trans) {
      _isParentState(trans.to());

    });

    _isParentState($state.current);

    function _isState(state) {

      return state && subItemsStateRefs.some(function(subItemState) {
        return state.name.indexOf(subItemState) === 0 ||
          (menuItem.children && menuItem.children.indexOf(state.name) > -1);
      });
    }

    function _isParentState(state) {
      if (state && menuItem && state.parentState && _stateParent(state.parentState)) {
        $element.addClass('selectedParent');
      } else {
        $element.removeClass('selectedParent');
      }
    }

    function _stateParent(state) {
      if (state) {
        return menuItem.name === state;
      }
    }
  }

  /** @ngInject */
  function lpUiSrefTogglingSubmenu() {
    return {
      restrict: 'A',
      require: '^lpSidebarTogglingItem',
      link: function(scope, el, attrs, lpSidebarTogglingItem) {
        lpSidebarTogglingItem.$$expandSubmenu = function() {
          el.slideDown();
        };
        lpSidebarTogglingItem.$$collapseSubmenu = function() {
          el.slideUp();
        };
      },
    };
  }

  /** @ngInject */
  function lpUiSrefToggler(sidebarService) {
    return {
      restrict: 'A',
      require: '^lpSidebarTogglingItem',
      link: function(scope, el, attrs, lpSidebarTogglingItem) {
        el.on('click', function() {
          if (sidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              sidebarService.setMenuCollapsed(false);
            });
            lpSidebarTogglingItem.$expand();
          } else {
            lpSidebarTogglingItem.$toggle();
          }
        });
      },
    };
  }

})();

'use strict';
angular.module('littlepayPortalMerchantApp.theme')
  .directive('summarybox', summarybox);
summarybox.$inject = ['$filter'];

/** @ngInject */
function summarybox($filter) {
  return {
    restrict: 'E',
    scope: {
      'boxTitle': '@',
      'summaryModel': '=',
      'currencySymbol': '=',
      'isPercentage': '@',
      'currentValueStyle': '@',
      'previousStartDate': '@',
      'previousEndDate': '@',
      'boxTooltip': '@',
    },
    templateUrl: 'app/theme/components/summarybox/summarybox.html',
    link: function(scope) {

      scope.formatValue = function(val) {
        if (this.isPercentage) {
          return val + '%';
        }

        var number = parseFloat(val);
        if (!!this.currencySymbol) {
          if (number < 1000) {
            return $filter('currency')(val, this.currencySymbol);
          } else {
            return $filter('currency')(number.toFixed(0), this.currencySymbol, 0);
          }
        }
        return $filter('number')(val);
      };

      scope.getPreviousPeriodTooltip = function() {
        if (scope.previousStartDate === scope.previousEndDate) {
          return 'Previous period was on ' + scope.previousStartDate;
        }
        return 'Previous period was from ' + scope.previousStartDate + ' to ' +
          scope.previousEndDate;
      };

      scope.showGrowth = function(model) {
        return model && (model.growth>0.09 || model.growth<-0.09);
      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('tableSort', tableSort);
tableSort.$inject = ['$location'];

/** @ngInject */
function tableSort($location) {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: 'app/theme/components/tableSort/tableSort.html',
    scope: {
      order: '=',
      by: '=',
      reverse: '=',
      sort: '=',
    },
    link: function(scope) {
      if ($location.search().order) {
        scope.by = $location.search().order;
      }
      if ($location.search().reverse) {
        var isFalse = $location.search().reverse === 'false';
        scope.reverse = !isFalse;
      }
      scope.onClick = function() {
        if (scope.order === scope.by) {
          scope.reverse = !scope.reverse;
        } else {
          scope.by = scope.order;
          scope.reverse = true;
        }

        $location.search('order', scope.order);
        $location.search('reverse', scope.reverse);

        scope.sort();

      };
    },
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .directive('timeline', timeline);
timeline.$inject = ['$location'];

/** @ngInject */
function timeline($location) {
  return {
    restrict: 'E',
    scope: {
      'ngModel': '=',
      'onChange': '=',
      'available': '=',
      'customTimelineOptions': '=',
    },
    templateUrl: 'app/theme/components/timeline/timeline.html',
    link: function(scope) {

      var getSelectedOptioon = function() {
        return scope.timelineOptions[scope.ngModel];
      };

      // TODO: KENNY: use custom timelineOptions or default one, discuss with Zehra
      scope.timelineOptions = scope.customTimelineOptions || this.getDefaultTimelineOptions(scope);

      var startDate = $location.search().start_date;
      var endDate = $location.search().end_date;

      var filteredTimeline = scope.timelineOptions.filter(function(s) {
        if (moment(s.start_date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') ===
          decodeURIComponent(startDate) &&
          moment(s.end_date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') ===
          decodeURIComponent(endDate)) {
          return s;
        }
      });

      scope.ngModel = filteredTimeline.length > 0 ?
        filteredTimeline[0].index :
        scope.timelineOptions[0].index;

      scope.updateTimeLine = function() {
        var selected = getSelectedOptioon();
        scope.$apply(function() {
          $location.search('start_date', encodeURIComponent(selected.start_date));
          $location.search('end_date', encodeURIComponent(selected.end_date));
        });

        scope.onChange(selected);
      };

      scope.onChange(getSelectedOptioon());
    },
    getDefaultTimelineOptions: function() {

      // This is for mocking
      var today = new Date(2018, 7, 26);
      // This should be the actual implementation:
      // var today = new Date();
      var yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      var lastWeekday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      var firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      var lastMonthToday = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
      var lastMonthLastDay = new Date(today.getFullYear(), today.getMonth(), 0);
      var lastThreeMonthToday = new Date(today.getFullYear(), today.getMonth() - 3,
        today.getDate());
      return [
        {
          'index': 0,
          'name': 'Previous Day',
          'start_date': moment(yesterday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
          'end_date': moment(yesterday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        }, {
          'index': 1,
          'name': 'Last 7 Days',
          'start_date': moment(lastWeekday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
          'end_date': moment(yesterday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        }, {
          'index': 2,
          'name': 'This Month',
          'start_date': moment(firstDayOfMonth).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
          'end_date': moment(yesterday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        }, {
          'index': 3,
          'name': 'Last 30 Days',
          'start_date': moment(lastMonthToday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
          'end_date': moment(yesterday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        }, {
          'index': 4,
          'name': 'Last Month',
          'start_date': moment(firstDayOfLastMonth).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
          'end_date': moment(lastMonthLastDay).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        }, {
          'index': 5,
          'name': 'Last 3 Months',
          'start_date': moment(lastThreeMonthToday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
          'end_date': moment(yesterday).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        }];
    },
  };
}

/*global angular, _, moment, $, jstz*/

/**
 * angular-timezone-selector
 * Forked from https://github.com/mishguruorg/angular-timezone-selector
 *
 * A simple directive that allows a user to pick their timezone
 *
 * Author:  Ashok Fernandez <ashok@mish.guru>
 * Date:    12/06/2015
 * License: MIT
 */
 'use strict';

angular.module('littlepayPortalMerchantApp.theme')
  .constant('_', _)
  .constant('moment', moment)
  .factory('timezoneFactory', ['_', 'moment', function (_, moment) {
    return {
      get: function () {
        var timezoneMap = {}
        moment.tz.names().forEach(function (zoneName) {
          var tz = moment.tz(zoneName)
          timezoneMap[zoneName] = {
            id: zoneName,
            name: zoneName.replace(/_/g, ' '),
            offset: 'UTC' + tz.format('Z'),
            nOffset: tz.utcOffset()
          }
        })
        return timezoneMap
      }
    }
  }])

  // Timezone name to country codemap
  .factory('zoneToCC', ['_', function (_) {
    // Note: zones is populated with the data from 'data/zone.csv' when this file is built
    var zones = [{"id":"1","cca2":"AD","name":"Europe/Andorra"},{"id":"2","cca2":"AE","name":"Asia/Dubai"},{"id":"3","cca2":"AF","name":"Asia/Kabul"},{"id":"4","cca2":"AG","name":"America/Antigua"},{"id":"5","cca2":"AI","name":"America/Anguilla"},{"id":"6","cca2":"AL","name":"Europe/Tirane"},{"id":"7","cca2":"AM","name":"Asia/Yerevan"},{"id":"8","cca2":"AO","name":"Africa/Luanda"},{"id":"9","cca2":"AQ","name":"Antarctica/McMurdo"},{"id":"10","cca2":"AQ","name":"Antarctica/Rothera"},{"id":"11","cca2":"AQ","name":"Antarctica/Palmer"},{"id":"12","cca2":"AQ","name":"Antarctica/Mawson"},{"id":"13","cca2":"AQ","name":"Antarctica/Davis"},{"id":"14","cca2":"AQ","name":"Antarctica/Casey"},{"id":"15","cca2":"AQ","name":"Antarctica/Vostok"},{"id":"16","cca2":"AQ","name":"Antarctica/DumontDUrville"},{"id":"17","cca2":"AQ","name":"Antarctica/Syowa"},{"id":"18","cca2":"AQ","name":"Antarctica/Troll"},{"id":"19","cca2":"AR","name":"America/Argentina/Buenos_Aires"},{"id":"20","cca2":"AR","name":"America/Argentina/Cordoba"},{"id":"21","cca2":"AR","name":"America/Argentina/Salta"},{"id":"22","cca2":"AR","name":"America/Argentina/Jujuy"},{"id":"23","cca2":"AR","name":"America/Argentina/Tucuman"},{"id":"24","cca2":"AR","name":"America/Argentina/Catamarca"},{"id":"25","cca2":"AR","name":"America/Argentina/La_Rioja"},{"id":"26","cca2":"AR","name":"America/Argentina/San_Juan"},{"id":"27","cca2":"AR","name":"America/Argentina/Mendoza"},{"id":"28","cca2":"AR","name":"America/Argentina/San_Luis"},{"id":"29","cca2":"AR","name":"America/Argentina/Rio_Gallegos"},{"id":"30","cca2":"AR","name":"America/Argentina/Ushuaia"},{"id":"31","cca2":"AS","name":"Pacific/Pago_Pago"},{"id":"32","cca2":"AT","name":"Europe/Vienna"},{"id":"33","cca2":"AU","name":"Australia/Lord_Howe"},{"id":"34","cca2":"AU","name":"Antarctica/Macquarie"},{"id":"35","cca2":"AU","name":"Australia/Hobart"},{"id":"36","cca2":"AU","name":"Australia/Currie"},{"id":"37","cca2":"AU","name":"Australia/Melbourne"},{"id":"38","cca2":"AU","name":"Australia/Sydney"},{"id":"39","cca2":"AU","name":"Australia/Broken_Hill"},{"id":"40","cca2":"AU","name":"Australia/Brisbane"},{"id":"41","cca2":"AU","name":"Australia/Lindeman"},{"id":"42","cca2":"AU","name":"Australia/Adelaide"},{"id":"43","cca2":"AU","name":"Australia/Darwin"},{"id":"44","cca2":"AU","name":"Australia/Perth"},{"id":"45","cca2":"AU","name":"Australia/Eucla"},{"id":"46","cca2":"AW","name":"America/Aruba"},{"id":"47","cca2":"AX","name":"Europe/Mariehamn"},{"id":"48","cca2":"AZ","name":"Asia/Baku"},{"id":"49","cca2":"BA","name":"Europe/Sarajevo"},{"id":"50","cca2":"BB","name":"America/Barbados"},{"id":"51","cca2":"BD","name":"Asia/Dhaka"},{"id":"52","cca2":"BE","name":"Europe/Brussels"},{"id":"53","cca2":"BF","name":"Africa/Ouagadougou"},{"id":"54","cca2":"BG","name":"Europe/Sofia"},{"id":"55","cca2":"BH","name":"Asia/Bahrain"},{"id":"56","cca2":"BI","name":"Africa/Bujumbura"},{"id":"57","cca2":"BJ","name":"Africa/Porto-Novo"},{"id":"58","cca2":"BL","name":"America/St_Barthelemy"},{"id":"59","cca2":"BM","name":"Atlantic/Bermuda"},{"id":"60","cca2":"BN","name":"Asia/Brunei"},{"id":"61","cca2":"BO","name":"America/La_Paz"},{"id":"62","cca2":"BQ","name":"America/Kralendijk"},{"id":"63","cca2":"BR","name":"America/Noronha"},{"id":"64","cca2":"BR","name":"America/Belem"},{"id":"65","cca2":"BR","name":"America/Fortaleza"},{"id":"66","cca2":"BR","name":"America/Recife"},{"id":"67","cca2":"BR","name":"America/Araguaina"},{"id":"68","cca2":"BR","name":"America/Maceio"},{"id":"69","cca2":"BR","name":"America/Bahia"},{"id":"70","cca2":"BR","name":"America/Sao_Paulo"},{"id":"71","cca2":"BR","name":"America/Campo_Grande"},{"id":"72","cca2":"BR","name":"America/Cuiaba"},{"id":"73","cca2":"BR","name":"America/Santarem"},{"id":"74","cca2":"BR","name":"America/Porto_Velho"},{"id":"75","cca2":"BR","name":"America/Boa_Vista"},{"id":"76","cca2":"BR","name":"America/Manaus"},{"id":"77","cca2":"BR","name":"America/Eirunepe"},{"id":"78","cca2":"BR","name":"America/Rio_Branco"},{"id":"79","cca2":"BS","name":"America/Nassau"},{"id":"80","cca2":"BT","name":"Asia/Thimphu"},{"id":"81","cca2":"BW","name":"Africa/Gaborone"},{"id":"82","cca2":"BY","name":"Europe/Minsk"},{"id":"83","cca2":"BZ","name":"America/Belize"},{"id":"84","cca2":"CA","name":"America/St_Johns"},{"id":"85","cca2":"CA","name":"America/Halifax"},{"id":"86","cca2":"CA","name":"America/Glace_Bay"},{"id":"87","cca2":"CA","name":"America/Moncton"},{"id":"88","cca2":"CA","name":"America/Goose_Bay"},{"id":"89","cca2":"CA","name":"America/Blanc-Sablon"},{"id":"90","cca2":"CA","name":"America/Toronto"},{"id":"91","cca2":"CA","name":"America/Nipigon"},{"id":"92","cca2":"CA","name":"America/Thunder_Bay"},{"id":"93","cca2":"CA","name":"America/Iqaluit"},{"id":"94","cca2":"CA","name":"America/Pangnirtung"},{"id":"95","cca2":"CA","name":"America/Resolute"},{"id":"96","cca2":"CA","name":"America/Atikokan"},{"id":"97","cca2":"CA","name":"America/Rankin_Inlet"},{"id":"98","cca2":"CA","name":"America/Winnipeg"},{"id":"99","cca2":"CA","name":"America/Rainy_River"},{"id":"100","cca2":"CA","name":"America/Regina"},{"id":"101","cca2":"CA","name":"America/Swift_Current"},{"id":"102","cca2":"CA","name":"America/Edmonton"},{"id":"103","cca2":"CA","name":"America/Cambridge_Bay"},{"id":"104","cca2":"CA","name":"America/Yellowknife"},{"id":"105","cca2":"CA","name":"America/Inuvik"},{"id":"106","cca2":"CA","name":"America/Creston"},{"id":"107","cca2":"CA","name":"America/Dawson_Creek"},{"id":"108","cca2":"CA","name":"America/Vancouver"},{"id":"109","cca2":"CA","name":"America/Whitehorse"},{"id":"110","cca2":"CA","name":"America/Dawson"},{"id":"111","cca2":"CC","name":"Indian/Cocos"},{"id":"112","cca2":"CD","name":"Africa/Kinshasa"},{"id":"113","cca2":"CD","name":"Africa/Lubumbashi"},{"id":"114","cca2":"CF","name":"Africa/Bangui"},{"id":"115","cca2":"CG","name":"Africa/Brazzaville"},{"id":"116","cca2":"CH","name":"Europe/Zurich"},{"id":"117","cca2":"CI","name":"Africa/Abidjan"},{"id":"118","cca2":"CK","name":"Pacific/Rarotonga"},{"id":"119","cca2":"CL","name":"America/Santiago"},{"id":"120","cca2":"CL","name":"Pacific/Easter"},{"id":"121","cca2":"CM","name":"Africa/Douala"},{"id":"122","cca2":"CN","name":"Asia/Shanghai"},{"id":"123","cca2":"CN","name":"Asia/Harbin"},{"id":"124","cca2":"CN","name":"Asia/Chongqing"},{"id":"125","cca2":"CN","name":"Asia/Urumqi"},{"id":"126","cca2":"CN","name":"Asia/Kashgar"},{"id":"127","cca2":"CO","name":"America/Bogota"},{"id":"128","cca2":"CR","name":"America/Costa_Rica"},{"id":"129","cca2":"CU","name":"America/Havana"},{"id":"130","cca2":"CV","name":"Atlantic/Cape_Verde"},{"id":"131","cca2":"CW","name":"America/Curacao"},{"id":"132","cca2":"CX","name":"Indian/Christmas"},{"id":"133","cca2":"CY","name":"Asia/Nicosia"},{"id":"134","cca2":"CZ","name":"Europe/Prague"},{"id":"135","cca2":"DE","name":"Europe/Berlin"},{"id":"136","cca2":"DE","name":"Europe/Busingen"},{"id":"137","cca2":"DJ","name":"Africa/Djibouti"},{"id":"138","cca2":"DK","name":"Europe/Copenhagen"},{"id":"139","cca2":"DM","name":"America/Dominica"},{"id":"140","cca2":"DO","name":"America/Santo_Domingo"},{"id":"141","cca2":"DZ","name":"Africa/Algiers"},{"id":"142","cca2":"EC","name":"America/Guayaquil"},{"id":"143","cca2":"EC","name":"Pacific/Galapagos"},{"id":"144","cca2":"EE","name":"Europe/Tallinn"},{"id":"145","cca2":"EG","name":"Africa/Cairo"},{"id":"146","cca2":"EH","name":"Africa/El_Aaiun"},{"id":"147","cca2":"ER","name":"Africa/Asmara"},{"id":"148","cca2":"ES","name":"Europe/Madrid"},{"id":"149","cca2":"ES","name":"Africa/Ceuta"},{"id":"150","cca2":"ES","name":"Atlantic/Canary"},{"id":"151","cca2":"ET","name":"Africa/Addis_Ababa"},{"id":"152","cca2":"FI","name":"Europe/Helsinki"},{"id":"153","cca2":"FJ","name":"Pacific/Fiji"},{"id":"154","cca2":"FK","name":"Atlantic/Stanley"},{"id":"155","cca2":"FM","name":"Pacific/Chuuk"},{"id":"156","cca2":"FM","name":"Pacific/Pohnpei"},{"id":"157","cca2":"FM","name":"Pacific/Kosrae"},{"id":"158","cca2":"FO","name":"Atlantic/Faroe"},{"id":"159","cca2":"FR","name":"Europe/Paris"},{"id":"160","cca2":"GA","name":"Africa/Libreville"},{"id":"161","cca2":"GB","name":"Europe/London"},{"id":"162","cca2":"GD","name":"America/Grenada"},{"id":"163","cca2":"GE","name":"Asia/Tbilisi"},{"id":"164","cca2":"GF","name":"America/Cayenne"},{"id":"165","cca2":"GG","name":"Europe/Guernsey"},{"id":"166","cca2":"GH","name":"Africa/Accra"},{"id":"167","cca2":"GI","name":"Europe/Gibraltar"},{"id":"168","cca2":"GL","name":"America/Godthab"},{"id":"169","cca2":"GL","name":"America/Danmarkshavn"},{"id":"170","cca2":"GL","name":"America/Scoresbysund"},{"id":"171","cca2":"GL","name":"America/Thule"},{"id":"172","cca2":"GM","name":"Africa/Banjul"},{"id":"173","cca2":"GN","name":"Africa/Conakry"},{"id":"174","cca2":"GP","name":"America/Guadeloupe"},{"id":"175","cca2":"GQ","name":"Africa/Malabo"},{"id":"176","cca2":"GR","name":"Europe/Athens"},{"id":"177","cca2":"GS","name":"Atlantic/South_Georgia"},{"id":"178","cca2":"GT","name":"America/Guatemala"},{"id":"179","cca2":"GU","name":"Pacific/Guam"},{"id":"180","cca2":"GW","name":"Africa/Bissau"},{"id":"181","cca2":"GY","name":"America/Guyana"},{"id":"182","cca2":"HK","name":"Asia/Hong_Kong"},{"id":"183","cca2":"HN","name":"America/Tegucigalpa"},{"id":"184","cca2":"HR","name":"Europe/Zagreb"},{"id":"185","cca2":"HT","name":"America/Port-au-Prince"},{"id":"186","cca2":"HU","name":"Europe/Budapest"},{"id":"187","cca2":"ID","name":"Asia/Jakarta"},{"id":"188","cca2":"ID","name":"Asia/Pontianak"},{"id":"189","cca2":"ID","name":"Asia/Makassar"},{"id":"190","cca2":"ID","name":"Asia/Jayapura"},{"id":"191","cca2":"IE","name":"Europe/Dublin"},{"id":"192","cca2":"IL","name":"Asia/Jerusalem"},{"id":"193","cca2":"IM","name":"Europe/Isle_of_Man"},{"id":"194","cca2":"IN","name":"Asia/Kolkata"},{"id":"195","cca2":"IO","name":"Indian/Chagos"},{"id":"196","cca2":"IQ","name":"Asia/Baghdad"},{"id":"197","cca2":"IR","name":"Asia/Tehran"},{"id":"198","cca2":"IS","name":"Atlantic/Reykjavik"},{"id":"199","cca2":"IT","name":"Europe/Rome"},{"id":"200","cca2":"JE","name":"Europe/Jersey"},{"id":"201","cca2":"JM","name":"America/Jamaica"},{"id":"202","cca2":"JO","name":"Asia/Amman"},{"id":"203","cca2":"JP","name":"Asia/Tokyo"},{"id":"204","cca2":"KE","name":"Africa/Nairobi"},{"id":"205","cca2":"KG","name":"Asia/Bishkek"},{"id":"206","cca2":"KH","name":"Asia/Phnom_Penh"},{"id":"207","cca2":"KI","name":"Pacific/Tarawa"},{"id":"208","cca2":"KI","name":"Pacific/Enderbury"},{"id":"209","cca2":"KI","name":"Pacific/Kiritimati"},{"id":"210","cca2":"KM","name":"Indian/Comoro"},{"id":"211","cca2":"KN","name":"America/St_Kitts"},{"id":"212","cca2":"KP","name":"Asia/Pyongyang"},{"id":"213","cca2":"KR","name":"Asia/Seoul"},{"id":"214","cca2":"KW","name":"Asia/Kuwait"},{"id":"215","cca2":"KY","name":"America/Cayman"},{"id":"216","cca2":"KZ","name":"Asia/Almaty"},{"id":"217","cca2":"KZ","name":"Asia/Qyzylorda"},{"id":"218","cca2":"KZ","name":"Asia/Aqtobe"},{"id":"219","cca2":"KZ","name":"Asia/Aqtau"},{"id":"220","cca2":"KZ","name":"Asia/Oral"},{"id":"221","cca2":"LA","name":"Asia/Vientiane"},{"id":"222","cca2":"LB","name":"Asia/Beirut"},{"id":"223","cca2":"LC","name":"America/St_Lucia"},{"id":"224","cca2":"LI","name":"Europe/Vaduz"},{"id":"225","cca2":"LK","name":"Asia/Colombo"},{"id":"226","cca2":"LR","name":"Africa/Monrovia"},{"id":"227","cca2":"LS","name":"Africa/Maseru"},{"id":"228","cca2":"LT","name":"Europe/Vilnius"},{"id":"229","cca2":"LU","name":"Europe/Luxembourg"},{"id":"230","cca2":"LV","name":"Europe/Riga"},{"id":"231","cca2":"LY","name":"Africa/Tripoli"},{"id":"232","cca2":"MA","name":"Africa/Casablanca"},{"id":"233","cca2":"MC","name":"Europe/Monaco"},{"id":"234","cca2":"MD","name":"Europe/Chisinau"},{"id":"235","cca2":"ME","name":"Europe/Podgorica"},{"id":"236","cca2":"MF","name":"America/Marigot"},{"id":"237","cca2":"MG","name":"Indian/Antananarivo"},{"id":"238","cca2":"MH","name":"Pacific/Majuro"},{"id":"239","cca2":"MH","name":"Pacific/Kwajalein"},{"id":"240","cca2":"MK","name":"Europe/Skopje"},{"id":"241","cca2":"ML","name":"Africa/Bamako"},{"id":"242","cca2":"MM","name":"Asia/Rangoon"},{"id":"243","cca2":"MN","name":"Asia/Ulaanbaatar"},{"id":"244","cca2":"MN","name":"Asia/Hovd"},{"id":"245","cca2":"MN","name":"Asia/Choibalsan"},{"id":"246","cca2":"MO","name":"Asia/Macau"},{"id":"247","cca2":"MP","name":"Pacific/Saipan"},{"id":"248","cca2":"MQ","name":"America/Martinique"},{"id":"249","cca2":"MR","name":"Africa/Nouakchott"},{"id":"250","cca2":"MS","name":"America/Montserrat"},{"id":"251","cca2":"MT","name":"Europe/Malta"},{"id":"252","cca2":"MU","name":"Indian/Mauritius"},{"id":"253","cca2":"MV","name":"Indian/Maldives"},{"id":"254","cca2":"MW","name":"Africa/Blantyre"},{"id":"255","cca2":"MX","name":"America/Mexico_City"},{"id":"256","cca2":"MX","name":"America/Cancun"},{"id":"257","cca2":"MX","name":"America/Merida"},{"id":"258","cca2":"MX","name":"America/Monterrey"},{"id":"259","cca2":"MX","name":"America/Matamoros"},{"id":"260","cca2":"MX","name":"America/Mazatlan"},{"id":"261","cca2":"MX","name":"America/Chihuahua"},{"id":"262","cca2":"MX","name":"America/Ojinaga"},{"id":"263","cca2":"MX","name":"America/Hermosillo"},{"id":"264","cca2":"MX","name":"America/Tijuana"},{"id":"265","cca2":"MX","name":"America/Santa_Isabel"},{"id":"266","cca2":"MX","name":"America/Bahia_Banderas"},{"id":"267","cca2":"MY","name":"Asia/Kuala_Lumpur"},{"id":"268","cca2":"MY","name":"Asia/Kuching"},{"id":"269","cca2":"MZ","name":"Africa/Maputo"},{"id":"270","cca2":"NA","name":"Africa/Windhoek"},{"id":"271","cca2":"NC","name":"Pacific/Noumea"},{"id":"272","cca2":"NE","name":"Africa/Niamey"},{"id":"273","cca2":"NF","name":"Pacific/Norfolk"},{"id":"274","cca2":"NG","name":"Africa/Lagos"},{"id":"275","cca2":"NI","name":"America/Managua"},{"id":"276","cca2":"NL","name":"Europe/Amsterdam"},{"id":"277","cca2":"NO","name":"Europe/Oslo"},{"id":"278","cca2":"NP","name":"Asia/Kathmandu"},{"id":"279","cca2":"NR","name":"Pacific/Nauru"},{"id":"280","cca2":"NU","name":"Pacific/Niue"},{"id":"281","cca2":"NZ","name":"Pacific/Auckland"},{"id":"282","cca2":"NZ","name":"Pacific/Chatham"},{"id":"283","cca2":"OM","name":"Asia/Muscat"},{"id":"284","cca2":"PA","name":"America/Panama"},{"id":"285","cca2":"PE","name":"America/Lima"},{"id":"286","cca2":"PF","name":"Pacific/Tahiti"},{"id":"287","cca2":"PF","name":"Pacific/Marquesas"},{"id":"288","cca2":"PF","name":"Pacific/Gambier"},{"id":"289","cca2":"PG","name":"Pacific/Port_Moresby"},{"id":"290","cca2":"PH","name":"Asia/Manila"},{"id":"291","cca2":"PK","name":"Asia/Karachi"},{"id":"292","cca2":"PL","name":"Europe/Warsaw"},{"id":"293","cca2":"PM","name":"America/Miquelon"},{"id":"294","cca2":"PN","name":"Pacific/Pitcairn"},{"id":"295","cca2":"PR","name":"America/Puerto_Rico"},{"id":"296","cca2":"PS","name":"Asia/Gaza"},{"id":"297","cca2":"PS","name":"Asia/Hebron"},{"id":"298","cca2":"PT","name":"Europe/Lisbon"},{"id":"299","cca2":"PT","name":"Atlantic/Madeira"},{"id":"300","cca2":"PT","name":"Atlantic/Azores"},{"id":"301","cca2":"PW","name":"Pacific/Palau"},{"id":"302","cca2":"PY","name":"America/Asuncion"},{"id":"303","cca2":"QA","name":"Asia/Qatar"},{"id":"304","cca2":"RE","name":"Indian/Reunion"},{"id":"305","cca2":"RO","name":"Europe/Bucharest"},{"id":"306","cca2":"RS","name":"Europe/Belgrade"},{"id":"307","cca2":"RU","name":"Europe/Kaliningrad"},{"id":"308","cca2":"RU","name":"Europe/Moscow"},{"id":"309","cca2":"RU","name":"Europe/Volgograd"},{"id":"310","cca2":"RU","name":"Europe/Samara"},{"id":"311","cca2":"RU","name":"Europe/Simferopol"},{"id":"312","cca2":"RU","name":"Asia/Yekaterinburg"},{"id":"313","cca2":"RU","name":"Asia/Omsk"},{"id":"314","cca2":"RU","name":"Asia/Novosibirsk"},{"id":"315","cca2":"RU","name":"Asia/Novokuznetsk"},{"id":"316","cca2":"RU","name":"Asia/Krasnoyarsk"},{"id":"317","cca2":"RU","name":"Asia/Irkutsk"},{"id":"318","cca2":"RU","name":"Asia/Yakutsk"},{"id":"319","cca2":"RU","name":"Asia/Khandyga"},{"id":"320","cca2":"RU","name":"Asia/Vladivostok"},{"id":"321","cca2":"RU","name":"Asia/Sakhalin"},{"id":"322","cca2":"RU","name":"Asia/Ust-Nera"},{"id":"323","cca2":"RU","name":"Asia/Magadan"},{"id":"324","cca2":"RU","name":"Asia/Kamchatka"},{"id":"325","cca2":"RU","name":"Asia/Anadyr"},{"id":"326","cca2":"RW","name":"Africa/Kigali"},{"id":"327","cca2":"SA","name":"Asia/Riyadh"},{"id":"328","cca2":"SB","name":"Pacific/Guadalcanal"},{"id":"329","cca2":"SC","name":"Indian/Mahe"},{"id":"330","cca2":"SD","name":"Africa/Khartoum"},{"id":"331","cca2":"SE","name":"Europe/Stockholm"},{"id":"332","cca2":"SG","name":"Asia/Singapore"},{"id":"333","cca2":"SH","name":"Atlantic/St_Helena"},{"id":"334","cca2":"SI","name":"Europe/Ljubljana"},{"id":"335","cca2":"SJ","name":"Arctic/Longyearbyen"},{"id":"336","cca2":"SK","name":"Europe/Bratislava"},{"id":"337","cca2":"SL","name":"Africa/Freetown"},{"id":"338","cca2":"SM","name":"Europe/San_Marino"},{"id":"339","cca2":"SN","name":"Africa/Dakar"},{"id":"340","cca2":"SO","name":"Africa/Mogadishu"},{"id":"341","cca2":"SR","name":"America/Paramaribo"},{"id":"342","cca2":"SS","name":"Africa/Juba"},{"id":"343","cca2":"ST","name":"Africa/Sao_Tome"},{"id":"344","cca2":"SV","name":"America/El_Salvador"},{"id":"345","cca2":"SX","name":"America/Lower_Princes"},{"id":"346","cca2":"SY","name":"Asia/Damascus"},{"id":"347","cca2":"SZ","name":"Africa/Mbabane"},{"id":"348","cca2":"TC","name":"America/Grand_Turk"},{"id":"349","cca2":"TD","name":"Africa/Ndjamena"},{"id":"350","cca2":"TF","name":"Indian/Kerguelen"},{"id":"351","cca2":"TG","name":"Africa/Lome"},{"id":"352","cca2":"TH","name":"Asia/Bangkok"},{"id":"353","cca2":"TJ","name":"Asia/Dushanbe"},{"id":"354","cca2":"TK","name":"Pacific/Fakaofo"},{"id":"355","cca2":"TL","name":"Asia/Dili"},{"id":"356","cca2":"TM","name":"Asia/Ashgabat"},{"id":"357","cca2":"TN","name":"Africa/Tunis"},{"id":"358","cca2":"TO","name":"Pacific/Tongatapu"},{"id":"359","cca2":"TR","name":"Europe/Istanbul"},{"id":"360","cca2":"TT","name":"America/Port_of_Spain"},{"id":"361","cca2":"TV","name":"Pacific/Funafuti"},{"id":"362","cca2":"TW","name":"Asia/Taipei"},{"id":"363","cca2":"TZ","name":"Africa/Dar_es_Salaam"},{"id":"364","cca2":"UA","name":"Europe/Kiev"},{"id":"365","cca2":"UA","name":"Europe/Uzhgorod"},{"id":"366","cca2":"UA","name":"Europe/Zaporozhye"},{"id":"367","cca2":"UG","name":"Africa/Kampala"},{"id":"368","cca2":"UM","name":"Pacific/Johnston"},{"id":"369","cca2":"UM","name":"Pacific/Midway"},{"id":"370","cca2":"UM","name":"Pacific/Wake"},{"id":"371","cca2":"US","name":"America/New_York"},{"id":"372","cca2":"US","name":"America/Detroit"},{"id":"373","cca2":"US","name":"America/Kentucky/Louisville"},{"id":"374","cca2":"US","name":"America/Kentucky/Monticello"},{"id":"375","cca2":"US","name":"America/Indiana/Indianapolis"},{"id":"376","cca2":"US","name":"America/Indiana/Vincennes"},{"id":"377","cca2":"US","name":"America/Indiana/Winamac"},{"id":"378","cca2":"US","name":"America/Indiana/Marengo"},{"id":"379","cca2":"US","name":"America/Indiana/Petersburg"},{"id":"380","cca2":"US","name":"America/Indiana/Vevay"},{"id":"381","cca2":"US","name":"America/Chicago"},{"id":"382","cca2":"US","name":"America/Indiana/Tell_City"},{"id":"383","cca2":"US","name":"America/Indiana/Knox"},{"id":"384","cca2":"US","name":"America/Menominee"},{"id":"385","cca2":"US","name":"America/North_Dakota/Center"},{"id":"386","cca2":"US","name":"America/North_Dakota/New_Salem"},{"id":"387","cca2":"US","name":"America/North_Dakota/Beulah"},{"id":"388","cca2":"US","name":"America/Denver"},{"id":"389","cca2":"US","name":"America/Boise"},{"id":"390","cca2":"US","name":"America/Phoenix"},{"id":"391","cca2":"US","name":"America/Los_Angeles"},{"id":"392","cca2":"US","name":"America/Anchorage"},{"id":"393","cca2":"US","name":"America/Juneau"},{"id":"394","cca2":"US","name":"America/Sitka"},{"id":"395","cca2":"US","name":"America/Yakutat"},{"id":"396","cca2":"US","name":"America/Nome"},{"id":"397","cca2":"US","name":"America/Adak"},{"id":"398","cca2":"US","name":"America/Metlakatla"},{"id":"399","cca2":"US","name":"Pacific/Honolulu"},{"id":"400","cca2":"UY","name":"America/Montevideo"},{"id":"401","cca2":"UZ","name":"Asia/Samarkand"},{"id":"402","cca2":"UZ","name":"Asia/Tashkent"},{"id":"403","cca2":"VA","name":"Europe/Vatican"},{"id":"404","cca2":"VC","name":"America/St_Vincent"},{"id":"405","cca2":"VE","name":"America/Caracas"},{"id":"406","cca2":"VG","name":"America/Tortola"},{"id":"407","cca2":"VI","name":"America/St_Thomas"},{"id":"408","cca2":"VN","name":"Asia/Ho_Chi_Minh"},{"id":"409","cca2":"VU","name":"Pacific/Efate"},{"id":"410","cca2":"WF","name":"Pacific/Wallis"},{"id":"411","cca2":"WS","name":"Pacific/Apia"},{"id":"412","cca2":"YE","name":"Asia/Aden"},{"id":"413","cca2":"YT","name":"Indian/Mayotte"},{"id":"414","cca2":"ZA","name":"Africa/Johannesburg"},{"id":"415","cca2":"ZM","name":"Africa/Lusaka"},{"id":"416","cca2":"ZW","name":"Africa/Harare"},{"id":"417","cca2":"CA","name":"America/Montreal"}]
    var zoneMap = {}
    zones.forEach( function (zone) {
      zoneMap[zone.name] = zone.cca2
    })
    return zoneMap
  }])

  // Country code to country name map
  .factory('CCToCountryName', ['_', function (_) {
    // Note: codes is populated with the data from 'data/cca2_to_country_name.csv' when this file is built
    var codes = [{"cca2":"AF","name":"Afghanistan"},{"cca2":"AX","name":"Aland Islands"},{"cca2":"AL","name":"Albania"},{"cca2":"DZ","name":"Algeria"},{"cca2":"AS","name":"American Samoa"},{"cca2":"AD","name":"Andorra"},{"cca2":"AO","name":"Angola"},{"cca2":"AI","name":"Anguilla"},{"cca2":"AQ","name":"Antarctica"},{"cca2":"AG","name":"Antigua And Barbuda"},{"cca2":"AR","name":"Argentina"},{"cca2":"AM","name":"Armenia"},{"cca2":"AW","name":"Aruba"},{"cca2":"AU","name":"Australia"},{"cca2":"AT","name":"Austria"},{"cca2":"AZ","name":"Azerbaijan"},{"cca2":"BS","name":"Bahamas"},{"cca2":"BH","name":"Bahrain"},{"cca2":"BD","name":"Bangladesh"},{"cca2":"BB","name":"Barbados"},{"cca2":"BY","name":"Belarus"},{"cca2":"BE","name":"Belgium"},{"cca2":"BZ","name":"Belize"},{"cca2":"BJ","name":"Benin"},{"cca2":"BM","name":"Bermuda"},{"cca2":"BT","name":"Bhutan"},{"cca2":"BO","name":"Bolivia"},{"cca2":"BA","name":"Bosnia And Herzegovina"},{"cca2":"BW","name":"Botswana"},{"cca2":"BV","name":"Bouvet Island"},{"cca2":"BR","name":"Brazil"},{"cca2":"IO","name":"British Indian Ocean Territory"},{"cca2":"BN","name":"Brunei Darussalam"},{"cca2":"BG","name":"Bulgaria"},{"cca2":"BF","name":"Burkina Faso"},{"cca2":"BI","name":"Burundi"},{"cca2":"KH","name":"Cambodia"},{"cca2":"CM","name":"Cameroon"},{"cca2":"CA","name":"Canada"},{"cca2":"CV","name":"Cape Verde"},{"cca2":"KY","name":"Cayman Islands"},{"cca2":"CF","name":"Central African Republic"},{"cca2":"TD","name":"Chad"},{"cca2":"CL","name":"Chile"},{"cca2":"CN","name":"China"},{"cca2":"CX","name":"Christmas Island"},{"cca2":"CC","name":"Cocos (Keeling) Islands"},{"cca2":"CO","name":"Colombia"},{"cca2":"KM","name":"Comoros"},{"cca2":"CG","name":"Congo"},{"cca2":"CD","name":"Congo (Democratic Republic)"},{"cca2":"CK","name":"Cook Islands"},{"cca2":"CR","name":"Costa Rica"},{"cca2":"CI","name":"Cote D'Ivoire"},{"cca2":"HR","name":"Croatia"},{"cca2":"CU","name":"Cuba"},{"cca2":"CY","name":"Cyprus"},{"cca2":"CZ","name":"Czech Republic"},{"cca2":"DK","name":"Denmark"},{"cca2":"DJ","name":"Djibouti"},{"cca2":"DM","name":"Dominica"},{"cca2":"DO","name":"Dominican Republic"},{"cca2":"EC","name":"Ecuador"},{"cca2":"EG","name":"Egypt"},{"cca2":"SV","name":"El Salvador"},{"cca2":"GQ","name":"Equatorial Guinea"},{"cca2":"ER","name":"Eritrea"},{"cca2":"EE","name":"Estonia"},{"cca2":"ET","name":"Ethiopia"},{"cca2":"FK","name":"Falkland Islands (Malvinas)"},{"cca2":"FO","name":"Faroe Islands"},{"cca2":"FJ","name":"Fiji"},{"cca2":"FI","name":"Finland"},{"cca2":"FR","name":"France"},{"cca2":"GF","name":"French Guiana"},{"cca2":"PF","name":"French Polynesia"},{"cca2":"TF","name":"French Southern Territories"},{"cca2":"GA","name":"Gabon"},{"cca2":"GM","name":"Gambia"},{"cca2":"GE","name":"Georgia"},{"cca2":"DE","name":"Germany"},{"cca2":"GH","name":"Ghana"},{"cca2":"GI","name":"Gibraltar"},{"cca2":"GR","name":"Greece"},{"cca2":"GL","name":"Greenland"},{"cca2":"GD","name":"Grenada"},{"cca2":"GP","name":"Guadeloupe"},{"cca2":"GU","name":"Guam"},{"cca2":"GT","name":"Guatemala"},{"cca2":"GG","name":"Guernsey"},{"cca2":"GN","name":"Guinea"},{"cca2":"GW","name":"Guinea-Bissau"},{"cca2":"GY","name":"Guyana"},{"cca2":"HT","name":"Haiti"},{"cca2":"HM","name":"Heard Island & Mcdonald Islands"},{"cca2":"VA","name":"Holy See (Vatican City State)"},{"cca2":"HN","name":"Honduras"},{"cca2":"HK","name":"Hong Kong"},{"cca2":"HU","name":"Hungary"},{"cca2":"IS","name":"Iceland"},{"cca2":"IN","name":"India"},{"cca2":"ID","name":"Indonesia"},{"cca2":"IR","name":"Iran (Islamic Republic Of)"},{"cca2":"IQ","name":"Iraq"},{"cca2":"IE","name":"Ireland"},{"cca2":"IM","name":"Isle Of Man"},{"cca2":"IL","name":"Israel"},{"cca2":"IT","name":"Italy"},{"cca2":"JM","name":"Jamaica"},{"cca2":"JP","name":"Japan"},{"cca2":"JE","name":"Jersey"},{"cca2":"JO","name":"Jordan"},{"cca2":"KZ","name":"Kazakhstan"},{"cca2":"KE","name":"Kenya"},{"cca2":"KI","name":"Kiribati"},{"cca2":"KR","name":"Korea"},{"cca2":"KW","name":"Kuwait"},{"cca2":"KG","name":"Kyrgyzstan"},{"cca2":"LA","name":"Lao People's Democratic Republic"},{"cca2":"LV","name":"Latvia"},{"cca2":"LB","name":"Lebanon"},{"cca2":"LS","name":"Lesotho"},{"cca2":"LR","name":"Liberia"},{"cca2":"LY","name":"Libyan Arab Jamahiriya"},{"cca2":"LI","name":"Liechtenstein"},{"cca2":"LT","name":"Lithuania"},{"cca2":"LU","name":"Luxembourg"},{"cca2":"MO","name":"Macao"},{"cca2":"MK","name":"Macedonia"},{"cca2":"MG","name":"Madagascar"},{"cca2":"MW","name":"Malawi"},{"cca2":"MY","name":"Malaysia"},{"cca2":"MV","name":"Maldives"},{"cca2":"ML","name":"Mali"},{"cca2":"MT","name":"Malta"},{"cca2":"MH","name":"Marshall Islands"},{"cca2":"MQ","name":"Martinique"},{"cca2":"MR","name":"Mauritania"},{"cca2":"MU","name":"Mauritius"},{"cca2":"YT","name":"Mayotte"},{"cca2":"MX","name":"Mexico"},{"cca2":"FM","name":"Micronesia (Federated States Of)"},{"cca2":"MD","name":"Moldova"},{"cca2":"MC","name":"Monaco"},{"cca2":"MN","name":"Mongolia"},{"cca2":"ME","name":"Montenegro"},{"cca2":"MS","name":"Montserrat"},{"cca2":"MA","name":"Morocco"},{"cca2":"MZ","name":"Mozambique"},{"cca2":"MM","name":"Myanmar"},{"cca2":"NA","name":"Namibia"},{"cca2":"NR","name":"Nauru"},{"cca2":"NP","name":"Nepal"},{"cca2":"NL","name":"Netherlands"},{"cca2":"AN","name":"Netherlands Antilles"},{"cca2":"NC","name":"New Caledonia"},{"cca2":"NZ","name":"New Zealand"},{"cca2":"NI","name":"Nicaragua"},{"cca2":"NE","name":"Niger"},{"cca2":"NG","name":"Nigeria"},{"cca2":"NU","name":"Niue"},{"cca2":"NF","name":"Norfolk Island"},{"cca2":"MP","name":"Northern Mariana Islands"},{"cca2":"NO","name":"Norway"},{"cca2":"OM","name":"Oman"},{"cca2":"PK","name":"Pakistan"},{"cca2":"PW","name":"Palau"},{"cca2":"PS","name":"Palestinian Territory (Occupied)"},{"cca2":"PA","name":"Panama"},{"cca2":"PG","name":"Papua New Guinea"},{"cca2":"PY","name":"Paraguay"},{"cca2":"PE","name":"Peru"},{"cca2":"PH","name":"Philippines"},{"cca2":"PN","name":"Pitcairn"},{"cca2":"PL","name":"Poland"},{"cca2":"PT","name":"Portugal"},{"cca2":"PR","name":"Puerto Rico"},{"cca2":"QA","name":"Qatar"},{"cca2":"RE","name":"Reunion"},{"cca2":"RO","name":"Romania"},{"cca2":"RU","name":"Russian Federation"},{"cca2":"RW","name":"Rwanda"},{"cca2":"BL","name":"Saint Barthelemy"},{"cca2":"SH","name":"Saint Helena"},{"cca2":"KN","name":"Saint Kitts And Nevis"},{"cca2":"LC","name":"Saint Lucia"},{"cca2":"MF","name":"Saint Martin"},{"cca2":"PM","name":"Saint Pierre And Miquelon"},{"cca2":"VC","name":"Saint Vincent And Grenadines"},{"cca2":"WS","name":"Samoa"},{"cca2":"SM","name":"San Marino"},{"cca2":"ST","name":"Sao Tome And Principe"},{"cca2":"SA","name":"Saudi Arabia"},{"cca2":"SN","name":"Senegal"},{"cca2":"RS","name":"Serbia"},{"cca2":"SC","name":"Seychelles"},{"cca2":"SL","name":"Sierra Leone"},{"cca2":"SG","name":"Singapore"},{"cca2":"SK","name":"Slovakia"},{"cca2":"SI","name":"Slovenia"},{"cca2":"SB","name":"Solomon Islands"},{"cca2":"SO","name":"Somalia"},{"cca2":"SS","name":"South Sudan"},{"cca2":"ZA","name":"South Africa"},{"cca2":"GS","name":"South Georgia And Sandwich Isl."},{"cca2":"ES","name":"Spain"},{"cca2":"LK","name":"Sri Lanka"},{"cca2":"SD","name":"Sudan"},{"cca2":"SR","name":"Suriname"},{"cca2":"SJ","name":"Svalbard And Jan Mayen"},{"cca2":"SZ","name":"Swaziland"},{"cca2":"SE","name":"Sweden"},{"cca2":"CH","name":"Switzerland"},{"cca2":"SY","name":"Syrian Arab Republic"},{"cca2":"TW","name":"Taiwan"},{"cca2":"TJ","name":"Tajikistan"},{"cca2":"TZ","name":"Tanzania"},{"cca2":"TH","name":"Thailand"},{"cca2":"TL","name":"Timor-Leste"},{"cca2":"TG","name":"Togo"},{"cca2":"TK","name":"Tokelau"},{"cca2":"TO","name":"Tonga"},{"cca2":"TT","name":"Trinidad And Tobago"},{"cca2":"TN","name":"Tunisia"},{"cca2":"TR","name":"Turkey"},{"cca2":"TM","name":"Turkmenistan"},{"cca2":"TC","name":"Turks And Caicos Islands"},{"cca2":"TV","name":"Tuvalu"},{"cca2":"UG","name":"Uganda"},{"cca2":"UA","name":"Ukraine"},{"cca2":"AE","name":"United Arab Emirates"},{"cca2":"GB","name":"United Kingdom"},{"cca2":"US","name":"United States"},{"cca2":"UM","name":"United States Outlying Islands"},{"cca2":"UY","name":"Uruguay"},{"cca2":"UZ","name":"Uzbekistan"},{"cca2":"VU","name":"Vanuatu"},{"cca2":"VE","name":"Venezuela"},{"cca2":"VN","name":"Viet Nam"},{"cca2":"VG","name":"Virgin Islands (British)"},{"cca2":"VI","name":"Virgin Islands (U.S.)"},{"cca2":"WF","name":"Wallis And Futuna"},{"cca2":"EH","name":"Western Sahara"},{"cca2":"YE","name":"Yemen"},{"cca2":"ZM","name":"Zambia"},{"cca2":"ZW","name":"Zimbabwe"},{"cca2":"SX","name":"Sint Maarten"},{"cca2":"CW","name":"Curacao"},{"cca2":"BQ","name":"Bonaire"},{"cca2":"KP","name":"North Korea"}]
    var codeMap = {}
    codes.forEach(function (code) {
      codeMap[code.cca2] = code.name
    })
    return codeMap
  }])

  .directive('timezoneSelector', ['_', 'moment', 'timezoneFactory', 'zoneToCC','$timeout', 'CCToCountryName', function (_, moment, timezoneFactory, zoneToCC, $timeout, CCToCountryName) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/theme/components/timezoneSelector/timezoneSelector.html',
      scope: {
        ngModel: '=',
        translations: '='
      },
      link: function ($scope, elem, attrs) {
        var data = []
        var timezones = timezoneFactory.get()

        // Group the timezones by their country code
        var timezonesGroupedByCC = {};
        angular.forEach(timezones, function (timezone) {
          if (Object.keys(zoneToCC).indexOf(timezone.id) != -1) {
            var CC = zoneToCC[timezone.id]
            timezonesGroupedByCC[CC] = !timezonesGroupedByCC[CC] ? [] : timezonesGroupedByCC[CC]
            timezonesGroupedByCC[CC].push(timezone)
          }
        })

        // Add the grouped countries to the data array with their country name as the group option
        angular.forEach(timezonesGroupedByCC, function (zonesByCountry, CC) {
          var zonesForCountry = {
            text: CCToCountryName[CC] + ': ',
            children: zonesByCountry,
            firstNOffset: zonesByCountry[0].nOffset
          }

          data.push(zonesForCountry)
        })

        // Sort by UTC or country name
        if (attrs.sortBy === 'offset') {
          data = data.sort(function(a, b){
            return a.firstNOffset < b.firstNOffset ? -1 : 1;
          });
          angular.forEach( data, function (zonesForCountry, key) {
            zonesForCountry.children = zonesForCountry.children.sort(function(a, b) {
              return a.nOffset < b.nOffset ? -1 : 1;
            });
          })
        } else {
          data = data.sort(function (a, b) {
            return a.text.localeCompare(b.text);
          })
        }

        // add initial options forlocal
        if (attrs.showLocal !== undefined) {
          if (jstz !== undefined) {
            // Make sure the tz from jstz has underscores replaced with spaces so it matches
            // the format used in timezoneFactory
            var extraTZs = [];
            angular.forEach(timezones, function(timezone){
              if(timezone.id === jstz.determine().name()) {
                extraTZs.push(timezone);
              }
            });
            // var extraTZs = timezones.filter(function(a){
            //   return a.id = jstz.determine().name();
            // });
          } else {
            var localUTC = 'UTC' + moment().format('Z')
            extraTZs = _.filter(timezones, {'offset': localUTC})
          }

          if (extraTZs !== undefined && extraTZs.length > 0) {
            data.splice(0, 0, {
              text: ($scope.translations && $scope.translations.local ? $scope.translations.local : 'Local') + ': ',
              children: extraTZs,
              firstNOffset: extraTZs[0].nOffset,
              firstOffset: extraTZs[0].offset
            })
          }
        }

        if (attrs.setLocal !== undefined) {
          if (jstz !== undefined) {
            $scope.ngModel || ($scope.ngModel = jstz.determine().name())
          }
        }

        // add initial options
        if (attrs.primaryChoices !== undefined) {
          var primaryChoices = [];
          (attrs.primaryChoices.split(' ')).forEach(function (choice) {
            primaryChoices.push(choice.replace('_', ' '));
          });

          extraTZs = _.filter(timezones, function (tz) { return _.includes(primaryChoices, tz.name) })

          if (extraTZs !== undefined && extraTZs.length > 0) {
            data.splice(0, 0, {
              text: _.get($scope, 'translations.primary', 'Primary') + ': ',
              children: extraTZs,
              firstNOffset: extraTZs[0].nOffset,
              firstOffset: extraTZs[0].offset
            })
          }
        }

        // Construct a select box with the timezones grouped by country
        data.forEach( function (group) {
          // var optgroup = $('<div class="ui horizontal divider">' + group.text + '</div>')
          var menu = elem.find('.menu');
          // elem.find('.menu').append(optgroup);

          group.children.forEach(function (option) {
            if (attrs.displayUtc === 'true' && option.name.indexOf('(UTC') === -1) {
              option.name = option.name + ' (' + option.offset + ')'
            }

            menu.append('<div class="item" data-value="' + option.id + '">' +
              option.name + '</div>')
          });
        });

        // Initialise the chosen box
        var dropdown = elem.dropdown('set selected', $scope.ngModel);
        // $timeout(dropdown.dropdown('set selected', $scope.ngModel), 1);
        dropdown.dropdown({
          fullTextSearch: true,
          onChange: function(value) {
            $scope.$apply(function() {
              $scope.ngModel = value;
            });
            if ($scope.dropdownChange) {
              $timeout($scope.dropdownChange(value), 1);
            }
          },
        });


        // elem.chosen({
        //   width: attrs.width || '300px',
        //   include_group_label_in_selected: true,
        //   search_contains: true,
        //   no_results_text: _.get($scope, 'translations.no_results_text',
        //       'No results, try searching for the name of your country or nearest major city.'),
        //   placeholder_text_single: _.get($scope, 'translations.placeholder', 'Choose a timezone')
        // })

        // Update the box if ngModel changes
        $scope.$watch('ngModel', function (x) {
          elem.val($scope.ngModel)
          elem.trigger('chosen:updated')
        })
      }
    }
  }])

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .service('ChartRegistry', ChartRegistry);

ChartRegistry.$inject = ['Utils'];

function ChartRegistry(Utils) {
  var registry = {};

  /**
   * Allows chart to be registered
   *
   * @param newChart
   */
  this.register = function(newChart) {
    var chartId = newChart.getId();
    if (!chartId) {
      throw 'Unable to register chart, chartId not presented.';
    }
    if (!!registry[chartId]) {
      throw 'Unable to register chart, chartId=' + chartId + ' has already been registered.';
    }
    if (!Utils.isFunction(newChart.getChartOptions)) {
      throw 'Unable to register chart, function getChartOptions() not presented';
    }
    registry[chartId] = newChart;
  };

  this.get = function(chartId) {
    return registry[chartId];
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AccountChangePasswordCtrl', [
    '$scope', 'User', 'Auth', '$location', '$timeout', '$rootScope', '$translate',
    function($scope, User, Auth, $location, $timeout, $rootScope, $translate) {
      $rootScope.$loginPage = true;
      $scope.changePasswordModel = User.model;
      $scope.changePasswordNotificationMessage = {};
      $scope.invalid = User.invalid;

      $scope.submitPassword = function() {
        if (!User.validatePasswordEmpty()) {
          $scope.changePasswordNotificationMessage.errorMessage($translate.instant('USERS.ACCOUNT.ENTER-PASSWORD'));
          return;
        }

        if (!User.validatePasswordFormat()) {
          $scope.changePasswordNotificationMessage.errorMessage(
            $translate.instant('USERS.ACCOUNT.PASSWORD-IS-TOO-WEAK'));
          return;
        }

        if (!User.validateRepeatPassword()) {
          $scope.changePasswordNotificationMessage.errorMessage(
            $translate.instant('USERS.ACCOUNT.DOES-NOT-MATCH'));
          return;
        }
        var data = {
          'password': $scope.changePasswordModel.newUser.password,
          'app_meta_data': Auth.currentUser.profile.app_metadata,
          'userId': Auth.currentUser.profile.user_id,
        };

        User.updateUser(data).then(function() {
          Auth.currentUser.profile.last_password_reset = new Date();
          localStorage.setItem('profile', JSON.stringify(Auth.currentUser.profile));
          $timeout(function() {
            if (!/\/admin\//.test($location.path())) {
              $location.path('/admin/transactions');
            }
          }, 1);

        }).catch(function(data) {
          var message = $translate.instant('USERS.ACCOUNT.ERROR');
          if (data.status === 400) {
            message = $translate.instant('USERS.ACCOUNT.PASSWORD-HAS-BEEN-USED');
          }
          $scope.changePasswordNotificationMessage.errorMessage(message);
        });
      };

      $scope.logout = function() {
        Auth.logout();
      };
    },
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AccountLoginCtrl', AccountLoginCtrl);
AccountLoginCtrl.$inject = ['$scope', 'Auth', '$location', '$rootScope', 'CUSTOM_MERCHANT_CONFIG'];

function AccountLoginCtrl($scope, Auth, $location, $rootScope, CUSTOM_MERCHANT_CONFIG) {
  $rootScope.$loginPage = true;
  $scope.loggingIn = $location.hash().length > 0;
  $scope.languages = Auth.availableLanguages;
  $scope.isMultipleLanguage = Auth.isMultipleLanguage;
  $scope.selectedLanguage = Auth.getSelectedLanguage();
  $scope.shouldShowPrivacyPolicy = CUSTOM_MERCHANT_CONFIG.shouldShowPrivacyPolicy;

  $scope.loginClick = function() {
    if (localStorage.getItem('profile') && localStorage.getItem('id_token')) {
      Auth.removeLocalStorage();
    }
    Auth.login();
  };

  $scope.languageChanged = function(newVar) {
    Auth.changeLanguage(newVar);
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('AccountInfoCtrl', AccountInfoCtrl);
AccountInfoCtrl.$inject = [
  '$scope',
  'User',
  'Permission',
  'Auth',
  '$stateParams',
  '$location',
  'Participant',
  'toastr'];

/** @ngInject */
function AccountInfoCtrl($scope, User, Permission, Auth, $stateParams, $location, Participant,
                         toastr) {
  $scope.isParent = Auth.isParent();
  $scope.isAdmin = Auth.isAdmin();
  var participantName = Auth.getParticipantName();
  $scope.participantModel = Participant.model;
  $scope.userModel = User.model;

  $scope.translatePrefix = 'SETTINGS.ACCOUNT-SUMMARY.ACCOUNT-INFO.';

  var sortUserPermissions = function(index) {
    var userPermissions = $scope.userModel.user.app_meta_data.participants[index].permissions;
    return User.userPermissionsReverse($scope.permissionModel.list.permissions, userPermissions);
  };


  User.findParticipant = function(participantName, arr) {
    arr = arr || $scope.participants;
    var found = null;
    angular.forEach(arr, function(participant, key) {
      if (participant.name === participantName) {
        found = key;
        return false;
      }
    });

    return found;
  };

  User.fetchUser($stateParams.userId).then(function(data) {
    if (data.app_meta_data && data.app_meta_data.participants) {
      $scope.participants = angular.copy(data.app_meta_data.participants);

      //initialise access to parent participant
      var parentParticipantKey = User.findParticipant(Auth.getParticipantName());
      if (parentParticipantKey !== null && $scope.participants[parentParticipantKey].role ===
        'admin') {
        $scope.userModel.assignedToParent = true;
      } else {
        $scope.userModel.assignedToParent = false;
      }
      $scope.userModel.wasAssignedToParent = $scope.userModel.assignedToParent;

      var foundCurrentParticipant = false;

      //initialise access to children participants
      Permission.fetchPermissions().then(function() {
        angular.forEach($scope.participants, function(metadata, index) {
          if ($scope.userModel.participantAccounts[metadata.name]) {
            metadata.permissions = sortUserPermissions(index);
            $scope.userModel.participantAccounts[metadata.name] = metadata;
            $scope.userModel.participantAccounts[metadata.name].selected = true;
          }

          if (!$scope.isParent && metadata.name === participantName) {
            foundCurrentParticipant = true;
            $scope.userModel.participantAccounts[metadata.name] = metadata;
            $scope.userModel.participantAccounts[metadata.name].selected = true;
          }
        });

        //no access to parent or any children = user doesnt "belong" to the current participant = redirect
        if ($scope.isParent && !$scope.isAdmin && !$scope.userModel.wasAssignedToParent) {
          var hasAccess = false;
          for (var key in $scope.userModel.participantAccounts) {
            if ($scope.userModel.participantAccounts.hasOwnProperty(key) &&
              $scope.userModel.participantAccounts[key].selected) {
              hasAccess = true;
              break;
            }
          }
          // if (scope.isParent && )
          if (!hasAccess) {
            $location.path('/parent/users');
          }
        }
      }).finally(function() {
        //child participant does not have the selected user = redirect
        if (!$scope.isParent && !foundCurrentParticipant) {
          $location.path('/admin/settings/account');
        }
        $scope.pageLoaded();
      });
    }
  }).catch(function(response) {
    if (response.status === 404) {
      $location.path('/parent/users');
      toastr.error($scope.translate('CANNOT-FOUND'));
    }
  });
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('accountOwnerCtrl', accountOwnerCtrl);
accountOwnerCtrl.$inject = ['$scope', 'Auth'];

/** @ngInject */
function accountOwnerCtrl($scope, Auth) {
  $scope.profile = Auth.currentUser.profile;
  $scope.isAdmin = Auth.isAdmin();
  $scope.translatePrefix = 'SETTINGS.ACCOUNT.ACCOUNT-OWNER.';


  if (Auth.isParent()) {
    $scope.pageLoaded();
  }

  /* Click Handlers */
  $scope.changePasswordClick = function() {
    Auth.changePassword();
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('accountRevenueInspectionUsersCtrl', accountRevenueInspectionUsersCtrl);
accountRevenueInspectionUsersCtrl.$inject = ['$scope', 'Auth', '$location', 'FeatureFlags', 'RevenueInspectionUser', '$rootScope'];

/** @ngInject */
function accountRevenueInspectionUsersCtrl($scope, Auth, $location, FeatureFlags, RevenueInspectionUser, $rootScope) {
  var vm = this;

  vm.isParent = Auth.isParent();
  $scope.translatePrefix = 'SETTINGS.ACCOUNT.USERS.';
  vm.userModel = RevenueInspectionUser.model;
  vm.getUsers = getUsers;
  vm.onPageClickRevenueInspectionUsers = onPageClickRevenueInspectionUsers;

  $location.search('page', null);

  function getUsers(pageNo) {
    if($scope.feature_flags.RevenueInspection) {
      $scope.pageLoaded = false;
      if ($scope.isAdmin) {
        pageNo = pageNo || vm.userModel.currentPage;
        RevenueInspectionUser.getUsers(pageNo).finally(function() {
          $scope.pageLoaded = true;
        }).catch(function() {
          $scope.error = true;
        });
      }else {
        $scope.pageLoaded = true;
      }
    }
  };

  function onPageClickRevenueInspectionUsers(pageNo) {
    getUsers(pageNo);
  }

  $scope.$watch(function() {
    return $rootScope.currentParticipant;
  }, function(currentParticipant) {
    if(currentParticipant) {
      FeatureFlags.fetchFeatureFlags().then(function() {
        getUsers(1);
      });
    }
  });
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('accountUsersCtrl', accountUsersCtrl);
accountUsersCtrl.$inject = ['$scope', 'Auth', 'User', '$location', 'FeatureFlags'];

/** @ngInject */
function accountUsersCtrl($scope, Auth, User, $location, FeatureFlags) {
  $scope.isAdmin = Auth.isAdmin();
  $scope.isParent = Auth.isParent();
  $scope.translatePrefix = 'SETTINGS.ACCOUNT.USERS.';
  $scope.getUsers = getUsers;
  getUsers();

  var eliminateNoChildParticipants = function() {
    angular.forEach($scope.userModel.allUsers, function(user) {
      var participants = [];
      angular.forEach(user.app_meta_data.participants, function(participant) {
        if ($scope.eligableParticipants.indexOf(participant.name) !== -1) {
          participants.push(participant);
        } else if (participant.name === Auth.getParticipantName()) {
          participants.push(angular.extend(participant, {
            parent: true,
          }));
        }
      });
      user.app_meta_data.participants = angular.copy(participants);
    });
  };

  var sortUserParticipants = function() {
    angular.forEach($scope.userModel.allUsers, function(user) {
      user.app_meta_data.participants.sort(function(a, b) {
        if (a.parent && !b.parent) {
          return -1;
        } else if (!a.parent && b.parent) {
          return 1;
        }
        return a.name.localeCompare(b.name);
      });
    });
  };

  function getUsers() {
    $scope.pageLoaded = false;

    if ($scope.isAdmin) {
      User.getUsers().finally(function() {
        $scope.pageLoaded = true;
      }).catch(function() {
        $scope.error = true;
      }).then(function() {
        if ($scope.isParent) {
          eliminateNoChildParticipants();
        }
        sortUserParticipants();
      });
    } else {
      $scope.pageLoaded = true;
    }
  }

  $scope.onPageClick = function(pageNo) {
    $scope.getUsers(pageNo);
  };

  $scope.onEntryChange = function(pageNo) {
    if ($scope.participantLoaded === false) {
      return;
    }
    $scope.getUsers(pageNo);
  };

  $scope.participantChanged = function() {
    $location.search('participant', ($scope.userModel.group || null));
    $scope.getUsers();

  };

  $scope.$watch('participantLoaded', function(participantLoaded) {
    if (participantLoaded) {
      $scope.getUsers();
    }
  });
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('DeleteAccountCtrl', DeleteAccountCtrl);
DeleteAccountCtrl.$inject = ['$scope', 'User', '$location', 'Auth', 'sweetAlert', 'toastr'];

/** @ngInject */
function DeleteAccountCtrl($scope, User, $location, Auth, sweetAlert, toastr) {

  $scope.translatePrefix = 'SETTINGS.ACCOUNT-SUMMARY.DELETE-ACCOUNT.';

  var deleteUserModal = function() {
    User.deleteUser($scope.userModel.user.id).then(function() {
      if (Auth.isParent()) {
        $location.path('/parent/users');
      } else {
        $location.path('/admin/settings/account');
      }
      toastr.success($scope.translate('DELETE-SUCCESS'));

    }).catch(function() {
      toastr.error($scope.translate('DELETE-ERROR'));
    });
  };

  $scope.deleteUserAccount = function() {
    $scope.deleteAlert(deleteUserModal);
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('UpdateAccountCtrl', UpdateAccountCtrl);
UpdateAccountCtrl.$inject = ['$scope'];

/** @ngInject */
function UpdateAccountCtrl($scope) {

  $scope.translatePrefix = 'SETTINGS.ACCOUNT-SUMMARY.UPDATE-ACCOUNT.';

  var updateMetaData = function(key, selected) {
    angular.forEach($scope.userModel.user.app_meta_data.participants, function(metadata, i) {
      if (metadata.name === key) {
        selected = i;
      }
    });

    if (selected === -1 && $scope.userModel.participantAccounts[key].selected) {
      $scope.userModel.user.app_meta_data.participants.push({
        'name': key,
      });
    }

    if (selected > -1 && !$scope.userModel.participantAccounts[key].selected) {
      $scope.userModel.user.app_meta_data.participants.splice(selected, 1);
    }
  };

  $scope.updateAccountSelection = function(e, key) {
    e.preventDefault();
    var selected = -1;

    if ($scope.isParent) {
      $scope.userModel.participantAccounts[key].selected = !$scope.userModel.participantAccounts[key].selected;

      if ($scope.userModel.participantAccounts[key].selected) {
        $scope.userModel.participantAccounts[key].role = 'user';
        delete $scope.userModel.participantAccounts[key].permissions;
      }

      if ($scope.userModel.user.app_meta_data) {
        updateMetaData(key, selected);
      }
    }

  };

}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('AdminNotificationSummaryCtrl', AdminNotificationSummaryCtrl);

AdminNotificationSummaryCtrl.$inject = ['$scope', 'NOTIFICATIONS', '$stateParams', 'User'];

/** @ngInject */
function AdminNotificationSummaryCtrl($scope, NOTIFICATIONS, $stateParams, User) {
  $scope.pageLoaded();
  var id = $stateParams.notificationId;
  $scope.notification = NOTIFICATIONS.list.filter(function(n) {
    return n.key === id;
  })[0];

  if (!$scope.profile.user_metadata || !$scope.profile.user_metadata.notifications ||
    ($scope.notification.status === 'new' && $scope.profile.user_metadata.notifications.version !==
      id)) {

    var data = {
      'user_meta_data': $scope.profile.user_metadata || {},
      'app_meta_data': $scope.profile.app_metadata,
      'userId': $scope.profile.user_id,
    };

    angular.extend(data.user_meta_data, {
      'notifications': {
        'version': id,
      },
    });

    User.updateUser(data).then(function() {
      $scope.profile.user_metadata = data.user_meta_data;
      localStorage.setItem('profile', JSON.stringify($scope.profile));
      $scope.notificationSeen();
    });
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.library')
  .controller('AdminNotificationsCtrl', AdminNotificationsCtrl);
AdminNotificationsCtrl.$inject = ['$scope', 'NOTIFICATIONS', 'Auth'];

/** @ngInject */
function AdminNotificationsCtrl($scope, NOTIFICATIONS, Auth) {
  $scope.pageLoaded();
  $scope.notifications = NOTIFICATIONS.list;
  $scope.isParent = Auth.isParent();
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
  .controller('AdminCorrectionsAnalysis', AdminCorrectionsAnalysis);

AdminCorrectionsAnalysis.$inject = [
  '$controller',
  '$scope',
  'CorrectionAnalysis',
  '$location',
  'Utils',
  'analyticsConfig',
  'initOptions',
  'OrganiseData',
  '$filter',
  'ChartRegistry',
  'WebAnalytics'];

/** @ngInject */
function AdminCorrectionsAnalysis($controller, $scope, CorrectionAnalysis, $location, Utils,
  analyticsConfig, initOptions, OrganiseData, $filter,
  ChartRegistry, WebAnalytics) {

  Object.assign(this, $controller('AdminAnalysis', { $scope: $scope, $location: $location }));

  var vm = this;
  vm.analyticsModel = CorrectionAnalysis.model;
  vm.options = initOptions;
  vm.csvFilenamePrefix = 'CorrectionsAnalysis';
  vm.datePickerOptions.customOptions = $scope.analyticsConfig.customDatepickerOptions;
  vm.colWidths = [10, 20, 12, 10, 8, 8, 8, 8, 8, 8];

  $scope.translatePrefix = 'ANALYSIS.CORRECTIONS.';

  vm.goToPage = function (page) {
    vm.tableData = vm.analyticsModel.detailData.slice((page - 1) * 100, page * 100);
    vm.paginationData.currentPage = page;
  };

  vm.getCorrectionsData = function (currencyCode) {
    $scope.analyticsConfig.selectedCurrencyCode = currencyCode || $scope.getAnalyticsCurrencyCode();

    vm.loading = true;
    vm.form = {};
    vm.calcPreviousPeriodDates();
    vm.setSearchValues();

    // NOSONAR
    CorrectionAnalysis.getCorrectionsData($scope.getAnalyticsStartDateFormatted(), $scope.getAnalyticsEndDateFormatted(), $scope.getAnalyticsCurrencyCode()).then(function () {
      // NOSONAR
      vm.tableData = vm.analyticsModel.detailData.slice(0, 100);
      vm.paginationData.pagination.total = vm.analyticsModel.detailData.length;

      vm.formSubmit();
    }).finally(function () {
      vm.loading = false;
    });
  };

  vm.formSubmit = function () {
    vm.loading = true;

    var filters = {
      currencySymbol: vm.analyticsModel.currencySymbol,
      selected: {
        filterOptions: vm.options.correctionTypes,
        startDate: $scope.getAnalyticsStartDate(),
        endDate: $scope.getAnalyticsEndDate(),
        initiator: vm.form.initiator
      }
    };

    vm.chartOptions = ChartRegistry.get('corrections').getChartOptions(vm.analyticsModel, filters);
    vm.loading = false;
    vm.formatCsvFilename();
  };

  vm.isDateSubtotalRow = function (row) {
    return row.initiator === null && row.participant_name === null;
  };

  vm.isParticipantDateSubtotalRow = function (row) {
    return row.initiator === null && row.participant_name !== null;
  };

  vm.isOtherSubtotalRow = function (row) {
    return vm.isParticipantDateSubtotalRow(row);
  };

  vm.updateType = function (price) {
    vm.form.refund_type = price;
    vm.formSubmit();
  };

  vm.downloadCsv = function () {
    WebAnalytics.trackCSVDownload(vm.csvFilename);

    return vm.analyticsModel.detailData.map(function (item) {
      var csvItem = {};
      csvItem[$scope.translate('DATE')] = item.date;

      if (vm.isAtParentLevel()) {
        csvItem[$scope.translate('CHILD-PARTICIPANT')] = vm.toUpperOr(item.participant_name, $scope.translate('ALL'));
      }
      csvItem[$scope.translate('INITIATOR')] = vm.toUpperOr($scope.translate(item.initiator), $scope.translate('ALL'))
      csvItem[$scope.translate('MICROPAYMENT-AMOUNT')] = item.charge_amount;
      csvItem[$scope.translate('APPROVED-AMOUNT')] = item.approved_amount;
      csvItem[$scope.translate('APPROVED-COUNT')] = item.approved_count;

      csvItem[$scope.translate('REFUSED-AMOUNT')] = item.refused_amount;
      csvItem[$scope.translate('REFUSED-COUNT')] = item.refused_count;
      csvItem[$scope.translate('AWAITING-AMOUNT')] = item.awaiting_amount;
      csvItem[$scope.translate('AWAITING-COUNT')] = item.awaiting_amount;

      return csvItem;
    });
  };

  if (analyticsConfig.currencyCodes.length > 0) {
    vm.initData(analyticsConfig, vm.datePickerOptions);
    vm.getCorrectionsData();
  }

  vm.pageLoaded();
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
  .controller('AdminCustomersAnalysis', AdminCustomersAnalysis);

AdminCustomersAnalysis.$inject = [
  '$controller',
  '$scope',
  'CustomerAnalysis',
  '$location',
  'Utils',
  'initOptions',
  'OrganiseData',
  'ChartRegistry',
  'analyticsConfig',
  '$filter',
  '$rootScope'];

/** @ngInject */
function AdminCustomersAnalysis($controller, $scope, CustomerAnalysis, $location, Utils, initOptions,
                                OrganiseData, ChartRegistry, analyticsConfig, $filter, $rootScope) {

  Object.assign(this, $controller('AdminAnalysis', {$scope: $scope, $location: $location}));

  $scope.translatePrefix = 'ANALYSIS.CUSTOMERS.';

  var vm = this;
  vm.analyticsModel = CustomerAnalysis.model;
  vm.options = angular.copy(initOptions);
  vm.selectedDateFilter = undefined;
  vm.available = [0, 1];
  vm.form = {};
  vm.selectedChartType = vm.options.chart_types[0].id;
  vm.csvFilenamePrefix = 'CustomersAnalytics';
  vm.chartOptions = {};
  vm.reactHistChartOptions = {};
  vm.datePickerOptions.weekMode = true;
  vm.datePickerOptions.firstDayOfWeek = 'monday';
  vm.datePickerOptions.customOptions = getDatePickerOptions();
  vm.colWidths = [5, 25, 10, 10, 10, 10, 10, 10, 10];

  function getFirstDayOfWeek() {
    var firstDayOfWeek = vm.datePickerOptions.firstDayOfWeek;
    var date = moment();
    date = date.clone();
    if(firstDayOfWeek==='sunday') {
      date.day(0);
    } else {
      if(date.day()===0) {
        date.subtract(6, 'days');
      } else {
        date.day(1);
      }
    }
    return date;
  }

  function getDatePickerOptions() {

    var date = getFirstDayOfWeek();

    return [
      {
        label: 'LAST-14-DAYS',
        fromDate: date.clone().subtract(14, 'days'),
        toDate: date.clone().subtract(1, 'days'),
      },
      {
        label: 'LAST-30-DAYS',
        fromDate: date.clone().subtract(28, 'days'),
        toDate: date.clone().subtract(1, 'days'),
      },
      {
        label: 'LAST-90-DAYS',
        fromDate: date.clone().subtract(84, 'days'),
        toDate: date.clone().subtract(1, 'days'),
      },
    ];
  }

  vm.initSelectedGraph = function() {
    var selectedGraphId = $location.search().graph || vm.options.selects[0].id;
    var selectedGraph = vm.options.selects.find(function(graph) {
      return graph.id===selectedGraphId;
    }) || vm.options.selects[0];

    vm.selectedGraphId = selectedGraphId;
    vm.selectedGraph = selectedGraph;

    vm.formatCsvFilenamePrefix();
  };

  vm.formSubmit = function formSubmit() {
    vm.loading = true;
    vm.calcPreviousPeriodDates();

    // build chartOptions for each graph
    var graphId = vm.selectedGraph.id;
    var graphModel = vm.analyticsModel[graphId];
    var screenSettings = {
      currencySymbol: vm.analyticsModel.currencySymbol,
      config: angular.copy(initOptions),
      filters: vm.form,
      chart_type: vm.selectedChartType,
      startDate: $scope.getAnalyticsStartDate(),
      endDate: $scope.getAnalyticsEndDate(),
     };

    vm.chartOptions = ChartRegistry.get(graphId).getChartOptions(graphModel, screenSettings);

    // graph specific settings
    if (graphId === 'cohort_retention') {
      // config filter for starting_week
      vm.options.starting_week = vm.analyticsModel.cohort_retention.filter_labels;
    } else if (graphId === 'reactivated_customers') {
      // get chart option for reactivated history chart
      vm.reactHistChartOptions = ChartRegistry.get('reactivated_history').getChartOptions(
        vm.analyticsModel.reactivated_customers_history);
    }

    vm.loading = false;
    vm.formatCsvFilename();
  };

  vm.getCustomersData = function getCustomersData() {
    vm.loading = true;
    vm.form = {};
    vm.analyticsModel.currencySymbol = $filter('toISOCurrencySymbol')($scope.getAnalyticsCurrencyCode());
    vm.setSearchValues();

    if(vm.selectedGraph.id==='new_vs_returning') {
      getCustomersNewVsReturning();
    } else if(vm.selectedGraph.id==='capped_vs_uncapped') {
      getCustomersCappedVsUncapped();
    }
  };

  function getCustomersNewVsReturning() {
    CustomerAnalysis.getCustomersSummary($scope.getAnalyticsStartDateFormatted(), $scope.getAnalyticsEndDateFormatted(), $scope.getAnalyticsCurrencyCode()).then(function() {
    }).finally(function() {
      CustomerAnalysis.getCustomersData($scope.getAnalyticsStartDateFormatted(), $scope.getAnalyticsEndDateFormatted(), $scope.getAnalyticsCurrencyCode()).then(function() {
        vm.formSubmit();
      }).finally(function() {
        vm.loading = false;
      });
    });
  }

  function getCustomersCappedVsUncapped() {
    CustomerAnalysis.getCappedVsUncappedSummary($scope.getAnalyticsStartDateFormatted(), $scope.getAnalyticsEndDateFormatted(), $scope.getAnalyticsCurrencyCode()).then(function() {
    }).finally(function() {
      CustomerAnalysis.getCappedVsUncappedData($scope.getAnalyticsStartDateFormatted(), $scope.getAnalyticsEndDateFormatted(), $scope.getAnalyticsCurrencyCode()).then(function() {
        vm.formSubmit();
      }).finally(function() {
        vm.options.capping_frequencies = getAvailableCappingFrequencies();
        vm.loading = false;
      });
    });
  }

  function getAvailableCappingFrequencies() {
    var availableCappingFrequencies = [];

    vm.analyticsModel.capped_vs_uncapped.csvData.forEach(function(row) {
      var cappingFrequency = row.capping_frequency;
      if(cappingFrequency!==undefined && cappingFrequency!==null && availableCappingFrequencies.indexOf(cappingFrequency)===-1) {
        availableCappingFrequencies.push(cappingFrequency);
      }
    });
    availableCappingFrequencies.sort(function(a, b) {
      return a<b ? -1 : 1;
    });

    return availableCappingFrequencies;
  }

  vm.changeForm = function changeForm() {
    vm.selectedGraph = vm.options.selects.find(function(item) {
      return item.id===vm.selectedGraphId;
    });

    $location.search('graph', vm.selectedGraphId);

    vm.formatCsvFilenamePrefix();
    vm.getCustomersData();
  };

  vm.formatCsvFilenamePrefix = function() {
    vm.csvFilenamePrefix = vm.selectedGraph.csvPrefix;
    vm.formatCsvFilename();
  };

  vm.changeChartType = function(chartType) {
    vm.selectedChartType = chartType;
    vm.formSubmit();
  };

  vm.showFareTypeFilters = function showFareTypeFilters() {
    return !!vm.selectedGraph.showFareTypeFilters;
  };

  vm.showProductFilters = function showProductFilters() {
    return !!vm.selectedGraph.showProductFilters;
  };

  vm.showStartingWeekFilters = function showStartingWeekFilters() {
    return !!vm.selectedGraph.showStartingWeekFilters;
  };

  vm.showCappingFrequencyFilter = function() {
    return vm.selectedGraph.id==='capped_vs_uncapped' && vm.options.capping_frequencies.length;
  };

  vm.showCustomerCountNominalChargeFilter = function() {
    return vm.selectedGraph.id==='capped_vs_uncapped' && vm.options.capping_frequencies.length;
  };

  vm.isReactivatedChartSelected = function isReactivatedChartSelected() {
    return vm.selectedGraph.id === 'reactivated_customers';
  };

  vm.isLifetimeChartSelected = function isLifetimeChartSelected() {
    return vm.selectedGraph.id === 'lifetime_value';
  };

  vm.isAverageRevenueChartSelected = function isAverageRevenueChartSelected() {
    return vm.selectedGraph.id === 'average_revenue';
  };

  vm.isRetentionChartSelected = function isRetentionChartSelected() {
    return vm.selectedGraph.id === 'cohort_retention';
  };

  vm.isReturningVsNewChartSelected = function isReturningVsNewChartSelected() {
    return vm.selectedGraph.id === 'new_vs_returning';
  };

  vm.isRFMSegmentation = function isRFMSegmentation() {
    return vm.selectedGraph.id === 'rfm_segmentation';
  };

  vm.getSelectedGraphLabel = function getSelectedGraphLabel() {
    return vm.selectedGraph.label;
  };

  vm.isFirstForDate = function(date, index) {
    if (index > 0) {
      return this.analyticsModel[vm.selectedGraphId].csvData[index - 1].week_commencing !== date;
    }

    return true;
  };

  vm.getFareLabel = function getFareLabel(fareId) {
    if (!fareId) {
      return '';
    }

    var match = vm.options.fare_type.filter(function(fare) {
      return fare.id === fareId;
    });

    if (match.length > 0) {
      return match[0].label;
    }
    return fareId;
  };

  vm.downloadCsv = function downloadCsv() {
    WebAnalytics.trackCSVDownload(vm.csvFilename);

    if (vm.selectedGraphId === 'new_vs_returning') {
      return downloadNewVsReturningCSV();
    } else if (vm.selectedGraphId === 'capped_vs_uncapped') {
      return downloadCappedVsUncappedCSV();
    }
  };

  function downloadNewVsReturningCSV() {
    return vm.analyticsModel[vm.selectedGraphId].csvData.map(function(item) {
      var csvItem = {};
      csvItem[$scope.translate('WEEK-COMMENCING')] = item.week_commencing;

      if (vm.isAtParentLevel()) {
        csvItem[$scope.translate('CHILD-PARTICIPANT-NAME')] = vm.toUpperOr(item.participant_name, $scope.translate('ALL'));
      }

      csvItem[$scope.translate('FARE-TYPE')] = $scope.translate(vm.getFareLabel(item.fare_type)) || $scope.translate('ALL');
      csvItem[$scope.translate('NEW-COUNT')] = item.new;
      csvItem[$scope.translate('RETAINED-COUNT')] = item.retained;
      csvItem[$scope.translate('RETURNING-COUNT')] = item.returning;
      csvItem[$scope.translate('NEW-NOMINAL-AMOUNT')] = '' + vm.analyticsModel.currencySymbol + item.new_nominal;
      csvItem[$scope.translate('NEW-ADJUSTED-AMOUNT')] = '' + vm.analyticsModel.currencySymbol + item.new_adjusted;
      csvItem[$scope.translate('RETAINED-NOMINAL-AMOUNT')] = '' + vm.analyticsModel.currencySymbol + item.retained_nominal;
      csvItem[$scope.translate('RETAINED-ADJUSTED-AMOUNT')] = '' + vm.analyticsModel.currencySymbol + item.retained_adjusted;
      csvItem[$scope.translate('RETURNING-NOMINAL-AMOUNT')] = '' + vm.analyticsModel.currencySymbol + item.returning_nominal;
      csvItem[$scope.translate('RETURNING-ADJUSTED-AMOUNT')] = '' + vm.analyticsModel.currencySymbol + item.returning_adjusted;
      return csvItem;
    });
  }

  function downloadCappedVsUncappedCSV() {
    return vm.analyticsModel[vm.selectedGraphId].csvData.map(function(item) {
      var csvItem = {};
      csvItem[$scope.translate('WEEK-COMMENCING')] = $filter('date')(moment(item.week_commencing, 'YYYY-MM-DD').valueOf(), 'shortDate');

      if (vm.isAtParentLevel()) {
        csvItem[$scope.translate('CHILD-PARTICIPANT-NAME')] = vm.toUpperOr(item.participant_name, $scope.translate('ALL'));
      }

      csvItem[$scope.translate('CAPPING-FREQUENCY')] = item.capping_frequency;
      csvItem[$scope.translate('NUMBER-OF-CUSTOMERS')] = item.customer_count;
      csvItem[$scope.translate('TOTAL-NOMINAL-AMOUNT')] = vm.analyticsModel.currencySymbol + item.total_nominal_amount;
      csvItem[$scope.translate('TOTAL-CHARGE-AMOUNT')] = vm.analyticsModel.currencySymbol + item.total_charge_amount;
      csvItem[$scope.translate('DIFFERENCE')] = '' + vm.analyticsModel.currencySymbol + item.nominal_charge_difference;
      csvItem[$scope.translate('AVG-LAST-30-DAYS-NOMINAL-SPEND')] = '' + vm.analyticsModel.currencySymbol + item.last_30_days_average_nominal_amount;
      return csvItem;
    });
  }

  vm.hasNoGraphData = function() {
    return !vm.selectedGraphId || vm.analyticsModel[vm.selectedGraphId].csvData.length===0;
  };

  //because this page is only accessible to participants who have purchased it
  //we need to wait until the currentParticipant is loaded to ensure that
  //they have permission to access it
  $scope.$watch(function() {
    return $rootScope.currentParticipant;
  }, function(currentParticipant) {
    if(currentParticipant) {
      if (!currentParticipant.config.product_config.analytics_modules.customers) {
        vm.pageState = 'error_permissions';
      } else {
        vm.initData(analyticsConfig, vm.datePickerOptions);
        vm.initSelectedGraph();
        vm.getCustomersData();
      }
      vm.pageLoaded();
    }
  });
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
  .controller('AdminCustomReportsAnalysis', AdminCustomReportsAnalysis);

AdminCustomReportsAnalysis.$inject = [
  '$controller',
  '$scope',
  '$location',
  '$sce',
  'Utils',
  'analyticsConfig',
  'initOptions',
  'Auth'
];

/** @ngInject */
function AdminCustomReportsAnalysis($controller, $scope, $location, $sce, Utils, analyticsConfig, initOptions, Auth) {

  Object.assign(this, $controller('AdminAnalysis', { $scope: $scope, $location: $location }));

  var vm = this;

  vm.options = initOptions;
  vm.reports_host = window.__env.reports_host;
  vm.dashboardsList = [];
  vm.iframe_src = '';

  function httpGet(url) {
    var key = 'Bearer ' + localStorage.getItem('id_token');
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( 'GET', url, false );
    xmlHttp.setRequestHeader('Authorization',key);
    xmlHttp.send(null);
    return JSON.parse(xmlHttp.responseText);
  }

  function loadEmbedUrl(dashboard_id) {
    var participant_id = Auth.getParticipantId();
    var is_parent = Auth.isParent();
    var url = vm.reports_host + '/dashboards/' + dashboard_id.trim();
    var dashboard_url = httpGet(url).url;
    dashboard_url += (is_parent) ? ('&groupId=' + participant_id) : ('&participantId=' + participant_id);
    vm.iframe_src = $sce.trustAsResourceUrl(dashboard_url);
  }

  function loadDashboardList() {
    var url = vm.reports_host + '/dashboards';
    vm.dashboardsList = httpGet(url).dashboard_list;
  }

  vm.loadEmbedUrl = loadEmbedUrl;
  loadDashboardList();
  vm.pageLoaded();
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
  .controller('AdminDebtRecoveryAnalysis', AdminDebtRecoveryAnalysis);

AdminDebtRecoveryAnalysis.$inject = ['$controller', '$scope', 'DebtAnalysis', 'analyticsConfig', '$location', 'initOptions', 'OrganiseData', '$filter', 'WebAnalytics'];

/** @ngInject */
function AdminDebtRecoveryAnalysis($controller, $scope, DebtAnalysis, analyticsConfig, $location, initOptions, OrganiseData, $filter, WebAnalytics) { //NOSONAR
  Object.assign(this, $controller('AdminAnalysis', {$scope: $scope, $location: $location}));

  var vm = this;

  vm.form = {};
  vm.analyticsModel = {};
  vm.options = initOptions;
  vm.chartOptions = {};
  vm.csvFilenamePrefix = 'DebtRecoveryAnalysis';
  vm.datePickerOptions.customOptions = $scope.analyticsConfig.customDatepickerOptions;
  vm.colWidths = [10, 20, 10, 10, 10, 10, 10, 10, 10];

  $scope.translatePrefix = 'ANALYSIS.DEBT-RECOVERY.';

  vm.hasNoData = function() {
    return this.dataTemporary && this.dataTemporary.length === 0;
  };

  vm.getDebtRecoveryData = function(currencyCode) {
    $scope.analyticsConfig.selectedCurrencyCode = currencyCode || $scope.getAnalyticsCurrencyCode();
    vm.analyticsModel.currencySymbol = $filter('toISOCurrencySymbol')(
      $scope.getAnalyticsCurrencyCode());

    var startDate = $scope.getAnalyticsStartDateFormatted();
    var endDate = $scope.getAnalyticsEndDateFormatted();

    vm.setSearchValues();
    vm.formatCsvFilename();

    vm.loading = true;
    DebtAnalysis.getDebtRecoveryData(startDate, endDate, $scope.getAnalyticsCurrencyCode())
      .then(function(data) {
        vm.analyticsModel.csvData = data.debt_recovery_details.filter(filterImpossibleResults);
        vm.renderChart();
      }).finally(function() {
      vm.loading = false;
    });
  };

  vm.isSubtotalRow = function(row) {
    return !row.participant_name && vm.isAtParentLevel();
  };

  $scope.schemeFilter = function(row) {
    return row.scheme === vm.form.scheme || (!vm.form.scheme && row.scheme === null);
  };

  vm.renderChart = function() {
    vm.options.schemes = OrganiseData.getAvailableSchemeOptions(vm.analyticsModel.csvData);

    vm.dataTemporary = vm.analyticsModel.csvData.filter($scope.schemeFilter);
    if(vm.isAtParentLevel()) {
      //only graph "summary" rows
      vm.dataTemporary = vm.dataTemporary.filter(function(item) {
        return !item.participant_name;
      });
    }

    var series = vm.hasNoData() ? [] : vm.options.debts.map(function(option) {
      var data = vm.dataTemporary.map(function(s) {
        return s[option.id];
      });
      var otherData = vm.dataTemporary.map(function(s) {
        return s[option.mappedTo];
      });

      return {
        name: $scope.translate(option.label),
        data: data,
        otherData: otherData,
        lineWidth: 6,
        marker: {
          radius: 0
        }
      };
    });
    var xAxis = vm.dataTemporary.map(function(s) {
      return s.days_after_transaction_date;
    });

    vm.chartOptions.series = series;
    vm.chartOptions.xAxis = {'categories': xAxis};
    vm.chartOptions.tooltip = {
      shared: true,
      crosshairs: false,
      formatter: function() {
        var total = 0;
        var html = '<b>' + $scope.translate('DAYS-AFTER-TRANSACTION', {'day': this.x}) +'</b><br />';
        angular.forEach(this.points, function(point) {
          var percent = Number(point.y).toFixed(2).toString();
          var amount = vm.analyticsModel.currencySymbol +
            Number(series[point.series.index].otherData[point.point.index])
              .toLocaleString('en', {minimumFractionDigits: 2});
          html += '<span style="color:' + point.color + '">●</span> ' + point.series.name +
            ': <b>' + percent + '% (' + amount + ')</b><br/>';
          total += point.y;
        });
        if (total === 0) {
          html = '<b>' + $scope.translate('DAYS-AFTER-TRANSACTION', {'day': this.x}) +'</b><br />'+ $scope.translate('NO-DATA');
        }
        return html;
      }
    };
  };

  vm.downloadCsv = function() {
    WebAnalytics.trackCSVDownload(vm.csvFilename);

    return vm.analyticsModel.csvData.map(function(item) {
      var csvItem = {};
      csvItem[$scope.translate('DAYS-AFTER-TRANSACTION-DATE')] = item.days_after_transaction_date;

      if (vm.isAtParentLevel()) {
        csvItem[$scope.translate('CHILD-PARTICIPANT')] = vm.toUpperOr(item.participant_name, $scope.translate('ALL'));
      }
      csvItem[$scope.translate('SCHEME')] = vm.toUpperOr((item.scheme === 'UNKNOWN' ? $scope.translate('UNKNOWN') : item.scheme), $scope.translate('ALL'));
      csvItem[$scope.translate('TOTAL-TRANSACTION-VALUE')] = item.transaction_value;
      csvItem[$scope.translate('ORIGINAL-DEBT')] = item.original_debt;
      csvItem[$scope.translate('DEBT-AMOUNT-RECOVERED')] = item.recovered_debt;
      csvItem[$scope.translate('DEBT-AMOUNT-OUTSTANDING')] = item.outstanding_debt;
      csvItem[$scope.translate('DEBT-PERCENT-RECOVERED')] = item.recovered_debt_percent;
      csvItem[$scope.translate('DEBT-PERCENT-OUTSTANDING')] = item.outstanding_debt_percent;

      return csvItem;
    });
  };

  function filterImpossibleResults(row) {
    var daysShown = $scope.getAnalyticsEndDate().diff($scope.getAnalyticsStartDate(), 'day') + 1;
    var daysAfterTransactionDate = row.days_after_transaction_date;
    if((daysAfterTransactionDate + '').indexOf('+')>-1) {
      daysAfterTransactionDate = parseInt(row.days_after_transaction_date.replace('+', ''), 10);
    }
    return daysAfterTransactionDate<=daysShown;
  }

  // Number of days since debt occured
  vm.chartOptions = {
    title: {
      text: $scope.translate('CHART-TITLE-X')
    },
    chart: {
      type: 'column'
    },

    tooltip: {
      shared: true,
      crosshairs: true
    },
    credits: {
      enabled: false
    },
    colors: ['#b7f9c8', '#1DBD72'],
    plotOptions: {
      series: {
        cursor: 'pointer',
        stacking: 'normal',
        marker: {
          lineWidth: 1
        }
      }
    },
    yAxis: {
      max: 100,
      labels: {
        format: '{value}%'
      },
      title: {
        text: $scope.translate('CHART-TITLE-Y')
      }
    }
  };

  if(analyticsConfig.currencyCodes.length>0) {
    vm.initData(analyticsConfig, vm.datePickerOptions);
    vm.getDebtRecoveryData();
  }

  vm.pageLoaded();
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
  .controller('AdminDeclinesAnalysis', AdminDeclinesAnalysis);

AdminDeclinesAnalysis.$inject = [
  '$controller',
  '$scope',
  'initOptions',
  'DeclineAnalysis',
  'OrganiseData',
  'analyticsConfig',
  'Utils',
  '$location',
  '$filter',
  'WebAnalytics',
  'pako'];

/** @ngInject */
function AdminDeclinesAnalysis($controller, $scope, initOptions, DeclineAnalysis, OrganiseData,
                               analyticsConfig, Utils, $location, $filter, WebAnalytics, pako) {
  Object.assign(this,
    $controller('AdminAnalysis', {$scope: $scope, $location: $location, $filter: $filter}));

  var vm = this;

  vm.csvFilenamePrefix = 'DeclinesAnalysisByDate';
  vm.form = {
    declineReasons: [],
    fareTypes:[],
    requestTypes:[]
  };
  vm.declinesByDate = [];
  vm.declinesByIssuer = [];
  vm.declinesByBin = [];
  vm.options = angular.copy(initOptions);
  vm.getDeclinesData = getDeclinesData;
  vm.updateLiability = updateLiability;
  vm.updateDeclineBy = updateDeclineBy;
  vm.renderChart = renderChart;
  vm.switchDataSet = switchDataSet;
  vm.hasNoData = hasNoData;
  vm.goToPage = goToPage;
  vm.showMoreData = showMoreData;
  vm.declineBy = vm.options.declineBy[0];
  vm.declineByIndex = 0;
  vm.selected = vm.declineBy.value[0].id;
  vm.selectedIndex = 0;
  vm.options.liability = vm.declineBy.value;
  vm.chartOptions = {};
  vm.chartSeriesData = [];
  vm.available = [0];
  vm.dataSetSelected = 'byDate';
  vm.tableDataLimit = 100;
  vm.datePickerOptions.customOptions = $scope.analyticsConfig.customDatepickerOptions;

  $scope.translatePrefix = 'ANALYSIS.DECLINES.';

  function declineReasonMatches(item) {
    var foundId;
    if(vm.form.declineReasons.length) {
      var itemId = item.decline_code;
      var declineReasons = vm.form.declineReasons.split(',');
      foundId = declineReasons.find(function(id) {
        return itemId===id;
      });
    }

    return !vm.form.declineReasons.length || foundId;
  }

  function declineByFareTypesMatches(item) {
    var itemId = item.fare_type;
    var declineByFareTypes = vm.form.fareTypes.split(',');
    var foundId = declineByFareTypes.find(function(id) {
      return itemId===id;
    });
    return !vm.form.fareTypes.length || foundId;
  }

  function declineByRequestTypesMatches(item) {
    var itemId = item.request_type;
    var declineByRequestTypes = vm.form.requestTypes.split(',');
    var foundId = declineByRequestTypes.find(function(id) {
      return itemId===id;
    });
    return !vm.form.requestTypes.length || foundId;
  }

  $scope.declinesByDateChartFilter = function(row) {
    function schemeMatches(item) {
      return (!vm.form.scheme && !item.scheme) || item.scheme === vm.form.scheme;
    }
    if(!vm.form.scheme && !vm.form.declineReasons.length) {
      return row.participant_name === undefined && !row.decline_code && !row.scheme;
    } else if(vm.form.scheme && !vm.form.declineReasons.length) {
      return schemeMatches(row) && !row.decline_code;
    } else if(!vm.form.scheme && vm.form.declineReasons.length) {
      return declineReasonMatches(row);
    } else if(vm.form.scheme && vm.form.declineReasons.length) {
      return schemeMatches(row) && declineReasonMatches(row);
    }
    return false;
  };

  function showMoreData() {
    vm.tableDataLimit+=100;
  }

  function goToPage(page) {
    vm.tableData = vm.declinesByDate.slice((page-1)*100, page*100);
    vm.paginationData.currentPage = page;
  }

  function hasNoData() {
    return hasNoByDateData() || hasNoByBinData() || hasNoByIssuerData();
  }

  function hasNoByDateData() {
    return vm.dataSetSelected === 'byDate' && vm.declinesByDate.length === 0;
  }

  function hasNoByBinData() {
    return vm.dataSetSelected === 'byBin' && vm.declinesByBin.length === 0;
  }

  function hasNoByIssuerData() {
    return vm.dataSetSelected === 'byIssuer' && vm.declinesByIssuer.length === 0;
  }

  function getDeclinesData(currencyCode) {
    $scope.analyticsConfig.selectedCurrencyCode = currencyCode || $scope.getAnalyticsCurrencyCode();
    vm.currencySymbol = $filter('toISOCurrencySymbol')($scope.getAnalyticsCurrencyCode());

    var startDate = $scope.getAnalyticsStartDateFormatted();
    var endDate = $scope.getAnalyticsEndDateFormatted();

    vm.setSearchValues();
    vm.formatCsvFilename();

    vm.loading = true;
    DeclineAnalysis.getDeclines(startDate, endDate, $scope.getAnalyticsCurrencyCode())
      .then(function(data) {
        if(data.data) {
          data = atob(data.data);
          data = pako.inflate(data, {to: 'string'});
          data = JSON.parse(data);
        }

        var id = 1;
        data.by_date.forEach(function(item) {
          item.id = id++;
        });

        vm.declinesByDate = data.by_date;
        vm.declinesByIssuer = data.by_issuer;
        vm.declinesByBin = data.by_bin;
        vm.tableData = vm.declinesByDate.slice(0, 100);
        vm.paginationData.pagination.total = vm.declinesByDate.length;

        vm.options.declineReasons = OrganiseData.getAvailableDeclineReasons(vm.declinesByDate, vm.form.scheme);
        vm.options.schemes = OrganiseData.getAvailableSchemeOptions(vm.declinesByDate);
        vm.options.fareTypes = OrganiseData.getAvailableFareTypeOptions(vm.declinesByDate);
        vm.options.requestTypes = OrganiseData.getAvailableRequestTypeOptions(vm.declinesByDate);

        renderChart();
      }).finally(function() {
      vm.loading = false;
    });
  }

  function updateLiability() {
    vm.selectedIndex = vm.declineBy.value.findIndex(function(item) {
      return item.id===vm.selected;
    });
    renderChart();
  }

  function updateDeclineBy() {
    vm.declineBy = vm.options.declineBy[vm.declineByIndex];
    vm.selected = vm.declineBy.value[vm.selectedIndex].id;
    vm.options.liability = vm.declineBy.value;
    renderChart();
  }

  function switchDataSet(selected) {
    vm.dataSetSelected = selected;
    if (selected === 'byDate') {
      vm.csvFilenamePrefix = 'DeclinesAnalysisByDate';
    } else if (selected === 'byIssuer') {
      vm.csvFilenamePrefix = 'DeclinesAnalysisByIssuer';
    } else if (selected === 'byBin') {
      vm.csvFilenamePrefix = 'DeclinesAnalysisByBin';
    }
    vm.formatCsvFilename();
  }

  function renderChart() {
    prepareDataForChart();

    vm.chartOptions = {
      title: {
        text: $scope.translate('GRAPH-TITLE', {'name': $scope.translate(vm.declineBy.name)}),
      },
      chart: {
        type: 'areaspline',
      },
      yAxis: [
        {
          labels: {
            format: '{value}%',
          },
          title: {
            text: $scope.translate('DECLINE-RATE-GRAPH'),
          },
        }],
      xAxis: {
        tickWidth: 0,
        gridLineWidth: 1,
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%d/%m/%Y'
        },
      },
      tooltip: {
        shared: true, //puts all values for each column in the same tooltip
        crosshairs: true,
        formatter: function() {
          var total = 0;
          var html = '<b>' + moment(this.x).format('DD/MM/YYYY') + '</b><br />';
          angular.forEach(this.points, function(point) {
            html += '<span style="color:' + point.color + '">●</span> ' + point.series.name +
              ': <b>' + Number(point.y.toFixed(2)).toLocaleString() + '%</b><br/>';
            total += point.y;
          });
          if (total === 0) {
            html = '<b>' + moment(this.x).format('DD/MM/YYYY') + '</b><br />' + $scope.translate('NO-DATA');
          }
          return html;
        },
      },
      credits: {
        enabled: false,
      },
      colors: [
        '#1DBD72',
        '#aa43ce',
        '#ffe14f',
        '#5170ea',
        '#ea5151',
        '#51eac8',
        '#ea9d51',
        '#ea51b7',
        '#a2ea51'],
      plotOptions: {
        series: {
          cursor: 'pointer',
          marker: {
            lineWidth: 1,
          },
          pointStart: $scope.getAnalyticsStartDate().valueOf(),
          pointInterval: 'day',
        },
        areaspline: {
          fillOpacity: 0.2
        }
      },
      legend: {
        enabled: needMultipleSeries(),
      },
      series: vm.chartSeriesData
    };
  }

  function needMultipleSeries() {
    return vm.form.declineReasons.length || vm.form.fareTypes.length || vm.form.requestTypes.length;
  }

  function prepareDataForChart() {
    vm.chartSeriesData = [];

    var filter = {
      selected: {
        filterOptions: vm.options.liability.filter(function(s) {
          return s.id === vm.selected;
        }),
        startDate: $scope.getAnalyticsStartDate(),
        endDate: $scope.getAnalyticsEndDate(),
      },
    };
    if(needMultipleSeries()) {
      prepareMultipleSeriesForChart(filter.selected);
    } else {
      prepareSingleSeriesForChart(filter.selected);
    }
  }

  function prepareSingleSeriesForChart(selectedFilters) {
    var filteredData = vm.declinesByDate
      .filter($scope.declinesByDateChartFilter);

    var data = OrganiseData
      .getDataTable(filteredData, OrganiseData.sortData, selectedFilters)
      .map(function(s) {
        return {x: s[0], y: s[1]};
      });

    addSeries($scope.translate('DECLINE-RATE-Y'), data);
  }

  function prepareMultipleSeriesForChart(selectedFilters) {
    var schemes = vm.options.schemes.filter(function(scheme) {
      var valid = scheme.id;
      if(vm.form.scheme) {
        valid = valid && vm.form.scheme===scheme.id;
      }
      return valid;
    });

   var filters = {};
   var declineReasons =  [];
    if(vm.form.declineReasons.length){
      declineReasons = vm.options.declineReasons.filter(function(declineReason) {
        var selectedDeclineReasons = vm.form.declineReasons.split(',');
        return !selectedDeclineReasons.length || selectedDeclineReasons.find(function(item) {
          return item === declineReason.id;
        });
      });
      Object.assign(filters, {'reason' : declineReasons});
    }
    var declineFareTypes = [];
    if(vm.form.fareTypes.length) {
      declineFareTypes = vm.options.fareTypes.filter(function(fareType) {
        var selectedFareTypes = vm.form.fareTypes.split(',');
        return !selectedFareTypes.length || selectedFareTypes.find(function(item) {
          return item === fareType.id;
        });
      });
      Object.assign(filters, {'fareType': declineFareTypes});
    }
    var declineRequestTypes = [];
    if(vm.form.requestTypes.length) {
      declineRequestTypes = vm.options.requestTypes.filter(function(requestType) {
        var selectedRequestTypes = vm.form.requestTypes.split(',');
        return !selectedRequestTypes.length || selectedRequestTypes.find(function(item) {
          return item === requestType.id;
        });
      });
      Object.assign(filters, {'requestType': declineRequestTypes});
    }

    var dateCategories = Object.keys(
      OrganiseData.fillEmptyDateKeys([], selectedFilters.startDate,
      selectedFilters.endDate, 'DD/MM/YYYY')
    );

    var filteredData;
    var previousItemId = [];
    var numberOfFilters = Object.entries(filters).length;
    schemes.forEach(function(scheme) {
      multipleFilters(scheme, filteredData, selectedFilters, dateCategories, filters, numberOfFilters, previousItemId);
    });

    vm.chartSeriesData.sort(function(a, b) {
      return a.name.localeCompare(b.name);
    });

  }

  function multipleFilters(scheme, filteredData, selectedFilters, dateCategories, filters, numberOfFilters, previousItemId){
    if(numberOfFilters === 0) {
      filteredData = vm.declinesByDate.filter(function(row) {
        var condition = row.scheme === scheme.id;

        Object.entries(previousItemId).forEach(function(item) {
            var rowFilter = getRowFilter(item[0],row);

            condition  = condition && rowFilter === item[1];
        });

        return condition;
      });

      var label = (scheme.label + ' - ' + Object.values(previousItemId)).replace(',', ' - ');
      if (vm.isAtParentLevel()) {
        prepareSeriesForSchemeAndReasonParent(scheme, label, filteredData, selectedFilters, dateCategories);
      } else {
        prepareSeriesForSchemeAndReasonChild(scheme, label, filteredData, selectedFilters);
      }
      previousItemId = [];
    } else {
      Object.values(filters)[numberOfFilters -1].forEach(function(item) {
        var key = String(Object.keys(filters)[numberOfFilters -1]);
        var obj = {};
        obj[key] = item.id;
        Object.assign(previousItemId, obj);
        multipleFilters(scheme, filteredData, selectedFilters, dateCategories, filters,numberOfFilters-1, previousItemId);
      });
    }
  }

  function getRowFilter(key, row) {
    var rowFilter;
    if(key === 'reason') {
      rowFilter = row.decline_code;
      if (row.decline_scheme) {
        rowFilter += '-' + row.decline_scheme;
      }
    } else if(key ==='fareType') {
      rowFilter = row.fare_type;
    } else if(key ==='requestType') {
     rowFilter = row.request_type;
    }
    return rowFilter;
  }

  function prepareSeriesForSchemeAndReasonChild(scheme, label, filteredData, selectedFilters) {
    var data = OrganiseData
      .getDataTable(filteredData, OrganiseData.sortData, selectedFilters)
      .map(function(s) {
        return {x: s[0], y: s[1]};
      });
    if (data.length > 0) {
      addSeries(label, data);
    }
  }

  function prepareSeriesForSchemeAndReasonParent(scheme, label, filteredData, selectedFilters, dateCategories) {
    var dateTotals = [];
    var fieldId = selectedFilters.filterOptions[0].id;

    filteredData.forEach(function(row) {
      var rowDeclineReason = row.decline_code;

      var isDeclineReasonsSelectedValid = vm.form.declineReasons.length && (rowDeclineReason == declineReasonMatches(row));
      var isDeclineReasonNotSelected = !vm.form.declineReasons.length;
      if (row.participant_name && row.scheme && (isDeclineReasonsSelectedValid || isDeclineReasonNotSelected)) {
        var x = moment(row.submit_date).toDate();
        var total = getDeclineCount(row, fieldId);
        var of = getDeclineTotalCount(row, fieldId);

        var item = {
          date: x,
          total: total,
          of: of,
          submit_date: row.submit_date
        };

        var index = dateTotals.findIndex(function(dateTotal) {
          return dateTotal.submit_date === item.submit_date;
        });

        if (index === -1) {
          dateTotals.push(item);
        } else {
          dateTotals[index].total += total;
          dateTotals[index].of += of;
        }
      }
    });

    var data = [];

    dateTotals.forEach(function(dateTotal) {
      var y = (dateTotal.total / dateTotal.of * 10000.0) / 100.0;
      data.push({x: dateTotal.date, y: y});
    });

    if(data.length>0) {
      data = fillInMissingDates(data, dateCategories);
      addSeries(label, data);
    }
  }

  function fillInMissingDates(data, dates) {
    var dataSize = data.length;

    dates.forEach(function(dateKey) {
      var foundIndex = data.findIndex(function(data) {
        var thisDateKey = moment(data.x).format('DD/MM/YYYY');
        return thisDateKey===dateKey;
      });
      if(foundIndex===-1) {
        var date = moment.utc(dateKey, 'DD/MM/YYYY');
        data.push({x: date.toDate(), y: 0.0});
      }
    });

    if(data.length!==dataSize) {
      data.sort(function(a, b) {
        return moment.utc(a.x).isBefore(moment.utc(b.x)) ? -1 : 1;
      });
    }

    return data;
  }

  function getDeclineCount(row, fieldId) {
    var fields = {
      all_percent: 'total_all_decline_count',
      covered_percent: 'total_covered_count',
      not_covered_percent: 'total_not_covered_count',
      all_amount_percent: 'total_decline_amount',
      covered_amount_percent: 'total_covered_amount',
      not_covered_amount_percent: 'total_not_covered_amount'
    };
    return row[fields[fieldId]];
  }

  function getDeclineTotalCount(row, fieldId) {
    return fieldId.indexOf('amount')===-1 ? row.scheme_total_trans_count : row.scheme_total_trans_amount;
  }

  function addSeries(name, data) {
    vm.chartSeriesData.push({
      name: name,
      data: data,
      lineWidth: 1.5,
      colorIndex: vm.chartSeriesData.length,
    });
  }

  vm.downloadCsv = function() {
    WebAnalytics.trackCSVDownload(vm.csvFilename);

    if (vm.dataSetSelected === 'byDate') {
      return vm.downloadCsvByDate();
    } else if (vm.dataSetSelected === 'byIssuer') {
      return vm.downloadCsvByIssuer();
    } else if (vm.dataSetSelected === 'byBin') {
      return vm.downloadCsvByBin();
    }
  };

  vm.downloadCsvByDate = function() {
    return vm.declinesByDate.map(function(item) {
      var csvItem = {};
      csvItem[$scope.translate('DATE')] = vm.isGrandTotalRow(item) ? '' : moment(item.submit_date).format('YYYY-MM-DD');

      if (vm.isAtParentLevel()) {
        csvItem[$scope.translate('CHILD-PARTICIPANT-NAME')] = vm.toUpperOr(item.participant_name, 'ALL');
      }
      csvItem[$scope.translate('SCHEME')] = vm.getSchemeOrSummaryRowTitle(item);
      csvItem[$scope.translate('DECLINE-CODE')] = item.decline_code;
      csvItem[$scope.translate('DECLINE-REASON')] = item.decline_code ? vm.getDeclineReason(item, '') : '';
      csvItem[$scope.translate('FARE-TYPE')] = item.fare_type;
      csvItem[$scope.translate('REQUEST-TYPE')] = item.request_type;
      csvItem[$scope.translate('TOTAL-TRANSACTION-AMOUNT-TABLE')] = item.total_adjusted_amount;
      csvItem[$scope.translate('TOTAL-TRANSACTION-COUNT')] = item.total_trans_count;
      csvItem[$scope.translate('COVERED-DECLINE-COUNT')] = item.total_covered_count;
      csvItem[$scope.translate('NOT-COVERED-DECLINE-COUNT')] = item.total_not_covered_count;
      csvItem[$scope.translate('TOTAL-DECLINE-COUNT')] = item.total_all_decline_count;
      csvItem[$scope.translate('COVERED-DECLINE-AMOUNT')] = item.total_covered_amount;
      csvItem[$scope.translate('NOT-COVERED-DECLINE-AMOUNT')] = item.total_not_covered_amount;
      csvItem[$scope.translate('TOTAL-DECLINE-AMOUNT')] = item.total_decline_amount;
      csvItem[$scope.translate('COVERED-DECLINE-RATE-OF-COUNT')] = item.covered_percent;
      csvItem[$scope.translate('NOT-COVERED-DECLINE-RATE-OF-COUNT')] = item.not_covered_percent;
      csvItem[$scope.translate('TOTAL-DECLINE-RATE-OF-COUNT')] = item.all_percent;
      csvItem[$scope.translate('COVERED-DECLINE-RATE-OF-AMOUNT')] = item.covered_amount_percent;
      csvItem[$scope.translate('NOT-COVERED-DECLINE-RATE-OF-AMOUNT')] = item.not_covered_amount_percent;
      csvItem[$scope.translate('TOTAL-DECLINE-RATE-OF-AMOUNT')] = item.all_amount_percent;

      return csvItem;
    });
  };

  vm.downloadCsvByIssuer = function() {
    return vm.declinesByIssuer.map(function(item) {
      var csvItem = {};
      csvItem[$scope.translate('ISSUER-NAME')] = vm.toUpperOr(item.issuer_bank === 'UNKNOWN' ? $scope.translate('UNKNOWN') : item.issuer_bank );
      csvItem[$scope.translate('ISSUER-COUNTRY')] = vm.toUpperOr(item.issuer_country === 'UNKNOWN' ? $scope.translate('UNKNOWN') : item.issuer_country);
      csvItem[$scope.translate('SCHEME')] = vm.toUpperOr(item.scheme);
      csvItem[$scope.translate('DECLINED-TRANSACTION-COUNT')] = item.declined_count;
      csvItem[$scope.translate('DECLINED-TRANSACTION-AMOUNT')] = item.declined_value;
      csvItem[$scope.translate('TOTAL-TRANSACTION-COUNT')] = item.total_count;
      csvItem[$scope.translate('TOTAL-TRANSACTION-AMOUNT-TABLE')] = item.total_value;
      csvItem[$scope.translate('DECLINE-RATE-OF-COUNT')] = item.declined_count_percent;
      csvItem[$scope.translate('DECLINE-RATE-OF-AMOUNT')] = item.declined_value_percent;

      return  csvItem;

    });
  };

  vm.downloadCsvByBin = function() {
    return vm.declinesByBin.map(function(item) {
      var csvItem = {};
      csvItem[$scope.translate('BIN')] = item.bin || $scope.translate('UNKNOWN');
      csvItem[$scope.translate('ISSUER-NAME')] = vm.toUpperOr(item.issuer_bank === 'UNKNOWN' ? $scope.translate('UNKNOWN') : item.issuer_bank );
      csvItem[$scope.translate('SCHEME')] = vm.toUpperOr(item.scheme);
      csvItem[$scope.translate('DECLINED-TRANSACTION-COUNT')] = item.declined_count;
      csvItem[$scope.translate('DECLINED-TRANSACTION-AMOUNT')] = item.declined_value;
      csvItem[$scope.translate('TOTAL-TRANSACTION-COUNT')] = item.total_count;
      csvItem[$scope.translate('TOTAL-TRANSACTION-AMOUNT-TABLE')] = item.total_value;
      csvItem[$scope.translate('DECLINE-RATE-OF-COUNT')] = item.declined_count_percent;
      csvItem[$scope.translate('DECLINE-RATE-OF-AMOUNT')] = item.declined_value_percent;

      return csvItem;
    });
  };

  vm.getDeclineReason = function(decline, prefix) {
    return OrganiseData.getDeclineReason(decline.decline_code, decline.acquirer_code, decline.scheme, prefix);
  };

  vm.isSchemeDailySummaryRow = function(decline) {
    return decline.scheme && !decline.decline_code;
  };

  vm.isDailySummaryRow = function(decline) {
    return !decline.scheme && decline.submit_date;
  };

  vm.isGrandTotalRow = function(decline) {
    return !decline.scheme && !decline.submit_date;
  };

  vm.getSchemeOrSummaryRowTitle = function(decline) {
    if(vm.isDailySummaryRow(decline)) {
      return $scope.translate('DAILY-TOTAL');
    } else if(vm.isGrandTotalRow(decline)) {
      return $scope.translate('GRAND-TOTAL');
    } else if(vm.isSchemeDailySummaryRow(decline)) {
      return decline.scheme + ' ' + $scope.translate('DAILY-TOTAL');
    }
    return decline.scheme;
  };

  if(analyticsConfig.currencyCodes.length > 0) {
    vm.initData(analyticsConfig, vm.datePickerOptions);
    vm.getDeclinesData();
  }

  vm.pageLoaded();
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.corrections')
  .controller('AdminCorrectionRequestsCtrl', AdminCorrectionRequestsCtrl);

AdminCorrectionRequestsCtrl.$inject = [
  '$scope',
  'Refund',
  'Customer',
  '$window',
  'sweetAlert',
  'Aggregation',
  'Auth',
  '$timeout',
  'Form'];

/** @ngInject */
function AdminCorrectionRequestsCtrl($scope, Refund, Customer, $window, sweetAlert, Aggregation,
                                     Auth, $timeout, Form) {
  $scope.refundModel = Refund.model;
  $scope.hasPermission = ($scope.profile.account.role === 'admin') ||
    ($scope.profile.account.permissions.indexOf('IssueRefund') > -1);
  $scope.proposedRefund = 0;
  $scope.loading = false;

  $scope.translatePrefix = 'CORRECTIONS.CORRECTION-REQUESTS.';

  var loader = '<div id="form-loader" class="text-center wrapper" ng-if="show"><div id="loader-wrapper"><div id="loader1" class="loader"></div><div id="loader2" class="loader"></div><div id="loader3" class="loader"></div><div id="loader4" class="loader"></div><div id="loader5" class="loader"></div></div></div>';
  $scope.processingBtn = {};
  var getRefunds = function(pageNo) {
    $scope.loading = true;

    pageNo = pageNo || $scope.refundModel.currentPage;
    Refund.fetchRefunds(pageNo, true).finally(function() {
      $scope.pageLoaded();
    }).catch(function() {
      var msg = $scope.translate('SOMETHING-WENT-WRONG');
      $scope.callErrorPage(msg, 'transactions');
    }).finally(function() {
      $scope.loading = false;
    });
  };

  $scope.onEntryChange = function(pageNo) {
    getRefunds(pageNo);
  };

  $scope.onPageClick = function(pageNo) {
    getRefunds(pageNo);
  };

  $scope.seeTransaction = function(e, refund) {
    Form.queries.customerId = refund.customer_id;
    Customer.search(1).then(function(data) {
      if (e.srcElement.localName === 'td') {
        $window.location.href = '/admin/customers/' + data.list[0].id +
          '/transactions?aggregationId=' + refund.aggregation_id;
      }
    });

  };

  $scope.hideRefundModal = function() {
    $scope.showSubmitCorrectionRequestModal = false;
  };

  $scope.submitRequest = function() {
    var m = angular.element(document.querySelector('#modalBodyinner'));
    m.append(loader);

    var message = $scope.translate('REFUND-REQUEST-IS', {'approval': $scope.refundModel.currentRefund.approval})
    var title = $scope.refundModel.currentRefund.approval;
    var type = 'success';

    Refund.approveRequest().catch(function() {
      title = 'Error';
      type = 'error';
      message = $scope.translate('COULD-NOT-BE-COMPLETED');

    }).finally(function() {
      $scope.hideRefundModal();
      sweetAlert.swal(
        title,
        message,
        type
      ).then(function() {
        getRefunds();
      });
    });
  };

  var approvalSetup = function(modal, refund) {

    var loader = angular.element(document.querySelector('#form-loader'));
    if (loader) {
      loader.remove();
    }
    $scope.refundModel.currentRefund = refund;
    $scope.refundModel.currentRefund.approval = 'APPROVED';
    var amount = refund.transaction_amount - (refund.proposed_amount || 0);
    $scope.proposedRefund = Number(amount.toFixed(2));
    $scope.showSubmitCorrectionRequestModal = true;
  };

  var callConfirmation = function(msg, type, modal, refund) {

    sweetAlert.swal({
      title: $scope.translate('ARE-YOU-SURE'),
      html: msg,
      type: type,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#dddddd',
      confirmButtonText: $scope.translate('YES-CONTINUE'),
      cancelButtonText: $scope.translate('NO-CANCEL'),
      confirmButtonClass: 'btn btn-success btn-sm',
      cancelButtonClass: 'btn btn-danger btn-sm',
    }).then(function(response) {
      if (response.value) {
        $timeout(function() {
          approvalSetup(modal, refund);
        }, 1);
      }
    });
  };

  $scope.callModalClick = function(modal, refund, index) {
    Form.queries.customerId = refund.customer_id;
    $scope.processingBtn[index] = true;
    Customer.search(1).then(function(data) {
      Aggregation.query({
        'customerId': data.list[0].id,
        'participantName': Auth.getParticipantName(),
        'aggregationId': refund.aggregation_id,
      }, function(aggregation) {
        $scope.processingBtn[index] = false;
        if (aggregation.settlement_result && aggregation.settlement_result.status &&
          aggregation.settlement_result.status === 'SETTLED') {
          approvalSetup(modal, refund);
        } else {
          var msg = $scope.translate('HAS-NOT-SETTLED');
          var type = 'warning';
          if (aggregation.status === 'OPEN') {
            msg = $scope.translate('AGGREGATION-WILL-ADJUST');
            type = 'info';
          }
          callConfirmation(msg, type, modal, refund);
        }
      });
    });
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.corrections')
  .controller('AdminCorrectionsCtrl', AdminCorrectionsCtrl);
AdminCorrectionsCtrl.$inject = ['$scope', 'Refund', 'Customer', '$window', '$location', 'Form'];

/** @ngInject */
function AdminCorrectionsCtrl($scope, Refund, Customer, $window, $location, Form) {
  $scope.refundModel = Refund.model;
  $scope.form = {};
  $scope.loading = false;

  $scope.translatePrefix = 'CORRECTIONS.CORRECTIONS-LIST.';

  var getFilters = function() {
    if ($location.search().status) {
      $scope.form.status = $location.search().status;
    }

    if ($location.search().initiator) {
      $scope.form.initiator = $location.search().initiator;
    }
  };

  var getRefunds = function(pageNo) {
    $scope.loading = true;
    getFilters();
    pageNo = pageNo || $scope.refundModel.currentPage;
    Refund.fetchRefunds(pageNo).finally(function() {
      $scope.pageLoaded();
    }).catch(function() {
      var msg = $scope.translate('SOMETHING-WENT-WRONG');
      $scope.callErrorPage(msg, 'transactions');
    }).finally(function() {
      $scope.loading = false;
    });
  };

  $scope.onEntryChange = function(pageNo) {
    getRefunds(pageNo);
  };

  $scope.onPageClick = function(pageNo) {
    getRefunds(pageNo);
  };

  $scope.seeTransaction = function(e, refund) {
    Form.queries.customerId = refund.customer_id;
    Customer.search(1).then(function(data) {
      if (e.srcElement.localName === 'td') {
        $window.location.href = '/admin/customers/' + data.list[0].id +
          '/transactions?aggregationId=' + refund.aggregation_id;
      }
    });
  };

  $scope.reset = function(name) {
    $scope.form[name] = null;
    $scope.correctionsSearchSubmit();
  };

  $scope.correctionsSearchSubmit = function() {
    angular.forEach($scope.form, function(field, key) {
      $location.search(key, (field || null));
    });

    getRefunds();
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.corrections')
  .controller('AdminMakeCorrectionCtrl', AdminMakeCorrectionCtrl);
AdminMakeCorrectionCtrl.$inject = [
  '$scope',
  'Refund',
  'Transaction',
  'Customer',
  '$location',
  'Aggregation',
  'transactionFactory',
  'Auth',
  'sweetAlert',
  'Form',
  'Utils',
  '$timeout',
  'WebAnalytics'];

/** @ngInject */
function AdminMakeCorrectionCtrl($scope, Refund, Transaction, Customer, $location, Aggregation,transactionFactory,
                                 Auth, sweetAlert, Form, Utils, $timeout, WebAnalytics) {
  $scope.transactionModel = Transaction.model;
  $scope.search = Form.queries;
  $scope.invalid = Form.invalid;
  $scope.loading = Form.loading;
  $scope.customerModel = Customer.model;
  $scope.refundModel = Refund.model;
  $scope.aggregationModel = Aggregation.model;
  $scope.refundNotificationMessage = {};
  $scope.invalidRefund = Refund.invalid;
  $scope.refundLoading = false;

  $scope.translatePrefix = 'CORRECTIONS.MAKE-CORRECTION.';

  $scope.hasPermission = ($scope.profile.account.role === 'admin') ||
    ($scope.profile.account.permissions.indexOf('IssueRefund') > -1);

  var getTransactions = function(queryParams) {
    queryParams = queryParams || null;
    $scope.transactionsFound = true;

    $scope.loading.hasLoaded = false;
    return Transaction.fetchTransactions('refundable', queryParams).finally(function() {
      $scope.loading.hasLoaded = true;
    });
  };

  var resetTransactions = function() {
    Transaction.model.allTransactions = [];
  };

  var validSearchForm = function() {
    if (!$scope.search.cardBin || ($scope.search.cardBin && $scope.search.cardBin.length !== 6)) {
      $scope.invalid.cardBin = true;
    }
    if (!$scope.search.pan || ($scope.search.pan && $scope.search.pan.length !== 4)) {
      $scope.invalid.pan = true;
    }
    return !Form.isInvalid();
  };

  $scope.resetForm = function() {
    $scope.search = {};
    angular.forEach($location.search(), function(field, key) {
      $location.search(key, null);
    });

    $scope.transactionsFound = false;
    Form.resetInvalid();
  };

  $scope.searchTransaction = function() {
    resetTransactions();
    Form.resetInvalid();

    if (!validSearchForm()) {
      return;
    }
    if ($scope.search.expiryMonth) {
      $scope.search.expiryMonth = Utils.pad($scope.search.expiryMonth, 2);
    }

    var formFilters = {};
    angular.forEach($scope.search, function(field, key) {
      if (field) {
        if (key === 'fromTime') {
          field = encodeURIComponent(moment(field, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' 00:00');
        }
        if (key === 'toTime') {
          field = encodeURIComponent(moment(field, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' 23:59');
        }
        formFilters[key] = field;
      }
    });
    getTransactions(formFilters)
      .then(function() {
        WebAnalytics.trackSearchResponseEvent($location.url(),
          Transaction.model.allTransactions.length);
      });
  };

  $scope.pasteJustNumbers = function($event) {
    var cardNo = (Customer.pasteJustNumbers($event));
    $scope.search.cardBin = cardNo[0];
    $scope.search.pan = cardNo[1];
  };

  var setQueries = function() {
    $scope.pageLoaded();

    if ($scope.search.cardBin && $scope.search.pan) {
      $scope.searchTransaction();
    }
  };

  setQueries();

  $scope.onEntryChange = function() {
    $scope.transactionModel.limit = $location.search().entry;
    if ($scope.search.cardBin && $scope.search.pan) {
      $scope.searchTransaction();
    }
  };

  var resetModal = function() {
    Refund.resetValidation();
    $scope.refundNotificationMessage.hide();
  };

  var refundSetup = function(modal, transaction, aggregation) {
    var loader = angular.element(document.querySelector('#form-loader'));
    if (loader) {
      loader.remove();
    }
    if(aggregation !== null){
      transaction.aggregation_id = aggregation.id;
      transaction.customer_id = $scope.customerModel.currentCustomer.customer_id;
      transaction.transaction_time = transaction.micropayment.taps[0].tap_time;
    }
    $scope.refundModel.transaction = transaction;
    Form.queries.customerId = transaction.customer_id;
    Customer.search(1).then(function(data) {
      var customer = data.list[0];
      Aggregation.query({
        'customerId': data.list[0].id,
        'participantName': Auth.getParticipantName(),
        'aggregationId': transaction.aggregation_id,
      }, function(aggregation) {
        if (transaction.micropayment) {
          $scope.refundModel.currentRefund = {
            'aggregation_id': transaction.aggregation_id,
            'customer_id': customer.id,
            'refund_amount': transaction.micropayment.amount,
            'micropayment_id': transaction.micropayment.id,
            'amount': transaction.micropayment.amount,
            'currency': transaction.micropayment.currency,
            'transaction_amount': transaction.micropayment.amount,
            'reason': '',
          };
          if (aggregation.settlement_result) {
            angular.extend($scope.refundModel.currentRefund, {
              'settlement_id': aggregation.settlement_result.request_id,
              'transaction_id': aggregation.settlement_result.transaction_id,
              'card_sequence_number': aggregation.settlement_result.card_sequence_number,
              'transaction_type': aggregation.settlement_result.transaction_type,
              'transaction_date': aggregation.settlement_result.transaction_date,
            });
          }
          var appliedProductId = null;
          var i, len;
          for (i = 0, len = transaction.micropayment.adjustments.length; i < len; i++) {
            var adj = transaction.micropayment.adjustments[i];
            if (adj.applied) {
              appliedProductId = adj.product_id;
            }
          }
          angular.extend($scope.refundModel.currentRefund, {
            'product_id': appliedProductId,
          });
        }
      });
    }).finally(function() {
      if(aggregation !== null){
        $scope = transactionFactory.getModel('scope');
      }
      $scope[modal] = true;
    });

    resetModal();
    var warningMessage = $scope.translate('REFUND-SENSITIVITY-WARNING');
    if (transaction.micropayment.adjustments.length > 0) {
      warningMessage += '<br/><br/>' + $scope.translate('TRANSACTION-REFUNDED', {'description': transaction.micropayment.adjustments[0].description});
    }
    $scope.refundNotificationMessage.warningMessage(warningMessage);
  };

  $scope.callModalClick = function(modal, transaction, aggregation, micropayment) {
    $scope.refundLoading = false;

    if(aggregation !== null){
      $scope.refundNotificationMessage = transactionFactory.getModel('refundNotificationMessage');
      transaction = {};
      transaction.micropayment = micropayment;
      transaction.aggregation_status = aggregation.status;
      transaction.payment_guarantee_status = aggregation.payment_guarantee_status;
      if(aggregation.settlement_result){
        transaction.settlement_status = aggregation.settlement_result.status;
      }
    }

    if (transaction.settlement_status && transaction.settlement_status === 'SETTLED') {
      refundSetup(modal, transaction, aggregation);
    } else {
      var msg = $scope.translate('TRANSACTION-NOT-SETTLED');
      var type = 'warning';
      if (transaction.aggregation_status === 'OPEN') {
        msg = $scope.translate('AGGREGATION-WILL-ADJUST');
        type = 'info';
      }
      sweetAlert.swal({
        title: $scope.translate('ARE-YOU-SURE'),
        html: msg,
        type: type,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#dddddd',
        confirmButtonText: $scope.translate('YES-CONTINUE'),
        cancelButtonText: $scope.translate('NO-CANCEL'),
        confirmButtonClass: 'btn btn-success btn-sm',
        cancelButtonClass: 'btn btn-danger btn-sm',
      }).then(function(result) {
        if (result.value) {
          refundSetup(modal, transaction,aggregation);
        }
      });
    }
  };

  $scope.hideRefundModal = function() {
    resetModal();
    $scope.showSubmitRefundModal = false;
  };

  /* Event Handlers */
  $scope.addRefundClick = function() {
    if (!Refund.validateRefundAmountEmpty()) {
      $scope.refundNotificationMessage.errorMessage($scope.translate('ENTER-A-REFUND-AMOUNT'));
      return;
    }

    if (!Refund.validateRefundAmount()) {
      $scope.refundNotificationMessage.errorMessage(
        $scope.translate('REFUND-AMOUNT-IS-GREATER'));
      return;
    }

    if (!Refund.validateReason()) {
      $scope.refundNotificationMessage.errorMessage($scope.translate('REASON-EMPTY'));
      return;
    }

    if (!Refund.validateReasonContents()) {
      $scope.refundNotificationMessage.errorMessage($scope.translate('REASON-SENSITIVE'));
      return;
    }

    $scope.refundLoading = true;

    var message = $scope.translate('REQUEST-SENT-FOR-SETTLEMENT');
    var title = $scope.translate('SUBMITTED');
    var type = 'success';

    Refund.addRefund($scope.refundModel.currentRefund).catch(function(d) {
      title = 'Error';
      type = 'error';
      if (d) {
        message = d.data.description;
      }
      if (d.status === 400) {
        message = d.data.errors[0].detail;
        var pos = message.indexOf(' - ');
        if (pos !== -1) {
          message = message.substr(pos + 3);
        }
      }
    }).finally(function() {
      $scope.hideRefundModal();
      sweetAlert.swal(
        title,
        message,
        type
      ).then(function() {
        if (type === 'success') {
          $timeout(function() {
            $location.search('');
            $location.path('/admin/corrections');
          }, 1);
        }
      });
      $scope.refundLoading = false;
    });
  };

  $scope.$watch('refundModel.currentRefund.refund_amount', Refund.refundAmountHandler);
}

/**
 * @author z.geddes
 * created on 01.03.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomerSummaryCtrl', AdminCustomerSummaryCtrl);
AdminCustomerSummaryCtrl.$inject = [
  '$scope',
  'Customer',
  'Statement',
  'Identifier',
  'toastr',
  '$interval',
  'List',
  'Auth',
  '$location',
  'WebAnalytics',
  'Aggregation',
  'Participant',
  '$rootScope',
  '$state',
  '$stateParams'
];

/** @ngInject */
function AdminCustomerSummaryCtrl($scope, Customer, Statement, Identifier, toastr, $interval, List,
                                  Auth, $location, WebAnalytics, Aggregation, Participant, $rootScope, $state, $stateParams) {
  var vm = this;
  $scope.customerTabPage();

  vm.customerModel = Customer.model;
  vm.identifierModel = Identifier.model;
  vm.aggregationModel = Aggregation.model;
  vm.participantModel = Participant.model;

  vm.customerModel.currentCustomer = {};
  vm.invoiceDateForm = {};
  vm.receiptNotificationMessage = {};
  vm.getCustomerCSV = getCustomerCSV;
  vm.triggerDebtRecovery = triggerDebtRecovery;
  vm.debtRecoveryInterval = null;
  vm.getCustomerCSVFilename = getCustomerCSVFilename;
  vm.trackCSVDownload = trackCSVDownload;
  vm.showModal = showModal;
  vm.generateInvoice = generateInvoice;
  vm.hideModal = hideModal;
  vm.filterTransactionsByDate = filterTransactionsByDate;
  vm.canRefundMicropayment = canRefundMicropayment;
  vm.hasPermissionToRefund = Auth.checkUserHasPermission('IssueRefund');
  vm.isOperationsAdmin = Auth.isOperationsAdmin();

  $scope.translatePrefix = 'CUSTOMERS.CUSTOMER-SUMMARY.';

  Customer.fetchCurrentCustomer().then(function() {
    Identifier.fetchCustomerIdentifiers(function() {
      loadDebtsForCustomer();
    });
  });

  function showModal(modal) {
    vm[modal] = true;
  }

  function hideModal() {
    vm.printReceiptModal = false;
    vm.invoiceDateForm.fromTime = null;
    vm.invoiceDateForm.toTime = null;
    vm.receiptNotificationMessage.hide();
    vm.invoiceDateFormError.fromTime = false;
    vm.invoiceDateFormError.toTime = false;
  }

  function generateInvoice() {

    if(validateInvoiceDates()) {
      vm.receiptNotificationMessage.hide();

      Aggregation.getAllAggregations().then(function() {

        Participant.selectedDateFormatForReceipt(vm.invoiceDateForm);

        filterTransactionsByDate();

      }).finally(function() {
        updateInvoiceConfigAmount();
        hideModal();
        $rootScope.isReceipt = true;
        var url = $state.current.url;
        $location.path($location.path().replace(url, '/receipt'));
      });
    }
  }

  function validateInvoiceDates() {
    var isValid = true;
    if(!Participant.isAnyDateSelected(vm.invoiceDateForm)) {
      vm.receiptNotificationMessage.errorMessage($scope.translate('INVOICE.SELECT-DATE'));
      isValid = false;
    }
    if(vm.invoiceDateFormError.fromTime || vm.invoiceDateFormError.toTime) {
      vm.receiptNotificationMessage.errorMessage($scope.translate('INVOICE.INVALID-DATE'));
      isValid = false;
    }
    return isValid;
  }

  function updateInvoiceConfigAmount() {
    if(vm.aggregationModel.receiptTransactions && vm.aggregationModel.receiptTransactions.length > 0) {
      vm.participantModel.invoiceConfigs.currency = vm.aggregationModel.receiptTransactions[0].currency;
      vm.participantModel.invoiceConfigs.issue_date = new Date();
      Participant.calculateTotalAmount(vm.aggregationModel.receiptTransactions);
    }
  }

  function filterTransactionsByDate() {
    vm.aggregationModel.receiptTransactions = vm.aggregationModel.receiptTransactions.filter(function(transaction) {

      var lastMicropayment = transaction.micropayments[transaction.micropayments.length-1];
      var lastTap = lastMicropayment.taps[lastMicropayment.taps.length - 1];
      var lastTapTime = lastTap.tap_time;
      var isValid = false;

      if(vm.participantModel.invoiceConfigs.fromTime && vm.participantModel.invoiceConfigs.toTime) {
        isValid = moment(lastTapTime).isBetween(vm.participantModel.invoiceConfigs.fromTime, vm.participantModel.invoiceConfigs.toTime);
      }else if (vm.participantModel.invoiceConfigs.fromTime && !vm.participantModel.invoiceConfigs.toTime) {
        isValid = moment(vm.participantModel.invoiceConfigs.fromTime).isBefore(lastTapTime);
      }else if(!vm.participantModel.invoiceConfigs.fromTime && vm.participantModel.invoiceConfigs.toTime) {
        isValid = moment(vm.participantModel.invoiceConfigs.toTime).isAfter(lastTapTime);
      }
      return isValid;
    });
  }

  function getCustomerCSVFilename() {
    return 'Customer_Statement_CustomerID_' + vm.customerModel.currentCustomer.customer_id + '.csv';
  }

  function trackCSVDownload() {
    return WebAnalytics.trackDownload($location.absUrl() + '/' + vm.getCustomerCSVFilename());
  }

  function loadDebtsForCustomer() {
    var participantId = Auth.getParticipantName();
    var customerId = vm.customerModel.currentCustomer.customer_id;

    Customer.getDebtsForCustomer({'participantName': participantId, 'customerId': customerId})
      .$promise.then(function(debts) {
      for (var i = 0; i < vm.identifierModel.identifiers.length; i++) {
        var identifier = vm.identifierModel.identifiers[i];
        identifier.showButton = identifierIsOnDenyList(identifier) &&
          identifierHasDebt(identifier, debts);
      }
    });
  }

  function identifierIsOnDenyList(identifier) {
    if (identifier.lists && identifier.lists[0] && identifier.lists[0].functions) {
      for (var i = 0; i < identifier.lists[0].functions.length; i++) {
        if (identifier.lists[0].functions[i] === 'DENY') {
          return true;
        }
      }
    }
    return false;
  }

  function identifierHasDebt(identifier, debts) {
    for (var j = 0; j < debts.list.length; j++) {
      if (debts.list[j].funding_source_vault_id === identifier.vault_id) {
        return true;
      }
    }
    return false;
  }

  function getCustomerCSV(customerId) {
    return Statement.getCustomerStatement(customerId).then(function(data) {
      return Statement.flattenObject(data);
    });
  }

  function triggerDebtRecovery(identifier) {
    return Customer.triggerDebtRecoveryForCard(vm.customerModel.currentCustomer.customer_id,
      identifier.vault_id).then(function() {
      toastr.success($scope.translate('DEBT-RECOVERY-TRIGGERED'));
      checkForDebtRecovery(identifier);
    });
  }

  function checkForDebtRecovery(identifier) {
    identifier.loading = 1;
    var customerId = $stateParams.customerId;

    vm.debtRecoveryInterval = $interval(function() {
      List.fetchIdentifierLists(identifier.id, customerId).then(function(data) {
        identifier.loading += 2;
        if (data.length > 0 && ((data[0].functions.length > 0 && data[0].functions[0] !== 'DENY') ||
          data[0].functions.length === 0)) {
          $interval.cancel(vm.debtRecoveryInterval);
          Identifier.fetchCustomerIdentifiers(undefined, customerId);
          identifier.loading = 0;
        } else if (identifier.loading > 30) {
          $interval.cancel(vm.debtRecoveryInterval);
          identifier.loading = 0;
          toastr.error($scope.translate('UNABLE-TO-RECOVER'));
        }
      }).catch(function() {
        $interval.cancel(vm.debtRecoveryInterval);
        toastr.error($scope.translate('ERROR-DEBT-RECOVERY'));
        identifier.loading = 0;
      });
    }, 2000);
  }

  function canRefundMicropayment(micropayment) {
    if(vm.isOperationsAdmin === true){
      return true;
    }
    return (!micropayment.participant_id || isSameParticipant(micropayment.participant_id));
  }

  function isSameParticipant(micropaymentParticipantId) {
    return vm.participantModel.currentParticipant.participant_id === micropaymentParticipantId;
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomersCtrl', AdminCustomersCtrl);

AdminCustomersCtrl.$inject = [
  '$scope',
  '$location',
  'Customer',
  'Statement',
  'Utils',
  'Form',
  'WebAnalytics'];

/** @ngInject */
function AdminCustomersCtrl($scope, $location, Customer, Statement, Utils, Form, WebAnalytics) {

  var vm = this;
  vm.customerModel = Customer.model;
  vm.loading = Form.loading;
  vm.invalid = Form.invalid;

  vm.searchCustomers = searchCustomers;
  vm.pasteJustNumbers = pasteJustNumbers;
  vm.customersSearchClick = customersSearchClick;
  vm.getCustomerCSV = getCustomerCSV;
  vm.resetForm = resetForm;

  $scope.translatePrefix = 'CUSTOMERS.CUSTOMERS.';

  $scope.pageLoaded();

  function searchCustomers(pageNo) {
    vm.loading.hasLoaded = false;

    pageNo = pageNo || vm.customerModel.currentPage;

    Form.queries.customerId = vm.customerModel.searchForm.customerId;
    return Customer.search(pageNo).catch(function() {
      vm.loading.error = true;
    }).finally(function() {
      vm.loading.hasLoaded = true;
    });
  }

  function pasteJustNumbers($event) {
    var cardNo = (Customer.pasteJustNumbers($event));
    vm.customerModel.searchForm.cardBin = cardNo[0];
    vm.customerModel.searchForm.pan = cardNo[1];
  }

  function getCustomerCSV(customerId) {
    return Statement.getCustomerStatement(customerId).then(function(data) {
      return Statement.flattenObject(data);
    });
  }

  function resetForm() {
    vm.customerModel.searchForm = {};
    $location.url($location.path());
    customersSearchClick();
  }

  function customersSearchClick() {
    Form.resetInvalid();

    if (vm.customerModel.searchForm.cardBin && vm.customerModel.searchForm.cardBin.length !== 6) {
      vm.invalid.cardBin = true;
    }
    if (vm.customerModel.searchForm.pan && vm.customerModel.searchForm.pan.length !== 4) {
      vm.invalid.pan = true;
    }
    if (vm.customerModel.searchForm.expiryMonth) {
      if (vm.customerModel.searchForm.expiryMonth.trim().length > 0 &&
        !Customer.validateExpiryMonth(vm.customerModel.searchForm.expiryMonth)) {
        vm.invalid.expiryMonth = true;
      }
      vm.customerModel.searchForm.expiryMonth = Utils.pad(vm.customerModel.searchForm.expiryMonth,
        2);
      if (!vm.customerModel.searchForm.expiryYear) {
        vm.invalid.expiryYear = true;
      }
    }

    if (vm.customerModel.searchForm.expiryYear) {
      vm.customerModel.searchForm.expiryYear = Utils.pad(vm.customerModel.searchForm.expiryYear, 2);
      if (!vm.customerModel.searchForm.expiryMonth) {
        vm.invalid.expiryMonth = true;
      }
    }

    if (vm.customerModel.searchForm.expiryMonth && vm.customerModel.searchForm.expiryYear &&
      !(vm.customerModel.searchForm.cardBin && vm.customerModel.searchForm.pan)) {
      vm.invalid.pan = true;
      vm.invalid.cardBin = true;
    }

    if (Form.isInvalid()) {
      return false;
    }
    searchCustomers(1)
      .then(function() {
        WebAnalytics.trackSearchResponseEvent($location.url(), Customer.model.customers.length);
      });
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomersByIdCtrl', AdminCustomersByIdCtrl);
AdminCustomersByIdCtrl.$inject = ['$scope', 'Customer', '$location', '$stateParams', 'Form'];

/** @ngInject */
function AdminCustomersByIdCtrl($scope, Customer, $location, $stateParams, Form) {
  if (!$scope.customerPage) {
    Form.queries.customerId = $stateParams.customerId;
    Customer.search(1).then(function(data) {
      $location.path('/admin/customers/' + data.list[0].id + '/transactions').replace();
    });
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AdminCustomersByVaultIdCtrl', ['$scope', 'Customer', '$location',
    function($scope, Customer, $location) {

      if (!$scope.customerPage) {
        Customer.search().then(function(data) {
          $location.path('/admin/customers/' + data.list[0].id + '/transactions');
        });
      }
    },
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminTrialInvitationsCtrl', AdminTrialInvitationsCtrl);
AdminTrialInvitationsCtrl.$inject = ['$scope', 'Link'];

/** @ngInject */
function AdminTrialInvitationsCtrl($scope, Link) {
  $scope.linkModel = Link.model;
  $scope.magicLinkNotificationMessage = {};
  $scope.pageLoaded();

  $scope.translatePrefix = 'TRIAL-INVITATIONS.';


  var validateDuration = function() {
    var valid;
    try {
      var val = $scope.expires_in;
      var expiration = parseInt(val, 10);
      valid = (val === '') || (expiration > 0 && expiration <= 30);
    } catch (e) {
      valid = false;
    }
    return valid;
  };

  var watchExpiresField = function() {
    if ($scope.expires_in === undefined) {
      $scope.expires_in = '';
      return;
    }
    var regEx = /(\d{0,2})/;
    var matches = $scope.expires_in.match(regEx);
    $scope.expires_in = matches[0];
  };

  $scope.generateLink = function() {
    $scope.linkGenerated = false;
    $scope.magicLinkNotificationMessage.hide();
    if (validateDuration()) {
      Link.fetchLink('PILOT_ENROLMENT', $scope.expires_in).then(function() {
        $scope.linkGenerated = true;
      });
    } else {
      $scope.magicLinkNotificationMessage.errorMessage(
        $scope.translate('ERROR-MESSAGE'));
    }
  };

  $scope.$watch('expires_in', watchExpiresField);
}

'use strict';
angular.module('littlepayPortalMerchantApp.pages.admin.developer')
  .controller('AdminDeveloperLogsCtrl', AdminDeveloperLogsCtrl);
AdminDeveloperLogsCtrl.$inject = ['$scope', 'Event', 'Device', 'List', '$location', '$filter', 'toastr'];

/** @ngInject */
function AdminDeveloperLogsCtrl($scope, Event, Device, List, $location, $filter, toastr) {
  $scope.translatePrefix = 'DEVELOPER.LOGS.';

  var vm = this;
  vm.eventModel = Event.model;
  vm.deviceModel = Device.model;
  vm.form = {
    device: '0'
  };
  vm.loading = false;
  vm.hasSearched = false;
  vm.listModalVisible = false;
  vm.denyListModal = {
    loading: true,
    vaultId: undefined
  };

  vm.getEvents = getEvents;
  vm.eventsSearchSubmit = eventsSearchSubmit;
  vm.onEntryChange = onEntryChange;
  vm.prettify = prettify;
  vm.clickCollapse = clickCollapse;
  vm.panelClass = panelClass;
  vm.onPageClick = onPageClick;
  vm.reset = reset;
  vm.getCurrentDeviceText = getCurrentDeviceText;
  vm.checkIfCardOnDenyList = checkIfCardOnDenyList;
  vm.submitListModal = submitListModal;
  vm.closeListModal = closeListModal;
  vm.getDenyListReason = getDenyListReason;

  angular.forEach($location.search(), function(field, key) {
    vm.form[key] = field;
  });

  function getEvents(pageNo) {
    var device = getSelectedDevice();

    vm.eventModel.currentPage = pageNo || vm.eventModel.currentPage;

    if(device) {
      getEventsForDevice(device);
    } else if(vm.form.correlation_id) {
      getEventsForCorrelationId();
    } else if(!device && !vm.form.correlation_id) {
      vm.eventModel.list = [];
      reset();
    }
  }

  function getSelectedDevice() {
    var deviceIndex = parseInt(vm.form.device, 10);
    return deviceIndex===0 ? undefined : vm.deviceModel.allDevices[deviceIndex - 1];
  }

  function getEventsForDevice(device) {
    vm.loading = true;
    vm.hasSearched = true;

    Event.getEvents(device, vm.form.correlation_id, vm.eventModel.currentPage, vm.eventModel.entryNumber).then(function(data) {
      updatePageModel(data);
    }).finally(function() {
      vm.loading = false;
      $scope.pageLoaded();
    });
  }

  function getEventsForCorrelationId() {
    vm.loading = true;
    vm.hasSearched = true;

    Event.getEventsByCorrelationId(vm.eventModel.currentPage).then(function(data) {
      updatePageModel(data);
    }).finally(function() {
      vm.loading = false;
      $scope.pageLoaded();
    });
  }

  function updatePageModel(data) {
    vm.eventModel.list = data.list;
    vm.eventModel.pagination = data.pagination;
    vm.eventModel.noOfPages = Math.ceil(data.pagination.total / parseInt(vm.eventModel.entryNumber, 10));
  }

  function getCurrentDeviceText() {
    var device = getSelectedDevice();
    return device ? device.terminal_id : $scope.translate('ANY-DEVICE');
  }

  function adjustUrl() {
    var device = vm.form.device;
    if(device==='0') {
      device = undefined;
    }
    $location.search('device', device);
    $location.search('correlation_id', vm.form.correlation_id);
    $location.search('page', vm.eventModel.currentPage);
    $location.search('entry', vm.eventModel.entryNumber);
  }

  function eventsSearchSubmit() {
    adjustUrl();
    vm.getEvents();
  }

  function onEntryChange(pageNo) {
    vm.getEvents(pageNo);
  }

  function onPageClick(pageNo) {
    vm.getEvents(pageNo);
  }

  function reset() {
    vm.form.device = '0';
    vm.form.correlation_id = undefined;

    vm.eventModel = {
      list: [],
      pagination: {},
      currentPage: 1,
      entryNumber: '10',
      noOfPages: 0
    };

    vm.hasSearched = false;

    adjustUrl();
  }

  function prettify(json) {
    if (json) {
      return $filter('prettify')(json);
    }
  }

  function panelClass(level) {
    switch (level) {
      case 'INFO':
        return 'info';
      case 'WARN':
        return 'warning';
      case 'ERROR':
        return 'danger';
      default:
        return 'default';
    }
  }

  function clickCollapse(event) {
    if(!event.expanded) {
      Event.getEventDetails(event).then(function(data) {
        event.key_values = data.key_values;
        event.event_trace = data.event_trace;
      }).finally(function() {
        event.expanded = true;
      });
    } else {
      event.expanded = false;
    }
  }

  function checkIfCardOnDenyList(vaultId) {
    vm.denyListModal.vaultId = vaultId;
    vm.denyListModal.loading = true;

    setTimeout(function() {
      List.getCardListEntries(vaultId).then(function(data) {
        vm.denyListModal.loading = false;

        if (cardIsOnDenyList(data)) {
          vm.denyListModal.cardIsOnDenyList = true;
        } else {
          vm.denyListModal.cardIsOnDenyList = false;
          vm.denyListModal.reason = 'UNSPECIFIED';
        }
      }).catch(function() {
        toastr.error($scope.translate('CHECK-DENY-LIST-ERROR'));
        closeListModal();
      });
    }, 2000);
  }

  function submitListModal() {
    if(vm.denyListModal.cardIsOnDenyList) {
      removeCardFromDenyList();
    } else {
      addCardToDenyList();
    }
  }

  function removeCardFromDenyList() {
    var request = {
      function: 'DENY',
      comment: vm.denyListModal.comment
    };

    vm.denyListModal.loading = true;

    List.removeCardFromList(vm.denyListModal.vaultId, request).then(function() {
      toastr.success($scope.translate('REMOVE-CARD-SUCCESS'));
    }).catch(function() {
      toastr.error($scope.translate('REMOVE-CARD-ERROR'));
    }).finally(function() {
      closeListModal();
    });
  }

  function addCardToDenyList() {
    var request = {
      function: 'DENY',
      action: 'ADD',
      comment: vm.denyListModal.comment,
      reason: vm.denyListModal.reason
    };

    vm.denyListModal.loading = true;

    List.addCardToList(vm.denyListModal.vaultId, request).then(function() {
      toastr.success($scope.translate('ADD-CARD-SUCCESS'));
    }).catch(function() {
      toastr.error($scope.translate('ADD-CARD-ERROR'));
    }).finally(function() {
      closeListModal();
    });
  }

  function closeListModal() {
    vm.denyListModal.loading = true;
    vm.denyListModal.vaultId = undefined;
    vm.denyListModal.comment = '';
    vm.denyListModal.reason = '';
  }

  function getDenyListReason(reasonKey) {
    if(!reasonKey) {
      reasonKey = vm.denyListModal.reason || 'UNSPECIFIED';
    }
    return $scope.translate(reasonKey);
  }

  function cardIsOnDenyList(listEntries) {
    for(var i = 0; i < listEntries.list.length; i++) {
      if(listEntries.list[i].functions.indexOf('DENY')!==-1) {
        return true;
      }
    }

    return false;
  }
}

'use strict';
angular.module('littlepayPortalMerchantApp.pages.admin.developer')
  .controller('AdminDeveloperTransactionCtrl', AdminDeveloperTransactionCtrl);
AdminDeveloperTransactionCtrl.$inject = ['$scope', 'Device', 'toastr', 'TRANSACTION_SIMULATOR_OPTIONS', 'DeviceSimulator', '$filter', 'Participant'];

/** @ngInject */
function AdminDeveloperTransactionCtrl($scope, Device, toastr, TRANSACTION_SIMULATOR_OPTIONS, DeviceSimulator, $filter, Participant) {
  $scope.translatePrefix = 'DEVELOPER.TRANSACTION-SIMULATOR.';

  var FARE_TYPE_ON = 'ON';

  var vm = this;
  vm.loading = true;
  vm.error = false;
  vm.formErrors = {};

  function initForm() {
    vm.form = {
      transaction_date_time: moment.utc().format(),
      transaction_outcome: 'ALLOW',
      amount: 2.50,
      currency: vm.options.currencies[0],
      pan: '4111111111111111'
    };
    vm.formErrors = {};
    vm.lastTransactionId = undefined;
    vm.variableFare = false;
    vm.lastPurchase = undefined;
    vm.correlatedPurchase = undefined;

    selectDevice();
  }

  function initOptions() {
    vm.options = angular.copy(TRANSACTION_SIMULATOR_OPTIONS);
    vm.options.currencies = vm.options.currencies.filter(participantHasCurrency);
    vm.options.transactionOutcomes = vm.options.transactionOutcomes.map(function(i) {
      i.label = $scope.translate(i.label);
      return i;
    });
  }

  function participantHasCurrency(currency) {
    return Participant.model.currentParticipant.config.merchant_configs.find(function(config) {
      return $filter('toISOCurrency')(config.currency_code) === currency;
    });
  }

  function selectDevice() {
    var device;

    if(vm.form.device) {
      device = _.find(vm.deviceList, function(d) {
        return vm.form.device === d.device_id_issuer + '#' + d.terminal_id;
      });
    } else if(vm.deviceList.length > 0) {
      device = vm.deviceList[0];
    }

    if(device) {
      vm.form.device = device.device_id_issuer + '#' + device.terminal_id;
      vm.form.device_id = device.terminal_id;
      vm.form.device_id_issuer = device.device_id_issuer;
      vm.selectedDeviceId = device.id;
    }
  }

  function init() {
    vm.loading = true;
    vm.deviceList = [];

    Participant.fetchCurrentParticipant().then(function() {
      initOptions();
      initForm();

      Device.fetchAllDevices(true).then(function(response) {
        vm.deviceList = response.devices || [];
        selectDevice();
      }).finally(function() {
        vm.loading = false;
      });
    });
  }

  function handleSuccessfulResponse(response, transactionType) {
    vm.responseJson = response.message.trim();
    vm.lastTransactionId = response.tap_id;
    vm.form.transaction_date_time = moment.utc().format();
    vm.lastPurchase = response.model.auto_purchase;
    vm.variableFare = transactionType === FARE_TYPE_ON;
    vm.correlatedPurchase = transactionType === FARE_TYPE_ON ? buildCorrelatedPurchase(response.model.auto_purchase.correlated_purchase) : undefined;

    toastr.success($scope.translate('TRANSACTION-SUCCESS'));
  }

  function showError(message) {
    message = $scope.translate('TRANSACTION-ERROR') + (message ? ': ' + message : '.');
    toastr.error(message);
  }

  function buildRequest(transactionType) {
    var data = angular.copy(vm.form);
    data.eligible_zones = data.eligible_zones ? data.eligible_zones.split(',') : undefined;
    data.fare_type = transactionType;
    if(transactionType === 'OFF' && vm.correlatedPurchase) {
      data.correlated_purchase = vm.correlatedPurchase;
    }

    return data;
  }

  function buildCorrelatedPurchase(correlatedPurchase) {
    return {
      id: correlatedPurchase.purchase_id,
      description: correlatedPurchase.description,
      amount: correlatedPurchase.amount
    };
  }

  vm.validForm = function() {
    return Object.keys(vm.formErrors).map(function(key) {
      return vm.formErrors[key];
    }).indexOf(true) === -1;
  };

  vm.validatePan = function() {
    vm.formErrors.pan = !vm.form.pan ||
           isNaN(vm.form.pan) ||
           vm.form.pan.length < 12 ||
           vm.options.validBins.indexOf(vm.form.pan.substr(0, 6)) === -1;
  };

  vm.validateTransactionDateTime = function() {
    vm.formErrors.transaction_date_time = !moment(vm.form.transaction_date_time, 'YYYY-MM-DD[T]HH:mm:ss[Z]', true).isValid();
  };

  vm.onSubmit = function(transactionType) {
    if(!vm.validForm()) {
      return;
    }

    vm.loading = true;

    selectDevice();

    var data = buildRequest(transactionType);

    DeviceSimulator.submitTransaction(vm.selectedDeviceId, data).then(function(response) {
      if(response.status && response.status === 'OK') {
        handleSuccessfulResponse(response, transactionType);
      } else {
        showError(response.message);
      }
    }).catch(function() {
      showError();
    }).finally(function() {
      vm.loading = false;
    });
  };

  vm.onReset = function() {
    initForm();

    vm.responseJson = undefined;
  };

  vm.isFormError = function(key) {
    return vm.formErrors[key];
  };

  vm.prettifyResponse = function() {
    return $filter('prettify')(vm.responseJson);
  };

  vm.viewLogs = function() {
    if(vm.lastTransactionId) {
      window.open('/admin/developer/logs?correlation_id=' + vm.lastTransactionId, '_blank').focus();
    }
  };

  vm.copyTransactionId = function() {
    var textArea = document.getElementById('copy-box');
    textArea.value = vm.lastTransactionId;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    document.execCommand('copy');

    toastr.success($scope.translate('TRANSACTION-ID-COPIED'));
  };

  init();
}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('AdminDevicesAssignmentsCtrl', AdminDevicesAssignmentsCtrl);
AdminDevicesAssignmentsCtrl.$inject = ['$scope', 'Device'];

/** @ngInject */
function AdminDevicesAssignmentsCtrl($scope, Device) {
  $scope.deviceAssignmentsModel = Device.assignmentsModel;

  $scope.translatePrefix = 'DEVICES.DEVICE-ASSIGNMENTS.';

  var getAssignments = function(pageNo) {
    $scope.pageLoadAgain();
    pageNo = pageNo || $scope.deviceAssignmentsModel.currentPage;

    Device.fetchAssignments(pageNo).finally(function() {
      $scope.pageLoaded();
    });
  };

  $scope.onEntryChange = function(pageNo) {
    getAssignments(pageNo);
  };

  $scope.onPageClick = function(pageNo) {
    getAssignments(pageNo);
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.devices')
  .controller('AdminDevicesCtrl', AdminDevicesCtrl);
AdminDevicesCtrl.$inject = ['$scope', 'Device', '$rootScope', '$location', 'WebAnalytics'];

/** @ngInject */
function AdminDevicesCtrl($scope, Device, $rootScope, $location, WebAnalytics) {
  $scope.deviceModel = Device.model;
  $scope.searchForm = Device.searchForm;

  $scope.translatePrefix = 'DEVICES.DEVICE-LISTS.';

  if ($scope.searchForm.terminal_id) {
    $scope.showAdvancedSearch = true;
    $scope.searchForm.newSearch = true;
  }

  var getDevices = function(pageNo) {
    pageNo = pageNo || $scope.deviceModel.currentPage;
    $scope.pageLoadAgain();
    $scope.error = false;

    return Device.fetchDevices(pageNo).catch(function() {
      $scope.error = true;
    }).finally(function() {
      $scope.pageLoaded();
    });
  };

  $scope.onEntryChange = function(pageNo) {
    getDevices(pageNo);
  };

  $scope.onPageClick = function(pageNo) {
    getDevices(pageNo);
  };

  $scope.sortDevices = function() {
    getDevices();
  };

  $scope.advancedSearch = function() {
    $scope.showAdvancedSearch = !$scope.showAdvancedSearch;
  };

  $scope.clearForm = function() {
    Device.clearSearchForm();
    getDevices();
  };

  $scope.deviceSearchSubmit = function() {
    $scope.searchForm.newSearch = true;
    getDevices()
      .then(function() {
        WebAnalytics.trackSearchResponseEvent($location.url(), Device.model.allDevices.length);
      });
  };

}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsExceptionPeriodsCtrl', AdminProductsExceptionPeriodsCtrl);
AdminProductsExceptionPeriodsCtrl.$inject = [
  '$scope',
  'ExceptionPeriod',
  'toastr',
  'editableOptions',
  'Auth'];

/** @ngInject */
function AdminProductsExceptionPeriodsCtrl($scope, ExceptionPeriod, toastr, editableOptions, Auth) {
  var vm = this;
  vm.exceptionPeriodModel = ExceptionPeriod.model;
  vm.getExceptionPeriods = getExceptionPeriods;
  vm.addException = addException;
  vm.removeConfirmation = removeConfirmation;
  vm.save = save;
  vm.cancel = cancel;
  editableOptions.theme = 'bs3';

  vm.hasPermission = Auth.hasPermission('WriteProducts');
  vm.loading = {
    'hasLoaded': false,
    'error': false,
  };
  vm.repeatTypeList = ['ANNUALLY', 'NO_REPEAT'];
  vm.timePeriodTypeList = ['PEAK', 'OFFPEAK'];

  $scope.translatePrefix = 'PRODUCTS.EXCEPTION-PERIODS.';

  $scope.pageLoaded();

  $scope.onPageClick = function(pageNo) {
    getExceptionPeriods(pageNo);
  };

  function getExceptionPeriods(pageNo) {
    ExceptionPeriod.fetch(pageNo).catch(function() {
      vm.loading.error = true;
    }).finally(function() {
      vm.loading.hasLoaded = true;
    }).then(function() {
      angular.forEach(vm.exceptionPeriodModel.list, function(data) {
        data.dateNew = new Date(data.date);
      });
    });
  }

  function addException() {
    vm.newInserted = {
      'participant_id': $scope.profile.account.id,
      'dateNew': new Date(),
      'description': '',
      'repeat_type': 'ANNUALLY',
      'period_type': 'PEAK',
    };
    vm.exceptionPeriodModel.list.push(vm.newInserted);
  }

  function remove() {
    if (vm.exceptionPeriodModel.list[vm.selectedIndex].id) {
      ExceptionPeriod.delete({
        'exceptionId': vm.exceptionPeriodModel.list[vm.selectedIndex].id,
        'participantId': $scope.profile.account.id,
      }, function() {
        toastr.success($scope.translate('REMOVED-SUCCESSFULLY'));
        removeFromArray();
      }, function() {
        toastr.error($scope.translate('REMOVED-ERROR'));
      });
    } else {
      removeFromArray();
    }
  }

  function removeConfirmation(index) {
    var msg = $scope.translate('REMOVE-CONFIRMATION');
    vm.selectedIndex = index;
    $scope.deleteAlert(remove, msg);
  }

  function removeFromArray() {
    vm.exceptionPeriodModel.list.splice(vm.selectedIndex, 1);
    getExceptionPeriods();
  }

  function save(data, id) {
    data.id = id;
    ExceptionPeriod.save(data).then(function() {
      toastr.success($scope.translate('SAVED-SUCCESSFULLY'));
    }).catch(function(response) {
      toastr.error($scope.translate('SAVED-ERROR', {'detail': response.data.errors[0].detail }));
    }).finally(function() {
      getExceptionPeriods();
    });
  }

  function cancel(rowform) {
    getExceptionPeriods();
    rowform.$cancel();
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsPricingPeriodsCtrl', AdminProductsPricingPeriodsCtrl);
AdminProductsPricingPeriodsCtrl.$inject = [
  '$scope',
  'PricingPeriod',
  'Utils',
  'initPricingPeriod',
  'toastr',
  'Auth',
  '$timeout',
  'Participant'];

/** @ngInject */
function AdminProductsPricingPeriodsCtrl($scope, PricingPeriod, Utils, initPricingPeriod, toastr,
                                         Auth, $timeout, Participant) {

  var vm = this;
  vm.pricingPeriodModel = PricingPeriod.model;
  vm.participantModel = Participant.model;
  $scope.translatePrefix = 'PRODUCTS.PRICING-PERIODS.';

  $scope.$watch('vm.participantModel.currentParticipant', function(newVal){
    if(!$scope.isEmpty(newVal)) {

      vm.vars = initPricingPeriod;
      vm.convertToSec = Utils.convertToSec;
      vm.removeRange = removeRange;
      vm.activate = activate;
      vm.save = save;
      vm.addRule = addRule;
      vm.removeConfirmation = removeConfirmation;
      vm.isEmpty = isEmpty;
      vm.hasPermission = Auth.hasPermission('WriteProducts');
      vm.dayIsUsedElsewhere = dayIsUsedElsewhere;
      vm.timezone = vm.participantModel.currentParticipant.config.local_time_zone;

      initRules();
      $scope.pageLoaded();

    }
  });

  function initRules() {
    if (vm.pricingPeriodModel.list.length < 1) {
      vm.pricingPeriodModel.list.push({});
      vm.vars.options = [angular.copy(vm.vars.defaultOptions)];
    } else {
      vm.vars.options = [];
      angular.forEach(vm.pricingPeriodModel.list, function(val) {
        var start = [];
        var options = angular.copy(vm.vars.defaultOptions);
        angular.forEach(val.time_periods, function(p) {

          var start_time;
          var finish_time;

          if(typeof p.offset !== 'undefined') {
            start_time = convertUsingOffset(p.start_time, p.offset);
          } else {
            start_time = convertToTimezone(p.start_time);
          }

          if(typeof p.offset !== 'undefined') {
            finish_time = convertUsingOffset(p.finish_time, p.offset);
          }else {
            finish_time = convertToTimezone(p.finish_time);
          }

          if (finish_time === '00:00') {
            finish_time = '24:00';
          }
          start.push(start_time, finish_time);
        });
        if (start.length > 0) {
          options.start = start;
          options.connect = Utils.adjustConnect(options.start);
        }
        vm.vars.options.push(options);
      });
    }
    vm.temporaryList = angular.copy(vm.pricingPeriodModel.list);
  }

  function addRule() {
    vm.pricingPeriodModel.list.push({});
    vm.vars.options.push(angular.copy(vm.vars.defaultOptions));
    vm.vars.selectedRule = vm.pricingPeriodModel.list.length - 1;
  }

  function removeRule() {
    var key = vm.vars.selectedRule;
    if (vm.pricingPeriodModel.list[key].id) {
      PricingPeriod.delete({
        'participantId': $scope.profile.account.id,
        'periodId': vm.pricingPeriodModel.list[key].id,
      }, function() {
        toastr.success($scope.translate('RULE-IS-REMOVED', {'name': vm.pricingPeriodModel.list[key].name }));
        removeFromArray(key);
      }, function() {
        toastr.error($scope.translate('RULE-IS-REMOVED-ERROR', {'name': vm.pricingPeriodModel.list[key].name }));
      });
    } else {
      var newName = $scope.translate('NEW');
      toastr.success( $scope.translate('NEW-RULE-IS-REMOVED', {'name': (vm.pricingPeriodModel.list[key].name || newName)}) );
      removeFromArray(key);
    }
  }

  function removeConfirmation() {
    var msg = $scope.translate('REMOVE-CONFIRMATION');
    $scope.deleteAlert(removeRule, msg);
  }

  function removeFromArray(key) {
    $timeout(function() {
      vm.pricingPeriodModel.list.splice(key, 1);
      vm.vars.options.splice(key, 1);
      vm.vars.selectedRule = 0;
      initRules();
    }, 1);
  }

  function removeRange(key, index) {
    vm.pricingPeriodModel.list[key].time_periods.splice(index, 1);
    vm.vars.options[key].removed = {
      'index': index,
      'id': Math.floor((Math.random() * 90000) + 10000),
    };
  }

  function activate(key, rule, event) {
    if (!rule.days) {
      rule.days = [];
    }
    var location = rule.days.indexOf(key.toUpperCase());
    if (location > -1) {
      rule.days.splice(location, 1);
    } else {
      rule.days.push(key.toUpperCase());
    }
    sortDays(rule);
    event.target.blur();
  }

  function sortDays(rule) {
    rule.days.sort(function(a, b) {
      var posA = vm.vars.weeknamesIndex.indexOf(a);
      var posB = vm.vars.weeknamesIndex.indexOf(b);
      if (posA === posB) {
        return 0;
      }
      return posA < posB ? -1 : 1;
    });
  }

  function save(rule, key) {
    var tempRule = angular.copy(rule);

    angular.forEach(tempRule.time_periods, function(value) {
      value.start_time = convertToUtcTime(value.start_time);
      value.finish_time = convertToUtcTime(value.finish_time);
      value.timezone = vm.timezone;
    });

    PricingPeriod.save(tempRule).then(function(data) {
      toastr.success($scope.translate('RULE-IS-SAVED', {'name': rule.name}));
      rule.id = data.id;
      vm.pricingPeriodModel.list[key] = rule;
    }).catch(function(response) {
      toastr.error( $scope.translate('RULE-IS-SAVED', {'name': rule.name, 'detail': response.data.errors[0].detail }));
    });
  }

  function convertToUtcTime(time) {
    return moment.tz(time, 'HH:mm', vm.timezone).utc().format('HH:mm');
  }

  function convertToTimezone(time) {
    return moment.utc(time, 'HH:mm').tz(vm.timezone).format('HH:mm');
  }

  function convertUsingOffset(time, offset) {
    return moment.utc(time, 'HH:mm').utcOffset(offset).format('HH:mm');
  }

  function isEmpty(item) {
    return angular.equals({}, item);
  }

  function dayIsUsedElsewhere(ruleKey, day) {
    for (var key in vm.pricingPeriodModel.list) {
      if (ruleKey + '' !== key + '' &&
        vm.pricingPeriodModel.list[key].days.indexOf(day.toUpperCase()) > -1) {
        return true;
      }
    }
    return false;
  }
}

/**
 * @author z.geddes
 * created on 05.03.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsZonesCtrl', AdminProductsZonesCtrl);
AdminProductsZonesCtrl.$inject = ['$scope', 'Zone', 'Form', 'toastr', 'editableOptions', 'Auth', 'sweetAlert'];

/** @ngInject */
function AdminProductsZonesCtrl($scope, Zone, Form, toastr, editableOptions, Auth, sweetAlert) {
  var vm = this;
  vm.zoneModel = Zone.model;
  editableOptions.theme = 'bs3';
  vm.form = Form.queries;
  vm.loading = Form.loading;
  vm.getZones = getZones;
  vm.addZone = addZone;
  vm.addTerminalId = addTerminalId;
  vm.removeTerminalId = removeTerminalId;
  vm.removeConfirmation = removeConfirmation;
  vm.save = save;
  vm.cancel = cancel;
  vm.hasPermission = Auth.hasPermission('WriteProducts');
  $scope.pageLoaded();

  $scope.translatePrefix = 'PRODUCTS.ZONES.';

  getZones();

  function getZones() {
    Zone.fetch().catch(function() {
      vm.loading.error = true;
    }).finally(function() {
      vm.loading.hasLoaded = true;
    });
  }

  function addZone() {
    vm.newInserted = {
      'zone_name': '',
      'lookup_keys': [''],
    };
    vm.zoneModel.list.push(vm.newInserted);
  }

  function addTerminalId(zone) {
    zone.lookup_keys.push('');
  }

  function removeTerminalId(zone) {
    zone.lookup_keys.splice(zone.lookup_keys.length - 1, 1);
  }

  function remove() {
    if (vm.zoneModel.list[vm.selectedIndex].id) {
      Zone.remove(vm.zoneModel.list[vm.selectedIndex].id).then(function() {
        toastr.success($scope.translate('ZONE-REMOVED'));
        removeFromArray();
      }).catch(function() {
        toastr.error($scope.translate('ZONE-REMOVED-ERROR'));
        getZones();
      });
    } else {
      removeFromArray();
    }
  }

  function removeConfirmation(index) {
    var msg = $scope.translate('ZONE-REMOVE-ARE-YOU-SURE');
    vm.selectedIndex = index;
    $scope.deleteAlert(remove, msg);
  }

  function removeFromArray() {
    vm.zoneModel.list.splice(vm.selectedIndex, 1);
    getZones();
  }

  function save(data, key) {
    Zone.save(vm.zoneModel.list[key], vm.form.participant).then(function() {
      toastr.success($scope.translate('ZONE-SAVED'));
    }).catch(function(response) {
      toastr.error($scope.translate('SAVING-ERROR', {'message': response.data.errors[0].detail}));
    }).finally(function() {
      getZones();
    });
  }

  function cancel(rowform) {
    rowform.$cancel();
    getZones();
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.search')
  .controller('AdminSearchChargesCtrl', AdminSearchChargesCtrl);

AdminSearchChargesCtrl.$inject = ['$scope', 'TransactionSearch', '$location', 'Form', 'TRANSACTION_FILTERS', 'toastr', '$filter'];

/** @ngInject */
function AdminSearchChargesCtrl($scope, TransactionSearch, $location, Form, TRANSACTION_FILTERS, toastr, $filter) {

  var vm = this;
  vm.transactionModel = TransactionSearch.model;
  vm.loading = Form.loading;
  vm.getTransactions = getTransactions;
  vm.search = search;
  vm.transactionFilters = TRANSACTION_FILTERS;
  vm.cleared = cleared;
  vm.remove = remove;
  vm.resetAll = resetAll;
  vm.callModalFunction = callModalFunction;
  vm.cardDetailsFilter = cardDetailsFilter;
  vm.hasAmountError = TransactionSearch.hasAmountError;
  vm.isValid = TransactionSearch.isValid;
  vm.formFilters = TransactionSearch.searchForm;
  vm.form = {};
  vm.pageLoading = false;
  vm.loading.hasLoaded = true;

  vm.earliestFromDate = TransactionSearch.getEarliestFromDate();
  $scope.translatePrefix = 'TRANSACTIONS.SEARCH.';

  TransactionSearch.setForms(vm.form, $location.search());

  function getTransactions(pageNo) {
    var queryParams = angular.copy(vm.form) || null;
    vm.loading.hasLoaded = false;
    pageNo = pageNo || vm.transactionModel.currentPage;
    TransactionSearch.fetchTransactions(pageNo, queryParams).catch(function() {
      vm.loading.error = true;
    }).finally(function() {
      vm.loading.hasLoaded = true;
    });
  }

  function search(form, page) {
    vm.filtersAreValid = true;
    var invalid_input = '';

    angular.forEach(form, function(element, name) {

      if (!name.startsWith('$') && form[name].$valid === false) {
        vm.filtersAreValid = false;
        invalid_input = form[name].$error_description || $scope.translate('ERROR-MESSAGE', {'name': $filter('replaceUnderscore')(name), 'value': form[name].$viewValue });
      }
    });

    if (vm.filtersAreValid) {
      getTransactions(1);

    }else {

      toastr.error($scope.translate('INVALID-INPUT', {input: invalid_input}));
    }
  }

  function resetAll(){
    angular.forEach(vm.form, function(value, key) {
      remove(key);
    });
    $location.search('page', null);
  }

  function remove(field) {
    TransactionSearch.removeFilters(field, vm.form);
    vm.search(vm.form, 1);
  }

  function cleared(model){
    angular.forEach(vm.form, function(value, key) {
      if(value === model) {
        remove(key);
      }
    });
  }

  function callModalFunction(transaction) {
    TransactionSearch.selectCharge(transaction);
  }

  function cardDetailsFilter() {
    return vm.formFilters.card_first || vm.formFilters.card_last || vm.formFilters.expiration || vm.formFilters.card_type || vm.formFilters.form_factor;
  }

}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.search')
  .controller('AdminOrdersCtrl', AdminOrdersCtrl);
AdminOrdersCtrl.$inject = ['$scope', '$state', 'Order', 'OrderSearch', 'FeatureFlags', 'Form', 'toastr', '$filter'];

/** @ngInject */
function AdminOrdersCtrl($scope, $state, Order, OrderSearch, FeatureFlags, Form, toastr, $filter) {
  var vm = this;
  vm.orderModel = OrderSearch.model;
  vm.loading = Form.loading;
  vm.form = OrderSearch.searchForm;
  vm.getOrderDetailsForm = {
    orderId: undefined,
  };
  vm.pageState = getState();
  vm.getOrders = getOrders;
  vm.getOrderDetails = getOrderDetails;
  vm.featureFlags = featureFlags();
  vm.orderSearchClick = orderSearchClick;
  vm.getOrderDetailsClick = getOrderDetailsClick;
  vm.resetClick = resetClick;
  vm.isValid = OrderSearch.isValid;
  vm.cleared = cleared;
  vm.remove = remove;
  $scope.translatePrefix = 'ORDER.';
  $scope.showOrderTable = false;

  function getOrders(pageNo) {
    vm.loading.hasLoaded = false;
    OrderSearch.fetchOrders(pageNo).catch(function() {
      vm.loading.error = true;
    }).finally(function() {
      vm.loading.hasLoaded = true;
    });
  }

  function getOrderDetails(orderId) {
    vm.loading.error = false;
    Order.getOrderDetails(orderId)
      .then(function(orderDetails) {
        $state.go('admin.search.orderDetails', {
          orderId: orderId,
          orderDetails: orderDetails,
        });
      })
      .catch(function(error) {
        vm.loading.error = true;
        if (error.status === 404) {
          toastr.error($scope.translate('NO-ORDER-FOUND'));
        } else {
          toastr.error($scope.translate('ERROR-MESSAGE'));
        }
      })
      .finally(function() {
        vm.loading.hasLoaded = true;
      });
  }

  function getState(){
    return $state.current.hide ? "error_permissions" : "ready";
  }

  function featureFlags() {
    vm.featureFlags = false;
    FeatureFlags.fetchFeatureFlags().then(function(res) {
      if(res.CnpOrders !== 'undefined'){
        if(res.CnpOrders === 'ENABLED'){
          vm.featureFlags = true;
        }
      }
    });
  }

  function orderSearchClick() {
    vm.filtersAreValid = true;
    var invalid_input = '';
    angular.forEach(vm.form, function(element, name) {
      if (!name.startsWith('$') && vm.form[name].$valid === false) {
        vm.filtersAreValid = false;
        invalid_input = vm.form[name].$error_description || $scope.translate('ERROR-MESSAGE', {'name': $filter('replaceUnderscore')(name), 'value': vm.form[name].$viewValue });
      }
    });
    if (vm.filtersAreValid) {
      $scope.showOrderTable = true;
      getOrders(1);
    } else {
      toastr.error($scope.translate('INVALID-INPUT', {input: invalid_input}));
    }
  }

  function getOrderDetailsClick() {
    vm.loading.hasLoaded = false;
    getOrderDetails(vm.getOrderDetailsForm.orderId);
  }

  function resetClick() {
    OrderSearch.resetClick(vm.form);
    $scope.showOrderTable = false;
  }

  function cleared(model) {
    angular.forEach(vm.form, function (value, key) {
      if (value === model) {
        remove(key);
      }
    });
  }

  function remove(field) {
    OrderSearch.removeFilters(field, vm.form);
    vm.orderSearchClick();
  }

  $scope.$watch('vm.form.amount', function(val) {
    val = angular.isString(val) ? val : val + '';
    var regEx = /(\d+)(\.)*(\d{0,2})/;
    var matches = val.match(regEx);
    if (!matches) {
      vm.form.amount = '';
      return;
    }
    var firstDigit = matches[1];
    var dot = matches[2];
    var secondDigit = matches[3];

    var amount = 0;
    if (matches.length >= 2) {
      amount = firstDigit;
    }
    if (matches.length >= 3 && dot) {
      amount += '.';
    }
    if (matches.length >= 4 && secondDigit) {
      amount += secondDigit;
    }
    vm.form.amount = amount;
  });
}


'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.search')
  .controller('AdminSearchTripsCtrl', AdminSearchTripsCtrl);

AdminSearchTripsCtrl.$inject = ['$scope', 'TransactionSearch', '$location', 'Form', 'TRANSACTION_FILTERS', 'toastr', '$filter'];

/** @ngInject */
function AdminSearchTripsCtrl($scope, TransactionSearch, $location, Form, TRANSACTION_FILTERS, toastr, $filter) {

  var vm = this;
  vm.transactionModel = TransactionSearch.model;
  vm.loading = Form.loading;
  vm.loading.hasLoaded = true;
  vm.getTrips = getTrips;
  vm.search = search;
  vm.transactionFilters = TRANSACTION_FILTERS;
  vm.cleared = cleared;
  vm.remove = remove;
  vm.resetAll = resetAll;
  vm.callModalFunction = callModalFunction;
  vm.cardDetailsFilter = cardDetailsFilter;
  vm.hasAmountError = TransactionSearch.hasAmountError;
  vm.isValid = TransactionSearch.isValid;
  vm.formFilters = TransactionSearch.searchForm;

  vm.earliestFromDate = TransactionSearch.getEarliestFromDate();
  vm.form = {};

  $scope.translatePrefix = 'TRANSACTIONS.SEARCH.';

  TransactionSearch.setForms(vm.form, $location.search());

  function getTrips(pageNo) {
    var queryParams = angular.copy(vm.form) || null;
    vm.loading.hasLoaded = false;
    pageNo = pageNo || vm.transactionModel.currentPage;
    TransactionSearch.fetchTrips(pageNo, queryParams).catch(function() {
      vm.loading.error = true;
    }).finally(function() {
      vm.loading.hasLoaded = true;
    });
  }

  function search(form, page) {
    vm.filtersAreValid = true;
    var invalid_input = '';

    angular.forEach(form, function(element, name) {

      if (!name.startsWith('$') && form[name].$valid === false) {
        vm.filtersAreValid = false;
        invalid_input = form[name].$error_description || $scope.translate('ERROR-MESSAGE', {'name': $filter('replaceUnderscore')(name), 'value': form[name].$viewValue });
      }
    });

    if (vm.filtersAreValid) {

      getTrips(1);

    }else {
      toastr.error($scope.translate('INVALID-INPUT', {input: invalid_input}));
    }
  }

  function resetAll(){
    angular.forEach(vm.form, function(value, key) {
      remove(key);
    });
    $location.search('page', null);
  }

  function remove(field) {
    TransactionSearch.removeFilters(field, vm.form);
    vm.search(vm.form, 1);
  }

  function cleared(model){
    angular.forEach(vm.form, function(value, key) {
      if(value === model) {
        remove(key);
      }
    });
  }

  function callModalFunction(trip) {
    TransactionSearch.selectTrip(trip);
  }

  function cardDetailsFilter() {
    return vm.formFilters.card_first || vm.formFilters.card_last || vm.formFilters.expiration || vm.formFilters.card_type || vm.formFilters.form_factor;
  }

}

'use strict';
angular.module('littlepayPortalMerchantApp')
  .controller('AdminSettingsAccountCtrl', AdminSettingsAccountCtrl);
AdminSettingsAccountCtrl.$inject = [
  '$scope',
  'Auth',
  'User',
  'Permission',
  '$location',
  '$timeout',
  'toastr',
  '$translate',
  'FeatureFlags',
  'RevenueInspectionUser'
];

/** @ngInject */
function AdminSettingsAccountCtrl($scope, Auth, User, Permission, $location, $timeout, toastr, $translate, FeatureFlags, RevenueInspectionUser) {
  $scope.userModel = User.model;
  $scope.permissionModel = Permission.model;
  $scope.isAdmin = Auth.isAdmin();
  $scope.error = false;
  $scope.notificationMessage = null;
  $scope.createUserNotificationMessage = {};
  $scope.translatePrefix = 'SETTINGS.ACCOUNT.';

  $scope.pageLoaded();

  Permission.fetchPermissions();

  var updateUserList = function() {
    User.getUsers().finally(function() {
      $scope.pageLoaded();
    });
    $location.search('page', null);
  };

  var updateRevenueInspectionUserList = function(msg) {
    $scope.pageLoadAgain();
    $timeout(function() {
      RevenueInspectionUser.getUsers(1).finally(function() {
        $scope.pageLoaded();
      });
    }, 1000);
    $scope.modalCloseClick();
    toastr.success(msg);
  }

  $scope.callModalClick = function(modal, user) {
    User.clearCreateUserForm();
    $scope[modal] = true;
    $scope.currentUser = user || {};
  };

  $scope.modalCloseClick = function() {
    User.clearCreateUserForm();
    $scope.createUserNotificationMessage.hide();
    $scope.createStaffAccountModal = false;
    $scope.deleteStaffAccountModal = false;
    $scope.createRevenueInspectionAccountModal = false;
    $scope.deleteRevenueInspectionAccountModal = false;
    $scope.editRevenueInspectionAccountModal = false;
  };

  $scope.deleteUserModal = function() {
    if(!$scope.deleteRevenueInspectionAccountModal) {
      User.deleteUser($scope.currentUser.id).then(function() {
        $timeout(function() {
          updateUserList();
        }, 1000);
        toastr.success($scope.translate('DELETE-SUCCESS'));
      }).catch(function() {
        toastr.error($scope.translate('DELETE-ERROR'));
      });
    }else {
      RevenueInspectionUser.deleteUser($scope.currentUser.id).then(function() {
        updateRevenueInspectionUserList($scope.translate('DELETE-SUCCESS'));
      }).catch(function() {
        toastr.error($scope.translate('DELETE-ERROR'));
      });
    }

    $scope.modalCloseClick();
  };

  $scope.updateUserModel = function() {
    User.resetValidation();
    if(!validatePassword()) {
      return;
    }
    var data = {
      'password': $scope.userModel.newUser.password,
      'app_meta_data': $scope.currentUser.app_meta_data,
      'userId': $scope.currentUser.id
    };
    RevenueInspectionUser.updateUser(data).then(function() {
      updateRevenueInspectionUserList($scope.translate('UPDATE-USER-SUCCESS'));
    }).catch(function(response) {
      var message = response.description || $scope.translate('COULD-NOT-UPDATE-THE-USER');
      $scope.createUserNotificationMessage.errorMessage(message);
    });
  }

  $scope.createUserModal = function() {
    User.resetValidation();

    if(!validateEmail() || !validatePassword()) {
      return;
    }

    if(!$scope.createRevenueInspectionAccountModal) {
      User.createUser().then(function() {
        toastr.success($scope.translate('CREATE-USER-SUCCESS'));

        $scope.pageLoadAgain();
        $timeout(function() {
          updateUserList();
        }, 1000);
        $scope.modalCloseClick();
      }).catch(function(response) {
        var message = createUserError(response);
          $scope.translate('INVALID-EMAIL-PASSWORD');
        $scope.createUserNotificationMessage.errorMessage(message);
      });
    }else {
      RevenueInspectionUser.model.newUser = angular.copy($scope.userModel.newUser);
      RevenueInspectionUser.createUser().then(function() {
        updateRevenueInspectionUserList($scope.translate('CREATE-USER-SUCCESS'));
      }).catch(function(response) {
        var message = createUserError(response);
        $scope.createUserNotificationMessage.errorMessage(message);
      });
    }
  };

  var validateEmail = function() {
    if (!User.validateEmailEmpty()) {
      $scope.createUserNotificationMessage.errorMessage(
        $scope.translate('EMPTY-EMAIL-ERROR')
      );
      return false;
    }
    if (!User.validateEmailFormat()) {
      $scope.createUserNotificationMessage.errorMessage(
        $scope.translate('VALID-EMAIL-ERROR')
      );
      return false;
    }
    return true;
  }

  var validatePassword = function() {
    if (!User.validatePasswordEmpty()) {

      $scope.createUserNotificationMessage.errorMessage(
        $scope.translate('EMPTY-PASSWORD-ERROR')
      );
      return false;
    }
    if (!User.validatePasswordFormat()) {
      $scope.createUserNotificationMessage.errorMessage(
        $scope.translate('VALID-PASSWORD-ERROR')
      );
      return false;
    }
    if (!User.validateRepeatPassword()) {
      $scope.createUserNotificationMessage.errorMessage(
        $scope.translate('CONFIRMATION-PASSWORD-ERROR')
      );
      return false;
    }
    return true;
  }

  var createUserError = function(response) {
    if(response.description) {
      return response.description;
    }
    if(response.data && response.data.errors && response.data.errors[0] && response.data.errors[0].detail) {
      if(response.data.errors[0].detail.indexOf('-') === -1) {
        return response.data.errors[0].detail;
      }
      return response.data.errors[0].detail.split('-')[1].trim();
    }
    return $scope.translate('INVALID-EMAIL-PASSWORD');
  }

  $scope.pageLoaded();
}

'use strict';
angular.module('littlepayPortalMerchantApp')
  .controller('AdminSettingsAccountSummaryCtrl', AdminSettingsAccountSummaryCtrl);
AdminSettingsAccountSummaryCtrl.$inject = [
  '$scope',
  'Auth',
  'User',
  'Permission',
  '$stateParams',
  'toastr'];

/** @ngInject */
function AdminSettingsAccountSummaryCtrl($scope, Auth, User, Permission, $stateParams, toastr) {
  $scope.userModel = User.model;
  $scope.permissionModel = Permission.model;
  $scope.error = false;
  $scope.isAdmin = Auth.isAdmin();
  $scope.notificationMessage = null;
  $scope.translatePrefix = 'SETTINGS.ACCOUNT-SUMMARY.';

  $scope.save = function() {
    $scope.pageLoadAgain();
    var data = {
      'app_meta_data': $scope.userModel.user.app_meta_data,
      'userId': $stateParams.userId,
    };

    angular.forEach(data.app_meta_data.participants, function(metadata, key) {
      if ($scope.userModel.participantAccounts[metadata.name] &&
        $scope.userModel.participantAccounts[metadata.name].selected) {

        var participant = angular.copy($scope.userModel.participantAccounts[metadata.name]);
        var permissions = User.userPermissions(
          $scope.userModel.participantAccounts[metadata.name].permissions);

        $scope.userModel.user.app_meta_data.participants[key].role = participant.role;
        $scope.userModel.user.app_meta_data.participants[key].permissions = permissions;

        if (participant.role === 'admin' || permissions.length === 0) {
          delete $scope.userModel.user.app_meta_data.participants[key].permissions;
        }
      }
    });

    User.updateUser(data)
      .then(function() {
        toastr.success($scope.translate('UPDATE-ACCOUNT.UPDATE-SUCCESS'));
      }).catch(function() {
      toastr.error($scope.translate('UPDATE-ACCOUNT.UPDATE-ERROR'));

    }).finally(function() {
      $scope.pageLoaded();
    });

  };
}

'use strict';
angular.module('littlepayPortalMerchantApp.pages.admin.settings')
  .controller('AdminSettingsGeneralCtrl', AdminSettingsGeneralCtrl);
AdminSettingsGeneralCtrl.$inject = ['$scope', 'Participant', 'Auth', 'toastr'];

/** @ngInject */
function AdminSettingsGeneralCtrl($scope, Participant, Auth, toastr) {

  $scope.translatePrefix = 'SETTINGS.PROFILE.';

  $scope.participantModel = Participant.model;
  $scope.isParent = Auth.isParent();
  $scope.error = false;
  $scope.haspermissionIssueRefund = Auth.checkUserHasPermission('IssueRefund');
  $scope.hasPermissionWriteProduct = Auth.checkUserHasPermission('WriteProduct');

  $scope.merchantConfigSelected = 0;

  $scope.forms = {
    mpsForm: false,
    adjustableForm: false,
  };

  var convertMinutesToSeconds = function(m) {
    return m * 60;
  };

  var convertSecondsToMinutes = function(m) {
    return m / 60;
  };

  var updateMpsPricingMinToSec = function() {
    $scope.participantTemporary.config.mps_config.pricing.maximum_journey_time = convertMinutesToSeconds(
      $scope.participantTemporary.config.mps_config.pricing.maximum_journey_time);
    $scope.participantTemporary.config.mps_config.pricing.tap_correlation_buffer = convertMinutesToSeconds(
      $scope.participantTemporary.config.mps_config.pricing.tap_correlation_buffer);
  };

  var updateMpsPricingSecToMin = function() {
    $scope.participantTemporary.config.mps_config.pricing.maximum_journey_time = convertSecondsToMinutes(
      $scope.participantTemporary.config.mps_config.pricing.maximum_journey_time);
    $scope.participantTemporary.config.mps_config.pricing.tap_correlation_buffer = convertSecondsToMinutes(
      $scope.participantTemporary.config.mps_config.pricing.tap_correlation_buffer);
  };

  $scope.switchMerchant = function(name) {
    $scope.merchantConfigSelected = name;
  };

  $scope.getTemporaryValue = function() {
    $scope.participantTemporary = angular.copy($scope.participantModel.currentParticipant);
    updateMpsPricingSecToMin();
  };

  $scope.cancelParticipant = function() {
    $scope.getTemporaryValue();
  };

  Participant.fetchCurrentParticipant().then(function() {
    $scope.getTemporaryValue();
  }).catch(function() {
    $scope.error = true;
  }).finally(function() {
    $scope.pageLoaded();
  });

  $scope.updateParticipant = function() {
    updateMpsPricingMinToSec();
    Participant.updateCurrentParticipant($scope.participantTemporary).$promise.then(function() {
      $scope.participantModel.currentParticipant = angular.copy($scope.participantTemporary);
      updateMpsPricingSecToMin();
      toastr.success($scope.translate('UPDATE-SUCCESS'));
    }).catch(function() {
      toastr.error($scope.translate('UPDATE-ERROR'));
    });
  };

  $scope.$watchGroup([
    'participantTemporary.config.mps_config.pricing.maximum_journey_time',
    'participantTemporary.config.mps_config.pricing.tap_correlation_buffer'], function(newValues) {
    var errorMPS = ['errorMaxJourneyTime', 'errorCorrelationBuffer'];
    $scope.forms.mpsFormDisable = false;

    angular.forEach(newValues, function(value, key) {
      if (value > 1440) {
        $scope[errorMPS[key]] = true;
        $scope.forms.mpsFormDisable = true;
      } else {
        $scope[errorMPS[key]] = false;
      }
    });
  }, true);

  $scope.isAggregationEndOfDay = function() {
      return $scope.participantModel.currentParticipant.config.payment_config.aggregation_type === 'END_OF_DAY_AGGREGATION';
  };

  $scope.isRollingAggregation = function() {
    return $scope.participantModel.currentParticipant.config.payment_config.aggregation_type === 'ROLLING_AGGREGATION';
  };
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.analysis')
  .controller('AdminTransactionAnalysis', AdminTransactionAnalysis);

AdminTransactionAnalysis.$inject = [
  '$controller',
  '$scope',
  'TransactionAnalysis',
  'analyticsConfig',
  'OrganiseData',
  'initOptions',
  'ChartRegistry',
  '$location',
  'WebAnalytics'];

/** @ngInject */
function AdminTransactionAnalysis($controller, $scope, TransactionAnalysis, analyticsConfig,
                                  OrganiseData, initOptions, ChartRegistry, $location, WebAnalytics) {

  Object.assign(this, $controller('AdminAnalysis', {$scope: $scope, $location: $location}));

  var vm = this;
  vm.form = {};
  vm.analyticsModel = TransactionAnalysis.model;
  vm.options = Object.assign(vm.options, initOptions);
  vm.selectedPrice = vm.options.price[1]; //set to 0 to select "All" by default (only showing nominal fares at the moment)
  vm.csvFilenamePrefix = 'TransactionsAnalytics';
  vm.datePickerOptions.customOptions = $scope.analyticsConfig.customDatepickerOptions;
  vm.colWidths = [10, 20, 12.5, 12.5, 12.5, 12.5, 7, 7, 6];

  $scope.translatePrefix = 'ANALYSIS.TRANSACTIONS.';

  function getAvailableProductOptions(detailData) {
    function hasProduct(productId, products) {
      for (var i = 0; i < products.length; i++) {
        if (products[i].id === productId) {
          return true;
        }
      }
      return false;
    }

    var availableProducts = [];
    detailData.forEach(function(data) {
      if (data.product && !hasProduct(data.product, availableProducts)) {
        availableProducts.push({
          label: data.product === 'none' ? $scope.translate('NO-PRODUCT') : data.product,
          id: data.product
        });
      }
    });

    availableProducts.sort(function(a, b) {
      if (a.id === 'none') {
        return -1;
      } else if (b.id === 'none') {
        return 1;
      }
      return a.label.localeCompare(b.label);
    });

    return availableProducts;
  }

  function getAvailableFareTypeOptions(detailData, fareTypeOptions) {
    var availableFareTypes = [];
    detailData.forEach(function(data) {
      if (availableFareTypes.indexOf(data.fare_type) === -1) {
        availableFareTypes.push(data.fare_type);
      }
    });

    availableFareTypes = fareTypeOptions.filter(function(option) {
      return !option.value || availableFareTypes.indexOf(option.value) !== -1;
    });

    return availableFareTypes;
  }

  function getAvailableLocationOptions() {
    return vm.analyticsModel.locations;
  }

  function productIsAvailable(productId) {
    return vm.options.product.findIndex(function(product) {
      return productId===product.id;
    })!==-1;
  }

  function fareTypeIsAvailable(fareType) {
    return vm.options.fareType.findIndex(function(type) {
      return type.value===fareType;
    })!==-1;
  }

  function updateSelectedFilters() {
    if(vm.form.fareType && !fareTypeIsAvailable(vm.form.fareType)) {
      vm.form.fareType = '';
    }
    if(vm.form.scheme) {
      var foundScheme = vm.options.schemes.findIndex(function(scheme) {
        return scheme.id === vm.form.scheme;
      })!==-1;
      if(!foundScheme) {
        vm.form.scheme = '';
      }
    }
    if(vm.form.product) {
      var selectedProducts = [];
      for(var i = vm.form.product.length - 1; i >= 0; i--) {
        var productId = vm.form.product[i];
        if(productIsAvailable(productId)) {
          selectedProducts.push(productId);
        }
      }
      if(selectedProducts.length!==vm.form.product) {
        vm.form.product = selectedProducts;
      }
    }
    if(vm.form.location && !vm.options.locations.indexOf(vm.form.location)) {
      vm.form.location = 'All Locations';
    }
  }

  vm.goToPage = function(page) {
    vm.currentPageData = vm.tableData.slice((page-1)*100, page*100);
    vm.paginationData.currentPage = page;
  };

  vm.getColspan = function() {
    var colspan = 7;
    if (vm.isAtParentLevel()) {
      colspan++;
    }
    if (vm.analyticsModel.hasAdjustments) {
      colspan++;
    }
    return colspan;
  };

  vm.getTransactionsData = function(currencyCode) {
    $scope.analyticsConfig.selectedCurrencyCode = currencyCode || $scope.getAnalyticsCurrencyCode();

    vm.loading = true;
    vm.calcPreviousPeriodDates();
    vm.setSearchValues();

    var selectedLocations = vm.form.locations ? vm.form.locations.split(',') : '';

    TransactionAnalysis.getTransactionData(
      $scope.getAnalyticsStartDateFormatted(),
      $scope.getAnalyticsEndDateFormatted(),
      $scope.getAnalyticsCurrencyCode(),
      selectedLocations).then(function () {
      if(vm.analyticsModel.hasAdjustments) {
        vm.selectedPrice = vm.options.price[0];
      }

      createTableData();
      initFilters();

      vm.formSubmit();
    }).finally(function () {
      vm.loading = false;
    });
  };

  function createTableData() {
    vm.tableData = JSON.parse(JSON.stringify(vm.analyticsModel.detailData));

    mergeTableRowsIgnoringLocation();

    vm.currentPageData = vm.tableData.slice(0, 100);
    vm.paginationData.pagination.total = vm.tableData.length;
  }

  /**
   * We need to know every location in the data, but because the data table is
   * not showing a location column, we end up with lots of "duplicate" rows
   * (everything except the location is the same), so we need to merge these
   * rows so that the table looks correct, without affecting the original data
   */
  function mergeTableRowsIgnoringLocation() {
    for(var i = vm.tableData.length - 1; i > 0; i--) {
      var currentRow = vm.tableData[i];
      var previousRow = vm.tableData[i-1];
      if(rowsShouldBeMerged(currentRow, previousRow)) {
        mergeTableRows(currentRow, previousRow, i);
      }
    }
  }

  function mergeTableRows(row1, row2, index) {
    row2.nominal_amount += row1.nominal_amount;
    row2.adjusted_amount += row1.adjusted_amount;
    row2.count += row1.count;
    vm.tableData.splice(index, 1);
  }

  function rowsShouldBeMerged(row1, row2) {
    return isDataRow(row1) &&
           isDataRow(row2) &&
           rowsAreSameIgnoringLocation(row1, row2);
  }

  function isDataRow(row) {
    return row.fare_type &&
           row.product &&
           row.trip_completion &&
           row.location_name &&
           row.scheme;
  }

  function rowsAreSameIgnoringLocation(row1, row2) {
    return row1.fare_type===row2.fare_type &&
           row1.product===row2.product &&
           row1.trip_completion===row2.trip_completion &&
           row1.scheme===row2.scheme &&
           row1.participant_id===row2.participant_id;
  }

  function initFilters() {
    // build the product and fareType options
    vm.options.product = getAvailableProductOptions(vm.analyticsModel.detailData);
    vm.options.fareType = getAvailableFareTypeOptions(vm.analyticsModel.detailData, initOptions.fareType);
    vm.options.schemes = OrganiseData.getAvailableSchemeOptions(vm.analyticsModel.detailData);
    vm.options.locations = getAvailableLocationOptions();

    updateSelectedFilters();
  }

  function initChart(screenSettings) {
    vm.chartOptions = ChartRegistry.get('transactions_by_product')
      .getChartOptions(vm.analyticsModel, screenSettings);
  }

  vm.locationFilterChanged = function() {
    vm.getTransactionsData();
  };

  vm.formSubmit = function() {
    vm.loading = true;

    // get the selected products
    var products = vm.options.product;
    if (!!vm.form.product && vm.form.product.length > 0) {
      products = angular.copy(vm.options.product).filter(function(product) {
        return vm.form.product.indexOf(product.id) !== -1;
      });
    }
    // get selected fare
    var fares = vm.options.fareType.filter(function(fare, index) {
      return index !== 0 && fare.value === vm.form.fareType;
    });
    // get selected price
    var prices = !!vm.selectedPrice.value ? [vm.selectedPrice] : vm.options.price;
    //get selected scheme
    var scheme = vm.options.schemes.filter(function(scheme, index) {
      return index !== 0 && scheme.id === vm.form.scheme;
    });
    var completion = vm.form.completion==='All' ? undefined : vm.form.completion;
    var locations = vm.form.locations ? vm.form.locations.split(',') : [];

    // build screenSettings for the graph
    var screenSettings = {
      currencySymbol: vm.analyticsModel.currencySymbol,
      selected: {
        products: products,
        prices: prices,
        fares: fares,
        scheme: scheme,
        completion: completion,
        locations: locations,
        startDate: $scope.getAnalyticsStartDate(),
        endDate: $scope.getAnalyticsEndDate()
      }
    };

    initChart(screenSettings);

    vm.loading = false;
    vm.formatCsvFilename();
  };

  vm.updatePrice = function(price) {
    vm.selectedPrice = price;
    vm.formSubmit();
  };

  vm.getProductLabel = function(productId) {
    var found = vm.options.product.filter(function(product) {
      return product.id === productId;
    });

    if (found.length > 0) {
      return found[0].label;
    }
    return productId;
  };

  vm.getFareLabel = function(fareId) {
    if (!fareId) {
      return '';
    }

    var match = vm.options.fareType.filter(function(fare) {
      return fare.value === fareId;
    });

    if (match.length > 0) {
      return match[0].name;
    }
    return fareId;
  };

  vm.downloadCsv = function() {
    WebAnalytics.trackCSVDownload(vm.csvFilename);

    return vm.analyticsModel.detailData.map(function(item) {
      var csvItem ={};
       csvItem[$scope.translate('DATE')] = item.date;
      if (vm.isAtParentLevel()) {
        csvItem[$scope.translate('CHILD-PARTICIPANT')] = vm.toUpperOr(item.participant_name, $scope.translate('ALL'));
      }
      csvItem[$scope.translate('FARE-TYPE')] = vm.toUpperOr(item.fare_type ? $scope.translate(item.fare_type.replace('_', '-')) : '', $scope.translate('ALL'));
      csvItem[$scope.translate('PRODUCT')] = vm.toUpperOr(item.product === 'none' ? $scope.translate('NO-PRODUCT') : item.product, $scope.translate('ALL'));
      csvItem[$scope.translate('COMPLETION')] = item.trip_completion ? $scope.translate(item.trip_completion.toUpperCase()) : $scope.translate('ALL');
      csvItem[$scope.translate('LOCATION')] = item.location_name ? item.location_name : $scope.translate('ALL');
      csvItem[$scope.translate('SCHEME')] = vm.toUpperOr((item.scheme === 'UNKNOWN' ? $scope.translate('UNKNOWN') : item.scheme ), $scope.translate('ALL'));
      csvItem[$scope.translate('NOMINAL-AMOUNT')] = vm.analyticsModel.currencySymbol + item.nominal_amount;

      if (vm.analyticsModel.hasAdjustments) {
        csvItem[$scope.translate('CHARGED-AMOUNT')] = vm.analyticsModel.currencySymbol + item.adjusted_amount;
      }
      csvItem[$scope.translate('COUNT')] = item.count;
      return csvItem;
    });
  };

  vm.isDateSubtotalRow = function(row) {
    return isNoParticipant(row) && isNoFareType(row) && isNoProduct(row);
  };

  function isNoParticipant(row) {
    return !row.participant_name || row.participant_name.trim().length === 0;
  }

  function isNoFareType(row) {
    return !row.fare_type || row.fare_type.trim().length === 0;
  }

  function isNoProduct(row) {
    return !row.product || row.product.trim().length === 0;
  }

  vm.isOtherSubtotalRow = function(row) {
    return !vm.isDateSubtotalRow(row) &&
      !row.fare_type &&
      !row.product;
  };

  vm.isSchemeSubtotalRow = function(row) {
    return !row.fare_type && !row.product && row.scheme;
  };

  vm.isChildParticipantSubtotalRow = function(row) {
    return row.participant_name && !row.fare_type && !row.product && !row.scheme;
  };

  this.isFirstForDateOrParticipant = function(item, index) {
    if (index > 0) {
      return vm.currentPageData[index - 1].date !== item.date ||
        vm.currentPageData[index - 1].participant_id !== item.participant_id;
    }

    return true;
  };

  this.isFirstForDate = function(date, index) {
    if (index > 0) {
      return vm.currentPageData[index - 1].date !== date;
    }

    return true;
  };

  vm.hasNoGraphData = function() {
    return vm.hasNoData() ||
           !vm.chartOptions.series || vm.chartOptions.series.length<1 ||
           !vm.chartOptions.series[0].data || vm.chartOptions.series[0].data.length===0;
  };

  if (analyticsConfig.currencyCodes.length > 0) {
    vm.initData(analyticsConfig, vm.datePickerOptions);
    vm.getTransactionsData();
  }

  vm.pageLoaded();
}

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('ParentUsersNewUserCtrl', [
    '$scope',
    'Auth',
    '$timeout',
    'User',
    'Permission',
    'Participant',
    '$location',
    '$window',
    'toastr',
    function($scope, Auth, $timeout, User, Permission, Participant, $location, $window,
             toastr) {
      $scope.userModel = User.model;
      $scope.permissionModel = Permission.model;
      $scope.participantModel = Participant.model;
      $scope.validPassword = User.validatePasswordFormat();
      $scope.isParent = Auth.isParent();
      $scope.newUserNotificationMessage = {};
      $scope.errorMessage = '';
      $scope.permissions = {};

      $scope.translatePrefix = 'USERS.NEW-USER.';

      var orderParticipantAccounts = function() {
        Participant.fetchCurrentParticipant().then(function() {
          $scope.participantModel.currentParticipant.child_participants.sort(function(a, b) {
            return a.id.localeCompare(b.id);
          });
          angular.forEach($scope.participantModel.currentParticipant.child_participants,
            function(participant) {
              $scope.userModel.participantAccounts[participant.id] = {
                'name': participant.id,
                'role': 'user',
              };
            });
        }).finally(function() {
          $scope.pageLoaded();
        });
      };

      orderParticipantAccounts();
      Permission.fetchPermissions();

      $scope.save = function(user, form) {
        form.userParent.$valid = true;
        $scope.errorMessage = '';

        var valid = true;

        $scope.userModel.newUser = angular.copy(user);
        angular.forEach($scope.userModel.participantAccounts, function(participant, key) {
          if (participant.selected) {
            var data = {
              'name': key,
              'role': participant.role,
            };
            if (participant.permissions) {
              angular.extend(data, {
                'permissions': User.userPermissions(participant.permissions),
              });
            }
            $scope.userModel.newUser.app_meta_data.participants.push(data);
          }
        });

        angular.forEach(form, function(element, name) {
          if (!name.startsWith('$') && !form[name].$valid) {
            valid = false;
          }
        });

        if (($scope.userModel.newUser.app_meta_data.participants.length === 0 &&
          !$scope.userModel.newUser.assignToParent) && !$scope.assignToAllChildren) {
          valid = false;
          form.userParent.$valid = false;
          $scope.newUserNotificationMessage.errorMessage(
            $scope.translate('USER-ERROR-MSG'));
          $window.scrollTo(0, 0);
        }

        if (form.userPassword.$viewValue !== form.userRepeatPassword.$viewValue) {
          valid = false;
          form.userRepeatPassword.$valid = false;
        }

        if (valid) {
          $scope.pageLoadAgain();
          angular.extend($scope.userModel.newUser, {
            'participantId': Auth.getParticipantName(),
          });
          if ($scope.userModel.newUser.assignToParent || $scope.assignToAllChildren) {
            var permissions = [];
            if ($scope.assignToAllChildren) {
              angular.forEach($scope.permissions, function(permission) {
                permissions.push(permission);
              });
            }

            $scope.userModel.newUser.app_meta_data.participants.push({
              name: Auth.getParticipantName(),
              role: $scope.userModel.newUser.assignToParent ? 'admin' : 'user',
              parent: true,
              permissions: permissions,
            });
          }
          User.createAuser($scope.userModel.newUser).$promise.then(function(data) {
            $location.path('/parent/users/' + data.id);
            toastr.success($scope.translate('CREATED-SUCCESSFULLY'));
          }, function(error) {
            if (error.status === 409) {
              toastr.error(
                $scope.translate('UNABLE-TO-ADD'));

              $scope.newUserNotificationMessage.errorMessage(
                $scope.translate('UNABLE-TO-ADD'));
              $window.scrollTo(0, 0);
            } else {
              toastr.error($scope.translate('CREATE-ERROR'));

            }
            $scope.pageLoaded();
          });
        }
      };

      $scope.reset = function(userForm) {
        if (userForm) {
          userForm.$setPristine();
          userForm.$setUntouched();
        }
        $scope.userModel.newUser = {};
        $scope.user = {
          'app_meta_data': {
            'participants': [],
          },
          'assignToParent': false,
        };
      };
      $scope.reset();
    },
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('ParentUserSummaryCtrl', [
    '$scope', 'User', 'Permission', 'Participant', 'Auth', '$filter', '$stateParams', 'toastr',

    function($scope, User, Permission, Participant, Auth, $filter, $stateParams, toastr) {
      $scope.userModel = User.model;
      $scope.participantModel = Participant.model;
      $scope.permissionModel = Permission.model;
      $scope.notificationMessage = null;
      $scope.isParent = Auth.isParent();
      $scope.assignedToParent = false;

      $scope.translatePrefix = 'USERS.USER-SUMMARY.';

      var orderParticipantAccounts = function() {
        $scope.userModel.participantAccounts = {};
        Participant.fetchCurrentParticipant().then(function() {
          var unorderedParticipantAccounts = {};
          angular.forEach($scope.participantModel.currentParticipant.child_participants,
            function(participant) {
              unorderedParticipantAccounts[participant.id] = {
                'name': participant.id,
                'role': 'user',
              };
            });
          Object.keys(unorderedParticipantAccounts).sort().forEach(function(key) {
            $scope.userModel.participantAccounts[key] = unorderedParticipantAccounts[key];
          });
        });
      };

      if ($scope.isParent) {
        orderParticipantAccounts();
      }

      $scope.save = function() {
        var data = {
          'app_meta_data': $scope.userModel.user.app_meta_data,
          'userId': $stateParams.userId,
        };

        angular.forEach(data.app_meta_data.participants, function(metadata, key) {
          if ($scope.userModel.participantAccounts[metadata.name] &&
            $scope.userModel.participantAccounts[metadata.name].selected) {

            var participant = angular.copy(
              $scope.userModel.participantAccounts[metadata.name]);
            var permissions = User.userPermissions(
              $scope.userModel.participantAccounts[metadata.name].permissions);

            $scope.userModel.user.app_meta_data.participants[key].role = participant.role;
            $scope.userModel.user.app_meta_data.participants[key].permissions = permissions;

            if (participant.role === 'admin' || permissions.length === 0) {
              delete $scope.userModel.user.app_meta_data.participants[key].permissions;
            }
          }
        });
        //access to parent participant changed
        if ($scope.userModel.wasAssignedToParent !== $scope.userModel.assignedToParent) {
          if (!$scope.userModel.assignedToParent) {
            var key = User.findParticipant(Auth.getParticipantName(),
              $scope.userModel.user.app_meta_data.participants);
            if (key !== null) {
              $scope.userModel.user.app_meta_data.participants.splice(key, 1);
            }
          } else {
            $scope.userModel.user.app_meta_data.participants.push({
              'name': Auth.getParticipantName(),
              'role': 'admin',
              'parent': true,
            });
          }
          $scope.userModel.wasAssignedToParent = $scope.userModel.assignedToParent;
        }

        if ($scope.userModel.user.app_meta_data.participants.length < 1) {
          toastr.warning(
            'The user needs to be assigned to at least one participant (parent or child).');
          return;
        }

        $scope.pageLoadAgain();

        User.updateUser(data).then(function() {
          toastr.success('The user is successfully updated.');

        }).catch(function() {
          toastr.error('There was an error. We could not update the user.');

        }).finally(function() {
          $scope.pageLoaded();
        });
      };
    },
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp')
  .controller('ParentUsersCtrl', [
    '$scope', 'User', '$location', 'Auth', 'Participant',
    function($scope, User, $location, Auth, Participant) {
      $scope.userModel = User.model;
      $scope.participantModel = Participant.model;
      $scope.profile = Auth.currentUser.profile;
      $scope.eligableParticipants = [];
      $scope.participantLoaded = false;
      $scope.pageLoaded = false;

      Participant.fetchCurrentParticipant().catch(function() {
        $scope.error = true;
      }).then(function() {
        $scope.participantModel.currentParticipant.child_participants.sort(function(a, b) {
          return a.id.localeCompare(b.id);
        });
        angular.forEach($scope.participantModel.currentParticipant.child_participants,
          function(child) {
            $scope.eligableParticipants.push(child.id);
          });
        $scope.userModel.group = $location.search().participant || null;
        $scope.participantLoaded = true;
      });

    },
  ]);

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', 'Utils',
    function(ChartRegistry, OrganiseData, Utils) {
      /**
       * AverageRevenueChart
       *
       * @constructor
       */
      function AverageRevenue() {
        var getStartDate = function(dataTemporary) {
          if (!dataTemporary || dataTemporary.length === 0) {
            return new Date();
          }
          return moment(dataTemporary[0][0], 'YYYY-MM-DD').toDate() || new Date();
        };
        var getDataTemporary = function(model, seriesOption, filters) {
          var dataTemporary = OrganiseData.backupData(model.csvData);

          // apply filter to data
          angular.forEach(filters, function(e, key) {
            e = e || null;
            if (e && e.length > 0) {
              dataTemporary = OrganiseData.filterData(dataTemporary, key, e);
            }
          });

          // this groups and sorts data by submit_date, and sums all the values for a given submit_date
          dataTemporary = OrganiseData.getDataTable(dataTemporary, OrganiseData.sortData,
            [seriesOption]);
          return dataTemporary;
        };
        var getSeries = function(seriesOption, dataTemporary) {
          // get the dataTemporary

          var startDate = getStartDate(dataTemporary);
          return [
            {
              name: seriesOption.label,
              data: dataTemporary.map(function(s) {
                return s[1];
              }),
              lineWidth: 6,
              marker: {
                radius: 0,
              },
              pointStart: Date.UTC(startDate.getFullYear(), startDate.getMonth(),
                startDate.getDate()),
              pointInterval: 24 * 3600 * 1000,
            }];
        };

        this.getId = function() {
          return 'average_revenue';
        };
        this.getChartOptions = function(model, screenSettings) {
          var currencySymbol = '£';
          var chartOptions = {
            title: {
              text: 'Average Revenue Per Customer (£)',
            },
            chart: {
              type: 'column',
            },
            xAxis: {
              type: 'datetime',
              tickWidth: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
              labels: {
                formatter: function() {
                  return Utils.formatDate(this.value);
                },
              },
            },
            yAxis: [
              {
                labels: {
                  formatter: function() {
                    return '£' + (this.value).toLocaleString('en');
                  },
                },
                title: {
                  text: 'Average Revenue (£)',
                },
              }],
            tooltip: {
              shared: true,
              crosshairs: true,
              valuePrefix: currencySymbol,
            },
            credits: {
              enabled: false,
            },
            colors: ['#DBE8F9', '#F7A54B', '#466289', '#A0AEC1'],
            plotOptions: {
              series: {
                cursor: 'pointer',
                stacking: 'normal',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };

          var seriesOption = {
            'label': 'Average Revenue Per Customer',
            'id': 'average_value_per_customer',
          };
          var dataTemporary = getDataTemporary(model, seriesOption, screenSettings.filters);
          chartOptions.series = getSeries(seriesOption, dataTemporary);

          return chartOptions;
        };

      }

      ChartRegistry.register(new AverageRevenue());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', 'Utils', '$translate',
    function(ChartRegistry, OrganiseData, Utils, $translate) {
      /**
       * ReturningVsNewChart
       *
       * @constructor
       */
      function CappedVsUncappedChart() {

        // internal functions
        var getStartDate = function(dataTemporary) {
          if (!dataTemporary || dataTemporary.length === 0) {
            return new Date();
          }
          return moment(dataTemporary[0].week_commencing, 'YYYY-MM-DD').toDate() || new Date();
        };

        this.getId = function() {
          return 'capped_vs_uncapped';
        };

        this.getChartOptions = function(model, screenSettings) {
          var yAxisLabel = $translate.instant('ANALYSIS.CUSTOMERS.NUMBER-OF-CUSTOMERS');
          if(screenSettings.chart_type==='total_nominal_amount') {
            yAxisLabel = $translate.instant('ANALYSIS.CUSTOMERS.TOTAL-NOMINAL-AMOUNT') + ' (' + screenSettings.currencySymbol + ')';
          } else if(screenSettings.chart_type==='total_charge_amount') {
            yAxisLabel = $translate.instant('ANALYSIS.CUSTOMERS.TOTAL-CHARGE-AMOUNT') + ' (' + screenSettings.currencySymbol + ')';
          }

          var chartOptions = {
            title: {
              text: $translate.instant('ANALYSIS.CUSTOMERS.CAPPED-VS-UNCAPPED-CUSTOMERS'),
            },
            chart: {
              type: 'areaspline',
            },
            xAxis: {
              tickWidth: 0,
              gridLineWidth: 1,
              type: 'datetime',
              dateTimeLabelFormats: {
                day: '%d/%m/%Y'
              },
              labels: {
                formatter: function() {
                  return moment(this.value).format('DD/MM/YYYY');
                }
              }
            },
            yAxis: [
              {
                labels: {
                  formatter: function() {
                    return (this.value).toLocaleString('en');
                  },
                },
                title: {
                  text: yAxisLabel
                },
              }],
            tooltip: {
              shared: true,
              crosshairs: true,
              formatter: function() {
                var html = '<b>' + moment(this.x).format('DD/MM/YYYY') + '</b><br />';
                angular.forEach(this.points, function(point) {
                  html += '<span style="color:' + point.color + '">●</span> ' + point.series.name +
                    ': <b>' + (screenSettings.chart_type==='customer_count' ? '' : screenSettings.currencySymbol) + Number(point.y.toFixed(2)).toLocaleString() + '</b><br/>';
                });
                return html;
              },
            },
            credits: {
              enabled: false,
            },
            colors: [
              '#1DBD72',
              '#aa43ce',
              '#ffc24f',
              '#5170ea',
              '#ea5151',
              '#51eac8',
              '#ea9d51',
              '#ea51b7',
              '#c1ea51'
            ],
            plotOptions: {
              series: {
                cursor: 'pointer',
                marker: {
                  lineWidth: 1,
                },
                pointStart: screenSettings.startDate.valueOf(),
                pointInterval: 'day',
              },
              areaspline: {
                fillOpacity: 0.2
              }
            },
            series: []
          };

          for(var i = 0; i < 7; i++) {
            if(needSeries(screenSettings, i)) {
              addSeries(model, chartOptions, screenSettings, i);
            }
          }

          return chartOptions;
        };

        function needSeries(screenSettings, cappingFrequency) {
          return !screenSettings.filters.capping_frequencies ||
                 !screenSettings.filters.capping_frequencies.length ||
                 screenSettings.filters.capping_frequencies.indexOf(cappingFrequency + '')!==-1;
        }

        function addSeries(model, chartOptions, screenSettings, cappingFrequency) {
          var startDate = getStartDate(model.csvData);
          var seriesData = getSeriesData(model, cappingFrequency, screenSettings);

          if(seriesData) {
            chartOptions.series.push({
              name: cappingFrequency === 0 ? 'Never capped' : cappingFrequency,
              type: 'areaspline',
              data: seriesData,
              marker: {
                radius: 0,
              },
              pointStart: Date.UTC(startDate.getFullYear(),
                startDate.getMonth(),
                startDate.getDate()),
              pointInterval: 7 * 24 * 3600 * 1000,
              colorIndex: chartOptions.series.length,
            });
          }
        }

        function getSeriesData(model, cappingFrequency, screenSettings) {
          var data = JSON.parse(JSON.stringify(model.csvData));
          data = data.filter(function(row) {
            return row.capping_frequency===cappingFrequency;
          });

          var seriesData = [];
          var date = screenSettings.startDate.clone();
          var hasData = false;
          while(date.isBefore(screenSettings.endDate)) {
            var result = data.find(function(row) {
              return moment(row.week_commencing, 'YYYY-MM-DD').isSame(date, 'day');
            });

            hasData = hasData || !!result;

            seriesData.push(result ? result[screenSettings.chart_type] : 0);
            date.add(1, 'week');
          }

          return hasData ? seriesData : null;
        }
      }

      ChartRegistry.register(new CappedVsUncappedChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData',
    function(ChartRegistry, OrganiseData) {
      /**
       * RetentionChart
       *
       * @param OrganiseData
       * @constructor
       */
      function RetentionChart() {

        // constant for the chart
        var categoryId = 'week';

        // private functions
        var getCategories = function(model) {
          return model.csvData.map(function(row) {
            return row[categoryId];
          });
        };
        var getSeriesLabelIds = function(filters) {
          var filteredSeriesLabel = [];
          angular.forEach(filters, function(filterValues) {
            filterValues = filterValues || null;
            if (filterValues && filterValues.length > 0) {
              filteredSeriesLabel = filteredSeriesLabel.concat(filterValues);
            }
          });
          return filteredSeriesLabel;
        };
        var getSeries = function(model, filters) {

          var dataTemporary = OrganiseData.backupData(model.csvData);
          // translate table into map
          var seriesAsMap = OrganiseData.getDataTableToMap(dataTemporary, [categoryId]);

          // work out which series should be included for graph
          var filteredSeriesLabelIds = getSeriesLabelIds(filters);

          // if no filter has been applied, display all serieses
          if (filteredSeriesLabelIds.length === 0) {
            filteredSeriesLabelIds = seriesAsMap.labels;
          }

          // return only the selected graph serieses
          return filteredSeriesLabelIds.map(function(labelId) {
            var label = '';
            angular.forEach(model.filter_labels, function(each) {
              if (each.id === labelId) {
                label = each.label;
              }
            });
            return {
              name: label,
              data: seriesAsMap.data[labelId],
              lineWidth: 6,
              marker: {
                radius: 0,
              },
            };
          });
        };

        // public functions
        this.getId = function() {
          return 'cohort_retention';
        };
        this.getChartOptions = function(model, screenSettings) {

          var chartOptions = {
            title: {
              text: 'Cohort Retention %',
            },
            xAxis: {
              tickWidth: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
            },
            yAxis: {
              labels: {},
              title: {
                text: 'Retention (%)',
              },
            },
            tooltip: {
              shared: true,
              crosshairs: true,
              valueSuffix: '%',
            },
            credits: {
              enabled: false,
            },
            colors: ['#DBE8F9', '#F7A54B', '#466289', '#A0AEC1'],
          };

          //create multiple series element for displaying
          chartOptions.series = getSeries(model, screenSettings.filters);
          // index 'week is the categories for xAxis fare_types
          chartOptions.xAxis.categories = getCategories(model);
          return chartOptions;
        };

      }

      ChartRegistry.register(new RetentionChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', '$translate',
    function(ChartRegistry, OrganiseData, $translate) {
      function CorrectionsChart() {
        var getSeries = function(data, screenSettings) {
          //remove "summary" rows, and filter by initiator if required
          data = OrganiseData.filterOutData(data, ['participant_name', 'initiator', 'date'],
            null);
          if (screenSettings.selected.initiator) {
            data = OrganiseData.filterData(data, 'initiator',
              screenSettings.selected.initiator);
          }

          var dataTemporary = OrganiseData.getDataTable(data, OrganiseData.sortData,
            screenSettings.selected, undefined, undefined, 'date');
          var series = [];
          screenSettings.selected.filterOptions.forEach(function(c, index) {
            var type = c.id === 'corrections_as_percentage_total' ? 'spline' : 'column';
            var axis = type === 'spline' ? 1 : 0;

            series.push({
              id: c.id,
              name: $translate.instant('ANALYSIS.CORRECTIONS.'+ c.label),
              type: type,
              data: dataTemporary.map(function(s) {
                return s[index + 1];
              }),
              lineWidth: 6,
              yAxis: axis,
              marker: {
                radius: 0,
              },
            });
          });
          return series;
        };

        this.getId = function() {
          return 'corrections';
        };

        this.getChartOptions = function(model, screenSettings) {
          var series = getSeries(model.detailData, screenSettings);
          var dateCategories = Object.keys(
            OrganiseData.fillEmptyDateKeys([], screenSettings.selected.startDate,
              screenSettings.selected.endDate, 'DD/MM/YYYY'));

          return {
            title: {
              text: $translate.instant('ANALYSIS.CORRECTIONS.TOTAL-CORRECTIONS-BY-STATUS'),
            },
            chart: {
              type: 'column',
            },
            xAxis: [
              {
                labels: {},
                tickWidth: 0,
                gridLineWidth: 0,
                lineColor: 'transparent',
                categories: dateCategories,
              }],
            yAxis: [
              {
                labels: {
                  format: '{value}',
                },
                title: {
                  text: $translate.instant('ANALYSIS.CORRECTIONS.CORRECTION-AMOUNT'),
                },
                stackLabels: { //show labels at the top of each column (not a lot of room when looking at lots of data)
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'gray',
                    textOutline: '2px #FFFFFF',
                  },
                  formatter: function() {
                    if (Math.abs(this.total) < 0.001) {
                      return '';
                    }
                    return screenSettings.currencySymbol + (this.total > 100 ?
                      (this.total / 1000).toFixed(1) + 'k' :
                      Math.round(this.total));
                  },
                },
              },
              {
                labels: {
                  format: '{value}%',
                },
                title: {
                  text: $translate.instant('ANALYSIS.CORRECTIONS.CORRECTION-PERCENTAGE'),
                },
                opposite: true,
              },
            ],
            series: series,
            tooltip: {
              shared: true,
              crosshairs: false,
              formatter: function() {
                var total = 0;
                var html = '<b>' + this.x + '</b><br />';
                angular.forEach(this.points, function(point) {
                  var value = model.currencySymbol +
                    Number(Math.round(point.y)).toLocaleString();
                  if (point.series.userOptions.id === 'corrections_as_percentage_total') {
                    value = Number(point.y).toFixed(2) + '%';
                  }
                  html += '<span style="color:' + point.color + '">●</span> ' +
                    point.series.name + ': <b>' + value + '</b><br/>';
                  total += point.y;
                });
                if (total === 0) {
                  html = '<b>' + this.x + '</b><br />'+ $translate.instant('ANALYSIS.CORRECTIONS.NO-DATA');
                }
                return html;
              },
            },
            credits: {
              enabled: false,
            },
            colors: ['#1DBD72', '#aa43ce', '#ffc24f', '#A0AEC188'],
            plotOptions: {
              series: {
                cursor: 'pointer',
                stacking: 'normal',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };
        };
      }

      ChartRegistry.register(new CorrectionsChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', 'Utils',
    function(ChartRegistry, OrganiseData, Utils) {

      /**
       * LifetimeVAlueChart
       *
       * @param OrganiseData
       * @param model
       * @param selectedChartOption
       * @param filters
       * @constructor
       */
      function LifetimeValueChart() {
        var getStartDate = function(data) {
          if (!data || data.length === 0) {
            return new Date();
          }
          return moment(data[0][0], 'YYYY-MM-DD').toDate() || new Date();
        };
        var getDataTemporary = function(model, seriesOptions, filters) {
          var dataTemporary = OrganiseData.backupData(model.csvData);

          // apply filter to data
          angular.forEach(filters, function(filter, key) {
            filter = filter || null;
            if (!!filter && filter.length > 0) {
              dataTemporary = OrganiseData.filterData(dataTemporary, key, filter);
            }
          });

          // this groups and sorts data by submit_date, and sums all the values for a given submit_date
          dataTemporary = OrganiseData.getDataTable(dataTemporary, OrganiseData.sortData,
            seriesOptions);
          return dataTemporary;
        };
        var getSeries = function(seriesOptions, dataTemporary) {

          return seriesOptions.map(function(c, index) {
            var type = dataTemporary.length > 1 ? c.type : 'column';
            var startDate = getStartDate(dataTemporary);
            return {
              name: c.label,
              type: type,
              data: dataTemporary.map(function(s) {
                return s[index + 1];
              }),
              lineWidth: 6,
              marker: {
                radius: 0,
              },
              pointStart: Date.UTC(startDate.getFullYear(), startDate.getMonth(),
                startDate.getDate()),
              pointInterval: 24 * 3600 * 1000,
            };
          });
        };

        this.getId = function() {
          return 'lifetime_value';
        };
        this.getChartOptions = function(model, screenSettings) {
          var currencySymbol = '£';
          var subTitle = '<span>* Lifetime value is an educated guess at how much you can expect to make from the average customer before they churn. ' +
            'Knowing your LTV will help you decide how much you can spend to acquire and support each new customer - the higher the better. ' +
            'How it is calculated LTV = Average monthly recurring revenue per customer / (User Churn Rate =(customers that have become inactive in the last 30 days/Active customers 30 days ago) x100))</span>';

          var chartOptions = {
            title: {
              text: 'Lifetime Value (£)',
            },
            subtitle: {
              text: subTitle,
              useHTML: true,
              style: {'color': '#666666', 'font-size': '11px'},
            },
            xAxis: {
              labels: {
                formatter: function() {
                  return Utils.formatDate(this.value);
                },
              },
              type: 'datetime',
              tickWidth: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
            },
            yAxis: [
              {
                labels: {
                  formatter: function() {
                    return '£' + (this.value.toFixed(2)).toLocaleString('en');
                  },
                },
                title: {
                  text: ' ',
                },
              }],
            tooltip: {
              shared: true,
              crosshairs: true,
              valuePrefix: currencySymbol,
            },
            credits: {
              enabled: false,
            },
            colors: ['#DBE8F9', '#F7A54B', '#466289', '#A0AEC1'],
            plotOptions: {
              series: {
                cursor: 'pointer',
                stacking: 'normal',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };
          var seriesOptions = [
            {
              'label': 'Lifetime Value',
              'id': 'ltv',
              'type': 'area',
            }];

          var dataTemporary = getDataTemporary(model, seriesOptions, screenSettings.filters);
          chartOptions.series = getSeries(seriesOptions, dataTemporary);

          return chartOptions;
        };
      }

      ChartRegistry.register(new LifetimeValueChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', 'Utils',
    function(ChartRegistry, OrganiseData, Utils) {
      /**
       * ReactivatedChart
       *
       * @constructor
       */
      function ReactivatedChart() {

        var getSeriesLabelIds = function(filters) {
          var seriesLabelIds = [];
          angular.forEach(filters, function(filterValues) {
            filterValues = filterValues || null;
            if (filterValues && filterValues.length > 0) {
              seriesLabelIds = seriesLabelIds.concat(filterValues);
            }
          });
          return seriesLabelIds;
        };
        var getLabel = function(fareConfig, id) {
          return fareConfig.filter(function(value) {
            return value.id === id;
          });
        };
        var getSeries = function(model, screenSettings) {

          var dataTemporary = OrganiseData.backupData(model.csvData);
          // transform table into map
          var seriesAsMap = {};
          dataTemporary.map(function(data) {
            if (!seriesAsMap[data.fare_type]) {
              seriesAsMap[data.fare_type] = [];
            }
            seriesAsMap[data.fare_type].push(data.count);
          });

          // work out which series should be included in the graph
          var filteredSeriesLabelIds = getSeriesLabelIds(screenSettings.filters);

          // if no filter has been applied, display all serieses
          if (filteredSeriesLabelIds.length === 0) {
            filteredSeriesLabelIds = model.fare_types;
          }

          return filteredSeriesLabelIds.map(function(labelId) {
            var startDate = moment(model.start_date, 'YYYY-MM-DD').toDate();
            var data = seriesAsMap[labelId];
            return {
              name: getLabel(screenSettings.config.fare_type, labelId)[0].label,
              type: data.length > 1 ? 'spline' : 'column',
              data: data,
              lineWidth: 6,
              marker: {
                radius: 0,
              },
              pointStart: Date.UTC(startDate.getFullYear(), startDate.getMonth(),
                startDate.getDate()),
              pointInterval: 24 * 3600 * 1000,
            };
          });
        };

        this.getId = function() {
          return 'reactivated_customers';
        };
        this.getChartOptions = function(model, screenSettings) {
          var chartOptions = {
            title: {
              text: 'Reactivated Customers',
            },
            chart: {
              type: 'spline',
            },
            xAxis: {
              labels: {
                formatter: function() {
                  return Utils.formatDate(this.value);
                },
              },
              type: 'datetime',
              tickWidth: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
            },
            yAxis: [
              {
                title: {
                  text: 'Reactivated Customers',
                },
              }],
            tooltip: {
              shared: true,
              crosshairs: true,
            },
            credits: {
              enabled: false,
            },
            colors: ['#DBE8F9', '#F7A54B', '#466289', '#A0AEC1'],
            plotOptions: {
              series: {
                cursor: 'pointer',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };

          chartOptions.series = getSeries(model, screenSettings);
          return chartOptions;
        };
      }

      ChartRegistry.register(new ReactivatedChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData',
    function(ChartRegistry, OrganiseData) {

      /**
       * ReactivatedHistorychart
       *
       * @param OrganiseData
       * @param model
       * @param selectedChartOption
       * @constructor
       */
      function ReactivatedHistoryChart() {
        this.getId = function() {
          return 'reactivated_history';
        };
        this.getChartOptions = function(model) {
          var chartOptions = {
            title: {
              text: 'Day of Reactivated Customers',
            },
            chart: {
              type: 'column',
            },
            xAxis: {
              tickWidth: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
              categories: [],
            },
            yAxis: [
              {
                title: {
                  text: '# of Reactivated Customers',
                },
              }],
            series: [
              {
                name: 'Reactivated Customers (over past 12 months)',
                type: 'column',
                data: [],
                lineWidth: 6,
                marker: {
                  radius: 0,
                },
              }],
            tooltip: {
              shared: true,
            },
            credits: {
              enabled: false,
            },
            colors: ['#F7A54B', '#A0AEC1'],
            plotOptions: {
              series: {
                cursor: 'pointer',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };

          // build the series for the chart
          var dataTemporary = OrganiseData.backupData(model.csvData);

          var series = [];
          var categories = [];
          dataTemporary.map(function(data) {
            categories.push(data.label);
            series.push(data.value);
          });
          chartOptions.series[0].data = series;
          chartOptions.xAxis.categories = categories;
          return chartOptions;
        };
      }

      ChartRegistry.register(new ReactivatedHistoryChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', 'Utils', '$translate',
    function(ChartRegistry, OrganiseData, Utils, $translate) {
      /**
       * ReturningVsNewChart
       *
       * @constructor
       */
      function NewVsReturningChart() {

        // internal functions
        var getStartDate = function(dataTemporary) {
          if (!dataTemporary || dataTemporary.length === 0) {
            return new Date();
          }
          return moment(dataTemporary[0][0], 'YYYY-MM-DD').toDate() || new Date();
        };
        var getDataTemporary = function(model, seriesOptions, filters) {
          var dataTemporary = OrganiseData.backupData(model.csvData);

          // apply filter to data
          angular.forEach(filters, function(e, key) {
            e = e || null;
            if (e && e.length > 0) {
              dataTemporary = OrganiseData.filterData(dataTemporary, key, e);
            }
          });

          // this groups and sorts data by submit_date, and sums all the values for a given submit_date
          dataTemporary = OrganiseData.getDataTableWeekly(dataTemporary, OrganiseData.sortData,
            seriesOptions, undefined, undefined, 'week_commencing');
          return dataTemporary;
        };
        var getSeries = function(seriesOptions, dataTemporary) {

          return seriesOptions.map(function(c, index) {
            var type = c.type;
            var axis = type === 'spline' ? 1 : 0;
            var startDate = getStartDate(dataTemporary);
            return {
              name: c.label,
              type: type,
              data: dataTemporary.map(function(s) {

                return s[index + 1];
              }),
              lineWidth: 6,
              yAxis: axis,
              marker: {
                radius: 0,
              },
              pointStart: Date.UTC(startDate.getFullYear(), startDate.getMonth(),
                startDate.getDate()),
              pointInterval: 7 * 24 * 3600 * 1000,
            };
          });
        };

        this.getId = function() {
          return 'new_vs_returning';
        };
        this.getChartOptions = function(model, screenSettings) {
          var chartOptions = {
            title: {
              text: $translate.instant('ANALYSIS.CUSTOMERS.EXISTING-VS-NEW-CUSTOMERS'),
            },
            chart: {
              type: 'column',
            },
            xAxis: {
              labels: {
                formatter: function() {
                  return Utils.formatDateToWeek(this.value);
                },
              },
              type: 'datetime',
              tickWidth: 0,
              gridLineWidth: 0,
              lineColor: 'transparent',
            },
            yAxis: [
              {
                labels: {
                  formatter: function() {
                    return (this.value).toLocaleString('en');
                  },
                },
                title: {
                  text: $translate.instant('ANALYSIS.CUSTOMERS.NUMBER-OF-CUSTOMERS'),
                },
              }],
            tooltip: {
              shared: true,
              crosshairs: true,
            },
            credits: {
              enabled: false,
            },
            colors: ['#DBE8F9', '#F7A54B', '#466289', '#A0AEC1'],
            plotOptions: {
              series: {
                cursor: 'pointer',
                stacking: 'normal',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };
          var seriesOptions = [
                             {
                               'label': $translate.instant('ANALYSIS.CUSTOMERS.NEW-CUSTOMERS'),
                               'id': 'new',
                               'type': 'column',
                             }, {
                               'label': $translate.instant('ANALYSIS.CUSTOMERS.RETAINED-CUSTOMERS'),
                               'id': 'retained',
                               'type': 'column',
                             }, {
                               'label': $translate.instant('ANALYSIS.CUSTOMERS.RETURNING-CUSTOMERS'),
                               'id': 'returning',
                               'type': 'column',
                             }
           ];

          var options = {
            filterOptions: seriesOptions,
            startDate: screenSettings.startDate,
            endDate: screenSettings.endDate,
            interval: 7,
          };

          // get dataTemporary
          var dataTemporary = getDataTemporary(model, options, screenSettings.filters);
          // get series for the chart
          chartOptions.series = getSeries(seriesOptions, dataTemporary);

          return chartOptions;
        };
      }

      ChartRegistry.register(new NewVsReturningChart());
    }]
  );

'use strict';

angular.module('littlepayPortalMerchantApp.theme.services')
  .run(['ChartRegistry', 'OrganiseData', '$translate',
    function(ChartRegistry, OrganiseData, $translate) {
      /**
       * TransactionsByProduct
       *
       * @constructor
       */
      function TransactionsByProduct() {
        // internal constant & function declarations
        var settings = {
          fareFieldId: 'fare_type',
          productFieldId: 'product',
          nominalAmtFieldId: 'nominal_amount',
          adjustedAmtFieldId: 'adjusted_amount',
          schemeFieldId: 'scheme',
          completionFieldId: 'trip_completion',
          locationFieldId: 'location_name',
          totalAsProduct: [{id: ''}],  // for now if id of the product is empty, it represents as total for the date
        };

        var isPriceSelected = function(filters, priceFieldId) {
          var selectedPriceIds = filters.selected.prices.map(function(price) {
            return price.value;
          });
          return selectedPriceIds.indexOf(priceFieldId) !== -1;
        };

        var getDataTemporary = function(analyticsModel, filters) {
          // get filtered data
          var dataTemporary = OrganiseData.backupData(analyticsModel.detailData);
          if (filters.selected.products.length > 0) {
            var selectedProducts = filters.selected.products.map(function(product) {
              return product.id;
            });
            dataTemporary = OrganiseData.filterData(dataTemporary, settings.productFieldId,
              selectedProducts);
          }
          if (filters.selected.fares.length > 0) {
            var selectedFares = filters.selected.fares.map(function(fare) {
              return fare.value;
            });
            dataTemporary = OrganiseData.filterData(dataTemporary, settings.fareFieldId,
              selectedFares);
          }
          if (filters.selected.scheme.length > 0) {
            dataTemporary = OrganiseData.filterData(dataTemporary, settings.schemeFieldId,
              filters.selected.scheme[0].id);
          }
          if(filters.selected.completion) {
            dataTemporary = OrganiseData.filterData(dataTemporary, settings.completionFieldId, filters.selected.completion);
          }
          if(filters.selected.locations.length) {
            dataTemporary = OrganiseData.filterData(dataTemporary, settings.locationFieldId, filters.selected.locations);
          }
          return dataTemporary;
        };

        var getNominalSeries = function(dataTemporary, selectedFilters) {
          var nominalDataTemporary = OrganiseData.getDataTable(dataTemporary,
            OrganiseData.groupByProducts, selectedFilters, settings.nominalAmtFieldId,
            settings.productFieldId, 'date');
          return selectedFilters.products.map(function(c, index) {
            return {
              id: c.id,
              name: c.label,
              data: nominalDataTemporary.map(function(s) {
                var value = s[index + 1];
                return !!value ? Number(value.toFixed(2)) : value;
              }),
              marker: {
                radius: 0,
              },
              stack: settings.nominalAmtFieldId,
              colorIndex: index,
            };
          });
        };

        var getAdjustedSeries = function(dataTemporary, selectedFilters, nominalAmtSelected) {
          var adjustedDataTemporary = OrganiseData.getDataTable(dataTemporary,
            OrganiseData.groupByProducts, selectedFilters, settings.adjustedAmtFieldId,
            settings.productFieldId, 'date');
          return selectedFilters.products.map(function(c, index) {
            return {
              name: c.label + (nominalAmtSelected ? ' ('+ $translate.instant('ANALYSIS.TRANSACTIONS.ADJUSTED') +')' : ''),
              data: adjustedDataTemporary.map(function(s) {
                var value = s[index + 1];
                return !!value ? Number(value.toFixed(2)) : value;
              }),
              marker: {
                radius: 0,
              },
              stack: settings.adjustedAmtFieldId,
              colorIndex: index + selectedFilters.products.length,
            };
          });
        };

        this.getId = function() {
          return 'transactions_by_product';
        };

        var buildColours = function(seriesCount) {
          var baseColours = [
            '#1DBD72',
            '#aa43ce',
            '#ffc24f',
            '#5170ea',
            '#ea5151',
            '#51eac8',
            '#ea9d51',
            '#ea51b7',
            '#c1ea51'];
          var nominalColours = [];
          var adjustedColours = [];
          for (var i = 0; i < seriesCount; i++) {
            nominalColours.push(baseColours[i]);
            adjustedColours.push(adjustColour(baseColours[i], -0.30));
          }
          var colours = [];
          for (i = 0; i < nominalColours.length; i++) {
            colours.push(nominalColours[i]);
          }
          for (i = 0; i < adjustedColours.length; i++) {
            colours.push(adjustedColours[i]);
          }
          return colours;
        };

        var adjustColour = function(hex, lum) {
          hex = String(hex).replace(/[^0-9a-f]/gi, '');
          if (hex.length < 6) {
            hex = hex.replace(/(.)/g, '$1$1');
          }
          lum = lum || 0;
          // Convert to decimal and change luminosity
          var rgb = '#';
          var c;
          for (var i = 0; i < 3; ++i) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ('00' + c).substr(c.length);
          }
          return rgb;
        };

        this.getChartOptions = function(model, screenSettings) {
          var currencySymbol = screenSettings.currencySymbol;
          var dataTemporary = getDataTemporary(model, screenSettings);
          var nominalAmtSelected = isPriceSelected(screenSettings, settings.nominalAmtFieldId);
          var adjustedAmtSelected = isPriceSelected(screenSettings,
            settings.adjustedAmtFieldId);

          // build nominal series, if price is selected or no price selected
          var nominalSeries;
          if (nominalAmtSelected) {
            // build series for nominal amount
            nominalSeries = getNominalSeries(dataTemporary, screenSettings.selected);
          }

          // build adjusted series, if price is selected or no price selected
          var adjustedSeries;
          if (adjustedAmtSelected) {
            // build series for adjusted amount
            adjustedSeries = getAdjustedSeries(dataTemporary, screenSettings.selected,
              nominalAmtSelected);
          }

          // work out how many dates are included for the graph
          var dateCategories = Object.keys(
            OrganiseData.fillEmptyDateKeys([], screenSettings.selected.startDate,
              screenSettings.selected.endDate, 'DD/MM/YYYY'));

          // both nominal and adjusted series is the same size. both
          // are derived from selectedProducts
          var series = nominalSeries || adjustedSeries || [];
          if (nominalAmtSelected && adjustedAmtSelected) {
            series = [];
            nominalSeries.forEach(function(val, index) {
              series.push(nominalSeries[index]);
              series.push(adjustedSeries[index]);
            });
          }

          return {
            title: {
              text: $translate.instant('ANALYSIS.TRANSACTIONS.TOTAL-TRANSACTION-AMOUNT-BY-PRODUCT'),
            },
            chart: {
              type: 'column',
            },
            xAxis: [
              {
                labels: {},
                categories: dateCategories,
                tickWidth: 0,
                gridLineWidth: 0,
                lineColor: 'transparent',
              },
            ],
            yAxis: {
              title: {
                text: $translate.instant('ANALYSIS.TRANSACTIONS.TOTAL-TRANSACTIONS') + '(' + currencySymbol + ')',
              },
              stackLabels: { //show labels at the top of each column (not a lot of room when looking at lots of data)
                enabled: true,
                style: {
                  fontWeight: 'bold',
                  color: 'gray',
                  textOutline: '2px #FFFFFF',
                },
                formatter: function() {
                  if (Math.abs(this.total) < 0.001) {
                    return '';
                  }
                  return currencySymbol + (this.total > 100 ?
                    (this.total / 1000).toFixed(1) + 'k' :
                    Math.round(this.total));
                },
              },
            },
            legend: {
              enabled: series.length > 1,
            },
            series: series,
            tooltip: {
              shared: true, //puts all values for each column in the same tooltip
              crosshairs: true,
              formatter: function() {
                var total = 0;
                var html = '<b>' + this.x + '</b><br />';
                angular.forEach(this.points, function(point) {
                  html += '<span style="color:' + point.color + '">●</span> ' +
                    point.series.name + ': <b>' + currencySymbol +
                    Number(Math.round(point.y)).toLocaleString() + '</b><br/>';
                  total += point.y;
                });
                if (total === 0) {
                  html = '<b>' + this.x + '</b><br />' + $translate.instant('ANALYSIS.TRANSACTIONS.NO-DATA');
                }
                return html;
              },
            },
            credits: {
              enabled: false,
            },
            colors: buildColours(
              nominalAmtSelected && adjustedAmtSelected ? series.length / 2 : series.length),
            plotOptions: {
              series: {
                cursor: 'pointer',
                stacking: 'normal',
                marker: {
                  lineWidth: 1,
                },
              },
            },
          };
        };
      }

      ChartRegistry.register(new TransactionsByProduct());
    }]
  );

/**
 * @author z.geddes
 * created on 01.03.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomerSummaryCardsCtrl', AdminCustomerSummaryCardsCtrl);
AdminCustomerSummaryCardsCtrl.$inject = ['Identifier', '$rootScope'];

/** @ngInject */
function AdminCustomerSummaryCardsCtrl(Identifier, $rootScope) {
  var crd = this;
  crd.collapseListHistory = collapseListHistory;
  crd.collapse = collapse;
  crd.listHistoryToggle = {};
  $rootScope.isReceipt = false;

  function collapseListHistory(key) {
    crd.listHistoryToggle[key] = !crd.listHistoryToggle[key];
    if (crd.listHistoryToggle[key]) {
      Identifier.fetchListHistory(Identifier.model.identifiers[key].id, key);
    }
  }

  function collapse($event, ag) {
    $event.preventDefault();
    ag.open = !ag.open;
  }
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomerSummaryInvoiceCtrl', AdminCustomerSummaryInvoiceCtrl);
AdminCustomerSummaryInvoiceCtrl.$inject = [
  '$scope',
  '$location',
  '$window'
];

/** @ngInject */
function AdminCustomerSummaryInvoiceCtrl($scope, $location, $window) {
  var rp = this;

  $scope.translatePrefix = 'CUSTOMERS.CUSTOMER-SUMMARY.INVOICE.';

  var previousPath = $location.path().replace('receipt','transactions');
  rp.printStatement = printStatement;
  rp.goBack = goBack;
  rp.backtourl = previousPath;

  function goBack() {
    $window.location.href = previousPath;
  }

  function printStatement() {
    window.print();
  }

}

/**
 * @author z.geddes
 * created on 01.03.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomerSummaryRefundsCtrl', AdminCustomerSummaryRefundsCtrl);
AdminCustomerSummaryRefundsCtrl.$inject = ['Refund', 'Form', '$rootScope'];

/** @ngInject */
function AdminCustomerSummaryRefundsCtrl(Refund, Form, $rootScope) {
  var rfd = this;
  rfd.refundModel = Refund.model;
  rfd.loading = Form.loading;
  $rootScope.isReceipt = false;

  Refund.getRefundHistory().finally(function() {
    rfd.loading.hasLoaded = true;
  }).catch(function() {
    rfd.loading.error = true;
  });
}

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomerSummaryAdjustmentsCtrl', AdminCustomerSummaryAdjustmentsCtrl);

AdminCustomerSummaryAdjustmentsCtrl.$inject = [
  '$scope',
  'Adjustments',
  '$filter',
];


/** @ngInject */
function AdminCustomerSummaryAdjustmentsCtrl($scope, Adjustments, $filter) {
  var adj = this;
  $scope.adjustmentModel = Adjustments.model;
  adj.getFareDecisionByMicropayments = window.__env.getFareDecisionByMicropayments;
  adj.setAdjustmentVariables = setAdjustmentVariables;
  adj.getIncentiveCappingText = getIncentiveCappingText;
  adj.setReturnFareDiscountedTrips = setReturnFareDiscountedTrips;

  function setAdjustmentVariables(micropayment, adjustment) {
    adj.micropayment = micropayment;
    adj.adjustment = adjustment;
    adj.productId = adjustment.product_id;
    adj.getFareDecisionByMicropayments ?
      populateFareDecisionFromMicropaymentObj() : populateFareDecisionFromApi();
  }

  function setReturnFareDiscountedTrips(micropayment) {
    adj.returnFareDiscountedTrips = getReturnFareDiscountedTrips(micropayment.fare_decision.product_rule_check_map);  
  }

  function populateFareDecisionFromMicropaymentObj() {
    adj.fareDecision = getFareDecisionByMicropayments();
  }
  function populateFareDecisionFromApi() {
    adj.fareDecision =  getFareDecisionByApi();
  }

  function getFareDecisionByMicropayments() {
    return _.get(adj.micropayment.fare_decision, ['product_rule_check_map', adj.productId]);
  }

  function getFareDecisionByApi() {
    var decision = $scope.adjustmentModel.decision;
    return _.get(decision, [adj.micropayment.id, adj.productId]);
  }

  $scope.$watch('adjustmentModel.decision',function (model) {
    if(!_.isEmpty(model)) {
      populateFareDecisionFromApi();
    }
  });

  $scope.$watch('adj.fareDecision', checkIsIncentivesCappingApplied);

  function checkIsIncentivesCappingApplied() {
    var incentiveCapping = getIncentiveCappingForMicropaymentAndProduct();
    adj.isIncentivesCappingApplied = incentiveCapping && incentiveCapping.passed;
  }

  function getIncentiveCappingForMicropaymentAndProduct() {
    return _.get(adj.fareDecision, ['results', 'incentivised_capping']);
  }

  function getIncentiveCappingText() {
    var incentiveCapping = getIncentiveCappingForMicropaymentAndProduct();
    var incentiveCappingText = '';
    if(incentiveCapping) {
      var incentiveCappingDetails = getIncentiveCappingDetails(incentiveCapping);

      var incentiveDayText = $scope.translate('INCENTIVE-DAY', incentiveCappingDetails);
      var incentiveAmountText = isIncentiveCappingTypeDaily() ?
        $scope.translate('INCENTIVE-DAILY-ADJUSTMENT-TEXT', incentiveCappingDetails)
        : $scope.translate('INCENTIVE-CUMULATIVE-LIMIT-TEXT', incentiveCappingDetails);

      incentiveCappingText = incentiveDayText + ' - ' + incentiveAmountText;
    }
   return incentiveCappingText;
  }

  function isIncentiveDiscountTypePercentage() {
    return _.get(getIncentiveCappingForMicropaymentAndProduct(), ['incentive_type']) === 'PERCENTAGE';
  }

  function isIncentiveCappingTypeDaily() {
    return _.get(getIncentiveCappingForMicropaymentAndProduct(), ['incentive_capping_type']) === 'DAILY_CAP';
  }

  function getIncentiveCappingDetails(incentiveCapping) {
    var discount;

    if (isIncentiveCappingTypeDaily()) {
      if (isIncentiveDiscountTypePercentage()) {
        discount = incentiveCapping.discount + '%';
      } else {
        discount = $filter('isoCurrency')(incentiveCapping.discount, adj.micropayment.currency);
      }
    }
    return  {
      day: incentiveCapping.day,
      discount: discount,
      newLimit:  $filter('isoCurrency')(incentiveCapping.new_limit, adj.micropayment.currency),
      limit:  $filter('isoCurrency')(incentiveCapping.original_limit, adj.micropayment.currency)
    };
  }

  function getReturnFareDiscountedTrips(productRuleCheckMap) {
    let returnFareDiscountedTrips = [];
    for (const rules of Object.values(productRuleCheckMap)) {
      if (rules.results.discount && rules.results.discount.trip_type && !rules.results.discount.passed) {
        returnFareDiscountedTrips.push(rules);
      }
    }
    return returnFareDiscountedTrips;
  }

}

/**
 * @author z.geddes
 * created on 01.03.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .controller('AdminCustomerSummaryTransactionsCtrl', AdminCustomerSummaryTransactionsCtrl);
AdminCustomerSummaryTransactionsCtrl.$inject = [
  '$scope',
  'Customer',
  'Aggregation',
  'Adjustments',
  '$location',
  'sweetAlert',
  '$timeout',
  'Refund',
  'transactionFactory',
  'TRANSACTION_FILTERS',
  'Form',
  '$rootScope',
];

/** @ngInject */
function AdminCustomerSummaryTransactionsCtrl($scope, Customer, Aggregation, Adjustments, $location, sweetAlert, $timeout, Refund, transactionFactory,
                                              TRANSACTION_FILTERS, Form, $rootScope) {
  var trs = this;
  trs.aggregationModel = Aggregation.model;
  trs.transactionFilters = TRANSACTION_FILTERS;
  trs.form = Form.queries;
  trs.collapse = collapse;
  trs.transactionSearchClick = transactionSearchClick;
  trs.customerAggregations = customerAggregations;
  trs.showAllTransactions = showAllTransactions;
  trs.showNotAppliedAdjustments = showNotAppliedAdjustments;
  $rootScope.isReceipt = false;
  trs.checkUnusedAdjustments = checkUnusedAdjustments;
  trs.getMicropaymentRowTemplate = getMicropaymentRowTemplate;
  trs.showAdjustments = {};
  trs.limitTransactionsDate = '2021-01-01';

  trs.loading = {
    'hasLoaded': false,
    'error': false,
  };
  $scope.refundLoading = false;

  $scope.refundModel = Refund.model;
  $scope.customerModel = Customer.model;
  $scope.refundNotificationMessage = {};
  function collapse($event, ag) {
    $event.preventDefault();
    ag.open = !ag.open;
  }

  transactionFactory.setModel('refundNotificationMessage', $scope.refundNotificationMessage);
  transactionFactory.setModel('scope', $scope);

  function customerAggregations(pageNo) {
    var attributes = {
      'participant': $scope.participant,
      'pageNo': pageNo || trs.aggregationModel.currentPage,
    };
    Aggregation.customerAggregations(attributes).finally(function() {
      trs.loading.hasLoaded = true;
      if(!window.__env.getFareDecisionByMicropayments) {
        populateFareDecision();
      }
    }).catch(function() {
      trs.loading.error = true;
    });
  }

  function populateFareDecision() {
    for (var i = 0; i < trs.aggregationModel.aggregations.length; i++) {
      for (var j = 0; j < trs.aggregationModel.aggregations[i].micropayments.length; j++) {
        var micropayment = trs.aggregationModel.aggregations[i].micropayments[j];
        if (micropayment.adjustments.length > 0) {
            for (var k = 0; k < micropayment.taps.length; k++) {
              var key = micropayment.id;
              var tap = micropayment.taps[k];
              Adjustments.getFareDecision(key, tap.id);
            }
        }
      }
    }
  }

  function transactionSearchClick() {
    trs.loading.hasLoaded = false;

    angular.forEach(trs.form, function(field, key) {
      if (field) {
        if (key === 'fromTime') {
          field = encodeURIComponent(moment(field, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' 00:00');
        }
        if (key === 'toTime') {
          field = encodeURIComponent(moment(field, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' 23:59');
        }
      }
      $location.search(key, field);
    });

    customerAggregations(1);
  }

  function showAllTransactions() {
    trs.form.aggregationId = null;
    $location.search('aggregationId', null);
    customerAggregations(1);
  }

  function showNotAppliedAdjustments(id) {
    trs.showAdjustments[id] = !trs.showAdjustments[id];
  }

  function checkUnusedAdjustments(adjustments) {
    var allUnappliedAdjustments = adjustments.filter(function(adjustment) {
      return !adjustment.applied;
    });
    return allUnappliedAdjustments.length > 0;
  }

  function getMicropaymentRowTemplate(micropayment) {
    var templateName = micropayment.amount < 0 ? 'credit' : 'debit';
    return 'app/pages/admin/customers/customerSummary/transactions/' + templateName + '.html';
  }

  /* Event Handlers */
  $scope.addRefundClick = function() {
    if (!Refund.validateRefundAmountEmpty()) {
      $scope.refundNotificationMessage.errorMessage($scope.translate('ENTER-A-REFUND-AMOUNT'));
      return;
    }

    if (!Refund.validateRefundAmount()) {
      $scope.refundNotificationMessage.errorMessage(
        $scope.translate('REFUND-AMOUNT-IS-GREATER'));
      return;
    }

    if (!Refund.validateReason()) {
      $scope.refundNotificationMessage.errorMessage($scope.translate('REASON-EMPTY'));
      return;
    }

    if (!Refund.validateReasonContents()) {
      $scope.refundNotificationMessage.errorMessage($scope.translate('REASON-SENSITIVE'));
      return;
    }

    var message = $scope.translate('REQUEST-SENT-FOR-SETTLEMENT');
    var title = $scope.translate('SUBMITTED');
    var type = 'success';

    $scope.refundLoading = true;

    Refund.addRefund($scope.refundModel.currentRefund).catch(function(d) {
      title = 'Error';
      type = 'error';
      if (d) {
        message = d.data.description;
      }
      if (d.status === 400) {
        message = d.data.errors[0].detail;
        var pos = message.indexOf(' - ');
        if (pos !== -1) {
          message = message.substr(pos + 3);
        }
      }
    }).finally(function() {
      $scope.hideRefundModal();
      sweetAlert.swal(
        title,
        message,
        type
      ).then(function() {
       $timeout(function() {
          transactionSearchClick();
        }, 1);
      });
      $scope.refundLoading = false;
    });
  };

  $scope.hideRefundModal = function() {
    Refund.resetValidation();
    $scope.refundNotificationMessage.hide();
    $scope.showSubmitRefundModal = false;
  };

  $scope.$watch('refundModel.currentRefund.refund_amount', Refund.refundAmountHandler);
}

angular.module('littlepayPortalMerchantApp.pages.admin.customers')
  .factory('transactionFactory', function () {
    var factory = {};
    var model = {};

    factory.setModel = function(key, value) {
      model[key] = value;
    };
    factory.getModel = function(key) {
      return model[key];
    };
    return factory;
  });

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsCappingListCtrl', AdminProductsCappingListCtrl);

AdminProductsCappingListCtrl.$inject = ['$scope', 'Capping', 'Auth', 'PRODUCTS_FILTER', 'Form', '$timeout', '$location'];

/** @ngInject */
function AdminProductsCappingListCtrl($scope, Capping, Auth, PRODUCTS_FILTER, Form, $timeout, $location) {
  var vm = this;
  vm.cappingModel = Capping.model;
  vm.loading = Form.loading;
  vm.hasPermission = Auth.hasPermission('WriteProducts');
  vm.filters = PRODUCTS_FILTER;
  vm.fetchCappings = fetchCappings;
  vm.showHowTo = showHowTo;
  vm.howToInfo = true;
  vm.switchTab = switchTab;
  vm.switchSelected = 'CURRENT-PRODUCTS';
  $scope.translatePrefix = 'PRODUCTS.CAPPING.';
  vm.cappingModel.allCapping = [];
  vm.sortProducts = sortProducts;

  fetchCappings();

  function fetchCappings() {
    $scope.pageLoadAgain();
    Capping.fetchAllCappings().then(function(data) {
      vm.cappingModel.currentProducts = [];
      vm.cappingModel.upcomingProducts = [];
      vm.cappingModel.expiredProducts = [];
      angular.forEach(data, function(d, k){
        var curTime = moment().utc();
        if(curTime.isBefore(d.start_date)) {
          vm.cappingModel.upcomingProducts.push(d);
        } else if(((!d.start_date || curTime.isAfter(d.start_date)) && (!d.end_date || curTime.isBefore(d.end_date)))) {
          vm.cappingModel.currentProducts.push(d);
        }else if(curTime.isAfter(d.end_date) && !d.superseded){
          vm.cappingModel.expiredProducts.push(d);
        }
        vm.cappingModel.allCapping = vm.cappingModel.currentProducts;
      });
      sortProducts();
      vm.loading.hasLoaded = true;
    }).catch(function(error) {
      console.log(error);
    }).finally(function() {
      $scope.pageLoaded();
    });
  }

  function showHowTo() {
    vm.howToInfo = !vm.howToInfo;
  }

  function switchTab(name) {
    vm.switchSelected = name;
    vm.cappingModel.allCapping = vm.cappingModel[name];
    vm.loading.hasLoaded = false;
    $timeout( function(){
      vm.loading.hasLoaded = true;
    }, 1000 );

  }

  function sortProducts() {
    var sortOrder = getSortOrder();
    var sortingProperty = getSortProperty(); 
    vm.cappingModel.allCapping.sort(sortBasedOnProperty(sortingProperty, sortOrder));
    vm.cappingModel.expiredProducts.sort(sortBasedOnProperty(sortingProperty, sortOrder));
    vm.cappingModel.currentProducts.sort(sortBasedOnProperty(sortingProperty, sortOrder));
    vm.cappingModel.upcomingProducts.sort(sortBasedOnProperty(sortingProperty, sortOrder));
  }

  function getSortProperty() {
    return $location.search().order || 'description';
  }

  function getSortOrder() {
    return $location.search().reverse === 'false' || $location.search().reverse === false ? 'DESC' : 'ASC';
  }

  function sortBasedOnProperty(property, order) {
    var sortOrder = 1;
    if(order === 'DESC') {
        sortOrder = -1;
    }
    return function (a,b) {
        var result = a[property].localeCompare(b[property]);
        return result * sortOrder;
    }
  }
}

/**
 * @author z.geddes
 * created on 01.02.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminCappingNewCtrl', AdminCappingNewCtrl);
AdminCappingNewCtrl.$inject = [
  'Capping',
  '$timeout',
  '$location',
  'PRODUCTS_FILTER',
  '$scope',
  'toastr',
  'Participant',
  'FeatureFlags'];

/** @ngInject */
function AdminCappingNewCtrl(Capping, $timeout, $location, PRODUCTS_FILTER, $scope, toastr, Participant, FeatureFlags) {
  var vm = this;
  vm.cappingModel = Capping.model;
  vm.productsFilter = PRODUCTS_FILTER;
  vm.save = save;
  vm.showHowTo = showHowTo;
  vm.onIsAllDayToggle = onIsAllDayToggle;
  vm.reset = reset;
  vm.cappingTypeChanged = cappingTypeChanged;
  vm.limitedTripChanged = limitedTripChanged;
  vm.howToInfo = true;
  vm.participant = Participant.model;
  vm.getCappingTypes = $scope.getCappingTypes;
  vm.transferType = false;
  $scope.translatePrefix = 'PRODUCTS.CAPPING.';

  function checkTimeLessThanMax(inputTimeStr) {
    var inputTimeMoment = moment(inputTimeStr, 'HH:mm:ss');
    var maxTimeMoment = moment(
      (PRODUCTS_FILTER.maxOverlapHours + ':00:00').padStart(8, '0'),
      'HH:mm:ss');
    return !inputTimeMoment.isAfter(maxTimeMoment);
  }

  function onIsAllDayToggle() {
    vm.capping.rules.from_time_local = vm.capping.rules.all_day ? '00:00:00' : undefined;
    vm.capping.rules.to_time_local = vm.capping.rules.all_day ? '23:59:59' : undefined;
    vm.capping.rules.to_time_overlap_local = undefined;
  }

  function save(capping, form) {
    var valid = true;
    vm.cappingModel.newCapping = angular.copy(capping);
    var invalid_input = '';

    if (vm.cappingModel.newCapping.rules && vm.cappingModel.newCapping.rules.to_time_overlap_local &&
      !checkTimeLessThanMax(vm.cappingModel.newCapping.rules.to_time_overlap_local)) {
      valid = false;
      form.to_time_overlap_local.$setValidity('to_time_overlap_local', false);
    } else if (form.to_time_overlap_local !== undefined) {
      form.to_time_overlap_local.$setValidity('to_time_overlap_local', true);
    }

    if(vm.cappingModel.newCapping.capping_type === 'TIME_BASED_CAP' && vm.cappingModel.newCapping.rules.transfer_type === 'UNLIMITED' && vm.cappingModel.newCapping.rules.number_of_transfer) {
      delete vm.cappingModel.newCapping.rules.number_of_transfer;
    }

    if(vm.cappingModel.newCapping.capping_type === 'TIME_BASED_CAP' && (vm.cappingModel.newCapping.rules.capping_duration_in_minutes < 1 || vm.cappingModel.newCapping.rules.capping_duration_in_minutes > 1440)) {
      valid = false;
      form.capping_duration_in_minutes.$setValidity('capping_duration_in_minutes', false);
    }

    angular.forEach(form, function(element, name) {
      if (!name.startsWith('$') && !form[name].$valid) {
        valid = false;
        invalid_input = name + ' is ' + form[name].$modelValue;
      }
    });

    if (valid) {
      vm.cappingModel.newCapping.product_type = 'CAPPING';

      var timezone = vm.cappingModel.newCapping.rules.time_zone;

      if (vm.cappingModel.newCapping.capping_type === 'WEEKLY_CAP') {
        vm.cappingModel.newCapping.rules.weekly_cap_end_day =
          vm.cappingModel.newCapping.rules.weekly_cap_start_day === 'MONDAY' ?
            'SUNDAY' :
            'SATURDAY';
      }

      setTransactionTypes();
      setStartEndTime(timezone);

      Capping.create(vm.cappingModel.newCapping).then(function(data) {
        $timeout(function() {
          toastr.success($scope.translate('SUCCESSFULLY-CREATED'));
          $location.path('admin/products/capping/' + data.id + '/default');
        }, 1000);
      }).catch(function() {
        toastr.error($scope.translate('ERROR-CREATED'));
      });
    } else {
      toastr.error($scope.translate('INVALID-INPUT', {'input': invalid_input}));
    }
  }

  function setTransactionTypes(){
    vm.cappingModel.newCapping.rules.transaction_types = ['autoscan', vm.capping.rules.transaction_type]
    delete vm.capping.rules.transaction_type;
  }

  function setStartEndTime(tz) {
    if(vm.proposedStart === 'immediate') {
      vm.cappingModel.newCapping.start_date = moment().utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    }else {
      var test = vm.startDate + " " + vm.proposedStartTime;
      vm.cappingModel.newCapping.start_date = formatDateTimeStringtoDateTime(test, tz);
    }

    if(vm.proposedEnd === 'scheduleEndDate') {
      vm.cappingModel.newCapping.end_date = formatDateTimeStringtoDateTime(vm.endDate + " " + vm.proposedEndTime, tz);
    }
  }

  function formatDateTimeStringtoDateTime(dateString, tz){
    if (dateString === undefined) {
      return undefined;
    }
    if(tz) {
      return moment.tz(dateString, tz).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    }else {
      return moment(dateString).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    }
  }

  function cappingTypeChanged(option) {
    if(vm.capping.capping_type === 'TIME_BASED_CAP'){
      vm.capping.rules ? vm.capping.rules.transfer_type = 'UNLIMITED' : vm.capping.rules = {'transfer_type': 'UNLIMITED'};
    }else {
      if(vm.capping.rules) {
        delete vm.capping.rules.number_of_transfer;
        delete vm.capping.rules.transfer_type;
        delete vm.capping.rules.capping_duration_in_minutes;
      }
    }
  }

  function limitedTripChanged() {
    if(!vm.limitedTrips) {
      vm.capping.rules.trip_number_limit = 0;
    }
  }

  /**
   * Expects timeString in format 'HH:mm:ss'
   * @param timeString
   * @param tz
   * @returns {*}
   */

  function reset(cappingForm) {
    if (cappingForm) {
      vm.cappingForm.$setPristine();
      vm.cappingForm.$setUntouched();
    }
    vm.cappingModel.newCapping = {};
    vm.capping = {};
  }

  function showHowTo() {
    vm.howToInfo = !vm.howToInfo;
  }

  $scope.$watch(function() {
    return $scope.currentParticipant;
  }, function(currentParticipant) {
    //only initialise page once we know the current participant has been loaded
    //(which will also have loaded the feature flags for the current participant)
    if (currentParticipant) {
      reset();
      $scope.pageLoaded();
    }
  });
}

/**
 * @author z.geddes
 * created on 25.11.2019
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminCappingScheduleCtrl', AdminCappingScheduleCtrl);
AdminCappingScheduleCtrl.$inject = [
  'Capping',
  '$timeout',
  '$location',
  '$scope',
  'toastr',
  'CappingScheduleHelper'];

/** @ngInject */
function AdminCappingScheduleCtrl(Capping, $timeout, $location, $scope, toastr, CappingScheduleHelper) {
  var sc = this;
  var vm = $scope.$parent.vm;

  sc.schedulePopup = schedulePopup;
  sc.hideModal = hideModal;
  sc.submitRequest = submitRequest;
  sc.duplicateProduct = duplicateProduct;

  sc.futureScheduledProductInfo = [];

  $scope.$on('schedulePopup', function(e) {
    schedulePopup();
  });

  $scope.$on('getCurrentProductReady', function(e) {
    copyOriginalForUpdate();
    getFutureScheduledProducts();
  });

  function schedulePopup(change) {

    if(change) {
      setScheduleTimes();
    }else {
      sc.schedule = {};
    }
    sc.showScheduleProductModal = true;
    sc.scheduleError = {};
  }

  function copyOriginalForUpdate(){
    vm.originalCopyCapping = angular.copy(vm.cappingModel.selectedCapping);
  }

  function getFutureScheduledProducts(){
    if(vm.cappingModel.selectedCapping.future_scheduled_product_ids) {
      angular.forEach(vm.cappingModel.selectedCapping.future_scheduled_product_ids, function(id, key){
        Capping.getCappingById({'cappingId': id, 'participantName': vm.cappingModel.selectedCapping.participant_id})
        .$promise.then(function(d){
          if(moment().utc().isBefore(d.start_date) && (moment().utc().isBefore(d.end_date) || !d.end_date)) {

            sc.futureScheduledProductInfo[key] = {
              'id': d.id,
              'status': d.status,
              'product_code': d.product_code,
              'time_zone': d.rules.time_zone,
              'start_date': fromUTCtoTimeZone(d.start_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD HH:mm:ss',d.rules.time_zone)
            };
          }

        });
      });
    }

  }

  function hideModal () {
    sc.showScheduleProductModal = false;
    sc.schedule = {};
    sc.isDuplicating = false;
  };

  function submitRequest() {
    if(sc.isDuplicating) {
        duplicateThisProduct();
    }else {
      if(vm.isFuture && validateScheduleForm()) {
        vm.sendUpdateProduct().finally(function() {
          hideModal();
        });
      }

      if(vm.isCurrent && validateScheduleForm()) {
        vm.prepareToUpdate();

        var isThereExistingFutureProduct = vm.originalCopyCapping.superseded && vm.originalCopyCapping.end_date;
        if(!isThereExistingFutureProduct || (isThereExistingFutureProduct && moment(vm.temporaryCapping.start_date).isBefore(vm.originalCopyCapping.end_date))) {
          vm.originalCopyCapping.end_date = vm.temporaryCapping.start_date;
        }

        vm.originalCopyCapping.superseded = true;
        Capping.updateCapping({
          'cappingId': vm.temporaryCapping.id,
          'participantName': vm.vars.participant},
          vm.originalCopyCapping).$promise
         .then(function(){
           if(!vm.temporaryCapping.original_version_id) {
             vm.temporaryCapping.original_version_id = vm.temporaryCapping.id;
           }
           vm.temporaryCapping.previous_version_id = vm.temporaryCapping.id;
           createProduct();
         }).catch(function(data) {
             toastr.error(
             $scope.translate('ERROR-UPDATED', {'detail': data.data.errors[0].detail}));
         }).finally(function() {
           vm.loading = false;
           hideModal ();
         });
      }
    }
  }

  function setScheduleTimes() {
    var timezone = vm.cappingModel.selectedCapping.rules.time_zone;
    sc.schedule = {
      proposedStart: 'scheduleStartDate',
      startDate: fromUTCtoTimeZone(vm.cappingModel.selectedCapping.start_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD'),
      proposedStartTime: fromUTCtoTimeZone(vm.cappingModel.selectedCapping.start_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'HH:mm:ss'),
      proposedEnd: !vm.cappingModel.selectedCapping.end_date ? 'indefinite' : 'scheduleEndDate',
    }

    if(vm.cappingModel.selectedCapping.end_date){
      sc.schedule.endDate = fromUTCtoTimeZone(vm.cappingModel.selectedCapping.end_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD');
      sc.schedule.proposedEndTime = fromUTCtoTimeZone(vm.cappingModel.selectedCapping.end_date, 'YYYY-MM-DDTHH:mm:ss[Z]', 'HH:mm:ss');
    }
  }

  function fromUTCtoTimeZone(date, from_format, to_format, timezone) {
    var timezone = timezone || vm.cappingModel.selectedCapping.rules.time_zone;
    return moment.utc(date, from_format).tz(timezone).format(to_format);
  }

  function fromTimeZoneToUTC(date) {
    var timezone = vm.temporaryCapping.rules.time_zone;
    var to_format = 'YYYY-MM-DDTHH:mm:ss[Z]';
    return moment.tz(date, timezone).utc().format(to_format);
  }

  function validateScheduleForm() {
    sc.scheduleError = {};

    if(!sc.schedule.proposedStart) {
      sc.scheduleError.proposedStart = true;
      return false;
    }

    if(sc.schedule.proposedStart === 'scheduleStartDate' && !sc.schedule.startDate) {
      sc.scheduleError.startDate = true;
      return false;
    }

    if(sc.schedule.proposedStart === 'scheduleStartDate' && sc.schedule.startDate && !sc.schedule.proposedStartTime) {
      sc.scheduleError.proposedStartTime = true;
      return false;
    }

    if(!sc.schedule.proposedEnd) {
      sc.scheduleError.proposedEnd = true;
      return false;
    }

    if(sc.schedule.proposedEnd === 'scheduleEndDate' && !sc.schedule.endDate) {
      sc.scheduleError.endDate = true;
      return false;
    }

    if(sc.schedule.proposedEnd === 'scheduleEndDate' && sc.schedule.endDate && !sc.schedule.proposedEndTime) {
      sc.scheduleError.proposedEndTime = true;
      return false;
    }

    var m_startTime = moment(sc.schedule.proposedStartTime, 'HH:mm:ss');
    var m_endTime = moment(sc.schedule.proposedEndTime, 'HH:mm:ss');
    if((sc.schedule.endDate === sc.schedule.startDate) && (m_startTime.isAfter(m_endTime))){
      sc.scheduleError.proposedEndTimeInvalid = true;
      return false;
    }

    setStartEndTime();
    return true;
  }

  function setStartEndTime() {

    if(sc.schedule.proposedStart === 'immediate') {
      vm.temporaryCapping.start_date = fromTimeZoneToUTC(Date.now());
    }else {
      vm.temporaryCapping.start_date = fromTimeZoneToUTC(sc.schedule.startDate + " " + sc.schedule.proposedStartTime);
    }

    if(sc.schedule.proposedEnd === 'scheduleEndDate') {
      vm.temporaryCapping.end_date = fromTimeZoneToUTC(sc.schedule.endDate + " " + sc.schedule.proposedEndTime);
    }else {
      if(vm.temporaryCapping.end_date) {
        delete vm.temporaryCapping.end_date;
      }
    }
  }

  function duplicateThisProduct() {
    if(validateScheduleForm()) {
      createProduct();
    }
  }

  function duplicateProduct() {
    sc.isDuplicating = true;
    schedulePopup();
  }

  function createProduct() {
    if(sc.isDuplicating) {
      vm.prepareToUpdate();
    }
    vm.newProduct = angular.copy(vm.temporaryCapping);

    delete vm.newProduct.id;
    delete vm.newProduct.created_date;
    delete vm.superseded;
    if (sc.isDuplicating) {
      delete vm.newProduct.original_version_id;
      delete vm.newProduct.previous_version_id;
    }

    Capping.create(vm.newProduct).then(function(data) {
      $timeout(function() {
        if(sc.isDuplicating) {
          toastr.success($scope.translate('SUCCESSFULLY-DUPLICATED'));
          redirectToNewProduct(data.id);
        }else {
          toastr.success($scope.translate('SUCCESSFULLY-UPDATED'));
          if(CappingScheduleHelper.isFutureScheduled(data)) {
            updateOriginalProductWithFutureScheduledProductId(data);
          }else {
            redirectToNewProduct(data.id);
          }
        }
      }, 1000);
    }).catch(function() {
      toastr.error($scope.translate('ERROR-CREATED'));
    }).finally(function() {
      vm.loading = false;
    });
  }

  function updateOriginalProductWithFutureScheduledProductId(data) {
      if(vm.originalCopyCapping.future_scheduled_product_ids) {
        vm.originalCopyCapping.future_scheduled_product_ids.push(data.id)
      }else {
        vm.originalCopyCapping.future_scheduled_product_ids = [data.id];
      }
      Capping.updateCapping({
        'cappingId': vm.temporaryCapping.id,
        'participantName': vm.vars.participant},
        vm.originalCopyCapping).$promise.then(function() {
          redirectToNewProduct(data.id);
        });
  }
  function redirectToNewProduct(id) {
    $location.url('admin/products/capping/' + id + '/default');
  }

}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsCappingSummaryCtrl', AdminProductsCappingSummaryCtrl);

AdminProductsCappingSummaryCtrl.$inject = [
  '$scope',
  'Capping',
  'Auth',
  'productsForm',
  'Participant',
  'toastr',
  '$filter',
  'Zone',
  '$timeout',
  '$location',
  '$q',
  'FeatureFlags',
  'PRODUCTS_FILTER',
  'CappingHelper'];

/** @ngInject */
function AdminProductsCappingSummaryCtrl($scope, Capping, Auth, productsForm, Participant, toastr, $filter, Zone,
                                         $timeout, $location, $q, FeatureFlags, PRODUCTS_FILTER, CappingHelper) {
  var vm = this;
  vm.cappingModel = Capping.model;
  vm.zoneModel = Zone.model;
  vm.hasPermission = Auth.hasPermission('WriteProducts');
  vm.vars = productsForm;
  vm.formErrors = {};
  vm.loading = false;
  vm.getTemporaryValue = getTemporaryValue;
  vm.editProduct = editProduct;
  vm.updateProduct = updateProduct;
  vm.deleteProduct = deleteProduct;
  vm.switch = switchTab;
  vm.toggleZone = toggleZone;
  vm.toggleStatus = toggleStatus;
  vm.addRoute = addRoute;
  vm.removeRoute = removeRoute;
  vm.getMultiParticipantZonesFromIds = getMultiParticipantZonesFromIds;
  vm.getMultiParticipantNamesFromIds = getMultiParticipantNamesFromIds;
  vm.getZoneGroupNameFromId = getZoneGroupNameFromId;
  vm.getZoneNameFromId = getZoneNameFromId;
  vm.onIsAllDayToggle = onIsAllDayToggle;
  vm.sendUpdateProduct = sendUpdateProduct;
  vm.prepareToUpdate = prepareToUpdate;
  vm.zoneModeTooltip = 'test';
  vm.cappingTypeChanged = cappingTypeChanged;
  vm.limitedTripChanged = limitedTripChanged;
  vm.getCappingTypes = $scope.getCappingTypes;
  vm.participant = Participant.model;
  vm.shouldShowTimeZone = '';
  vm.incentiveTypeChanged = incentiveTypeChanged;
  vm.showIncentiveTab = showIncentiveTab;
  vm.cancelEditButton = cancelEditButton;
  vm.validateTimeBasedCapping = validateTimeBasedCapping;
  vm.transferTypeChanged = transferTypeChanged;
  vm.cappingHelper = CappingHelper;

  $scope.translatePrefix = 'PRODUCTS.CAPPING.';

  function validateToTimeOverlap() {
    var isValid = true;
    if (vm.temporaryCapping.rules.to_time_overlap_local) {
      isValid = checkTimeLessThanMax(vm.temporaryCapping.rules.to_time_overlap_local);
      if(!isValid) {
        vm.formErrors.to_time_overlap_local = true;
      }
    }
    return isValid;
  }

  function validateTimeBasedCapping() {
    var isValid = true;

    if (vm.temporaryCapping.capping_type === 'TIME_BASED_CAP') {
      var isCappingDurationValid = vm.temporaryCapping.rules.capping_duration_in_minutes > 0 && vm.temporaryCapping.rules.capping_duration_in_minutes <= 1440;
      var isNumberOfTransferValid = true;
      if(vm.temporaryCapping.rules.transfer_type === 'LIMITED') {
        isNumberOfTransferValid = vm.temporaryCapping.rules.number_of_transfer && vm.temporaryCapping.rules.number_of_transfer > 0 && vm.temporaryCapping.rules.number_of_transfer < 100;
      }
      isValid = isCappingDurationValid && isNumberOfTransferValid;
    }

    if (!isValid) {
      vm.formErrors.to_time_overlap_local = true;
    }
    vm.cappingHelper.model.disable = !isValid;

    return isValid;
  }

  function validateTripLimitNumber() {
    var isValid = true;

    if(vm.limitedTrips) {
      isValid = vm.temporaryCapping.rules.trip_number_limit > 0 && vm.temporaryCapping.rules.trip_number_limit < 100;
    }
    if(!isValid) {
      vm.formErrors.trip_number_limit = true;
    }
    return isValid;
  }

  function validateRoutes() {
    removeBlankRoutes();

    var routeEnabledButHaveNoRoutes = vm.temporaryCapping.route_capping_enabled && (!vm.temporaryCapping.rules.routes || vm.temporaryCapping.rules.routes.length < 1);
    if(routeEnabledButHaveNoRoutes) {
      vm.formErrors.route = true;
    }
    return routeEnabledButHaveNoRoutes;

  }

  function limitedTripChanged() {
    if(!vm.limitedTrips) {
      vm.temporaryCapping.rules.trip_number_limit = 0;
    }
  }

  function checkTimeLessThanMax(inputTimeStr) {
    var inputTimeMoment = moment(inputTimeStr, 'HH:mm:ss');
    var maxTimeMoment = moment((productsForm.filters.maxOverlapHours + ':00:00').padStart(8, '0'), 'HH:mm:ss');
    return !inputTimeMoment.isAfter(maxTimeMoment);
  }

  function onIsAllDayToggle() {
    vm.temporaryCapping.rules.from_time_local = vm.temporaryCapping.rules.all_day ?
      '00:00:00' :
      undefined;
    vm.temporaryCapping.rules.to_time_local = vm.temporaryCapping.rules.all_day ? '23:59:59' : undefined;
    vm.temporaryCapping.rules.to_time_overlap_local = undefined;
  }

  function getZoneGroupNameFromId(zoneGroupId) {
    return _.find(vm.temporaryCapping.rules.zone_groups, {id: zoneGroupId}).name;
  }

  function getZoneNameFromId(zoneId) {
    return vm.zoneModel.idToNameMap[zoneId] || zoneId;
  }

  function getMultiParticipantNamesFromIds(participantIds) {
    return _.reduce(participantIds, function(acc, id) {
      if (vm.temporaryCapping.multi_participants_list[id] !== undefined) {
        acc.push(vm.temporaryCapping.multi_participants_list[id].name);
      }
      return acc;
    }, []);
  }

  function getMultiParticipantZonesFromIds(zoneIds) {
    return _.pick(vm.temporaryCapping.multi_participant_zones, zoneIds);
  }

  function getCurrentCapping(callback) {
    Capping.fetchCappingById().then(function(data) {
      vm.cappingModel.selectedCapping = data;
      var scheduleStatus = CappingScheduleHelper.getScheduleStatus(data);
      vm[scheduleStatus] = true;
      vm.cappingHelper.model.allAvailableProducts = [];

      if(vm.isCurrent) {
        $scope.$broadcast('getCurrentProductReady');
      }

      var temporaryValuePromise = getTemporaryValue();

      vm.canEdit = vm.hasPermission && !vm.temporaryCapping.multi_participant;
      $scope.pageLoaded();
      if (callback !== undefined) {
        callback();
      }
      return temporaryValuePromise;
    }).catch(function(error) {
      console.log(error);
    });
  }

  function getCurrentCappingWithUpdatedTriangles(zoneIds, timePeriodType, key) {
    return Capping.fetchCappingById(zoneIds, timePeriodType).then(function(data) {
      vm.temporaryCapping.rules[key] = data.rules[key];

    }).catch(function(error) {
      console.log(error);
    });
  }

  function initZones() {
    angular.forEach(CappingHelper.model.peakOffPeak, function(key, x) {
      vm.temporaryCapping.rules[x] = vm.temporaryCapping.rules[x] ?
        vm.temporaryCapping.rules[x] :
        {};

      if (vm.temporaryCapping.rules[x]) {
        vm.vars[x].keys = Object.keys(vm.temporaryCapping.rules[x]);
        vm.vars[x].width = (100 / Object.keys(vm.temporaryCapping.rules[x]).length + '%') || '100%';
        vm.vars[x].all_zones = vm.zoneModel.list;
      }
    });
  }

  function getZones() {
    return Zone.fetch(vm.temporaryCapping.participant_id)
      .then(function() {
        if (vm.temporaryCapping.multi_participant && !vm.cappingHelper.isEmpty(vm.zoneModel.list)) {
          _.concat(vm.zoneModel.list, vm.temporaryCapping.multiParticipantZones);
        }
      });
  }

  function cancelEditButton() {
    vm.cappingHelper.model.disable = false;
    vm.getTemporaryValue();
  }

  function getTemporaryValue() {
    vm.cappingEditForm.$setPristine();
    vm.temporaryCapping = angular.copy(vm.cappingModel.selectedCapping);
    vm.shouldShowTimeZone = shouldShowTimeZone();

    // await getting zones to avoid showing zone ids to the user
    return getZones().finally(function () {
      setTimeBasedCapping();
      setTransactionType();
      setNumberOfTrips();
      initZones();

      if (vm.cappingHelper.isWeeklyOrMultiDayCap(vm.temporaryCapping)) {
        vm.cappingHelper.setIncentiveRulesWithDailyCapDiscount(vm.temporaryCapping);
      }
    });
  }

  function setTransactionType() {
    vm.temporaryCapping.rules.transaction_types = _.without(vm.temporaryCapping.rules.transaction_types, 'autoscan');
    vm.temporaryCapping.rules.transaction_type = vm.temporaryCapping.rules.transaction_types[0];
  }

  function setTimeBasedCapping() {
    if(vm.temporaryCapping.capping_type === 'TIME_BASED_CAP' && !vm.temporaryCapping.transfer_type) {
      vm.temporaryCapping.transfer_type = 'UNLIMITED';
    }
  }

  function incentiveTypeChanged() {
    if(vm.cappingHelper.isIncentiveCumulativeCap(vm.temporaryCapping)) {
      vm.cappingHelper.setIncentiveRulesWithCumulativeCap(vm.temporaryCapping);
    } else {
      vm.cappingHelper.setIncentiveRulesWithDailyCapDiscount(vm.temporaryCapping);
    }
    vm.temporaryCapping.incentive_rules = CappingHelper.model.incentiveRules;
    vm.cappingHelper.model.disable = false;
  }

  function setNumberOfTrips() {
    vm.limitedTrips = vm.temporaryCapping.rules.trip_number_limit !== undefined && vm.temporaryCapping.rules.trip_number_limit > 0;
  }

  function editProduct(formName) {
    angular.forEach(vm.vars.forms, function(val, key) {
      if (key !== formName) {
        vm.vars.forms[key] = false;
      }
    });
    getTemporaryValue();
  }

  function validateForm() {
    vm.formErrors = {};

    validateToTimeOverlap();
    validateTimeBasedCapping();
    validateTripLimitNumber();
    validateRoutes();
    if(vm.temporaryCapping.incentive_rules) {
      vm.temporaryCapping.incentive_rules.applied_original_product_ids = CappingHelper.getAppliedOriginalProductIds(vm.temporaryCapping);

    }

    if (!vm.cappingEditForm.$valid) {
        _.forEach(vm.cappingEditForm.$$controls, function(formControl) {
          if (formControl.$invalid) {
            vm.formErrors[formControl.$name] = true;
          }
        });
    }

    if(vm.vars.forms.zoneOptionsForm) {
      if(!vm.temporaryCapping.zoned_capping_pricing_type) {
        vm.formErrors.zonePricingType = true;
      }

      if(!vm.temporaryCapping.zoned_capping_mode) {
        vm.formErrors.zoneMode = true;
      }
    }

    vm.cappingEditForm.$setSubmitted();
    return _.isEmpty(vm.formErrors);
  }

  function updateProduct() {
    if (validateForm()) {
      if (vm.isCurrent) {
        $scope.$broadcast('schedulePopup');
      } else if (vm.isFuture) {
        updateOriginalProduct();
      }
    } else {
      toastr.error($scope.translate('INVALID-UPDATE'));
      return $q.reject($scope.translate('FORM-VALIDATION-FAILED'));
    }
  }

  function updateOriginalProduct(){
    prepareToUpdate();
    sendUpdateProduct();
  }

  function prepareToUpdate() {
    vm.loading = true;
    setWeeklyCapEndDay();
    removeFieldsIfNotTimeBasedCapping();
    setTransactionTypes();
  }

  function sendUpdateProduct() {
    vm.loading = true;
    return Capping.updateCapping({
      'cappingId': vm.temporaryCapping.id,
      'participantName': vm.vars.participant,
    }, vm.temporaryCapping).$promise
      .then(function() {
        vm.cappingModel.selectedCapping = angular.copy(vm.temporaryCapping);
        getTemporaryValue();
        toastr.success($scope.translate('SUCCESSFULLY-UPDATED'));
      })
      .catch(function(data) {
        toastr.error(
          $scope.translate('ERROR-UPDATED', {'detail': data.data.errors[0].detail}));
      }).finally(function() {
        vm.loading = false;
      });
  }

  function deleteProduct() {
    var msg = $scope.translate('REMOVE-CAPPING-WARNING');
    $scope.deleteAlert(removeProduct, msg);
  }

  function removeProduct() {
    Capping.removeCapping(vm.temporaryCapping.id).then(function() {
      toastr.success($scope.translate('SUCCESSFULLY-REMOVED'));
      $location.path('admin/products/capping');
    }).catch(function() {
      toastr.error($scope.translate('ERROR-REMOVED'));
    });
  }

  function removeBlankRoutes() {
    if (vm.temporaryCapping.rules.routes) {
      for (var i = 0; i < vm.temporaryCapping.rules.routes.length; i++) {
        var route = vm.temporaryCapping.rules.routes[i];
        if (!route || route.length === 0) {
          vm.temporaryCapping.rules.routes.splice(i, 1);
          i--;
        }
      }
    }
  }

  function removeFieldsIfNotTimeBasedCapping(){
    if(vm.temporaryCapping.capping_type != 'TIME_BASED_CAP') {
      delete vm.temporaryCapping.rules.capping_duration_in_minutes;
      delete vm.temporaryCapping.rules.number_of_transfer;
      delete vm.temporaryCapping.rules.transfer_type;
    } else if(vm.temporaryCapping.capping_type === 'TIME_BASED_CAP' && vm.temporaryCapping.rules.transfer_type === 'UNLIMITED' && vm.temporaryCapping.rules.number_of_transfer){
      delete vm.temporaryCapping.rules.number_of_transfer;
    }
  }

  function setTransactionTypes(){
    vm.temporaryCapping.rules.transaction_types = ['autoscan', vm.temporaryCapping.rules.transaction_type]
    delete vm.temporaryCapping.rules.transaction_type;
  }

  function setWeeklyCapEndDay() {
    if (vm.temporaryCapping.capping_type === 'WEEKLY_CAP') {
      vm.temporaryCapping.rules.weekly_cap_end_day = 'SATURDAY';
      if (vm.temporaryCapping.rules.weekly_cap_start_day === 'MONDAY') {
        vm.temporaryCapping.rules.weekly_cap_end_day = 'SUNDAY';
      }
    }
  }

  function switchTab(name) {
    vm.vars.switchSelected = name;
  }

  /**
   * This toggle function handles toggling of zones
   * @param timePeriodType PEAK or OFFPEAK
   * @param rulesKey peak_zones or offpeak_zones
   * @param zone - the zone
   */
  function toggleZone(timePeriodType, rulesKey, zone) {
    var zones = vm.vars[rulesKey].keys.slice();
    var i = zones.indexOf(zone.id);

    if (i > -1) {
      zones.splice(i, 1);
    } else {
      zones.push(zone.id);
    }

    getCurrentCappingWithUpdatedTriangles(zones, timePeriodType, rulesKey).then(function () {
      vm.vars[rulesKey].keys = Object.keys(vm.temporaryCapping.rules[rulesKey]);
    });
  }

  function toggleStatus(y) {
    y.status = y.status === 'ENABLED' ? 'DISABLED' : 'ENABLED';
  }

  function addRoute() {
    if (!vm.temporaryCapping.rules.routes) {
      vm.temporaryCapping.rules.routes = [];
    }
    vm.temporaryCapping.rules.routes.push('');
    $timeout(function() {
      $('#product-routes input[type=text]:last').select().focus();
    }, 100);
  }

  function removeRoute(index) {
    vm.temporaryCapping.rules.routes.splice(index, 1);
  }

  function shouldShowTimeZone() {
    var currentAndIndefinete = vm.isCurrent && !vm.temporaryCapping.end_date;
    var currentAndInactive = vm.isCurrent && vm.cappingModel.selectedCapping.status === 'INACTIVE';
    return vm.cappingModel.selectedCapping.rules.time_zone && !(currentAndIndefinete || currentAndInactive);
  }

  function transferTypeChanged() {
    if (vm.temporaryCapping.rules.transfer_type === 'LIMITED') {
      vm.temporaryCapping.rules.number_of_transfer = 1;
    }else {
      vm.cappingHelper.model.disable = false;
    }
  }

  function cappingTypeChanged() {
    if(vm.temporaryCapping.capping_type === 'TIME_BASED_CAP'){
      vm.temporaryCapping.rules.transfer_type = 'UNLIMITED';
      validateTimeBasedCapping();
    } else {
      vm.cappingHelper.model.disable = false;
    }
  }

  function showIncentiveTab() {
    return vm.cappingHelper.isWeeklyOrMultiDayCap(vm.temporaryCapping);
  }

  $scope.$watch(function() {
    return $scope.currentParticipant;
  }, function(currentParticipant) {
    //only initialise page once we know the current participant has been loaded
    //(which will also have loaded the feature flags for the current participant)
    if (currentParticipant) {
      getCurrentCapping();
    }
  });
}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsDiscountListCtrl', AdminProductsDiscountListCtrl);

AdminProductsDiscountListCtrl.$inject = ['$scope', 'Discount', 'Auth', 'PRODUCTS_FILTER', 'Form', '$timeout'];

/** @ngInject */
function AdminProductsDiscountListCtrl($scope, Discount, Auth, PRODUCTS_FILTER, Form, $timeout) {
  var vm = this;
  vm.discountModel = Discount.model;
  vm.loading = Form.loading;
  vm.hasPermission = Auth.hasPermission('WriteProducts');
  vm.fetchDiscounts = fetchDiscounts;
  vm.showHowTo = showHowTo;
  vm.infoToggle = true;
  vm.switchTab = switchTab;
  vm.switchSelected = 'CURRENT-PRODUCTS';
  $scope.translatePrefix = 'PRODUCTS.CAPPING.';
  vm.discountModel.allDiscount = [];

  fetchDiscounts();

  function fetchDiscounts() {
    $scope.pageLoadAgain();
    Discount.fetchAllDiscounts().then(function(discounts) {
      vm.discountModel.currentProducts = [];
      vm.discountModel.upcomingProducts = [];
      vm.discountModel.expiredProducts = [];
      angular.forEach(discounts, function(data){
        var curTime = moment().utc();
        if(curTime.isBefore(data.start_date)) {
          vm.discountModel.upcomingProducts.push(data);
        } else if(((!data.start_date || curTime.isAfter(data.start_date)) && (!data.end_date || curTime.isBefore(data.end_date)))) {
          vm.discountModel.currentProducts.push(data);
        }else if(curTime.isAfter(data.end_date) && !data.superseded){
          vm.discountModel.expiredProducts.push(data);
        }
        vm.discountModel.allDiscount = vm.discountModel.currentProducts;
      });
      vm.loading.hasLoaded = true;
    }).catch(function(error) {
      console.log(error);
    }).finally(function() {
      $scope.pageLoaded();
    });
  }

  function showHowTo() {
    vm.infoToggle = !vm.infoToggle;
  }

  function switchTab(name) {
    vm.switchSelected = name;
    vm.discountModel.allDiscount = vm.discountModel[name];
    vm.loading.hasLoaded = false;
    $timeout( function(){
      vm.loading.hasLoaded = true;
    }, 1000 );

  }
}

/**
 * @author z.geddes
 * created on 01.02.2018
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminDiscountNewCtrl', AdminDiscountNewCtrl);
AdminDiscountNewCtrl.$inject = [
  'Discount',
  '$timeout',
  '$location',
  'PRODUCTS_FILTER',
  '$scope',
  'toastr',
  'Participant',
  'FeatureFlags'];

/** @ngInject */
function AdminDiscountNewCtrl(Discount, $timeout, $location, PRODUCTS_FILTER, $scope, toastr, Participant, FeatureFlags) {
  var vm = this;
  vm.discountModel = Discount.model;
  vm.productsFilter = PRODUCTS_FILTER;
  vm.save = save;
  vm.showHowTo = showHowTo;
  vm.reset = reset;
  vm.toggleHowToInfo = true;
  vm.participant = Participant.model;

  $scope.translatePrefix = 'PRODUCTS.CAPPING.';

  function save(discount, form) {
    var valid = true;
    vm.discountModel.newDiscount = angular.copy(discount);

    var invalid_input = '';

    angular.forEach(form, function(element, name) {
      if (!name.startsWith('$') && !form[name].$valid) {
        valid = false;
        invalid_input = name + ' is ' + form[name].$modelValue;
      }
    });

    if (valid) {
      vm.discountModel.newDiscount.product_type = 'DISCOUNT';
      var timezone = vm.discountModel.newDiscount.time_zone;

      setStartEndTime(timezone);

      Discount.create(vm.discountModel.newDiscount).then(function(data) {
        $timeout(function() {
          toastr.success($scope.translate('SUCCESSFULLY-CREATED'));
          $location.path('admin/products/discount/' + data.id );
        }, 1000);
      }).catch(function() {
        toastr.error($scope.translate('ERROR-CREATED'));
      });
    } else {
      toastr.error($scope.translate('INVALID-INPUT', {'input': invalid_input}));
    }
  }

  function setStartEndTime(tz) {
    if(vm.proposedStart === 'immediate') {
      vm.discountModel.newDiscount.start_date = moment().utc().format();
    }else {
      var test = vm.startDate + " " + vm.proposedStartTime;
      vm.discountModel.newDiscount.start_date = formatDateTimeStringtoDateTime(test, tz);
    }

    if(vm.proposedEnd === 'scheduleEndDate') {
      vm.discountModel.newDiscount.end_date = formatDateTimeStringtoDateTime(vm.endDate + " " + vm.proposedEndTime, tz);
    }
  }

  function formatDateTimeStringtoDateTime(dateString, tz){
    if (dateString === undefined) {
      return undefined;
    }
    if(tz) {
      return moment.tz(dateString, tz).utc().format();
    }else {
      return moment(dateString).utc().format();
    }
  }

  function reset(discountForm) {
    if (discountForm) {
      vm.discountForm.$setPristine();
      vm.discountForm.$setUntouched();
    }
    vm.discountModel.newdiscount = {};
    vm.discount = {};
  }

  function showHowTo() {
    vm.toggleHowToInfo = !vm.toggleHowToInfo;
  }

  $scope.$watch(function() {
    return $scope.currentParticipant;
  }, function(currentParticipant) {
    //only initialise page once we know the current participant has been loaded
    //(which will also have loaded the feature flags for the current participant)
    if (currentParticipant) {
      vm.reset();
      $scope.pageLoaded();
    }
  });
}

/**
 * @author z.geddes
 * created on 25.11.2019
 */
'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminDiscountScheduleCtrl', AdminDiscountScheduleCtrl);
AdminDiscountScheduleCtrl.$inject = [
  'Discount',
  '$timeout',
  '$location',
  '$scope',
  'toastr'];

/** @ngInject */
function AdminDiscountScheduleCtrl(Discount, $timeout, $location, $scope, toastr) {
  var sc = this;
  var vm = $scope.$parent.vm;

  sc.schedulePopup = schedulePopup;
  sc.hideModal = hideModal;
  sc.submitRequest = submitRequest;
  sc.duplicateProduct = duplicateProduct;
  sc.futureScheduledProductInfo = [];

  $scope.$on('schedulePopup', function() {
    schedulePopup();
  });

  $scope.$on('getCurrentProductReady', function() {
    copyOriginalForUpdate();
    getFutureScheduledProducts();
  });

  function schedulePopup(change) {
    if(change) {
      setScheduleTimes();
    }else {
      sc.schedule = {};
    }
    sc.showScheduleProductModal = true;
    sc.scheduleError = {};
  }

  function copyOriginalForUpdate(){
    vm.originalCopyDiscount = angular.copy(vm.discountModel.selectedDiscount);
  }

  function getFutureScheduledProducts(){
    if(vm.discountModel.selectedDiscount.future_scheduled_product_ids) {
      angular.forEach(vm.discountModel.selectedDiscount.future_scheduled_product_ids, function(id, key){
        Discount.getDiscountById({'discountId': id, 'participantName': vm.discountModel.selectedDiscount.participant_id})
        .$promise.then(function(d){
          if(moment().utc().isBefore(d.start_date) && (moment().utc().isBefore(d.end_date) || !d.end_date)) {

            sc.futureScheduledProductInfo[key] = {
              'id': d.id,
              'status': d.status,
              'product_code': d.product_code,
              'time_zone': d.time_zone,
              'start_date': fromUTCtoTimeZone(d.start_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD HH:mm:ss',d.time_zone)
            };
          }

        });
      });
    }

  }

  function hideModal () {
    sc.showScheduleProductModal = false;
    sc.schedule = {};
    sc.isDuplicating = false;
  };

  function submitRequest() {
    if(sc.isDuplicating) {
        duplicateThisProduct();
    }else {
      if(vm.isFuture && validateScheduleForm()) {
        vm.sendUpdateProduct().finally(function() {
          hideModal();
        });
      }

      if(vm.isCurrent && validateScheduleForm()) {
        vm.loading = true;
        var isThereExistingFutureProduct = vm.originalCopyDiscount.superseded && vm.originalCopyDiscount.end_date;
        if(!isThereExistingFutureProduct || (isThereExistingFutureProduct && moment(vm.temporaryDiscount.start_date).isBefore(vm.originalCopyDiscount.end_date))) {
          vm.originalCopyDiscount.end_date = vm.temporaryDiscount.start_date;
        }
        vm.originalCopyDiscount.superseded = true;
        Discount.updateDiscount({
          'discountId': vm.temporaryDiscount.id,
          'participantName': vm.vars.participant},
          vm.originalCopyDiscount).$promise
         .then(function(){
           if(!vm.temporaryDiscount.original_version_id) {
             vm.temporaryDiscount.original_version_id = vm.temporaryDiscount.id;
           }
           vm.temporaryDiscount.previous_version_id = vm.temporaryDiscount.id;
           createProduct();
         }).catch(function(data) {
             toastr.error(
             $scope.translate('ERROR-UPDATED', {'detail': data.data.errors[0].detail}));
         }).finally(function() {
           vm.loading = false;
           hideModal ();
         });
      }
    }
  }

  function setScheduleTimes() {
    var timezone = vm.discountModel.selectedDiscount.time_zone;
    sc.schedule = {
      proposedStart: 'scheduleStartDate',
      startDate: fromUTCtoTimeZone(vm.discountModel.selectedDiscount.start_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD'),
      proposedStartTime: fromUTCtoTimeZone(vm.discountModel.selectedDiscount.start_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'HH:mm:ss'),
      proposedEnd: !vm.discountModel.selectedDiscount.end_date ? 'indefinite' : 'scheduleEndDate',
    }

    if(vm.discountModel.selectedDiscount.end_date){
      sc.schedule.endDate = fromUTCtoTimeZone(vm.discountModel.selectedDiscount.end_date,'YYYY-MM-DDTHH:mm:ss[Z]', 'YYYY-MM-DD');
      sc.schedule.proposedEndTime = fromUTCtoTimeZone(vm.discountModel.selectedDiscount.end_date, 'YYYY-MM-DDTHH:mm:ss[Z]', 'HH:mm:ss');
    }
  }

  function fromUTCtoTimeZone(date, from_format, to_format, timezone) {
    var timezone = timezone || vm.discountModel.selectedDiscount.time_zone;
    var formatedTime;
    if(!timezone) {
      formatedTime = moment.utc(date, from_format).format(to_format);
    }else {
      formatedTime = moment.utc(date, from_format).tz(timezone).format(to_format);
    }
    return formatedTime;
  }

  function fromTimeZoneToUTC(date) {
    var timezone = vm.temporaryDiscount.time_zone;
    return moment.tz(date, timezone).utc().format();
  }

  function validateScheduleForm() {
    sc.scheduleError = {};

    if(!sc.schedule.proposedStart) {
      sc.scheduleError.proposedStart = true;
      return false;
    }

    if(sc.schedule.proposedStart === 'scheduleStartDate' && !sc.schedule.startDate) {
      sc.scheduleError.startDate = true;
      return false;
    }

    if(sc.schedule.proposedStart === 'scheduleStartDate' && sc.schedule.startDate && !sc.schedule.proposedStartTime) {
      sc.scheduleError.proposedStartTime = true;
      return false;
    }

    if(!sc.schedule.proposedEnd) {
      sc.scheduleError.proposedEnd = true;
      return false;
    }

    if(sc.schedule.proposedEnd === 'scheduleEndDate' && !sc.schedule.endDate) {
      sc.scheduleError.endDate = true;
      return false;
    }

    if(sc.schedule.proposedEnd === 'scheduleEndDate' && sc.schedule.endDate && !sc.schedule.proposedEndTime) {
      sc.scheduleError.proposedEndTime = true;
      return false;
    }

    var m_startTime = moment(sc.schedule.proposedStartTime, 'HH:mm:ss');
    var m_endTime = moment(sc.schedule.proposedEndTime, 'HH:mm:ss');
    if((sc.schedule.endDate === sc.schedule.startDate) && (m_startTime.isAfter(m_endTime))){
      sc.scheduleError.proposedEndTimeInvalid = true;
      return false;
    }

    setStartEndTime();
    return true;
  }

  function setStartEndTime() {

    if(sc.schedule.proposedStart === 'immediate') {
      vm.temporaryDiscount.start_date = fromTimeZoneToUTC(Date.now());
    }else {
      vm.temporaryDiscount.start_date = fromTimeZoneToUTC(sc.schedule.startDate + " " + sc.schedule.proposedStartTime);
    }

    if(sc.schedule.proposedEnd === 'scheduleEndDate') {
      vm.temporaryDiscount.end_date = fromTimeZoneToUTC(sc.schedule.endDate + " " + sc.schedule.proposedEndTime);
    }else {
      if(vm.temporaryDiscount.end_date) {
        delete vm.temporaryDiscount.end_date;
      }
    }
  }

  function duplicateThisProduct() {
    if(validateScheduleForm()) {
      createProduct();
    }
  }

  function duplicateProduct() {
    sc.isDuplicating = true;
    schedulePopup();
  }

  function createProduct() {
    if(sc.isDuplicating) {
    }
    vm.newProduct = angular.copy(vm.temporaryDiscount);

    delete vm.newProduct.id;
    delete vm.newProduct.created_date;
    delete vm.superseded;
    if (sc.isDuplicating) {
      delete vm.newProduct.original_version_id;
      delete vm.newProduct.previous_version_id;
    }

    Discount.create(vm.newProduct).then(function(data) {
      $timeout(function() {
        if(sc.isDuplicating) {
          toastr.success($scope.translate('SUCCESSFULLY-DUPLICATED'));
          redirectToNewProduct(data.id);
        }else {
          toastr.success($scope.translate('SUCCESSFULLY-UPDATED'));
          if(vm.isFutureScheduled(data)) {
            updateOriginalProductWithFutureScheduledProductId(data);
          }else {
            redirectToNewProduct(data.id);
          }
        }
      }, 1000);
    }).catch(function() {
      toastr.error($scope.translate('ERROR-CREATED'));
    }).finally(function() {
      vm.loading = false;
    });
  }

  function updateOriginalProductWithFutureScheduledProductId(data) {
      if(vm.originalCopyDiscount.future_scheduled_product_ids) {
        vm.originalCopyDiscount.future_scheduled_product_ids.push(data.id)
      }else {
        vm.originalCopyDiscount.future_scheduled_product_ids = [data.id];
      }
      Discount.updateDiscount({
        'discountId': vm.temporaryDiscount.id,
        'participantName': vm.vars.participant},
        vm.originalCopyDiscount).$promise.then(function() {
          redirectToNewProduct(data.id);
        });
  }
  function redirectToNewProduct(id) {
    $location.url('admin/products/discount/' + id);
  }

}

'use strict';

angular.module('littlepayPortalMerchantApp.pages.admin.products')
  .controller('AdminProductsDiscountSummaryCtrl', AdminProductsDiscountSummaryCtrl);

AdminProductsDiscountSummaryCtrl.$inject = [
  '$scope',
  'Discount',
  'Auth',
  'productsForm',
  'Participant',
  'toastr',
  '$timeout',
  '$location',
  '$q',
  'FeatureFlags',
  'PRODUCTS_FILTER'];

/** @ngInject */
function AdminProductsDiscountSummaryCtrl($scope, Discount, Auth, productsForm, Participant, toastr,
                                         $timeout, $location, $q, FeatureFlags, PRODUCTS_FILTER) {
  var vm = this;
  vm.discountModel = Discount.model;
  vm.hasPermission = Auth.hasPermission('WriteProducts');
  vm.vars = productsForm;
  vm.loading = false;
  vm.getTemporaryValue = getTemporaryValue;
  vm.editProduct = editProduct;
  vm.updateProduct = updateProduct;
  vm.deleteProduct = deleteProduct;
  vm.toggleStatus = toggleStatus;
  vm.getMultiParticipantNamesFromIds = getMultiParticipantNamesFromIds;
  vm.sendUpdateProduct = sendUpdateProduct;
  vm.isFutureScheduled = isFutureScheduled;
  vm.getCurrentDiscount = getCurrentDiscount;
  vm.participant = Participant.model;

  $scope.translatePrefix = 'PRODUCTS.CAPPING.';

  function getMultiParticipantNamesFromIds(participantIds) {
    return _.reduce(participantIds, function(acc, id) {
      if (vm.temporaryDiscount.multi_participants_list[id] !== undefined) {
        acc.push(vm.temporaryDiscount.multi_participants_list[id].name);
      }
      return acc;
    }, []);
  }

  function getCurrentDiscount(callback) {
    Discount.fetchDiscountById().then(function(data) {
      vm.discountModel.selectedDiscount = data;
      checkProductValidty(data);

      if(vm.isCurrent) {
        $scope.$broadcast('getCurrentProductReady');
      }

      getTemporaryValue();

      vm.canEdit = vm.hasPermission && !vm.temporaryDiscount.multi_participant;
      $scope.pageLoaded();
      if (callback !== undefined) {
        callback();
      }
    }).catch(function(error) {
      console.log(error);
    });
  }

  function checkProductValidty(d) {
    if(moment().utc().isAfter(d.start_date) && (moment().utc().isBefore(d.end_date) || !d.end_date)) {
      vm.isCurrent = true;
    } else if(isFutureScheduled(d)) {
      vm.isFuture = true;
    }else if(moment().utc().isAfter(d.end_date) && !d.superseded){
      vm.isExpired = true;
    }
  }

  function isFutureScheduled(d) {
    return moment().utc().isBefore(d.start_date) && (moment().utc().isBefore(d.end_date) || !d.end_date);
  }


  function getTemporaryValue() {
    vm.temporaryDiscount = angular.copy(vm.discountModel.selectedDiscount);
  }

  function editProduct(formName) {
    angular.forEach(vm.vars.forms, function(val, key) {
      if (key !== formName) {
        vm.vars.forms[key] = false;
      }
    });
    getTemporaryValue();
  }

  function updateProduct() {
    if(vm.isCurrent) {
      $scope.$broadcast('schedulePopup');
    }else if(vm.isFuture){
      updateOriginalProduct();
    }
  }

  function updateOriginalProduct(){
    sendUpdateProduct();
  }

  function sendUpdateProduct() {
    vm.loading = true;
    return Discount.updateDiscount({
      'discountId': vm.temporaryDiscount.id,
      'participantName': vm.vars.participant,
    }, vm.temporaryDiscount).$promise
      .then(function() {
        vm.discountModel.selectedDiscount = angular.copy(vm.temporaryDiscount);
        getTemporaryValue();
        toastr.success($scope.translate('SUCCESSFULLY-UPDATED'));
      })
      .catch(function(data) {
        toastr.error(
          $scope.translate('ERROR-UPDATED', {'detail': data.data.errors[0].detail}));
      }).finally(function() {
        vm.loading = false;
      });
  }

  function deleteProduct() {
    var msg = $scope.translate('REMOVE-DISCOUNT-WARNING');
    $scope.deleteAlert(removeProduct, msg);
  }

  function removeProduct() {
    Discount.removeDiscount(vm.temporaryDiscount.id).then(function() {
      toastr.success($scope.translate('SUCCESSFULLY-REMOVED'));
      $location.path('admin/products/discount');
    }).catch(function() {
      toastr.error($scope.translate('ERROR-REMOVED'));
    });
  }

  function toggleStatus(y) {
    y.status = y.status === 'ENABLED' ? 'DISABLED' : 'ENABLED';
  }

  function shouldShowTimeZone() {
    var currentAndIndefinete = vm.isCurrent && !vm.temporaryDiscount.end_date;
    var currentAndInactive = vm.isCurrent && vm.discountModel.selectedDiscount.status === 'INACTIVE';
    return vm.discountModel.selectedDiscount.time_zone && !(currentAndIndefinete || currentAndInactive);
  }


  $scope.$watch(function() {
    return $scope.currentParticipant;
  }, function(currentParticipant) {
    //only initialise page once we know the current participant has been loaded
    //(which will also have loaded the feature flags for the current participant)
    if (currentParticipant) {
      getCurrentDiscount();
    }
  });
}

"use strict";

var REFRESH_ORDERS_AFTER_REFUNDS_INTERVAL = 2000;

angular
  .module("littlepayPortalMerchantApp.pages.admin.search")
  .controller("AdminOrderDetailsCtrl", AdminOrderDetailsCtrl);
AdminOrderDetailsCtrl.$inject = [
  "$scope",
  "Order",
  "EcomPurchases",
  "sweetAlert",
  "$location",
  "Form",
  "toastr",
  "Auth",
  "Refund",
];

function AdminOrderDetailsCtrl(
  $scope,
  Order,
  EcomPurchases,
  sweetAlert,
  $location,
  Form,
  toastr,
  Auth,
  Refund
) {
  var vm = this;
  vm.loading = Form.loading;
  vm.loading.hasLoaded = false;
  vm.refundsModal = false;
  vm.refundOrderModal = false;
  vm.customerComment = "CUSTOMER_REQUEST";
  $scope.refundNotificationMessage = {};
  vm.orderModel = Order.model;
  vm.hasPermissionToRefund = Auth.checkUserHasPermission("IssueRefund");

  $scope.translatePrefix = "ORDER.";

  refreshOrderDetails();

  function refreshOrderDetails() {
    Order.getOrderDetails()
      .catch(function (error) {
        vm.loading.error = true;

        $location.path("admin/orders");
        if (error.status === 404) {
          toastr.error($scope.translate("NO-ORDER-FOUND"));
        } else {
          toastr.error($scope.translate("ERROR-MESSAGE"));
        }
      })
      .finally(function () {
        vm.loading.hasLoaded = true;
      });
  }

  $scope.showRefundOrderModal = function () {
    var amount = vm.orderModel.currentOrderDetails.order.amount;
    var refundedAmount =
      vm.orderModel.currentOrderDetails.order.refunded_amount;

    vm.refundAmount = (
      (refundedAmount ? amount - refundedAmount : amount) / 100
    ).toFixed(2);
    vm.refundOrderId = vm.orderModel.currentOrderDetails.order.id;
    vm.refundOrderModal = true;
    $scope.refundNotificationMessage.warningMessage(
      $scope.translate("REFUND-SENSITIVITY-WARNING")
    );
  };

  $scope.canRefundOrder = function () {
    if (!vm.orderModel.currentOrderDetails) {
      return false;
    }
    var amount = vm.orderModel.currentOrderDetails.order.amount;
    var refundedAmount =
      vm.orderModel.currentOrderDetails.order.refunded_amount;
    var orderStatus = vm.orderModel.currentOrderDetails.order.status;
    return (
      vm.hasPermissionToRefund &&
      (orderStatus === "CAPTURED" || orderStatus === "PARTIALLY_REFUNDED") &&
      refundedAmount < amount
    );
  };

  $scope.submitOrderRefundRequest = function () {
    var title = $scope.translate("SUBMITTED");
    var type = "success";
    var message = $scope.translate("REFUND-SUBMITTED");
    if (!Order.validateReasonContents(vm.customerComment, vm.issuerComment)) {
      title = $scope.translate("ERROR");
      type = "error";
      message =
        $scope.translate("REFUND-SUBMIT-ERROR") +
        "\n" +
        $scope.translate("REASON-SENSITIVE");
      sweetAlert.swal(title, message, type);
      return;
    }

    sweetAlert.swal.showLoading();
    vm.refundOrderModal = false;

    Order.requestOrderRefund(
      vm.orderModel.currentOrderDetails.order.transaction_id,
      {
        amount: (vm.refundAmount * 100).toFixed(0),
        reason: vm.customerComment,
        comment: vm.issuerComment,
      }
    )
      .then(function () {
        setTimeout(refreshOrderDetails, REFRESH_ORDERS_AFTER_REFUNDS_INTERVAL);
      })
      .catch(function (error) {
        title = $scope.translate("ERROR");
        type = "error";
        message =
          $scope.translate("REFUND-SUBMIT-ERROR") +
          "\n" +
          error.data.errors[0].detail;
      })
      .finally(function () {
        sweetAlert.swal(title, message, type);
      });
  };

  function splitAndCapitalize(s) {
    return s
      .split(/[-_.]/g)
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.substring(1);
      })
      .join(" ");
  }

  $scope.getEntityType = function (event) {
    return splitAndCapitalize(event.entity_type);
  };

  $scope.getEventDetails = function (event) {
    var eventTypeWithoutEntity = event.event_type.substring(
      event.event_type.indexOf(".") + 1
    );
    var typeAction = splitAndCapitalize(eventTypeWithoutEntity);

    switch (event.entity_type) {
      case "order":
      case "charge":
      case "purchase":
      case "payment-intent":
      case "authentication":
      case "invoice":
        return typeAction;
      case "refund":
        return (
          typeAction +
          " for " +
          event.currency +
          " " +
          (event.amount / 100).toFixed(2)
        );
      default:
        return event.event_type;
    }
  };

  $scope.shouldDisplayPaymentInstrument = function (event) {
    if (event.entity_type === "authentication") {
      return true;
    }
    return (
      event.entity_type === "payment-intent" &&
      event.event_type.split(".")[1] === "processing"
    );
  };

  $scope.getPaymentInstrumentIcon = function (payment_instrument) {
    if (payment_instrument === undefined) {
      return undefined;
    }

    switch (payment_instrument.payment_method) {
      case "PAYPAL":
        return "cc paypal";
      case "GOOGLE_PAY":
        return "google";
      case "APPLE_PAY":
        return "cc apple pay";
      case "SAVED_CARD":
      case "CARD":
        if (payment_instrument.card_type) {
          return "cc " + payment_instrument.card_type.toLowerCase();
        }
        return "credit card";
      default:
        return undefined;
    }
  };

  $scope.getPaymentInstrumentText = function (payment_instrument) {
    if (payment_instrument === undefined) {
      return undefined;
    }

    var paymentMethod = payment_instrument.payment_method;
    var last_digits = payment_instrument.card_last_digits;
    var expiry = payment_instrument.card_expiry;

    if (
      (paymentMethod === "CARD" || paymentMethod === "SAVED_CARD") &&
      last_digits &&
      expiry
    ) {
      return last_digits + " " + expiry;
    }
  };

  $scope.getClientTypeIcon = function (clientType) {
    switch (clientType) {
      case "MOBILE":
        return "big icon mobile alternate";
      case "IOS":
        return "big icon apple";
      case "ANDROID":
        return "big icon android";
      case "BROWSER":
        return "big icon desktop";
      default:
        return undefined;
    }
  };

  $scope.getAuthenticationCheckStatusIcon = function (status) {
    switch (status) {
      case "SUCCEEDED":
        return "check circle";
      case "FAILED":
        return "times circle";
      case "UNKNOWN":
        return "question circle";
    }
  };

  $scope.$watch("vm.refundAmount", function (val) {
    val = angular.isString(val) ? val : val + "";
    var regEx = /(\d+)(\.)*(\d{0,2})/;
    var matches = val.match(regEx);
    if (!matches) {
      vm.refundAmount = "";
      return;
    }
    var firstDigit = matches[1];
    var dot = matches[2];
    var secondDigit = matches[3];

    var refundAmount = 0;
    if (matches.length >= 2) {
      refundAmount = firstDigit;
    }
    if (matches.length >= 3 && dot) {
      refundAmount += ".";
    }
    if (matches.length >= 4 && secondDigit) {
      refundAmount += secondDigit;
    }
    vm.refundAmount = refundAmount;
  });
}

angular.module('littlepayPortalMerchantApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/account/account.html','<div class="account-page page container"><div class="page-view" ui-view=""></div></div>');
$templateCache.put('app/pages/admin/admin.html','<div ng-include="\'app/theme/components/header/header.html\'" ng-if="!isReceipt"></div><sidebar ng-if="!isReceipt"></sidebar><div ng-controller="CookieCtrl"><cookiepopup></cookiepopup></div><div class="littlepay-page-container" id="test"><div class="littlepay-page-content"><div class="container" ng-show="!pageError"><navbar-breadcrumb ng-if="!isReceipt"></navbar-breadcrumb><page-loader ng-if="!tabPage" show="pageLoading"></page-loader><div class="admin-view" ui-view=""></div></div><div class="container" ng-show="!pageLoading && pageError"><div id="errorPage" class="wrapper wrapper-white text-center"><div class="swal2-icon swal2-error swal2-animate-error-icon display-block"><span class="swal2-x-mark swal2-animate-x-mark"><span class="swal2-x-mark-line-left"></span> <span class="swal2-x-mark-line-right"></span></span></div><div class="swal2-modal display-block"><h2 class="swal2-title" id="swal2-title">{{ translate(\'ADMIN.ERROR\') }}</h2><div id="swal2-content" class="swal2-content display-block">{{errorMsg}}</div></div><a class="customer-status withTopMargin" href="{{url}}">{{ translate(\'ADMIN.GO-BACK\') }} <i class="fa fa-fw fa-long-arrow-left"></i></a></div></div></div></div><back-top><i class="angle up icon back-top" id="backTop" title="{{ translate(\'ADMIN.BACK-TO-TOP\') }}"></i></back-top><div ng-include="\'app/theme/components/rightbar/rightbar.html\'"></div>');
$templateCache.put('app/pages/parent/parent.html','<div ng-include="\'app/theme/components/header/header.html\'"></div><div class="littlepay-page-container" id="test"><sidebar></sidebar><div ng-controller="CookieCtrl"><cookiepopup></cookiepopup></div><div class="littlepay-page-content"><div class="container"><navbar-breadcrumb></navbar-breadcrumb><div class="admin-view" ui-view=""></div></div></div></div><div ng-include="\'app/theme/components/rightbar/rightbar.html\'"></div>');
$templateCache.put('app/pages/account/changePassword/changePassword.html','<div class="changePasswordContainer"><div class="form-header text-center"><img class="sidebar-logo" src="/assets/images/logo.png" width="200" alt="Little Pay Merchant Portal"><h2 translate="USERS.ACCOUNT.CHANGE-PASSWORD"></h2></div><form class="form-horizontal" ng-submit="submitPassword()"><div class="form-body clearfix"><notification-message ng-model="changePasswordNotificationMessage"></notification-message><div class="form-group clearfix" ng-class="{\'has-error\': invalid.password, \'has-feedback\': invalid.password }"><label class="col-sm-3 control-label modal-password-label" translate="USERS.ACCOUNT.PASSWORD"></label><div class="col-sm-9"><input type="password" class="form-control modal-password-field" ng-model="changePasswordModel.newUser.password"> <span class="glyphicon icon-cross form-control-feedback" ng-show="invalid.password" aria-hidden="true"></span></div></div><div class="form-group clearfix" ng-class="{\'has-error\': invalid.repeatPassword, \'has-feedback\': invalid.repeatPassword }"><label class="col-sm-3 control-label modal-repeat-password-label" translate="USERS.ACCOUNT.REPEAT-PASSWORD"></label><div class="col-sm-9"><input type="password" class="form-control modal-repeat-password-field" ng-model="changePasswordModel.newUser.repeatPassword"> <span class="glyphicon icon-cross form-control-feedback" ng-show="invalid.repeatPassword" aria-hidden="true"></span></div></div></div><div class="form-bottom text-center"><input type="submit" class="btn btn-primary" value="{{ \'USERS.ACCOUNT.SUBMIT\' | translate }}"></div></form></div><div class="text-center"><a href="#" ng-click="logout()" translate="USERS.ACCOUNT.LOGOUT"></a></div>');
$templateCache.put('app/pages/account/login/login.html','<div class="ui large vertically attached menu littlepay-page-header" id="login-header" ng-if="isMultipleLanguage"><div class="right floated item"><div class="ui pointing dropdown top right" dropdown="" ng-model="selectedLanguage" dropdown-change="languageChanged"><div class="text">{{ languages[selectedLanguage].label }}</div><i class="angle up icon"></i><div class="menu"><div class="item" ng-repeat="(key,language) in languages" data-value="{{ key }}">{{ language.label }}</div></div></div></div></div><div class="login-page page container" ng-controller="AccountLoginCtrl"><div class="row"><div class="text-center col-sm-12"><span id="login-logo" role="img" aria-label="Littlepay Merchant Portal"></span></div><div class="col-sm-12 text-center" ng-if="!loggingIn"><button ng-click="loginClick()" class="ui button login-button basic positive huge" translate="USERS.ACCOUNT.LOGIN"></button></div><div class="col-sm-12 text-center" ng-if="loggingIn"><page-loader show="true"></page-loader></div></div></div><div id="login-footer"><div class="ui large vertically attached inverted menu"><div ng-if="shouldShowPrivacyPolicy" class="right floated item"><a class="margin-right1" href="https://littlepay.com/privacy/" target="_blank"><small translate="USERS.ACCOUNT.PRIVACY-POLICY"></small></a></div></div></div>');
$templateCache.put('app/pages/admin/analysis/movedtocontrolportal.html','<div style="display: flex; justify-content: center; align-items: center; height: 60vh; margin: 0; text-align: center; flex-direction: column;"><h1 style="margin-bottom: 20px">Analytics is now only available via the Control Portal</h1><h3 style="margin-bottom: 20px">Login to Control Portal for Analytics</h3><a ng-href="{{ctrlUrl}}" target="_blank" style="display: inline-block; padding: 10px 20px; font-size: 16px; color: white; background-color: #00bf6f; text-decoration: none; border-radius: 5px;" class="btn btn-default btn-lg">Control Portal</a></div>');
$templateCache.put('app/pages/admin/dashboard/dashboard.html','<div class="ui segment basic clearing without-padding"><timeline ng-model="vm.timeline" on-change="vm.getData"></timeline></div><div class="ui segment basic clearing no-top-margin"><div include-with-scope="app/pages/admin/dashboard/widgets/summarySection.html"></div></div>');
$templateCache.put('app/pages/admin/support/supportInfo.html','<div class="ui segment basic clearing" ng-init="pageLoaded();"><div class="panel panel-default clearfix support-info-panel"><div class="panel-heading"><h5 class="panel-title" translate="SUPPORT.SUPPORT-INFORMATION"></h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-md-12 panel-t mps-engine-text" translate="{{merchantSupportFromHere()}}"></div></div></li><li class="list-group-item"><div class="row"><div class="col-md-4 panel-t mps-engine-text" translate="{{merchantSupportCenter()}}"></div><div class="col-md-8"><a ng-if="customMerchantSubdomainName !== \'vixtech\'" href="{{merchantSupportCenterValue() | translate}}" target="_blank" title="{{merchantSupportCenter() | translate}}">{{ merchantSupportCenterValue() | translate }}</a> <a ng-if="customMerchantSubdomainName === \'vixtech\'" href="mailto:{{merchantSupportCenterValue() | translate}}" target="_blank" title="{{merchantSupportCenter() | translate}}">{{ merchantSupportCenterValue() | translate }}</a></div></div></li><li class="list-group-item"><div class="row"><div class="col-md-4 panel-t mps-engine-text" translate="SUPPORT.EMERGENCY-CONTACT-NUMBER"></div><div class="col-md-8">{{ merchantSupportEmergencyContact()| translate}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-md-4 panel-t mps-engine-text"></div><div class="col-md-8" translate="SUPPORT.MESSAGE"></div></div></li></ul></div></div>');
$templateCache.put('app/pages/admin/transactions/transactions.html','<div class="wrapper" ng-show="!pageLoading"><div class="ui segments"><div class="segment clearing ui tableFilters"><entry-change ng-model="transactionModel" on-entry-change="onEntryChange"></entry-change></div><div class="segment ui no-padding" ng-class="{\'loading\': loading}"><table class="ui table"><thead><tr class="header"><th class="center aligned">#</th><th>{{ translate(\'TAP-TIME\') }}</th><th>{{ translate(\'AMOUNT\') }}</th><th>{{ translate(\'DESCRIPTION\') }}</th><th>{{ translate(\'PURCHASE\') }}</th><th>{{ translate(\'LOCATION\') }}</th><th>{{ translate(\'TRANSACTION-STATUS\') }}</th><th></th></tr></thead><tbody><tr ng-repeat="transaction in transactionModel.allTransactions" ng-click="seeTransaction($event,transaction)"><td data-th="#" class="collapsing center aligned">{{$index+1}}</td><td data-th="{{translate(\'TAP-TIME\')}}" ng-show="transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time"><span><short-medium-date-time ng-model="transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time"></short-medium-date-time></span></td><td data-th="{{translate(\'TAP-TIME\')}}" ng-show="!transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time"><short-medium-date-time ng-model="transaction.micropayment.updated_time"></short-medium-date-time></td><td data-th="{{ translate(\'AMOUNT\') }}" ng-show="transaction.micropayment.amount != null">{{ transaction.micropayment.amount | isoCurrency:transaction.micropayment.currency }}</td><td data-th="{{ translate(\'AMOUNT\') }}" ng-show="transaction.micropayment.amount == null">({{ translate(\'PENDING_CHARGE\') }})</td><td data-th="{{ translate(\'DESCRIPTION\') }}"><i class="fa fa-fw fa-bus"></i>{{ translate(transaction.micropayment.taps[transaction.micropayment.taps.length - 1].description | uppercase) }}</td><td data-th="{{ translate(\'PURCHASE\') }}" ng-show="transaction.micropayment.purchases[0].description || transaction.micropayment.amount != null"><span class="truncate">{{ transaction.micropayment.purchases[0].description }}</span></td><td data-th="{{ translate(\'PURCHASE\') }}" ng-show="!transaction.micropayment.purchases[0].description && transaction.micropayment.amount == null"><span class="truncate">{{ translate(\'PENDING_CHARGE\') }}</span></td><td data-th="{{ translate(\'LOCATION\') }}"><span ng-repeat="tap in transaction.micropayment.taps"><span class="truncate">{{ tap.location }}<span><br ng-if="!$last"></span></span></span></td><td data-th="{{ translate(\'TRANSACTION-STATUS\') }}" class="collapsing"><payment-guarantee-status-label ng-model="transaction"></payment-guarantee-status-label><span ng-if="transaction.settlement_status" class="label label-{{(transaction.settlement_status | removeSpaces) | lowercase}}">{{ (\'GUARANTEESTATUS.\' + (transaction.settlement_status | removeSpaces)) | translate }}</span><is-adjusted ng-model="transaction"></is-adjusted><span class="label label-incomplete" ng-if="transaction.micropayment.charge_type === \'incomplete_variable_fare\'">{{ \'GUARANTEESTATUS.INCOMPLETE\' | translate }}</span> <span class="label label-warning" ng-if="transaction.micropayment.charge_type === \'pending_variable_fare\'">{{ \'GUARANTEESTATUS.TAP-PENDING\' | translate }}</span> <span ng-if="transaction.multi_operator" class="label label-default margin-right1">{{ \'GUARANTEESTATUS.MULTI-OP\' | translate }}</span></td><td data-th="{{ translate(\'ACTIONS\') }}"><a class="ui icon button basic positive right floated" ng-href="/admin/customersById/{{ transaction.customer_id }}" title="{{ translate(\'SEE-CUSTOMER\') }}"><i class="fa fa-user"></i></a></td></tr></tbody><tfoot ng-if="transactionModel.allTransactions.length === 0"><tr><th colspan="8"><h4 class="ui red">{{ translate(\'NO-TRANSACTIONS\') }}</h4></th></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/admin/unauthorized/unauthorized.html','<div class="wrapper"><div class="alert alert-warning text-center"><h1>Unauthorized Access!</h1><br>You are not authorized to access the page you requested.</div></div>');
$templateCache.put('app/pages/parent/account/account.html','<div class="wrapper" ng-show="!pageLoading"><div ng-include="\'app/pages/library/account/accountOwner/accountOwner.html\'"></div></div>');
$templateCache.put('app/theme/components/cardExpiration/cardExpiration.html','<div class="ui fluid icon input"><input type="text" name="{{name}}" ng-model="expDate" class="exp-date" placeholder="MM/YY" id="expDate" required=""> <i class="times link icon" ng-if="expDate" ng-click="removeContent()"></i></div>');
$templateCache.put('app/theme/components/collapseMenuButton/collapseMenuButton.html','<a class="sidebar-collapse" sidebar-toggle-menu="" ng-class="{\'active\': $baSidebarService.isMenuCollapsed()}"><div class="sidebar-collapse-icon"><span class="line-one"></span> <span class="line-two"></span> <span class="line-three"></span></div></a>');
$templateCache.put('app/theme/components/currencyPicker/currencyPicker.html','<div class="currency-picker ui selection dropdown labeled icon button big no-right-margin" dropdown="" ng-model="selectedCode" dropdown-change="updateCurrencyPicker" syn-ui-with-model="true"><span class="text"><h4 class="ui blue header currency-header">{{selectedCode | toISOCurrency}}</h4></span> <i class="alternate outline icon {{selectedCode | toISOCurrency}}"></i><div class="menu"><div class="item" ng-repeat="code in currencyCodes" data-value="{{code}}"><h4 class="ui blue header currency-header">{{code | toISOCurrency}}</h4></div></div></div>');
$templateCache.put('app/theme/components/dateRangePicker/dateRangePicker.html','<div class="ui selection labeled icon button top pointing big date-range" ng-model="ngModel"><span class="text"><h4 class="ui blue header timeline-header" ng-model="startDate" moment-picker="startDate" format="YYYY-MM-DD" min-view="year" max-view="month" start-view="month" min-date="minStartDate" max-date="endDate" change="updateStartDate()">From {{startDate | dateToString}}</h4></span> <i class="calendar alternate outline icon"></i></div><div class="ui selection labeled icon button top pointing big date-range no-right-padding-margin" ng-model="ngModel"><span class="text"><h4 class="ui blue header timeline-header" ng-model="endDate" moment-picker="endDate" format="YYYY-MM-DD" min-view="year" max-view="month" start-view="month" min-date="startDate" max-date="maxEndDate" change="updateEndDate()">To {{endDate | dateToString}}</h4></span> <i class="calendar alternate outline icon"></i></div>');
$templateCache.put('app/theme/components/dateRangePicker2/dateRangePicker2.html','<div translate-namespace="COMPONENTS.DATERANGE" class="ui selection labeled icon button top pointing big date-range datepicker-button" ng-class="{\'active\': calendarOpened}" ng-click="toggleCalendar()" ng-blur="blurHandler()"><span class="text"><h4 class="ui blue header timeline-header">{{ \'COMPONENTS.DATERANGE.TIMELINEHEADER\' | translate: {\'fromDate\': (ngModel.fromDate.toDate() | date:\'shortDate\'),\'toDate\': (ngModel.toDate.toDate() | date:\'shortDate\')} }}</h4></span> <i class="calendar alternate outline icon"></i></div><div translate-namespace="COMPONENTS.DATERANGE" id="datepickerBox-{{$id}}" class="datepicker" ng-class="{\'ng-hide\': !calendarOpened, \'with-custom-options\': customOptions}" tabindex="1" ng-blur="blurHandler()"><div class="calendar-wrapper"><div class="controls"><i class="angle left icon" ng-class="{\'invisible\': !canGoBack()}" ng-click="prevMonth($event)"></i> <span class="title" ng-bind="title"></span> <i class="angle right icon" ng-class="{\'invisible\': !canGoForward()}" ng-click="nextMonth($event)"></i></div><div class="day-names"><span ng-repeat="dn in dayNames" translate="{{\'.\'+ dn}}"></span></div><div class="calendar"><span ng-repeat="d in days" class="day {{d.class}}" ng-click="selectDate($event, d)" ng-mouseenter="highlightRange(d.date)">{{ d.date.date() }}</span></div><br></div><div class="datepicker-custom-options" ng-if="customOptions"><span ng-repeat="option in customOptions" ng-class="{\'active\': isCustomOptionSelected(option)}" ng-click="selectCustomOption(option)" translate="{{\'.\'+ option.label}}"></span></div><a ng-if="pickedFromDate" class="datepicker-clear-selection" ng-click="clearSelection()" translate=".RESET"></a></div>');
$templateCache.put('app/theme/components/editButton/editButton.html','<ul class="panel-btn"><li ng-if="!variable"><a class="btn btn-warning" ng-click="editClick()"><i class="pencil alternate icon edit-button"></i></a></li><li ng-if="variable"><a href="#" class="btn btn-primary btn-xs" ng-click="editClick()" ng-disabled="disable"><i class="icon download"></i> Save</a></li><li ng-if="variable"><a href="#" class="btn btn-danger btn-xs pull-right" ng-click="editCancel()"><i class="icon times"></i></a></li></ul>');
$templateCache.put('app/theme/components/entryChange/entryChange.html','<div translate-namespace="COMPONENTS.ENTRYCHANGE" class="small" ng-if="onEntryChange" ng-show="ngModel.pagination.total > 10 || ngModel.allTransactions.length >= 10 || ngModel.pagination.item_count > 0"><span translate=".SHOW"></span><div id="entryChangeDropdown" class="ui compact selection dropdown" ng-model="ngModel.entryNumber" dropdown="" dropdown-change="updateListEntry"><i class="dropdown icon"></i><div class="text">{{ngModel.entryNumber}}</div><div class="menu"><div class="item" data-value="10">10</div><div class="item" data-value="50" ng-if="ngModel.pagination.total > 10 || ngModel.allTransactions || ngModel.pagination.current_page > 0">50</div><div class="item" data-value="100" ng-if="ngModel.pagination.total > 100 || ngModel.allTransactions">100</div><div class="item" data-value="200" ng-if="ngModel.pagination.total > 200 || ngModel.allTransactions">200</div><div class="item" data-value="500" ng-if="ngModel.pagination.total > 500 || ngModel.allTransactions">500</div></div></div><span translate=".ENTRIES"></span></div>');
$templateCache.put('app/theme/components/footer/footer.html','<div id="littlepay-page-footer" class="littlepay-page-footer-fixed" ng-controller="FooterCtrl"><ul class="littlepay-page-footer-controls"><li><a class="notifications" title="Notifications" href="/admin/notifications"><i class="fa fa-bell parent faa-ring" ng-class="{\'animated\': newNotification}"><i class="fa fa-exclamation-circle child" ng-show="newNotification"></i></i></a></li><li><a class="logout" ng-click="logout()"><i class="fa fa-power-off"></i></a></li></ul><div id="notification-container" ng-if="!active && newNotification"><h3>Notifications <a href="/admin/notifications"><i class="fa fa-cog right"></i></a></h3><div ng-repeat="(key, n) in newNotifications"><input class="checkbox" type="checkbox" id="{{key}}" value="small" ng-change="checked()" ng-model="infoBox[key]"> <label class="notification new" for="{{key}}">{{n.title | htmlToPlaintext}}<br><a href="admin/notifications/{{key}}">View</a> <i class="fa fa-times right"></i></label></div></div></div>');
$templateCache.put('app/theme/components/header/header.html','<div class="littlepay-page-header"><div id="main-logo-container"><a id="main-logo" href="admin/transactions">Littlepay</a><collapse-menu-button></collapse-menu-button></div><ul class="header-buttons pull-right"><li><div class="profile clearfix"><div class="profile-info"><h4>{{profile.name}}</h4><span>{{profile.account.displayName}}</span></div></div></li><li class="header-button-stuck" ng-if="getAvailableParticipantCount() > 0"><a href="#" class="littlepay-page-rightbar-toggle" ng-click="openNotifications()" ng-class="{\'active\':notificationsOpened}"><i class="fa fa-bell parent faa-ring" ng-class="{\'animated\': newNotification}"><i class="fa fa-exclamation-circle child" ng-show="newNotification"></i></i></a></li><li><language-selection ng-if="isMultipleLanguage" ng-model="profile.language" languages="languages"></language-selection></li><li class="header-button-stuck" ng-if="getAvailableParticipantCount() > 0"><a href="#" class="littlepay-page-rightbar-toggle" ng-click="rightBarCollapse()"><div class="littlepay-page-rightbar-toggle-icon"><span class="line-one"></span> <span class="line-two"></span></div></a></li></ul><div id="control-portal-warning" style="background-color: red; width:100%; height: 30px; margin-top: 55px; display: flex; justify-content: center; margin-block-end: 30px;" ng-if="showCtrlWarning"><p style="color:white; font-size:14pt; font-style: oblique;">Littlepay will begin transitioning to <a style="color:white; text-decoration: underline;" ng-href="{{ctrlUrl}}" target="_blank">Control Portal</a> from {{ctrlDate | date:\'MMMM dd yyyy\'}}. Please contact support@littlepay.com with any questions</p><p></p></div></div><div id="notification-container" ng-if="notificationsOpened" ng-controller="FooterCtrl"><ul class="list-group"><li class="list-group-item" ng-repeat="n in newNotifications | orderBy:\'-\' | limitTo:3"><a href="/admin/notifications/{{n.key}}" ng-if="!isParent"><span class="margin-right1">{{n.title | htmlToPlaintext}}</span><span ng-if="n.status" class="label label-success">{{ \'ADMIN.NEW\' | translate }}</span></a> <a href="/parent/notifications/{{n.key}}" ng-if="isParent"><span class="margin-right1">{{n.title | htmlToPlaintext}}</span><span ng-if="n.status" class="label label-success">{{ \'ADMIN.NEW\' | translate }}</span></a></li><li class="list-group-item"><h3><a href="/admin/notifications" ng-click="openNotifications()" ng-if="!isParent"><i class="fa fa-cog right"></i> {{ \'ADMIN.SEE-ALL\' | translate }}</a> <a href="/parent/notifications" ng-click="openNotifications()" ng-if="isParent"><i class="fa fa-cog right"></i> {{ \'ADMIN.SEE-ALL\' | translate }}</a></h3></li></ul></div>');
$templateCache.put('app/theme/components/inlineLoader/inlineLoader.html','<div class="inline-loader-wrapper"><div class="loader loader1"></div><div class="loader loader2"></div><div class="loader loader3"></div><div class="loader loader4"></div><div class="loader loader5"></div></div>');
$templateCache.put('app/theme/components/languageSelection/languageSelection.html','<div id="language-selection"><div class="ui compact dropdown" dropdown="" ng-model="ngModel" dropdown-change="languageChanged"><div class="text"><span>{{ languages[ngModel].label }}</span></div><i class="angle down icon"></i><div class="menu"><div class="item" ng-repeat="(key,language) in languages" data-value="{{ key }}"><span>{{ language.label }}</span></div></div></div></div>');
$templateCache.put('app/theme/components/modal/modal.html','<span><div id="modalBody" class="modal swal2-modal fade {{ modalName }} {{modalClass}}" data-ng-class="{\'in swal2-show\': show, \'hide\': !show}"><form class="form-horizontal" ng-submit="submitClick()" ng-if="!hideContentWhenLoading || !loading"><div class="modal-header" ng-if="header"><button type="button" class="close" ng-click="closeClick()">&times;</button><h4 class="swal2-title no-bottom-margin">{{header}}</h4></div><div class="modal-body {{modalBodyClass}}" id="modalBodyinner"><div class="modal-body-content" ng-transclude=""></div><div class="modal-button-container"><input type="submit" class="swal2-confirm btn btn-success btn-sm swal2-styled" value="{{confirmation}}" ng-disabled="loading" ng-if="confirmation !== undefined"> <input type="button" class="swal2-cancel btn btn-default btn-sm swal2-styled" ng-click="closeClick()" value="{{cancel}}"></div></div></form><div class="modal-loader no-overflow" ng-if="loading"><div class="modal-loader-wrapper"><div class="loader loader1"></div><div class="loader loader2"></div><div class="loader loader3"></div><div class="loader loader4"></div><div class="loader loader5"></div></div></div><div ng-if="hideContentWhenLoading && loading" class="modal-placeholder"></div></div><div class="modal-backdrop fade" ng-click="closeClick()" data-ng-class="{\'in\': show, \'hide\': !show}" style="{{backdropShowStyle}}"></div></span>');
$templateCache.put('app/theme/components/navbarBreadcrumb/navbarBreadcrumb.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><a ng-if="tooltipText" href="#" class="fa fa-question-circle tooltip-icon-large" ng-click="callModalClick()"></a><div ng-include="\'app/theme/components/navbarBreadcrumb/navbarBreadcrumbModal.html\'"></div><ul class="breadcrumb al-breadcrumb"><li><a href="admin/transactions">{{ \'PAGE-TITLES.HOME\' | translate }}</a></li><li ng-if="parentPageTitle"><a href="{{parentPageurl}}">{{ parentPageTitle }}</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/navbarBreadcrumb/navbarBreadcrumbModal.html','<modal modal-name="page-title-modal" header="{{ translate(\'INFORMATION\') }}" show="showPageTitleModal" on-close-click="hidePageTitleModal" cancel="{{ translate(\'CLOSE\') }}" id="pageTitleModal"><div class="fields"><div class="ui info message show"><p>{{ tooltipText }}</p></div></div></modal>');
$templateCache.put('app/theme/components/newModal/newModal.html','<div class="ui modal newModal {{ size }}"><i class="close icon"></i><div class="header">{{ header }}</div><div class="modal-body-content" ng-transclude=""></div><div class="actions"><div class="ui black deny button">{{ cancelText }}</div><div class="ui positive right labeled icon button" ng-if="submit" ng-click="submitClick()">{{ submitText }} <i class="checkmark icon"></i></div></div></div>');
$templateCache.put('app/theme/components/notificationMessage/notificationMessage.html','<div class="notification-message-container"><div class="notification-message alert alert-{{ngModel.status}}" ng-show="ngModel.show"><span><b>{{ngModel.header}}</b></span><br class="visible-xs"><span class="notification-message-text" ng-bind-html="ngModel.currentMessageHtml()"></span></div></div>');
$templateCache.put('app/theme/components/pageLoader/pageLoader.html','<div id="form-loader" class="text-center wrapper" ng-if="show"><div id="loader-wrapper"><div class="loader loader1"></div><div class="loader loader2"></div><div class="loader loader3"></div><div class="loader loader4"></div><div class="loader loader5"></div></div></div>');
$templateCache.put('app/theme/components/pageResultsSummary/pageResultsSummary.html','<div class="page-results-summary" ng-show="ngModel.noOfPages || (ngModel.pagination.item_count > 0 && !ngModel.pagination.total)"><div class="row"><div class="page-results-summary-col col-sm-6 text-left"><div class="page-results-summary-text small"><b ng-if="ngModel.pagination.total">{{ \'COMPONENTS.PAGERESULTSUMMARY.DISPLAY\' | translate: {resultsStartNo: ngModel.resultsStartNo, resultsEndNo: ngModel.resultsEndNo, total: ngModel.pagination.total} }}</b> <b ng-if="!ngModel.pagination.total">{{ \'COMPONENTS.PAGERESULTSUMMARY.DISPLAY-WITHOUT-TOTAL\' | translate: {resultsStartNo: ngModel.resultsStartNo, resultsEndNo: ((ngModel.pagination.current_page - 1)* ngModel.pagination.limit) + ngModel.pagination.item_count} }}</b></div></div><div class="page-results-summary-col col-sm-6 text-right"><pagination ng-model="ngModel" on-page-click="onPageClick" on-entry-change="onEntryChange"></pagination></div></div></div>');
$templateCache.put('app/theme/components/pagination/pagination.html','<div class="ui right floated pagination menu tiny" ng-if="(ngModel.currentPage && ngModel.noOfPages > 1) || (!ngModel.pagination.total && ngModel.pagination.current_page && pageNumbers.length > 1)"><div class="icon item" ng-if="ngModel.noOfPages > 4"><a ng-click="goToFirstPage($event)" ng-if="ngModel.currentPage != 1"><i class="fa fa-fast-backward"></i></a> <span class="gray-text" ng-if="ngModel.currentPage === 1"><i class="fa fa-fast-backward"></i></span></div><div class="icon item" ng-if="ngModel.noOfPages > 4"><a ng-if="ngModel.currentPage - 4 >= 1" ng-click="prevTenPageClick($event)" title="{{ \'PAGINATION.GO-TO-PREVIOUS-FOUR-PAGES\' | translate }}"><i class="fa fa-backward"></i></a> <span class="gray-text" ng-if="ngModel.currentPage - 4 < 1"><i class="fa fa-backward"></i></span></div><div class="icon item" ng-if="ngModel.currentPage > 1 && !ngModel.pagination.total"><a ng-click="pageClick($event, ngModel.currentPage - 1)" title="{{ \'PAGINATION.GO-TO-PREVIOUS-PAGE\' | translate }}"><i class="fa fa-backward"></i></a></div><a ng-repeat="pageNo in pageNumbers" title="{{ \'PAGINATION.GO-TO-PAGE\' | translate:{ page: pageNo } }}" ng-class="{ active: pageNo == ngModel.currentPage }" ng-click="pageClick($event, pageNo)" class="item pointer">{{pageNo}}</a><div class="icon item" ng-if="ngModel.pagination.next && !ngModel.pagination.total"><a ng-click="pageClick($event, ngModel.currentPage + 1)" title="{{ \'PAGINATION.GO-TO-NEXT-PAGE\' | translate }}"><i class="fa fa-forward"></i></a></div><div class="icon item" ng-if="ngModel.noOfPages > 4"><a ng-if="ngModel.currentPage <= ngModel.noOfPages - 4" ng-click="nextTenPageClick($event)" title="{{ \'PAGINATION.GO-TO-NEXT-FOUR-PAGES\' | translate }}"><i class="fa fa-forward"></i></a> <span class="gray-text" ng-if="ngModel.currentPage > ngModel.noOfPages - 4"><i class="fa fa-forward"></i></span></div><div class="icon item" ng-if="ngModel.noOfPages > 4"><a ng-click="goToLastPage($event)" ng-if="ngModel.currentPage != ngModel.noOfPages"><i class="fa fa-fast-forward"></i></a> <span class="gray-text" ng-if="ngModel.currentPage === ngModel.noOfPages"><i class="fa fa-fast-forward"></i></span></div></div>');
$templateCache.put('app/theme/components/peakRule/peakRule.html','<div class="panel clearfix" ng-class="{\'panel-default\': selectedRule !== key, \'panel-info\': selectedRule === key}" ng-if="ngModel"><div class="panel-heading"><ul class="panel-btn"><li ng-if="selectedRule === key"><i class="fa fa-download edit-button btn btn-success btn-xs" ng-class="{\'disabled\': !hasChanged}" ng-click="save(ngModel, key)"></i></li><li ng-if="selectedRule === key"><i class="fa fa-trash edit-button btn btn-danger btn-xs" ng-click="remove(key)"></i></li><li ng-if="selectedRule !== key"><i class="fa fa-pencil edit-button btn btn-warning btn-xs" ng-click="editClick(key)"></i></li></ul><h4 class="panel-title">{{ (\'PRODUCTS.PRICING-PERIODS.NEW-RULE-NAME\' | translate: {\'name\': ngModel.name}) || (\'PRODUCTS.PRICING-PERIODS.NEW-RULE\' | translate) }}</h4></div><div class="panel-body"><p ng-if="ngModel.days">On <span ng-repeat="day in ngModel.days track by $index">{{ngModel.days.length > 1 && !$first ? ($last ? " and " : ", ") : ""}}{{\'PRODUCTS.PRICING-PERIODS.\' + day | translate }}</span></p><p ng-if="ngModel.time_periods.length > 0">{{ \'PRODUCTS.PRICING-PERIODS.PEAK-HOURS-SET\' | translate }}<br><span ng-repeat="peak in ngModel.time_periods"><i>{{peak.start_time}}</i>&nbsp;-&nbsp;<i>{{peak.finish_time}}</i><br ng-if="ngModel.time_periods.length > 1 && !$last"></span></p><p></p></div></div>');
$templateCache.put('app/theme/components/popup/cookie-popup.html','<div class="has-text-white has-background-black navbar--cookie is-fixed-bottom" ng-class="{\'is-active\': displayPopup}" ng-if="displayPopup"><div class="container"><div class="row"><div class="col-xs-10"><span class="content"><p ng-bind-html="translate(\'ADMIN.COOKIE-POPUP\')"></p></span></div><div class="col-xs-2"><button ng-click="consent()" class="btn btn-default btn-lg"><strong>{{ \'ADMIN.ACCEPT\' | translate }}</strong></button></div></div></div></div>');
$templateCache.put('app/theme/components/rightbar/rightbar.html','<div class="littlepay-page-rightbar" ng-controller="RightbarCtrl"><div class="profile rightbar clearfix"><ul><li class="title"><i class="fa fa-exchange fw"></i> Accounts</li></ul></div><div><ul><li><input type="text" id="participant-filter" class="filter" ng-model="filterText" ng-keyup="filterParticipants($event)" placeholder="Filter..." autocomplete="false"></li><li ng-repeat="account in availableParticipants"><a ng-click="changeAccount(account)" ng-if="!account.hide" ng-class="{selected: account.id == profile.account.name}"><i class="fa fa-user margin-right1"></i><b>{{ account.name }}</b></a><ul ng-if="account.children.length>0"><li ng-repeat="child in account.children"><a ng-click="changeAccount(child)" ng-if="!child.hide" ng-class="{selected: child.id == profile.account.name}">{{ child.name }}</a></li></ul></li></ul></div></div><div class="overlay-rightbar" ng-click="rightBarCollapse()"></div>');
$templateCache.put('app/theme/components/selectDropdown/selectDropdown.html','<div class="dropdown-container" ng-class="{ show: listVisible }"><div class="dropdown-display" ng-class="{ clicked: listVisible }"><span class="placeholder target" ng-if="isPlaceholder">{{placeholder}}</span> <span class="target" ng-if="!isPlaceholder">{{display}}</span> <i class="fa" ng-class="{\'fa-angle-down\': !listVisible, \'fa-angle-up\': listVisible}"></i></div><div class="dropdown-list"><div><div ng-repeat="(item, key) in list" ng-click="select(item)" ng-class="{ selected: item === selected }"><span>{{ key !== undefined ? key : item }}</span></div></div></div></div>');
$templateCache.put('app/theme/components/selectProducts/selectProducts.html','<select name="participant_ids" id="select-products" multiple="" default-text="{{\'PRODUCTS.CAPPING.SELECT-PRODUCTS\' | translate}}" ng-model="ngModel" class="ui fluid search dropdown multiple" dropdown="" dropdown-change="checkValidity()" has-error="isProductsFieldEmpty"><option ng-repeat="product in allProducts" value="{{product.id}}">{{ product.description }} {{ getScheduleStatus(product) }}</option></select>');
$templateCache.put('app/theme/components/summarybox/summarybox.html','<div class="column summary-column summary-box"><div class="ui segment"><div class="summary-header"><h3>{{boxTitle}} <i ng-if="boxTooltip !== undefined" class="fa fa-question-circle tooltip-icon" tooltip-side="bottom" tooltips="" tooltip-template="{{ boxTooltip }}"></i></h3></div><div class="clearfix current-summary"><div class="ui horizontal statistic {{currentValueStyle}}"><div class="value">{{formatValue(summaryModel.current)}}</div><div class="label" ng-if="showGrowth(summaryModel)"><span class="ui header {{summaryModel.growth < 0 ? \'red\': \'green\'}}"><i class="arrow icon {{summaryModel.growth < 0 ? \'down\': \'up\'}}"></i> {{summaryModel.growth | number:1 }}%</span></div></div></div><div class="clearfix previous-summary"><div class="ui horizontal statistic mini grey"><div tooltips="" tooltip-template="{{getPreviousPeriodTooltip()}}" tooltip-side="bottom left aligned" tooltip-class="analytics-previous-tooltip">{{ \'ANALYSIS.TRANSACTIONS.PREVIOUS\' | translate }}: {{formatValue(summaryModel.previous)}}</div></div></div></div></div>');
$templateCache.put('app/theme/components/tableSort/tableSort.html','<a ng-click="onClick()" class="sortableColumn" ng-class="{\'inactive\': order !== by}"><span ng-transclude=""></span> <i class="sort icon" ng-class="{\'up\': order === by && !reverse, \'down\' : order===by && reverse}"></i></a>');
$templateCache.put('app/theme/components/timeline/timeline.html','<div class="ui selection floating dropdown labeled icon button right top pointing big" dropdown="" ng-model="ngModel" dropdown-change="updateTimeLine"><span class="text"><h4 class="ui blue header timeline-header">{{timelineOptions[ngModel].name}}</h4><span class="ui small">{{timelineOptions[ngModel].start_date | date:\'dd/MM/yyyy\'}} - {{timelineOptions[ngModel].end_date | date:\'dd/MM/yyyy\'}}</span></span> <i class="calendar alternate outline icon"></i><div class="menu"><div class="item" ng-repeat="(key,timelineOption) in timelineOptions" data-value="{{$index}}" ng-class="{\'disabled\': available.indexOf(key) === -1}"><h4 class="ui blue header timeline-header">{{timelineOption.name}}</h4><span class="ui small">{{timelineOption.start_date | date:\'dd/MM/yyyy\'}} - {{timelineOption.end_date | date:\'dd/MM/yyyy\'}}</span></div></div></div>');
$templateCache.put('app/theme/components/timezoneSelector/timezoneSelector.html','<div id="entryChangeDropdown" class="ui search selection dropdown"><i class="dropdown icon"></i><div class="text">{{ngModel || \'Please select\' }}</div><div class="menu"></div></div>');
$templateCache.put('app/theme/components/sidebar/sidebar.html','<aside class="al-sidebar" ng-swipe-right="$sidebarService.setMenuCollapsed(false)" ng-swipe-left="$sidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop" ng-style="{top:ctrlWarnGap + \'px\' }"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in getMenuItems()" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" lp-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span translate="{{::item.title}}"></span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" lp-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span translate="{{::item.title}}"></span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" lp-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" lp-sidebar-toggling-item="subitem" class="sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" lp-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link" title="{{subitem.description}}"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" lp-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="subSubitem.disabled" class="al-sidebar-list-link" translate="{{::subSubitem.title}}" title="{{subSubitem.description}}"></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}" translate="{{::subSubitem.title}}" title="{{subSubitem.description}}"></a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="(!subitem.subMenu && subitem.disabled)" class="disabled" translate="{{::subitem.title}}" title="{{subitem.description}}"></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}" translate="{{::subitem.title}}" title="{{subitem.description}}"></a></li></ul></li><li class="al-sidebar-list-item"><a ng-mouseenter="hoverItem($event, item)" class="al-sidebar-list-link" ng-click="logout()"><i class="ion-log-out"></i><span>{{ \'PAGE-TITLES.LOGOUT\' | translate }}</span></a></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/pages/admin/analysis/corrections/corrections.html','<div ng-switch="vm.pageState"><div ng-switch-when="ready"><div class="ui clearing segment basic analytics-filters"><currency-picker ng-model="analyticsConfig.selectedCurrencyCode" currency-codes="analyticsConfig.currencyCodes" on-change="vm.getCorrectionsData"></currency-picker><date-range-picker2 ng-model="analyticsConfig.selectedDateRange" on-date-change="vm.getCorrectionsData" min-date="analyticsConfig.minStartDate" max-date="analyticsConfig.maxEndDate" max-days="90" week-mode="vm.datePickerOptions.weekMode" first-day-of-week="vm.datePickerOptions.firstDayOfWeek" custom-options="vm.datePickerOptions.customOptions" align="right"></date-range-picker2></div><div class="ui segment basic clearing no-top-padding-margin margin-bottom"><div include-with-scope="app/pages/admin/analysis/corrections/widgets/summarySection.html"></div><div class="ui segments"><div class="ui segment" ng-class="{\'loading\': vm.loading}"><div include-with-scope="app/pages/admin/analysis/corrections/widgets/filtersSection.html"></div><div class="chart-wrapper"><div class="hc-chart" options="vm.chartOptions"></div></div><div ng-if="vm.hasNoData() && !vm.loading" class="no_graph_data">{{ translate(\'NO-DATA-FOUND-FOR-FILTERS\') }}</div></div></div><div class="margin-top" include-with-scope="app/pages/admin/analysis/corrections/widgets/correctionsData.html"></div></div></div><div ng-switch-when="no_data" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'NO-DATA-FOUND-FOR-PARTICIPANT\') }}</h4></div></div><div ng-switch-when="loading" class="wrapper"><div class="ui segment clearing"><page-loader show="true"></page-loader></div></div><div ng-switch-when="error_permissions" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'YOU-DO-NOT-HAVE-PERMISSION\') }}</h4></div></div></div>');
$templateCache.put('app/pages/admin/analysis/customers/customers.html','<div ng-switch="vm.pageState"><div ng-switch-when="ready"><div class="ui segment basic clearing analytics-filters"><currency-picker ng-model="analyticsConfig.selectedCurrencyCode" currency-codes="analyticsConfig.currencyCodes" on-change="vm.getCustomersData"></currency-picker><date-range-picker2 ng-model="analyticsConfig.selectedDateRange" on-date-change="vm.getCustomersData" min-date="analyticsConfig.minStartDate" max-date="analyticsConfig.maxEndDate" max-days="90" week-mode="vm.datePickerOptions.weekMode" first-day-of-week="vm.datePickerOptions.firstDayOfWeek" custom-options="vm.datePickerOptions.customOptions" align="right"></date-range-picker2></div><div class="ui segment basic clearing no-top-padding-margin margin-bottom"><div include-with-scope="app/pages/admin/analysis/customers/widgets/summarySection.html"></div><div class="ui segments"><div class="ui segment" ng-class="{\'loading\': vm.loading}"><div include-with-scope="app/pages/admin/analysis/customers/widgets/filtersSection.html"></div><div class="chart-wrapper"><div class="hc-chart" options="vm.chartOptions" ng-if="!vm.hasNoGraphData() || vm.loading"></div></div><div ng-if="vm.hasNoGraphData() && !vm.loading" class="no_graph_data_block">{{ translate(\'NO-DATA-FOUND-FOR-FILTERS\') }}</div></div></div><div class="margin-top" ng-if="vm.selectedGraph.id === \'new_vs_returning\'" include-with-scope="app/pages/admin/analysis/customers/widgets/returningVsNew/section.html"></div><div class="margin-top" ng-if="vm.selectedGraph.id === \'capped_vs_uncapped\'" include-with-scope="app/pages/admin/analysis/customers/widgets/cappedVsUncapped/section.html"></div></div></div><div ng-switch-when="no_data" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'NO-DATA-FOUND-FOR-PARTICIPANT\') }}</h4></div></div><div ng-switch-when="loading" class="wrapper"><div class="ui segment clearing"><page-loader show="true"></page-loader></div></div><div ng-switch-when="error_permissions" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'YOU-DO-NOT-HAVE-PERMISSION\') }}</h4></div></div></div>');
$templateCache.put('app/pages/admin/analysis/customreports/customreports.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Custom Reports</title></head><body><div id="dashboards"><div id="dashboard_list" class="dashboard_list"><div ng-if="vm.dashboardsList" style="display: flex; margin: 0 0 0 10px;"><div class="item" ng-repeat="dashboardItem in vm.dashboardsList" style="margin: 0 10px 10px 0;"><a href="#" class="btn btn-primary btn-xs" ng-click="vm.loadEmbedUrl(dashboardItem.id)">{{(dashboardItem.name).includes(\'/\') ? ((dashboardItem.name).substr(((dashboardItem.name).indexOf(\'/\') + 1))) : dashboardItem.name}}</a></div></div></div><div ng-if="vm.iframe_src" id="dashboard_embed_frame" class="dashboard_embed_frame"><iframe name="qs_embeded_frame" ng-src="{{vm.iframe_src}}" style="width: 100%; min-height: 1000px;"></iframe></div></div></body></html>');
$templateCache.put('app/pages/admin/analysis/debtRecovery/debtRecovery.html','<div ng-switch="vm.pageState"><div ng-switch-when="ready"><div class="ui clearing segment basic analytics-filters no-summary-boxes"><currency-picker ng-model="analyticsConfig.selectedCurrencyCode" currency-codes="analyticsConfig.currencyCodes" on-change="vm.getDebtRecoveryData"></currency-picker><date-range-picker2 ng-model="analyticsConfig.selectedDateRange" on-date-change="vm.getDebtRecoveryData" min-date="analyticsConfig.minStartDate" max-date="analyticsConfig.maxEndDate" max-days="90" week-mode="vm.datePickerOptions.weekMode" first-day-of-week="vm.datePickerOptions.firstDayOfWeek" custom-options="vm.datePickerOptions.customOptions" align="right"></date-range-picker2></div><div class="ui segment basic clearing no-top-padding-margin margin-bottom"><div class="ui segments"><div class="ui segment" ng-class="{\'loading\': vm.loading}"><div include-with-scope="app/pages/admin/analysis/debtRecovery/widgets/filtersSection.html"></div><div class="chart-wrapper"><div class="hc-chart" options="vm.chartOptions"></div></div><div ng-if="vm.hasNoData() && !vm.loading" class="no_graph_data">{{ translate(\'NO-DATA-FOUND\') }}</div></div></div><div include-with-scope="app/pages/admin/analysis/debtRecovery/widgets/debtRecoveryData.html"></div></div></div><div ng-switch-when="no_data" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'NO-DATA-FOUND-PARTICIPANT\') }}</h4></div></div><div ng-switch-when="loading" class="wrapper"><div class="ui segment clearing"><page-loader show="true"></page-loader></div></div><div ng-switch-when="error_permissions" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'NO-PERMISSION\') }}</h4></div></div></div>');
$templateCache.put('app/pages/admin/analysis/declines/declines.html','<div ng-switch="vm.pageState"><div ng-switch-when="ready"><div class="ui segment basic clearing analytics-filters no-summary-boxes"><currency-picker ng-model="analyticsConfig.selectedCurrencyCode" currency-codes="analyticsConfig.currencyCodes" on-change="vm.getDeclinesData"></currency-picker><date-range-picker2 ng-model="analyticsConfig.selectedDateRange" on-date-change="vm.getDeclinesData" min-date="analyticsConfig.minStartDate" max-date="analyticsConfig.maxEndDate" max-days="90" week-mode="vm.datePickerOptions.weekMode" first-day-of-week="vm.datePickerOptions.firstDayOfWeek" custom-options="vm.datePickerOptions.customOptions" align="right"></date-range-picker2></div><div class="ui segment basic clearing no-top-padding-margin margin-bottom"><div class="ui segments"><div class="ui segment" ng-class="{\'loading\': vm.loading}"><div include-with-scope="app/pages/admin/analysis/declines/widgets/filtersSection.html"></div><div class="chart-wrapper"><div class="hc-chart" options="vm.chartOptions" language="profile.language" on-language-change="vm.getDeclinesData"></div></div><div ng-if="vm.hasNoData() && !vm.loading" class="no_graph_data">{{ translate(\'NO-DATA-FOUND-FOR-FILTERS\') }}</div></div></div><div include-with-scope="app/pages/admin/analysis/declines/widgets/declinesData.html"></div></div></div><div ng-switch-when="no_data" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'NO-DATA-FOUND-FOR-PARTICIPANT\') }}</h4></div></div><div ng-switch-when="loading" class="wrapper"><div class="ui segment clearing"><page-loader show="true"></page-loader></div></div><div ng-switch-when="error_permissions" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'YOU-DO-NOT-HAVE-PERMISSION\') }}</h4></div></div></div>');
$templateCache.put('app/pages/admin/analysis/transactions/transactions.html','<div ng-switch="vm.pageState"><div ng-switch-when="ready"><div class="ui segment basic clearing analytics-filters"><currency-picker ng-model="analyticsConfig.selectedCurrencyCode" currency-codes="analyticsConfig.currencyCodes" on-change="vm.getTransactionsData"></currency-picker><date-range-picker2 ng-model="analyticsConfig.selectedDateRange" on-date-change="vm.getTransactionsData" min-date="analyticsConfig.minStartDate" max-date="analyticsConfig.maxEndDate" max-days="90" week-mode="vm.datePickerOptions.weekMode" first-day-of-week="vm.datePickerOptions.firstDayOfWeek" custom-options="vm.datePickerOptions.customOptions" align="right"></date-range-picker2></div><div class="ui segment basic clearing no-top-padding-margin margin-bottom"><div include-with-scope="app/pages/admin/analysis/transactions/widgets/summarySection.html"></div><div class="ui segments"><div class="ui segment" ng-class="{\'loading\': vm.loading}"><div include-with-scope="app/pages/admin/analysis/transactions/widgets/filtersSection.html"></div><div class="chart-wrapper"><div class="hc-chart" options="vm.chartOptions" id="transactionsChart" language="profile.language" on-language-change="vm.getTransactionsData"></div></div><div ng-if="vm.hasNoGraphData() && !vm.loading" class="no_graph_data">{{ translate(\'NO-DATA-FOUND\') }}</div></div></div><div class="margin-top" include-with-scope="app/pages/admin/analysis/transactions/widgets/transactionsData.html"></div></div></div><div ng-switch-when="no_data" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'NO-DATA-FOUND-FOR-PARTICIPANT\') }}</h4></div></div><div ng-switch-when="loading" class="wrapper"><div class="ui segment clearing"><page-loader show="true"></page-loader></div></div><div ng-switch-when="error_permissions" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'YOU-DO-NOT-HAVE-PERMISSION\') }}</h4></div></div></div>');
$templateCache.put('app/pages/admin/corrections/correctionRequests/correctionRequests.html','<div class="wrapper" ng-show="!pageLoading"><div class="ui segments"><div class="segment clearing ui tableFilters"><entry-change ng-model="refundModel" on-entry-change="onEntryChange"></entry-change></div><div class="segment ui no-padding" ng-class="{\'loading\': loading}"><table class="ui table"><thead><tr><th class="center aligned">#</th><th class="center aligned">{{ translate(\'CHARGED-AMOUNT\') }}</th><th class="center aligned">{{ translate(\'PROPOSED-AMOUNT\') }}</th><th>{{ translate(\'REFUND-AMOUNT\') }}</th><th>{{ translate(\'CUSTOMER-COMMENT\') }}</th><th>{{ translate(\'REQUEST-TIME\') }}</th><th></th></tr></thead><tbody><tr ng-repeat="refund in refundModel.list"><td data-th="#" class="collapsing center aligned">{{ ((refundModel.currentPage - 1) * refundModel.pagination.limit) + 1 + $index }}</td><td data-th="{{ translate(\'CHARGED-AMOUNT\') }}" class="center aligned">{{ refund.transaction_amount | isoCurrency:refund.currency }}</td><td data-th="{{ translate(\'PROPOSED-AMOUNT\') }}" class="center aligned">{{ (refund.proposed_amount || \'0\') | isoCurrency:refund.currency }}</td><td data-th="{{ translate(\'REFUND-AMOUNT\') }}">{{ (refund.transaction_amount - refund.proposed_amount) | isoCurrency:refund.currency }}</td><td data-th="{{ translate(\'CUSTOMER-COMMENT\') }}">{{ refund.reason }}</td><td data-th="{{ translate(\'REQUEST-TIME\') }}">{{ refund.created_time | date:\'shortDate\' }}<br>{{ refund.created_time | date:\'mediumTime\' }}</td><td data-th="{{ translate(\'ACTIONS\') }}"><div class="ui icon buttons right floated"><a class="ui button blue" ng-href="/admin/customersById/{{ refund.customer_id }}?aggregationId={{refund.aggregation_id}}" title="{{ translate(\'SEE-TRANSACTION\') }}"><i class="fa fa-exchange"></i></a> <a ng-if="hasPermission" title="{{ translate(\'RESPOND-TO-REFUND-REQUEST\') }}" class="ui red button" ng-click="callModalClick(\'showSubmitCorrectionRequestModal\', refund, $index)"><span>{{ translate(\'RESPOND\') }} <i ng-show="processingBtn[$index]" class="fa fa-circle-o-notch fa-spin fa fa-fw"></i> <i ng-show="!processingBtn[$index]" class="fa fa-check-circle fa-fw"></i></span></a></div></td></tr></tbody><tfoot><tr><th colspan="8"><page-results-summary ng-model="refundModel" on-page-click="onPageClick"></page-results-summary><h4 class="ui red" ng-if="refundModel.list.length === 0">{{ translate(\'NO-CORRECTIONS\') }}</h4></th></tr></tfoot></table></div></div></div><modal modal-name="submit-refund-modal" header="{{ translate(\'APPROVE-CORRECTION-REQUEST\') }}" show="showSubmitCorrectionRequestModal" on-close-click="hideRefundModal" on-submit-click="submitRequest" confirmation="{{ translate(\'SUBMIT\') }}" cancel="{{ translate(\'CANCEL\') }}" id="submitCorrectionRequestModal"><div class="form-group" ng-if="refundModel.currentRefund.boarding_stop_id"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'BOARDING-STOP\') }}</label><div class="col-sm-7"><input type="text" class="form-control input-sm" placeholder="{{ refundModel.currentRefund.boarding_stop_id }}" readonly="" disabled=""></div></div><div class="form-group" ng-if="refundModel.currentRefund.alighting_stop_id"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'ALIGHTING-STOP\') }}</label><div class="col-sm-7"><input type="text" class="form-control input-sm" placeholder="{{ refundModel.currentRefund.alighting_stop_id }}" readonly="" disabled=""></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'TRANSACTION-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{refundModel.currentRefund.currency}}</div><input type="text" class="form-control modal-amount-field input-sm" placeholder="0.0" ng-model="refundModel.currentRefund.transaction_amount" readonly="" disabled=""></div></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'PROPOSED-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{refundModel.currentRefund.currency}}</div><input type="text" class="form-control modal-amount-field input-sm" placeholder="0.0" ng-model="refundModel.currentRefund.proposed_amount" readonly="" disabled=""></div></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'REFUND-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{refundModel.currentRefund.currency}}</div><input type="text" class="form-control modal-amount-field input-sm" placeholder="0.0" ng-model="proposedRefund" readonly="" disabled=""></div></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'CUSTOMER-COMMENT\') }}</label><div class="col-sm-7"><textarea class="form-control modal-reason-field" rows="3" placeholder="{{ translate(\'CUSTOMER-COMMENT\') }}" ng-model="refundModel.currentRefund.reason" readonly="" disabled=""></textarea></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'ISSUER-COMMENT\') }}</label><div class="col-sm-7"><textarea class="form-control modal-reason-field" rows="3" placeholder="{{ translate(\'ISSUER-COMMENT\') }}" ng-model="refundModel.currentRefund.issuer_comment"></textarea></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'APPROVAL\') }}</label><div class="col-sm-7"><select ng-model="refundModel.currentRefund.approval" class="form-control"><option value="APPROVED" selected="selected">{{ translate(\'APPROVED\') }}</option><option value="REFUSED">{{ translate(\'REFUSED\') }}</option></select></div></div></modal>');
$templateCache.put('app/pages/admin/corrections/corrections/corrections.html','<div class="wrapper" ng-show="!pageLoading"><div class="ui segments"><div class="segment clearing ui tableFilters"><div class="ui form right floated"><div class="fields"><div class="inline field"><div include-with-scope="app/pages/admin/corrections/corrections/widgets/statusFilter.html"></div></div><div class="inline field"><div include-with-scope="app/pages/admin/corrections/corrections/widgets/initiatorFilter.html"></div></div></div></div><entry-change ng-model="refundModel" on-entry-change="onEntryChange"></entry-change></div><div class="segment ui no-padding" ng-class="{\'loading\': loading}"><table class="ui table"><thead><tr><th class="center aligned">#</th><th class="center aligned">{{ translate(\'CHARGED-AMOUNT\') }}</th><th class="center aligned">{{ translate(\'REFUND-AMOUNT\') }}</th><th>{{ translate(\'STATUS\') }}</th><th>{{ translate(\'UPDATED-TIME\') }}</th><th>{{ translate(\'CUSTOMER-COMMENT\') }}</th><th>{{ translate(\'ISSUER-COMMENT\') }}</th><th></th></tr></thead><tbody><tr ng-repeat="refund in refundModel.list"><td data-th="#" class="collapsing center aligned">{{ ((refundModel.currentPage - 1) * refundModel.pagination.limit) + 1 + $index }}</td><td data-th="{{ translate(\'CHARGED-AMOUNT\') }}" class="center aligned">{{ refund.transaction_amount | isoCurrency:refund.currency }}</td><td data-th="{{ translate(\'PROPOSED-AMOUNT\') }}" class="center aligned">{{ (refund.refund_amount || \'0\' ) | isoCurrency:refund.currency }}</td><td data-th="Status"><span class="label" ng-class="{ \'label-warning\': refund.approval === \'AWAITING\', \'label-success\': refund.approval === \'APPROVED\', \'label-danger\': refund.approval === \'REFUSED\' }">{{ \'REFUNDSTATUS.\' + refund.approval | translate }}</span> <span class="label" ng-if="refund.approval !== \'REFUSED\'" ng-class="{ \'label-warning\': refund.status === \'CREATED\' || refund.status === \'ADJUSTED\', \'label-success\': refund.status === \'SETTLED\', \'label-danger\': refund.status === \'REJECTED\', \'label-info\': refund.status === \'SENT_FOR_SETTLEMENT\' || refund.status === \'SENT_FOR_ADJUSTMENT\' }">{{ \'REFUNDSTATUS.\' +(refund.status | replaceUnderscoreWithDash) | translate }}</span> <span ng-if="refund.multi_operator" class="label label-default margin-right1">{{ \'GUARANTEESTATUS.MULTI-OP\' | translate }}</span></td><td data-th="{{ translate(\'REQUEST-TIME\') }}">{{ refund.created_time | date:\'shortDate\' }}<br>{{ refund.created_time | date:\'mediumTime\' }}</td><td data-th="{{ translate(\'CUSTOMER-COMMENT\') }}">{{ refund.reason }}</td><td data-th="{{ translate(\'ISSUER-COMMENT\') }}"><b>{{ refund.issuer }}</b><br>{{ refund.issuer_comment }}</td><td data-th="{{ translate(\'CUSTOMER\') }}" class="table-action table-action-sm edit divTableCell"><a class="ui icon button basic blue" ng-href="/admin/customersById/{{ refund.customer_id }}" title="{{ translate(\'SEE-CUSTOMER\') }}"><i class="fa fa-user"></i></a></td></tr></tbody><tfoot><tr><th colspan="8"><page-results-summary ng-model="refundModel" on-page-click="onPageClick"></page-results-summary><h4 class="ui red" ng-if="refundModel.list.length === 0">{{ translate(\'NO-CORRECTION-HAVE-FOUND\') }}</h4></th></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/admin/corrections/makeCorrection/makeCorrection.html','<div class="wrapper wrapper-white" ng-show="!pageLoading"><div class="page-subtitle"><h3>{{ translate(\'SEARCH-TRANSACTIONS\') }}</h3><p ng-bind-html="translate(\'SEARCH-TRANSACTIONS-LINE\')"></p></div><form ng-submit="searchTransaction()" id="searchCustomerTransactions"><div class="ui stackable doubling celled grid form no-gap"><div class="six column row filtersSection"><div class="column"><div class="field"><label>{{ translate(\'CARD-NUMBER\') }}</label><div class="fields"><div class="nine wide field ui input" ng-class="{\'error\': invalid.cardBin }"><input class="binNo" type="text" placeholder="111111" ng-model="search.cardBin" maxlength="6" ng-paste="pasteJustNumbers($event)" numbers-only=""></div><div class="seven wide field ui input" ng-class="{\'error\': invalid.pan }"><input class="lastNo" type="text" placeholder="1111" ng-model="search.pan" maxlength="4"></div></div></div></div><div class="column"><div class="field"><label>{{ translate(\'CARD-EXPIRY\') }}</label><div class="two fields"><div class="field ui input" ng-class="{\'error\': invalid.expiryMonth }"><input type="text" class="inline expiry" placeholder="{{ translate(\'MONTH\') }}" maxlength="2" ng-model="search.expiryMonth"></div><div class="field ui input" ng-class="{\'error\': invalid.expiryYear }"><input type="text" class="inline expiry" placeholder="{{ translate(\'YEAR\') }}" maxlength="2" ng-model="search.expiryYear"></div></div></div></div><div class="column"><div class="field"><label>{{ translate(\'DATE-FROM\') }}</label><ng-datepicker ng-model="search.fromTime" class="datepicker-field" not-after="toTime"></ng-datepicker></div></div><div class="column"><div class="field"><label>{{ translate(\'DATE-TO\') }}</label><ng-datepicker ng-model="search.toTime" class="datepicker-field" not-before="search.fromTime"></ng-datepicker></div></div><div class="column"><div class="field"><label>{{ translate(\'TRANSACTION-AMOUNT\') }}</label> <input class="small-input form-control" placeholder="$$$" ng-model="search.amount"></div></div><div class="column"><div class="field"><label>&nbsp;</label><div class="ui buttons fluid"><button type="submit" class="ui positive button">{{ translate(\'SEARCH\') }}</button> <a class="ui red basic button" ng-click="resetForm()">{{ translate(\'CLEAR\') }}</a></div></div></div></div></div></form></div><div class="wrapper" ng-show="transactionsFound"><div class="ui segments"><div class="segment clearing ui tableFilters"><entry-change ng-model="transactionModel" on-entry-change="onEntryChange"></entry-change></div><div class="segment ui no-padding" ng-class="{\'loading\': !loading.hasLoaded}"><table class="ui table"><thead><tr class="header"><th class="center aligned">#</th><th>{{ translate(\'TAP-TIME\') }}</th><th>{{ translate(\'AMOUNT\') }}</th><th>{{ translate(\'DESCRIPTION\') }}</th><th>{{ translate(\'PURCHASE\') }}</th><th>{{ translate(\'LOCATION\') }}</th><th>{{ translate(\'TRANSACTION-STATUS\') }}</th><th>{{ translate(\'CUSTOMER-ID\') }}</th><th ng-if="hasPermission"></th></tr></thead><tbody><tr ng-if="transactionModel.allTransactions.length > 0" ng-repeat="transaction in transactionModel.allTransactions" ng-click="seeTransaction($event,transaction)"><td data-th="#" class="collapsing center aligned">{{$index+1}}</td><td data-th="{{ translate(\'TAP-TIME\') }}" ng-show="transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time"><div>{{ transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time | date:\'shortDate\'}}</div><div>{{ transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time | date:\'mediumTime\'}}</div></td><td data-th="{{ translate(\'TAP-TIME\') }}" ng-show="!transaction.micropayment.taps[transaction.micropayment.taps.length - 1].tap_time"><div>{{ transaction.micropayment.updated_time | date:\'shortDate\'}}</div><div>{{ transaction.micropayment.updated_time | date:\'mediumTime\'}}</div></td><td data-th="{{ translate(\'AMOUNT\') }}">{{ transaction.micropayment.amount | isoCurrency:transaction.micropayment.currency }}</td><td data-th="{{ translate(\'DESCRIPTION\') }}"><i class="fa fa-fw fa-bus"></i>{{ translate(transaction.micropayment.taps[transaction.micropayment.taps.length - 1].description | uppercase) }}</td><td data-th="{{ translate(\'PURCHASE\') }}" ng-show="transaction.micropayment.purchases[0].description">{{ transaction.micropayment.purchases[0].description }}</td><td data-th="{{ translate(\'PURCHASE\') }}" ng-show="!transaction.micropayment.purchases[0].description"><b class="text-danger">{{ translate(\'CREDIT\') }}</b></td><td data-th="{{ translate(\'LOCATION\') }}"><ul class="micropaymentList" ng-if="transaction.micropayment.taps.length > 0"><li class="from" ng-repeat="tap in transaction.micropayment.taps" ng-show="tap.location"><tap-location ng-model="tap"></tap-location><small ng-if="transaction.micropayment.taps.length>1"><short-medium-date-time ng-model="tap.tap_time"></short-medium-date-time></small></li><li ng-if="transaction.micropayment.charge_type === \'incomplete_variable_fare\'" class="incomplete"><p>{{ translate(\'INCOMPLETE\') }}</p></li></ul></td><td data-th="{{ translate(\'TRANSACTION-STATUS\') }}" class="divTableCell"><payment-guarantee-status-label ng-model="transaction"></payment-guarantee-status-label><span ng-if="transaction.settlement_status" class="label label-{{transaction.settlement_status | lowercase}}">{{ (\'GUARANTEESTATUS.\' + transaction.settlement_status ) | translate }}</span> <span class="label label-warning" ng-if="isAdjusted(transaction.micropayment.adjustments)">{{ translate(\'ADJUSTED\') }}</span> <span class="label" ng-class="{\'label-success\': transaction.aggregation_status === \'CLOSED\', \'label-warning\': transaction.aggregation_status === \'SUSPENDED\'}">{{ translate(transaction.aggregation_status) }}</span> <span class="label label-incomplete" ng-if="transaction.micropayment.charge_type === \'incomplete_variable_fare\'">{{ translate(\'INCOMPLETE\') }}</span></td><td data-th="{{ translate(\'CUSTOMER-ID\') }}" class="divTableCell"><a href="/admin/customersById/{{ transaction.customer_id }}">{{ transaction.customer_id }}</a></td><td data-th="{{ translate(\'CUSTOMER-ID\') }}" class="text-center divTableCell" ng-if="hasPermission"><a href="#" class="btn btn-warning btn-sm" ng-click="callModalClick(\'showSubmitRefundModal\', transaction, null, null)">{{ translate(\'CREDIT\') }}</a></td></tr></tbody><tfoot><tr><th colspan="9"><h4 class="ui red" ng-if="(!transactionModel.allTransactions || transactionModel.allTransactions.length === 0) && loading.hasLoaded">{{ translate(\'NO-TRANSACTIONS-FOUND\') }}</h4></th></tr></tfoot></table></div></div><div ng-include="\'app/pages/admin/corrections/makeCorrection/makeCorrectionModal.html\'"></div></div>');
$templateCache.put('app/pages/admin/corrections/makeCorrection/makeCorrectionModal.html','<modal modal-name="submit-refund-modal" header="{{ translate(\'SUBMIT-CORRECTION-REQUEST\') }}" show="showSubmitRefundModal" on-close-click="hideRefundModal" on-submit-click="addRefundClick" confirmation="{{ translate(\'SUBMIT\') }}" cancel="{{ translate(\'CANCEL\') }}" id="submitRefundModal" loading="refundLoading"><notification-message ng-model="refundNotificationMessage"></notification-message><div class="form-group"><label class="col-sm-5 control-label modal-customer-label">{{ translate(\'CHARGED-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{refundModel.currentRefund.currency}}</div><input type="text" class="form-control modal-amount-field" placeholder="0.0" ng-model="refundModel.currentRefund.transaction_amount" readonly="" disabled=""></div></div></div><div class="form-group" ng-class="{\'has-error\': invalidRefund.refundAmount, \'has-feedback\': invalidRefund.refundAmount }"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'REFUND-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{refundModel.currentRefund.currency}}</div><input type="text" class="form-control modal-amount-field" placeholder="0.0" ng-model="refundModel.currentRefund.refund_amount"></div><span class="glyphicon icon-cross form-control-feedback" ng-show="invalidRefund.refundAmount" aria-hidden="true"></span></div></div><div class="form-group" ng-class="{\'has-error\': invalidRefund.reason, \'has-feedback\': invalidRefund.reason }"><label class="col-sm-5 control-label modal-reason-label">{{ translate(\'CUSTOMER-COMMENT\') }}</label><div class="col-sm-7"><textarea class="form-control modal-reason-field" rows="3" placeholder="{{ translate(\'CUSTOMER-COMMENT\') }}" ng-model="refundModel.currentRefund.reason"></textarea></div></div><div class="form-group" ng-class="{\'has-error\': invalidRefund.reason, \'has-feedback\': invalidRefund.reason }"><label class="col-sm-5 control-label modal-reason-label">{{ translate(\'ISSUER-COMMENT\') }}</label><div class="col-sm-7"><textarea class="form-control modal-reason-field" rows="3" placeholder="{{ translate(\'ISSUER-COMMENT\') }}" ng-model="refundModel.currentRefund.issuer_comment"></textarea></div></div></modal>');
$templateCache.put('app/pages/admin/customers/customerSummary/customerSummary.html','<div class="wrapper wrapper-white" ng-if="!isReceipt"><div class="row"><div class="col-sm-9"><table class="summaryTable"><tbody><tr><td class="header text-right">{{ translate(\'CUSTOMER-ID\') }}</td><td>{{vm.customerModel.currentCustomer.customer_id}}</td></tr><tr><td class="header text-right">{{ translate(\'CUSTOMER-REF\') }}</td><td>{{vm.customerModel.currentCustomer.customer_ref || translate(\'NO-REFERANCE\') }}</td></tr><tr><td class="header text-right">{{ translate(\'PRIMARY-CARD\') }}</td><td><i class="fa fa-credit-card"></i><span class="masked-no">{{vm.customerModel.currentCustomer.primary_masked_pan}}</span></td></tr><tr><td class="header text-right">{{ translate(\'CREATED-AT\') }}</td><td>{{vm.customerModel.currentCustomer.created_date | date:\'short\'}}</td></tr></tbody></table></div><div class="col-sm-3"><div class="clearfix"><span class="customer-status pull-right"><span class="model-status model-status-{{vm.customerModel.currentCustomer.status | lowercase }}"></span> {{ translate(vm.customerModel.currentCustomer.status | replaceUnderscoreWithDash) }}</span> <span class="customer-status pull-right"><span class="model-status model-status-{{vm.customerModel.currentCustomer.status | lowercase }}" ng-class="{\'model-status-active\': vm.customerModel.currentCustomer.is_registered, \'model-status-inactive\': !vm.customerModel.currentCustomer.is_registered}"></span> {{ translate(vm.customerModel.currentCustomer.is_registered | toRegisteredOrNot) }}</span></div><div class="clearfix"><a class="pull-right customer-status btn1 pull-right" ng-csv="vm.getCustomerCSV(vm.customerModel.currentCustomer.id)" filename="{{vm.getCustomerCSVFilename()}}" csv-label="true" lazy-load="true" ng-click="vm.trackCSVDownload()"><i class="fa fa-download fa-fw"></i>{{ translate(\'CUSTOMER-STATEMENT\') }}</a></div><div class="clearfix" ng-if="feature_flags.ReceiptGeneration"><a class="pull-right customer-status btn1 pull-right" ng-click="vm.showModal(\'printReceiptModal\')"><i class="fa fa-download fa-fw"></i>{{ translate(\'INVOICE.GET-RECEIPT\') }}</a></div></div></div><ul class="customerTabs clearfix"><li ui-sref-active="active"><a ui-sref="admin.customerSummary.transactions">{{ translate(\'TRANSACTIONS\') }}</a></li><li ui-sref-active="active"><a ui-sref="admin.customerSummary.cards">{{ translate(\'CARDS\') }}</a></li><li ui-sref-active="active"><a ui-sref="admin.customerSummary.refunds">{{ translate(\'REFUNDS\') }}</a></li></ul></div><div class="wrapper" id="tabsSection"><div class="customerSummary-view" ui-view=""></div></div><div include-with-scope="app/pages/admin/customers/customerSummary/customerInvoice/getReceiptModal.html"></div>');
$templateCache.put('app/pages/admin/customers/customers/customers.html','<div class="wrapper" ng-show="!pageLoading"><form ng-submit="vm.customersSearchClick()" id="searchCustomerTransactions"><div class="ui stackable doubling celled grid form no-gap"><div class="five column row filtersSection"><div class="column"><div class="field"><label>{{ translate(\'CARD-NUMBER\') }}</label><div class="two fields"><div class="field ui input" ng-class="{\'error\': vm.invalid.cardBin }"><input class="binNo" type="text" placeholder="{{ translate(\'BIN-NUMBER\') }}" ng-model="vm.customerModel.searchForm.cardBin" maxlength="6" ng-paste="vm.pasteJustNumbers($event)" numbers-only=""></div><div class="field ui input" ng-class="{\'error\': vm.invalid.pan }"><input class="lastNo" type="text" placeholder="{{ translate(\'PAN-NUMBER\') }}" ng-model="vm.customerModel.searchForm.pan" maxlength="4"></div></div></div></div><div class="column"><div class="field"><label>{{ translate(\'CARD-EXPIRY\') }}</label><div class="two fields"><div class="field ui input" ng-class="{\'error\': vm.invalid.expiryMonth }"><input type="text" class="inline expiry" placeholder="{{ translate(\'MONTH\') }}" maxlength="2" ng-model="vm.customerModel.searchForm.expiryMonth"></div><div class="field ui input" ng-class="{\'error\': vm.invalid.expiryYear }"><input type="text" class="inline expiry" placeholder="{{ translate(\'YEAR\') }}" maxlength="2" ng-model="vm.customerModel.searchForm.expiryYear"></div></div></div></div><div class="column"><div class="field"><label>{{ translate(\'CUSTOMER-REFERANCE-NUMBER\') }}</label> <input type="text" ng-model="vm.customerModel.searchForm.customerRef" placeholder="{{ translate(\'CUSTOMER123\') }}"></div></div><div class="column"><div class="field"><label>{{ translate(\'CUSTOMER-ID\') }}</label> <input type="text" ng-model="vm.customerModel.searchForm.customerId" placeholder="1234a567-bcde-8f90-123g-4hifeff493bf"></div></div><div class="column"><div class="field"><label>&nbsp;</label><div class="ui buttons fluid"><button type="submit" class="ui positive button">{{ translate(\'SEARCH\') }}</button> <a class="ui red basic button" ng-click="vm.resetForm()">{{ translate(\'CLEAR\') }}</a></div></div></div></div></div></form><div class="ui segments"><div class="segment clearing ui tableFilters"><entry-change ng-model="vm.customerModel" on-entry-change="vm.searchCustomers"></entry-change></div><div class="segment ui no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><table class="ui table"><thead><tr class="header"><th class="center aligned">#</th><th>{{ translate(\'CUSTOMER-ID\') }} <i class="fa fa-question-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'CUSTOMER-ID-TOOLTIP\') }}"></i></th><th>{{ translate(\'CUSTOMER-CARD\') }} <i class="fa fa-question-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'CUSTOMER-CARD-TOOLTIP\') }}"></i></th><th>{{ translate(\'CUSTOMER-REFERANCE\') }} <i class="fa fa-question-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'CUSTOMER-REFERANCE-TOOLTIP\') }}"></i></th><th>{{ translate(\'CREATED-AT\') }}</th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customerModel.customers"><td data-th="#" class="collapsing center aligned">{{ ((vm.customerModel.currentPage - 1) * vm.customerModel.pagination.limit) + 1 + $index }}</td><td data-th="{{ translate(\'CUSTOMER-ID\') }}"><a ng-href="/admin/customers/{{customer.id}}/transactions">{{ customer.customer_id }}</a></td><td data-th="{{ translate(\'CUSTOMER-CARD\') }}" class="divTableCell">{{ customer.primary_masked_pan }}</td><td data-th="{{ translate(\'CUSTOMER-REFERANCE\') }}" class="divTableCell">{{customer.customer_ref || "-"}}</td><td data-th="{{ translate(\'CREATED-AT\') }}" class="number-field divTableCell">{{customer.created_date | date:\'medium\' }}</td><td data-th="{{ translate(\'ACTIONS\') }}"><a ng-csv="vm.getCustomerCSV(customer.id)" filename="Customer_Statement_CustomerID_{{customer.id}}.csv" csv-label="true" lazy-load="true" class="ui icon button basic blue right floated" title="{{ translate(\'DOWNLOAD-CSV\') }}"><i class="user icon"></i></a></td></tr></tbody><tfoot><tr><th colspan="6"><page-results-summary ng-model="vm.customerModel" on-page-click="vm.searchCustomers"></page-results-summary><h4 class="ui red" ng-if="vm.customerModel.pagination.total === 0 && vm.loading.hasLoaded">{{ translate(\'NO-CUSTOMERS-FOUND\') }}</h4></th></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/admin/customers/trialInvitations/trialInvitations.html','<div class="wrapper wrapper-white" ng-show="!pageLoading"><div class="page-subtitle"><h3>{{ translate(\'CREATE-MAGIC-LINK\') }}</h3><p>{{ translate(\'MAGIC-LINK-MESSAGE\') }}</p></div><notification-message ng-model="magicLinkNotificationMessage"></notification-message><form class="form-horizontal" ng-submit="generateLink()"><div class="form-group clearfix" ng-class="{\'has-error\': invalid.email, \'has-feedback\': invalid.email }"><div class="col-md-3"><label class="control-label modal-email-label">{{ translate(\'EXPIRATION-DURATION\') }}</label> <span class="help-text">{{ translate(\'HELP-TEXT\') }}</span></div><div class="col-md-4"><div class="input-group"><input type="text" class="form-control modal-email-field" ng-model="expires_in"> <span class="input-group-addon" id="days">{{ translate(\'DAYS\') }}</span></div></div></div><div class="form-group"><div class="col-md-offset-3 col-sm-3"><input type="submit" value="{{ translate(\'GENERATE-MAGIC-LINK\') }}" class="btn btn-primary"></div></div></form></div><div class="wrapper" ng-if="linkGenerated"><div class="page-subtitle"><h3><i class="fa fa-fw fa-magic"></i>{{ translate(\'YOUR-MAGIC-LINK\') }}</h3></div><div class="alert alert-info infoSliderAlert" role="alert"><strong>{{ translate(\'HEADS-UP\') }}</strong> {{ translate(\'HEADS-UP-MESSAGE\', {expiresIn: linkModel.allLinks.expires_in / 86400}) }} <span ng-if="linkModel.allLinks.expires_in === 86400">{{ translate(\'DAY\') }}</span> <span ng-if="linkModel.allLinks.expires_in > 86400">{{ translate(\'DAYS\') }}</span> {{ translate(\'MAKE-SURE\') }}</div><div class="input-group input-group-lg"><input type="text" id="magicLink" class="form-control" ng-model="linkModel.allLinks.url"> <span class="input-group-btn"><button class="btn btn-info" type="button" ngclipboard="" data-clipboard-target="#magicLink"><i class="fa fa-clipboard fa-fw"></i>{{ translate(\'COPY-LINK\') }}</button></span></div></div>');
$templateCache.put('app/pages/admin/dashboard/widgets/summarySection.html','<div class="ui three column grid doubling stackable" id="analytics-summary-section"><div class="column summary-column"><div class="ui segment"><div class="summary-header"><h3>Sales over last 7(/30/60) days</h3></div><div class="clearfix current-summary"><div class="ui horizontal statistic"><div class="value">\xA3315,458</div><div class="label"><span class="ui green header"><i class="arrow up icon"></i> %6.7</span></div></div></div><div class="hc-chart" options="vm.chartOptions_sales"></div></div></div><div class="column summary-column"><div class="ui segment"><div class="summary-header"><h3>Avarage Decline Rate over last 7(/30/60) days</h3></div><div class="clearfix current-summary"><div class="ui horizontal statistic"><div class="value">1.8%</div><div class="label"><span class="ui green header"><i class="arrow up icon"></i> %5.2</span></div></div></div><div class="hc-chart" options="vm.chartOptions_declines"></div></div></div><div class="column summary-column"><div class="ui segment"><div class="summary-header"><h3>Number of Active Customers over last 7 days</h3></div><div class="clearfix current-summary"><div class="ui horizontal statistic"><div class="value">10,023</div><div class="label"><span class="ui red header"><i class="arrow down icon"></i> %1.2</span></div></div></div><div class="hc-chart" options="vm.chartOptions_customers"></div></div></div></div>');
$templateCache.put('app/pages/admin/developer/logs/logs.html','<div id="eventsPage" class="wrapper" ng-show="!pageLoading"><div class="ui segment"><form><div class="ui form"><div class="three fields"><div class="field"><label>{{ translate(\'CORRELATION-ID\') }}</label> <input type="text" ng-disabled="vm.loading" ng-model="vm.form.correlation_id" placeholder="{{ translate(\'CORRELATION-ID\') }}" ng-keypress="vm.searchOnReturn($event)"></div><div class="field"><label>{{ translate(\'EVENTS-BY-DEVICE\') }}</label><div class="ui fluid selection search dropdown" ng-class="{\'disabled\': vm.loading}" ng-model="vm.form.device" dropdown="" syn-ui-with-model="true"><i class="dropdown icon"></i><div class="text">{{ vm.getCurrentDeviceText() }}</div><div class="menu"><div class="item" data-value="0">{{ translate(\'ANY-DEVICE\') }}</div><div class="item" ng-repeat="(key,device) in vm.deviceModel.allDevices" data-value="{{key+1}}">{{device.terminal_id}}</div></div></div></div><div class="field"><label>&nbsp;</label> <button type="button" class="ui button right" ng-class="{\'disabled\': vm.loading}" ng-click="vm.reset()">{{ translate(\'RESET\') }}</button> <button type="submit" class="ui right positive button" ng-class="{\'loading\': vm.loading}" ng-click="vm.eventsSearchSubmit()">{{ translate(\'SEARCH\') }}</button></div></div></div></form></div><entry-change ng-model="vm.eventModel" on-entry-change="vm.onEntryChange"></entry-change><div class="panel-group clearfix" ng-if="vm.eventModel.list.length"><div ng-if="!vm.loading" ng-repeat="event in vm.eventModel.list" class="panel panel-{{vm.panelClass(event.severity_level)}} clearfix"><div class="panel-heading clickable" ng-click="vm.clickCollapse(event)"><h5 class="panel-title"><span class="info">{{ event.event_message || event.event_type }}</span></h5><ul class="panel-btn"><li><span class="btn">{{event.event_date | date:\'dd/MM/yyyy H:mm:ss:sss\'}}</span></li></ul></div><div class="panel-collapse collapse" id="event{{$index}}" ng-class="{\'in\':event.expanded}"><div class="panel-body"><div class="row"><div class="col-md-6"><table class="table table-condensed table-bordered"><tr><th>Correlation IDs</th><td data-th="Correlation ID"><div ng-repeat="correlation in event.correlation_id_list">{{correlation}}</div></td></tr><tr ng-repeat="(key,value) in event.key_values" ng-if="key!==\'CustomerId\'"><th>{{ key | titleCase }}</th><td data-th="{{ key | titleCase }}"><span ng-if="key==\'FundingSourceId\'" class="clickable link" ng-click="vm.checkIfCardOnDenyList(value)">{{ value }}</span> <a ng-if="key==\'UniqueTapIdentifier\' && event.key_values[\'CustomerId\']" ng-href="/admin/customersById/{{ event.key_values[\'CustomerId\'] }}">{{ value }}</a> <span ng-if="(key!==\'FundingSourceId\' && key!==\'UniqueTapIdentifier\') || (key==\'UniqueTapIdentifier\' && event.key_values[\'CustomerId\']===undefined)">{{ value }}</span></td></tr></table></div><div class="col-md-6" ng-if="event.event_trace"><pre ng-bind-html="vm.prettify(event.event_trace)">\n                </pre></div></div></div></div></div></div><div ng-if="!vm.loading && vm.eventModel.list.length === 0"><div class="ui segment"><span ng-if="vm.hasSearched">No events have been found.</span> <span ng-if="!vm.hasSearched">Enter a correlation ID or select a device to search for events.</span></div></div><page-results-summary ng-if="!vm.loading" ng-model="vm.eventModel" on-page-click="vm.onPageClick"></page-results-summary></div><modal show="vm.denyListModal.vaultId" modal-class="no-overflow invisible" modal-body-class="no-overflow" loading="vm.denyListModal.loading" hide-content-when-loading="true" modal-name="toggle-card-on-list" confirmation="{{vm.denyListModal.cardIsOnDenyList ? translate(\'REMOVE\') : translate(\'ADD\') }}" cancel="{{ translate(\'CANCEL\') }}" on-submit-click="vm.submitListModal" on-close-click="vm.closeListModal"><div class="panel-group clearfix"><div class="panel clearfix"><p>{{ translate(vm.denyListModal.cardIsOnDenyList ? \'CARD-ON-DENY-LIST-MESSAGE\' : \'CARD-NOT-ON-DENY-LIST-MESSAGE\') }}</p><div class="form-group" ng-if="!vm.denyListModal.cardIsOnDenyList"><label class="col-sm-5 required control-label">{{ translate(\'REASON\') }} <i class="fa fa-fw fa-info-circle tooltip-icon" tooltips="" tooltip-side="bottom" tooltip-template="{{ translate(\'REASON-TOOLTIP\') }}"></i></label><div class="col-sm-7"><div class="ui fluid selection dropdown" ng-model="vm.denyListModal.reason" dropdown="" syn-ui-with-model="true"><i class="dropdown icon"></i><div class="text">{{ translate(vm.denyListModal.reason || \'UNSPECIFIED\') }}</div><div class="menu"><div class="item" data-value="UNSPECIFIED">{{ translate(\'UNSPECIFIED\') }}</div><div class="item" data-value="DECLINED">{{ translate(\'DECLINED\') }}</div><div class="item" data-value="FRAUD">{{ translate(\'FRAUD\') }}</div></div></div></div></div><div class="form-group" ng-if="!vm.denyListModal.cardIsOnDenyList"><label class="col-sm-5 control-label">{{ translate(\'COMMENT\') }} <i class="fa fa-fw fa-info-circle tooltip-icon" tooltips="" tooltip-side="bottom" tooltip-template="{{ translate(\'COMMENT-TOOLTIP\') }}"></i></label><div class="col-sm-7"><input type="text" class="form-control input-sm" ng-model="vm.denyListModal.comment"></div></div></div></div></modal>');
$templateCache.put('app/pages/admin/developer/transaction/transaction.html','<div class="wrapper"><div class="row" ng-if="vm.loading || vm.deviceList.length>0"><div class="col-xs-12 col-sm-5"><div class="ui segments"><div class="ui segment" ng-class="{\'loading\': vm.loading}"><div class="row for-form"><div class="col-xs-12 col-sm-4"><label class="required">{{translate(\'DEVICE\')}}</label></div><div class="col-xs-12 col-sm-8"><select ng-model="vm.form.device" class="form-control"><option ng-repeat="device in vm.deviceList" value="{{device.device_id_issuer}}#{{device.terminal_id}}">{{device.terminal_id}}</option></select></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'pan\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'PAN\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.pan" ng-keyup="vm.validatePan()" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'currency\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'CURRENCY\')}}</label></div><div class="col-xs-12 col-sm-8"><select ng-model="vm.form.currency" class="form-control" ng-options="currency for currency in vm.options.currencies"></select></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'transaction_date_time\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'TRANSACTION-DATE-TIME\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.transaction_date_time" ng-keyup="vm.validateTransactionDateTime()" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'transaction_outcome\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'TRANSACTION-OUTCOME\')}}</label></div><div class="col-xs-12 col-sm-8"><select ng-model="vm.form.transaction_outcome" class="form-control" ng-options="option.value as option.label for option in vm.options.transactionOutcomes"></select></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'amount\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'PURCHASE-AMOUNT\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.amount" size="6" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'description\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'PURCHASE-DESCRIPTION\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.description" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'eligible_zones\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'ELIGIBLE-CAPPING-ZONES\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.eligible_zones" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'token_key_id\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'TOKEN-KEY-ID\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.token_key_id" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'token\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'TOKEN\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.token" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'icc_public_key\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'ICC-PUBLIC-KEY\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.icc_public_key" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'route_id\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'ROUTE-ID\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.route_id" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'stop_title\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'STOP-TITLE\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.stop_title" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'stop_id\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'STOP-ID\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.stop_id" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'stop_scheme\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'STOP-SCHEME\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.stop_scheme" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'destination_title\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'DESTINATION-TITLE\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.destination_title" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'destination_id\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'DESTINATION-ID\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.destination_id" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'destination_scheme\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'DESTINATION-SCHEME\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.destination_scheme" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'zone_title\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'ZONE-TITLE\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.zone_title" size="20" class="form-control"></div></div><div class="row for-form" ng-class="{\'error\': vm.isFormError(\'zone_id\')}"><div class="col-xs-12 col-sm-4"><label>{{translate(\'ZONE-ID\')}}</label></div><div class="col-xs-12 col-sm-8"><input type="text" ng-model="vm.form.zone_id" size="20" class="form-control"></div></div><div class="row for-form"><div class="col-xs-12"><button class="ui button primary" ng-click="vm.onSubmit(\'SINGLE\')" ng-disabled="!vm.validForm()" ng-if="!vm.variableFare">{{translate(\'TAP\')}}</button> <button class="ui button primary" ng-click="vm.onSubmit(\'ON\')" ng-disabled="!vm.validForm()" ng-if="!vm.variableFare">{{translate(\'TAP-ON\')}}</button> <button class="ui button primary" ng-click="vm.onSubmit(\'OFF\')" ng-disabled="!vm.validForm()" ng-if="vm.variableFare">{{translate(\'TAP-OFF\')}}</button> <button class="ui button" ng-click="vm.onReset()">{{translate(\'RESET\')}}</button></div></div></div></div></div><div class="col-xs-12 col-sm-7"><div class="ui segments" ng-if="vm.responseJson"><div hljs="" class="ui segment" ng-class="{\'loading\': vm.loading}"><button class="ui button green" ng-click="vm.viewLogs()" ng-if="vm.lastTransactionId">{{translate(\'VIEW-LOGS\')}}</button> <button class="ui button green" ng-click="vm.copyTransactionId()" ng-if="vm.lastTransactionId">{{translate(\'COPY-TRANSACTION-ID\')}}</button><pre class="no-border no-background" ng-bind-html="vm.prettifyResponse()">\n          </pre></div></div></div></div><div class="ui segments" ng-if="!vm.loading && vm.deviceList.length===0"><div class="ui segment">{{translate(\'NO-DEVICES-ERROR\')}}</div></div><textarea id="copy-box"></textarea></div>');
$templateCache.put('app/pages/admin/devices/assignments/assignments.html','<div class="wrapper" ng-show="!pageLoading"><div class="filters"><entry-change ng-model="deviceAssignmentsModel" on-entry-change="onEntryChange"></entry-change></div><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title ng-binding">{{ translate(\'DEVICE-ASSIGNMENT-HISTORY\') }}</h5></div><div class="divTable hoverTable"><div class="divTableHeading"><div class="divTableRow"><div class="divTableHead index text-center">#</div><div class="divTableHead">{{ translate(\'TERMINAL-ID\') }}</div><div class="divTableHead">{{ translate(\'PREVIOUS-PARTICIPANT\') }}</div><div class="divTableHead">{{ translate(\'NEW-PARTICIPANT\') }}</div><div class="divTableHead">{{ translate(\'UPDATED-TIME\') }}</div></div></div><div class="divTableBody" ng-if="deviceAssignmentsModel.assignments.length > 0"><div class="divTableRow" ng-repeat="(key,assignment) in deviceAssignmentsModel.assignments"><div data-th="#" class="text-center index divTableCell">{{ ((deviceAssignmentsModel.currentPage - 1) * deviceAssignmentsModel.pagination.limit) + 1 + $index }}</div><div data-th="{{ translate(\'TERMINAL-ID\') }}" class="divTableCell">{{ assignment.terminal_id }}</div><div data-th="{{ translate(\'PREVIOUS-PARTICIPANT\') }}" class="divTableCell">{{ assignment.previous_participant_id }}</div><div data-th="{{ translate(\'NEW-PARTICIPANT\') }}" class="divTableCell">{{ assignment.new_participant_id }}</div><div data-th="{{ translate(\'UPDATED-TIME\') }}" class="divTableCell">{{ assignment.updated_time | date:\'short\' }}</div></div></div></div><div class="panel-body" ng-if="deviceAssignmentsModel.assignments.length === 0"><span>{{ translate(\'NO-ASSIGNMENTS-FOUND\') }}</span></div></div><page-results-summary ng-model="deviceAssignmentsModel" on-page-click="onPageClick"></page-results-summary></div>');
$templateCache.put('app/pages/admin/devices/devices/devices.html','<div class="wrapper" ng-show="!pageLoading"><div class="filters"><entry-change ng-model="deviceModel" on-entry-change="onEntryChange"></entry-change></div><div class="panel panel-default"><div class="panel-heading"><form ng-submit="deviceSearchSubmit()" id="searchCustomerTransactions" class="panel-title"><div class="filterSection"><label>{{ translate(\'TERMINAL\') }}</label> <input type="text" class="filter" ng-model="searchForm.terminal_id" placeholder="ABC00001"></div><input class="btn customers-search-button" type="submit" value="{{ translate(\'SEARCH\') }}"></form></div><div class="divTable hoverTable"><div class="divTableHeading"><div class="divTableRow"><div class="divTableHead index text-center">#</div><div class="divTableHead">{{ translate(\'STATUS\') }}</div><div class="divTableHead">{{ translate(\'DESCRIPTION\') }}</div><div class="divTableHead" table-sort="" order="\'terminal-id\'" by="order" reverse="reverse" sort="sortDevices">{{ translate(\'TERMINAL\') }}</div><div class="divTableHead">{{ translate(\'DEVICE-GROUP\') }}</div><div class="divTableHead">{{ translate(\'CREATED\') }}</div></div></div><div class="divTableBody"><div class="divTableRow" ng-if="deviceModel.allDevices" ng-repeat="device in deviceModel.allDevices"><div data-th="#" class="index text-center divTableCell">{{ ((deviceModel.currentPage - 1) * deviceModel.pagination.limit) + 1 + $index }}</div><div data-th="{{ translate(\'STATUS\') }}" class="divTableCell"><span class="card-status card-status-{{device.status | lowercase }} tooltip-icon" ng-tooltip="{{device.status}}"></span> <small class="text-success">{{ translate(device.status) }}</small></div><div data-th="{{ translate(\'DESCRIPTION\') }}" class="divTableCell">{{ device.description }}</div><div data-th="{{ translate(\'TERMINAL\') }}" class="divTableCell">{{ device.terminal_id }}</div><div data-th="{{ translate(\'DEVICE-GROUP\') }}" class="divTableCell">{{ device.device_group.group_name }}</div><div data-th="{{ translate(\'CREATED\') }}" class="divTableCell">{{ device.created_date | date:\'short\'}}</div></div></div></div><div class="panel-body" ng-if="deviceModel.allDevices.length === 0"><span>{{ translate(\'NO-DEVICE-FOUND\') }}</span></div></div><page-results-summary ng-model="deviceModel" on-page-click="onPageClick"></page-results-summary></div>');
$templateCache.put('app/pages/admin/products/exceptionPeriods/exceptionPeriods.html','<div class="wrapper" ng-show="!pageLoading"><entry-change ng-model="vm.exceptionPeriodModel" on-entry-change="vm.getExceptionPeriods"></entry-change><div class="panel panel-default clearfix"><table class="table"><thead><tr><th width="5%">#</th><th width="15%">{{ translate(\'DATE\') }}</th><th width="15%">{{ translate(\'RECURRENCE\') }}</th><th width="15%">{{ translate(\'DESCRIPTION\') }}</th><th width="15%">{{ translate(\'PERIOD-APPLIED\') }}</th><th width="10%" ng-if="vm.hasPermission"></th></tr></thead><tbody><tr ng-if="vm.loading.hasLoaded" ng-repeat="exception in vm.exceptionPeriodModel.list track by $index"><td data-th="#">{{ ((vm.exceptionPeriodModel.currentPage - 1) * vm.exceptionPeriodModel.pagination.limit) + 1 + $index }}</td><td data-th="{{ translate(\'DATE\') }}"><span e-name="dateNew" e-form="rowform" editable-date="exception.dateNew">{{ (exception.dateNew | date:\'shortDate\') || \'empty\' }}</span></td><td data-th="{{ translate(\'RECURRENCE\') }}"><span href="#" editable-select="exception.repeat_type" e-name="repeat_type" e-form="rowform" e-ng-options="repeat as (\'PRODUCTS.EXCEPTION-PERIODS.\' + (repeat | replaceUnderscoreWithDash) | translate) for repeat in vm.repeatTypeList">{{ exception.repeat_type | replaceUnderscore }}</span></td><td data-th="{{ translate(\'DESCRIPTION\') }}"><span href="#" editable-text="exception.description" e-name="description" e-form="rowform">{{ exception.description }}</span></td><td data-th="{{ translate(\'PERIOD-APPLIED\') }}"><span href="#" editable-select="exception.period_type" e-name="period_type" e-form="rowform" e-ng-options="type as (\'PRODUCTS.EXCEPTION-PERIODS.\'+ type | translate) for type in vm.timePeriodTypeList">{{ exception.period_type }}</span></td><td data-th="{{ translate(\'ACTIONS\') }}" ng-show="vm.hasPermission" class="table-action exitableform-actions"><form editable-form="" name="rowform" onbeforesave="vm.save($data, exception.id)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.newInserted == exception"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary btn-sm"><i class="fa fa-save"></i></button> <button type="button" ng-disabled="rowform.$waiting" ng-click="vm.cancel(rowform)" class="btn btn-default btn-sm"><i class="fa fa-times-circle"></i></button></form><div class="buttons" ng-show="!rowform.$visible"><button type="button" class="btn btn-warning btn-sm" ng-click="rowform.$show()"><i class="fa fa-pencil"></i></button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeConfirmation($index, exception)"><i class="fa fa-trash"></i></button></div></td></tr></tbody></table><div class="panel-body" ng-if="!vm.loading.hasLoaded"><div class="text-center inline-loader"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></div></div><div class="panel-body" ng-if="vm.exceptionPeriodModel.list.length === 0 && vm.loading.hasLoaded"><span ng-if="!vm.loading.error">{{ translate(\'NO-EXCEPTION-FOUND\') }}</span> <span ng-if="vm.loading.error" class="text-danger">{{ translate(\'ERROR-ON-LOADING\') }}</span></div><div class="panel-footer" ng-if="vm.hasPermission"><a href="#" ng-click="vm.addException()"><i class="fa fa-fw fa-plus"></i>{{ translate(\'ADD-AN-EXCEPTION\') }}</a></div></div><page-results-summary ng-model="vm.exceptionPeriodModel" on-page-click="onPageClick"></page-results-summary></div>');
$templateCache.put('app/pages/admin/products/pricingPeriods/pricingPeriodTable.html','<div class="panel panel-default"><table class="table"><thead><tr><th width="5%">#</th><th width="20%">{{ translate(\'NAME\') }}</th><th width="20%">{{ translate(\'PERIOD\') }}</th><th width="20%">{{ translate(\'DAYS\') }}</th></tr></thead><tbody><tr ng-if="!vm.isEmpty(vm.pricingPeriodModel.list[0])" ng-repeat="rule in vm.pricingPeriodModel.list"><td>{{ $index+1 }}</td><td>{{rule.name}}</td><td><span ng-repeat="peak in rule.time_periods"><i>{{peak.start_time}}</i>-<i>{{peak.finish_time}}</i><br ng-if="rule.time_periods.length > 1 && !$last"></span></td><td><span ng-repeat="day in rule.days track by $index">{{day}} <i ng-if="rule.days.length > 1 && !$last">,</i></span></td></tr><tr ng-if="vm.isEmpty(vm.pricingPeriodModel.list[0])"><td colspan="4">{{ translate(\'NO-PRICING-SETTINGS-FOUND\') }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/admin/products/pricingPeriods/pricingPeriods.html','<div class="wrapper" ng-show="!pageLoading"><div class="row" ng-if="vm.hasPermission"><div class="col-md-8 clearfix"><div class="alert bg-info"><strong>{{ translate(\'CONFIGURATION\') }}</strong><p>{{ translate(\'CONFIGURATION-MESSAGE\') }}</p><p>{{ translate(\'CONFIGURATION-MESSAGE2\') }}</p></div><div ng-repeat="(key,rule) in vm.pricingPeriodModel.list" ng-if="vm.vars.selectedRule === key"><div class="row form-inline rule-section"><div class="form-group col-lg-3"><label class="control-label required">{{ translate(\'RULE-NAME\') }}</label><br><input type="text" ng-model="rule.name" class="form-control" required=""> <span class="help-block sub-little-text">{{ translate(\'RULE-NAME-HELP\') }}</span></div><div class="form-group col-lg-3"><label class="control-label required">{{ translate(\'TIMEZONE\') }}</label><br><input type="text" ng-model="vm.timezone" class="form-control" disabled=""> <span class="help-block sub-little-text">{{ translate(\'PARTICIPANT-TIMEZONE-SELECTION\') }}</span></div><div class="form-group col-lg-12" id="weekdays-selection"><div class="btn-group" role="group" aria-label="First group"><button ng-repeat="(i,day) in vm.vars.weeknames" type="button" class="btn btn-default" ng-click="vm.activate(day, rule, $event)" ng-model="rule.days[day]" ng-class="{\'active\': rule.days.indexOf(day | uppercase) > -1}" ng-disabled="vm.dayIsUsedElsewhere(key, day)">{{ translate( day | uppercase ) }}</button></div></div></div><div class="wrapper wrapper-white"><h3 class="subheading">{{ translate(\'SET-PEAK-TIME\') }}</h3><p class="settings-info">{{ translate(\'SET-PEAK-TIMES-HELPER\') }}</p><div class="ui positive message">{{ translate(\'TIMEZONE-FORMAT-INFO\') }}</div><div id="nouislider-container"><div nouislider="" options="vm.vars.options[key]"></div></div><div class="row" ng-show="vm.vars.options[key].start.length > 1"><div class="col-md-3"><label for="off-peak-segments">{{ translate(\'OFF-PEAK-SEGMENTS\') }}</label> <input type="text" id="off-peak-segments" class="form-control" ng-model="vm.vars.options[key].offPeakSegments" calc-peak-segment="vm.vars.options[key].start" off-peak="true" disabled=""></div><div class="col-md-3"><label for="peak-of-segments">{{ translate(\'PEAK-SEGMENTS\') }}</label> <input type="text" id="peak-of-segments" class="form-control" ng-model="vm.vars.options[key].peakSegments" calc-peak-segment="vm.vars.options[key].start" disabled=""></div><div class="col-md-3"><label for="peak-period">{{ translate(\'OFF-PEAK-LENGTH\') }}</label> <input type="text" id="peak-period" class="form-control" ng-model="vm.vars.options[key].offPeakPeriod" calc-peak-period="vm.vars.options[key].start" off-peak="true" disabled=""></div><div class="col-md-3"><label for="non-peak-period">{{ translate(\'PEAK-LENGTH\') }}</label> <input type="text" id="non-peak-period" class="form-control" calc-peak-period="vm.vars.options[key].start" ng-model="vm.vars.options[key].peakPeriod" disabled=""></div></div><div id="peak-hour-table" class="panel panel-default"><div class="divTable hoverTable"><div class="divTableHeading"><div class="divTableRow"><div class="divTableHead">{{ translate(\'TIME-INTERVAL\') }}</div><div class="divTableHead">{{ translate(\'START-TIME\') }}</div><div class="divTableHead">{{ translate(\'END-TIME\') }}</div><div class="divTableHead">{{ translate(\'DURATION\') }}</div><div class="divTableHead"></div></div></div><div class="divTableBody"><div class="divTableRow" ng-repeat="peak in rule.time_periods track by $index"><div data-th="{{ translate(\'TIME-INTERVAL\') }}" class="divTableCell"><span class="model-status model-status-active"></span>{{ translate(\'PEAK-NO\', {\'no\': $index+1 }) }}</div><div data-th="{{ translate(\'START-TIME\') }}" class="divTableCell">{{peak.start_time}}</div><div data-th="{{ translate(\'END-TIME\') }}" class="divTableCell">{{peak.finish_time}}</div><div data-th="{{ translate(\'DURATION\') }}" class="divTableCell">{{ (vm.convertToSec(peak.finish_time) - vm.convertToSec(peak.start_time) | secondsToHms)}}</div><div data-th="{{ translate(\'ACTION\') }}" class="divTableCell"><a href="#" ng-click="vm.removeRange(key,$index)" class="text-danger"><i class="fa fa-fw fa-times-circle fa-lg"></i></a></div></div><div class="divTableRow" ng-if="!rule.time_periods || rule.time_periods.length === 0"><div class="panel-body">{{ translate(\'NO-PEAK-PERIODS-FOUND\') }}</div></div></div></div></div></div></div></div><div class="col-md-4"><a class="btn btn-info btn-block" ng-click="vm.addRule()">{{ translate(\'ADD-ANOTHER-RULE\') }}</a><br><peak-rule ng-repeat="(i,rule) in vm.pricingPeriodModel.list" ng-model="rule" options="vm.vars.options[i]" selected-rule="vm.vars.selectedRule" key="i" has-changed="vm.hasChanged[i]" temp="vm.temporaryList[i]" remove="vm.removeConfirmation" save="vm.save"></peak-rule></div></div><div ng-if="!vm.hasPermission"><div include-with-scope="app/pages/admin/products/pricingPeriods/pricingPeriodTable.html"></div></div></div>');
$templateCache.put('app/pages/admin/products/zones/zones.html','<div class="wrapper" ng-show="!pageLoading"><div class="panel panel-default clearfix"><table class="table"><thead><tr><th width="5%">#</th><th width="30%">{{ translate(\'NAME\') }}</th><th width="30%">{{ translate(\'CAPPING-ZONE-ID\') }}<i class="fa fa-question-circle tooltip-icon" tooltip-side="bottom" tooltips="" tooltip-template="{{ translate(\'ZONE-ID-TOOLTIP\') }}"></i></th><th width="10%" ng-if="vm.hasPermission"></th></tr></thead><tbody><tr ng-if="vm.loading.hasLoaded" ng-repeat="(key,zone) in vm.zoneModel.list track by $index"><td data-th="#">{{ $index+1 }}</td><td data-th="{{ translate(\'NAME\') }}"><span e-name="zone_name" e-form="rowform" editable-text="zone.zone_name" e-placeholder="{{ translate(\'NAME\') }}">{{ zone.zone_name }}</span></td><td data-th="{{ translate(\'CAPPING-ZONE-ID\') }}" class="multipleField"><span ng-repeat="(n, lookup) in zone.lookup_keys track by $index" href="#" editable-text="zone.lookup_keys[n]" e-name="lookup_keys" e-form="rowform" e-placeholder="{{ translate(\'CAPPING-ZONE-ID\') }}" e-class="breakInput"><span class="label label-success">{{ zone.lookup_keys[n] }}</span></span> <a href="#" ng-click="vm.addTerminalId(zone)" ng-show="rowform.$visible"><span class="fa-stack fa"><i class="fa fa-square-o fa-stack-2x"></i> <i class="fa fa-plus fa-stack-1x"></i></span></a> <a href="#" ng-click="vm.removeTerminalId(zone)" ng-show="rowform.$visible" ng-if="zone.lookup_keys.length > 1"><span class="fa-stack fa"><i class="fa fa-square-o fa-stack-2x"></i> <i class="fa fa-minus fa-stack-1x"></i></span></a></td><td data-th="{{ translate(\'ACTIONS\') }}" ng-show="vm.hasPermission" class="exitableform-actions"><form editable-form="" name="rowform" onbeforesave="vm.save($data, key)" ng-show="rowform.$visible" class="form-buttons form-inline" shown="vm.newInserted == zone"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary btn-sm"><i class="fa fa-save"></i></button> <button type="button" ng-disabled="rowform.$waiting" ng-click="vm.cancel(rowform)" class="btn btn-default btn-sm"><i class="fa fa-times-circle"></i></button></form><div class="buttons" ng-show="!rowform.$visible"><button type="button" class="btn btn-warning btn-sm" ng-click="rowform.$show()"><i class="ion-edit"></i></button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeConfirmation($index, zone)"><i class="ion-trash-a"></i></button></div></td></tr></tbody></table><div class="panel-body" ng-if="!vm.loading.hasLoaded"><div class="text-center inline-loader"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></div></div><div class="panel-body" ng-if="vm.zoneModel.list.length === 0 && vm.loading.hasLoaded"><span ng-if="!vm.loading.error">{{ translate(\'NO-ZONES-FOUND\') }}</span> <span ng-if="vm.loading.error" class="text-danger">{{ translate(\'ERROR-LOADING-ZONES\') }}</span></div><div class="panel-footer" ng-if="vm.hasPermission"><a href="#" ng-click="vm.addZone()"><i class="fa fa-fw fa-plus"></i>{{ translate(\'ADD-NEW-ZONE\') }}</a></div></div></div>');
$templateCache.put('app/pages/admin/search/charges/searchCharges.html','<div class="wrapper"><div id="transactionSearch" ng-show="!vm.pageLoading" class="ui segment no-border no-padding"><div class="summary-tab-block"><ul class="nav nav-stacked summary-tabs"><li ui-sref-active="active"><a ui-sref="admin.search.charges.cardNumber"><h3 class="subheading mps-settings-section-header">{{ translate(\'CARD-NUMBER\') }}</h3></a></li><li ui-sref-active="active"><a ui-sref="admin.search.charges.amount"><h3 class="subheading mps-settings-section-header">{{ translate(\'AMOUNT\') }}</h3></a></li><li ui-sref-active="active"><a ui-sref="admin.search.charges.period"><h3 class="subheading mps-settings-section-header">{{ translate(\'PERIOD\') }}</h3></a></li><li ui-sref-active="active"><a ui-sref="admin.search.charges.status"><h3 class="subheading mps-settings-section-header">{{ translate(\'STATUS\') }}</h3></a></li></ul></div><div class="page-content-container"><form class="ui form" id="vm.transactionSearchForm" name="vm.transactionSearchForm" ng-submit="vm.search(vm.transactionSearchForm)" novalidate=""><div ui-view=""></div><button type="submit" class="hidden ui right positive button">{{ translate(\'SEARCH\') }}</button></form><div class="ui orange segment" ng-if="!isEmpty(vm.formFilters)"><h4 class="ui dividing header">{{ translate(\'SEARCHING-FILTERS\') }}</h4><p ng-if="isEmpty(vm.form)">{{ translate(\'PLEASE-USE-THE-FILTERS\') }}</p><div ng-if="!isEmpty(vm.form)" include-with-scope="app/pages/admin/search/widgets/filtersSummary.html"></div></div><button type="button" class="ui positive button" ng-click="vm.search()">{{ translate(\'SEARCH\') }}</button> <button type="button" class="ui default button" ng-click="vm.resetAll()">{{ translate(\'RESET\') }}</button></div></div><div class="ui segment no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><div class="ui top attached segment"><entry-change ng-model="vm.transactionModel" on-entry-change="vm.getTransactions"></entry-change></div><table class="ui attached table sortable"><thead><tr><th>{{ translate(\'CARD-NUMBER\') }}</th><th class="center aligned">{{ translate(\'EXPIRY\') }}</th><th table-sort="" order="\'FORM_FACTOR\'" by="order" reverse="reverse" sort="vm.getTransactions" class="center aligned">{{ translate(\'FORM-FACTOR\') }}</th><th table-sort="" order="\'AGGREGATION_AMOUNT\'" by="order" reverse="reverse" sort="vm.getTransactions">{{ translate(\'AMOUNT\') }}</th><th>{{ translate(\'CHARGE-STATUS\') }}</th><th table-sort="" order="\'SETTLEMENT_STATUS\'" by="order" reverse="reverse" sort="vm.getTransactions">{{ translate(\'SETTLEMENT-STATUS\') }}</th><th table-sort="" order="\'TAP_TIME\'" by="order" reverse="reverse" sort="vm.getTransactions">{{ translate(\'FIRST-TAP\') }}</th><th>{{ translate(\'ACTIONS\') }}</th></tr></thead><tbody><tr ng-repeat="transaction in vm.transactionModel.chargeList"><td data-th="{{ translate(\'CARD-NUMBER\') }}">{{ transaction.funding_source.first6 +\'******\'+ transaction.funding_source.last4 }}</td><td data-th="{{ translate(\'EXPIRY\') }}" class="center aligned">{{ transaction.funding_source.expiry | expiry }}</td><td data-th="{{ translate(\'FORM-FACTOR\') }}"><span ng-if="transaction.funding_source.form_factor" class="label label-{{transaction.funding_source.form_factor | lowercase }}">{{ translate(transaction.funding_source.form_factor | replaceUnderscoreWithDash) }}</span></td><td data-th="{{ translate(\'AMOUNT\') }}">{{ transaction.amount | isoCurrency:(transaction.currency | toISOCurrency) }}</td><td data-th="{{ translate(\'CHARGE-STATUS\') }}"><payment-guarantee-status-label ng-model="transaction"></payment-guarantee-status-label></td><td data-th="{{ translate(\'SETTLEMENT-STATUS\') }}"><span ng-if="transaction.settlement_result.status" class="label label-{{(transaction.settlement_result.status | removeSpacesAndLowerCase) }}">{{ translate(transaction.settlement_result.status | removeSpaces) }}</span></td><td data-th="{{ translate(\'FIRST-TAP\') }}">{{ transaction.micropayments[0].taps[0].tap_time | date:\'medium\'}}</td><td data-th="{{ translate(\'ACTIONS\') }}"><div class="ui icon buttons right aligned"><button ng-click="vm.callNewModal(transaction)" class="ui button orange">{{ translate(\'DETAILS\') }}</button> <a ng-href="admin/customersByVaultId/{{ transaction.funding_source_vault_id }}" target="_blank" class="ui button green"><i class="align user icon"></i></a></div></td></tr></tbody><tfoot><tr><th colspan="8"><h4 ng-if="vm.transactionModel.chargeList.length === 0">{{ translate(\'NO-TRANSACTIONS-HAVE-BEEN-FOUND\') }}</h4><page-results-summary ng-model="vm.transactionModel" on-page-click="vm.getTransactions"></page-results-summary></th></tr></tfoot></table></div></div><div include-with-scope="app/pages/admin/search/widgets/detailsModal.html"></div>');
$templateCache.put('app/pages/admin/search/orders/orders.html','<div ng-if="vm.featureFlags"><div ng-switch="vm.pageState" class="ecom-orders"><div ng-switch-when="ready"><div class="wrapper"><div class="well bg-white loading"><form ng-submit="vm.orderSearchClick()" id="vm.orderSearchForm" name="vm.orderSearchForm" class="ui form"><div class="fields"><div class="three wide field" ng-class="{\'error\': !vm.isValid(\'card_last\', vm.form.card_last, vm.orderSearchForm.card_last) }"><label>{{ translate(\'CARD-NO-LAST4\', null, \'TRANSACTIONS.SEARCH.\') }}</label><div class="ui fluid icon input"><input class="form-control" type="text" name="card_last" maxlength="4" placeholder="{{ translate(\'CARD-NO-PAN\', null, \'TRANSACTIONS.SEARCH.\') }}" ng-model="vm.form.card_last"> <i class="times link icon" ng-if="vm.form.card_last" ng-click="vm.remove(\'card_last\')"></i></div></div><div class="three wide field" ng-class="{\'error\': !vm.isValid(\'amount\', vm.form.amount, vm.orderSearchForm.amount)}"><label>{{ translate(\'AMOUNT\', null, \'TRANSACTIONS.SEARCH.\') }}</label><div class="ui fluid icon input"><input class="form-control" type="text" name="amount" placeholder="{{ translate(\'AMOUNT\', null, \'TRANSACTIONS.SEARCH.\') }}" ng-model="vm.form.amount"> <i class="times link icon" ng-if="vm.form.amount" ng-click="vm.remove(\'amount\')"></i></div></div><div class="two wide field" ng-class="{\'error\': !vm.isValid(\'expiration\', vm.form.expiration, vm.orderSearchForm.expiration) }"><label>{{ translate(\'EXPIRATION\', null, \'TRANSACTIONS.SEARCH.\') }}</label><div class="ui fluid icon input"><input type="text" name="expiration" ng-model="vm.form.expiration" class="form-control exp-date" placeholder="MM/YY" id="expDate"> <i class="times link icon" ng-if="vm.form.expiration" ng-click="vm.remove(\'expiration\')"></i></div></div><div class="two wide field" ng-class="{\'error\': !vm.isValid(\'from_date\', vm.form.from_date, vm.orderSearchForm.from_date) }"><label>{{ translate(\'FROM-DATE\', null, \'CUSTOMERS.CUSTOMER-SUMMARY.\') }}</label><ng-datepicker ng-model="vm.form.from_date" view-format="DD/MM/YYYY" class="datepicker-field" placeholder="DD/MM/YYYY" name="from_date" required="required"></ng-datepicker></div><div class="two wide field" ng-class="{\'error\': !vm.isValid(\'to_date\', vm.form.to_date, vm.orderSearchForm.to_date) }"><label>{{ translate(\'TO-DATE\', null, \'CUSTOMERS.CUSTOMER-SUMMARY.\') }}</label><ng-datepicker ng-model="vm.form.to_date" view-format="DD/MM/YYYY" class="datepicker-field" placeholder="DD/MM/YYYY" name="to_date" required="required"></ng-datepicker></div><div class="two wide field" ng-class="{\'error\': !vm.isValid(\'from_time\', vm.form.from_time, vm.orderSearchForm.from_time) }"><label>{{ translate(\'FROM-TIME\') }}</label><div class="ui fluid icon input"><input class="form-control" type="text" name="from_time" placeholder="00:00" ng-model="vm.form.from_time" required=""></div></div><div class="two wide field" ng-class="{\'error\': !vm.isValid(\'to_time\', vm.form.to_time, vm.orderSearchForm.to_time) }"><label>{{ translate(\'TO-TIME\') }}</label><div class="ui fluid icon input"><input class="form-control" type="text" name="to_time" placeholder="23:59" ng-model="vm.form.to_time" required=""></div></div></div><button type="button" class="ui positive button" ng-click="vm.orderSearchClick()">{{ translate(\'SEARCH\', null, \'TRANSACTIONS.SEARCH.\') }}</button> <button type="button" class="ui default button" ng-click="vm.resetClick()">{{ translate(\'RESET\', null, \'TRANSACTIONS.SEARCH.\') }}</button></form></div><div class="well bg-white loading"><form ng-submit="vm.getOrderDetailsClick()" id="fetchOrder" name="vm.searchOrders"><div class="form-group"><label for="orderIdInput">{{translate(\'ORDER-ID\')}}</label> <input type="text" class="form-control" id="orderIdInput" name="orderIdInput" required="" ng-disabled="!vm.loading.hasLoaded" ng-model="vm.getOrderDetailsForm.orderId" ng-pattern="/^or_.{36}$/" placeholder="or_a7b38191-bcd8-4dce-87f6-cbd9a3091944"> <small id="orderIdInputHelp" class="form-text text-muted">{{translate(\'ORDER-ID-INPUT-HELP-TEXT\')}} <code>or_</code></small></div><button type="submit" ng-disabled="vm.getOrderDetailsForm.$invalid || !vm.loading.hasLoaded" class="btn search-btn">{{translate(\'CONTINUE\')}}</button></form></div><div class="ui segments" ng-show="showOrderTable"><div class="segment clearing ui tableFilters"><entry-change ng-model="vm.orderModel" on-entry-change="vm.getOrders"></entry-change></div><div class="segment ui no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><table class="ui table segment"><thead><tr><th class="center aligned">#</th><th>{{ translate(\'TIME\') }}</th><th>{{ translate(\'ORDER-ID\') }}</th><th>{{ translate(\'CARD-NO-LAST4\', null, \'TRANSACTIONS.SEARCH.\') }}</th><th>{{ translate(\'AMOUNT\') }}</th><th>{{ translate(\'PARTICIPANT-ID\') }}</th><th>{{ translate(\'STATUS\') }}</th></tr></thead><tbody><tr ng-repeat="order in vm.orderModel.orders"><td data-th="#" class="collapsing center aligned">{{ (vm.orderModel.currentPage - 1) * vm.orderModel.pagination.limit + $index + 1 }}</td><td data-th="{{ translate(\'TIME\') }}" class="divTableCell">{{ order.last_updated | date:"dd/MM/yyyy HH:mm:ss"}}</td><td data-th="{{ translate(\'ORDER-ID\') }}" class="divTableCell"><a ng-href="/admin/search/orders/{{order.id}}" title="translate(\'ORDER-DETAILS\')">{{ order.id }}</a></td><td data-th="{{ translate(\'CARD-NUMBER\', null, \'TRANSACTIONS.SEARCH.\') }}" class="divTableCell">{{ order.last_four }}</td><td data-th="{{ translate(\'AMOUNT\') }}" class="divTableCell">{{ order.charge.amount | wholeNumberCurrencyToDecimal | isoCurrency:order.charge.currency }}</td><td data-th="{{ translate(\'PARTICIPANT-ID\') }}" class="divTableCell">{{ order.participant_id }}</td><td data-th="{{ translate(\'STATUS\') }}" class="divTableCell">{{ \'ORDER.\' + order.status | translate }}</td></tr></tbody><tfoot><tr><th colspan="7"><page-results-summary ng-model="vm.orderModel" on-page-click="vm.getOrders"></page-results-summary><h4 class="ui red" ng-if="vm.orderModel.orders.length === 0 && vm.loading.hasLoaded">{{ translate(\'NO-ORDER-FOUND\')}}</h4></th></tr></tfoot></table></div></div></div></div><div ng-switch-when="error_permissions" class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'YOU-DO-NOT-HAVE-PERMISSION\') }}</h4></div></div></div></div><div ng-if="!vm.featureFlags" class="ecom-orders"><div class="wrapper"><div class="ui segment clearing"><h4>{{ translate(\'YOU-DO-NOT-HAVE-FUNCTIONALITY\') }}</h4></div></div></div>');
$templateCache.put('app/pages/admin/search/trips/searchTrips.html','<div class="wrapper"><div id="transactionSearch" ng-show="!vm.pageLoading" class="ui segment no-border no-padding"><div class="summary-tab-block"><ul class="nav nav-stacked summary-tabs"><li ui-sref-active="active"><a ui-sref="admin.search.trips.cardNumber"><h3 class="subheading mps-settings-section-header">{{ translate(\'CARD-NUMBER\') }}</h3></a></li><li ui-sref-active="active"><a ui-sref="admin.search.trips.amount"><h3 class="subheading mps-settings-section-header">{{ translate(\'AMOUNT\') }}</h3></a></li><li ui-sref-active="active"><a ui-sref="admin.search.trips.period"><h3 class="subheading mps-settings-section-header">{{ translate(\'PERIOD\') }}</h3></a></li><li ui-sref-active="active"><a ui-sref="admin.search.trips.trip"><h3 class="subheading mps-settings-section-header">{{ translate(\'TRIP\') }}</h3></a></li></ul></div><div class="page-content-container"><form class="ui form" id="vm.transactionSearchForm" name="vm.transactionSearchForm" ng-submit="vm.search(vm.transactionSearchForm)" novalidate=""><div ui-view=""></div><button type="submit" class="hidden ui right positive button">{{ translate(\'SEARCH\') }}</button></form><div class="ui orange segment" ng-if="!isEmpty(vm.formFilters)"><h4 class="ui dividing header">{{ translate(\'SEARCHING-FILTERS\') }}</h4><p ng-if="isEmpty(vm.formFilters)">{{ translate(\'PLEASE-USE-THE-FILTERS\') }}</p><div ng-if="!isEmpty(vm.formFilters)" include-with-scope="app/pages/admin/search/widgets/filtersSummary.html"></div></div><button type="button" class="ui positive button" ng-click="vm.search()">{{ translate(\'SEARCH\') }}</button> <button type="button" class="ui default button" ng-click="vm.resetAll()">{{ translate(\'RESET\') }}</button></div></div><div class="ui segment no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><div class="ui top attached segment"><entry-change ng-model="vm.transactionModel" on-entry-change="vm.getTrips"></entry-change></div><table class="ui attached celled padded structured table"><thead><tr><th rowspan="2">{{ translate(\'CARD-NUMBER\') }}</th><th class="one wide center aligned" rowspan="2" ng-bind-html="translate(\'FARE-AMOUNT-TABLE\')"></th><th class="one wide center aligned" rowspan="2" ng-bind-html="translate(\'NOMINAL-AMOUNT-TABLE\')"></th><th class="center aligned" rowspan="2">{{ translate(\'CHARGE-TYPE\') }}</th><th class="center aligned" colspan="3">{{ translate(\'TRIP\') }}</th><th class="center aligned" rowspan="2"></th></tr><tr><th>{{ translate(\'ROUTE\') }}</th><th>{{ translate(\'STOP\') }}</th><th>{{ translate(\'TAP-TIME\') }}</th></tr></thead><tbody><tr ng-repeat="trip in vm.transactionModel.tripList"><td data-th="{{ translate(\'CARD-NUMBER\') }}">{{ trip.funding_source.first6 +\'******\'+ trip.funding_source.last4 }}</td><td data-th="{{ translate(\'FARE-AMOUNT\') }}">{{ trip.amount | isoCurrency:(trip.currency | toISOCurrency) }}</td><td data-th="{{ translate(\'NOMINAL-AMOUNT\') }}">{{ trip.nominal_amount | isoCurrency:(trip.currency | toISOCurrency) }}</td><td data-th="{{ translate(\'CHARGE-TYPE\') }}"><span ng-if="trip.charge_type" class="label label-{{ trip.charge_type | lowercase }}">{{ translate(trip.charge_type | replaceUnderscoreWithDash) }}</span></td><td data-th="{{ translate(\'ROUTE\') }}"><p ng-repeat="tap in trip.taps">{{tap.route_id}}</p></td><td data-th="{{ translate(\'STOP\') }}"><p ng-repeat="tap in trip.taps">{{tap.location}}</p></td><td data-th="{{ translate(\'TAP-TIME\') }}"><p ng-repeat="tap in trip.taps">{{tap.tap_time | date:\'medium\'}}</p></td><td><div class="ui icon buttons right aligned"><button ng-click="vm.callNewModal(trip)" class="ui button orange">{{ translate(\'DETAILS\') }}</button> <a ng-href="admin/customersByVaultId/{{ trip.funding_source.id }}?participantId={{trip.participant_id}}" target="_blank" class="ui button green"><i class="align user icon"></i></a></div></td></tr></tbody><tfoot><tr><th colspan="8"><h4 ng-if="vm.transactionModel.tripList.length === 0">{{ translate(\'NO-TRIPS-HAVE-BEEN-FOUND\') }}</h4><page-results-summary ng-model="vm.transactionModel" on-page-click="vm.getTrips"></page-results-summary></th></tr></tfoot></table></div></div><div include-with-scope="app/pages/admin/search/widgets/detailsModal.html"></div>');
$templateCache.put('app/pages/admin/search/widgets/amount.html','<div class="fields"><div class="three wide field" ng-class="{\'error\': vm.hasAmountError(vm.form, vm.transactionSearchForm, \'minAmount\')}"><label>{{ translate(\'MIN-AMOUNT\') }}</label><div class="ui fluid icon input"><input type="text" name="minAmount" placeholder="{{ translate(\'MIN-AMOUNT\') }}" ng-model="vm.form.minAmount"> <i class="times link icon" ng-if="vm.form.minAmount" ng-click="vm.remove(\'minAmount\')"></i></div></div><div class="three wide field" ng-class="{\'error\': vm.hasAmountError(vm.form, vm.transactionSearchForm, \'maxAmount\')}"><label>{{ translate(\'MAX-AMOUNT\') }}</label><div class="ui fluid icon input"><input type="text" name="maxAmount" placeholder="{{ translate(\'MAX-AMOUNT\') }}" ng-model="vm.form.maxAmount"> <i class="times link icon" ng-if="vm.form.maxAmount" ng-click="vm.remove(\'maxAmount\')"></i></div></div></div>');
$templateCache.put('app/pages/admin/search/widgets/cardNumber.html','<div class="fields"><div class="four wide field" ng-class="{\'error\': !vm.isValid(\'card_first\', vm.form.card_first, vm.transactionSearchForm.card_first)}"><label>{{ translate(\'CARD-NUMBER-FIRST6\') }}</label><div class="ui fluid icon input"><input type="text" name="card_first" maxlength="6" placeholder="{{ translate(\'CARD-NO-BIN\') }}" ng-model="vm.form.card_first"> <i class="times link icon" ng-if="vm.form.card_first" ng-click="vm.remove(\'card_first\')"></i></div></div><div class="three wide field" ng-class="{\'error\': !vm.isValid(\'card_last\', vm.form.card_last, vm.transactionSearchForm.card_last) }"><label>{{ translate(\'CARD-NO-LAST4\') }}</label><div class="ui fluid icon input"><input type="text" name="card_last" maxlength="4" placeholder="{{ translate(\'CARD-NO-PAN\') }}" ng-model="vm.form.card_last"> <i class="times link icon" ng-if="vm.form.card_last" ng-click="vm.remove(\'card_last\')"></i></div></div><div class="two wide field" ng-class="{\'error\': !vm.isValid(\'expiration\', vm.form.expiration, vm.transactionSearchForm.expiration) }"><label>{{ translate(\'EXPIRATION\') }}</label><expiration-directive ng-model="vm.form.expiration" remove="vm.remove" name="expiration"></expiration-directive></div><div class="three wide field"><label>{{ translate(\'CARD-TYPE\') }}</label><div class="ui search selection dropdown" name="card_type" syn-ui-with-model="true" dropdown="" ng-model="vm.form.card_type" dropdown-change="vm.statusChanged(filter, \'card_type\')" default-text="{{ translate(\'SELECT-CARD-TYPE\') }}" clearable="true" cleared="vm.cleared"><i class="dropdown icon"></i><div class="text">{{ translate(vm.form.card_type) }}</div><div class="menu"><div class="item" ng-repeat="card in vm.transactionFilters.cardType" data-value="{{card | lowercase}}">{{ translate(card) }}</div></div></div></div><div class="three wide field"><label>{{ translate(\'FORM-FACTOR\') }}</label><div class="ui search selection dropdown" name="form_factor" syn-ui-with-model="true" dropdown="" ng-model="vm.form.form_factor" dropdown-change="vm.statusChanged(filter, \'form_factor\')" default-text="{{ translate(\'SELECT-FORM-FACTOR\') }}" clearable="true" cleared="vm.cleared"><i class="dropdown icon"></i><div class="text">{{ translate(vm.form.form_factor | replaceUnderscoreWithDash)}}</div><div class="menu"><div class="item" ng-repeat="(key,card) in vm.transactionFilters.formFactor" data-value="{{key}}">{{ translate(key | replaceUnderscoreWithDash) }}</div></div></div></div></div>');
$templateCache.put('app/pages/admin/search/widgets/detailsModal.html','<new-modal header="{{ translate(\'CHARGE-DETAILS\') }}" size="large" show="vm.callNewModal" call-function="vm.callModalFunction"><table class="ui attached celled padded structured table"><thead><tr><th colspan="3" class="left aligned">{{ translate(\'CARD-NO\') }}: {{vm.transactionModel.selectedTransaction.funding_source.first6 +\'******\'+vm.transactionModel.selectedTransaction.funding_source.last4}}</th><th colspan="2" class="left aligned">{{ translate(\'EXPIRY\') }}: {{vm.transactionModel.selectedTransaction.funding_source.expiry | expiry}}</th><th colspan="2" class="left aligned">{{ translate(\'FORM-FACTOR\') }}: <span ng-if="vm.transactionModel.selectedTransaction.funding_source.form_factor" class="label label-{{vm.transactionModel.selectedTransaction.funding_source.form_factor | lowercase }}">{{ translate(vm.transactionModel.selectedTransaction.funding_source.form_factor | uppercase) }}</span> <span ng-if="!vm.transactionModel.selectedTransaction.funding_source.form_factor">-</span></th></tr><tr><th colspan="3" class="left aligned">{{ translate(\'AMOUNT\') }}: {{ vm.transactionModel.selectedTransaction.amount | isoCurrency:(vm.transactionModel.selectedTransaction.currency | toISOCurrency) }}</th><th colspan="2" class="left aligned">{{ translate(\'CHARGE-STATUS\') }}:<payment-guarantee-status-label ng-model="vm.transactionModel.selectedTransaction"></payment-guarantee-status-label><span class="label label-danger" ng-if="vm.transactionModel.dataStatus">Initially Declined</span></th><th colspan="2" class="left aligned">{{ translate(\'SETTLEMENT-STATUS\') }}: <span ng-if="vm.transactionModel.selectedTransaction.settlement_result.status" class="label label-{{vm.transactionModel.selectedTransaction.settlement_result.status | lowercase }}">{{ translate(vm.transactionModel.selectedTransaction.settlement_result.status, undefined, \'GUARANTEESTATUS.\') }}</span><div ng-if="vm.transactionModel.selectedTransaction.settlement_result.status === \'SETTLED\'">{{ translate(\'SETTLED-AT\') }}:&nbsp;<short-medium-date-time ng-model="vm.transactionModel.selectedTransaction.settlement_result.status_date_time"></short-medium-date-time></div><span ng-if="!vm.transactionModel.selectedTransaction.settlement_result.status">-</span></th></tr><tr><th rowspan="2">{{ translate(\'FARE-AMOUNT\') }}</th><th rowspan="2">{{ translate(\'NOMINAL-AMOUNT\') }}</th><th rowspan="2">{{ translate(\'CHARGE-TYPE\') }}</th><th colspan="4">{{ translate(\'TRIP\') }}</th></tr><tr><th>{{ translate(\'ZONE\') }}</th><th>{{ translate(\'ROUTE\') }}</th><th>{{ translate(\'STOP\') }}</th><th>{{ translate(\'TAP-TIME\') }}</th></tr></thead><tbody ng-repeat="trip in vm.transactionModel.selectedTransaction.micropayments"><tr><td data-th="{{ translate(\'FARE-AMOUNT\') }}">{{ trip.amount | isoCurrency:(trip.currency | toISOCurrency) }}</td><td data-th="{{ translate(\'NOMINAL-AMOUNT\') }}">{{ trip.nominal_amount | isoCurrency:(trip.currency | toISOCurrency) }}</td><td data-th="{{ translate(\'CHARGE-TYPE\') }}"><span ng-if="trip.charge_type" class="label label-{{ trip.charge_type | lowercase }}">{{ translate(trip.charge_type | replaceUnderscoreWithDash) }}</span></td><td data-th="{{ translate(\'ZONE\') }}"><p ng-repeat="tap in trip.taps">{{ tap.zone_names | join:{ limit: 3, useAnd: true } }}</p></td><td data-th="{{ translate(\'ROUTE\') }}"><p ng-repeat="tap in trip.taps">{{tap.route_id}}</p></td><td data-th="{{ translate(\'STOP\') }}"><p ng-repeat="tap in trip.taps">{{tap.location}}</p></td><td data-th="{{ translate(\'TAP-TIME\') }}"><p ng-repeat="tap in trip.taps">{{tap.tap_time | date: \'short\' }}</p></td></tr></tbody></table></new-modal>');
$templateCache.put('app/pages/admin/search/widgets/filtersSummary.html','<div class="ui list"><div class="item" ng-if="vm.cardDetailsFilter()"><span class="ui label" ng-if="vm.formFilters.card_first || vm.formFilters.card_last">{{ translate(\'CARD-NUMBER\') }}: <span class="detail">{{ vm.formFilters | filtersCardNumber }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove([\'card_first\', \'card_last\'])"></i></span> <span class="ui label" ng-if="vm.formFilters.expiration">{{ translate(\'CARD-EXPIRATION\') }}: <span class="detail">{{ vm.formFilters.expiration }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'expiration\')"></i></span> <span class="ui label" ng-if="vm.formFilters.card_type">{{ translate(\'CARD-TYPE\') }}: <span class="detail">{{ vm.formFilters.card_type | uppercase}}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'card_type\')"></i></span> <span class="ui label" ng-if="vm.formFilters.form_factor">{{ translate(\'FORM-FACTOR\') }}: <span class="detail">{{ vm.formFilters.form_factor | replaceUnderscore }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'form_factor\')"></i></span></div><div class="item" ng-if="vm.formFilters.minAmount || vm.formFilters.maxAmount"><span class="ui label" ng-if="vm.formFilters.minAmount">{{ translate(\'MIN-AMOUNT\') }}: <span class="detail">{{ vm.formFilters.minAmount }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'minAmount\')"></i></span> <span class="ui label" ng-if="vm.formFilters.maxAmount">{{ translate(\'MAX-AMOUNT\') }}: <span class="detail">{{ vm.formFilters.maxAmount }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'maxAmount\')"></i></span></div><div class="item" ng-if="vm.formFilters.fromTime || vm.formFilters.toTime"><span class="ui label">{{ translate(\'PERIOD\') }}: <span class="detail" ng-if="vm.formFilters.fromTime && vm.formFilters.toTime">{{ translate(\'FILTERSPERIOD-BOTH\', {fromTime: (vm.formFilters.fromTime | date:\'shortDate\'), toTime: (vm.formFilters.toTime | date:\'shortDate\')}) }}</span> <span class="detail" ng-if="vm.formFilters.fromTime && !vm.formFilters.toTime">{{ translate(\'FILTERSPERIOD-FROMTIME\', {fromTime: (vm.formFilters.fromTime | date:\'shortDate\')}) }}</span> <span class="detail" ng-if="!vm.formFilters.fromTime && vm.formFilters.toTime">{{ translate(\'FILTERSPERIOD-TOTIME\', {toTime: (vm.formFilters.toTime | date:\'shortDate\')}) }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove([\'fromTime\', \'toTime\'])"></i></span></div><div class="item" ng-if="vm.formFilters.charge_status || vm.formFilters.settlement_status"><span class="ui label" ng-if="vm.formFilters.charge_status">{{ translate(\'CHARGE-STATUS\') }}:<span class="detail">{{ vm.formFilters.charge_status }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'charge_status\')"></i></span> <span class="ui label" ng-if="vm.formFilters.settlement_status">{{ translate(\'SETTLEMENT-STATUS\') }}:<span class="detail">{{ vm.formFilters.settlement_status }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'settlement_status\')"></i></span></div><div class="item" ng-if="vm.formFilters.zone || vm.formFilters.route"><span class="ui label" ng-if="vm.formFilters.zone">{{ translate(\'ZONE\') }}:<span class="detail">{{ vm.formFilters.zone }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'zone\')"></i></span> <span class="ui label" ng-if="vm.formFilters.route">{{ translate(\'ROUTE\') }}:<span class="detail">{{ vm.formFilters.route }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'route\')"></i></span></div><div class="item" ng-if="vm.formFilters.terminal_id"><span class="ui label" ng-if="vm.formFilters.terminal_id">{{ translate(\'TERMINAL-ID\') }}:<span class="detail">{{ vm.formFilters.terminal_id }}</span> <i class="delete link icon ng-scope" ng-click="vm.remove(\'terminal_id\')"></i></span></div><div class="item" ng-if="vm.formFilters.order"><span class="ui label">{{ translate(\'ORDER-BY\') }}: <span class="detail">{{ vm.formFilters.order | replaceUnderscore }} in {{ formFilters.reverse && m.formFilters.reverse !== \'false\' ? \'ASC\' : \'DESC\'}}</span></span></div></div><p ng-if="vm.isEmpty(vm.formFilters)">{{ translate(\'NO-FILTER-IS-SELECTED\') }}</p>');
$templateCache.put('app/pages/admin/search/widgets/period.html','<div class="fields"><div class="four wide field"><label>{{ translate(\'FROM-DATE\') }}</label><ng-datepicker ng-model="vm.form.fromTime" class="datepicker-field" name="fromTime" not-after="vm.form.toTime" remove="vm.cleared"></ng-datepicker></div><div class="four wide field"><label>{{ translate(\'TO-DATE\') }}</label><ng-datepicker ng-model="vm.form.toTime" format="YYYY-MM-DD" view-format="DD/MM/YYYY" class="datepicker-field" placeholder="DD/MM/YYYY" name="toTime" not-before="vm.form.fromTime" remove="vm.cleared"></ng-datepicker></div></div>');
$templateCache.put('app/pages/admin/search/widgets/status.html','<div class="fields"><div class="four wide field"><label>{{ translate(\'CHARGE-STATUS\') }}</label><div class="ui search selection dropdown" name="charge_status" syn-ui-with-model="true" dropdown="" ng-model="vm.form.charge_status" dropdown-change="vm.statusChanged(filter, \'charge_status\')" default-text="{{ translate(\'SELECT-CHARGE-STATUS\') }}" clearable="true" cleared="vm.cleared"><i class="dropdown icon"></i><div class="text">{{ translate(vm.form.charge_status, undefined, \'GUARANTEESTATUS.\') }}</div><div class="menu"><div class="item" ng-repeat="(key, value) in vm.transactionFilters.paymentGuaranteeStatus" data-value="{{value}}">{{ translate(value, undefined, \'GUARANTEESTATUS.\') }}</div></div></div></div><div class="four wide field"><label>{{ translate(\'SETTLEMENT-STATUS\') }}</label><div class="ui search selection dropdown" name="settlement_status" syn-ui-with-model="true" dropdown="" ng-model="vm.form.settlement_status" dropdown-change="vm.statusChanged(filter, \'settlement_status\')" default-text="{{ translate(\'SELECT-SETTLEMENT-STATUS\') }}" clearable="true" cleared="vm.cleared"><i class="dropdown icon"></i><div class="text">{{ translate(vm.form.settlement_status | replaceUnderscoreWithDash, undefined, \'GUARANTEESTATUS.\') }}</div><div class="menu"><div class="item" ng-repeat="(key, value) in vm.transactionFilters.settlementResult" data-value="{{value}}">{{ translate(value, undefined, \'GUARANTEESTATUS.\') }}</div></div></div></div><div class="four wide field"><label>{{ translate(\'TERMINAL-ID\') }}</label><div class="ui fluid icon input"><input type="text" name="terminal_id" placeholder="{{ translate(\'TERMINAL-ID\') }}" ng-model="vm.form.terminal_id"> <i class="times link icon" ng-if="vm.form.terminal_id" ng-click="vm.remove(\'terminal_id\')"></i></div></div></div>');
$templateCache.put('app/pages/admin/search/widgets/trip.html','<div class="fields"><div class="four wide field"><label>{{ translate(\'ROUTE\') }}</label><div class="ui fluid icon input"><input type="text" name="route" placeholder="{{ translate(\'ROUTE\') }}" ng-model="vm.form.route"> <i class="times link icon" ng-if="vm.form.route" ng-click="vm.remove(\'route\')"></i></div></div><div class="four wide field"><label>{{ translate(\'TERMINAL-ID\') }}</label><div class="ui fluid icon input"><input type="text" name="terminal_id" placeholder="{{ translate(\'TERMINAL-ID\') }}" ng-model="vm.form.terminal_id"> <i class="times link icon" ng-if="vm.form.terminal_id" ng-click="vm.remove(\'terminal_id\')"></i></div></div></div>');
$templateCache.put('app/pages/admin/settings/settingsAccount/settingsAccount.html','<div class="wrapper settings-page-content" ng="AdminSettingsCtrl"><div class="alert alert-danger" ng-show="error && !pageLoading"><strong>{{ translate(\'WARNING\') }}</strong> <span>{{ translate(\'WARNING-MESSAGE\') }}</span></div><div ng-show="!pageLoading && !error"><div ng-include="\'app/pages/library/account/accountOwner/accountOwner.html\'"></div><section ng-show="isAdmin && !error"><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'STAFF-ACCOUNTS\') }}</h3><p class="settings-info">{{ translate(\'STAFF-ACCOUNTS-DETAILS\') }}</p></div><div class="col-md-8"><div ng-include="\'app/pages/library/account/accountUsers/accountUsers.html\'"></div></div></div></section><section ng-if="isAdmin && !error && feature_flags.RevenueInspection"><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'REVENUE-INSPECTION-USER-ACCOUNTS\') }}</h3><p class="settings-info">{{ translate(\'REVENUE-INSPECTION-ACCOUNTS-DETAILS\') }}</p></div><div class="col-md-8"><div ng-include="\'app/pages/library/account/accountUsers/accountRevenueInspectionUsers.html\'"></div></div></div></section></div></div><div ng-include="\'app/pages/admin/settings/settingsAccount/components/createUser.html\'"></div><div ng-include="\'app/pages/admin/settings/settingsAccount/components/deleteUser.html\'"></div><div ng-include="\'app/pages/admin/settings/settingsAccount/components/updatePassword.html\'"></div>');
$templateCache.put('app/pages/admin/settings/settingsAccountSummary/settingsAccountSummary.html','<div class="wrapper"><div ng-show="!pageLoading && !error"><div ng-include="\'app/pages/library/account/accountInfo/accountInfo.html\'"></div><section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'USER-ACCESS\') }}</h3><p class="settings-info">{{ translate(\'USER-ACCESS-DETAILS\') }}</p></div><div class="col-md-8"><form ng-submit="save()"><div ng-repeat="(key, participant) in userModel.participantAccounts" ng-include="\'app/pages/library/account/updateAccount/updateAccount.html\'"></div></form></div></div></section><div ng-include="\'app/pages/library/account/deleteAccount/deleteAccount.html\'"></div></div></div>');
$templateCache.put('app/pages/admin/settings/settingsGeneral/settingsGeneral.html','<div class="wrapper" ng-show="!pageLoading"><div class="alert alert-danger" ng-show="error && !pageLoading"><strong>{{ translate(\'WARNING\') }}</strong> {{ translate(\'WARNING-MESSAGE\') }}</div><div ng-include="\'app/pages/admin/settings/settingsGeneral/components/participantInfo.html\'"></div><div ng-if="isParent" ng-include="\'app/pages/admin/settings/settingsGeneral/components/childParticipants.html\'"></div><div ng-if="!isParent" ng-include="\'app/pages/admin/settings/settingsGeneral/components/merchantSettings.html\'"></div></div>');
$templateCache.put('app/pages/library/account/accountInfo/accountInfo.html','<section ng-controller="AccountInfoCtrl"><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'ACCOUNT-INFORMATION\') }}</h3><p class="settings-info">{{ translate(\'ACCOUNT-INFORMATION-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'USER-PROFILE\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'ID\') }}</div><div class="col-xs-8 participant-id-text">{{ userModel.user.id }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'EMAIL\') }}</div><div class="col-xs-8 participant-id-text">{{ userModel.user.email }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'EMAIL-VERIFIED\') }}</div><div class="col-xs-8 participant-id-text">{{ translate(userModel.user.email_verified ? \'VERIFIED\' : \'PENDING\') }}</div></div></li><li class="list-group-item" ng-if="selectedAccount != undefined"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'ROLE\') }}</div><div class="col-xs-8 participant-id-text">{{ translate(userModel.user.app_meta_data.participants[selectedAccount].role | capitalize) }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'LAST-LOGIN\') }}</div><div class="col-xs-8 participant-id-text"><span ng-if="userModel.user.last_login"><short-medium-date-time ng-model="userModel.user.last_login"></short-medium-date-time></span> <span ng-if="!userModel.user.last_login">{{ translate(\'INVITATION-SENT\') }}</span></div></div></li></ul></div></div></div></section>');
$templateCache.put('app/pages/library/account/accountOwner/accountOwner.html','<section ng-controller="accountOwnerCtrl"><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'ACCOUNT-OWNER\') }}</h3><p class="settings-info">{{ translate(\'ACCOUNT-OWNER-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'ACCOUNT-OWNER\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'EMAIL\') }}</div><div class="col-xs-8 participant-id-text">{{ profile.email }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'EMAIL-VERIFIED\') }}</div><div class="col-xs-8 participant-id-text">{{ translate(profile.email_verified ? \'VERIFIED\' : \'PENDING\') }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'ROLE\') }}</div><div class="col-xs-8 participant-id-text">{{ translate(isAdmin ? \'ADMIN\' : \'USER\') }}</div></div></li><li ng-if="!isAdmin && profile.account.permissions" class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'PERMISSIONS\') }}</div><div class="col-xs-8 participant-id-text"><span ng-repeat="permission in profile.account.permissions"><span class="label label-warning">{{ translate(permission | uppercase) }}</span></span> <span ng-if="profile.account.permissions.length === 0">{{ translate(\'NO-PERMISSIONS-SET\') }}</span></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'MEMBER-SINCE\') }}</div><div class="col-xs-8 participant-id-text">{{ profile.created_at | date: \'medium\'}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'LAST-PASSWORD-RESET\') }}</div><div class="col-xs-8 participant-id-text">{{ profile.last_password_reset | date:\'medium\' }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'PASSWORD\') }}</div><div class="col-xs-8 participant-id-text"><a class="ui button basic primary" ng-click="changePasswordClick()"><i class="icon key"></i> {{ translate(\'CHANGE-PASSWORD\') }}</a></div></div></li></ul></div></div></div></section>');
$templateCache.put('app/pages/library/account/accountUsers/accountRevenueInspectionUsers.html','<div ng-controller="accountRevenueInspectionUsersCtrl as vm"><div class="ui segments userAccountSegment"><div class="segment clearing ui tableFilters"><a ng-if="!isParent" class="ui labeled icon button green small right floated tooltip-icon" ng-click="callModalClick(\'createRevenueInspectionAccountModal\')" title="{{ translate(\'ADD-REVENUE-STAFF-ACCOUNT\') }}"><i class="plus icon"></i> {{ translate(\'ADD-REVENUE-STAFF-ACCOUNT\') }}</a></div><div ng-if="isAdmin" class="segment ui no-padding" ng-class="{\'loading\': !pageLoaded}"><table class="ui table"><thead><tr class="header"><th class="center aligned">#</th><th>{{ translate(\'EMAIL\') }}</th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.userModel.allUsers"><td data-th="#" class="collapsing center aligned">{{ ((vm.userModel.currentPage - 1) * vm.userModel.pagination.limit) + 1 + $index }}</td><td><span ng-if="user.email !== profile.email" ng-href="admin/settings/account/{{user.id}}">{{user.email}}</span> <span ng-if="user.email === profile.email">{{user.email}} - {{ translate(\'ACCOUNT-OWNER\') }}</span></td><td><a ng-if="(user.email !== profile.email) && !isParent" class="btn btn-xs btn-danger tooltip-icon pull-right" ng-click="callModalClick(\'deleteRevenueInspectionAccountModal\', user)"><i class="fa fa-trash-o"></i></a> <a ng-if="(user.email !== profile.email) && !isParent" class="btn btn-xs btn-info tooltip-icon pull-right" ng-click="callModalClick(\'editRevenueInspectionAccountModal\', user)" title="{{translate(\'CHANGE-PASSWORD\')}}"><i class="fa fa-pencil"></i></a></td></tr></tbody><tfoot><tr><th colspan="5"><page-results-summary ng-model="vm.userModel" on-page-click="vm.onPageClickRevenueInspectionUsers"></page-results-summary><h4 class="ui red" ng-if="vm.userModel.allUsers.length === 0">{{ translate(\'NOT-FOUND\')}}</h4></th></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/library/account/accountUsers/accountUsers.html','<div ng-controller="accountUsersCtrl"><div class="ui stackable doubling celled grid form no-gap" ng-if="isParent"><div class="four column row filtersSection"><div class="column"><div class="field"><div class="ui floating labeled icon dropdown basic button" dropdown="" ng-model="userModel.group" dropdown-change="participantChanged" default-text="Select Participant"><i class="filter icon"></i> <span class="text"></span><div class="menu"><div class="item" data-value="">{{ translate(\'PARENT-AND-ALL-CHILDREN\') }}</div><div class="item" ng-repeat="participant in participantModel.currentParticipant.child_participants" data-value="{{participant.id}}">{{participant.id}}</div></div></div></div></div></div></div><div class="ui segments userAccountSegment"><div class="segment clearing ui tableFilters"><a ng-if="!isParent" class="ui labeled icon button green small right floated tooltip-icon" ng-click="callModalClick(\'createStaffAccountModal\')" title="{{ translate(\'ADD-STAFF-ACCOUNT\') }}"><i class="plus icon"></i> {{ translate(\'ADD-STAFF-ACCOUNT\') }}</a> <a ng-if="isParent" class="ui labeled icon button green small right floated tooltip-icon" href="/parent/users/new-user" title="{{ translate(\'ADD-STAFF-ACCOUNT\') }}"><i class="plus icon"></i> {{ translate(\'ADD-STAFF-ACCOUNT\') }}</a></div><div ng-if="isAdmin" class="segment ui no-padding" ng-class="{\'loading\': !pageLoaded}"><table class="ui table"><thead><tr class="header"><th class="center aligned">#</th><th>{{ translate(\'EMAIL\') }}</th><th>{{ translate(\'LAST-LOGIN\') }}</th><th></th><th ng-if="!isParent"></th></tr></thead><tbody><tr ng-repeat="user in userModel.allUsers"><td data-th="#" class="collapsing center aligned">{{ 1 + $index }}</td><td ng-if="!isParent"><a ng-if="user.email !== profile.email" ng-href="admin/settings/account/{{user.id}}">{{user.email}}</a> <span ng-if="user.email === profile.email">{{user.email}} - {{ translate(\'ACCOUNT-OWNER\') }}</span></td><td class="panel-t" ng-if="isParent"><a ng-if="user.email !== profile.email" ng-href="parent/users/{{user.id}}">{{user.email}}</a> <span ng-if="user.email === profile.email">{{user.email}} - {{ translate(\'ACCOUNT-OWNER\') }}</span></td><td><span ng-if="user.last_login">{{user.last_login | date:\'short\' }}</span> <span ng-if="!user.last_login">{{ translate(\'INVITATION-SENT\') }}</span></td><td ng-if="!isParent"><p class="table-upper-text uppercase" ng-class="{\'text-success\': \'admin\'=== (user.participants.role || user.app_meta_data.participants[0].role) ,\'text-info\': \'user\' === (user.participants.role || user.app_meta_data.participants[0].role) }">{{ translate((user.participants.role || user.app_meta_data.participants[0].role) | uppercase) }}</p><small ng-if="user.participants.role === \'user\' && user.participants.permissions"><span ng-repeat="permission in user.participants.permissions">{{ \'PERMISSIONS.\' + ( permission | uppercase ) | translate }}{{$last ? \'\' : \', \'}}</span></small></td><td ng-if="(user.email !== profile.email) && !isParent"><a class="btn btn-xs btn-danger tooltip-icon" ng-click="callModalClick(\'deleteStaffAccountModal\', user)"><i class="fa fa-trash-o"></i></a></td><td ng-if="isParent"><span class="label label-block label-warning margin-right1 pull-right" ng-repeat="participant in user.app_meta_data.participants" ng-class="{\'label-parent\': participant.parent}"><span class="label-inner">{{participant.name}}</span></span></td></tr></tbody><tfoot ng-if="userModel.allUsers.length === 0"><tr><th colspan="5"><h4 class="ui red">{{ translate(\'NOT-FOUND\')}}</h4></th></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/library/account/deleteAccount/deleteAccount.html','<div ng-controller="DeleteAccountCtrl"><section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'REMOVE-USER-ACCOUNT\') }}</h3></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'DELETE-ACCOUNT\') }}</h5></div><ul class="list-group"><li class="list-group-item"><p>{{ translate(\'MESSAGE\') }}</p><br><p><a href="#" class="btn btn-danger" ng-click="deleteUserAccount()" data-toggle="modal" data-target="#confirm-delete"><i class="fa fa-fw fa-trash-o"></i> {{ translate(\'DELETE-USER-ACCOUNT\') }}</a></p></li></ul></div></div></div></section></div>');
$templateCache.put('app/pages/library/account/updateAccount/updateAccount.html','<div ng-controller="UpdateAccountCtrl" class="updateSelectedParticipantForm clearfix" ng-class="{\'nonSelectedChild\': isParent && !participant.selected, \'col-lg-4 col-md-6 col-sm-6\': isParent }" ng-init="test(key)"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{participant.name}}</h5><ul class="panel-btn" ng-if="!isParent"><li><button type="submit" class="btn panel-collapse tooltip-icon btn-primary">{{ translate(\'SAVE\') }}</button></li></ul><ul class="panel-btn" ng-if="isParent"><li ng-if="participant.selected"><a href="#" class="btn panel-collapse tooltip-icon" title="{{ translate(\'REMOVE-PARTICIPANT-ACCOUNT\') }}" ng-click="updateAccountSelection($event, key)" ng-class="{\'btn-danger\': participant.selected }"><i ng-if="participant.selected" class="fa fa-minus"></i></a></li></ul></div><ul class="list-group" ng-if="(isParent && participant.selected) || !isParent"><li class="list-group-item clearfix"><div class="form-group"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="user-{{key}}" name="userRole-{{key}}" class="modal-repeat-role-field" ng-model="participant.role" value="user"> <label for="user-{{key}}" class="modal-role-label">{{ translate(\'USER\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="admin-{{key}}" name="userRole-{{key}}" class="modal-repeat-role-field" ng-model="participant.role" value="admin"> <label for="admin-{{key}}" class="modal-role-label">{{ translate(\'ADMIN\') }}</label></div></div></li><li class="list-group-item clearfix accountAccessBoxes"><div ng-class="{\'disable\': participant.role === \'admin\'}"></div><p>{{ translate(\'MESSAGE\') }}</p><div class="form-group"><div class="toggle-button toggle-button--checkbox margin-right1" ng-repeat="permission in permissionModel.list.permissions"><input id="{{permission.name}}-{{participant.name}}" type="checkbox" class="modal-repeat-role-field" ng-model="participant.permissions[permission.name]"> <label for="{{permission.name}}-{{participant.name}}">{{ \'PERMISSIONS.\' + (permission.name | uppercase) | translate }}</label></div></div></li></ul><div class="panel-body noSelectedAccountAccessBox" ng-if="(isParent && !participant.selected)"><h5 class="text-center uppercase"><a href="#" class="btn panel-collapse tooltip-icon btn-sm" title="{{ translate(\'ADD-PARTICIPANT-ACCOUNT\') }}" ng-click="updateAccountSelection($event, key)" ng-class="{\'btn-danger\': participant.selected, \'btn-success\': !participant.selected}">{{ translate(\'ADD-ACCOUNT\') }}</a></h5></div></div></div>');
$templateCache.put('app/pages/library/notifications/notificationSummary/notificationSummary.html','<div class="wrapper wrapper-white" ng-show="!pageLoading"><div class="row notificationSummary"><div class="col-md-10 col-md-offset-1"><div class="page-subtitle"><h3>{{notification.title}}</h3><p class="date">{{notification.date | date:\'shortDate\'}}</p></div><div><div ng-if="!notification.hideSummaryOnDetailPage" ng-bind-html="notification.summary"></div><ng-include src="notification.body"></ng-include><br><h5>Best Regards,<br>Littlepay Team</h5></div></div></div></div>');
$templateCache.put('app/pages/library/notifications/notifications/notifications.html','<div class="wrapper" ng-show="!pageLoading"><div ng-repeat="n in notifications | orderBy:\'-\'" class="wrapper wrapper-white notificationSummary {{n.status}}"><h4>{{n.title}}</h4><p class="date">{{ n.date | date:\'shortDate\' }}</p><div ng-bind-html="n.summary"></div><a ng-href="/admin/notifications/{{n.key}}" class="readMoreLink" ng-click="advancedSearch()" ng-if="!isParent">Read More <i class="fa fa-caret-right fa-fw"></i></a> <a ng-href="/parent/notifications/{{n.key}}" class="readMoreLink" ng-click="advancedSearch()" ng-if="isParent">Read More <i class="fa fa-caret-right fa-fw"></i></a></div></div>');
$templateCache.put('app/pages/library/notifications/widget/cappingProductEnhancements.html','<p>There are now a few new sections under the Products page that must be configured in the same order before setting up your capping rules. Setting up these configuration rules is optional.</p><p>These new sections are:</p><ul class="decimal"><li>Pricing Period</li><li>Exception Period</li><li>Zones</li></ul><br><p>Let us take you through each page and show you the new features.</p><h3>Pricing Period</h3><p>The Pricing Period Page is where you can enable your peak and off-peak periods for your journeys. The steps involved are:</p><ul class="no-list"><li><strong class="label label-info margin-right1">Step 1:</strong> Name your rule. In the example we have called the rule \u201CWEEKDAY\u201D.</li><li><strong class="label label-info margin-right1">Step 2:</strong> Add the desired days for your rule. You can do this by \u2018clicking\u2019 on any day of the week. In the example we have selected \u2018Monday, Tuesday, Wednesday, Thursday and Friday.\u2019</li><li><strong class="label label-info margin-right1">Step 3:</strong> Set up the peak period intervals within the rule. You can set up multiple peak periods. To do this, double click on the right hand side of the slider bar. This will then display a \u2018Time Interval\u2019 segment, that you can move on the slider to set your desired times and length. To remove a peak segment click on the "x" button on the table below the slider.</li><li><strong class="label label-info margin-right1">Step 4:</strong> Once you have completed adding your peak periods, go to the \u2018summary section\u2019 on the right hand side of the screen. Every setting entered will be displayed in this summary section. Once you are finished please click on the green save button to save your \u2018Pricing Period Rule.\u2019</li></ul><br><img class="image" src="assets/images/notifications/PricingPeriod.gif"><br><ul class="no-list"><li><strong class="label label-info margin-right1">Step 5:</strong>To modify (or switch between) each rule go to the \u2018summary section\u2019 and click on yellow<u>"EDIT"</u>button of the rule you wish to change. Please make sure to save your changes by clicking the green<u>\u201CSAVE\u201D</u>button, to prevent any loss of changes made.</li></ul><p class="text-warning"><span class="label label-danger margin-right1">NOTE!</span>You can add as many rules as you would like. All you need to do is to click on the "Add Another Rule" button on the top right corner and repeat steps 1 through to 4. You cannot use the same week days in multiple rules. Please make sure each rule has unique days. If you selected Monday to Friday in the \u2018WEEKDAY\u2019 rule for example you can only use SATURDAY or SUNDAY for the new rules you are configuring.</p><br><br><h3>Exception Period</h3><p>The Exception period page allows you to configure and add specific exceptions to your peak and off-peak periods. For example, exceptions may be recurring annual holidays (e.g., Christmas Day) or special events during the year. To add a new exception period, click on the "Add an exception" link.</p><p>Specify the date for the exception and have the option of configuring this as a once off or annually, as well as whether it is to be applied to the peak or off-peak period. Make sure you save the Exception period once completed. You also on this page, Delete or Modify an existing Exception Period.</p><br><img class="image" src="assets/images/notifications/ExceptionPeriod.gif"><br><br><br><h3>Zones</h3><p>The Zones page is where you configure and add zones that you would like to apply to your Capping Product. Each zone needs to be configured with at least one Device Zone ID.</p><p>To add a new zone, click on the "Add a new zone" link. Ensure you have saved your zone once you have added the name and Zone Terminal IDs. This page also allows you to delete or update an existing zone.</p><p class="text-warning"><span class="label label-danger margin-right1">NOTE!</span>For correct Zone IDs, please refer to or contact your device vendor and ensure this ID is the same as what is entered in this page.</p><br><img class="image" src="assets/images/notifications/Zones.gif"><br><br><h3>Capping</h3><p>To add a new Capping Product, go to \u201CCapping\u201D and from this summary page (that will list all your capping products), click on the "Add Capping" button. You will be able to configure capping by the following fields:</p><table class="table table-bordered"><tr><th>Status</th><td>There are two options available: Active or Inactive. Active means that your capping product will become live. Inactive provides you with the option to configure a product and save it to use at a later stage when activated.</td></tr><tr><th>Activation Type</th><td>There are two options available: \u2018All Customers\u2019 or \u2018All Registered Customers\u2019. This allows you to apply your capping product to just your registered customers if you would prefer, or to all your customers.</td></tr><tr><th>Capping Type</th><td>Currently \u2018Daily\u2019 is the only option available. \u2018Weekly\u2019 will be coming soon.</td></tr><tr><th>Product Code</th><td>This is a unique code that you would like to assign to your Product for identification purposes</td></tr><tr><th>Description</th><td>The description for your product, typically used as a descriptor for the type of product purchased, shown on a merchant\u2019s customer portal or customer statement.</td></tr><tr><th>Cap Trigger Amount</th><td>The amount from which capping will be applied</td></tr><tr><th>Max Fare Amount</th><td>The maximum fare amount that applies to capping. Amounts over this limit will not be included in the cap.</td></tr><tr><th>Start time</th><td>The time of day the daily cap product applies from</td></tr><tr><th>Finish time</th><td>The time of day the daily cap product finishes</td></tr><tr><th>Capping Application Level</th><td>Whether the capping is applied at a customer level or card level</td></tr><tr><th>Transaction Types</th><td>This determines the transaction type that the capping will be applied to. It is mandatory that \u2018Autoscan\u2019 is selected and then either Variable or Flat or both, depending on what Fare types you wish Capping to apply to.</td></tr></table><p>Once you have completed your Product Capping details, create the product. You will be taken to the \u2018Capping Product\u2019 Summary page. The next step is to add product and zone rules to your new capping product. Click on the \u2018Edit\u2019 button, of the product you wish to configure. In the Product Summary page, three main tabs: Products Settings, Product Rules and Zone Rules.</p><p>Clicking on the \u2018Product Settings tab\u2019 will provide you with a summary of the default product settings that you previously configured. It is here where you can \u2018Modify\u2019 the default settings of your product and \u2018Delete\u2019 your Capping Product.</p><p>Clicking on the \'Product Rules tab\', allows you to not only modify the existing rules you have applied to your capping product, but also enable \'Route Capping\' by entering in route IDs. Given that users will enter in routes using \'free text\' it is important that the route information is captured correctly, otherwise the rule will not be incorporated as part of the capping product.</p><br><img class="image" src="assets/images/notifications/ProductSummaryPage2.jpg"><br><p>Finally by clicking on Zone Rules tab, you can set up the zones you wish to add to your Capping Product. In the \u2018Zone Options\u2019 Window, select \u2018Yes\u2019 to enable Zone-Based Capping.</p><p>The \u2018Peak / Off-peak Capping Preference\u2019 setting is used to specify which capping trigger amount is applied when a customer travels across peak and off-peak periods. For example, when one trip is done during peak time period, then three trips are performed in the off-peak time period, the system needs to determine which capping trigger amounts to apply. The options available are:</p><ul class="decimal"><li>Peak: when travel occurs during both peak and off-peak periods, the customer pays no more than the cap trigger amounts set within the \'peak\' tab</li><li>Off-peak: when travel occurs across both peak and off-peak periods, the customer pays no more than the cap trigger amounts set for the \'off-peak\' tab</li><li>Most-Expensive: when travel occurs across both peak and off-peak periods, the customer pays no more than the most expensive cap trigger amount from the amounts set in both \'peak\' and \'off-peak\' tabs</li><li>Least expensive: when travel occurs across both peak and off-peak periods, the customer pays no more than the least expensive cap trigger amount from the amounts set in both \'peak\' and \'off-peak\' tabs</li></ul><p>Next you have the ability to set capping trigger and maximum fare values for each zone combination for both peak and off-peak periods. Simply select each zone to include it in the table, and deselect the zone to exclude it from the table. You also have the option to \u2018Activate\u2019 or \u2018Deactivate\u2019 each rule. Once the table is updated, please ensure that it is saved before switching between the peak and off peak tabs.</p><p>This section of the Merchant Portal Zone set up is quite complex and our Support Team is happy to assist you with this set up.</p><br>While you will be able to see these new pages within our Merchant Portal, they will not be functional until our Support Team have enabled this functionality for you. Please contact our Support Team so we work with you to enable this via our Operational Portal and assist you in setting up your Zone and Route Based Capping Products.<p></p>');
$templateCache.put('app/pages/library/notifications/widget/customerSearch.html','<p>You will notice new filters above the customers list that replaces the old Search page.<br><br><img class="image" src="assets/images/notifications/newFiltersFeatureinCustomersPage.jpg"><br><br>Please contact our Support Team if you have any questions about these new features.</p>');
$templateCache.put('app/pages/library/notifications/widget/customersAndTransactions.html','<p>Customer transactions can be filtered by credit/debit card, transaction date range, payment and settlement status.<br><br><img class="image" src="assets/images/notifications/newCustomerSummaryPageLayout.jpg"><br><br>Please contact our Support Team if you have any questions about these new features.</p>');
$templateCache.put('app/pages/library/notifications/widget/deviceAssignments.html','<p>A full history of device assignments can be viewed from the Devices - Assignments page. On this page you will see when a device has been assigned away from your account or has been assigned to your account from another merchant.<br><img class="image" src="assets/images/notifications/deviceManagementAndAssignmentsImprovements.jpg"><br><br>Please contact our Support Team if you have any questions about these new features.</p>');
$templateCache.put('app/pages/library/notifications/widget/fareCorrections.html','<p>Approving, issuing and tracking your customer correction requests has never been easier. The corrections list gives an overview of your requests and can be filtered by approval status or by initiator (you or the customer).<br><br>Issuing a refund or correcting a fare is also easier. Use the Make Correction page to search for customer transactions. You will need to know the truncated PAN and can enhance your search with the card expiry date, date range of transaction and transaction amount.<br><img class="image" src="assets/images/notifications/DashboardHasExtandedWithNewCorrectionsSection.jpg"><br><br></p><p>Please contact our Support Team if you have any questions about these new features.</p>');
$templateCache.put('app/pages/library/notifications/widget/merchantAnalytics.html','<p>All Admin users of the Littlepay Merchant Portal, have now been provided access to our new Merchant Analytics modules allowing access to analyse Transactions, Corrections, Declines and Debt Recovery. Each module delivers graphical and tabular data that can be downloaded into a CSV file.</p><p>Having spoken to various transit operators about your unique transit reporting tasks, we believe our new modules will allow you to access the key transit-related payments metrics to support your business intelligence needs.</p><p><img class="image" src="assets/images/notifications/merchantAnalytics.png"></p><p><b>When will I gain access?</b></p><p>We have activated these modules on all Admin users of your Merchant Portal account. When logging into the Merchant Portal, you will be provided with a new menu item called \'Analysis\', which contains the four modules mentioned above. These four modules form our Merchant Analytics \u201CBasic\u201D tier. All admin users will have access to these modules by default and will be able to enable other users to access these modules.</p><p><b>What about future functionality?</b></p><p>In future, we will also be releasing a \'Customers\' module,that will form part of our Merchant Analytics \u201CAdvanced\u201D tier. The \u2018Customers\u2019 module will allow you to deep dive into your customer segments, whether it be engagement, repeat purchase behaviour or loyalty, preferred modes (e.g., retail vs. variable fare), products or channels (e.g., online payments via website vs. contactless). If you would like further information about this please contact us.</p><p><b>Help us improve our product</b></p><p>Littlepay is looking forward to working with you to build our Merchant Analytics platform so if you have any feedback please provide to product@littlepay.com.</p>');
$templateCache.put('app/pages/library/notifications/widget/merchantAnalyticsDeclines.html','<p>Based on feedback we have have had from our customers we have updated the Merchant Analytics Modules with two key new features:</p><ul><li>Ability to select any date range, since my service went live, across all the analytics modules, with a maximum 90-days of data allowed to be picked between start and end date</li><li>Ability to filter data, in the Declines analytic Screen, based on one or multiple selection of decline reasons. See screen shots below.</li></ul><p><img class="image" src="assets/images/notifications/merchantAnalyticsDeclines1.png"></p><p><img class="image" src="assets/images/notifications/merchantAnalyticsDeclines2.png"></p><p>These enhancements will provide our customers with the ability to drill down into their customer data, to assist with identifying any patterns across both recent and historical data.</p><p>We are always looking at ways we can enhance our Merchant Analytics Platform, so if you have any feedback please provide to <a href="mailto:product@littlepay.com">product@littlepay.com</a>.</p>');
$templateCache.put('app/pages/library/notifications/widget/merchantGroupHierarchy.html','<p>You will need us to grant admin permissions to your group account. You can do this by emailing our Support Team.</p><p>After logging in to the dashboard, you will notice the parent/group account is accessible from the top right menu icon. You can switch between accounts by selecting the merchant from the list.<br><br>When logged in to a parent account, you will be able to manage your users, across child accounts, granting user access to the merchants within your group.<br><img class="image" src="assets/images/notifications/parentChildAccountManagement.jpg"><br><br></p><p>Please contact our Support Team if you have any questions about these new features.</p>');
$templateCache.put('app/pages/library/notifications/widget/merchantPortalManualDebtRecovery.html','<p>To do this upon receiving a call from a customer, advising they have cleared the debt from their card, go to the \'Customers\' page and search for their card number. Once you have located their \'Customer Summary\' page, click on the tab \'Cards\', and you will see that they are on the \'Deny list\'.<br>There will also be a button available for you to click, that will instigate debt recovery with their issuing bank. As long as the debt has been cleared, the customer\'s card will be removed from the Deny List and they will be able to travel, with this card.<br>Note for a VISA card there are no specific limits on how many debt recovery attempts you can make but for Mastercard two is the limit per day.</p><br><img class="image" src="assets/images/notifications/merchantPortalManualDebtRecovery.jpg"><br><br><p>Please contact our Support Team if you have any questions about these new features.</p>');
$templateCache.put('app/pages/parent/users/newUser/newUser.html','<div class="wrapper wrapper-white" ng-show="!pageLoading"><notification-message ng-model="newUserNotificationMessage"></notification-message><form name="newUserForm" id="newUserForm" ng-submit="save(user, newUserForm)" novalidate="" autocomplete="off"><div class="form-group row" ng-class="{\'has-feedback\': newUserForm.$submitted || newUserForm.userEmail.$touched, \'has-error\': !newUserForm.userEmail.$valid && (newUserForm.$submitted || newUserForm.userEmail.$touched)}"><label for="userEmail" class="col-sm-2 col-form-label text-right">{{ translate(\'EMAIL\') }}</label><div class="col-sm-10"><input class="form-control" type="email" name="userEmail" placeholder="{{ translate(\'EMAIL\') }}" ng-model="user.email" required=""> <span ng-show="newUserForm.$submitted || newUserForm.userEmail.$touched"><i class="fa-times fa form-control-feedback" ng-show="newUserForm.userEmail.$error.required || !newUserForm.userEmail.$valid" aria-hidden="true"></i> <span ng-show="!newUserForm.userEmail.$valid" class="help-text text-danger">{{ translate(\'EMAIL-HELP-ERROR\') }}</span></span></div></div><div class="form-group row" ng-class="{\'has-feedback\': newUserForm.$submitted || newUserForm.userPassword.$touched, \'has-error\': !newUserForm.userPassword.$valid && (newUserForm.$submitted || newUserForm.userPassword.$touched) }"><label for="userPassword" class="col-sm-2 col-form-label text-right">{{ translate(\'PASSWORD\') }}</label><div class="col-sm-10"><input type="password" class="form-control" name="userPassword" placeholder="{{ translate(\'PASSWORD\') }}" ng-model="user.password" autocomplete="new-password" required="" pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"> <span ng-show="newUserForm.$submitted || newUserForm.userPassword.$touched"><i class="fa-times fa form-control-feedback" ng-show="newUserForm.userPassword.$error.required || !newUserForm.userPassword.$valid" aria-hidden="true"></i> <span ng-show="!newUserForm.userPassword.$valid" class="help-text text-danger">{{ translate(\'PASSWORD-HELP-ERROR\') }}</span></span></div></div><div class="form-group row" ng-class="{\'has-feedback\': newUserForm.$submitted || newUserForm.userRepeatPassword.$touched, \'has-error\': !newUserForm.userRepeatPassword.$valid && newUserForm.userPassword.$valid && (newUserForm.$submitted || newUserForm.userRepeatPassword.$touched) }"><label for="userRepeatPassword" class="col-sm-2 col-form-label text-right">{{ translate(\'REPEAT-PASSWORD\') }}</label><div class="col-sm-10"><input type="password" class="form-control" name="userRepeatPassword" placeholder="{{ translate(\'REPEAT-PASSWORD\') }}" ng-model="user.repeatPassword" autocomplete="new-password" required="" pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"> <span ng-show="(newUserForm.$submitted || newUserForm.userRepeatPassword.$touched) && newUserForm.userPassword.$valid"><i class="fa-times fa form-control-feedback" ng-show="newUserForm.userRepeatPassword.$error.required || (newUserForm.userPassword.$valid && !newUserForm.userRepeatPassword.$valid)" aria-hidden="true"></i> <span ng-show="!newUserForm.userRepeatPassword.$valid" class="help-text text-danger">{{ translate(\'REPEAT-PASSWORD-HELP-ERROR\') }}</span></span></div></div><br><div class="form-group row"><label for="userParent" class="col-sm-2 col-form-label text-right"></label><div class="col-sm-10"><div class="toggle-button toggle-button--checkbox margin-right1"><input id="userAllChildren" name="userAllChildren" type="checkbox" class="modal-repeat-role-field" ng-model="assignToAllChildren"> <label for="userAllChildren">{{ translate(\'ACCESS-CHILD-PARTICIPANTS\') }}</label> <span ng-show="newUserForm.$submitted && !newUserForm.userAllChildren.$valid"><span class="help-text text-danger">{{errorMessage}}</span></span></div></div></div><div class="form-group row"><label for="userParent" class="col-sm-2 col-form-label text-right"></label><div class="col-sm-10"><div class="toggle-button toggle-button--checkbox margin-right1"><input id="userParent" name="userParent" type="checkbox" class="modal-repeat-role-field" ng-model="user.assignToParent"> <label for="userParent">{{ translate(\'ACCESS-TO-PARENTS\') }}</label> <span ng-show="newUserForm.$submitted && !newUserForm.userParent.$valid"><span class="help-text text-danger">{{errorMessage}}</span></span></div></div></div><div class="form-group row" ng-if="assignToAllChildren && !user.assignToParent"><label for="userParent" class="col-sm-2 col-form-label text-right"></label><div class="col-sm-10"><div class="toggle-button toggle-button--checkbox margin-right1"><input id="issueRefundForchildren" name="issueRefundForchildren" type="checkbox" class="modal-repeat-role-field" ng-model="permissions.allChildrenIssueRefund" ng-true-value="\'IssueRefund\'"> <label for="issueRefundForchildren">{{ translate(\'ISSUE-REFUND\') }}</label></div><div class="toggle-button toggle-button--checkbox margin-right1"><input id="getAccessLinksForchildren" name="getAccessLinksForchildren" type="checkbox" class="modal-repeat-role-field" ng-model="permissions.allChildrenGetAccessLinks" ng-true-value="\'GetAccessLinks\'"> <label for="getAccessLinksForchildren">{{ translate(\'GET-ACCESS-LINKS\') }}</label></div><div class="toggle-button toggle-button--checkbox margin-right1"><input id="writeProductsForchildren" name="writeProductsForchildren" type="checkbox" class="modal-repeat-role-field" ng-model="permissions.allChildrenWriteProducts" ng-true-value="\'WriteProducts\'"> <label for="writeProductsForchildren">{{ translate(\'WRITE-PRODUCTS\') }}</label></div><div class="toggle-button toggle-button--checkbox margin-right1"><input id="viewAnalyticsForchildren" name="viewAnalyticsForchildren" type="checkbox" class="modal-repeat-role-field" ng-model="permissions.allChildrenViewAnalytics" ng-true-value="\'AccessAnalytics\'"> <label for="viewAnalyticsForchildren">{{ translate(\'VIEW-ANALYTICS\') }}</label></div></div></div><div class="form-group row" id="selectChildParticipant" ng-if="!assignToAllChildren"><div class="col-sm-10 col-sm-offset-2"><div class="row"><div ng-repeat="(key, participant) in userModel.participantAccounts" ng-include="\'app/pages/library/account/updateAccount/updateAccount.html\'"></div></div></div></div><div class="form-group row"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-primary">{{ translate(\'CREATE-USER\') }}</button></div></div></form></div>');
$templateCache.put('app/pages/parent/users/userSummary/userSummary.html','<div class="wrapper"><div ng-show="!pageLoading && !error"><div ng-include="\'app/pages/library/account/accountInfo/accountInfo.html\'"></div><section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'ACCOUNT-ACCESS\') }}</h3><p class="settings-info">{{ translate(\'ACCOUNT-ACCESS-INFO\') }}</p></div><div class="col-md-8"><form ng-submit="save()"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'ACCESSIBLE-ACCOUNTS\') }}</h5><ul class="panel-btn" ng-if="isParent"><li><button type="submit" class="btn panel-collapse tooltip-icon btn-primary" tooltip-side="top" ng-click="updateAccountSelection($event, key)">{{ translate(\'SAVE\') }}</button></li></ul></div><div class="panel-body"><div class="row border-bottom margin-bottom summaryParentParticipant"><div class="col-xs-4 participant-id-label panel-t">{{ translate(\'PARENT-PARTICIPANT\') }}</div><div class="col-xs-8 participant-id-text"><div class="toggle-button toggle-button--checkbox margin-right1"><input id="userParent" name="userParent" type="checkbox" class="modal-repeat-role-field" ng-model="userModel.assignedToParent"> <label for="userParent">&nbsp;</label></div></div></div><div class="row"><div ng-repeat="(key, participant) in userModel.participantAccounts" ng-include="\'app/pages/library/account/updateAccount/updateAccount.html\'"></div></div></div></div></form></div></div></section><div ng-include="\'app/pages/library/account/deleteAccount/deleteAccount.html\'"></div></div></div>');
$templateCache.put('app/pages/parent/users/users/users.html','<div class="wrapper"><div ng-include="\'app/pages/library/account/accountUsers/accountUsers.html\'"></div></div>');
$templateCache.put('app/pages/admin/analysis/corrections/widgets/correctionsData.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding analytics-heading"><thead><tr><th><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div><h3>{{ translate(\'CORRECTIONS-DATA\') }}</h3></th></tr></thead></table><table class="ui table fixed-padding analytics-data"><tr><th width="{{vm.getColWidth(0)}}" class="force-center-align">{{ translate(\'SUBMIT-DATE\') }}</th><th width="{{vm.getColWidth(1)}}" ng-if="vm.isAtParentLevel()">{{ translate(\'CHILD-PARTICIPANT\') }}</th><th width="{{vm.getColWidth(2)}}">{{ translate(\'INITIATOR\') }}</th><th width="{{vm.getColWidth(3)}}" class="force-right-align">{{ translate(\'ORIGINAL-CHARGE-AMOUNT\') }}</th><th width="{{vm.getColWidth(4)}}" class="force-right-align">{{ translate(\'APPROVED\') }}</th><th width="{{vm.getColWidth(5)}}" class="force-right-align">{{ translate(\'NO-OF-APPROVED\') }}</th><th width="{{vm.getColWidth(6)}}" class="force-right-align">{{ translate(\'REFUSED\') }}</th><th width="{{vm.getColWidth(7)}}" class="force-right-align">{{ translate(\'NO-OF-REFUSED\') }}</th><th width="{{vm.getColWidth(8)}}" class="force-right-align">{{ translate(\'AWAITING-ACTION\') }}</th><th width="{{vm.getColWidth(9)}}" class="force-right-align">{{ translate(\'NO-OF-AWAITING-ACTION\') }}</th></tr><tbody><tr ng-repeat="correction in vm.tableData" ng-class="{\'row-highlight-date-total\': vm.isDateSubtotalRow(correction), \'row-highlight-other-total\': vm.isOtherSubtotalRow(correction)}"><td class="force-center-align" data-th="{{ translate(\'SUBMIT-DATE\') }}">{{vm.isFirstForDate(correction.date, $index) ? (correction.date | date:\'shortDate\') : \'\'}}</td><td ng-if="vm.isAtParentLevel()" data-th="{{ translate(\'CHILD-PARTICIPANT\') }}"><span ng-if="vm.isDateSubtotalRow(correction)">{{ translate(\'DAILY-TOTAL\') }}</span> <span ng-if="vm.isFirstForDateOrParticipant(correction, $index)">{{correction.participant_name}}</span> <span ng-if="!vm.isDateSubtotalRow(correction) && vm.isParticipantDateSubtotalRow(correction)">{{correction.participant_name}} {{ translate(\'DAILY-TOTAL\') }}</span></td><td data-th="{{ translate(\'INITIATOR\') }}"><span ng-if="!vm.isDateSubtotalRow(correction) && !vm.isParticipantDateSubtotalRow(correction)">{{ translate(correction.initiator) }}</span></td><td class="force-right-align" data-th="{{ translate(\'ORIGINAL-CHARGE-AMOUNT\') }}">{{correction.charge_amount | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'APPROVED\') }}">{{correction.approved_amount | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'NO-OF-APPROVED\') }}">{{correction.approved_count | number}}</td><td class="force-right-align" data-th="{{ translate(\'REFUSED\') }}">{{correction.refused_amount | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'NO-OF-REFUSED\') }}">{{correction.refused_count | number}}</td><td class="force-right-align" data-th="{{ translate(\'AWAITING-ACTION\') }}">{{correction.awaiting_amount | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'NO-OF-AWAITING-ACTION\') }}">{{correction.awaiting_count | number}}</td></tr><tr ng-if="vm.analyticsModel.detailData.length === 0 && !vm.loading"><td colspan="{{vm.isAtParentLevel() ? 10 : 9}}" class="force-center-align">{{ translate(\'NO-DATA-FOUND\') }}</td></tr></tbody><tfoot><tr><th colspan="{{vm.isAtParentLevel() ? 10 : 9}}"><page-results-summary ng-model="vm.paginationData" on-page-click="vm.goToPage"></page-results-summary></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/corrections/widgets/filtersSection.html','<div class="segment clearing ui tableFilters no-border no-padding no-box-shadow margin-bottom"><div class="ui form"><div class="ui buttons basic right floated"><a class="ui button" ng-repeat="type in vm.options.refund_type" ng-class="{\'active\': vm.form.refund_type === type.id}" ng-click="vm.updateType(type.id)">{{ translate(type.label) }}</a></div><div class="fields"><div class="inline field" ng-if="vm.options.schemes.length>1"><div class="ui selection dropdown" dropdown="" ng-model="vm.form.initiator" dropdown-change="vm.formSubmit" default-text="{{ translate(\'ALL-SCHEMES\') }}"><input type="hidden" name="initiator"> <i class="dropdown icon"></i><div class="text">{{ translate(vm.options.initiators[0].label) }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.initiators" data-value="{{option.id}}" ng-class="{\'active\': option === vm.form.initiator}">{{ translate(option.label) }}</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/admin/analysis/corrections/widgets/summarySection.html','<div class="ui five column grid doubling stackable" id="analytics-summary-section"><summarybox class="column summary-column" box-title="{{ translate(\'CORRECTION-AMOUNT-APPROVED\') }} ({{ vm.analyticsModel.currencySymbol }})" summary-model="vm.analyticsModel.summaryData.approved_amount" currency-symbol="vm.analyticsModel.currencySymbol" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox class="column summary-column" box-title="{{ translate(\'TOTAL-NO-OF-CORRECTIONS-APPROVED\') }}" summary-model="vm.analyticsModel.summaryData.number_of_approved_refunds" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox class="column summary-column" box-title="{{ translate(\'CORRECTION-AMOUNT-REFUSED\') }} ({{ vm.analyticsModel.currencySymbol }})" summary-model="vm.analyticsModel.summaryData.refused_amount" currency-symbol="vm.analyticsModel.currencySymbol" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox class="column summary-column" box-title="{{ translate(\'TOTAL-NO-OF-CORRECTIONS-REFUSED\') }}" summary-model="vm.analyticsModel.summaryData.number_of_refused_refunds" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox class="column summary-column" box-title="{{ translate(\'CORRECTIONS-AS-OF-TOTAL-SALES\') }}" summary-model="vm.analyticsModel.summaryData.corrections_as_percentage_total" is-percentage="true" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/filtersSection.html','<div class="ui segment clearing tableFilters no-border no-padding no-box-shadow"><div class="ui form" ng-if="!vm.loading"><div class="ui buttons basic right floated" ng-if="vm.showCustomerCountNominalChargeFilter()"><a class="ui button" ng-repeat="option in vm.options.chart_types" ng-class="{\'active\': vm.selectedChartType === option.id}" ng-click="vm.changeChartType(option.id)">{{ translate(option.label) }}</a></div><div class="fields"><div class="inline field"><div class="ui selection dropdown" dropdown="" ng-model="vm.selectedGraphId" default-text="{{vm.getSelectedGraphLabel()}}" dropdown-change="vm.changeForm"><input type="hidden" name="gender"> <i class="dropdown icon"></i><div class="text">{{ translate(vm.getSelectedGraphLabel()) }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.selects" data-value="{{option.id}}" ng-class="{\'active selected\': option.id === vm.selectedGraph.id, \'disabled\': !!option.disabled}">{{ translate(option.label) }}</div></div></div></div><div class="inline field" ng-if="vm.showFareTypeFilters()"><select name="skills" class="ui fluid dropdown" dropdown="" ng-model="vm.form.fare_type" dropdown-change="vm.formSubmit" multiple="" default-text="{{translate(\'All-FARE-TYPES\')}}"><option value="">{{ translate(\'FARE-TYPE\') }}</option><option ng-repeat="option in vm.options.fare_type" value="{{option.id}}" ng-class="{\'active filtered\': (vm.form.fare_type.indexOf(option.id) > -1)}" ng-disabled="option.disabled === true">{{ translate(option.label) }}</option></select></div><div class="inline field" ng-if="vm.showProductFilters()"><select name="skills" class="ui fluid dropdown" dropdown="" ng-model="vm.form.product" dropdown-change="vm.formSubmit" multiple=""><option value="">{{ translate(\'PRODUCTS\') }}</option><option ng-repeat="option in vm.options.product" value="{{option.id}}" ng-class="{\'active filtered\': vm.form.product.indexOf(option.id) > -1}">{{ translate(option.label) }}</option></select></div><div class="inline field" ng-if="vm.showStartingWeekFilters()"><select name="skills" class="ui fluid dropdown" dropdown="" ng-model="vm.form.starting_week" dropdown-change="vm.formSubmit" multiple=""><option value="">{{ translate(\'STARTING-WEEK\') }}</option><option ng-repeat="option in vm.options.starting_week" value="{{option.id}}" ng-class="{\'active filtered\': vm.form.starting_week.indexOf(option.id) > -1}">{{ translate(option.label) }}</option></select></div><div class="inline field" ng-if="vm.showCappingFrequencyFilter()"><select name="capping_frequency" class="ui fluid dropdown min125px" dropdown="" ng-model="vm.form.capping_frequencies" dropdown-change="vm.formSubmit" multiple="true" default-text="{{translate(\'ALL\')}}"><option value="">{{ translate(\'ALL\') }}</option><option ng-repeat="option in vm.options.capping_frequencies" value="{{option}}" ng-class="{\'active filtered\': vm.form.capping_frequencies.indexOf(option) > -1}">{{ translate(\'CAPPING-FREQUENCY-\' + option) }}</option></select></div></div></div></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/summarySection.html','<div class="ui three column grid doubling stackable" id="analytics-summary-section"><summarybox ng-if="vm.selectedGraphId===\'new_vs_returning\'" class="column summary-column" box-title="{{ translate(\'TOTAL-NEW-CUSTOMERS\') }}" summary-model="vm.analyticsModel.new_vs_returning.summaryData.new_customer" current-value-style="small" box-tooltip="{{ translate(\'TOTAL-NEW-CUSTOMERS-TOOLTIP\') }}" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox ng-if="vm.selectedGraphId===\'capped_vs_uncapped\'" class="column summary-column" box-title="{{ translate(\'TOTAL-CUSTOMERS-TRANSACTED\') }}" summary-model="vm.analyticsModel.capped_vs_uncapped.summaryData.customer_count" current-value-style="small" box-tooltip="{{ translate(\'TOTAL-CUSTOMERS-TRANSACTED-TOOLTIP\') }}" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox ng-if="vm.selectedGraphId===\'capped_vs_uncapped\'" class="column summary-column" box-title="{{ translate(\'TOTAL-ADJUSTED-CUSTOMERS\') }}" summary-model="vm.analyticsModel.capped_vs_uncapped.summaryData.adjusted_customer_count" current-value-style="small" box-tooltip="{{ translate(\'TOTAL-ADJUSTED-CUSTOMERS-TOOLTIP\') }}" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox ng-if="vm.selectedGraphId===\'capped_vs_uncapped\'" class="column summary-column" box-title="{{ translate(\'AVG-LAST-30-DAYS-NOMINAL-SPEND-PER-ADJUSTED-CUSTOMER\') }}" summary-model="vm.analyticsModel.capped_vs_uncapped.summaryData.last_30_days_average_nominal_amount" current-value-style="small" currency-symbol="vm.analyticsModel.currencySymbol" box-tooltip="{{ translate(\'AVG-LAST-30-DAYS-NOMINAL-SPEND-PER-ADJUSTED-CUSTOMER-TOOLTIP\') }}" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox></div>');
$templateCache.put('app/pages/admin/analysis/debtRecovery/widgets/debtRecoveryData.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding analytics-heading"><thead><tr><th><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div><h3>{{ translate(\'OPERATOR-LIABILITY\') }} ({{vm.form.scheme || translate(\'ALL-SCHEMES\') }})</h3></th></tr></thead></table><table class="ui table fixed-padding analytics-data"><tr><th width="{{vm.getColWidth(0)}}" class="force-center-align">{{ translate(\'DAYS-AFTER-TAP-DATE\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'DAYS-AFTER-TAP-DATE-TOOLTIP\') }}" class="small question circle icon push-top"></i></th><th width="{{vm.getColWidth(1)}}" ng-if="vm.isAtParentLevel()">{{ translate(\'CHILD-PARTICIPANT\') }}</th><th width="{{vm.getColWidth(2)}}" class="force-center-align">{{ translate(\'SCHEME\') }}</th><th width="{{vm.getColWidth(3)}}" class="force-center-align">{{ translate(\'TOTAL-TRANSACTION-VALUE\') }}</th><th width="{{vm.getColWidth(4)}}" class="force-right-align">{{ translate(\'ORIGINAL-DEBT\') }}</th><th width="{{vm.getColWidth(5)}}" class="force-right-align">{{ translate(\'DEBT-AMOUNT-RECOVERED\') }}</th><th width="{{vm.getColWidth(6)}}" class="force-right-align">{{ translate(\'DEBT-AMOUNT-OUTSTANDING\') }}</th><th width="{{vm.getColWidth(7)}}" class="force-right-align">{{ translate(\'RECOVERED\') }}</th><th width="{{vm.getColWidth(8)}}" class="force-right-align">{{ translate(\'OUTSTANDING\') }}</th></tr><tbody><tr ng-repeat="debt in vm.analyticsModel.csvData | filter:schemeFilter" ng-class="{\'row-highlight-other-total\':vm.isSubtotalRow(debt)}"><td class="force-center-align" data-th="{{ translate(\'DAYS-AFTER-TAP-DATE\') }}">{{debt.days_after_transaction_date}}</td><td ng-if="vm.isAtParentLevel()" data-th="{{ translate(\'CHILD-PARTICIPANT\') }}">{{debt.participant_name || translate(\'TOTAL\') }}</td><td class="force-center-align" data-th="{{ translate(\'SCHEME\') }}">{{ (debt.scheme === \'UNKNOWN\' ? translate(\'UNKNOWN\') : debt.scheme) || translate(\'ALL\')}}</td><td class="force-center-align" data-th="{{ translate(\'TOTAL-TRANSACTION-VALUE\') }}">{{debt.transaction_value | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'ORIGINAL-DEBT\') }}">{{ debt.original_debt | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'DEBT-AMOUNT-RECOVERED\') }}">{{ debt.recovered_debt | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'DEBT-AMOUNT-OUTSTANDING\') }}">{{ debt.outstanding_debt | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'RECOVERED\') }}">{{ debt.recovered_debt_percent | number:2 }}%</td><td class="force-right-align" data-th="{{ translate(\'OUTSTANDING\') }}">{{ debt.outstanding_debt_percent | number:2 }}%</td></tr><tr ng-if="vm.analyticsModel.csvData.length === 0 && !vm.loading"><td colspan="{{vm.isAtParentLevel() ? 9 : 8}}" class="force-center-align">{{ translate(\'NO-DATA-FOUND\') }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/admin/analysis/debtRecovery/widgets/filtersSection.html','<div class="segment clearing ui tableFilters no-border no-padding no-box-shadow margin-bottom"><div class="ui form"><div class="fields"><div class="inline field"><div class="ui selection dropdown" dropdown="" ng-model="vm.form.scheme" dropdown-change="vm.renderChart" default-text="{{translate(\'ALL-SCHEMES\')}}"><input type="hidden" name="scheme"> <i class="dropdown icon"></i><div class="text">{{translate(\'ALL-SCHEMES\')}}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.schemes" data-value="{{option.id}}" ng-class="{\'active\': option === vm.form.scheme}">{{option.label}}</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/admin/analysis/declines/widgets/declinesData.html','<div class="panel panel-default clearfix"><div class="panel-heading"><ul class="nav nav-tabs"><li class="uib-tab nav-item" ng-class="{\'active\':vm.dataSetSelected === \'byDate\'}"><a class="nav-link panel-title" href="#" ng-click="vm.switchDataSet(\'byDate\')">{{ translate(\'DECLINES-BY-DATE\') }}</a></li><li ng-if="false" class="uib-tab nav-item" ng-class="{\'active\':vm.dataSetSelected === \'byIssuer\'}"><a class="nav-link panel-title" href="#" ng-click="vm.switchDataSet(\'byIssuer\')">{{ translate(\'TOP-ISSUERS\') }}</a></li><li class="uib-tab nav-item" ng-class="{\'active\':vm.dataSetSelected === \'byBin\'}"><a class="nav-link panel-title" href="#" ng-click="vm.switchDataSet(\'byBin\')">{{ translate(\'TOP-BINS\') }}</a></li></ul></div><div class="panel-body" ng-if="vm.dataSetSelected === \'byDate\'" include-with-scope="app/pages/admin/analysis/declines/widgets/dataTables/byDate.html"></div><div class="panel-body" ng-if="false" include-with-scope="app/pages/admin/analysis/declines/widgets/dataTables/byIssuer.html"></div><div class="panel-body" ng-if="vm.dataSetSelected === \'byBin\'" include-with-scope="app/pages/admin/analysis/declines/widgets/dataTables/byBin.html"></div></div>');
$templateCache.put('app/pages/admin/analysis/declines/widgets/filtersSection.html','<div class="segment clearing ui tableFilters no-border no-padding no-box-shadow margin-bottom"><div class="ui form"><div class="fields"><div class="inline field"><div class="ui selection dropdown" dropdown="" ng-model="vm.declineByIndex" dropdown-change="vm.updateDeclineBy"><input type="hidden" name="decline_by"> <i class="dropdown icon"></i><div class="text">{{ translate(vm.declineBy.name) }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.declineBy" data-value="{{$index}}">{{ translate(option.name) }}</div></div></div></div><div class="inline field"><div class="ui selection dropdown" dropdown="" ng-model="vm.selected" dropdown-change="vm.updateLiability"><input type="hidden" name="liability"> <i class="dropdown icon"></i><div class="text">{{ translate(vm.declineBy.value[vm.selectedIndex].label) }}</div><div class="menu"><div class="item" ng-repeat="option in vm.declineBy.value" data-value="{{option.id}}">{{ translate(option.label) }}</div></div></div></div><div class="inline field" ng-if="vm.options.schemes.length>1"><div class="ui selection dropdown" dropdown="" ng-model="vm.form.scheme" dropdown-change="vm.renderChart" default-text="{{ translate(\'FILTERS-ALL-SCHEMES\') }}"><input type="hidden" name="scheme"> <i class="dropdown icon"></i><div class="text">{{ translate(\'FILTERS-ALL-SCHEMES\') }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.schemes" data-value="{{option.id}}" ng-class="{\'active\': option === vm.form.scheme}">{{ option.label }}</div></div></div></div><div class="inline field" ng-if="vm.options.declineReasons.length>0"><div class="ui multiple selection dropdown" dropdown="" ng-model="vm.form.declineReasons" dropdown-change="vm.renderChart" default-text="{{ translate(\'FILTERS-ALL-DECLINE-REASONS\') }}"><input type="hidden" name="decline_reason"> <i class="dropdown icon"></i><div class="text">{{ translate(\'FILTERS-ALL-DECLINE-REASONS\') }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.declineReasons" data-value="{{option.id}}">{{ option.label }}</div></div></div></div><div class="inline field" ng-if="vm.options.fareTypes.length>0"><div class="ui multiple selection dropdown" dropdown="" ng-model="vm.form.fareTypes" dropdown-change="vm.renderChart" default-text="{{ translate(\'FILTERS-ALL-FARE-TYPES\') }}"><input type="hidden" name="fare_type"> <i class="dropdown icon"></i><div class="text">{{ translate(\'FILTERS-ALL-FARE-TYPES\') }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.fareTypes" data-value="{{option.id}}">{{ option.label }}</div></div></div></div><div class="inline field" ng-if="vm.options.requestTypes.length>0"><div class="ui multiple selection dropdown" dropdown="" ng-model="vm.form.requestTypes" dropdown-change="vm.renderChart" default-text="{{ translate(\'FILTERS-ALL-REQUEST-TYPES\') }}"><input type="hidden" name="request_type"> <i class="dropdown icon"></i><div class="text">{{ translate(\'FILTERS-ALL-REQUEST-TYPES\') }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.requestTypes" data-value="{{option.id}}">{{ option.label }}</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/admin/analysis/declines/widgets/summarySection.html','<div class="ui three column grid"><div class="column"><div class="ui segment"><div class="ui statistic"><div class="label">Correction Amount Approved (\xA3)</div><div class="value">40,509</div></div></div></div><div class="column"><div class="ui segment"><div class="ui statistic"><div class="label">Correction Amount Refused (\xA3)</div><div class="value">40,509</div></div></div></div><div class="column"><div class="ui segment"><div class="ui statistic"><div class="label">Corrections as % of Total Sales</div><div class="value">40,509</div></div></div></div></div>');
$templateCache.put('app/pages/admin/analysis/transactions/widgets/filtersSection.html','<div class="segment clearing ui tableFilters no-border no-padding no-box-shadow margin-bottom"><div class="ui form"><div class="ui buttons basic right floated" ng-if="vm.analyticsModel.hasAdjustments"><a class="ui button" ng-repeat="price in vm.options.price" ng-class="{\'active\': vm.selectedPrice === price}" ng-click="vm.updatePrice(price)">{{ translate(price.name ) }}</a></div><div class="fields"><div class="inline field" ng-if="vm.options.fareType.length>1"><div class="ui selection dropdown" dropdown="" ng-model="vm.form.fareType" dropdown-change="vm.formSubmit" syn-ui-with-model="true" default-text="{{ translate(\'ALL-FARE-TYPES\') }}"><input type="hidden" name="fareType"> <i class="dropdown icon"></i><div class="text">{{vm.options.fareType[0].name}}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.fareType" data-value="{{option.value}}" ng-class="{\'active\': option.value === vm.form.fareType, \'disabled\': !!option.disabled}">{{ translate(option.name) }}</div></div></div></div><div class="inline field productDropdown" ng-if="vm.options.product.length>1"><select name="products" class="ui fluid dropdown" dropdown="" ng-model="vm.form.product" dropdown-change="vm.formSubmit" multiple="" syn-ui-with-model="true" default-text="{{ translate(\'ALL-PRODUCTS\') }}"><option value="">{{ translate(\'ALL-PRODUCTS\') }}</option><option ng-repeat="option in vm.options.product" value="{{option.id}}" ng-class="{\'active filtered\': vm.form.product.indexOf(option.id) > -1}">{{option.label}}</option></select></div><div class="inline field"><div class="ui selection dropdown" dropdown="" ng-model="vm.form.scheme" dropdown-change="vm.formSubmit" syn-ui-with-model="true" default-text="{{ translate(\'ALL-SCHEMES\') }}"><input type="hidden" name="scheme"> <i class="dropdown icon"></i><div class="text">{{vm.options.schemes[0].label}}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.schemes" data-value="{{option.id}}" ng-class="{\'active\': option === vm.form.scheme}">{{ option.label }}</div></div></div></div><div class="inline field"><div class="ui selection dropdown" dropdown="" ng-model="vm.form.completion" dropdown-change="vm.formSubmit" syn-ui-with-model="true" default-text="All"><input type="hidden" name="completion"> <i class="dropdown icon"></i><div class="text">{{ translate(vm.options.completions[0].name | uppercase) }}</div><div class="menu"><div class="item" ng-repeat="option in vm.options.completions" data-value="{{option.value}}" ng-class="{\'active\': option === vm.form.completion}">{{ option.name }}</div></div></div></div><div class="inline field" ng-if="vm.options.locations.length>0"><div class="ui multiple selection dropdown" dropdown="" ng-model="vm.form.locations" dropdown-change="vm.locationFilterChanged" syn-ui-with-model="true" default-text="All Locations"><input type="hidden" name="locations"> <i class="dropdown icon"></i><div class="text">{{ translate(\'ALL-LOCATIONS\') }}</div><div class="menu"><div class="item" ng-repeat="location in vm.options.locations" data-value="{{location}}">{{ location===\'UNKNOWN\' ? translate(\'UNKNOWN\') : location }}</div></div></div></div></div></div></div>');
$templateCache.put('app/pages/admin/analysis/transactions/widgets/summarySection.html','<div class="ui three column grid doubling stackable" id="analytics-summary-section"><summarybox class="column summary-column" box-title="{{ translate(\'TOTAL-TRANSACTION-AMOUNT\')}} ({{ vm.analyticsModel.currencySymbol }})" summary-model="vm.analyticsModel.summaryData.trans_amount" currency-symbol="vm.analyticsModel.currencySymbol" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox class="column summary-column" box-title="{{ translate(\'TOTAL-NO-OF-TRANSACTIONS\') }}" summary-model="vm.analyticsModel.summaryData.number_of_trans" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox><summarybox class="column summary-column" box-title="{{ translate(\'AVARAGE-TRANSACTION-VALUE\') }} ({{vm.analyticsModel.currencySymbol}})" summary-model="vm.analyticsModel.summaryData.average_trans" currency-symbol="vm.analyticsModel.currencySymbol" current-value-style="small" previous-start-date="{{vm.previousStartDate}}" previous-end-date="{{vm.previousEndDate}}"></summarybox></div>');
$templateCache.put('app/pages/admin/analysis/transactions/widgets/transactionsData.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding analytics-heading"><thead><tr><th><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" add-bom="true" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div><h3>{{ translate(\'TRANSACTIONS-DATA\') }}</h3></th></tr></thead></table><table class="ui table fixed-padding analytics-data"><tr><th width="{{vm.getColWidth(0)}}" class="force-center-align">{{ translate(\'TOP-DATE\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'TOP-DATE-TOOLTIP\') }}" class="small question circle icon push-top"></i></th><th width="{{vm.getColWidth(1)}}" ng-if="vm.isAtParentLevel()">{{ translate(\'CHILD-PARTICIPANT\') }}</th><th width="{{vm.getColWidth(2)}}">{{ translate(\'FARE-TYPE\') }}</th><th width="{{vm.getColWidth(3)}}">{{ translate(\'PRODUCT\') }}</th><th width="{{vm.getColWidth(4)}}">{{ translate(\'COMPLETION\')}}</th><th width="{{vm.getColWidth(5)}}">{{ translate(\'SCHEME\') }}</th><th width="{{vm.getColWidth(6)}}" class="force-right-align">{{ translate(\'NOMINAL-AMOUNT\') }}</th><th width="{{vm.getColWidth(7)}}" ng-if="vm.analyticsModel.hasAdjustments" class="force-right-align">{{ translate(\'CHARGED-AMOUNT\') }}</th><th width="{{vm.getColWidth(8)}}" class="force-right-align">{{ translate(\'COUNT\') }}</th></tr><tbody><tr ng-repeat="transaction in vm.currentPageData" ng-class="{\'row-highlight-date-total\': vm.isDateSubtotalRow(transaction), \'row-highlight-other-total\': vm.isOtherSubtotalRow(transaction)}"><td class="force-center-align" data-th="{{ translate(\'SUBMIT-DATE\') }}">{{ vm.isFirstForDate(transaction.date, $index) ? (transaction.date | date:\'shortDate\') : \'\' }}</td><td ng-if="vm.isAtParentLevel()">{{vm.isFirstForDateOrParticipant(transaction, $index) && !vm.isChildParticipantSubtotalRow(transaction) ? transaction.participant_name : \'\'}}</td><td data-th="{{ translate(\'FARE-TYPE\') }}">{{ translate(vm.getFareLabel(transaction.fare_type | uppercase )) }}</td><td data-th="{{ translate(\'PRODUCT\') }}">{{!!transaction.fare_type ? vm.getProductLabel(transaction.product) : \'\'}}</td><td data-th="{{ translate(\'COMPLETION\')}}">{{transaction.trip_completion ? translate(transaction.trip_completion | uppercase) : \'\'}}</td><td data-th="{{ translate(\'SCHEME\') }}"><span ng-if="vm.isDateSubtotalRow(transaction)">{{ translate(\'DAILY-TOTAL\') }}</span> <span ng-if="vm.isChildParticipantSubtotalRow(transaction)">{{ translate(\'PARTICIPANT-DAILY-TOTAL\', {\'participant\': transaction.participant_name}) }}</span> <span ng-if="transaction.scheme === \'UNKNOWN\'">{{ translate(transaction.scheme) | uppercase }}</span> <span ng-if="transaction.scheme !== \'UNKNOWN\'">{{ transaction.scheme }}</span> <span ng-if="vm.isSchemeSubtotalRow(transaction)">{{ translate(\'TOTAL\') }}</span></td><td class="force-right-align" data-th="Nominal Amount">{{ transaction.nominal_amount | currency:vm.analyticsModel.currencySymbol }}</td><td ng-if="vm.analyticsModel.hasAdjustments" class="force-right-align" data-th="Charged Amount">{{ transaction.adjusted_amount | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="Count">{{ transaction.count | number }}</td></tr><tr ng-if="vm.hasNoData() && !vm.loading"><td colspan="{{vm.getColspan()}}" class="force-center-align">{{ translate(\'NO-DATA-FOUND\') }}</td></tr></tbody><tfoot><tr><th colspan="{{vm.getColspan()}}"><page-results-summary ng-model="vm.paginationData" on-page-click="vm.goToPage"></page-results-summary></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/corrections/corrections/widgets/initiatorFilter.html','<div class="ui floating labeled icon dropdown basic button" dropdown="" ng-model="form.initiator" dropdown-change="correctionsSearchSubmit" default-text="{{ translate(\'SELECT-INITIATOR\') }}"><i class="filter icon"></i> <span class="text"></span><div class="menu"><div class="header"><i class="tags icon"></i> {{ translate(\'FILTER-BY-INITIATOR\') }}</div><div class="divider"></div><div class="item" data-value="CUSTOMER">{{ translate(\'CUSTOMER\') }}</div><div class="item" data-value="MERCHANT">{{ translate(\'MERCHANT\') }}</div><div class="divider" ng-if="form.initiator"></div><div class="header center aligned"><button class="ui fluid red labeled icon button small" ng-if="form.initiator" ng-click="reset(\'initiator\')"><i class="undo icon"></i> {{ translate(\'RESET\') }}</button></div></div></div>');
$templateCache.put('app/pages/admin/corrections/corrections/widgets/statusFilter.html','<div class="ui floating labeled icon dropdown basic button" dropdown="" ng-model="form.status" dropdown-change="correctionsSearchSubmit" default-text="{{ translate(\'SELECT-STATUS\') }}"><i class="filter icon"></i> <span class="text"></span><div class="menu"><div class="header"><i class="tags icon"></i> {{ translate(\'FILTER-BY-STATUS\') }}</div><div class="divider"></div><div class="item" data-value="APPROVED"><i class="green circle icon"></i>{{ translate(\'APPROVED\') }}</div><div class="item" data-value="AWAITING"><i class="yellow circle icon"></i>{{ translate(\'AWAITING-ACTION\') }}</div><div class="item" data-value="REFUSED"><i class="red circle icon"></i>{{ translate(\'REFUSED\') }}</div><div class="divider" ng-if="form.status"></div><div class="header center aligned"><button class="ui fluid red labeled icon button small" ng-if="form.status" ng-click="reset(\'status\')"><i class="undo icon"></i> {{ translate(\'RESET\') }}</button></div></div></div>');
$templateCache.put('app/pages/admin/customers/customerSummary/cards/customerCards.html','<div ng-repeat="(key,identifier) in vm.identifierModel.identifiers" class="panel panel-default cards"><div class="panel-heading customerSummaryHeading"><a ng-if="identifier.lists.length > 0" ng-click="crd.collapseListHistory(key)" href="#" class="collapseListHistory pull-left"><i class="fa" ng-class="{\'fa-bars\': !crd.listHistoryToggle[key], \'fa-ellipsis-h\':crd.listHistoryToggle[key]}"></i></a><h5 class="panel-title"><span class="model-status model-status-{{identifier.status | lowercase }} tooltip-icon" tooltips="" tooltip-template="{{identifier.status}}"></span> <i class="fa fa-credit-card"></i><span class="masked-no">{{identifier.truncated_pan}}</span> <span class="masked-no" ng-if="identifier.expiry">{{identifier.expiry | expiry}}</span> <button class="btn btn-xs copy-btn" type="button" ngclipboard="" data-clipboard-text="{{identifier.truncated_pan}}"><i class="fa fa-clipboard fa-fw"></i>{{ translate(\'COPY\') }}</button> <button class="btn btn-xs debt-btn" type="button" ng-if="identifier.showButton" ng-disabled="identifier.loading" ng-click="vm.triggerDebtRecovery(identifier)">{{ translate(\'DEBT-RECOVERY\') }}</button></h5><span ng-if="identifier.lists[0].functions[0]" class="pull-right card-list-labels" ng-class="{\'expanded\': crd.listHistoryToggle[key]}"><span class="label margin-right1 card-list" ng-repeat="function in identifier.lists[0].functions" ng-class="{\'label-warning\': function === \'PILOT\',\'label-danger\': function === \'DENY\'}">{{ translate(function) }}</span></span></div><ul class="list-group" ng-if="crd.listHistoryToggle[key]"><li class="list-group-item" ng-repeat="history in vm.identifierModel.listHistory[key] | orderBy:\'-created_time\'"><div class="historyText"><i class="square icon" ng-class="{\'plus\': history.action === \'ADD\', \'minus\': history.action === \'REMOVE\'}"></i> <small class="pull-right"><short-medium-date-time ng-model="history.created_time"></short-medium-date-time></small> <span ng-if="history.action === \'ADD\'" ng-bind-html="translate(\'ADDED-TO-LIST\', {\'function\': translate(history.function+\'-LIST-NAME\') })"></span> <span ng-if="history.action === \'REMOVE\'" ng-bind-html="translate(\'REMOVED-FROM-LIST\', {\'function\': translate(history.function+\'-LIST-NAME\') })"></span></div><p class="listHistorylines" ng-if="history.reason && history.reason !== \'UNSPECIFIED\'"><b>{{ translate(\'REASON\') }}</b><span>{{ history.reason }}</span></p><p class="listHistorylines" ng-if="history.comment"><b>{{ translate(\'COMMENT\') }}</b><span>{{ history.comment }}</span></p></li></ul></div>');
$templateCache.put('app/pages/admin/customers/customerSummary/customerInvoice/customerReceipt.html','<p class="print-invoice text-center"><a ng-click="rp.goBack()" class="print-statement print-invoice small ng-binding"><i class="fa fa-arrow-left"></i> {{ translate(\'BACKTO-STATEMENT-PAGE\') }}</a> <a ng-click="rp.printStatement()" class="print-statement print-invoice small ng-binding"><i class="fa fa-print"></i> {{ translate(\'PRINT-INVOICE\') }}</a></p><div class="invoice-box" id="user-receipt-template"><table><tr class="top"><td colspan="5"><table><tr><td class="title"><div id="receipt-logo"></div><h1 ng-if="vm.participantModel.invoiceConfigs.trading_name" ng-bind-html="translate(vm.participantModel.invoiceConfigs.trading_name)"></h1></td><td class="merchant-info"><span ng-if="vm.participantModel.invoiceConfigs.vat_number">{{ translate(\'VAT-NUMBER\') }}: {{vm.participantModel.invoiceConfigs.vat_number}}<br></span> <span ng-if="vm.participantModel.invoiceConfigs.business_id">{{ translate(\'BUSINESS-ID\') }}: {{vm.participantModel.invoiceConfigs.business_id}}<br></span> <span ng-if="vm.participantModel.invoiceConfigs.issue_date">{{ translate(\'ISSUE-DATE\') }}: {{vm.participantModel.invoiceConfigs.issue_date | date:\'shortDate\'}}<br></span> <span ng-if="vm.participantModel.invoiceConfigs.fromTime">{{ translate(\'FROM\') }}</span> {{ vm.participantModel.invoiceConfigs.fromTime | date:\'shortDate\'}} <span ng-if="vm.participantModel.invoiceConfigs.toTime">{{ translate(\'TO\') }}</span> {{ vm.participantModel.invoiceConfigs.toTime | date:\'shortDate\'}}</td></tr></table></td></tr><tr class="information"><td colspan="5"><table><tr><td class="merchant-info">{{ translate(\'JOURNEY-STATEMENT\') }}</td></tr></table></td></tr><tr class="heading"><td>{{ translate(\'DATE\') }}</td><td>{{ translate(\'JOURNEY\') }}</td><td class="text-right">{{ translate(\'VAT-PERCENTAGE\', {\'percentage\': vm.participantModel.invoiceConfigs.vat_percentage*100}) }}</td><td class="text-right">{{ translate(\'AMOUNT-EXCL-VAT\') }}</td><td class="text-right">{{ translate(\'AMOUNT-INC-VAT\') }}</td></tr><tr class="details" ng-repeat="transaction in vm.aggregationModel.receiptTransactions"><td>{{ transaction.micropayments[transaction.micropayments.length-1].taps[transaction.micropayments[transaction.micropayments.length-1].taps.length-1].tap_time | date:\'medium\' }}</td><td>{{ transaction.micropayments[transaction.micropayments.length-1].purchases[0].description }}</td><td>{{ (transaction.amount | calculateVAT:vm.participantModel.invoiceConfigs.vat_percentage ) | isoCurrency:transaction.currency }}</td><td>{{ (transaction.amount | calculateExclVAT:vm.participantModel.invoiceConfigs.vat_percentage) | isoCurrency:transaction.currency }}</td><td>{{ transaction.amount | isoCurrency:transaction.currency }}</td></tr><tbody ng-if="vm.aggregationModel.receiptTransactions && vm.aggregationModel.receiptTransactions.length > 0"><tr class="item"><td colspan="4">{{ translate(\'TOTAL-AMOUNT-EXCL\') }}</td><td>{{ (vm.participantModel.invoiceConfigs.total_amount | calculateExclVAT:vm.participantModel.invoiceConfigs.vat_percentage) | isoCurrency:vm.participantModel.invoiceConfigs.currency }}</td></tr><tr class="item"><td colspan="4">{{ translate(\'VAT-TOTAL\', {\'percentage\': vm.participantModel.invoiceConfigs.vat_percentage*100}) }}</td><td>{{ (vm.participantModel.invoiceConfigs.total_amount | calculateVAT:vm.participantModel.invoiceConfigs.vat_percentage) | isoCurrency:vm.participantModel.invoiceConfigs.currency }}</td></tr><tr class="item last"><td colspan="4">{{ translate(\'TOTAL-AMOUNT-INCL-VAT\') }}</td><td>{{ vm.participantModel.invoiceConfigs.total_amount | isoCurrency:vm.participantModel.invoiceConfigs.currency }}</td></tr></tbody><tbody ng-if="!vm.aggregationModel.receiptTransactions || vm.aggregationModel.receiptTransactions.length < 1"><tr><td colspan="5">{{ translate(\'NO-TRIPS-HAVE-BEEN-FOUND-RECEIPT\') }}</td></tr></tbody></table><p class="text-center receipt-footer" ng-bind-html="translate(vm.participantModel.invoiceConfigs.receipt_footer)"></p></div><p class="text-center print-invoice"><a ng-click="rp.printStatement()" class="print-statement print-invoice small ng-binding"><i class="fa fa-print"></i> {{ translate(\'PRINT-INVOICE\') }}</a></p>');
$templateCache.put('app/pages/admin/customers/customerSummary/customerInvoice/getReceiptModal.html','<modal modal-name="print-receipt-modal" header="{{ translate(\'INVOICE.PRINT-RECEIPT\') }}" confirmation="{{ translate(\'INVOICE.GENERATE-RECEIPT\') }}" show="vm.printReceiptModal" on-submit-click="vm.generateInvoice" on-close-click="vm.hideModal" cancel="{{ translate(\'CANCEL\') }}"><notification-message ng-model="vm.receiptNotificationMessage"></notification-message><div class="content form-horizontal"><div class="form-group"><label class="col-sm-4 control-label modal-amount-label">{{ translate(\'FROM-DATE\') }}</label><div class="col-sm-8"><ng-datepicker ng-model="vm.invoiceDateForm.fromTime" calendar-opened="false" class="datepicker-field" name="fromTime" not-after="vm.invoiceDateForm.toTime" has-error="vm.invoiceDateFormError.fromTime" from-now-on="false"></ng-datepicker></div></div><div class="form-group"><label class="col-sm-4 control-label modal-reason-label">{{ translate(\'TO-DATE\') }}</label><div class="col-sm-8"><ng-datepicker ng-model="vm.invoiceDateForm.toTime" name="toTime" calendar-opened="false" class="datepicker-field" not-before="vm.invoiceDateForm.fromTime" has-error="vm.invoiceDateFormError.toTime" from-now-on="false"></ng-datepicker></div></div></div></modal>');
$templateCache.put('app/pages/admin/customers/customerSummary/refunds/customerRefunds.html','<div class="panel panel-default"><table class="table table-striped"><thead><tr><th class="index text-center">#</th><th>{{ translate(\'CHARGE-AMOUNT\') }}</th><th>{{ translate(\'REFUND-AMOUNT\') }}</th><th>{{ translate(\'STATUS\') }}</th><th>{{ translate(\'UPDATED-TIME\') }}</th><th>{{ translate(\'CUSTOMER-COMMENT\') }}</th><th>{{ translate(\'ISSUER-COMMENT\') }}</th></tr></thead><tbody><tr ng-repeat="refund in rfd.refundModel.refundHistory" ng-if="rfd.loading.hasLoaded"><td data-th="#" class="index text-center">{{ 1 + $index }}</td><td data-th="{{ translate(\'CHARGE-AMOUNT\') }}">{{ refund.transaction_amount | isoCurrency:refund.currency }}</td><td data-th="{{ translate(\'REFUND-AMOUNT\') }}">{{ (refund.refund_amount || \'0\' ) | isoCurrency:refund.currency }}</td><td data-th="{{ translate(\'STATUS\') }}"><span class="label" ng-class="{ \'label-warning\': refund.approval === \'AWAITING\', \'label-success\': refund.approval === \'APPROVED\', \'label-danger\': refund.approval === \'REFUSED\' }">{{ translate(refund.approval) }}</span> <span ng-if="refund.approval !== \'REFUSED\'" class="label" ng-class="{ \'label-warning\': refund.status === \'CREATED\' || refund.status === \'ADJUSTED\', \'label-success\': refund.status === \'SETTLED\', \'label-info\': refund.status === \'SENT_FOR_SETTLEMENT\' || refund.status === \'SENT_FOR_ADJUSTMENT\', \'label-danger\': refund.status === \'REJECTED\' }">{{ translate(refund | refundStatus | replaceUnderscoreWithDash) }}</span> <span ng-if="refund.multi_operator" class="label label-default margin-right1">{{ translate(\'MULTI-OP\') }}</span></td><td data-th="{{ translate(\'UPDATED-TIME\') }}" ng-show="refund.approved_time">{{ refund.approved_time | date:\'shortDate\' }}<br>{{ refund.approved_time | date:\'mediumTime\' }}</td><td data-th="{{ translate(\'UPDATED-TIME\') }}" ng-show="!refund.approved_time">{{ refund.created_time | date:\'shortDate\' }}<br>{{ refund.created_time | date:\'mediumTime\' }}</td><td data-th="{{ translate(\'CUSTOMER-COMMENT\') }}">{{ refund.reason }}</td><td data-th="{{ translate(\'ISSUER-COMMENT\') }}"><b>{{ refund.issuer }}</b><br>{{ refund.issuer_comment || \'-\' }}</td></tr></tbody><tbody><tr ng-if="!rfd.loading.hasLoaded"><td colspan="7"><div class="text-center inline-loader"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></div></td></tr><tr ng-if="rfd.refundModel.refundHistory.length === 0 && rfd.loading.hasLoaded"><td colspan="7"><span ng-if="!rfd.loading.error">{{ translate(\'NO-REFUNDS-FOUND\') }}</span> <span ng-if="rfd.loading.error" class="text-danger">{{ translate(\'REFUNDS-ERROR-MESSAGE\') }}</span></td></tr></tbody></table></div>');
$templateCache.put('app/pages/admin/customers/customerSummary/transactions/adjustments.html','<div ng-controller="AdminCustomerSummaryAdjustmentsCtrl as adj" ng-class="{\'text-success\': adjustment.applied, \'text-default\': !adjustment.applied}" ng-init="adj.setAdjustmentVariables(micropayment, adjustment)"><i class="fa fa-ticket fa-fw"></i> {{adjustment.description}}<medium ng-if="adj.fareDecision.results.discount">- {{ adj.fareDecision.results.discount.trip_type }}</medium><div ng-if="adj.fareDecision.results.cap_limit_reached"><small>{{ adj.fareDecision.results.cap_limit_reached.accumulated | isoCurrency:micropayment.currency }} {{translate(\'OF\')}} {{ adj.fareDecision.results.cap_limit_reached.limit | isoCurrency:micropayment.currency }} {{translate(\'LIMIT\')}}</small></div><div ng-if="adj.fareDecision.results.nb_of_free_trips_reached"><small>{{ adj.fareDecision.results.nb_of_free_trips_reached.nb_of_free_trips_accumulated }} {{translate(\'OF\')}} <span ng-switch="" on="adj.fareDecision.results.nb_of_free_trips_reached.nb_of_free_trips_max"><span ng-switch-when="UNLIMITED">{{translate( \'UNLIMITED\' )}}</span> <span ng-switch-default="">{{ adj.fareDecision.results.nb_of_free_trips_reached.nb_of_free_trips_max}}</span></span> {{translate(\'UNTIL\')}} {{ adj.fareDecision.results.nb_of_free_trips_reached.expiring_time | toLocaleString }}</small></div><div ng-if="adj.fareDecision.results.capping_window"><small>{{ adj.fareDecision.results.capping_window.nb_of_free_trips_accumulated }} {{translate(\'OF\')}} <span ng-switch="" on="adj.fareDecision.results.capping_window.nb_of_free_trips_max"><span ng-switch-when="UNLIMITED">{{translate( \'UNLIMITED\' )}}</span> <span ng-switch-default="">{{ adj.fareDecision.results.capping_window.nb_of_free_trips_max}}</span></span> {{translate(\'UNTIL\')}} {{ adj.fareDecision.results.capping_window.expiring_time | toLocaleString }}</small></div><div ng-if="adj.isIncentivesCappingApplied"><small ng-bind-html="adj.getIncentiveCappingText()"></small></div></div>');
$templateCache.put('app/pages/admin/customers/customerSummary/transactions/credit.html','<td data-th="Time" class="customer-summary-time-column" ng-class="{\'with-operator-column\': aggregation.multi_operator && micropayment.participant_name}"><h5 class="header transactionSubTitle">{{ translate(\'TIME\') }}</h5><short-medium-date-time ng-model="micropayment.updated_time"></short-medium-date-time></td><td data-th="{{ translate(\'OPERATOR\') }}" class="customer-summary-operator-column" ng-if="aggregation.multi_operator && micropayment.participant_name"><h5 class="header transactionSubTitle">{{ translate(\'OPERATOR\') }}</h5><span>{{micropayment.participant_name}}</span></td><td data-th="Purchase" colspan="3"><h5 class="header transactionSubTitle">{{ translate(\'PURCHASE\') }}</h5><b class="text-danger">{{ translate(\'CREDIT\') }}</b></td><td data-th="Amount" colspan="3"><h5 class="header transactionSubTitle">{{ translate(\'AMOUNT\') }}</h5><span>{{ micropayment.amount * -1 | isoCurrency:micropayment.currency }}</span></td>');
$templateCache.put('app/pages/admin/customers/customerSummary/transactions/debit.html','<td data-th="{{ translate(\'TIME\') }}" class="customer-summary-time-column" ng-class="{\'with-operator-column\': aggregation.multi_operator && micropayment.participant_name}"><h5 class="header transactionSubTitle">{{ translate(\'TIME\') }}</h5><short-medium-date-time ng-if="micropayment.taps[micropayment.taps.length-1].tap_time" ng-model="micropayment.taps[micropayment.taps.length-1].tap_time"></short-medium-date-time><short-medium-date-time ng-if="!micropayment.taps[micropayment.taps.length-1].tap_time" ng-model="micropayment.updated_time"></short-medium-date-time></td><td data-th="{{ translate(\'OPERATOR\') }}" class="customer-summary-operator-column" ng-if="aggregation.multi_operator && micropayment.participant_name"><h5 class="header transactionSubTitle">{{ translate(\'OPERATOR\') }}</h5><span>{{micropayment.participant_name}}</span></td><td data-th="{{ translate(\'DESCRIPTION\') }}"><h5 class="header transactionSubTitle">{{ translate(\'DESCRIPTION\') }}</h5><i class="fa fa-fw fa-bus"></i> {{ translate(micropayment.taps[micropayment.taps.length-1].description | uppercase) }}</td><td data-th="{{ translate(\'PURCHASE\') }}"><h5 class="header transactionSubTitle">{{ translate(\'PURCHASE\') }}</h5><div ng-show="micropayment.purchases.length > 0" class="purchases" ng-repeat="purchase in micropayment.purchases"><span>{{ purchase.description }}</span></div><b ng-show="micropayment.amount < 0" class="text-danger">{{ translate(\'CREDIT\') }}</b></td><td data-th="{{ translate(\'ADJUSTMENT\') }}" class="customer-summary-adjustment-column"><h5 class="header transactionSubTitle">{{ translate(\'ADJUSTMENT\') }}</h5><div ng-repeat="adjustment in micropayment.adjustments" ng-if="micropayment.adjustments.length > 0 && adjustment.applied" ng-include="" src="\'app/pages/admin/customers/customerSummary/transactions/adjustments.html\'"></div><a ng-if="trs.checkUnusedAdjustments(micropayment.adjustments)" ng-click="trs.showNotAppliedAdjustments(micropayment.id)" role="button"><span ng-if="!trs.showAdjustments[micropayment.id]">{{ translate(\'SHOW-NOT-APPLIED\') }}&nbsp;<i class="fa fa-caret-down"></i></span> <span ng-if="trs.showAdjustments[micropayment.id]">{{ translate(\'HIDE-NOT-APPLIED\') }}&nbsp;<i class="fa fa-caret-down fa-flip-vertical"></i></span></a><div ng-repeat="adjustment in micropayment.adjustments" ng-if="micropayment.adjustments.length > 0 && !adjustment.applied && trs.showAdjustments[micropayment.id]" ng-include="" src="\'app/pages/admin/customers/customerSummary/transactions/adjustments.html\'"></div><div ng-if="trs.showAdjustments[micropayment.id]" ng-include="" src="\'app/pages/admin/customers/customerSummary/transactions/returnfares.html\'"></div><span class="text-default" ng-if="micropayment.adjustments.length === 0">{{ translate(\'NONE\') }}</span></td><td data-th="{{ translate(\'NOMINAL\') }}"><h5 class="header transactionSubTitle">{{ translate(\'NOMINAL\') }}</h5><span ng-if="micropayment.nominal_amount != undefined || micropayment.charge_type">{{ (micropayment.nominal_amount | isoCurrency:micropayment.currency) || (micropayment.amount | isoCurrency:micropayment.currency) }}</span> <small class="text-default" ng-if="micropayment.nominal_amount == undefined && !micropayment.charge_type">({{ translate(\'PENDING\') }})</small><br><small class="text-success" ng-if="micropayment.nominal_amount && micropayment.amount !== micropayment.nominal_amount && micropayment.charge_type !== \'pending_variable_fare\'">{{ (micropayment.amount - micropayment.nominal_amount) | isoCurrency:micropayment.currency }}</small></td><td data-th="{{ translate(\'CHARGED\') }}"><h5 class="header transactionSubTitle">{{ translate(\'CHARGED\') }}</h5><span ng-if="micropayment.nominal_amount != undefined || micropayment.charge_type">{{ micropayment.amount | isoCurrency:micropayment.currency }}</span> <small class="text-default" ng-if="micropayment.nominal_amount == undefined && !micropayment.charge_type">({{ translate(\'PENDING\') }})</small></td><td data-th="Route"><ul class="micropaymentList" ng-if="micropayment.taps.length > 0"><li class="from" ng-repeat="tap in micropayment.taps" ng-show="tap.location"><tap-location ng-model="tap"></tap-location><small><short-medium-date-time ng-model="tap.tap_time"></short-medium-date-time></small></li><li ng-if="micropayment.charge_type === \'pending_variable_fare\'" class="pending"><p>{{ translate(\'AWAITING-TAP\') }}</p></li><li ng-if="micropayment.charge_type === \'incomplete_variable_fare\'" class="incomplete"><p>{{ translate(\'INCOMPLETE\') }}</p><small>{{ translate(\'MAX-FARE-APPLIED\') }}: {{ micropayment.nominal_amount | isoCurrency:micropayment.currency }}</small><div ng-if="trs.adjustmentModel.decision[micropayment.id].fare_attributes.results.precondition.onward_zone_names"><small>{{ translate(\'ONWARD-CAPPING-ZONES\') }} {{ trs.adjustmentModel.decision[micropayment.id].fare_attributes.results.precondition.onward_zone_names }}</small></div></li></ul></td><td class="text-center divTableCell"><a href="#" ng-if="vm.hasPermissionToRefund" class="btn btn-warning btn-sm" ng-class="{\'disabled\': !vm.canRefundMicropayment(micropayment)}" ng-controller="AdminMakeCorrectionCtrl" ng-click="callModalClick(\'showSubmitRefundModal\', null, aggregation, micropayment, vm.customerModel.currentCustomer)" translate="CUSTOMERS.CUSTOMER-SUMMARY.CREDIT" tooltips="" tooltip-template="{{ translate(\'CANNOT-REFUND\') }}" tooltip-hidden="{{vm.canRefundMicropayment(micropayment)}}"></a></td>');
$templateCache.put('app/pages/admin/customers/customerSummary/transactions/returnfares.html','<div ng-controller="AdminCustomerSummaryAdjustmentsCtrl as adj" ng-class="\'text-default\'" ng-init="adj.setReturnFareDiscountedTrips(micropayment)"><div ng-repeat="trip in adj.returnFareDiscountedTrips"><i class="fa fa-ticket fa-fw"></i> {{ trip.results.discount.description }} - {{ trip.results.discount.trip_type }}</div></div>');
$templateCache.put('app/pages/admin/customers/customerSummary/transactions/transactions.html','<a ng-if="trs.form.aggregationId" ng-click="trs.showAllTransactions()" href="#">{{ translate(\'SEE-ALL\') }}</a><entry-change ng-model="trs.aggregationModel" on-entry-change="trs.customerAggregations"></entry-change><div class="panel-group accordion transactionsAccordion clearfix" ng-class="{\'topMargin\': trs.aggregationModel.aggregations.length > 1}"><div class="panel panel-default"><div class="panel-heading" ng-if="!trs.form.aggregationId"><form ng-submit="trs.transactionSearchClick()" id="searchCustomerTransactions" class="panel-title"><div class="filterSection"><label>{{ translate(\'CARDS\') }}</label><select name="selectVaultId" class="filter" ng-options="list.truncated_pan as list.truncated_pan for list in vm.identifierModel.identifiers" ng-model="trs.form.card"><option value="">{{ translate(\'ALL-CARDS\') }}</option></select></div><div class="filterSection date"><label>{{ translate(\'FROM-DATE\') }} <i class="fa fa-question-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'FROM-DATE-HELPER\', {\'date\': (trs.limitTransactionsDate | date: \'shortDate\')}) }}"></i></label><ng-datepicker ng-model="trs.form.fromTime" class="datepicker-field" from-now-on="false" not-after="trs.form.toTime" not-before="trs.limitTransactionsDate"></ng-datepicker></div><div class="filterSection date"><label>{{ translate(\'TO-DATE\') }}</label><ng-datepicker ng-model="trs.form.toTime" class="datepicker-field" from-now-on="false" not-before="trs.form.fromTime"></ng-datepicker></div><div class="filterSection"><label>{{ translate(\'PAYMENT-STATUS\') }}</label><select name="paymentStatus" class="filter" ng-options="o as (\'GUARANTEESTATUS.\'+o | translate) for o in trs.transactionFilters.paymentGuaranteeStatus" ng-model="trs.form.status"><option value="">{{ translate(\'ALL-STATUS\') }}</option></select></div><div class="filterSection"><label>{{ translate(\'SETTLEMENT-RESULT\') }}</label><select name="settlementResult" class="filter" ng-options="o as (\'GUARANTEESTATUS.\'+o | translate) for o in trs.transactionFilters.settlementResult" ng-model="trs.form.settlement"><option value="">{{ translate(\'ALL-RESULTS\') }}</option></select></div><div class="filterSection"><label>{{ translate(\'TRIP-STATUS\') }}</label><select name="settlementResult" class="filter" ng-options="key as (\'GUARANTEESTATUS.\'+o | translate) for (o, key) in trs.transactionFilters.tripStatus" ng-model="trs.form.trip"><option value="">{{ translate(\'ALL-STATUS\') }}</option></select></div><input class="btn customers-search-button" type="submit" value="{{ translate(\'SEARCH\') }}"></form></div><ul class="list-group" id="customerTransactions" ng-if="trs.loading.hasLoaded"><li class="list-group-item clearfix" ng-repeat="aggregation in trs.aggregationModel.aggregations" ng-class="{\'panel-opened\': aggregation.open || form.aggregationId }" href="#{{aggregation.id}}"><a class="summary {{aggregation.status | lowercase}}" ng-click="trs.collapse($event,aggregation)"><span class="pull-left date"><short-medium-date-time ng-model="aggregation.micropayments[aggregation.micropayments.length-1].taps[aggregation.micropayments[aggregation.micropayments.length-1].taps.length-1].tap_time"></short-medium-date-time></span> <span class="label label-default">{{aggregation.amount | isoCurrency:aggregation.currency }}</span> <span ng-if="aggregation.settlement_result.status" class="label label-{{ (aggregation.settlement_result.status | removeSpacesAndLowerCase) }}">{{ (\'GUARANTEESTATUS.\' + (aggregation.settlement_result.status | removeSpaces) ) | translate }}</span><payment-guarantee-status-label ng-model="aggregation"></payment-guarantee-status-label><span ng-if="aggregation.multi_operator" class="label label-default margin-right1">{{ \'GUARANTEESTATUS.MULTI-OP\' | translate }}</span><aggregation-status ng-model="aggregation"></aggregation-status></a><table class="table summaryTable"><tbody><tr ng-if="aggregation.settlement_result.status === \'SETTLED\'"><td class="compact" colspan="{{ aggregation.multi_operator ? 9 : 8 }}">{{translate(\'SETTLED-AT\', undefined, \'TRANSACTIONS.SEARCH.\') | uppercase}}&nbsp;<short-medium-date-time ng-model="aggregation.settlement_result.status_date_time"></short-medium-date-time></td></tr><tr ng-repeat="micropayment in aggregation.micropayments" ng-include="trs.getMicropaymentRowTemplate(micropayment)"></tr><tr ng-if="aggregation.refunds"><th colspan="{{ aggregation.multi_operator ? 9 : 8 }}"><i class="fa fa-fw fa-money"></i> {{ translate(\'REFUNDS\') }}</th></tr><tr ng-if="aggregation.refunds" ng-repeat="refund in aggregation.refunds"><td data-th="Transaction Date"><h5 class="header transactionSubTitle">{{ translate(\'TRANSACTION-DATE\') }}</h5>{{ (refund.settlement_result.transaction_date | date:\'shortDate\') || \'-\' }}</td><td data-th="Settlement Date"><h5 class="header transactionSubTitle">{{ translate(\'SETTLEMENT-DATE\') }}</h5>{{ (refund.settlement_result.status_date_time | date:\'shortDate\') || \'-\' }}</td><td data-th="Refund Amount"><h5 class="header transactionSubTitle">{{ translate(\'REFUND-AMOUNT\') }}</h5>{{refund.amount | isoCurrency:refund.currency }}</td><td data-th="Refund Status"><h5 class="header transactionSubTitle">{{ translate(\'STATUS\') || \'\' }}</h5><span class="table-upper-text" ng-if="refund.approval">{{ translate(refund.approval) }}</span> <span ng-if="refund.approval !== \'REFUSED\'" class="table-upper-text text-{{ (refund.settlement_result.status || \'SENT FOR SETTLEMENT\') | removeSpacesAndLowerCase }}">{{ translate((refund.settlement_result.status | removeSpaces) || \'SENT-FOR-SETTLEMENT\') }}</span></td></tr></tbody></table></li></ul><div class="panel-body" ng-if="!trs.loading.hasLoaded"><div class="text-center inline-loader"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></div></div><div class="panel-body" ng-if="trs.aggregationModel.aggregations.length === 0 && trs.loading.hasLoaded"><span ng-if="!trs.loading.error">{{ translate(\'NO-TRANSACTIONS\', {\'date\': (trs.limitTransactionsDate | date: \'shortDate\') }) }}</span> <span ng-if="trs.loading.error" class="text-danger">{{ translate(\'ERROR\') }}</span></div></div></div><page-results-summary ng-model="trs.aggregationModel" on-page-click="trs.customerAggregations"></page-results-summary><div ng-include="\'app/pages/admin/corrections/makeCorrection/makeCorrectionModal.html\'"></div>');
$templateCache.put('app/pages/admin/products/capping/list/list.html','<div class="wrapper" ng-show="!pageLoading"><div class="filters clearfix" ng-if="vm.hasPermission"><span class="ui right floated teal icon button" ng-click="vm.showHowTo()">{{ translate(\'HOW-DO-I-USE\') }} <i class="fa fa-fw" ng-class="{\'fa-angle-down\':!vm.howToInfo, \'fa-angle-up\': vm.howToInfo}"></i></span></div><div class="infoSlider" ng-if="vm.howToInfo"><div class="alert alert-info infoSliderAlert" role="alert"><div ng-bind-html="translate(\'HOW-TO-PART1\') + translate(\'HOW-TO-PART2\') + translate(\'HOW-TO-PART3\')"></div><ul><li>{{ translate(\'POINT1\') }}</li><li>{{ translate(\'POINT2\') }}</li><li>{{ translate(\'POINT3\') }}</li></ul></div></div><div id="entryChangeDropdown" class="ui compact selection dropdown" ng-model="vm.switchSelected" dropdown="" dropdown-change="vm.switchTab"><i class="dropdown icon"></i><div class="text">{{ translate(vm.switchSelected) }}</div><div class="menu"><div class="item" data-value="currentProducts">{{ translate(\'CURRENT-PRODUCTS\') }}</div><div class="item" data-value="upcomingProducts">{{ translate(\'UPCOMING-PRODUCTS\') }}</div><div class="item" data-value="expiredProducts">{{ translate(\'EXPIRED-PRODUCTS\') }}</div></div></div><a ng-if="vm.hasPermission" class="ui right floated green labeled icon button" href="/admin/products/new-product"><i class="plus icon"></i> {{ translate(\'CREATE-PRODUCT\') }}</a><div class="segment ui no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><table class="ui attached table sortable"><thead><tr><th ng-if="vm.switchSelected === \'currentProducts\' || vm.switchSelected === \'CURRENT-PRODUCTS\'">{{ translate(\'STATUS\') }}</th><th table-sort="" order="\'description\'" by="order" reverse="reverse" sort="vm.sortProducts" class="product-description-column">{{ translate(\'DESCRIPTION\') }}</th><th>{{ translate(\'CAPPING-TYPE\') }}</th><th>{{ translate(\'ACTIVATION\') }}</th><th>{{ translate(\'ZONES\') }}</th><th>{{ translate(\'PRODUCT-PERIOD\') }}</th><th ng-if="vm.hasPermission"></th></tr></thead><tbody ng-if="vm.cappingModel.allCapping.length > 0"><tr ng-repeat="(key,capping) in vm.cappingModel.allCapping"><td ng-if="vm.switchSelected === \'currentProducts\' || vm.switchSelected === \'CURRENT-PRODUCTS\'" data-th="{{ translate(\'STATUS\') }}"><i class="circle icon" ng-class="{\'red\': capping.status !==\'ACTIVE\', \'green\': capping.status ===\'ACTIVE\'}"></i> <span ng-class="{\'text-success\': capping.status===\'ACTIVE\', \'text-danger\': capping.status!==\'ACTIVE\' }">{{ translate(capping.status | uppercase )}}</span></td><td class="product-description-column" data-th="{{ translate(\'DESCRIPTION\') }}">{{ capping.description }}</td><td data-th="{{ translate(\'CAPPING-TYPE\') }}"><div class="label label-default" ng-if="capping.multi_participant">{{ translate(\'MULTI-OPERATOR\') }}</div><div>{{ \'PRODUCTSTATUS.\' + capping.capping_type | replaceUnderscoreWithDash | translate }}</div></td><td data-th="{{ translate(\'ACTIVATION\') }}">{{ \'PRODUCTSTATUS.\' + capping.activation_type | replaceUnderscoreWithDash | translate }}</td><td data-th="{{ translate(\'ZONES\') }}"><span class="label" ng-class="{\'label-success\':capping.zoned_capping_enabled, \'label-danger\': !capping.zoned_capping_enabled }">{{ \'PRODUCTSTATUS.\'+(capping.zoned_capping_enabled | toEnabledNot | uppercase) | translate }}</span></td><td data-th="{{ translate(\'PRODUCT-PERIOD\') }}"><label>{{ translate(\'START-DATE\') }}</label> {{ capping.start_date | dateWithTimezone: [\'short\', capping.rules.time_zone] }}<br><label>{{ translate(\'END-DATE\') }}</label> {{ capping.end_date || translate(\'INDEFINITE\') | dateWithTimezone: [\'short\', capping.rules.time_zone] }}</td><td ng-if="!capping.multi_participant" data-th="{{ translate(\'EDIT\') }}"><div class="ui buttons right floated"><a ng-if="vm.switchSelected !== \'expiredProducts\'" class="ui tiny lp-yellow icon button" title="{{ translate(\'EDIT-PRODUCT\') }}" href="/admin/products/capping/{{capping.id}}/default"><i class="pencil icon"></i></a> <a ng-if="vm.switchSelected === \'expiredProducts\'" class="ui tiny blue right floated icon button" title="{{ translate(\'VIEW-CAPPING\') }}" href="/admin/products/capping/{{capping.id}}/default"><i class="eye icon"></i></a></div></td><td ng-if="capping.multi_participant" data-th="{{ translate(\'EDIT\') }}"><a class="ui tiny blue right floated icon button" title="{{ translate(\'VIEW-CAPPING\') }}" href="/admin/products/capping/{{capping.id}}/default"><i class="eye icon"></i></a></td></tr></tbody><tbody ng-if="!vm.cappingModel.allCapping.length"><tr><td colspan="{{vm.switchSelected === \'currentProducts\' || vm.switchSelected === \'CURRENT-PRODUCTS\' ? 7 : 6}}">{{ translate(\'NO-PRODUCTS-FOUND\') }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/admin/products/capping/new/new.html','<div class="wrapper"><div class="filters clearfix"><span class="ui right floated teal icon button" ng-click="vm.showHowTo()">{{ translate(\'HOW-DO-I-USE\') }} <i class="fa fa-fw" ng-class="{\'fa-angle-down\':!vm.howToInfo, \'fa-angle-up\': vm.howToInfo}"></i></span></div><div class="infoSlider" ng-if="vm.howToInfo"><div class="alert alert-info infoSliderAlert" role="alert"><div ng-bind-html="translate(\'HOW-TO-PART1\') + translate(\'HOW-TO-PART2\') + translate(\'HOW-TO-PART3\')"></div><ul><li>{{ translate(\'POINT1\') }}</li><li>{{ translate(\'POINT2\') }}</li><li>{{ translate(\'POINT3\') }}</li></ul></div></div><form name="vm.cappingForm" id="createCappingForm" class="form-horizontal" ng-submit="vm.save(vm.capping, vm.cappingForm)" novalidate=""><div class="panel panel-default clearfix"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'ADD-NEW\') }}</h5></div><div class="panel-body"><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'STATUS\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.status.$touched, \'has-error\': vm.cappingForm.status.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.status.$touched) }"><select ng-model="vm.capping.status" name="status" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="INACTIVE">{{ translate(\'INACTIVE\') }}</option><option value="ACTIVE" ng-if="vm.capping.activation_type !== \'ASSIGNED_CUSTOMERS_ONLY\'">{{ translate(\'ACTIVE\') }}</option></select><span class="help-block sub-little-text">{{ translate(\'STATUS-HELP-TEXT\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'ACTIVATION\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.activation_type.$touched, \'has-error\': vm.cappingForm.activation_type.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.activation_type.$touched) }"><select ng-model="vm.capping.activation_type" name="activation_type" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="CUSTOMER_DEFAULT">{{ translate(\'CUSTOMER-DEFAULT\') }}</option><option value="REGISTERED_CUSTOMER_DEFAULT">{{ translate(\'REGISTERED-CUSTOMER-DEFAULT\') }}</option><option value="ASSIGNED_CUSTOMERS_ONLY" ng-if="vm.participant.currentParticipant.config.payment_config.per_customer_product_assignments">{{ translate(\'ASSIGNED-CUSTOMERS-ONLY\') }}</option></select><span class="help-block sub-little-text">{{ translate(\'ACTIVATION-TYPE-HELP-TEXT\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'CAPPING-TYPE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.capping_type.$touched, \'has-error\': vm.cappingForm.capping_type.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.capping_type.$touched) }"><select ng-model="vm.capping.capping_type" name="capping_type" class="form-control" required="" ng-change="vm.cappingTypeChanged(value)"><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option ng-repeat="cappingType in vm.getCappingTypes()" value="{{cappingType}}">{{ translate(cappingType | replaceUnderscoreWithDash) }}</option></select><span class="help-block sub-little-text">{{ translate(\'CAPPING-TYPE-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.capping.capping_type==\'WEEKLY_CAP\'"><label class="col-md-2 control-label">{{ translate(\'WEEKLY-CAP-START-DAY\') }}</label><div class="col-md-8"><div ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.weekly_cap_start_day.$touched, \'has-error\': vm.cappingForm.weekly_cap_start_day.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.weekly_cap_start_day.$touched) }"><select ng-model="vm.capping.rules.weekly_cap_start_day" class="form-control" required="" name="weekly_cap_start_day"><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="SUNDAY">{{ translate(\'SUNDAY\') }}</option><option value="MONDAY">{{ translate(\'MONDAY\') }}</option></select><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.weekly_cap_start_day.$touched"><i class="times icon form-control-feedback" ng-show="vm.cappingForm.weekly_cap_start_day.$error.required" aria-hidden="true"></i></span></div></div></div><div class="form-group" ng-if="vm.capping.capping_type==\'MULTI_DAY_CAP\'"><label class="col-md-2 control-label">{{ translate(\'MULTIDAY-CAP-NUMBEROF-DAYS\') }}</label><div class="col-md-8"><div class="ui fluid input" ng-class="{\'error\': vm.cappingForm.num_days_in_cap_window.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.num_days_in_cap_window.$touched) || !(vm.cappingForm.num_days_in_cap_window.$viewValue > 1) }"><input type="number" ng-model="vm.capping.rules.num_days_in_cap_window" name="num_days_in_cap_window" class="form-control" required=""></div><span class="help-block sub-little-text">{{ translate(\'MULTIDAY-CAP-NUMBEROF-DAYS-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'PRODUCT-CODE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.product_code.$touched, \'has-error\': vm.cappingForm.product_code.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.product_code.$touched) }"><input type="text" ng-model="vm.capping.product_code" name="product_code" class="form-control" required=""> <span ng-show="vm.cappingForm.$submitted || vm.cappingForm.product_code.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.product_code.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'PRODUCT-CODE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'DESCRIPTION\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.description.$touched, \'has-error\': vm.cappingForm.description.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.description.$touched) }"><input type="text" ng-model="vm.capping.description" name="description" class="form-control" required=""> <span ng-show="vm.cappingForm.$submitted || vm.cappingForm.description.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.description.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'DESCRIPTION-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'CAP-TRIGGER-AMOUNT\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.default_limit.$touched, \'has-error\': vm.cappingForm.default_limit.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.default_limit.$touched) || vm.cappingForm.default_limit.$viewValue < 0 }"><input type="number" ng-model="vm.capping.rules.default_limit" name="default_limit" class="form-control" required=""> <span ng-show="vm.cappingForm.$submitted || vm.cappingForm.default_limit.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.default_limit.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAP-TRIGGER-AMOUNT-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'MAX-FARE-AMOUNT\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.max_fare_value.$touched, \'has-error\': vm.cappingForm.max_fare_value.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.max_fare_value.$touched) || vm.cappingForm.max_fare_value.$viewValue < 0 }"><input type="number" ng-model="vm.capping.rules.max_fare_value" name="max_fare_value" class="form-control" required=""> <span ng-show="vm.cappingForm.$submitted || vm.cappingForm.max_fare_value.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.max_fare_value.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'MAX-FARE-AMOUNT-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.capping.capping_type===\'DAILY_CAP\'"><label class="control-label required col-md-2">{{ translate(\'ALL-DAY\') }}</label><div class="col-md-8"><div class="onoffswitch"><input type="checkbox" ng-model="vm.capping.rules.all_day" name="all_day" id="all_day" ng-true-value="true" ng-false-value="false" class="switch-checkbox" ng-change="vm.onIsAllDayToggle()"> <label class="switch-label" for="all_day"><span class="switch-inner" data-yes="{{ translate(\'YES\') }}" data-no="{{ translate(\'NO\') }}"></span> <span class="switch-switch"></span></label></div><span class="help-block sub-little-text">{{ translate(\'ALL-DAY-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.capping.rules.all_day"><label class="control-label required col-md-2">{{ translate(\'OVERLAP-TIME\') }}</label><div class="col-md-8" ng-class="{\'has-error\': !vm.cappingForm.to_time_overlap_local.$valid && (vm.cappingForm.$submitted || vm.cappingForm.to_time_overlap_local.$touched) }"><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o fa-fw"></i></span> <input name="to_time_overlap_local" placeholder="HH:mm:ss" hour-input="" class="form-control" ng-model="vm.capping.rules.to_time_overlap_local" ng-minlength="8" ng-maxlength="8"></div><span class="help-block sub-little-text">(Optional) Allow an <em>open</em> capping product to continue into the next calendar day for a limited time.<br><strong>Maximum {{vm.productsFilter.maxOverlapHours}} hours from 00:00</strong>.</span></div></div><div ng-if="vm.capping.capping_type != \'TIME_BASED_CAP\'"><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'START-TIME\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.from_time_local.$touched, \'has-error\': vm.cappingForm.from_time_local.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.from_time_local.$touched) }"><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o fa-fw"></i></span> <input class="form-control" name="from_time_local" placeholder="HH:mm:ss" maxlength="8" hour-input="" ng-model="vm.capping.rules.from_time_local" required="" ng-disabled="vm.capping.rules.all_day"></div><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.from_time_local.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.from_time_local.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'START-TIME-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.capping.capping_type!=\'MULTI_DAY_CAP\'"><label class="control-label required col-md-2">{{ translate(\'FINISH-TIME\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.to_time_local.$touched, \'has-error\': vm.cappingForm.to_time_local.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.to_time_local.$touched) }"><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o fa-fw"></i></span> <input class="form-control" placeholder="HH:mm:ss" maxlength="8" hour-input="" name="to_time_local" ng-model="vm.capping.rules.to_time_local" required="" ng-disabled="vm.capping.rules.all_day"></div><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.to_time_local.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.to_time_local.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'FINISH-TIME-HELPER\') }}</span></div></div></div><div ng-if="vm.capping.capping_type === \'TIME_BASED_CAP\'"><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'CAPPING-DURATION\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.capping_duration_in_minutes.$touched, \'has-error\': (vm.cappingForm.capping_duration_in_minutes.$error.required || !vm.cappingForm.capping_duration_in_minutes.$valid) && (vm.cappingForm.$submitted || vm.cappingForm.capping_duration_in_minutes.$touched) || vm.cappingForm.capping_duration_in_minutes.$viewValue < 1 || vm.cappingForm.capping_duration_in_minutes.$viewValue > 1440 }"><div class="input-group"><span class="input-group-addon">{{ translate(\'MINUTES\') }}</span> <input type="number" ng-model="vm.capping.rules.capping_duration_in_minutes" name="capping_duration_in_minutes" class="form-control" required="" aria-describedby="capping_duration_in_minutes-addon"></div><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.capping_duration_in_minutes.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.capping_duration_in_minutes.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAPPING-DURATION-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'NUMBER-OF-TRANSFERS\') }}</label><div class="col-md-8"><div class="onoffswitch large-switch"><input type="checkbox" ng-model="vm.capping.rules.transfer_type" name="transfer_type" id="transfer_type" ng-true-value="\'LIMITED\'" ng-false-value="\'UNLIMITED\'" class="switch-checkbox"> <label class="switch-label" for="transfer_type"><span class="switch-inner" data-yes="{{ translate(\'LIMITED\') }}" data-no="{{ translate(\'UNLIMITED\') }}"></span> <span class="switch-switch"></span></label></div><span class="help-block sub-little-text">{{ translate(\'NUMBER-OF-TRANSFERS-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.capping.rules.transfer_type === \'LIMITED\'"><div class="col-md-8 col-md-offset-2"><div class="ui secondary segment inner-form"><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'VALUE-NO-OF-TRASFERS\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.number_of_transfer.$touched, \'has-error\': vm.cappingForm.number_of_transfer.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.number_of_transfer.$touched) || vm.cappingForm.number_of_transfer.$viewValue < 1 || vm.cappingForm.number_of_transfer.$viewValue > 99 }"><input type="number" ng-model="vm.capping.rules.number_of_transfer" name="number_of_transfer" class="form-control" required=""> <span ng-show="vm.cappingForm.$submitted || vm.cappingForm.max_fare_value.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.number_of_transfer.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'VALUE-NO-OF-TRASFERS-HELPER\') }}</span></div></div></div></div></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'TIMEZONE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.time_zone.$touched, \'has-error\': vm.cappingForm.time_zone.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.time_zone.$touched) }"><timezone-selector ng-model="vm.capping.rules.time_zone" display-utc="true" translations="translations" sort-by="offset" show-local="true" width="100%" class="form-control" required="" name="time_zone"></timezone-selector><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.time_zone.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.time_zone.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'TIMEZONE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'CAPPING-APPLICATION-LEVEL\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.capping_applied_level.$touched, \'has-error\': vm.cappingForm.capping_applied_level.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.capping_applied_level.$touched) }"><select ng-options="value as (\'PRODUCTS.CAPPING.\' + value | translate) for (key,value) in vm.productsFilter.cappingAppliedLevel" ng-model="vm.capping.rules.capping_applied_level" name="capping_applied_level" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option></select><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.capping_applied_level.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.capping_applied_level.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAPPING-APPLICATION-LEVEL-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'TRANSACTION-TYPES\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.transaction_types.$touched, \'has-error\': vm.cappingForm.transaction_types.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.transaction_types.$touched) }"><select ng-options="value as (\'PRODUCTS.CAPPING.\' + (value | uppercase) | translate) for (key,value) in vm.productsFilter.transactionTypes" ng-model="vm.capping.rules.transaction_type" name="transaction_types" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option></select><span class="help-block sub-little-text">{{ translate(\'SELECT-TRANSACTION-TYPES\') }}</span> <span ng-show="vm.cappingForm.$submitted || vm.cappingForm.transaction_types.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.transaction_types.$error.required" aria-hidden="true"></i></span></div></div><div class="form-group" ng-if="vm.capping.capping_type !== \'TIME_BASED_CAP\' && vm.capping.capping_type !== undefined"><label class="control-label col-md-2">{{ translate(\'NUMBER-OF-TRIPS\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.trip_number_limit.$touched, \'has-error\': (vm.cappingForm.trip_number_limit.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.trip_number_limit.$touched)) || (vm.limitedTrips && (vm.capping.rules.trip_number_limit < 1 || vm.capping.rules.trip_number_limit > 99)) || !vm.limitedTrips }"><div class="onoffswitch large-switch"><input type="checkbox" name="routeCapping" id="trip_number_limit" ng-model="vm.limitedTrips" ng-true-value="true" ng-false-value="false" class="switch-checkbox" ng-change="vm.limitedTripChanged()"> <label class="switch-label" for="trip_number_limit"><span class="switch-inner" data-yes="{{ translate(\'LIMITED\') }}" data-no="{{ translate(\'UNLIMITED\') }}"></span> <span class="switch-switch"></span></label></div><div class="ui message" ng-if="vm.limitedTrips"><input class="form-control" type="number" placeholder="{{ translate(\'NUMBER-OF-TRIPS\') }}" ng-model="vm.capping.rules.trip_number_limit" name="trip_number_limit" required=""> <span class="help-block sub-little-text">{{ translate(\'NUMBER-OF-TRIPS-HELP-TEXT\') }}</span></div></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'SCHEDULE-START\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.proposedStart.$touched, \'has-error\': vm.cappingForm.proposedStart.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.proposedStart.$touched) }"><div class="ui message"><div class="historyText"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="immediateStart" name="proposedStart" class="modal-repeat-role-field" ng-model="vm.proposedStart" value="immediate" required=""> <label for="immediateStart" class="modal-role-label">{{ translate(\'IMMEDIATELY\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledStart" name="proposedStart" class="modal-repeat-role-field" ng-model="vm.proposedStart" value="scheduleStartDate" required=""> <label for="scheduledStart" class="modal-role-label">{{ translate(\'SET-START-DATE\') }}</label></div></div><div ng-if="vm.proposedStart === \'scheduleStartDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':vm.cappingForm.startDate.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.startDate.$touched)}"><p>{{ translate(\'PLEASE-SELECT-START-DATE\') }}</p><ng-datepicker ng-model="vm.startDate" class="datepicker-field" required="" name="startDate" not-after="vm.endDate" from-now-on="true"></ng-datepicker><span ng-if="vm.cappingForm.startDate.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.startDate.$touched)" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':vm.cappingForm.proposedStartTime.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.proposedStartTime.$touched)}"><p>{{ translate(\'PLEASE-SELECT-START-TIME\') }}</p><input type="text" ng-model="vm.proposedStartTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss" required="" name="proposedStartTime"> <span ng-if="vm.cappingForm.proposedStartTime.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.proposedStartTime.$touched)" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-TIME\') }}</span></div></div></div></div><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.proposedStart.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.proposedStart.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAPPING-START-DATE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'SCHEDULE-END\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.cappingForm.$submitted || vm.cappingForm.proposedEnd.$touched, \'has-error\': vm.cappingForm.proposedEnd.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.proposedEnd.$touched) }"><div class="ui message"><div class="historyText"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="indefiniteEnd" name="proposedEnd" class="modal-repeat-role-field" ng-model="vm.proposedEnd" value="indefinite" required=""> <label for="indefiniteEnd" class="modal-role-label">{{ translate(\'INDEFINITE\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledEnd" name="proposedEnd" class="modal-repeat-role-field" ng-model="vm.proposedEnd" value="scheduleEndDate" required=""> <label for="scheduledEnd" class="modal-role-label">{{ translate(\'SET-END-DATE\') }}</label></div></div><div ng-if="vm.proposedEnd === \'scheduleEndDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': vm.cappingForm.endDate.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.endDate.$touched) }"><p>{{ translate(\'SELECT-AN-END-DATE\') }}</p><ng-datepicker ng-model="vm.endDate" class="datepicker-field" name="endDate" required="" not-before="vm.startDate" from-now-on="true"></ng-datepicker><span ng-if="vm.cappingForm.endDate.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.endDate.$touched)" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': vm.cappingForm.proposedEndTime.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.proposedEndTime.$touched) }"><p>{{ translate(\'SELECT-AN-END-TIME\') }}</p><input type="text" ng-model="vm.proposedEndTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss" name="proposedEndTime" required=""> <span ng-if="vm.cappingForm.proposedEndTime.$error.required && (vm.cappingForm.$submitted || vm.cappingForm.proposedEndTime.$touched)" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-TIME\') }}</span></div></div></div></div><span ng-show="vm.cappingForm.$submitted || vm.cappingForm.proposedEnd.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.cappingForm.proposedEnd.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAPPING-END-DATE-HELPER\') }}</span></div></div><div class="row"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="ui green left labeled icon button"><i class="plus icon"></i>{{ translate(\'CREATE\') }}</button> <button type="button" ng-click="vm.reset(vm.cappingForm)" class="ui white button">{{ translate(\'CLEAR\') }}</button> <a href="/admin/products" class="ui negative button">{{ translate(\'CANCEL\') }}</a></div></div></div></div></form></div>');
$templateCache.put('app/pages/admin/products/capping/summary/summary.html','<div ng-controller="AdminCappingScheduleCtrl as sc"><div class="wrapper"><div class="ui message" ng-class="{\'green\': vm.isCurrent, \'orange\': vm.isFuture, \'red\': vm.isExpired}"><span ng-if="vm.isCurrent"><span ng-if="vm.cappingModel.selectedCapping.status === \'ACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-CURRENTLY-ACTIVE\') }} <span ng-if="vm.temporaryCapping.end_date">{{ translate(\'IT-IS-SCHEDULED-TO-FINISH-ON\', {\'date\': (vm.temporaryCapping.end_date | dateWithTimezone: [\'medium\', vm.temporaryCapping.rules.time_zone] ) }) }}</span> <span ng-if="!vm.temporaryCapping.end_date">{{ translate(\'NO-END-DATE-IS-SET\') }}</span></span> <span ng-if="vm.cappingModel.selectedCapping.status === \'INACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-CURRENTLY-INACTIVE\') }}</span></span> <span ng-if="vm.isFuture"><a class="ui right floated green small" href="#" ng-click="sc.schedulePopup(1)">{{ translate(\'CHANGE-THE-SCHEDULE\') }}</a> <span ng-if="vm.cappingModel.selectedCapping.status === \'INACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-ON\', {\'date\': (vm.temporaryCapping.start_date | dateWithTimezone: [\'medium\', vm.temporaryCapping.rules.time_zone] )}) }} {{ translate(\'SCHEDULED-BUT-DISABLED\') }}</span> <span ng-if="vm.cappingModel.selectedCapping.status === \'ACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-TO-BE-ACTIVE-ON\', {\'date\': (vm.temporaryCapping.start_date | dateWithTimezone: [\'medium\', vm.temporaryCapping.rules.time_zone] )}) }} <span ng-if="vm.temporaryCapping.end_date">{{ translate(\'AND-FINISH-ON\', {\'date\': (vm.temporaryCapping.end_date | dateWithTimezone: [\'medium\', vm.temporaryCapping.rules.time_zone] )}) }}</span> <span ng-if="!vm.temporaryCapping.end_date">{{ translate(\'WILL-INDEFINITE\') }}</span></span></span> <span ng-if="vm.isExpired">{{ translate(\'THIS-PRODUCT-IS-EXPIRED-ON\', {\'date\': (vm.temporaryCapping.end_date | dateWithTimezone: [\'medium\', vm.temporaryCapping.rules.time_zone])}) }}.</span> <span ng-if="vm.shouldShowTimeZone">({{ vm.temporaryCapping.rules.time_zone }})</span></div><div ng-if="sc.futureScheduledProductInfo && sc.futureScheduledProductInfo.length > 0" class="ui message yellow"><span>There is a future scheduled version<i ng-if="sc.futureScheduledProductInfo.length > 1">s</i> of this product</span><ul><li ng-repeat="p in sc.futureScheduledProductInfo"><a href="admin/products/capping/{{p.id}}/default">{{ p.product_code }}.</a> <span ng-if="p.status === \'ACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-TO-BE-ACTIVE-ON\', {\'date\': (p.start_date | dateWithTimezone: [\'medium\', p.rules.time_zone] )}) }}</span> <span ng-if="p.status === \'INACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-ON\', {\'date\': (p.start_date | dateWithTimezone: [\'medium\', p.rules.time_zone] )}) }}</span></li></ul></div><ng-form name="vm.cappingEditForm"><div id="product-summary-page" ng-show="!pageLoading" class="ui segment no-border no-padding" ng-class="{\'loading\': vm.loading}"><div class="summary-tab-block"><ul class="nav nav-stacked summary-tabs"><li ui-sref-active="active"><a ui-sref="admin.products.cappingSummary.default({copy: vm.checkIfDuplicated})"><h3 class="subheading mps-settings-section-header">{{ translate(\'PRODUCT-SETTINGS\') }}</h3><p class="settings-info">{{ translate(\'PRODUCT-SETTINGS-HELPER\') }}</p></a></li><li ui-sref-active="active"><a ui-sref="admin.products.cappingSummary.rules({copy: vm.checkIfDuplicated})"><h3 class="subheading mps-settings-section-header">{{ translate(\'PRODUCT-RULES\') }}</h3><p class="settings-info">{{ translate(\'PRODUCT-RULES-HELPER\') }}</p></a></li><li ui-sref-active="active"><a ui-sref="admin.products.cappingSummary.zones({copy: vm.checkIfDuplicated})"><h3 class="subheading mps-settings-section-header">{{ translate(\'ZONE-RULES\') }}</h3><p class="settings-info">{{ translate(\'ZONE-RULES-HELPER\') }}</p></a></li><li ui-sref-active="active" ng-if="vm.showIncentiveTab()"><a ui-sref="admin.products.cappingSummary.incentives({copy: vm.checkIfDuplicated})"><h3 class="subheading mps-settings-section-header">{{ translate(\'INCENTIVE-RULES\') }}</h3><p class="settings-info">{{ translate(\'INCENTIVE-RULES-HELPER\') }}</p></a></li></ul></div><div class="page-content-container"><div ui-view=""></div></div></div></ng-form></div><modal modal-name="submit-refund-modal" header="{{ translate(\'SCHEDULE-CHANGES\') }}" show="sc.showScheduleProductModal" on-close-click="sc.hideModal" on-submit-click="sc.submitRequest" confirmation="{{ translate(\'SUBMIT\') }}" top-position="top" cancel="{{ translate(\'CANCEL\') }}"><div class="ui message"><p>{{ translate(\'CHANGES-TAKES-PLACE-IMMEDIATELY\') }}</p><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.proposedStart}"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="immediateStart" name="startDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedStart" value="immediate"> <label for="immediateStart" class="modal-role-label">{{ translate(\'IMMEDIATELY\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledStart" name="startDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedStart" value="scheduleStartDate"> <label for="scheduledStart" class="modal-role-label">{{ translate(\'SET-START-DATE\') }}</label></div><span ng-if="sc.scheduleError.proposedStart" class="help-block sub-little-text">{{ translate(\'SELECT-START-OPTION\') }}</span></div></div><div ng-if="sc.schedule.proposedStart === \'scheduleStartDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.startDate}"><p>{{ translate(\'PLEASE-SELECT-START-DATE\') }}</p><ng-datepicker ng-model="sc.schedule.startDate" inset="inset" calendar-opened="false" class="datepicker-field" not-after="sc.schedule.endDate" from-now-on="true"></ng-datepicker><span ng-if="sc.scheduleError.startDate" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.proposedStartTime}"><p>{{ translate(\'PLEASE-SELECT-START-TIME\') }}</p><input type="text" ng-model="sc.schedule.proposedStartTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss"> <span ng-if="sc.scheduleError.proposedStartTime" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-TIME\') }}</span></div></div></div></div><div class="ui message" ng-if="sc.schedule.proposedStart === \'immediate\' || (sc.schedule.proposedStart === \'scheduleStartDate\' && sc.schedule.startDate !== undefined )"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.proposedEnd}"><p>{{ translate(\'SELECT-WHEN-PRODUCT-TO-END\') }}</p><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="indefiniteEnd" name="endDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedEnd" value="indefinite"> <label for="indefiniteEnd" class="modal-role-label">{{ translate(\'INDEFINITE\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledEnd" name="endDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedEnd" value="scheduleEndDate"> <label for="scheduledEnd" class="modal-role-label">{{ translate(\'SET-END-DATE\') }}</label></div><span ng-if="sc.scheduleError.proposedEnd" class="help-block sub-little-text">{{ translate(\'SELECT-OPTION-END-DATE\') }}</span></div></div><div ng-if="sc.schedule.proposedEnd === \'scheduleEndDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': sc.scheduleError.endDate }"><p>{{ translate(\'SELECT-AN-END-DATE\') }}</p><ng-datepicker ng-model="sc.schedule.endDate" inset="inset" class="datepicker-field" not-before="sc.schedule.startDate" from-now-on="true"></ng-datepicker><span ng-if="sc.scheduleError.endDate" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': sc.scheduleError.proposedEndTime || sc.scheduleError.proposedEndTimeInvalid }"><p>{{ translate(\'SELECT-AN-END-TIME\') }}</p><input type="text" ng-model="sc.schedule.proposedEndTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss"> <span ng-if="sc.scheduleError.proposedEndTime" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-TIME\') }}</span> <span ng-if="sc.scheduleError.proposedEndTimeInvalid" class="help-block sub-little-text">{{ translate(\'END-TIME-CANNOT-BE-BEFORE-START-TIME\') }}</span></div></div></div></div></modal></div>');
$templateCache.put('app/pages/admin/products/discount/list/list.html','<div class="wrapper" ng-show="!pageLoading"><div class="filters clearfix" ng-if="vm.hasPermission"><span class="ui right floated teal icon button" ng-click="vm.showHowTo()">{{ translate(\'HOW-DO-I-USE\') }} <i class="fa fa-fw" ng-class="{\'fa-angle-down\':!vm.infoToggle, \'fa-angle-up\': vm.infoToggle}"></i></span></div><div class="infoSlider" ng-if="vm.infoToggle"><div class="alert alert-info infoSliderAlert" role="alert"><div ng-bind-html="translate(\'HOW-TO-PART1-DISCOUNT\') + translate(\'HOW-TO-PART2-DISCOUNT\')"></div></div></div><div id="entryChangeDropdown" class="ui compact selection dropdown" ng-model="vm.switchSelected" dropdown="" dropdown-change="vm.switchTab"><i class="dropdown icon"></i><div class="text">{{ translate(vm.switchSelected) }}</div><div class="menu"><div class="item" data-value="currentProducts">{{ translate(\'CURRENT-PRODUCTS\') }}</div><div class="item" data-value="upcomingProducts">{{ translate(\'UPCOMING-PRODUCTS\') }}</div><div class="item" data-value="expiredProducts">{{ translate(\'EXPIRED-PRODUCTS\') }}</div></div></div><a ng-if="vm.hasPermission" class="ui right floated green labeled icon button" href="/admin/products/new-discount-product"><i class="plus icon"></i> {{ translate(\'CREATE-PRODUCT\') }}</a><div class="segment ui no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><table class="ui table"><thead><tr class="header"><th ng-if="vm.switchSelected === \'currentProducts\' || vm.switchSelected === \'CURRENT-PRODUCTS\'">{{ translate(\'STATUS\') }}</th><th class="product-description-column">{{ translate(\'DESCRIPTION\') }}</th><th>{{ translate(\'DISCOUNT-TYPE\') }}</th><th>{{ translate(\'DISCOUNT\') }}</th><th>{{ translate(\'ACTIVATION-TYPE\') }}</th><th>{{ translate(\'PRODUCT-PERIOD\') }}</th><th ng-if="vm.hasPermission"></th></tr></thead><tbody ng-if="vm.discountModel.allDiscount.length > 0"><tr ng-repeat="(key,discount) in vm.discountModel.allDiscount"><td ng-if="vm.switchSelected === \'currentProducts\' || vm.switchSelected === \'CURRENT-PRODUCTS\'" data-th="{{ translate(\'STATUS\') }}"><i class="circle icon" ng-class="{\'red\': discount.status !==\'ACTIVE\', \'green\': discount.status ===\'ACTIVE\'}"></i> <span ng-class="{\'text-success\': discount.status===\'ACTIVE\', \'text-danger\': discount.status!==\'ACTIVE\' }">{{ translate(discount.status | uppercase )}}</span></td><td class="product-description-column" data-th="{{ translate(\'DESCRIPTION\') }}">{{ discount.description }}</td><td data-th="{{ translate(\'DISCOUNT-TYPE\') }}"><div class="label label-default" ng-if="discount.multi_participant">{{ translate(\'MULTI-OPERATOR\') }}</div><div>{{ \'PRODUCTSTATUS.\' + discount.discount_type | replaceUnderscoreWithDash | translate }}</div></td><td data-th="{{ translate(\'DISCOUNT-AMOUNT\') }}">{{ discount.discount_type === "FIXED" ? discount.fixed_discount : discount.percentage_discount + \'%\' }}</td><td data-th="{{ translate(\'ACTIVATION\') }}">{{ \'PRODUCTSTATUS.\' + discount.activation_type | replaceUnderscoreWithDash | translate }}</td><td data-th="{{ translate(\'PRODUCT-PERIOD\') }}"><label>{{ translate(\'START-DATE\') }}</label> {{ discount.start_date | dateWithTimezone: [\'short\', discount.rules.time_zone] }}<br><label>{{ translate(\'END-DATE\') }}</label> {{ discount.end_date || translate(\'INDEFINITE\') | dateWithTimezone: [\'short\', discount.rules.time_zone] }}</td><td ng-if="!discount.multi_participant" data-th="{{ translate(\'EDIT\') }}"><div class="ui buttons right floated"><a ng-if="vm.switchSelected !== \'expiredProducts\'" class="ui tiny lp-yellow icon button" title="{{ translate(\'EDIT-PRODUCT\') }}" href="/admin/products/discount/{{discount.id}}"><i class="pencil icon"></i></a> <a ng-if="vm.switchSelected === \'expiredProducts\'" class="ui tiny blue right floated icon button" title="{{ translate(\'VIEW-CAPPING\') }}" href="/admin/products/discount/{{discount.id}}"><i class="eye icon"></i></a></div></td><td ng-if="discount.multi_participant" data-th="{{ translate(\'EDIT\') }}"><a class="ui tiny blue right floated icon button" title="{{ translate(\'VIEW-CAPPING\') }}" href="/admin/products/discount/{{discount.id}}"><i class="eye icon"></i></a></td></tr></tbody><tbody ng-if="!vm.discountModel.allDiscount.length"><tr><td colspan="{{vm.switchSelected === \'currentProducts\' || vm.switchSelected === \'CURRENT-PRODUCTS\' ? 7 : 6}}">{{ translate(\'NO-PRODUCTS-FOUND\') }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/admin/products/discount/new/new.html','<div class="wrapper"><div class="filters clearfix"><span class="ui right floated teal icon button" ng-click="vm.showHowTo()">{{ translate(\'HOW-DO-I-USE\') }} <i class="fa fa-fw" ng-class="{\'fa-angle-down\':!vm.toggleHowToInfo, \'fa-angle-up\': vm.toggleHowToInfo}"></i></span></div><div class="infoSlider" ng-if="vm.toggleHowToInfo"><div class="alert alert-info infoSliderAlert" role="alert"><div ng-bind-html="translate(\'HOW-TO-PART1-DISCOUNT\') + translate(\'HOW-TO-PART2-DISCOUNT\')"></div></div></div><form name="vm.discountForm" id="createDiscountForm" class="form-horizontal" ng-submit="vm.save(vm.discount, vm.discountForm)" novalidate=""><div class="panel panel-default clearfix"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'ADD-NEW-DISCOUNT\') }}</h5></div><div class="panel-body"><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'STATUS\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.status.$touched, \'has-error\': vm.discountForm.status.$error.required && (vm.discountForm.$submitted || vm.discountForm.status.$touched) }"><select ng-model="vm.discount.status" name="status" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="INACTIVE">{{ translate(\'INACTIVE\') }}</option><option value="ACTIVE">{{translate(\'ACTIVE\') }}</option></select><span class="help-block sub-little-text">{{ translate(\'STATUS-HELP-TEXT\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'ACTIVATION\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.activation_type.$touched, \'has-error\': vm.discountForm.activation_type.$error.required && (vm.discountForm.$submitted || vm.discountForm.activation_type.$touched) }"><select ng-model="vm.discount.activation_type" name="activation_type" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="ASSIGNED_CUSTOMERS_ONLY" ng-if="vm.participant.currentParticipant.config.payment_config.per_customer_product_assignments">{{ translate(\'ASSIGNED-CUSTOMERS-ONLY\') }}</option></select><span class="help-block sub-little-text">{{ translate(\'ACTIVATION-TYPE-HELP-TEXT\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'PRODUCT-CODE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.product_code.$touched, \'has-error\': vm.discountForm.product_code.$error.required && (vm.discountForm.$submitted || vm.discountForm.product_code.$touched) }"><input type="text" ng-model="vm.discount.product_code" name="product_code" class="form-control" required=""> <span ng-show="vm.discountForm.$submitted || vm.discountForm.product_code.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.product_code.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'PRODUCT-CODE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'DESCRIPTION\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.description.$touched, \'has-error\': vm.discountForm.description.$error.required && (vm.discountForm.$submitted || vm.discountForm.description.$touched) }"><input type="text" ng-model="vm.discount.description" name="description" class="form-control" required=""> <span ng-show="vm.discountForm.$submitted || vm.discountForm.description.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.description.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'DESCRIPTION-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'DISCOUNT-TYPE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.discount_type.$touched, \'has-error\': vm.discountForm.discount_type.$error.required && (vm.discountForm.$submitted || vm.discountForm.discount_type.$touched) }"><select ng-options="(\'PRODUCTS.CAPPING.\' + key | translate) for key in vm.productsFilter.discountType" ng-model="vm.discount.discount_type" name="discount_type" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option></select><span class="help-block sub-little-text">{{ translate(\'DISCOUNT-TYPE-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.discount.discount_type === \'FIXED\'"><label class="control-label required col-md-2">{{ translate(\'AMOUNT\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.fixed_discount.$touched, \'has-error\': vm.discountForm.fixed_discount.$error.required && (vm.discountForm.$submitted || vm.discountForm.fixed_discount.$touched) }"><div class="input-group"><input type="text" ng-model="vm.discount.fixed_discount" name="fixed_discount" class="form-control" required=""> <span class="input-group-addon"><i class="money icon"></i></span></div><span ng-show="vm.discountForm.$submitted || vm.discountForm.fixed_discount.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.fixed_discount.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'DISCOUNT-AMOUNT-HELPER\') }}</span></div></div><div class="form-group" ng-if="vm.discount.discount_type === \'PERCENTAGE\'"><label class="control-label required col-md-2">{{ translate(\'PERCENTAGE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.percentage_.fixed_t.$touched, \'has-error\': vm.discountForm.percentage_discount.$error.required && (vm.discountForm.$submitted || vm.discountForm.percentage_discount.$touched) }"><div class="input-group"><input type="text" ng-model="vm.discount.percentage_discount" name="percentage_discount" class="form-control" required=""> <span class="input-group-addon">%</span></div><span ng-show="vm.discountForm.$submitted || vm.discountForm.percentage_discount.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.percentage_discount.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'DISCOUNT-PERCENTAGE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'TIMEZONE\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.time_zone.$touched, \'has-error\': vm.discountForm.time_zone.$error.required && (vm.discountForm.$submitted || vm.discountForm.time_zone.$touched) }"><timezone-selector ng-model="vm.discount.time_zone" display-utc="true" translations="translations" sort-by="offset" show-local="true" width="100%" class="form-control" required="" name="time_zone"></timezone-selector><span ng-show="vm.discountForm.$submitted || vm.discountForm.time_zone.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.time_zone.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'TIMEZONE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'SCHEDULE-START\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.proposedStart.$touched, \'has-error\': vm.discountForm.proposedStart.$error.required && (vm.discountForm.$submitted || vm.discountForm.proposedStart.$touched) }"><div class="ui message"><div class="historyText"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="immediateStart" name="proposedStart" class="modal-repeat-role-field" ng-model="vm.proposedStart" value="immediate" required=""> <label for="immediateStart" class="modal-role-label">{{ translate(\'IMMEDIATELY\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledStart" name="proposedStart" class="modal-repeat-role-field" ng-model="vm.proposedStart" value="scheduleStartDate" required=""> <label for="scheduledStart" class="modal-role-label">{{ translate(\'SET-START-DATE\') }}</label></div></div><div ng-if="vm.proposedStart === \'scheduleStartDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':vm.discountForm.startDate.$error.required && (vm.discountForm.$submitted || vm.discountForm.startDate.$touched)}"><p>{{ translate(\'PLEASE-SELECT-START-DATE\') }}</p><ng-datepicker ng-model="vm.startDate" class="datepicker-field" required="" name="startDate" not-after="vm.endDate" from-now-on="true"></ng-datepicker><span ng-if="vm.discountForm.startDate.$error.required && (vm.discountForm.$submitted || vm.discountForm.startDate.$touched)" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':vm.discountForm.proposedStartTime.$error.required && (vm.discountForm.$submitted || vm.discountForm.proposedStartTime.$touched)}"><p>{{ translate(\'PLEASE-SELECT-START-TIME\') }}</p><input type="text" ng-model="vm.proposedStartTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss" required="" name="proposedStartTime"> <span ng-if="vm.discountForm.proposedStartTime.$error.required && (vm.discountForm.$submitted || vm.discountForm.proposedStartTime.$touched)" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-TIME\') }}</span></div></div></div></div><span ng-show="vm.discountForm.$submitted || vm.discountForm.proposedStart.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.proposedStart.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAPPING-START-DATE-HELPER\') }}</span></div></div><div class="form-group"><label class="control-label required col-md-2">{{ translate(\'SCHEDULE-END\') }}</label><div class="col-md-8" ng-class="{\'has-feedback\': vm.discountForm.$submitted || vm.discountForm.proposedEnd.$touched, \'has-error\': vm.discountForm.proposedEnd.$error.required && (vm.discountForm.$submitted || vm.discountForm.proposedEnd.$touched) }"><div class="ui message"><div class="historyText"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="indefiniteEnd" name="proposedEnd" class="modal-repeat-role-field" ng-model="vm.proposedEnd" value="indefinite" required=""> <label for="indefiniteEnd" class="modal-role-label">{{ translate(\'INDEFINITE\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledEnd" name="proposedEnd" class="modal-repeat-role-field" ng-model="vm.proposedEnd" value="scheduleEndDate" required=""> <label for="scheduledEnd" class="modal-role-label">{{ translate(\'SET-END-DATE\') }}</label></div></div><div ng-if="vm.proposedEnd === \'scheduleEndDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': vm.discountForm.endDate.$error.required && (vm.discountForm.$submitted || vm.discountForm.endDate.$touched) }"><p>{{ translate(\'SELECT-AN-END-DATE\') }}</p><ng-datepicker ng-model="vm.endDate" class="datepicker-field" name="endDate" required="" not-before="vm.startDate" from-now-on="true"></ng-datepicker><span ng-if="vm.discountForm.endDate.$error.required && (vm.discountForm.$submitted || vm.discountForm.endDate.$touched)" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': vm.discountForm.proposedEndTime.$error.required && (vm.discountForm.$submitted || vm.discountForm.proposedEndTime.$touched) }"><p>{{ translate(\'SELECT-AN-END-TIME\') }}</p><input type="text" ng-model="vm.proposedEndTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss" name="proposedEndTime" required=""> <span ng-if="vm.discountForm.proposedEndTime.$error.required && (vm.discountForm.$submitted || vm.discountForm.proposedEndTime.$touched)" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-TIME\') }}</span></div></div></div></div><span ng-show="vm.discountForm.$submitted || vm.discountForm.proposedEnd.$touched"><i class="fa-times fa form-control-feedback" ng-show="vm.discountForm.proposedEnd.$error.required" aria-hidden="true"></i></span> <span class="help-block sub-little-text">{{ translate(\'CAPPING-END-DATE-HELPER\') }}</span></div></div><div class="row"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="ui green left labeled icon button"><i class="plus icon"></i>{{ translate(\'CREATE\') }}</button> <button type="button" ng-click="vm.reset(vm.discountForm)" class="ui white button">{{ translate(\'CLEAR\') }}</button> <a href="/admin/products" class="ui negative button">{{ translate(\'CANCEL\') }}</a></div></div></div></div></form></div>');
$templateCache.put('app/pages/admin/products/discount/summary/summary.html','<div ng-controller="AdminDiscountScheduleCtrl as sc"><div class="wrapper"><div class="ui message" ng-class="{\'green\': vm.isCurrent, \'orange\': vm.isFuture, \'red\': vm.isExpired}"><span ng-if="vm.isCurrent"><span ng-if="vm.discountModel.selectedDiscount.status === \'ACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-CURRENTLY-ACTIVE\') }} <span ng-if="vm.temporaryDiscount.end_date">{{ translate(\'IT-IS-SCHEDULED-TO-FINISH-ON\', {\'date\': (vm.temporaryDiscount.end_date | dateWithTimezone: [\'medium\', vm.temporaryDiscount.rules.time_zone] ) }) }}</span> <span ng-if="!vm.temporaryDiscount.end_date">{{ translate(\'NO-END-DATE-IS-SET\') }}</span></span> <span ng-if="vm.discountModel.selectedDiscount.status === \'INACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-CURRENTLY-INACTIVE\') }}</span></span> <span ng-if="vm.isFuture"><a class="ui right floated green small" href="#" ng-click="sc.schedulePopup(1)">{{ translate(\'CHANGE-THE-SCHEDULE\') }}</a> <span ng-if="vm.discountModel.selectedDiscount.status === \'INACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-ON\', {\'date\': (vm.temporaryDiscount.start_date | dateWithTimezone: [\'medium\', vm.temporaryDiscount.rules.time_zone] )}) }} {{ translate(\'SCHEDULED-BUT-DISABLED\') }}</span> <span ng-if="vm.discountModel.selectedDiscount.status === \'ACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-TO-BE-ACTIVE-ON\', {\'date\': (vm.temporaryDiscount.start_date | dateWithTimezone: [\'medium\', vm.temporaryDiscount.rules.time_zone] )}) }} <span ng-if="vm.temporaryDiscount.end_date">{{ translate(\'AND-FINISH-ON\', {\'date\': (vm.temporaryDiscount.end_date | dateWithTimezone: [\'medium\', vm.temporaryDiscount.rules.time_zone] )}) }}</span> <span ng-if="!vm.temporaryDiscount.end_date">{{ translate(\'WILL-INDEFINITE\') }}</span></span></span> <span ng-if="vm.isExpired">{{ translate(\'THIS-PRODUCT-IS-EXPIRED-ON\', {\'date\': (vm.temporaryDiscount.end_date | dateWithTimezone: [\'medium\', vm.temporaryDiscount.rules.time_zone])}) }}.</span> <span ng-if="vm.shouldShowTimeZone">({{ vm.temporaryDiscount.rules.time_zone }})</span></div><div ng-if="sc.futureScheduledProductInfo && sc.futureScheduledProductInfo.length > 0" class="ui message yellow"><span>There is a future scheduled version<i ng-if="sc.futureScheduledProductInfo.length > 1">s</i> of this product</span><ul><li ng-repeat="p in sc.futureScheduledProductInfo"><a href="admin/products/discount/{{p.id}}">{{ p.product_code }}.</a> <span ng-if="p.status === \'ACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-TO-BE-ACTIVE-ON\', {\'date\': (p.start_date | dateWithTimezone: [\'medium\', p.rules.time_zone] )}) }}</span> <span ng-if="p.status === \'INACTIVE\'">{{ translate(\'THIS-PRODUCT-IS-SCHEDULED-ON\', {\'date\': (p.start_date | dateWithTimezone: [\'medium\', p.rules.time_zone] )}) }}</span></li></ul></div><div id="product-summary-page" ng-show="!pageLoading" class="ui segment no-border no-padding" ng-class="{\'loading\': vm.loading}"><div class="page-content-container"><div class="panel panel-default clearfix"><div class="panel-heading"><edit-button ng-if="vm.canEdit && !vm.isExpired" variable="vm.vars.forms.defaultForm" update="vm.updateProduct" cancel="vm.getTemporaryValue" edit="vm.editProduct" order="vm.vars.forms.defaultForm"></edit-button><h5 class="panel-title">{{ translate(\'PRODUCTS-DEFAULT-OPTIONS\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'STATUS\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm"><span class="model-status model-status-{{vm.temporaryDiscount.status | lowercase }} tooltip-icon"></span> {{ translate(vm.temporaryDiscount.status) }}</div><div ng-if="vm.vars.forms.defaultForm"><select class="form-control" ng-model="vm.temporaryDiscount.status"><option value="ACTIVE">{{ translate(\'ACTIVE\') }}</option><option value="INACTIVE">{{ translate(\'INACTIVE\') }}</option></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'PRODUCT-TYPE\') }}</div><div class="col-xs-7">{{ translate(vm.temporaryDiscount.product_type) }}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'PRODUCT-CODE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ vm.temporaryDiscount.product_code }}</div><div ng-if="vm.vars.forms.defaultForm"><input type="text" ng-model="vm.temporaryDiscount.product_code" class="form-control inForm"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'DESCRIPTION\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ vm.temporaryDiscount.description }}</div><div ng-if="vm.vars.forms.defaultForm"><input type="text" ng-model="vm.temporaryDiscount.description" class="form-control inForm"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'ACTIVATION\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ translate(vm.temporaryDiscount.activation_type | replaceUnderscoreWithDash) || \'empty\' }}</div><div ng-if="vm.vars.forms.defaultForm"><select ng-model="vm.temporaryDiscount.activation_type" class="form-control"><option value="ASSIGNED_CUSTOMERS_ONLY" ng-if="vm.participant.currentParticipant.config.payment_config.per_customer_product_assignments">{{translate(\'ASSIGNED-CUSTOMERS-ONLY\')}}</option></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'DISCOUNT-TYPE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm"><div>{{ translate(vm.temporaryDiscount.discount_type) }}</div></div><div ng-if="vm.vars.forms.defaultForm"><select ng-model="vm.temporaryDiscount.discount_type" class="form-control"><option ng-repeat="discountType in vm.vars.filters.discountType" value="{{discountType}}">{{ translate(discountType) }}</option></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text"><span ng-if="vm.temporaryDiscount.discount_type === \'FIXED\'">{{ translate(\'DISCOUNT-AMOUNT\') }}</span> <span ng-if="vm.temporaryDiscount.discount_type === \'PERCENTAGE\'">{{ translate(\'DISCOUNT-PERCENTAGE\') }}</span></div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm"><div ng-if="vm.temporaryDiscount.discount_type === \'FIXED\'">{{ vm.temporaryDiscount.fixed_discount }}</div><div ng-if="vm.temporaryDiscount.discount_type === \'PERCENTAGE\'">{{ vm.temporaryDiscount.percentage_discount }} %</div></div><div class="input-group" ng-if="vm.vars.forms.defaultForm"><input ng-if="vm.temporaryDiscount.discount_type === \'FIXED\'" type="number" ng-model="vm.temporaryDiscount.fixed_discount" class="form-control inForm"> <input ng-if="vm.temporaryDiscount.discount_type === \'PERCENTAGE\'" type="number" ng-model="vm.temporaryDiscount.percentage_discount" class="form-control inForm"> <span ng-if="vm.temporaryDiscount.discount_type === \'PERCENTAGE\'" class="input-group-addon">%</span> <span ng-if="vm.temporaryDiscount.discount_type === \'FIXED\'" class="input-group-addon"><i class="money icon"></i></span></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'TIMEZONE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ vm.temporaryDiscount.time_zone | date:\'mediumTime\' }}</div><div ng-if="vm.vars.forms.defaultForm"><timezone-selector ng-model="vm.temporaryDiscount.time_zone" display-utc="true" translations="translations" primary-choices="vm.temporaryDiscount.time_zone" sort-by="offset" show-local="true" width="100%"></timezone-selector></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryDiscount.multi_participant && vm.temporaryDiscount.multi_participants_list"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'PARTICIPANTS\') }}</div><div class="col-xs-7"><div>{{ (vm.getMultiParticipantNamesFromIds(vm.temporaryDiscount.participant_ids)) | join }}</div></div></div></li><li class="list-group-item" ng-if="vm.temporaryDiscount.multi_participant"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'REVENUE-APPORTIONMENT-TYPE\') }}</div><div class="col-xs-7"><div>{{ vm.temporaryDiscount.revenue_apportionment_type | lowercase}}</div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CREATED\') }}</div><div class="col-xs-7">{{ vm.temporaryDiscount.created_date | date:\'medium\' }}</div></div></li></ul></div><div class="panel panel-default" ng-if="vm.canEdit"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'DUPLICATE-PRODUCT\') }}</h5></div><div class="panel-body"><p><b>{{ translate(\'DUPLICATE-PRODUCT-INFO\') }}</b></p><br><p><a href="#" class="ui teal button" ng-click="sc.duplicateProduct()"><i class="copy outline icon"></i> {{ translate(\'DUPLICATE-THIS-PRODUCT\') }}</a></p></div></div><div class="panel panel-default" ng-if="vm.canEdit && !vm.checkIfDuplicated"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'DELETE-PRODUCT\') }}</h5></div><div class="panel-body"><p><b>{{ translate(\'DELETE-PRODUCT-INFO\') }}</b></p><br><p><a href="#" class="ui red button" ng-click="vm.deleteProduct()"><i class="trash alternate icon"></i> {{ translate(\'DELETE-THIS-PRODUCT\') }}</a></p></div></div></div></div></div><modal modal-name="submit-refund-modal" header="{{ translate(\'SCHEDULE-CHANGES\') }}" show="sc.showScheduleProductModal" on-close-click="sc.hideModal" on-submit-click="sc.submitRequest" confirmation="{{ translate(\'SUBMIT\') }}" top-position="top" cancel="{{ translate(\'CANCEL\') }}"><div class="ui message"><p>{{ translate(\'CHANGES-TAKES-PLACE-IMMEDIATELY\') }}</p><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.proposedStart}"><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="immediateStart" name="startDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedStart" value="immediate"> <label for="immediateStart" class="modal-role-label">{{ translate(\'IMMEDIATELY\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledStart" name="startDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedStart" value="scheduleStartDate"> <label for="scheduledStart" class="modal-role-label">{{ translate(\'SET-START-DATE\') }}</label></div><span ng-if="sc.scheduleError.proposedStart" class="help-block sub-little-text">{{ translate(\'SELECT-START-OPTION\') }}</span></div></div><div ng-if="sc.schedule.proposedStart === \'scheduleStartDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.startDate}"><p>{{ translate(\'PLEASE-SELECT-START-DATE\') }}</p><ng-datepicker ng-model="sc.schedule.startDate" inset="inset" calendar-opened="false" class="datepicker-field" not-after="sc.schedule.endDate" from-now-on="true"></ng-datepicker><span ng-if="sc.scheduleError.startDate" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.proposedStartTime}"><p>{{ translate(\'PLEASE-SELECT-START-TIME\') }}</p><input type="text" ng-model="sc.schedule.proposedStartTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss"> <span ng-if="sc.scheduleError.proposedStartTime" class="help-block sub-little-text">{{ translate(\'PLEASE-PICK-START-TIME\') }}</span></div></div></div></div><div class="ui message" ng-if="sc.schedule.proposedStart === \'immediate\' || (sc.schedule.proposedStart === \'scheduleStartDate\' && sc.schedule.startDate !== undefined )"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\':sc.scheduleError.proposedEnd}"><p>{{ translate(\'SELECT-WHEN-PRODUCT-TO-END\') }}</p><div class="toggle-button toggle-button--checkbox margin-right1"><input type="radio" id="indefiniteEnd" name="endDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedEnd" value="indefinite"> <label for="indefiniteEnd" class="modal-role-label">{{ translate(\'INDEFINITE\') }}</label></div><div class="toggle-button toggle-button--checkbox"><input type="radio" id="scheduledEnd" name="endDate" class="modal-repeat-role-field" ng-model="sc.schedule.proposedEnd" value="scheduleEndDate"> <label for="scheduledEnd" class="modal-role-label">{{ translate(\'SET-END-DATE\') }}</label></div><span ng-if="sc.scheduleError.proposedEnd" class="help-block sub-little-text">{{ translate(\'SELECT-OPTION-END-DATE\') }}</span></div></div><div ng-if="sc.schedule.proposedEnd === \'scheduleEndDate\'"><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': sc.scheduleError.endDate }"><p>{{ translate(\'SELECT-AN-END-DATE\') }}</p><ng-datepicker ng-model="sc.schedule.endDate" inset="inset" class="datepicker-field" not-before="sc.schedule.startDate" from-now-on="true"></ng-datepicker><span ng-if="sc.scheduleError.endDate" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-DATE\') }}</span></div></div><div class="form-group"><div class="col-sm-12" ng-class="{\'has-error\': sc.scheduleError.proposedEndTime || sc.scheduleError.proposedEndTimeInvalid }"><p>{{ translate(\'SELECT-AN-END-TIME\') }}</p><input type="text" ng-model="sc.schedule.proposedEndTime" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss"> <span ng-if="sc.scheduleError.proposedEndTime" class="help-block sub-little-text">{{ translate(\'PICK-AN-END-TIME\') }}</span> <span ng-if="sc.scheduleError.proposedEndTimeInvalid" class="help-block sub-little-text">{{ translate(\'END-TIME-CANNOT-BE-BEFORE-START-TIME\') }}</span></div></div></div></div></modal></div>');
$templateCache.put('app/pages/admin/search/orders/orderDetails/makeOrderCorrectionModal.html','<modal modal-name="submit-refund-request" header="{{translate(\'SUBMIT-REFUND-REQUEST\')}}" confirmation="{{translate(\'SUBMIT\')}}" cancel="{{ translate(\'CANCEL\') }}" show="vm.refundOrderModal" on-submit-click="submitOrderRefundRequest" focus-first="true"><notification-message ng-model="refundNotificationMessage"></notification-message><div class="form-group"><label class="col-sm-5 control-label modal-customer-label">{{ translate(\'CHARGED-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{vm.orderModel.currentOrderDetails.order.currency}}</div><input type="text" class="form-control modal-amount-field" value="{{vm.orderModel.currentOrderDetails.order.amount | wholeNumberCurrencyToDecimal}}" readonly="" disabled=""></div></div></div><div class="form-group"><label class="col-sm-5 control-label modal-amount-label">{{ translate(\'REFUND-AMOUNT\') }}</label><div class="col-sm-7"><div class="input-group"><div class="input-group-addon">{{vm.orderModel.currentOrderDetails.order.currency}}</div><input type="text" class="form-control modal-amount-field" ng-model="vm.refundAmount"></div></div></div><div class="form-group"><label class="col-sm-5 control-label modal-reason-label">{{translate(\'CUSTOMER-COMMENT\')}}</label><div class="col-sm-7"><select ng-model="vm.customerComment" class="form-control"><option value="CUSTOMER_REQUEST">{{translate(\'CUSTOMER_REQUEST\')}}</option><option value="FRAUD">{{translate(\'FRAUD\')}}</option><option value="DUPLICATE">{{translate(\'DUPLICATE\')}}</option><option value="OTHER">{{translate(\'OTHER\') | lowerCaseWithUpperCaseFirstLetter }}</option></select></div></div><div class="form-group"><label class="col-sm-5 control-label modal-reason-label">{{translate(\'ISSUER-COMMENT\')}}</label><div class="col-sm-7"><textarea class="form-control modal-reason-field" rows="3" placeholder="{{translate(\'ISSUER-COMMENT\')}}" ng-model="vm.issuerComment"></textarea></div></div></modal>');
$templateCache.put('app/pages/admin/search/orders/orderDetails/orderDetails.html','<div class="wrapper"><div ng-include="\'app/pages/admin/search/orders/orderDetails/makeCorrectionModal.html\'"></div><div ng-include="\'app/pages/admin/search/orders/orderDetails/makeOrderCorrectionModal.html\'"></div><div class="segment ui" ng-class="{\'loading\': !vm.loading.hasLoaded}"><div class="row"><div class="col-sm-8"><div class="ui large label">{{ translate(\'ORDER-ID\') }}: {{ vm.orderModel.currentOrderDetails.order.transaction_id }}</div></div></div><div class="row"><br><div class="col-md-9"><div class="row"><div class="col-sm-8"><div class="ui huge header amount"><span class="currency">{{ vm.orderModel.currentOrderDetails.order.currency }}</span> {{ vm.orderModel.currentOrderDetails.order.amount | wholeNumberCurrencyToDecimal }} <span ng-if="vm.orderModel.currentOrderDetails.order.refunded_amount" style="font-size: small">(-{{ vm.orderModel.currentOrderDetails.order.refunded_amount | wholeNumberCurrencyToDecimal }})</span> <span class="ui medium label label-ecom-{{\'ORDER.\'+vm.orderModel.currentOrderDetails.order.status }}">{{vm.orderModel.currentOrderDetails.order.status }}</span></div></div><div class="col-sm-4"><div class="pull-right"><div class="ui medium label tooltip-icon label-ecom-{{ vm.orderModel.currentOrderDetails.order.cvv_check_status | lowercase }}" ng-if="vm.orderModel.currentOrderDetails.order.cvv_check_status != undefined" tooltips="" tooltip-template="{{\'CVV check \' + (vm.orderModel.currentOrderDetails.order.cvv_check_status | lowercase)}}"><i class="icon {{ getAuthenticationCheckStatusIcon(vm.orderModel.currentOrderDetails.order.cvv_check_status) }}"></i>CVV</div><div class="ui medium label tooltip-icon label-ecom-{{ vm.orderModel.currentOrderDetails.order.avs_check_status | lowercase }}" ng-if="vm.orderModel.currentOrderDetails.order.avs_check_status != undefined" tooltips="" tooltip-template="{{\'AVS check \' + (vm.orderModel.currentOrderDetails.order.avs_check_status | lowercase)}}"><i class="icon {{ getAuthenticationCheckStatusIcon(vm.orderModel.currentOrderDetails.order.avs_check_status) }}"></i>AVS</div><div class="ui medium label tooltip-icon label-ecom-{{ vm.orderModel.currentOrderDetails.order.three_ds_check_status | lowercase }}" ng-if="vm.orderModel.currentOrderDetails.order.three_ds_check_status != undefined" tooltips="" tooltip-template="{{\'3DS check \' + (vm.orderModel.currentOrderDetails.order.three_ds_check_status | lowercase)}}"><i class="icon {{ getAuthenticationCheckStatusIcon(vm.orderModel.currentOrderDetails.order.three_ds_check_status) }}"></i>3DS</div></div></div></div><div class="row"><br><div class="col-sm-12"><table class="ecomSummaryTable"><thead><tr class="header"><th class="">{{ translate(\'PARTICIPANT-ID\') }}</th><th class="">{{ translate(\'CUSTOMER-REF\') }}</th><th class="">{{ translate(\'PAYMENT-INTENT-ID\') }}</th><th class="">{{ translate(\'PAYMENT-METHOD\') }}</th><th class="">{{ translate(\'CLIENT-TYPE\') }}</th><th class="">{{ translate(\'LAST-UPDATE\') }}</th></tr></thead><tbody><tr><td>{{ vm.orderModel.currentOrderDetails.order.participant_id }}</td><td>{{ vm.orderModel.currentOrderDetails.order.customer_ref || translate(\'NO-REFERENCE-NUMBER\') }}</td><td>{{ vm.orderModel.currentOrderDetails.order.payment_intent_id }}</td><td><i class="big icon {{ getPaymentInstrumentIcon(vm.orderModel.currentOrderDetails.order.payment_instrument) }}"></i> {{ getPaymentInstrumentText(vm.orderModel.currentOrderDetails.order.payment_instrument) }}</td><td><span tooltips="" tooltip-template="{{ vm.orderModel.currentOrderDetails.order.client_type }}"><i class="{{ getClientTypeIcon(vm.orderModel.currentOrderDetails.order.client_type) }}"></i></span> {{ getClientTypeIcon(vm.orderModel.currentOrderDetails.order.client_type) === undefined ? vm.orderModel.currentOrderDetails.order.client_type : \'\' }}</td><td>{{ vm.orderModel.currentOrderDetails.order.last_update | date:"dd/MM/yyyy HH:mm:ss" }}</td></tr></tbody></table></div><div class="pull-right"><button class="ui icon button red small order-refund" ng-click="showRefundOrderModal()" ng-class="{\'disabled\': !canRefundOrder()}" tooltips="" tooltip-template="{{ translate(\'CANNOT-REFUND\') }}" tooltip-hidden="{{canRefundOrder()}}">{{ translate(\'ORDER-REFUND\') }}</button></div></div></div><div class="col-md-3"><table class="summaryTable"><tbody><tr><td class="header text-right">{{ translate(\'TYPE\') }} :</td><td>{{ (vm.orderModel.currentOrderDetails.order.purchase.model3_vault_id) ? translate(\'CARD\'): translate(\'OTHER\')}}</td></tr><tr><td class="header text-right">{{ translate(\'STATUS\') }} :</td><td>{{ vm.orderModel.currentOrderDetails.order.purchase.activation_status }}</td></tr><tr><td class="header text-right">{{ translate(\'VALIDITY\') }} :</td><td>{{ vm.orderModel.currentOrderDetails.order.purchase.end_date_time ? (vm.orderModel.currentOrderDetails.order.purchase.end_date_time | date:"dd/MM/yyyy HH:mm:ss") : "N/A" }}</td></tr><tr ng-repeat="(key, value) in vm.orderModel.currentOrderDetails.order.metadata"><td class="header text-right">{{key}} :</td><td>{{value}}</td></tr></tbody></table></div></div></div><h3 class="ui dividing header">{{ translate(\'EVENTS\') }}</h3><div class="segment ui no-padding" ng-class="{\'loading\': !vm.loading.hasLoaded}"><table class="table"><thead><tr class="header"><th>{{ translate(\'TIMESTAMP\') }}</th><th>{{ translate(\'TYPE\') }}</th><th>{{ translate(\'DETAILS\') }}</th><th>{{ translate(\'ID\') }}</th></tr></thead><tbody><tr ng-repeat="event in vm.orderModel.currentOrderDetails.history | orderBy:\'+\'"><td data-th="{{ translate(\'TIMESTAMP\') }}">{{ event.timestamp | date:"dd/MM/yyyy HH:mm:ss"}}</td><td data-th="{{ translate(\'TYPE\') }}">{{ getEntityType(event) }}</td><td data-th="{{ translate(\'DETAILS\') }}">{{ getEventDetails(event) }}<div ng-if="shouldDisplayPaymentInstrument(event)"><i class="big icon {{ getPaymentInstrumentIcon(event.payment_instrument) }}"></i> {{ getPaymentInstrumentText(event.payment_instrument) }}</div></td><td data-th="{{ translate(\'ID\') }}">{{ event.entity_type == \'authentication\' ? \'\' : event.id }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/admin/settings/settingsAccount/components/createUser.html','<modal modal-name="create-staff-account-modal" header="{{ createRevenueInspectionAccountModal ? translate(\'CREATE-REVENUE-INSPECTION-ACCOUNT\') : translate(\'CREATE-STAFF-ACCOUNT\') }}" confirmation="{{ translate(\'SUBMIT\') }}" show="createStaffAccountModal || createRevenueInspectionAccountModal" on-submit-click="createUserModal" on-close-click="modalCloseClick" ng-if="isAdmin" cancel="{{ translate(\'CANCEL\') }}"><notification-message ng-model="createUserNotificationMessage"></notification-message><div class="form-group" ng-class="{\'has-error\': invalid.email, \'has-feedback\': invalid.email }"><label class="col-sm-3 control-label modal-email-label text-right">{{ translate(\'EMAIL\') }}</label><div class="col-sm-9"><input type="text" class="form-control modal-email-field" ng-model="userModel.newUser.email"> <span class="glyphicon icon-cross form-control-feedback" ng-show="userModel.newUser.invalidUserEmail" aria-hidden="true"></span></div></div><div class="form-group" ng-class="{\'has-error\': invalid.password, \'has-feedback\': invalid.password }"><label class="col-sm-3 control-label modal-password-label">{{ translate(\'PASSWORD\') }}</label><div class="col-sm-9"><input type="password" class="form-control modal-password-field" ng-model="userModel.newUser.password"> <span class="glyphicon icon-cross form-control-feedback" ng-show="userModel.newUser.invalidUserPassword" aria-hidden="true"></span></div></div><div class="form-group" ng-class="{\'has-error\': invalid.repeatPassword, \'has-feedback\': invalid.repeatPassword }"><label class="col-sm-3 control-label modal-repeat-password-label">{{ translate(\'REPEAT-PASSWORD\') }}</label><div class="col-sm-9"><input type="password" class="form-control modal-repeat-password-field" ng-model="userModel.newUser.repeatPassword"> <span class="glyphicon icon-cross form-control-feedback" ng-show="invalidUserPasswordRepeat" aria-hidden="true"></span></div></div><div class="form-group" ng-if="!createRevenueInspectionAccountModal"><div class="col-sm-offset-3 col-sm-9"><div class="toggle-button toggle-button--checkbox"><input type="checkbox" id="userRole" class="modal-repeat-role-field" ng-model="userModel.newUser.role" ng-true-value="\'admin\'" ng-false-value="\'user\'" ng-checked="false"> <label for="userRole" class="modal-role-label">{{ translate(\'MAKE-USER-ADMIN\') }}</label></div></div></div><div ng-if="!createRevenueInspectionAccountModal && (userModel.newUser.role != \'admin\')" class="form-group" ng-repeat="permission in permissionModel.list.permissions"><div class="col-sm-offset-3 col-sm-9"><div class="toggle-button toggle-button--checkbox"><input ng-if="userModel.newUser.role != \'admin\'" type="checkbox" id="{{permission.name}}" class="modal-repeat-role-field" ng-model="userModel.newUser.permissions[permission.name]" ng-init="userModel.newUser.permissions[permission.name] = false"> <label for="{{permission.name}}" class="modal-role-label">{{ \'PERMISSIONS.\' + (permission.name | uppercase) | translate }}</label></div></div></div></modal>');
$templateCache.put('app/pages/admin/settings/settingsAccount/components/deleteUser.html','<modal modal-name="delete-staff-account-modal" header="{{ deleteRevenueInspectionAccountModal ? translate(\'DELETE-REVENUE-INSPECTION-USER-ACCOUNT\') : translate(\'DELETE-STAFF-ACCOUNT\') }}" confirmation="{{ translate(\'SUBMIT\') }}" show="deleteStaffAccountModal || deleteRevenueInspectionAccountModal" on-submit-click="deleteUserModal" on-close-click="modalCloseClick" cancel="{{ translate(\'CANCEL\') }}"><p>{{ translate(\'DELETE-WARNING-MESSAGE\', {user: currentUser.email}) }}</p><p>{{ translate(\'PROCEED\') }}</p></modal>');
$templateCache.put('app/pages/admin/settings/settingsAccount/components/updatePassword.html','<modal modal-name="change-password-staff-account-modal" header="{{ translate(\'CHANGE-ACCOUNT-PASSWORD\') }}" confirmation="{{ translate(\'SUBMIT\') }}" show="editRevenueInspectionAccountModal" on-submit-click="updateUserModel" on-close-click="modalCloseClick" ng-if="isAdmin" cancel="{{ translate(\'CANCEL\') }}"><notification-message ng-model="createUserNotificationMessage"></notification-message><div class="form-group"><label class="col-sm-3 control-label modal-email-label text-right">{{ translate(\'EMAIL\') }}</label><div class="col-sm-9"><input type="text" class="form-control modal-email-field" ng-model="currentUser.email" ng-readonly="true"></div></div><div class="form-group" ng-class="{\'has-error\': invalid.password, \'has-feedback\': invalid.password }"><label class="col-sm-3 control-label modal-password-label">{{ translate(\'NEW-PASSWORD\') }}</label><div class="col-sm-9"><input type="password" class="form-control modal-password-field" ng-model="userModel.newUser.password"> <span class="glyphicon icon-cross form-control-feedback" ng-show="userModel.newUser.invalidUserPassword" aria-hidden="true"></span></div></div><div class="form-group" ng-class="{\'has-error\': invalid.repeatPassword, \'has-feedback\': invalid.repeatPassword }"><label class="col-sm-3 control-label modal-repeat-password-label">{{ translate(\'REPEAT-NEW-PASSWORD\') }}</label><div class="col-sm-9"><input type="password" class="form-control modal-repeat-password-field" ng-model="userModel.newUser.repeatPassword"> <span class="glyphicon icon-cross form-control-feedback" ng-show="invalidUserPasswordRepeat" aria-hidden="true"></span></div></div></modal>');
$templateCache.put('app/pages/admin/settings/settingsGeneral/components/childParticipants.html','<section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'CHILD-PARTICIPANTS\') }}</h3><p class="settings-info">{{ translate(\'CHILD-PARTICIPANTS-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default clearfix"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'CHILD-PARTICIPANTS-LIST\') }}</h5></div><ul class="list-group"><li class="list-group-item" ng-repeat="(key,child) in participantModel.currentParticipant.child_participants">{{child.name}}</li></ul></div></div></div></section>');
$templateCache.put('app/pages/admin/settings/settingsGeneral/components/merchantConfig.html','<ul class="list-group merchantConfigList"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'MERCHANT-ID\') }}</div><div class="col-xs-7">{{config.merchant_id}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'MERCHANT-CATEGORY-CODE\') }}</div><div class="col-xs-7">{{config.merchant_category_code}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'ACQUIRER-TERMINAL-ID\') }}</div><div class="col-xs-7">{{config.acquirer_terminal_id}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'MERCHANT-NAME\') }}</div><div class="col-xs-7">{{config.merchant_name}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'CITY\') }}</div><div class="col-xs-7">{{config.merchant_city}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'POST-CODE\') }}</div><div class="col-xs-7">{{config.merchant_post_code}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'COUNTRY\') }}</div><div class="col-xs-7">{{config.merchant_country | isoCountry}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'CURRENCY\') }}</div><div class="col-xs-7">{{config.currency_code | toISOCurrency}}</div></div></li></ul>');
$templateCache.put('app/pages/admin/settings/settingsGeneral/components/merchantSettings.html','<section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'MERCHANT-CONFIGS\') }}</h3><p class="settings-info">{{ translate(\'MERCHANT-CONFIGS-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default clearfix"><div class="panel-heading"><ul class="nav nav-tabs"><li class="uib-tab nav-item" ng-repeat="config in participantModel.currentParticipant.config.merchant_configs" ng-class="{\'active\':merchantConfigSelected === $index}"><a class="nav-link panel-title" href="#" ng-click="switchMerchant($index)">{{config.currency_code | toISOCurrency }}</a></li></ul></div><div class="panel-body" id="peakOffPeakSettings" ng-if="participantModel.currentParticipant.config.merchant_configs.length > 0"><div ng-repeat="config in participantModel.currentParticipant.config.merchant_configs track by $index" ng-if="merchantConfigSelected === $index" include-with-scope="app/pages/admin/settings/settingsGeneral/components/merchantConfig.html"></div></div><div class="panel-body" ng-if="participantModel.currentParticipant.config.merchant_configs.length === 0">{{ translate(\'NO-CONFIGS-MSG\') }}</div></div><div class="panel panel-default clearfix" ng-if="participantModel.currentParticipant.config.local_time_zone"><ul class="list-group"><li class="list-group-item" ng-if="participantModel.currentParticipant.config.local_time_zone"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'TIMEZONE\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.config.local_time_zone }}</div></div></li></ul></div></div></div></section><section><div class="row"><div class="col-md-4"><h3 class="subheading mps-settings-section-header">{{ translate(\'MERCHANT-PRICING-SETTINGS\')}}</h3><p class="settings-info">{{ translate(\'MERCHANT-PRICING-SETTING-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><edit-button ng-if="haspermissionIssueRefund" variable="forms.mpsForm" update="updateParticipant" cancel="cancelParticipant" disable="forms.mpsFormDisable"></edit-button><h5 class="panel-title">{{ translate(\'MPS-SETTINGS\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'MPS-ENGINE\') }}</div><div class="col-xs-7">{{ participantModel.currentParticipant.config.mps_config.mps_engine }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.mps_config.mps_engine_version"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'MPS-ENGINE-VERSION\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.config.mps_config.mps_engine_version }}</div></div></li><li class="list-group-item" ng-show="(!forms.mpsForm && participantModel.currentParticipant.config.mps_config.pricing.maximum_journey_time) || forms.mpsForm"><div class="row"><div class="col-xs-5 panel-t"><span>{{ translate(\'MAXIMUM-JOURNEY-TIME\') }}</span> <i class="fa fa-fw fa-info-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'MAXIMUM-JOURNEY-TIME-TOOLTIP\') }}"></i></div><div class="col-xs-7" ng-show="!forms.mpsForm">{{ participantModel.currentParticipant.config.mps_config.pricing.maximum_journey_time | secondsToHms }}</div><div class="col-xs-7" ng-show="forms.mpsForm"><div class="input-group inForm form-group" ng-class="{ \'has-error\':errorMaxJourneyTime }"><input type="number" ng-model="participantTemporary.config.mps_config.pricing.maximum_journey_time" class="form-control"> <span class="input-group-addon">{{ translate(\'MINUTES\') }}</span></div><span class="help-text">{{ translate(\'MAXIMUM-JOURNEY-TIME-HELP-TEXT\') }}</span></div></div></li><li class="list-group-item" ng-show="(!forms.mpsForm && participantModel.currentParticipant.config.mps_config.pricing.tap_correlation_buffer) || forms.mpsForm"><div class="row"><div class="col-xs-5 panel-t"><span>{{ translate(\'TAP-CORRELATION-BUFFER\') }}</span> <i class="fa fa-fw fa-info-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'TAP-CORRELATION-BUFFER-TOOLTIP\') }}"></i></div><div class="col-xs-7" ng-show="!forms.mpsForm">{{participantModel.currentParticipant.config.mps_config.pricing.tap_correlation_buffer | secondsToHms }}</div><div class="col-xs-7" ng-show="forms.mpsForm"><div class="input-group inForm form-group" ng-class="{ \'has-error\':errorCorrelationBuffer }"><input type="number" ng-model="participantTemporary.config.mps_config.pricing.tap_correlation_buffer" class="form-control"> <span class="input-group-addon">{{ translate(\'MINUTES\') }}</span></div><span class="help-text">{{ translate(\'TAP-CORRELATION-BUFFER-HELP-TEXT\') }}</span></div></div></li></ul></div></div></div></section><section><div class="row"><div class="col-md-4"><h3 class="subheading payment-settings-section-header">{{ translate(\'PAYMENT-SETTINGS\') }}</h3><p class="settings-info">{{ translate(\'PAYMENT-SETTINGS-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'AGGREGATION-CONFIG\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'AGGREGATING\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.config.payment_config.aggregating | toYesNo }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.aggregating"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'AGGREGATION-TYPE\') }}</div><div class="col-xs-7" ng-if="isAggregationEndOfDay()">{{ translate(\'AGGREGATION-END-OF-DAY\') }}</div><div class="col-xs-7" ng-if="isRollingAggregation()">{{translate(\'ROLLING-AGGREGATION\')}}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.aggregating && isRollingAggregation()"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'AGGREGATION-DURATION\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.config.payment_config.aggregation_duration | secondsToHms }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.aggregating && isAggregationEndOfDay()"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'AGGREGATION-END-OF-DAY-TIME\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.config.payment_config.end_of_day_time}}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.aggregating"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'AGGREGATION-MAX-AMOUNT\') }}</div><div class="col-xs-7 number-field">{{ participantModel.currentParticipant.config.payment_config.aggregation_max_amount | number:2 }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.aggregating"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'AGGREGATION-MAX-FARE\') }}</div><div class="col-xs-7 number-field">{{ participantModel.currentParticipant.config.payment_config.aggregation_max_fare ? (participantModel.currentParticipant.config.payment_config.aggregation_max_fare | number:2) : \'\'}}</div></div></li></ul></div><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'REFUNDS-CONFIG\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'ENABLE-REFUND\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.config.payment_config.refund_config.enable_refunds | toYesNo }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.refund_config.enable_refunds"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'MAX-REFUNDS-IN-PERIOD\') }}</div><div class="col-xs-7 number-field">{{participantModel.currentParticipant.config.payment_config.refund_config.max_refunds_in_period }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.refund_config.enable_refunds"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'RESTRICTION-PERIOD\') }}</div><div class="col-xs-7 number-field">{{participantModel.currentParticipant.config.payment_config.refund_config.restriction_period_days}}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.refund_config.enable_refunds"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'RESTRICTION-TYPE\') }}</div><div class="col-xs-7">{{participantModel.currentParticipant.currentParticipant.config.payment_config.refund_config.restriction_type}}</div></div></li></ul></div><div class="panel panel-default"><div class="panel-heading"><edit-button ng-if="hasPermissionWriteProduct" variable="forms.adjustableForm" update="updateParticipant" cancel="cancelParticipant"></edit-button><h5 class="panel-title">{{ translate(\'ADJUSTABLE-CONFIG\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'ENABLE-ADJUSTMENTS\') }}</div><div class="col-xs-7">{{ participantModel.currentParticipant.config.payment_config.adjustments_enabled | toYesNo }}</div></div></li><li class="list-group-item" ng-if="participantModel.currentParticipant.config.payment_config.adjustments_enabled"><div class="row"><div class="col-xs-5 panel-t">{{ translate(\'INCOMPLETE-FARES\') }}</div><div class="col-xs-7" ng-show="!forms.adjustableForm">{{ translate(participantModel.currentParticipant.config.payment_config.incomplete_handling_mode) }}</div><div class="col-xs-7" ng-show="forms.adjustableForm"><select ng-model="participantTemporary.config.payment_config.incomplete_handling_mode" class="form-control"><option value="MATCH_ANY_ONWARD_ZONE_HIGHEST_CAP">{{ translate(\'MATCH_ANY_ONWARD_ZONE_HIGHEST_CAP\') }}</option><option value="MATCH_ALL_ONWARD_ZONES_LOWEST_CAP">{{ translate(\'MATCH_ALL_ONWARD_ZONES_LOWEST_CAP\') }}</option><option value="EXCLUDE_INCOMPLETE_FARE_FROM_CAPPING">{{ translate(\'EXCLUDE_INCOMPLETE_FARE_FROM_CAPPING\') }}</option></select></div></div></li></ul></div></div></div></section><section ng-if="participantModel.currentParticipant.config.avs_config"><div class="row"><div class="col-md-4"><h3 class="subheading mps-settings-section-header">{{ translate(\'VERIFICATION-SETTINGS\') }}</h3><p class="settings-info">{{ translate(\'VERIFICATION-SETTINGS-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'CARD-VERIFICATION-OPTIONS\') }}</h5></div><div class="panel-body"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'SUCCESS-CRITERIA\') }}</div><div class="col-xs-7 mps-version-text"><span class="label" ng-class="{\'label-success\': \'MATCH_BOTH\' === participantModel.currentParticipant.config.avs_config.success_criteria, \'label-warning\': \'MATCH_ADDRESS\' === participantModel.currentParticipant.config.avs_config.success_criteria, \'label-info\': \'MATCH_POSTCODE\' === participantModel.currentParticipant.config.avs_config.success_criteria, \'label-danger\' : \'EITHER\' === participantModel.currentParticipant.config.avs_config.success_criteria, \'label-primary\' : \'CVV_ONLY\' === participantModel.currentParticipant.config.avs_config.success_criteria, }" ng-show="!forms.AvsConfigForm">{{ translate(participantModel.currentParticipant.config.avs_config.success_criteria | replaceUnderscoreWithDash ) }}</span></div></div></div></div></div></div></section><section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'SERVICE-MODE\') }}</h3><p class="settings-info">{{ translate(\'SERVICE-MODE-DETAILS\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'SERVICE-MODE\') }}</div><div class="col-xs-7 mps-version-text"><span class="label" ng-class="{\'label-success\': \'LIVE\' === participantModel.currentParticipant.config.service_mode, \'label-warning\': \'PILOT\' === participantModel.currentParticipant.config.service_mode, \'label-danger\' : \'PILOT_CAPTURE\' === participantModel.currentParticipant.config.service_mode, }" ng-show="!serviceModeForm">{{ translate(participantModel.currentParticipant.config.service_mode | replaceUnderscoreWithDash) }}</span></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/admin/settings/settingsGeneral/components/participantInfo.html','<div ng-if="!pageLoading && !error"><section><div class="row"><div class="col-md-4"><h3 class="subheading">{{ translate(\'CUSTOMER-INFO\') }}</h3><p class="settings-info">{{ translate(\'CUSTOMER-INFO-DETAIL\') }}</p></div><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'CUSTOMER\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 participant-id-label panel-t">{{ translate(\'ID\') }}</div><div class="col-xs-7 participant-id-text">{{participantModel.currentParticipant.id}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 participant-name-label panel-t">{{ translate(\'PARTICIPANT-ID\') }}</div><div class="col-xs-7 participant-id-text">{{participantModel.currentParticipant.participant_id}}</div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 participant-name-label panel-t">{{ translate(\'NAME\') }}</div><div class="col-xs-7 participant-name-text">{{participantModel.currentParticipant.name}}</div></div></li></ul></div></div></div></section></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/averageRevenue/section.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding"><thead><tr><th colspan="3"><h3>Average Revenue per Customer Data</h3></th><th colspan="1"><div class="ui right floated teal labeled icon button"><i class="download icon"></i> Download</div></th></tr><tr><th class="force-center-align">Date</th><th class="force-right-align">Total Transaction ({{vm.analyticsModel.currencySymbol}})</th><th class="force-right-align">Total Active Transactions (#)</th><th class="force-right-align">Daily Average Revenue per Customer ({{vm.analyticsModel.currencySymbol}})</th></tr></thead><tbody><tr ng-repeat="row in vm.analyticsModel.lifetime_value.csvData"><td class="force-center-align" data-th="Date">{{ row.submit_date | date:\'dd/MM/yyyy\'}}</td><td class="force-right-align" data-th="Total Transaction ({{vm.analyticsModel.currencySymbol}})">{{ row.total_trans_amt | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="Total Active Transactions (#)">{{ row.total_active_tran | number:0 }}</td><td class="force-right-align" data-th="Daily Average Revenue per Customer ({{vm.analyticsModel.currencySymbol}})">{{ row.daily_average_revenue_per_user | currency:vm.analyticsModel.currencySymbol}}</td></tr></tbody><tfoot><tr><th colspan="9" ng-if="vm.analyticsModel.csvData.length === 0"><h4 class="ui red">No customers data been found.</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/cappedVsUncapped/section.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding analytics-heading"><thead><tr><th><h3>{{ translate(\'CUSTOMERS-DATA\') }}</h3></th><th><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" add-bom="true" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div></th></tr></thead></table><table class="ui table fixed-padding analytics-data"><thead><tr><th width="{{vm.getColWidth(0)}}" class="index text-center">#</th><th width="{{vm.getColWidth(1)}}" ng-if="vm.isAtParentLevel()">{{ translate(\'CHILD-PARTICIPANT-NAME\') }}</th><th width="{{vm.getColWidth(2)}}">{{ translate(\'WEEK-COMMENCING\') }}</th><th width="{{vm.getColWidth(3)}}">{{ translate(\'CAPPING-FREQUENCY\') }}</th><th width="{{vm.getColWidth(4)}}">{{ translate(\'NUMBER-OF-CUSTOMERS\') }}</th><th width="{{vm.getColWidth(5)}}" class="force-right-align">{{ translate(\'TOTAL-NOMINAL-AMOUNT\') }}</th><th width="{{vm.getColWidth(6)}}" class="force-right-align">{{ translate(\'TOTAL-CHARGE-AMOUNT\') }}</th><th width="{{vm.getColWidth(7)}}" class="force-right-align">{{ translate(\'DIFFERENCE\') }}</th><th width="{{vm.getColWidth(8)}}" class="force-right-align">{{ translate(\'AVG-LAST-30-DAYS-NOMINAL-SPEND\') }}</th></tr></thead><tbody><tr ng-repeat="item in vm.analyticsModel.capped_vs_uncapped.csvData" ng-class="{\'new-section\': $index>0 && vm.isFirstForDate(item.week_commencing, $index)}"><td class="collapsing center aligned" data-th="#">{{1 + $index}}</td><td data-th="{{ translate(\'CHILD-PARTICIPANT-NAME\') }}" ng-if="vm.isAtParentLevel()">{{item.participant_name}}</td><td data-th="{{ translate(\'WEEK-COMMENCING\') }}">{{ item.week_commencing | date:\'shortDate\'}}</td><td data-th="{{ translate(\'CAPPING-FREQUENCY\') }}">{{ translate(\'CAPPING-FREQUENCY-SHORT-\' + item.capping_frequency) }}</td><td data-th="{{ translate(\'NUMBER-OF-CUSTOMERS\') }}">{{ item.customer_count | number }}</td><td class="force-right-align" data-th="{{ translate(\'TOTAL-NOMINAL-AMOUNT\') }}">{{ item.total_nominal_amount | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'TOTAL-CHARGE-AMOUNT\') }}">{{ item.total_charge_amount | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'DIFFERENCE\') }}">{{ item.capping_frequency===0 ? \'-\' : (item.nominal_charge_difference | currency:vm.analyticsModel.currencySymbol) }}</td><td class="force-right-align" data-th="{{ translate(\'AVG-LAST-30-DAYS-NOMINAL-SPEND\') }}">{{ item.last_30_days_average_nominal_amount | currency:vm.analyticsModel.currencySymbol }}</td></tr></tbody><tfoot><tr><th colspan="8" ng-if="vm.analyticsModel.capped_vs_uncapped.csvData.length === 0"><h4 class="ui red">{{ translate(\'NO-CUSTOMERS-FOUND\') }}</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/lifeTime/data.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding"><thead><tr><th colspan="5"><h3>Lifetime Value Data</h3></th><th colspan="1"><div class="ui right floated teal labeled icon button"><i class="download icon"></i> Download</div></th></tr><tr><th class="force-center-align">Date</th><th class="force-right-align">Total Transaction ({{vm.analyticsModel.currencySymbol}})</th><th class="force-right-align">Total Active Transactions (#)</th><th class="force-right-align">User Churn Rate (%)</th><th class="force-right-align">Daily Average Revenue per Customer ({{vm.analyticsModel.currencySymbol}})</th><th class="force-right-align">LTV ({{vm.analyticsModel.currencySymbol}})</th></tr></thead><tbody><tr ng-repeat="row in vm.analyticsModel.lifetime_value.csvData"><td class="force-center-align" data-th="Date">{{ row.submit_date | date:\'dd/MM/yyyy\'}}</td><td class="force-right-align" data-th="Total Transaction ({{vm.analyticsModel.currencySymbol}})">{{ row.total_trans_amt | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align" data-th="Total Active Transactions (#)">{{ row.total_active_tran | number:0 }}</td><td class="force-right-align" data-th="User Churn Rate (%)">{{ row.user_churn_rate | number }}%</td><td class="force-right-align" data-th="Daily Average Revenue per Customer ({{vm.analyticsModel.currencySymbol}})">{{ row.daily_average_revenue_per_user | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="LTV ({{vm.analyticsModel.currencySymbol}})">{{ row.ltv | currency:vm.analyticsModel.currencySymbol}}</td></tr></tbody><tfoot><tr><th colspan="9" ng-if="vm.analyticsModel.csvData.length === 0"><h4 class="ui red">No customers data been found.</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/lifeTime/section.html','<div class="ui segments" ng-if="vm.isLifetimeChartSelected()"><div class="lifetime-summary-section" ng-class="{\'loading\': vm.loading}"><div class="lifetime-summary-box" ng-repeat="row in vm.analyticsModel.lifetime_value.summaryData"><div class="center aligned summary-header">{{row.label}}</div><div class="center aligned summary-data">{{row.value}} <span ng-if="!!row.growth" class="summary-data-growth coloring {{row.growth < 0 ? \'red\': \'green\'}}"><i class="arrow icon {{row.growth < 0 ? \'down\': \'up\'}}"></i>{{row.growth}}%</span></div></div></div></div><div class="margin-top" include-with-scope="app/pages/admin/analysis/customers/widgets/lifeTime/data.html"></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/reactivated/data.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding"><thead><tr><th colspan="3"><h3>Reactivated Customers Data</h3></th><th colspan="1"><div class="ui right floated teal labeled icon button"><i class="download icon"></i> Download</div></th></tr><tr><th>#</th><th class="force-center-align">Date</th><th>Fare Type</th><th class="force-right-align">No of Reactivated Customers</th></tr></thead><tbody><tr ng-repeat="row in vm.analyticsModel.reactivated_customers.csvData"><td data-th="#">{{$index+1}}</td><td class="force-center-align" data-th="Date">{{ row.submit_date | date:\'dd/MM/yyyy\'}}</td><td data-th="Fare Type">{{ row.fare_type | replaceUnderscore | capitalize:true }}</td><td class="force-right-align" data-th="No of Reactivated Customers">{{ row.count | number:0 }}</td></tr></tbody><tfoot><tr><th colspan="9" ng-if="vm.analyticsModel.csvData.length === 0"><h4 class="ui red">No customers data been found.</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/reactivated/section.html','<div class="ui segments reactivated-summary-section" ng-if="vm.isReactivatedChartSelected()"><h3 class="title">Number of Reactivated Customer by Month</h3><div class="reactivated-summary-boxes" ng-class="{\'loading\': vm.loading}"><div class="reactivated-summary-box" ng-repeat="history in vm.analyticsModel.reactivated_customers_history.summaryData"><div class="center aligned summary-header">{{history.label}}</div><div class="center aligned summary-data">{{history.value}}</div></div></div></div><div class="ui segments" ng-if="vm.isReactivatedChartSelected()"><div class="segment ui" ng-class="{\'loading\': vm.loading}"><div class="hc-chart" options="vm.reactHistChartOptions"></div></div></div><div class="margin-top" include-with-scope="app/pages/admin/analysis/customers/widgets/reactivated/data.html"></div>');
$templateCache.put('app/pages/admin/analysis/customers/widgets/returningVsNew/section.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding"><thead><tr><th colspan="10"><h3>{{ translate(\'CUSTOMERS-DATA\') }}</h3></th><th colspan="2"><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" add-bom="true" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div></th></tr><tr><th class="index text-center">#</th><th class="force-center-align">{{ translate(\'WEEK-COMMENCING\') }}</th><th class="force-right-align">{{ translate(\'FARE-TYPE\') }}</th><th class="force-right-align">{{ translate(\'NEW\') }}</th><th class="force-right-align">{{ translate(\'RETAINED\') }}</th><th class="force-right-align">{{ translate(\'RETURNING\') }}</th><th class="force-right-align">{{ translate(\'NEW-NOMINAL\') }}</th><th class="force-right-align">{{ translate(\'NEW-ADJUSTED\') }}</th><th class="force-right-align">{{ translate(\'RETAINED-NOMINAL\') }}</th><th class="force-right-align">{{ translate(\'RETAINED-ADJUSTED\') }}</th><th class="force-right-align">{{ translate(\'RETURNING-NOMINAL\') }}</th><th class="force-right-align">{{ translate(\'RETURNING-ADJUSTED\') }}</th></tr></thead><tbody><tr ng-repeat="item in vm.analyticsModel.new_vs_returning.csvData"><td class="collapsing center aligned" data-th="#">{{1 + $index}}</td><td class="force-center-align" data-th="{{ translate(\'WEEK-COMMENCING\') }}">{{ item.week_commencing | date:\'shortDate\'}}</td><td class="force-right-align" data-th="{{ translate(\'FARE-TYPE\') }}">{{ translate(vm.getFareLabel(item.fare_type | uppercase)) }}</td><td class="force-right-align" data-th="{{ translate(\'NEW\') }}">{{ item.new | number }}</td><td class="force-right-align" data-th="{{ translate(\'RETAINED\') }}">{{ item.retained | number}}</td><td class="force-right-align" data-th="{{ translate(\'RETURNING\') }}">{{ item.returning | number}}</td><td class="force-right-align" data-th="{{ translate(\'NEW-NOMINAL\') }}">{{ item.new_nominal | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'NEW-ADJUSTED\') }}">{{ item.new_adjusted | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'RETAINED-NOMINAL\') }}">{{ item.retained_nominal | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'RETAINED-ADJUSTED\') }}">{{ item.retained_adjusted | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'RETURNING-NOMINAL\') }}">{{ item.returning_nominal | currency:vm.analyticsModel.currencySymbol}}</td><td class="force-right-align" data-th="{{ translate(\'RETURNING-ADJUSTED\') }}">{{ item.returning_adjusted | currency:vm.analyticsModel.currencySymbol}}</td></tr><tr class="row-highlight-other-total"><td></td><td colspan="2">{{ translate(\'TOTAL-OVER-PERIOD\') }}</td><td class="force-right-align">{{ vm.analyticsModel.new_vs_returning.csvDataSummary.new | number }}</td><td class="force-right-align">N/A</td><td class="force-right-align">N/A</td><td class="force-right-align">{{ vm.analyticsModel.new_vs_returning.csvDataSummary.new_nominal | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align">{{ vm.analyticsModel.new_vs_returning.csvDataSummary.new_adjusted | currency:vm.analyticsModel.currencySymbol }}</td><td class="force-right-align">N/A</td><td class="force-right-align">N/A</td><td class="force-right-align">N/A</td><td class="force-right-align">N/A</td></tr></tbody><tfoot><tr><th colspan="9" ng-if="vm.analyticsModel.new_vs_returning.csvData.length === 0"><h4 class="ui red">{{ translate(\'NO-CUSTOMERS-FOUND\') }}</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/declines/widgets/dataTables/byBin.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding"><thead><tr><th colspan="9"><h3>{{ translate(\'TOP-BINS-BY-DECLINED-TRANSACTION-COUNT\') }}</h3></th><th colspan="1"><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div></th></tr><tr><th class="force-center-align">{{ translate(\'BIN\') }}</th><th>{{ translate(\'SCHEME\') }}</th><th>{{ translate(\'FARE-TYPE\') }}</th><th>{{ translate(\'REQUEST-TYPE\') }}</th><th class="force-right-align">{{ translate(\'DECLINED-TRANSACTION-COUNT\') }}</th><th class="force-right-align">{{ translate(\'DECLINED-TRANSACTION-VALUE\') }} ({{vm.currencySymbol}})</th><th class="force-right-align">{{ translate(\'TOTAL-TRANSACTION-COUNT\') }}</th><th class="force-right-align">{{ translate(\'TOTAL-TRANSACTION-VALUE\') }} ({{ vm.currencySymbol }})</th><th class="force-right-align">{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-COUNT\') }}</th><th class="force-right-align">{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-VALUE\') }}</th></tr></thead><tbody><tr ng-repeat="decline in vm.declinesByBin"><td class="force-center-align" data-th="BIN">{{ decline.bin || translate(\'UNKNOWN\') }}</td><td data-th="Issuer Name">{{ decline.scheme }}</td><td data-th="{{ translate(\'FARE-TYPE\') }}">{{ ::decline.fare_type }}</td><td data-th="{{ translate(\'REQUEST-TYPE\') }}">{{ ::decline.request_type }}</td><td class="force-right-align" data-th="{{ translate(\'DECLINED-TRANSACTION-COUNT\') }}">{{ decline.declined_count }}</td><td class="force-right-align" data-th="{{ translate(\'DECLINED-TRANSACTION-VALUE\') }} ({{ vm.currencySymbol }})">{{ decline.declined_value | currency:vm.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'TOTAL-TRANSACTION-COUNT\') }}">{{ decline.total_count }}</td><td class="force-right-align" data-th="{{ translate(\'TOTAL-TRANSACTION-VALUE\') }} ({{ vm.currencySymbol }})">{{ decline.total_value | currency:vm.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-COUNT\') }}">{{ decline.declined_count_percent | number:2 }}%</td><td class="force-right-align" data-th="{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-VALUE\') }}">{{ decline.declined_value_percent | number:2 }}%</td></tr></tbody><tfoot><tr><th colspan="10" ng-if="vm.declinesByBin.length === 0"><h4 class="ui red">{{ translate(\'NO-DECLINES-FOUND\') }}</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/declines/widgets/dataTables/byDate.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding-12px fixed-layout"><thead><tr><th width="46%" colspan="{{vm.isAtParentLevel() ? 8 : 7}}" class="no-bottom-border"><h3>{{ translate(\'DECLINES-BY-DATE\') }}</h3></th><th width="54%" colspan="12"><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div></th></tr><tr><th width="46%" colspan="{{vm.isAtParentLevel() ? 8 : 7}}" class="no-top-border"></th><th width="13.5%" class="force-center-align left-border" colspan="3">{{ translate(\'DECLINE-COUNT\') }}</th><th width="13.5%" class="force-center-align left-border" colspan="3">{{ translate(\'DECLINE-COUNT-PERCENTAGE\') }}</th><th width="13.5%" class="force-center-align left-border" colspan="3">{{ translate(\'DECLINE-AMOUNT\') }} ({{ vm.currencySymbol }})</th><th width="13.5%" class="force-center-align left-border" colspan="3">{{ translate(\'DECLINE-RATE\') }}</th></tr><tr><th width="2%" class="force-left-align">{{ translate(\'TAP-DATE\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'TAP-DATE-TOOLTIP\') }}" class="small question circle icon push-top"></i></th><th width="24%" class="force-left-align" ng-if="vm.isAtParentLevel()">{{ translate(\'CHILD-PARTICIPANT\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'CHILD-PARTICIPANT-TOOLTIP\') }}" class="small question circle icon push-top"></i></th><th width="4%" class="force-left-align">{{ translate(\'SCHEME\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'SCHEME-TOOLTIP\') }}" class="small question circle icon push-top"></i></th><th width="2%">{{ translate(\'DECLINE-REASON\') }}</th><th width="2%">{{ translate(\'FARE-TYPE\') }}</th><th width="2%">{{ translate(\'REQUEST-TYPE\') }}</th><th width="4%" class="force-center-align">{{ translate(\'TOTAL-TRANSACTION-COUNT-TABLE\') }}</th><th width="4%" class="force-center-align">{{ translate(\'TOTAL-TRANSACTION-AMOUNT-TABLE\') }} ({{ vm.currencySymbol }})</th><th width="4.5%" class="force-center-align left-border">{{ translate(\'COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'COVERED-TOOLTIP\')}}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-center-align">{{ translate(\'NOT-COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'NOT-COVERED-TOOLTIP\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-right-align">{{ translate(\'TOTAL\') }}</th><th width="4.5%" class="force-center-align left-border">{{ translate(\'COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'COVERED-TOOLTIP2\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-center-align">{{ translate(\'NOT-COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'NOT-COVERED-TOOLTIP2\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-right-align">{{ translate(\'TOTAL\') }}</th><th width="4.5%" class="force-center-align left-border">{{ translate(\'COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'COVERED-TOOLTIP3\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-center-align">{{ translate(\'NOT-COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'NOT-COVERED-TOOLTIP3\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-right-align">{{ translate(\'TOTAL\') }}</th><th width="4.5%" class="force-center-align left-border">{{ translate(\'COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'COVERED-TOOLTIP4\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-center-align">{{ translate(\'NOT-COVERED\') }} <i tooltips="" tooltip-side="top" tooltip-template="{{ translate(\'NOT-COVERED-TOOLTIP4\') }}" class="small question circle icon push-top"></i></th><th width="4.5%" class="force-right-align">{{ translate(\'TOTAL\') }}</th></tr></thead><tbody><tr ng-repeat="decline in vm.tableData" ng-class="{\'row-highlight-other-total\': decline.scheme && !decline.decline_code, \'row-highlight-date-total\': !decline.scheme}"><td class="force-left-align" data-th="Submit Date">{{::decline.submit_date | date:\'shortDate\'}}</td><td class="force-left-align" data-th="Child Participant" ng-if="vm.isAtParentLevel()">{{ ::decline.participant_name }}</td><td class="force-left-align" data-th="Scheme">{{vm.getSchemeOrSummaryRowTitle(decline)}}</td><td><span ng-if="decline.decline_code">{{::decline.decline_code}}{{vm.getDeclineReason(decline)}}</span></td><td data-th="{{ translate(\'FARE-TYPE\') }}">{{ ::decline.fare_type }}</td><td data-th="{{ translate(\'REQUEST-TYPE\') }}">{{ ::decline.request_type }}</td><td class="force-right-align" data-th="Total Transaction Count">{{ ::decline.total_trans_count }}</td><td class="force-right-align" data-th="Total Transaction Amount, After Adjustments ({{::vm.currencySymbol}})">{{ ::decline.total_adjusted_amount | currency:vm.currencySymbol }}</td><td class="force-right-align left-border" data-th="Declines Covered Under Issuer Liability (#)">{{ ::decline.total_covered_count | number:0 }}</td><td class="force-right-align" data-th="Declines Not Covered Under Issuer Liability (#)">{{ ::decline.total_not_covered_count | number:0 }}</td><td class="force-right-align" data-th="Total Decline Count (#)">{{ ::decline.total_all_decline_count | number:0 }}</td><td class="force-right-align left-border" data-th="Decline Rate, Covered under Issuer Liability (% of Total Count)">{{ ::decline.covered_percent | number:2 }}%</td><td class="force-right-align" data-th="Decline Rate, Not Covered under Issuer Liability (% of Total Count)">{{ ::decline.not_covered_percent | number:2 }}%</td><td class="force-right-align" data-th="Decline Rate (% of Total Count)">{{ ::decline.all_percent | number:2 }}%</td><td class="force-right-align left-border" data-th="Decline Amount Covered under Issuer Liability ({{::vm.currencySymbol}})">{{ ::decline.total_covered_amount | currency:vm.currencySymbol }}</td><td class="force-right-align" data-th="Decline Amount Not Covered under Issuer Liability ({{::vm.currencySymbol}})">{{ ::decline.total_not_covered_amount | currency:vm.currencySymbol }}</td><td class="force-right-align" data-th="Total Decline Amount ({{::vm.currencySymbol}})">{{ ::decline.total_decline_amount | currency:vm.currencySymbol }}</td><td class="force-right-align left-border" data-th="Decline Rate, Covered under Issuer Liability (% of Total Amount)">{{ ::decline.covered_amount_percent | number:2 }}%</td><td class="force-right-align" data-th="Decline Rate, Not Covered under Issuer Liability (% of Total Amount)">{{ ::decline.not_covered_amount_percent | number:2 }}%</td><td class="force-right-align" data-th="Decline Rate (% of Total Amount)">{{ ::decline.all_amount_percent | number:2 }}%</td></tr><tr><th colspan="7" ng-if="vm.declinesByDate.length === 0 && !vm.loading"><h4 class="ui red">{{ translate(\'NO-DECLINES-FOUND\') }}</h4></th></tr></tbody><tfoot><tr><th colspan="{{vm.isAtParentLevel() ? 20 : 19}}"><page-results-summary ng-model="vm.paginationData" on-page-click="vm.goToPage"></page-results-summary></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/analysis/declines/widgets/dataTables/byIssuer.html','<div class="segment ui no-padding" ng-class="{\'loading\': vm.loading}"><table class="ui table fixed-padding"><thead><tr><th colspan="10"><h3>{{ translate(\'TOP-ISSUER-BY-DECLINED-TRANSACTION-COUNT\') }}</h3></th><th colspan="1"><div class="ui right floated teal labeled icon button" ng-csv="vm.downloadCsv()" filename="{{vm.csvFilename}}" csv-label="true" lazy-load="true"><i class="download icon"></i> {{ translate(\'DOWNLOAD\') }}</div></th></tr><tr><th>{{ translate(\'ISSUER-NAME\') }}</th><th>{{ translate(\'ISSUER-COUNTRY\') }}</th><th>{{ translate(\'SCHEME\') }}</th><th>{{ translate(\'FARE-TYPE\') }}</th><th>{{ translate(\'REQUEST-TYPE\') }}</th><th class="force-right-align">{{ translate(\'DECLINED-TRANSACTION-COUNT\') }}</th><th class="force-right-align">{{ translate(\'DECLINED-TRANSACTION-VALUE\') }} ({{vm.currencySymbol}})</th><th class="force-right-align">{{ translate(\'TOTAL-TRANSACTION-COUNT-TABLE\') }}(#)</th><th class="force-right-align">{{ translate(\'TOTAL-TRANSACTION-VALUE\') }} ({{vm.currencySymbol}})</th><th class="force-right-align">{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-VALUE\') }}</th><th class="force-right-align">{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-COUNT\') }}</th></tr></thead><tbody><tr ng-repeat="decline in vm.declinesByIssuer"><td data-th="{{ translate(\'ISSUER-NAME\') }}">{{ decline.issuer_bank === \'UNKNOWN\' ? translate(\'UNKNOWN\') : decline.issuer_bank }}</td><td data-th="{{ translate(\'ISSUER-COUNTRY\') }}">{{ decline.issuer_country === \'UNKNOWN\' ? translate(\'UNKNOWN\') : decline.issuer_country }}</td><td data-th="{{ translate(\'SCHEME\') }}">{{ decline.scheme }}</td><td data-th="{{ translate(\'FARE-TYPE\') }}">{{decline.fare_type }}</td><td data-th="{{ translate(\'FARE-TYPE\') }}">{{decline.request_type }}</td><td class="force-right-align" data-th="{{ translate(\'DECLINED-TRANSACTION-COUNT\') }}">{{ decline.declined_count }}</td><td class="force-right-align" data-th="{{ translate(\'DECLINED-TRANSACTION-VALUE\') }} ({{vm.currencySymbol}})">{{ decline.declined_value | currency:vm.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'TOTAL-TRANSACTION-COUNT-TABLE\') }}(#)">{{ decline.total_count }}</td><td class="force-right-align" data-th="{{ translate(\'TOTAL-TRANSACTION-VALUE\') }} ({{vm.currencySymbol}})">{{ decline.total_value | currency:vm.currencySymbol }}</td><td class="force-right-align" data-th="{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-VALUE\') }}">{{ decline.declined_count_percent | number:2 }}%</td><td class="force-right-align" data-th="{{ translate(\'PERCENTAGE-TOTAL-TRANSACTION-COUNT\') }}">{{ decline.declined_value_percent | number:2 }}%</td></tr></tbody><tfoot><tr><th colspan="7" ng-if="vm.analyticsModel.length === 0"><h4 class="ui red">{{ translate(\'NO-DECLINES-FOUND\') }}</h4></th></tr></tfoot></table></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/default.html','<div class="panel panel-default clearfix"><div class="panel-heading"><edit-button ng-if="vm.canEdit && !vm.isExpired" variable="vm.vars.forms.defaultForm" update="vm.updateProduct" cancel="vm.getTemporaryValue" edit="vm.editProduct" order="vm.vars.forms.defaultForm" disable="vm.cappingHelper.model.disable"></edit-button><h5 class="panel-title">{{ translate(\'PRODUCTS-DEFAULT-OPTIONS\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'STATUS\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm"><span class="model-status model-status-{{vm.temporaryCapping.status | lowercase }} tooltip-icon"></span> {{ translate(vm.temporaryCapping.status) }}</div><div ng-if="vm.vars.forms.defaultForm"><select class="form-control" ng-model="vm.temporaryCapping.status"><option value="ACTIVE">{{ translate(\'ACTIVE\') }}</option><option value="INACTIVE">{{ translate(\'INACTIVE\') }}</option></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'PRODUCT-TYPE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ translate(vm.temporaryCapping.product_type) }}</div><div ng-if="vm.vars.forms.defaultForm"><select ng-options="key as (\'PRODUCTS.CAPPING.\' + value | uppercase | translate) for (key, value) in vm.vars.filters.productType" ng-model="vm.temporaryCapping.product_type" class="form-control"></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'PRODUCT-CODE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ vm.temporaryCapping.product_code }}</div><div ng-if="vm.vars.forms.defaultForm" ng-class="{\'has-error\': vm.cappingEditForm.product_code.$error.required && (vm.cappingEditForm.$submitted || vm.cappingEditForm.product_code.$touched)}"><input type="text" required="" name="product_code" ng-model="vm.temporaryCapping.product_code" class="form-control inForm"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'DESCRIPTION\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ vm.temporaryCapping.description }}</div><div ng-if="vm.vars.forms.defaultForm"><input type="text" ng-model="vm.temporaryCapping.description" class="form-control inForm"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAPPING-TYPE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm"><div ng-if="vm.temporaryCapping.multi_participant" class="label label-default display-inline-block">{{ translate(\'MULTI-OPERATOR\') }}</div><div>{{ translate(vm.temporaryCapping.capping_type | replaceUnderscoreWithDash) }}</div></div><div ng-if="vm.vars.forms.defaultForm"><select ng-model="vm.temporaryCapping.capping_type" class="form-control" ng-change="vm.cappingTypeChanged()"><option ng-repeat="cappingType in vm.getCappingTypes()" value="{{cappingType}}">{{ translate(cappingType | replaceUnderscoreWithDash) }}</option></select></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type===\'TIME_BASED_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAPPING-DURATION\') }}</div><div class="col-xs-7" ng-class="{\'has-error\': vm.formErrors.capping_duration_in_minutes || vm.temporaryCapping.rules.capping_duration_in_minutes < 1 || vm.temporaryCapping.rules.capping_duration_in_minutes > 1440}"><div ng-if="!vm.vars.forms.defaultForm"><ng-pluralize count="vm.temporaryCapping.rules.capping_duration_in_minutes" when="{\'0\': translate(\'NOT-SET\'), \'1\': \'{} \' + translate(\'DURATION-MINUTE\'), \'other\': \'{} \' + translate(\'DURATION-MINUTES\')}"></ng-pluralize></div><div ng-if="vm.vars.forms.defaultForm"><div class="input-group"><span class="input-group-addon">{{ translate(\'MINUTES\') }}</span> <input type="number" ng-model="vm.temporaryCapping.rules.capping_duration_in_minutes" class="form-control inForm" ng-change="vm.validateTimeBasedCapping()"></div><span class="help-block sub-little-text">{{ translate(\'CAPPING-DURATION-HELPER\') }}</span></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type===\'TIME_BASED_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'NUMBER-OF-TRANSFERS\') }}</div><div class="col-xs-7" ng-class="{\'has-error\': vm.formErrors.transfer_type }"><div ng-if="!vm.vars.forms.defaultForm">{{ translate(vm.temporaryCapping.rules.transfer_type) }}<ng-pluralize ng-if="vm.temporaryCapping.rules.transfer_type === \'LIMITED\'" count="vm.temporaryCapping.rules.number_of_transfer" when="{\'one\': \' - \' + translate(\'TRANSFER-MAX\'), \'other\': \' - \'+ translate(\'TRANSFERS-MAX\', {count : vm.temporaryCapping.rules.number_of_transfer}) }"></ng-pluralize></div><div ng-if="vm.vars.forms.defaultForm"><div class="onoffswitch large-switch"><input type="checkbox" ng-model="vm.temporaryCapping.rules.transfer_type" name="transfer_type" id="transfer_type" ng-true-value="\'LIMITED\'" ng-false-value="\'UNLIMITED\'" class="switch-checkbox" ng-change="vm.transferTypeChanged()"> <label class="switch-label" for="transfer_type"><span class="switch-inner" data-yes="{{ translate(\'LIMITED\') }}" data-no="{{ translate(\'UNLIMITED\')}}"></span> <span class="switch-switch"></span></label></div><div class="ui secondary segment inner-form" ng-if="vm.temporaryCapping.rules.transfer_type === \'LIMITED\'"><div class="form-group" ng-class="{\'has-error\': vm.formErrors.number_of_transfer || vm.temporaryCapping.rules.number_of_transfer < 1 || vm.temporaryCapping.rules.number_of_transfer > 99}"><label class="control-label">Transfer Value</label> <input type="number" ng-model="vm.temporaryCapping.rules.number_of_transfer" name="number_of_transfer" required="" class="form-control inForm" onkeypress="return event.charCode >= 48 && event.charCode <= 57" ng-change="vm.validateTimeBasedCapping()"> <span class="help-block sub-little-text">{{ translate(\'VALUE-NO-OF-TRASFERS-HELPER\') }}</span></div></div></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type==\'MULTI_DAY_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'MULTIDAY-CAP-NUMBEROF-DAYS\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ vm.temporaryCapping.rules.num_days_in_cap_window }}</div><div ng-if="vm.vars.forms.defaultForm" ng-class="{\'has-error\': vm.cappingEditForm.num_days_in_cap_window.$error.required && (vm.cappingEditForm.$submitted || vm.cappingEditForm.num_days_in_cap_window.$touched)}"><input type="number" name="num_days_in_cap_window" required="" ng-model="vm.temporaryCapping.rules.num_days_in_cap_window" class="form-control inForm"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'ACTIVATION\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.defaultForm">{{ translate(vm.temporaryCapping.activation_type | replaceUnderscoreWithDash) || \'empty\' }}</div><div ng-if="vm.vars.forms.defaultForm"><select ng-model="vm.temporaryCapping.activation_type" class="form-control"><option ng-repeat="(key, value) in vm.vars.filters.cappingActivation" value="{{key}}">{{value}}</option><option value="ASSIGNED_CUSTOMERS_ONLY" ng-if="vm.participant.currentParticipant.config.payment_config.per_customer_product_assignments">{{translate(\'ASSIGNED-CUSTOMERS-ONLY\')}}</option></select></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.multi_participant && vm.temporaryCapping.multi_participants_list"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'PARTICIPANTS\') }}</div><div class="col-xs-7"><div>{{ (vm.getMultiParticipantNamesFromIds(vm.temporaryCapping.participant_ids)) | join }}</div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.multi_participant"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'REVENUE-APPORTIONMENT-TYPE\') }}</div><div class="col-xs-7"><div>{{ vm.temporaryCapping.revenue_apportionment_type | lowercase}}</div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CREATED\') }}</div><div class="col-xs-7">{{ vm.temporaryCapping.created_date | date:\'medium\' }}</div></div></li></ul></div><div class="panel panel-default" ng-if="vm.canEdit"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'DUPLICATE-PRODUCT\') }}</h5></div><div class="panel-body"><p><b>{{ translate(\'DUPLICATE-PRODUCT-INFO\') }}</b></p><br><p><a href="#" class="ui teal button" ng-click="sc.duplicateProduct()"><i class="copy outline icon"></i> {{ translate(\'DUPLICATE-THIS-PRODUCT\') }}</a></p></div></div><div class="panel panel-default" ng-if="vm.canEdit && !vm.checkIfDuplicated"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'DELETE-PRODUCT\') }}</h5></div><div class="panel-body"><p><b>{{ translate(\'DELETE-PRODUCT-INFO\') }}</b></p><br><p><a href="#" class="ui red button" ng-click="vm.deleteProduct()"><i class="trash alternate icon"></i> {{ translate(\'DELETE-THIS-PRODUCT\') }}</a></p></div></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/incentiveDailyTable.html','<table class="ui table table-condensed no-bottom-margin"><thead><tr class="header"><th>{{ translate(vm.temporaryCapping.incentive_rules.incentive_type + \'-DAY-TRAVELLED\') }}</th><th><span ng-if="vm.cappingHelper.isIncentiveTypeDailyCap(vm.temporaryCapping)">{{ translate(\'DAILY_CAP-DISCOUNT\') }}</span> <span ng-if="!vm.cappingHelper.isIncentiveTypeDailyCap(vm.temporaryCapping)">{{ translate(\'CUMULATIVE_CAP-DISCOUNT\') }}</span></th><th>{{ translate(\'DESCRIPTION-1\') }}</th></tr></thead><tr ng-repeat="dayNumber in vm.cappingHelper.getDiscountDays(vm.temporaryCapping)"><th>{{ translate(\'INCENTIVE-DAYS\', {\'day\': dayNumber}) }}</th><td ng-if="vm.cappingHelper.isIncentiveTypeDailyCap(vm.temporaryCapping)"><div class="form-group"><input ng-if="vm.vars.forms.incentiveRulesForm" type="text" ng-model="vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].discount" class="form-control inForm" check-validity="" is-valid="vm.cappingHelper.validateIncentiveField" disable="vm.cappingHelper.model.disable" with-parent="true" cannot-be-null="true"></div><span ng-if="!vm.vars.forms.incentiveRulesForm">{{vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].discount}} <span ng-if="vm.temporaryCapping.incentive_rules.type === \'PERCENTAGE\' && vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].discount>0">%</span></span></td><td ng-if="vm.cappingHelper.isIncentiveCumulativeCap(vm.temporaryCapping)"><div class="form-group"><input ng-if="vm.vars.forms.incentiveRulesForm" type="text" ng-model="vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].cap_limit" class="form-control inForm" check-validity="" is-valid="vm.cappingHelper.validateIncentiveField" disable="vm.cappingHelper.model.disable" with-parent="true" cannot-be-null="true"></div><span ng-if="!vm.vars.forms.incentiveRulesForm">{{vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].cap_limit}}</span></td><td><div class="form-group"><input ng-if="vm.vars.forms.incentiveRulesForm" type="text" ng-model="vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].description" class="form-control inForm"></div><span ng-if="!vm.vars.forms.incentiveRulesForm">{{vm.temporaryCapping.incentive_rules.incentive_schedule[dayNumber].description}}</span></td></tr></table>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/incentiveDaysButtonGroup.html','<div class="btn-group topMargin filters" role="group"><button ng-repeat="dayNumber in vm.cappingHelper.getDiscountDays(vm.temporaryCapping)" type="button" class="btn btn-default" ng-click="vm.cappingHelper.toggleIncentiveZoneTable(dayNumber, selectedName)" ng-class="{\'active\': vm.cappingHelper.model.selectedZoneDay[selectedName] === dayNumber }">{{ translate(\'INCENTIVE-DAYS\', {\'day\': dayNumber }) }}</button></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/incentiveZonePeakOffPeakTable.html','<ul class="nav nav-tabs"><li class="uib-tab nav-item active" ng-class="{\'active\':vm.vars.switchSelected === \'peak\'}"><a class="nav-link panel-title ng-binding" href="#" ng-click="vm.switch(\'peak\')">{{ translate(\'PEAK\') }}</a></li><li class="uib-tab nav-item" ng-class="{\'active\':vm.vars.switchSelected === \'offpeak\'}"><a class="nav-link panel-title ng-binding" href="#" ng-click="vm.switch(\'offpeak\')">{{ translate(\'OFFPEAK\') }}</a></li></ul><div class="panel-body" id="peakOffPeakSettings"><div ng-if="vm.vars.switchSelected === \'peak\'"><div include-with-scope="app/pages/admin/products/capping/summary/widgets/incentiveDaysButtonGroup.html" selected-name="peak_incentive_triangle_schedule"></div><div ng-repeat="dayNumber in vm.cappingHelper.getDiscountDays(vm.temporaryCapping)" ng-if="vm.cappingHelper.model.selectedZoneDay[\'peak_incentive_triangle_schedule\'] === dayNumber" include-with-scope="app/pages/admin/products/capping/summary/widgets/peakOffPeakTable.html" selected-var="{{vm.cappingHelper.model.selectedZoneDay[\'peak_incentive_triangle_schedule\']}}" selected="vm.temporaryCapping.incentive_rules.peak_incentive_triangle_schedule" selected-name="incentive_rules"></div></div><div ng-if="vm.vars.switchSelected === \'offpeak\'"><div include-with-scope="app/pages/admin/products/capping/summary/widgets/incentiveDaysButtonGroup.html" selected-name="off_peak_incentive_triangle_schedule"></div><div ng-repeat="dayNumber in vm.cappingHelper.getDiscountDays(vm.temporaryCapping)" ng-if="vm.cappingHelper.model.selectedZoneDay[\'off_peak_incentive_triangle_schedule\'] === dayNumber" include-with-scope="app/pages/admin/products/capping/summary/widgets/peakOffPeakTable.html" selected-var="{{vm.cappingHelper.model.selectedZoneDay[\'off_peak_incentive_triangle_schedule\']}}" selected="vm.temporaryCapping.incentive_rules.off_peak_incentive_triangle_schedule" selected-name="incentive_rules"></div></div></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/incentives.html','<div class="panel panel-default clearfix"><div class="panel-heading"><edit-button ng-if="vm.canEdit && !vm.checkIfDuplicated && !vm.isExpired" variable="vm.vars.forms.incentiveRulesForm" update="vm.updateProduct" edit="vm.editProduct" cancel="vm.cancelEditButton" order="vm.vars.forms.incentiveRulesForm" disable="vm.cappingHelper.shouldBeDisabled(vm.temporaryCapping)"></edit-button><h5 class="panel-title">{{ translate(\'INCENTIVE-OPTIONS\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-2 panel-t mps-engine-text">{{ translate(\'INCENTIVE-ENABLED\') }}</div><div class="col-xs-10"><div ng-if="!vm.vars.forms.incentiveRulesForm">{{ translate(vm.temporaryCapping.incentive_enabled | toYesNo | uppercase) }}</div><div ng-if="vm.vars.forms.incentiveRulesForm"><div class="onoffswitch"><input type="checkbox" name="incentive_enabled_chk" id="incentive_enabled_chk" ng-model="vm.temporaryCapping.incentive_enabled" ng-true-value="true" ng-false-value="false" class="switch-checkbox" ng-change="vm.cappingHelper.toggleIncentiveEnable(vm.temporaryCapping)"> <label class="switch-label" for="incentive_enabled_chk"><span class="switch-inner" data-yes="{{ translate(\'YES\') }}" data-no="{{ translate(\'NO\') }}"></span> <span class="switch-switch"></span></label></div><span class="help-block sub-little-text">{{ translate(\'INCENTIVE-CAPPING-ENABLED-HELPER\') }}</span></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.incentive_enabled"><div class="row"><div class="col-xs-2 panel-t text-left mps-engine-text">{{ translate(\'INCENTIVE-TYPE\') }}</div><div class="col-xs-10"><div ng-if="!vm.vars.forms.incentiveRulesForm">{{ translate(vm.temporaryCapping.incentive_rules.incentive_type + \'-TYPE\') }}</div><div ng-if="vm.vars.forms.incentiveRulesForm" ng-class="{\'has-error\': vm.formErrors.incentiveDiscount}"><select ng-model="vm.temporaryCapping.incentive_rules.incentive_type" class="form-control" ng-change="vm.incentiveTypeChanged()" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="DAILY_CAP">{{ translate(\'DAILY_CAP-TYPE\') }}</option><option value="CUMULATIVE_CAP">{{ translate(\'CUMULATIVE_CAP-TYPE\') }}</option></select></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.incentive_enabled && vm.cappingHelper.isIncentiveTypeDailyCap(vm.temporaryCapping)"><div class="row"><div class="col-xs-2 panel-t text-left mps-engine-text">{{ translate(\'DAILY-CAP-PRODUCTS\') }}</div><div class="col-xs-10"><div ng-if="!vm.vars.forms.incentiveRulesForm"><label class="label margin-right1 label-{{product.schedule_status ? (product.schedule_status | lowercase) : \'info\'}}" ng-repeat="product in vm.cappingHelper.appliedIncentiveProducts"><a class="label-link" href="/admin/products/capping/{{product.id}}/default">{{ product.description}} <span ng-if="product.schedule_status">({{ translate(product.schedule_status) }})</span></a></label></div><div ng-if="vm.vars.forms.incentiveRulesForm"><div class="form-group error"><select-products ng-model="vm.cappingHelper.incentiveAppliedProductIds" all-products="vm.cappingHelper.model.allAvailableProducts" is-valid="vm.cappingHelper.validateIncentiveField" disabled="vm.cappingHelper.model.dropdownIsInvalid"></select-products></div><span class="help-block sub-little-text">{{ translate(\'SELECT-DAILY-CAPS-FOR-INCENTIVE-PRODUCT\') }}</span></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.incentive_enabled && vm.cappingHelper.isIncentiveTypeDailyCap(vm.temporaryCapping)"><div class="row"><div class="col-xs-2 panel-t text-left mps-engine-text">{{ translate(\'DISCOUNT-TYPE\') }}</div><div class="col-xs-10"><div ng-if="!vm.vars.forms.incentiveRulesForm">{{ translate(vm.temporaryCapping.incentive_rules.type) }}</div><div ng-if="vm.vars.forms.incentiveRulesForm" ng-class="{\'has-error\': vm.formErrors.incentiveDiscountType}"><select ng-options="key as translate(key) for (key, value) in vm.vars.filters.incentiveDiscountType" ng-model="vm.temporaryCapping.incentive_rules.type" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option></select></div></div></div></li></ul></div><div class="panel panel-default" ng-if="vm.temporaryCapping.incentive_enabled"><div class="panel-heading"><h5 class="panel-title">{{ translate(vm.temporaryCapping.incentive_rules.incentive_type + \'_TITLE\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-2 panel-t text-left mps-engine-text">{{ translate(\'DISCOUNT-QUALIFIER\') }}</div><div class="col-xs-4"><div ng-if="!vm.vars.forms.incentiveRulesForm">{{ translate(vm.temporaryCapping.incentive_rules.qualifier) }}</div><div ng-if="vm.vars.forms.incentiveRulesForm" ng-class="{\'has-error\': vm.formErrors.incentiveDiscount}"><select ng-model="vm.temporaryCapping.incentive_rules.qualifier" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="SINGLE_TRIP">{{ translate(\'SINGLE_TRIP\') }}</option><option ng-if="vm.cappingHelper.isIncentiveTypeDailyCap(vm.temporaryCapping)" value="CAP_REACHED">{{ translate(\'CAP_REACHED\') }}</option>ng-options="key as translate(key) for (key, value) in vm.vars.filters.incentiveDiscountQualifier"</select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-2 panel-t text-left mps-engine-text">{{ translate(\'CONFIGURATION\') }}</div><div class="col-xs-4"><div ng-if="!vm.vars.forms.incentiveRulesForm">{{ translate(vm.temporaryCapping.incentive_rules.configuration_type) }}</div><div ng-if="vm.vars.forms.incentiveRulesForm" ng-class="{\'has-error\': vm.formErrors.incentiveDiscount}"><select ng-model="vm.temporaryCapping.incentive_rules.configuration_type" class="form-control" ng-change="vm.cappingHelper.incentiveConfigurationChanged(vm.temporaryCapping)" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option><option value="DAILY_TABLE">{{ translate(\'DAILY_TABLE\') }}</option><option ng-if="vm.cappingHelper.isIncentiveCumulativeCap(vm.temporaryCapping)" value="ZONE_TRIANGLE">{{ translate(\'ZONE_TRIANGLE\') }}</option></select></div></div></div></li><li class="list-group-item"><div ng-if="vm.cappingHelper.displayDailyIncentiveTable(vm.temporaryCapping)" include-with-scope="app/pages/admin/products/capping/summary/widgets/incentiveDailyTable.html"></div><div ng-if="!vm.cappingHelper.displayDailyIncentiveTable(vm.temporaryCapping)" include-with-scope="app/pages/admin/products/capping/summary/widgets/incentiveZonePeakOffPeakTable.html"></div></li></ul></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/peakOffPeakTable.html','<table class="table table-condensed no-bottom-margin"><thead><tr><th>{{ translate(\'STATUS\') }}</th><th>{{ translate(\'ZONES\') }}</th><th>{{ translate(\'CAP-TRIGGER-AMOUNT\') }}</th><th>{{ translate(\'MAX-FARE-AMOUNT\') }}</th><th></th></tr></thead><tbody ng-repeat="(x, rule) in selected[selectedVar] track by $index"><tr ng-repeat="(y, r) in rule"><td><span class="label" ng-class="{\'label-success\':r.status === \'ENABLED\',\'label-danger\':r.status === \'DISABLED\'}">{{ translate(r.status | uppercase) }}</span></td><td ng-if="vm.temporaryCapping.multi_participant">{{ vm.getZoneGroupNameFromId(x) + \' - \' + vm.getZoneGroupNameFromId(y) }}</td><td ng-if="!vm.temporaryCapping.multi_participant">{{ vm.getZoneNameFromId(x) + \' - \' + vm.getZoneNameFromId(y) }}</td><td ng-if="selectedName === \'rules\'">{{ r.default_limit }}</td><td ng-if="selectedName === \'incentive_rules\'"><div class="form-group"><input ng-if="vm.vars.forms.incentiveRulesForm" type="text" class="form-control input-sm" placeholder="{{ translate(\'CAP-TRIGGER-AMOUNT\') }}" ng-model="r.default_limit" check-validity="" is-valid="vm.cappingHelper.validateIncentiveField" disable="vm.cappingHelper.model.disable" with-parent="true" cannot-be-null="true"></div><span ng-if="!vm.vars.forms.incentiveRulesForm">{{ r.default_limit }}</span></td><td>{{ r.max_fare_value }}</td><td></td></tr></tbody><tbody ng-if="vm.cappingHelper.isEmpty(selected[selectedVar])"><tr class="nohover"><td class="text-left" colspan="5">{{ translate(\'NO-ZONE-SETTINGS-FOUND\') }}</td></tr></tbody></table>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/peakOffPeakTriangle.html','<div><div class="zones-group"><p ng-bind-html="translate(\'ZONE-TRIANGLE-INFO\')"></p><div class="btn-group" role="group" aria-label="First group"><button ng-repeat="(i,zone) in vm.vars[selectedVar].all_zones" type="button" class="btn btn-default" ng-click="vm.toggleZone(selectedName,selectedVar, zone)" ng-model="zone.zone_name" ng-class="{\'active\': vm.vars[selectedVar].keys.indexOf(zone.id) > -1}">{{zone.zone_name}}</button></div></div><div class="rule-container"><div class="rule-row-container"><div class="origin-x"><div class="corner-block rule-table-entry" ng-if="vm.vars[selectedVar].keys.length > 0"></div><div class="rule-table-entry" ng-repeat="x in vm.vars[selectedVar].keys"><label class="subheading">{{ vm.getZoneNameFromId(x) | uppercase }}</label></div></div><div class="horizontal-scroll-container"><div class="origin-y"><div class="rule-table-entry" ng-repeat="x in vm.vars[selectedVar].keys"><label class="subheading">{{ vm.getZoneNameFromId(x) | uppercase }}</label></div></div><div><div class="rule-table-row" ng-repeat="(key, x) in vm.temporaryCapping.rules[selectedVar]"><div class="rule-table-entry" ng-repeat="(k, y) in (x)"><form class="cap-form"><div class="form-group"><label class="control-label">{{ translate(\'CAP-TRIGGER\') }}</label> <input type="text" class="form-control input-sm" placeholder="{{ translate(\'CAP-TRIGGER-AMOUNT\') }}" ng-model="y.default_limit"></div><div class="form-group"><label class="control-label">{{ translate(\'MAX-FARE\') }}</label> <input type="text" class="form-control input-sm" placeholder="{{ translate(\'MAX-FARE-AMOUNT\') }}" ng-model="y.max_fare_value"></div><button type="button" value="" class="btn btn-danger btn-block btn-xs" ng-if="y.status === \'ENABLED\'" ng-click="vm.toggleStatus(y)">{{ translate(\'DEACTIVATE\') }}</button> <button type="button" value="" class="btn btn-success btn-block btn-xs" ng-if="y.status === \'DISABLED\'" ng-click="vm.toggleStatus(y)">{{ translate(\'ACTIVATE\') }}</button></form></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/rules.html','<div class="panel panel-default clearfix"><div class="panel-heading"><edit-button ng-if="vm.canEdit && !vm.isExpired" variable="vm.vars.forms.ruleForm" update="vm.updateProduct" cancel="vm.getTemporaryValue" edit="vm.editProduct" order="vm.vars.forms.ruleForm"></edit-button><h5 class="panel-title">{{ translate(\'PRODUCTS-RULES\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAP-TRIGGER-AMOUNT\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.default_limit }}</div><div ng-if="vm.vars.forms.ruleForm"><input type="number" ng-model="vm.temporaryCapping.rules.default_limit" class="form-control inForm"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'MAX-FARE-AMOUNT\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.max_fare_value }}</div><div ng-if="vm.vars.forms.ruleForm"><input type="number" ng-model="vm.temporaryCapping.rules.max_fare_value" class="form-control inForm"></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type==\'WEEKLY_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'WEEKLY-CAP-START-DAY\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.weekly_cap_start_day }}</div><div ng-if="vm.vars.forms.ruleForm"><select ng-model="vm.temporaryCapping.rules.weekly_cap_start_day" class="form-control"><option value="SUNDAY">{{ translate(\'SUNDAY\') }}</option><option value="MONDAY">{{ translate(\'MONDAY\') }}</option></select></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type===\'DAILY_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'ALL-DAY\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ translate(vm.temporaryCapping.rules.all_day | toYesNo | uppercase) }}</div><div ng-if="vm.vars.forms.ruleForm"><div class="onoffswitch"><input type="checkbox" name="isAllDay" id="all_day" ng-model="vm.temporaryCapping.rules.all_day" ng-true-value="true" ng-false-value="false" class="switch-checkbox" ng-change="vm.onIsAllDayToggle()"> <label class="switch-label" for="all_day"><span class="switch-inner" data-yes="{{ translate(\'YES\') }}" data-no="{{ translate(\'NO\') }}"></span> <span class="switch-switch"></span></label></div></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.rules.all_day"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'OVERLAP-TIME\') }}</div><div class="col-xs-7" ng-class="{ \'has-error\': vm.formErrors.to_time_overlap_local }"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.to_time_overlap_local ? (vm.temporaryCapping.rules.to_time_overlap_local | date: \'short\') : \'No overlap\' }}</div><div ng-if="vm.vars.forms.ruleForm"><input type="text" ng-model="vm.temporaryCapping.rules.to_time_overlap_local" class="form-control inForm" hour-input="" maxlength="8" placeholder="hh:mm:ss"></div><span ng-if="vm.formErrors.to_time_overlap_local" class="help-block sub-little-text"><br><strong>{{ translate(\'OVERLAP-TIME-HELPER\', {\'hour\': vm.vars.filters.maxOverlapHours}) }}</strong>.</span></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type != \'TIME_BASED_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'START-TIME\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.from_time_local }}</div><div ng-if="vm.vars.forms.ruleForm"><input type="text" ng-disabled="vm.temporaryCapping.rules.all_day" ng-model="vm.temporaryCapping.rules.from_time_local" class="form-control inForm" hour-input="" maxlength="8" placeholder="HH:mm:ss"></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type!=\'MULTI_DAY_CAP\' && vm.temporaryCapping.capping_type !=\'TIME_BASED_CAP\'"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'FINISH-TIME\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.to_time_local }}</div><div ng-if="vm.vars.forms.ruleForm"><input type="text" ng-disabled="vm.temporaryCapping.rules.all_day" ng-model="vm.temporaryCapping.rules.to_time_local" class="form-control inForm" hour-input="" maxlength="8" placeholder="HH:mm:ss"></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'TIMEZONE\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.time_zone | date:\'mediumTime\' }}</div><div ng-if="vm.vars.forms.ruleForm"><timezone-selector ng-model="vm.temporaryCapping.rules.time_zone" display-utc="true" translations="translations" primary-choices="vm.temporaryCapping.rules.time_zone" sort-by="offset" show-local="true" width="100%"></timezone-selector></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAPPING-APPLICATION-LEVEL\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ translate(vm.temporaryCapping.rules.capping_applied_level) }}</div><div ng-if="vm.vars.forms.ruleForm"><select ng-options="value as translate(value) for (key,value) in vm.vars.filters.cappingAppliedLevel" ng-model="vm.temporaryCapping.rules.capping_applied_level" class="form-control"></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'TRANSACTION-TYPES\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm"><span class="label label-info margin-right1" ng-repeat="type in vm.temporaryCapping.rules.transaction_types">{{ translate(type | uppercase) }}</span></div><div ng-if="vm.vars.forms.ruleForm"><select ng-options="value as (\'PRODUCTS.CAPPING.\' + (value | uppercase) | translate) for (key,value) in vm.vars.filters.transactionTypes" ng-model="vm.temporaryCapping.rules.transaction_type" name="transaction_types" class="form-control" required=""></select></div></div></div></li><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'ROUTE-CAPPING-ENABLED\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm">{{ translate(vm.temporaryCapping.route_capping_enabled | toYesNo | uppercase) }}</div><div ng-if="vm.vars.forms.ruleForm"><div class="onoffswitch"><input type="checkbox" name="routeCapping" id="route-capping" ng-model="vm.temporaryCapping.route_capping_enabled" ng-true-value="true" ng-false-value="false" class="switch-checkbox"> <label class="switch-label" for="route-capping"><span class="switch-inner" data-yes="{{ translate(\'YES\') }}" data-no="{{ translate(\'NO\') }}"></span> <span class="switch-switch"></span></label></div><span class="help-block sub-little-text hasError" ng-if="vm.formErrors.route">{{ translate(\'ROUTES-CANNOT-BE-ENABLED\') }}</span></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.route_capping_enabled && !vm.temporaryCapping.multi_participant"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAPPED-ROUTES\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.ruleForm"><span class="label label-info margin-right1" ng-repeat="route in vm.temporaryCapping.rules.routes track by $index">{{route}}</span></div><div ng-if="vm.vars.forms.ruleForm" id="product-routes"><div class="form-group input-group" ng-repeat="(n, lookup) in vm.temporaryCapping.rules.routes track by $index"><input class="form-control" type="text" placeholder="{{ translate(\'ROUTE\') }}" ng-model="vm.temporaryCapping.rules.routes[n]"> <span class="input-group-btn"><button class="btn btn-danger" ng-click="vm.removeRoute($index)"><i class="fa fa-fw fa-trash"></i></button></span></div><button class="btn btn-sm btn-primary" ng-click="vm.addRoute()">{{ translate(\'ADD-ROUTE\') }}</button></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.route_capping_enabled && vm.temporaryCapping.multi_participant"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAPPED-ROUTES\') }}</div><div class="col-xs-7"><div ng-repeat="participantId in vm.temporaryCapping.participant_ids"><div class="h5">{{ vm.temporaryCapping.multi_participants_list[participantId].name }}</div><div><em ng-if="!vm.temporaryCapping.rules.participant_routes[participantId].length">{{ translate(\'NO-ROUTES\') }}</em> <span class="label label-info margin-right1" ng-repeat="route in vm.temporaryCapping.rules.participant_routes[participantId] track by $index">{{route}}</span></div><hr ng-if="!$last"></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.capping_type !== \'TIME_BASED_CAP\' && vm.temporaryCapping.capping_type !== undefined"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'NUMBER-OF-TRIPS\') }}</div><div class="col-xs-7" ng-class="{ \'has-error\': (vm.limitedTrips && (vm.temporaryCapping.rules.trip_number_limit < 1 || vm.temporaryCapping.rules.trip_number_limit > 99)) || !vm.limitedTrips }"><div ng-if="!vm.vars.forms.ruleForm">{{ vm.temporaryCapping.rules.trip_number_limit === 0 ? translate("UNLIMITED") : vm.temporaryCapping.rules.trip_number_limit }}</div><div ng-if="vm.vars.forms.ruleForm"><div class="onoffswitch large-switch"><input type="checkbox" name="routeCapping" id="number-of-trips" ng-model="vm.limitedTrips" ng-true-value="true" ng-false-value="false" class="switch-checkbox" ng-change="vm.limitedTripChanged()"> <label class="switch-label" for="number-of-trips"><span class="switch-inner" data-yes="{{ translate(\'LIMITED\') }}" data-no="{{ translate(\'UNLIMITED\') }}"></span> <span class="switch-switch"></span></label></div><div class="ui message" ng-show="vm.limitedTrips"><input class="form-control" type="number" placeholder="{{ translate(\'NUMBER-OF-TRIPS\') }}" ng-model="vm.temporaryCapping.rules.trip_number_limit"> <span class="help-block sub-little-text">{{ translate(\'NUMBER-OF-TRIPS-HELP-TEXT\') }}</span></div></div></div></div></li></ul></div>');
$templateCache.put('app/pages/admin/products/capping/summary/widgets/zones.html','<div class="panel panel-default clearfix"><div class="panel-heading"><edit-button ng-if="vm.canEdit && !vm.checkIfDuplicated && !vm.isExpired" variable="vm.vars.forms.zoneOptionsForm" update="vm.updateProduct" edit="vm.editProduct" cancel="vm.getTemporaryValue" order="vm.vars.forms.zoneOptionsForm"></edit-button><h5 class="panel-title">{{ translate(\'ZONE-OPTIONS\') }}</h5></div><ul class="list-group"><li class="list-group-item"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'ZONED-CAPPING-ENABLED\') }}</div><div class="col-xs-7"><div ng-if="!vm.vars.forms.zoneOptionsForm">{{ translate(vm.temporaryCapping.zoned_capping_enabled | toYesNo | uppercase) }}</div><div ng-if="vm.vars.forms.zoneOptionsForm"><div class="onoffswitch"><input type="checkbox" name="adjustments" id="adjustments" ng-model="vm.temporaryCapping.zoned_capping_enabled" ng-true-value="true" ng-false-value="false" class="switch-checkbox"> <label class="switch-label" for="adjustments"><span class="switch-inner" data-yes="{{ translate(\'YES\') }}" data-no="{{ translate(\'NO\') }}"></span> <span class="switch-switch"></span></label></div><span class="help-block sub-little-text">{{ translate(\'ZONED-CAPPING-ENABLED-HELPER\') }}</span></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.zoned_capping_enabled"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'CAPPING-PREFERENCE\') }}<i class="fa fa-question-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'CAPPING-PREFERENCE-TOOLTIP\') }}"></i></div><div class="col-xs-7"><div ng-if="!vm.vars.forms.zoneOptionsForm">{{ translate(vm.temporaryCapping.zoned_capping_pricing_type) }}</div><div ng-if="vm.vars.forms.zoneOptionsForm" ng-class="{\'has-error\': vm.formErrors.zonePricingType}"><select ng-options="value as translate(value) for (key, value) in vm.vars.filters.zonePricingType" ng-model="vm.temporaryCapping.zoned_capping_pricing_type" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option></select></div></div></div></li><li class="list-group-item" ng-if="vm.temporaryCapping.zoned_capping_enabled"><div class="row"><div class="col-xs-5 panel-t mps-engine-text">{{ translate(\'ZONE-CONFIGURATION\') }} <i class="fa fa-question-circle tooltip-icon" tooltips="" tooltip-template="{{ translate(\'ZONE-CONFIGURATION-TOOLTIP\') }}" tooltip-width="300px"></i></div><div class="col-xs-7"><div ng-if="!vm.vars.forms.zoneOptionsForm">{{ translate(vm.temporaryCapping.zoned_capping_mode) }}</div><div ng-if="vm.vars.forms.zoneOptionsForm" ng-class="{\'has-error\': vm.formErrors.zoneMode}"><select ng-options="value as translate(value) for (key, value) in vm.vars.filters.zoneMode" ng-model="vm.temporaryCapping.zoned_capping_mode" class="form-control" required=""><option value="">{{ translate(\'PLEASE-SELECT\') }}</option></select></div></div></div></li></ul></div><div class="panel panel-default clearfix zone-capping-rules" ng-if="vm.temporaryCapping.zoned_capping_enabled && !vm.checkIfDuplicated"><div class="panel-heading"><edit-button ng-if="vm.canEdit && !vm.checkIfDuplicated && !vm.isExpired" variable="vm.vars.forms.zoneRulesForm" update="vm.updateProduct" edit="vm.editProduct" cancel="vm.getTemporaryValue" order="vm.vars.forms.zoneRulesForm"></edit-button><ul class="nav nav-tabs"><li class="uib-tab nav-item" ng-class="{\'active\':vm.vars.switchSelected === \'peak\'}"><a class="nav-link panel-title" href="#" ng-click="vm.switch(\'peak\')">{{ translate(\'PEAK\') }}</a></li><li class="uib-tab nav-item" ng-class="{\'active\':vm.vars.switchSelected === \'offpeak\'}"><a class="nav-link panel-title" href="#" ng-click="vm.switch(\'offpeak\')">{{ translate(\'OFFPEAK\') }}</a></li></ul></div><div class="panel-body" id="peakOffPeakSettings"><div ng-if="vm.vars.switchSelected === \'peak\'"><div ng-if="!vm.vars.forms.zoneRulesForm" include-with-scope="app/pages/admin/products/capping/summary/widgets/peakOffPeakTable.html" selected-var="peak_zones" selected="vm.temporaryCapping.rules" selected-name="rules"></div><div ng-if="vm.vars.forms.zoneRulesForm" include-with-scope="app/pages/admin/products/capping/summary/widgets/peakOffPeakTriangle.html" selected-var="peak_zones" selected-name="PEAK"></div></div><div ng-if="vm.vars.switchSelected === \'offpeak\'"><div ng-if="!vm.vars.forms.zoneRulesForm" include-with-scope="app/pages/admin/products/capping/summary/widgets/peakOffPeakTable.html" selected-var="offpeak_zones" selected="vm.temporaryCapping.rules" selected-name="rules"></div><div ng-if="vm.vars.forms.zoneRulesForm" include-with-scope="app/pages/admin/products/capping/summary/widgets/peakOffPeakTriangle.html" selected-var="offpeak_zones" selected-name="OFFPEAK"></div></div></div></div><div class="panel panel-default clearfix" ng-if="vm.temporaryCapping.zoned_capping_enabled && vm.temporaryCapping.multi_participant"><div class="panel-heading"><h5 class="panel-title">{{ translate(\'MULTI-PARTICIPANT-ZONE-GROUPS\') }}</h5></div><ul class="list-group"><li class="list-group-item" ng-repeat="zoneGroup in vm.temporaryCapping.rules.zone_groups"><div class="row"><div class="col-xs-4">{{zoneGroup.name}}</div><div class="col-xs-4"><div ng-repeat="zone in zones = (vm.getMultiParticipantZonesFromIds(zoneGroup.zone_ids))">{{zone.name}}</div></div><div class="col-xs-2">{{ translate(zoneGroup.status | uppercase) }}</div></div></li></ul></div>');}]);